<template>
  <div class="">
    <svg
      id="e0gYpSRcAlv1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
    >
      <g transform="translate(-2.352076 0)" mask="url(#e0gYpSRcAlv2628)">
        <g transform="matrix(1 0 0 0.987565 23.828135 460.478974)">
          <rect
            width="1920"
            height="1093.598902"
            rx="0"
            ry="0"
            transform="matrix(1.131952 0 0 1-149.567751-466.27713)"
            fill="#fae167"
            stroke-width="0"
          />
          <g id="e0gYpSRcAlv5" transform="translate(.000009-189.35463)">
            <g transform="translate(95.982502 0)">
              <path
                d="M1483.8,804.77c.64,5.81,1.7,11.67,3.03,17.56h431.3c.9-2.72,1.76-5.48,2.6-8.29c1.08-3.66,2.17-8.67,2.91-11.82.7-2.97,1.52-5.85,2.27-8.79v-56.9c-4.19,3.72-8.21,7.75-12.29,12.02-2.48,2.59-4.66,5.18-7.32,7.66-13.48,12.51-27.67,23.28-43.64,30.92-3.99,1.91-7.95,3.31-12.01,4.36-12.76,3.32-24.5,2.24-37.15-.93.57-.89,1.04-1.89,1.5-2.91.36-.79.7-1.6,1.08-2.38.65-1.35,1.36-2.62,2.35-3.59c5.07-1.6,10.06-3.29,14.98-5.15c24.17-8.93,46.51-20.81,67.72-38.18c3.74-3.05,7.23-6.47,10.16-10.58c1.32-1.86,2.64-3.74,3.6-5.91c4.77-10.79,9.08-21.89,10-34.05c1.47-19.47-.14-38.27-3.94-57.15-4.3-21.33-10.24-42.08-17.27-62.33v-.02c-1.83-5.31-3.76-10.6-5.74-15.85-9.87-26.11-21.39-51.42-33.37-76.23-10.12,34.12-23.81,66.76-44.46,93.8-2.93,3.81-6.5,5.93-10,1.82-.44-.53-.72-1.12-.89-1.75-.63-2.48.66-5.61,1.75-8.13c2.92-6.74,5.87-13.4,8.87-19.98c11.03-24.15,22.95-47.18,38.04-68.78-14.86-25.05-29.77-50.06-44.69-75.06-5.51-9.25-11.03-18.5-16.56-27.75-11.4,15.8-23.73,29.37-38.26,41.2-1.82,1.47-3.67,2.79-5.56,4.14-7.87,4.19-12.31,10.84-16.12,19.7-.76,1.78-1.23,3.62-1.89,5.37-1.55,4.12-3.21,8.23-4.57,12.41-1.38,4.17-2.6,8.23-3.71,12.48-10.24,31.45,4.05,64.59-14.17,92.79-6.02-33.18,4.73-62.47,9.57-94.89.98-3.87,1.94-7.85,3.01-11.67c1.08-3.84,2.03-7.59,3.1-11.4.56-1.99,1.41-3.83,2.2-5.76.8-1.92,1.79-3.86,2.72-5.73-12.51,7.15-26,10.7-39.23,15.14-6.38,2.15-12.7,4.51-18.83,7.57-2.68,1.34-4.48,3.33-6.88,5.05-18.89,44.85-3.57,90.55.17,137.16-.14,7.12-1.15,13.94-2.91,20.91-1.04,4.17-3,8.45-5.2,12.11-1.25-3.23-2.43-6.76-3.34-10.07-.93-3.32-2.33-5.75-3.54-8.94-12.38-32.63-9.91-74.37-9-109.48.11-4.1-.01-9.58.06-14.06.06-4.5.05-9.55.15-14.11-4.98,3.06-9.88,6.25-14.7,9.55-2.08,1.43-4.16,2.88-6.2,4.35-23.31,16.77-44.5,36.72-62.49,61.29c4.33,12.22,8.45,24.37,13.23,36.4c1.6,4.02,3.06,7.94,4.94,11.97c15.07,32.24,32.26,62.23,53.34,89.69.53.89.97,1.75,1.31,2.59.76,1.24,1.32,2.71,1.6,4.44c1.17,7.22-2.85,13.38-8.93,14.69-10.77,2.3-15.95-8.13-18.12-18.69-.12-.23-.25-.46-.38-.7-9.82-19.02-20.24-38.78-28.83-59-1.82-4.26-3.68-8.86-5.31-13.3-8.14-22.21-14.01-45-19.76-68.2-4.08,5.11-7.93,10.3-11.57,15.62-2.04,2.98-4.02,6.02-5.91,9.1-2.72,4.38-5.28,8.89-7.7,13.52-3.47,6.63-6.62,13.53-9.44,20.76-4.64,11.88-8.78,23.94-8.68,36.98c0,.42.01.85.02,1.27.11,5.13.58,10.03,1.42,14.75.28,1.59.6,3.13.96,4.67.27,1.15.54,2.27.84,3.38.5,1.81,1.04,3.59,1.64,5.34c3.1,9.09,7.61,17.54,13.29,25.56c11.37,16.03,25.93,26.48,39.06,40.03c2.96,3.06,6.18,6.32,9.14,9.17c1.19,1.15,2.37,2.14,3.56,3.06c1.78,1.39,3.6,2.63,5.49,4.06c5.74,5.35,12.8,8.18,18.69,13.42-7.21.32-14.21.57-20.75-3.42-3.49-1.2-6.86-3.16-10.4-4.14-31.76-8.88-51.93-43.05-73.92-69.14-9.63,38.32-20.33,76.08-16.06,115.36Zm312.99-186.82c-2.94,2.27-6.27,2.81-9.75,2.89-1.09.02-2.05-.84-2.41-1.96-.16-.45-.22-.92-.16-1.41.5-4.11,1.52-7.79,4.39-10.43c1.11-1.01,2.28-1.58,3.51-1.91c1.55-.41,3.17-.45,4.84-.51.71-.02,1.33-.18,1.99.28.01,0,.03,0,.06,0c1.72.57,3.11,2.11,2.36,4.32-.74,2.2-1.75,4.36-2.95,6.34-.52.88-1.04,1.75-1.87,2.38ZM1763.7,799.38c.08-2.01.53-3.84,1.06-5.79.74-2.75,1.76-5.11,3.12-7.21c1.21-1.86,2.66-3.5,4.44-4.99c5.45-4.26,10.32-3.36,16.4-1.6.64.41,1.22.86,1.74,1.36c1.72,1.6,2.79,3.71,2.74,6.54-.08,3.67-1.53,6.16-3.31,8.97-1.44,2.31-2.71,4.49-4.92,6.09-4.61,3.36-9.37,4.93-14.98,4.32-3.47-.35-6.46-3.41-6.31-7.71Zm-86.6-138.15c-7.6-6.3-9.12-13.14-5.59-23.16c2.27-1.24,4.45-4.18,7.18-3.27c5.58,1.86,7.43,6.54,9.39,11.66.94,2.43,1.91,4.96,3.31,7.33.4,2.09-.06,4.17-1.07,5.78-.94,1.53-2.37,2.64-4.03,2.99-3.35.71-6.23.39-9.19-1.34Zm-34.79,62.33c2.44-9.84,10.62-16.61,19.25-12.25c4.99,2.53,7.29,7.96,7.9,13.77c2.64,5.77,4.52,12.24,5.69,16.01c2.44,7.9,1.33,18.23-7.13,20.22-3.17.75-8.2.99-11.31-.12-4.29-1.52-7.12-5.72-9.45-9.9-1.41-2.56-2.69-5.59-3.69-8.81-.81-2.25-1.4-4.73-1.72-7.54-.04-.36-.05-.73-.07-1.09-.38-3.58-.28-7.12.52-10.31Z"
                fill="#505536"
              />
              <g>
                <path
                  d="M1878.75,591.52c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1769.8,722.32c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1840.07,659.08c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1781.48,735.22c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1732.86,734.62c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1765.46,681.96c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1792.11,666.09c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1729.48,726.72c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1723.91,726.28c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1735.93,718.89c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1790.46,641.99c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1828.94,631.81c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1801.72,584.44c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1740.18,694.26c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1780.03,617.85c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1835.18,617.79c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1788.37,637.83c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1771.54,636.92c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1871.15,521.02c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  transform="translate(.000001 0)"
                  fill="#1a2b0e"
                />
                <path
                  d="M1854.96,659.68c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1785.31,711.12c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1777.4,668.4c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1782.11,673.9c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1730.85,743.33c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1764.51,707.37c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1829.63,655.27c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1818.17,717.93c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1737.85,690.98c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1764.2,670.42c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1744.22,695.83c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1775.32,629.13c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1818.48,595.64c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1788.52,648.97c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1715.74,743.47c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1797.3,667.27c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1813.8,698.42c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1862.16,508.59c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1760.01,675.46c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1736.8,745.84c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1744.79,715.65c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1719.34,735.86c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1739.93,730.72c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1795.74,711.56c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1803.58,708.4c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1767.76,712.06c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1806.58,702.83c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1814.78,582.28c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1811.91,593.82c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1861.9,542.13c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1802.37,629.43c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1754.46,749.9c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1854.38,552.45c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1776.07,648.58c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1833.88,650.41c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1775.36,708.34c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1807.1,650.31c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1856.2,522.21c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1770.44,670.22c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1843.25,607.14c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1743.67,690.02c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1805.18,676.44c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1883.49,560.36c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1719.83,742.29c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1823.28,696.24c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1874.69,509.29c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1726.91,736.79c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1774.75,730.89c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1770.04,651.29c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1725.67,716.29c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1839.04,697.38c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1814.43,640.86c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1797.89,588.54c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1787.67,716.36c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1768.7,739.3c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1809.79,614.18c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1750.2,730.44c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1855.3,621.29c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1760.84,746.92c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1786.02,731.23c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1822.36,633.42c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1834.27,669.13c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1833.85,686.26c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1731.26,714.6c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1757.29,685.52c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1849.78,560.29c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1790.29,701.16c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1822.59,710.24c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1725.14,744.54c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1864.28,528.58c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1753.17,679.73c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1836.92,581c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1821.72,684.52c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1740.45,684.29c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1777.34,680.01c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1752.24,744.47c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1879.47,530.14c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1750.46,665.29c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1744.19,737.41c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1747.36,749.83c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1791.18,722.18c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1741.59,746.43c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1854.33,606.76c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1871.88,637.99c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1841.87,590.75c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1792.55,731.32c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1838.46,560.95c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1782.36,690.83c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1800.84,595.05c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1775.63,722.1c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1855.33,570.03c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1867.51,561.55c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  transform="translate(.000001 0)"
                  fill="#1a2b0e"
                />
                <path
                  d="M1741.36,721.86c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1812.61,603.24c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1764.27,725.28c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1814.74,625.58c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1845.94,545.05c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1776.97,741.71c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1864.03,575.01c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1753.03,703.27c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1754.68,720.73c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1746.66,725.31c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1776.86,688.7c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1739.58,715.59c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1823.1,588.75c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1750.41,708.64c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1782.04,635.37c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1803.88,648.35c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1855.4,540.59c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  transform="translate(.000001 0)"
                  fill="#1a2b0e"
                />
                <path
                  d="M1874.23,579.82c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1762.6,652.32c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1732.84,695.41c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1835.89,637.2c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1758.18,730.11c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1835.46,611.79c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1799.21,655.97c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1811.3,659.5c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1890.18,548.37c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1754.86,713.49c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1845.43,673.03c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1810.16,668.3c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1797.84,648.25c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1768.56,660.13c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1846.97,539.4c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1758.97,705.65c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1759.07,740.9c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1795.67,722.27c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1747.26,679.96c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1843.71,570.45c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1806.77,689.18c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1750.87,693.14c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1820.33,617.37c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1851.01,588.43c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1777.65,640.89c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1760.97,713.43c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1757.67,656.18c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1745.07,674.16c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1761.65,645.45c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1762.24,663.62c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1821.46,580.6c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1793.44,655.94c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1767.07,698.96c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1729.98,708.69c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1789.21,676.12c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1814.16,677.25c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1831.87,705.48c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1786.75,662.02c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1801.64,618.38c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1818.42,651.35c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1804.98,580.91c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1817.69,607.93c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1800.14,672.1c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1733.8,701.59c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1771.68,679.04c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1780.24,656.92c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1855.31,676.76c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1715.78,748.97c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1798.07,637.56c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1798.1,679.14c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1860.23,638.05c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1806,635.72c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1808.92,625.97c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1794.05,628.94c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1752.75,670.64c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1826.57,604.73c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1790.24,631.5c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1811.41,718.12c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1762.75,734.62c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1836.24,568.15c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1738.95,698.76c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1866.46,551.58c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1828.79,571.37c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1843.57,644.53c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1873.29,540.4c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1812.82,587.64c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1831.32,592.66c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1734.52,706.01c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1793.57,596.38c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1757.59,661.95c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1778.99,701.1c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1742.07,707.49c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1841.04,552.54c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1745.76,702.63c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1786.58,684.94c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1827.03,674.45c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1762.23,685.52c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1757.87,666.48c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1769.3,642.45c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1758.17,696.52c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1782.8,648.58c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1762.16,692.59c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1781.79,719.01c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1801.25,727.73c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1794.29,688.23c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1773.02,696.62c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1828.45,582.51c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1883.1,613.75c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1834.82,627.41c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1823.59,664.9c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1833.95,603.12c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1798.33,700.41c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1845.42,625.94c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1802.13,717.54c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1770.99,686.75c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1851.6,534.97c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1783.14,628.83c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1865.6,498.3c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1864.1,601.84c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1785.09,696.55c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1846.69,687.35c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1785.49,622.89c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
                <path
                  d="M1804.78,663.53c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1a2b0e"
                />
              </g>
              <g>
                <path
                  d="M1679.48,795.78c.06-.09.11-.16.16-.25c4.57-7.49,9.29-14.88,13.87-22.37.18-.3.36-.58.53-.88c3.53-5.72,6.98-11.5,10.24-17.43v-.02c1.16-2.08,2.28-4.18,3.37-6.3c4.18-8.06,8.05-16.34,11.62-24.79c5.09-9.69,9.85-19.48,13.26-30.28c7.7-24.29,13.46-49.37,19.27-74.38c1.78-5.51,3.61-11.01,5.44-16.5-5.07,27.41-10.97,54.57-18.85,81.19-.2.64-.39,1.31-.6,1.95-10.53,35.12-24.47,67.48-42.69,98.13-5.35,9.01-10.49,18.19-15.43,27.52-1,1.86-1.98,3.75-2.96,5.64-.53,1.02-1.07,2.04-1.59,3.06-.38.74-.73,1.5-1.1,2.23h-9.36c.16-.32.32-.63.48-.95c4.5-8.72,9.26-17.27,14.32-25.6Z"
                  fill="#1a1909"
                />
                <path
                  d="M1719.27,723.76c5.09-9.69,9.85-19.48,13.26-30.28c7.7-24.29,13.46-49.37,19.27-74.38-1.97,6.09-3.89,12.19-5.71,18.3-.01.05-.02.08-.04.11-2.63,11.15-5.45,22.23-8.53,33.19-2.24,7.95-4.63,15.84-7.2,23.65-3.29,9.98-6.98,19.8-11.05,29.41Z"
                  fill="#1a1909"
                />
              </g>
              <path
                d="M1738.4,683.79c-.2.64-.39,1.31-.6,1.95c14.34-15.26,28.28-30.86,37.32-51.05c1.74-3.35,3.28-6.25,4.6-8.46c2.03-2.23,3.55-4.77,4.9-7.34-.16-.45-.22-.92-.16-1.41.5-4.11,1.52-7.79,4.39-10.43c1.11-1.01,2.28-1.58,3.51-1.91c1.26-2.44,2.42-4.9,3.54-7.4c4.23-9.44,7.7-19.37,11.65-28.68c1.63-3.94,3.28-7.92,4.99-11.83c2.26-5.16,4.65-10.27,7.29-15.21c11.03-24.15,22.95-47.18,38.04-68.78-14.86-25.05-29.77-50.06-44.69-75.06-3.16,20.73-6.59,41.53-11.12,61.85-1.17,5.25-2.42,10.46-3.74,15.64-2.17,9.78-4.63,19.26-7.39,28.56-1.39,4.64-2.83,9.23-4.37,13.82-1.14,5.03-2.66,10.04-4.45,15-1.3,4.23-2.84,8.5-4.57,12.78-1.71,4.27-3.6,8.57-5.59,12.89-.99,2.99-2.14,6.07-3.38,9.23-3.6,11.62-7.47,23.15-11.32,34.66-5.07,27.41-10.97,54.57-18.85,81.19Z"
                fill="#1a2b0e"
              />
              <path
                d="M1737.52,670.7c3.08-10.96,5.91-22.04,8.53-33.19-3.25,10.95-6.2,21.99-8.53,33.19Z"
                fill="#1a2b0e"
              />
              <g>
                <path
                  d="M1638.45,727.91c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1638.73,697.97c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1648.74,687.12c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1647.5,713.91c-.91-.8-1.37-2.17-1.08-3.53.39-1.82,1.98-2.93,3.54-2.48c1.2.35,2.03,1.51,2.19,2.85-1.7.67-3.27,1.76-4.66,3.17Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1682.12,728.03c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1620.32,719.8c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1657.97,681.31c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1683.27,734.91c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1664.32,663.06c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1628.31,732.62c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1638.7,735.59c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1640.87,679.58c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1641.95,735.21c.3,2.16.76,4.32,1.36,6.4-.25,0-.49-.02-.74-.09-1.57-.45-2.52-2.3-2.13-4.12.21-.99.79-1.76,1.52-2.2Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1672.89,733.92c.31-.03.63-.02.95.07c1.57.45,2.52,2.3,2.13,4.12-.17.81-.6,1.47-1.14,1.93-.53-1.72-1.17-3.82-1.94-6.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1677.51,696.56c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1646.05,714.28c.28.08.53.22.76.38-1.35,1.55-2.51,3.4-3.38,5.48-.8-.81-1.2-2.09-.93-3.38.39-1.82,1.98-2.93,3.54-2.48Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1583.64,681.2c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1660.35,648.58c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1664.72,713.63c-.84-.85-1.8-1.57-2.9-2.15-.21-.63-.27-1.34-.11-2.04.39-1.82,1.98-2.93,3.54-2.48c1.57.45,2.52,2.3,2.13,4.12-.32,1.48-1.42,2.47-2.67,2.56Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1636.48,707.11c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1596.18,670.35c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1616.23,707.18c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1681.7,746.43c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1591.09,688.21c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1607.09,716.91c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1647.73,697.75c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1655.26,696.64c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1669.47,674.24c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1663.02,699.05c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1641.67,745.33c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1676.14,746c.94.79,1.42,2.18,1.12,3.57-.18.86-.64,1.55-1.22,2c.27-1.79.3-3.69.1-5.57Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1632.56,742.51c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1625.28,646.71c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1664.21,685.95c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1633.48,737.44c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1635.43,690.63c-.13-.83-.34-1.6-.59-2.32.47-1.69,1.98-2.7,3.48-2.27c1.57.45,2.52,2.3,2.13,4.12s-1.98,2.93-3.54,2.48c-.53-.15-.98-.47-1.34-.89-.03-.37-.07-.74-.13-1.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1608.36,705.51c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1622.65,710.73c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1595.67,683.58c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1668.69,692.46c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1614.98,720.17c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1652.41,652.9c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1677.49,725.54c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1638.82,667.4c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1621.83,726.51c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1677.89,713.4c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1640.38,718.27c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1626.51,705.31c.46-.1.89-.23,1.32-.38.11.52.13,1.07.01,1.63-.39,1.82-1.98,2.93-3.54,2.48-1.39-.4-2.29-1.9-2.21-3.51c1.36.17,2.82.12,4.42-.22Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1609.68,691.66c.68,2.17,1.52,4.24,2.54,6.09-.63.42-1.4.58-2.16.36-1.57-.45-2.52-2.3-2.13-4.12.24-1.1.91-1.94,1.76-2.33Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1674.58,688.82c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1667.14,716.95c.21,0,.41.04.62.1c1.57.45,2.52,2.3,2.13,4.12-.13.63-.42,1.16-.79,1.59-.4-2.07-1.03-4.05-1.97-5.8Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1592.96,703.85c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1631.3,716.73c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1634.97,697.35c.77.81,1.14,2.07.87,3.32-.39,1.82-1.98,2.93-3.54,2.48-.28-.08-.54-.22-.78-.39c1.58-1.4,2.76-3.26,3.45-5.41Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1576.47,670.43c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1642.51,722.83c-.07.24-.15.48-.21.73-.46,1.84-.68,3.79-.72,5.8-1.35-.61-2.14-2.29-1.78-3.97.32-1.5,1.45-2.5,2.71-2.56Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1629.04,665.74c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1675.55,742.54c-.06-.26-.14-.52-.22-.78-.07-.46-.07-.94.04-1.42.39-1.82,1.98-2.93,3.54-2.48c1.57.45,2.52,2.3,2.13,4.12s-1.98,2.93-3.54,2.48c-.91-.26-1.6-1-1.95-1.92Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1649.73,676.78c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1642.51,640.84c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1600.06,710.73c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.57-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1631.02,724.49c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1673.99,708.02c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1682.42,718.59c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1653.17,668.02c-1.57-.45-3.15.66-3.54,2.48s.56,3.67,2.13,4.12s3.15-.66,3.54-2.48-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
                <path
                  d="M1603.24,696.79c-1.57-.45-3.15.66-3.54,2.48s.57,3.67,2.13,4.12c1.57.45,3.15-.66,3.54-2.48s-.56-3.67-2.13-4.12Z"
                  fill="#1d3d13"
                />
              </g>
              <path
                d="M1771.32,427.52c-17.98,22.35-26.2,52.73-33.88,82-8.09,30.82-16.18,61.65-24.27,92.47-16.08-50.06-16.73-106.6-1.83-157.15-17.34,40.83-35.16,85.34-28,130.11c5.12,32.04,22.69,60.32,26.07,92.67c1.66,15.89-.23,32.13-4.34,47.4c30.97-41.52,41.01-98.4,47.42-152.84c6.41-54.45,10.74-110.96,33.43-159.18l-14.6,24.52Z"
                fill="#566c3b"
              />
              <path
                d="M1623.49,484.25c-4.81,35.04-2.15,71.45,7.71,105.03c14.84,50.51,45.58,95,51,147.98c2,19.47.4,39.2-2.71,58.52.06-.09.11-.16.16-.25c4.57-7.49,9.29-14.88,13.87-22.37c1.43-8.1,1.22-16.62.98-24.94-.45-15.24-.88-30.48-1.31-45.72-.38-13.23-.76-26.47-2.42-39.54-.14-1.13-.29-2.25-.45-3.37-.94,1.53-2.37,2.64-4.03,2.99-3.35.71-6.23.39-9.19-1.34-7.6-6.3-9.12-13.14-5.59-23.16c2.27-1.24,4.45-4.18,7.18-3.27c5.58,1.86,7.43,6.54,9.39,11.66-3.55-18.31-8.61-36.29-11.7-54.73-7.42-44.28-2.47-89.3,11.79-130.97c2.05-5.99,4.31-11.68,5.55-16.56-6.38,2.15-12.7,4.51-18.83,7.57-2.68,1.34-4.48,3.33-6.88,5.05-18.89,44.85-3.57,90.54.17,137.16-.14,7.12-1.15,13.94-2.91,20.91-1.04,4.16-3,8.45-5.2,12.11-1.25-3.23-2.43-6.76-3.34-10.07-.93-3.32-2.33-5.75-3.54-8.94-12.38-32.63-9.91-74.37-9-109.48.11-4.1-.01-9.58.06-14.06.06-4.5.05-9.55.15-14.11-7.13,4.4-14.12,9.02-20.9,13.9Z"
                fill="#1d3d13"
              />
              <path
                d="M1695.57,625.46c14.9,20.07,13.86,46.07,11.3,70.83-1.14,11.11-2.05,22.11-2.69,33.27-.38,6.56-.8,13.18-2.11,19.6-1.32,6.4-4.15,11.67-6.4,17.57-.11.28-.07.61.07.88-.57,1.55-1.15,3.12-1.69,4.68c3.53-5.72,6.98-11.5,10.24-17.43v-.02c.43-1.35.8-2.75,1.13-4.16c2.45-5.12,4.97-10.21,7.63-15.22c2.09-3.91,4.18-7.79,6.23-11.7c5.09-9.69,9.85-19.48,13.26-30.28c7.7-24.29,13.46-49.37,19.27-74.38c2.25-9.65,4.5-19.29,6.87-28.89.1-.38-.38-.49-.48-.14-4.84,17.04-10.24,33.84-14.96,50.93-4.59,16.64-8.57,33.57-13.56,50.06-5.12,16.94-13.68,31.54-21.22,47.07-.47.93-.92,1.89-1.36,2.83.2-1.73.39-3.43.55-5.04c1.39-14.52,2.27-29.13,3.6-43.67c2.15-23.3,1.68-51.09-14.97-67.64-.51-.51-1.14.27-.71.85Z"
                fill="#808055"
              />
              <path
                d="M1675.14,820.09c9.63-9.53,18.96-19.09,29.6-27.22c10.32-7.88,21.13-14.8,32.07-21.45c22.8-13.83,46.32-25.91,69.13-39.7.15-.08.02-.33-.13-.25-23.97,13.28-48.97,24.18-72.66,38.12-18.43,10.84-38.54,24.09-53.47,41.8-1.54,2.88-3.05,5.79-4.54,8.7Z"
                fill="#808055"
              />
              <path
                d="M1657.89,788.68c-4.76-11.69-12.01-21.69-19.91-30.68-16.68-18.95-36.1-34.59-52.47-53.92-.27-.34.09-.99.45-.69c10.76,9.03,20.57,19.69,30.63,29.73c10.23,10.19,20.79,20.14,29.76,31.91c11.03,14.5,21.66,36.09,18.82,56.35-.16.32-.32.63-.48.95h-1.55c.55-11.67-.74-22.58-5.25-33.65Z"
                fill="#808055"
              />
              <path
                d="M1783.27,748.01c17.12,8.17,31.2,25.15,49.49,28.42.22.04.44.07.64.1c24.17-8.93,46.51-20.81,67.72-38.18c3.74-3.05,7.23-6.47,10.16-10.58c1.32-1.86,2.64-3.74,3.6-5.91c4.77-10.79,9.08-21.89,10-34.05c1.47-19.47-.14-38.27-3.94-57.15-5.43-26.95-13.46-52.94-23-78.19-3.59,38.88-16.97,76.48-31.03,112.42-4.43,11.33-9.05,22.8-16.24,32.03-6.01,7.74-13.57,13.57-21.12,19.19-15.12,11.23-30.55,21.89-46.27,31.91Z"
                fill="#334f23"
              />
              <path
                d="M1556.98,598.82c1.43,3.65.62,7.13,1.38,11.07c1.01,5.24,3.06,10.44,4.84,15.38c3.26,9.11,9.16,19.22,9.11,29.27-.02,4.01-3.88,7.23-7.05,4.93-7.91-5.73-11.6-18.56-14.11-28.53-2.5-9.9-5.57-21.21-1.87-31.08.89-2.37,3.28-2.85,5.19-2.6.95.12,2.06.41,2.51,1.56v0Z"
                fill="#566c3b"
              />
              <path
                d="M1510.81,641.4c0,.42.01.85.02,1.27c1.32,4.38.85,9.77,1.42,14.75.17,1.4.41,2.78.81,4.09.05.19.08.39.15.58.25,1.14.54,2.27.84,3.38.5,1.81,1.04,3.59,1.64,5.34c3.1,9.09,7.61,17.54,13.29,25.56c11.37,16.03,25.93,26.48,39.06,40.03c2.96,3.06,6.18,6.32,9.14,9.17c1.19,1.15,2.37,2.14,3.56,3.06-1.55-3.23-3.76-6.18-5.89-8.97-11.99-15.65-23.97-31.33-35.96-46.98-2.84-3.69-5.71-7.46-8.23-11.47-2.52-4-4.7-8.26-6.16-12.92-7.21-28.34,2.2-56,4.41-84.64-3.47,6.63-6.62,13.53-9.44,20.76-4.64,11.88-8.78,23.94-8.68,36.98Z"
                fill="#384527"
              />
            </g>
          </g>
          <g transform="matrix(1.00522 0 0 1-5.0029-172.925763)">
            <g>
              <path
                d="M1359.24,795.49c-.7,1.85-1.09,3.83-1.58,5.74-.6,1.43-1.13,2.87-1.53,4.37-.16-.86-.35-1.73-.58-2.56-1.04-3.79-2.71-7.23-3.91-10.99-1.37-4.3-2.07-8.36-1.24-12.92c1.05-5.78,2.89-11.58,3.74-17.44.05-.37-.38-.45-.53-.14-.32.66-.6,1.38-.89,2.06.62-2.44,1.29-4.92,1.91-7.35.78-3.09,1.41-6.32,2.08-9.38.68-3.05,1.28-5.74.55-8.78-.15-.62-1.02-.73-1.34-.15-1.69,3.09-2.31,6.7-3.94,9.83s-3.66,5.97-5.67,8.87c-1.8,2.59-3.65,5.17-5.34,7.84.15-1.02.31-2.03.48-3.05.12-.75.25-1.5.38-2.24c1.94-5.15,3.84-10.17,5.6-15.41c2.53-7.53,4.46-14.73,4.99-22.83.24-3.7-.1-8.1-.69-11.89.48-4.5.77-8.9.61-13.4c1.55,6.75,2.91,13.59,5.06,20.17c2.25,6.88,4.25,13.34,8.95,18.97.59,1.53,1.29,3.02,1.92,4.54c1.76,4.25,3.92,8.23,4.91,12.78c1.8,8.28.21,15.86-1.96,23.92-4.68,6.22-9.2,12.11-11.98,19.44Z"
                fill="#a2a08f"
              />
              <path
                d="M1359.47,814.65c.17.68.43,1.38.65,2.05.81-5.2,3.55-9.33,6.97-13.2.18-.2.33-.28.43-.44c1.26-2.02,2.81-4.17,4.18-6.01c4.6-6.19,9.09-12.2,13.74-18.29c2.08-2.73,4.06-5.52,5.81-8.48.09-.15.09-.32.13-.48c1.24-4.81,2.11-9.33,2.28-14.36.16-4.52.25-9.34.37-13.91-.73-4.11-1.08-7.94-.12-12.03-.03-.62-.05-1.23-.09-1.85-.16.32-.26.6-.35.96-.55,2.2-1.11,4.35-1.88,6.51-.77,2.15-2.02,4.06-2.95,6.17-1.64,3.73-2.88,7.62-4.54,11.37-3.2,7.27-6.67,14.34-11.11,20.94-.58.86-1.17,1.63-1.79,2.45-4.65,6.21-9.2,12.11-11.96,19.44-.7,1.84-1.09,3.83-1.58,5.74-.6,1.43-1.13,2.87-1.53,4.37.16.99.3,2.05.31,3.04.01,1.3-.28,2.48-.54,3.72-.04.18.09.36.11.51s.06.25.11.38c.47,1.29,1.13,2.38,2.05,3.4.29.32.64.5,1.03.67-1.03-3.66-1.65-7.06-.79-10.82.02-.09.16-.07.16.02.03,2.78.23,5.44.91,8.14Zm.33-.14c-2.5-9.21,1.43-17.14,6.78-24.1c7.25-9.42,13.72-17.75,21.05-26.72.14-.18.34.08.22.25-5.75,8.37-11.91,16.43-17.89,24.68-2.81,3.87-6.02,7.8-7.76,12.26-1.75,4.46-.98,9.05-1.84,13.64-.06.34-.47.29-.55,0Z"
                fill="#393922"
              />
              <path
                d="M1351.97,747.78c1.63-3.13,2.25-6.74,3.94-9.83.32-.59,1.19-.48,1.34.15.72,3.05.12,5.73-.55,8.78-.68,3.05-1.3,6.29-2.08,9.38-.62,2.43-1.29,4.91-1.91,7.36-1.96,5.02-3.73,10.18-5.27,15.32-1.25,4.17-1.55,7.99-.78,12.23.13.74.42,1.41.57,2.09.62,2.87,1.72,5.75,2.82,8.37s1.97,4.92,2.65,7.62c.17.69.27,1.42.4,2.13-.21.34-.45.61-.77.85-.37-.17-.76-.32-1.14-.47-.05-.02-.1-.03-.13-.05s-.04-.05-.05-.07c-.3-.43-.6-.85-.9-1.27-.06-.08-.12-.16-.18-.24-.56-.74-1.13-1.48-1.71-2.2-.43-.54-.87-1.08-1.31-1.62-1.32-1.62-2.61-3.26-3.8-4.98-1.03-3.79-1.9-7.58-2.56-11.45-.1-.56-.17-1.11-.25-1.69-.03-.2-.04-.33-.07-.59s-.1-.8-.13-1.08c-.03-.29-.04-.42-.07-.71-.03-.28-.06-.7-.09-.99-.02-.29-.03-.47-.05-.75s-.04-.66-.06-.94c-.01-.28-.02-.49-.03-.78-.01-.28-.02-.63-.03-.92c0-.28-.01-.51-.02-.79c0-.28,0-.61,0-.89s0-.53,0-.81s0-.58.01-.86c0-.28,0-.58.02-.84c0-.26.02-.5.03-.75.03-.82.07-1.63.12-2.44c0-.02,0-.04,0-.06.02-.34.06-.85.08-1.14s.02-.26.04-.54.07-.82.1-1.1.02-.26.05-.55c.03-.3.08-.79.12-1.14.02-.14.03-.32.05-.47.04-.39.09-.8.14-1.2.02-.13.03-.27.05-.4.05-.42.11-.85.17-1.27.01-.09.03-.21.04-.28.05-.36.16-1.09.19-1.34.02-.17,0-.05,0-.05v0c1.7-2.68,3.54-5.26,5.34-7.85c2.01-2.9,4.04-5.74,5.67-8.87Z"
                fill="#b1c5a1"
              />
            </g>
            <rect
              width="1919.49"
              height="748.63"
              rx="0"
              ry="0"
              transform="translate(-.33-69.99)"
              fill="none"
            />
          </g>
          <g
            id="e0gYpSRcAlv327"
            transform="matrix(.998939-.046048 0.046048 0.998939 10.711329-104.965038)"
          >
            <g>
              <path
                d="M1454.14,532.51c4.68-8.17,9.57-16.26,14.67-24.3c4.32-6.87,8.81-13.69,13.44-20.48c7.52-11.08,15.39-22.06,23.54-32.96v-.02l1.62-2.12c4.29-5.73,8.68-11.43,13.11-17.11c6.41-8.19,12.97-16.32,19.62-24.42c30.73-23.18,63.97-43.59,94.47-66.99.21,12.94,1.32,26.12,3.08,39.69c3.63,28.04,7.24,55.26,6.9,82.51-1.35,7.54-2.63,15.07-4,22.56-.56,3.08-1.16,6.15-1.78,9.22-.05.26-.12.52-.17.78-.59,2.82-1.21,5.64-1.89,8.44-.13.53-.26,1.05-.38,1.57-.67,2.62-1.37,5.23-2.12,7.84-.13.52-.27,1.03-.4,1.55-.32,1.32-.66,2.63-1.02,3.95-.09.4-.19.8-.31,1.21c0,.05-.02.1-.03.16-.33,1.29-.67,2.57-1.01,3.86-2.03,7.86-4.19,15.71-6.6,23.5-.68,1.51-1.32,3.03-2.09,4.52-1.74,3.45-3.95,6.73-6.12,10.06-4.71,7.2-8.97,14.54-13.2,21.87-8.32,14.42-16.6,28.85-27.34,42.52-.26.32-.48.64-.7.97-.12.17-.23.35-.34.53-.18.3-.36.6-.51.9-.21.41-.42.83-.58,1.25h-.01c-.18.43-.32.85-.45,1.27c0,0-.02,0-.01.01-20.57,21.79-45.68,40.72-67.83,61.61-5.24,2.26-10.04,5.06-14.5,8.14.09-3.41-.33-6.74-1.25-9.99v0c-.61-2.28-1.46-4.51-2.5-6.71c0-.03-.02-.06-.05-.1-9.87-21.11-36.2-39.52-47.75-59.89-17.33-30.53-2.99-64.89,14.48-95.39Z"
                fill="#b4575a"
              />
              <path
                d="M1566.14,392.34c.22,1.07.4,2.07.52,2.83c3.03,19.62,7.53,39.08,13.91,58.33c1.03,3.13,2.11,6.33,1.8,9.53c0,.11-.01.22-.03.33-.43,3.21-2.28,6.23-4.12,9.2-10.93,17.63-21.87,35.25-32.8,52.89h-.02c-1.69,2.73-3.38,5.47-5.08,8.21-.36.6-.74,1.19-1.11,1.79.16-.47.31-.94.46-1.4.18-.53.34-1.06.5-1.59.39-1.32.74-2.64,1.05-3.96h.01c6.71-28.67-4.7-58.27-17.75-86.12-1.05-2.23-2.09-4.52-2.96-6.85c6.41-8.19,12.97-16.32,19.62-24.42c8.51-6.42,17.21-12.63,26-18.75Z"
                fill="#7b3d3a"
              />
              <g>
                <path
                  d="M1536.1,601.4c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1607.04,570.7c-.14.03-.28.07-.42.09-2.11.29-4.17-.64-4.61-2.08-.43-1.44.93-2.85,3.04-3.15c1.67-.23,3.29.31,4.12,1.25-.72,1.29-1.42,2.59-2.13,3.89Z"
                  fill="#984a4a"
                />
                <path
                  d="M1595.35,531.56c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1560.17,623.98c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1542.28,605.35c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1560.2,590.97c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1532.26,670.99c-.49-.35-.86-.79-1.01-1.3-.43-1.44.93-2.85,3.04-3.15.88-.12,1.74-.02,2.49.23-1.49,1.42-3,2.82-4.53,4.22Z"
                  fill="#984a4a"
                />
                <path
                  d="M1554.23,618.33c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15s-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1544.25,532.25c1.66.11,3.1.93,3.45,2.11.43,1.44-.93,2.85-3.04,3.15-.96.13-1.9,0-2.69-.3.76-1.65,1.53-3.3,2.28-4.95Z"
                  fill="#984a4a"
                />
                <path
                  d="M1504.2,656.74c.04-.16.07-.33.11-.49.4-.18.85-.32,1.35-.39c2.11-.29,4.17.64,4.61,2.08s-.93,2.85-3.04,3.15c-1.48.21-2.93-.2-3.82-.96.26-1.13.52-2.27.79-3.4Z"
                  fill="#984a4a"
                />
                <path
                  d="M1553.12,531.71c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15s-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1524.38,623.79c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1593.37,580.57c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1539.4,594.03c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1542.98,577.37c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1542.75,635.63c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1598.43,554.82c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1510.49,663.54c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1547.13,625.7c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1554.66,599.44c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1545.36,584.52c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1552.29,634.89c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1496.77,688.86c.48-.27,1.05-.48,1.7-.57c2.11-.29,4.17.64,4.6,2.08s-.93,2.85-3.04,3.15c-1.75.24-3.45-.36-4.23-1.39.34-1.09.66-2.18.97-3.27Z"
                  fill="#984a4a"
                />
                <path
                  d="M1582.79,552.84c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1606.39,559.84c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1510,627.69c1.9-.07,3.64.81,4.03,2.12.43,1.44-.93,2.85-3.04,3.15-.65.09-1.3.05-1.89-.07.31-1.73.61-3.46.91-5.2Z"
                  fill="#984a4a"
                />
                <path
                  d="M1560.33,603.91c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1570.17,629.83c-1.78-.02-3.37-.88-3.74-2.13-.43-1.44.93-2.85,3.04-3.15c1.52-.21,3,.22,3.88,1-1.05,1.43-2.1,2.85-3.18,4.27Z"
                  fill="#984a4a"
                />
                <path
                  d="M1526.29,617.2c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1535.66,551.54c.55-.53,1.38-.92,2.38-1.06c2.11-.3,4.17.64,4.61,2.08.43,1.44-.93,2.85-3.04,3.15s-4.17-.64-4.61-2.08c-.04-.13-.05-.26-.06-.39.24-.57.49-1.13.72-1.7Z"
                  fill="#984a4a"
                />
                <path
                  d="M1545.6,538.59c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1577.04,585.32c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1519.31,666c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1508.49,636.16c.43.34.76.74.9,1.21.33,1.09-.37,2.16-1.64,2.74.25-1.32.5-2.64.74-3.96Z"
                  fill="#984a4a"
                />
                <path
                  d="M1513.8,651.91c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1523.25,612.95c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1615.31,543.32c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1517.45,609.5c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1546.39,572.81c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.38-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1577.87,527.26c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1582.97,519.94c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1557.47,629.8c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1573.27,560.76c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1582.34,601.04c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1519.14,594.84c.53-.67,1.46-1.19,2.64-1.35c2.11-.3,4.17.64,4.6,2.08s-.93,2.85-3.04,3.15-4.17-.64-4.6-2.08c-.03-.08-.02-.17-.04-.25.15-.51.29-1.03.44-1.55Z"
                  fill="#984a4a"
                />
                <path
                  d="M1521.2,587.24c1.73.07,3.24.91,3.6,2.12.43,1.44-.93,2.85-3.04,3.15-.67.09-1.32.06-1.93-.06.48-1.73.93-3.47,1.37-5.2Z"
                  fill="#984a4a"
                />
                <path
                  d="M1538.57,643.19c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1513.28,687.08c0,0-.09.02-.14.03-2.11.29-4.17-.64-4.6-2.08s.93-2.85,3.04-3.15s4.17.64,4.6,2.08c.08.26.08.51.05.76-.98.78-1.95,1.58-2.95,2.35Z"
                  fill="#984a4a"
                />
                <path
                  d="M1538.94,556.72c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1632.53,523.41c-1.23-.31-2.21-1.02-2.49-1.96-.43-1.44.93-2.85,3.04-3.15.26-.04.52-.05.77-.05-.43,1.72-.88,3.44-1.32,5.16Z"
                  fill="#984a4a"
                />
                <path
                  d="M1543.9,598.86c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1530.21,589.03c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1528.5,598.02c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1564.88,594.38c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1585,578.39c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1539.6,542.36c.39-.17.83-.31,1.32-.37c2.11-.29,4.17.64,4.6,2.08s-.93,2.85-3.04,3.15c-1.89.26-3.73-.46-4.41-1.65.51-1.07,1.03-2.14,1.53-3.21Z"
                  fill="#984a4a"
                />
                <path
                  d="M1585.99,607.25c-.25-.27-.44-.56-.54-.89-.43-1.44.93-2.85,3.04-3.15.02,0,.04,0,.06,0-.85,1.35-1.7,2.7-2.57,4.04Z"
                  fill="#984a4a"
                />
                <path
                  d="M1507.33,642.27c.21-.06.43-.11.67-.14c2.11-.3,4.17.64,4.61,2.08.43,1.44-.93,2.85-3.04,3.15-1.16.16-2.29-.05-3.16-.51.32-1.52.63-3.05.93-4.57Z"
                  fill="#984a4a"
                />
                <path
                  d="M1590.98,586.48c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1561.26,612.95c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1628.08,534.62c-.17.04-.33.08-.51.11-2.11.29-4.17-.64-4.61-2.08-.43-1.44.93-2.85,3.04-3.15c1.71-.24,3.38.34,4.18,1.33-.7,1.26-1.39,2.53-2.11,3.79Z"
                  fill="#984a4a"
                />
                <path
                  d="M1557.67,545.03c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1526.82,666.7c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1551.57,538.14c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1556.25,646.64c-1.41-.24-2.56-1.01-2.87-2.04-.43-1.44.93-2.85,3.04-3.15c1.4-.2,2.77.16,3.66.83-1.27,1.46-2.54,2.91-3.83,4.36Z"
                  fill="#984a4a"
                />
                <path
                  d="M1568.62,604.95c-2.11.29-3.47,1.7-3.04,3.15s2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1596.93,572.72c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15s-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1501.18,696.28c-.36-.32-.64-.69-.77-1.11-.43-1.44.93-2.85,3.04-3.15c1.04-.15,2.07,0,2.9.38-1.72,1.3-3.45,2.59-5.18,3.88Z"
                  fill="#984a4a"
                />
                <path
                  d="M1520.77,602.9c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1564.05,579.97c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1534.85,607.38c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1513.07,633.94c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1552.16,606.9c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1582.89,568.47c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1548.77,593.46c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1516.61,639.82c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1528.59,567.49c.29-.09.59-.17.91-.22c2.11-.29,4.17.64,4.6,2.08s-.93,2.85-3.04,3.15c-1.7.24-3.35-.33-4.16-1.31.56-1.23,1.12-2.47,1.69-3.7Z"
                  fill="#984a4a"
                />
                <path
                  d="M1545.91,614.71c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1526.84,635.2c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1594.91,517.05c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1553.03,575.06c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1574.2,596.3c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1570.38,586.63c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1511.33,619.83c0,0,.06-.02.09-.02c2.11-.29,4.17.64,4.6,2.08s-.93,2.85-3.04,3.15c-.88.12-1.74.02-2.49-.23.28-1.66.56-3.32.83-4.98Z"
                  fill="#984a4a"
                />
                <path
                  d="M1534.5,554.29c.44.33.78.74.92,1.21.41,1.39-.83,2.73-2.8,3.1.64-1.43,1.26-2.87,1.88-4.31Z"
                  fill="#984a4a"
                />
                <path
                  d="M1506.27,676.46c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1590,600.93c-.25.41-.52.81-.77,1.22-.22-.25-.4-.53-.5-.84-.42-1.42.88-2.79,2.92-3.12-.55.92-1.09,1.83-1.66,2.75Z"
                  fill="#984a4a"
                />
                <path
                  d="M1541.99,537.18c.38.32.67.69.8,1.12.41,1.37-.8,2.69-2.73,3.08.65-1.4,1.29-2.8,1.93-4.2Z"
                  fill="#984a4a"
                />
                <path
                  d="M1577.36,548.31c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1544.37,647.86c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1511.93,671.3c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1583.32,592.51c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1575.1,576.54c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1590.28,540.15c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.38-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1571.38,617.38c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1562.4,570.33c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1531.82,616.43c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1534.11,660.93c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1536.2,653.97c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1534.5,638.22c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1559.44,586.87c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1562.51,525.17c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1622.52,544.05c-1.91.08-3.66-.8-4.05-2.12-.43-1.44.93-2.85,3.04-3.15c1.39-.2,2.76.15,3.65.82-.88,1.48-1.75,2.97-2.64,4.45Z"
                  fill="#984a4a"
                />
                <path
                  d="M1500.37,674.17c.87.37,1.52.98,1.74,1.72.42,1.39-.84,2.74-2.82,3.1.37-1.6.73-3.21,1.08-4.82Z"
                  fill="#984a4a"
                />
                <path
                  d="M1522.8,580.48c.14-.33.27-.66.41-.99.41-.96.84-1.93,1.27-2.89c1.98-.14,3.83.75,4.24,2.11.43,1.44-.93,2.85-3.04,3.15-1.13.16-2.22-.05-3.08-.48.07-.3.13-.6.2-.89Z"
                  fill="#984a4a"
                />
                <path
                  d="M1524.14,678.2c-.24-.26-.43-.56-.53-.88-.43-1.44.93-2.85,3.04-3.15.69-.1,1.36-.05,1.98.09-1.48,1.32-2.98,2.64-4.5,3.94Z"
                  fill="#984a4a"
                />
                <path
                  d="M1530.29,579.71c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1550.43,566.21c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1552.93,526.18c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1540.81,622.62c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1578.83,580.42c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1498.18,683.59c.55-.56,1.41-.98,2.45-1.12c2.11-.29,4.17.64,4.61,2.08s-.93,2.85-3.04,3.15c-2.06.29-4.07-.6-4.56-1.98.19-.71.37-1.41.55-2.12Z"
                  fill="#984a4a"
                />
                <path
                  d="M1571.13,569.13c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1526.48,652.7c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15s-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1592.8,568.25c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1607,547.2c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1539.11,582.63c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1539.16,630.03c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1521.32,647.07c-2.11.3-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15s-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1514.94,607.61c1.32.27,2.4,1.01,2.69,2c.43,1.44-.93,2.85-3.04,3.15-.58.08-1.13.04-1.67-.05.71-1.69,1.38-3.39,2.02-5.1Z"
                  fill="#984a4a"
                />
                <path
                  d="M1576.41,605.39c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1523.59,630.86c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1512.15,614.81c.95.36,1.67.99,1.91,1.77.41,1.36-.79,2.68-2.71,3.08.27-1.62.53-3.23.8-4.85Z"
                  fill="#984a4a"
                />
                <path
                  d="M1631.49,527.43c-1.51-.2-2.77-.98-3.1-2.07-.43-1.44.93-2.85,3.04-3.15.48-.07.95-.06,1.41,0-.45,1.74-.9,3.49-1.36,5.23Z"
                  fill="#984a4a"
                />
                <path
                  d="M1522.26,582.84c1.5.2,2.75.98,3.07,2.06.43,1.44-.93,2.85-3.04,3.15-.45.06-.89.07-1.31.02.44-1.74.87-3.49,1.28-5.24Z"
                  fill="#984a4a"
                />
                <path
                  d="M1533.86,563.76c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.6,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1536.79,570.45c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.61,2.08c2.11-.29,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1501.66,668.15c.43.34.75.74.89,1.2.33,1.12-.41,2.21-1.74,2.78.29-1.33.57-2.66.85-3.99Z"
                  fill="#984a4a"
                />
                <path
                  d="M1544.28,561.76c-2.11.3-3.47,1.7-3.04,3.15s2.49,2.37,4.61,2.08c2.11-.3,3.47-1.7,3.04-3.15-.43-1.44-2.49-2.37-4.61-2.08Z"
                  fill="#984a4a"
                />
                <path
                  d="M1613.61,558.97c-2,.17-3.9-.72-4.31-2.1-.43-1.44.93-2.85,3.04-3.15c1.47-.21,2.9.19,3.79.93-.86,1.43-1.69,2.87-2.53,4.31Z"
                  fill="#984a4a"
                />
                <path
                  d="M1572.35,524.12c-2.11.29-3.47,1.7-3.04,3.15.43,1.44,2.49,2.37,4.6,2.08s3.47-1.7,3.04-3.15c-.43-1.44-2.49-2.37-4.6-2.08Z"
                  fill="#984a4a"
                />
              </g>
              <path
                d="M1636.52,505.73c.66-2.32,1.31-4.64,2.12-6.87.05-.26.12-.52.17-.78-1.69,2.45-2.11,5.04-2.29,7.65Z"
                fill="#e28078"
              />
              <path
                d="M1575.44,630.87c-.12.17-.23.35-.34.53-.18.3-.36.6-.51.9-.21.41-.42.83-.58,1.25h-.01c-.18.43-.32.85-.45,1.27c0,0-.02,0-.01.01-.28.87-.48,1.76-.61,2.65-14.53,18.49-30.32,36.5-52.96,51.62-4.73,2.05-9.18,4.39-13.26,6.94-4.72,1.96-9.09,4.34-13.17,6.99c1.79-2.22,3.73-4.39,5.81-6.5.37-.4.77-.79,1.16-1.18.6-.6,1.21-1.18,1.83-1.77.57-.54,1.14-1.07,1.74-1.6c1.96-1.8,3.99-3.55,6.09-5.27.37-.31.75-.63,1.14-.93c1.49-.86,2.97-1.74,4.4-2.65c2.82-1.72,5.52-3.5,8.14-5.34c1.58-1.11,3.15-2.24,4.67-3.4.02,0,.01-.01.03-.01c26.26-19.66,42.98-43.93,56.85-68.42.03-.05.06-.11.08-.15.36-.62.7-1.22,1.03-1.83q0,0,.02-.03c.16-.27.3-.53.45-.8v0c2.16-3.87,4.26-7.72,6.31-11.57v0c.09-.19.2-.37.29-.54.55-1.09,1.09-2.17,1.63-3.24v0c.4-.81.8-1.6,1.18-2.4.51-1.02,1-2.04,1.49-3.05.18-.36.34-.71.52-1.08.63-1.3,1.25-2.59,1.85-3.88h.01c.42-.9.84-1.77,1.28-2.65.5-1.04,1-2.08,1.51-3.12.19-.42.39-.83.58-1.25.76-1.62,1.5-3.24,2.25-4.85.08-.17.15-.34.23-.5.48-1.05.95-2.09,1.43-3.14.3-.65.6-1.3.9-1.94.37-.84.76-1.66,1.17-2.49.54-1.14,1.08-2.3,1.65-3.43c0,0,0-.01.01-.01.25-.6.55-1.2.85-1.8.95-1.24,1.87-2.48,2.75-3.74c1.15-1.59,2.25-3.19,3.3-4.8.23-.35.46-.69.68-1.03v0c.82-1.27,1.61-2.52,2.35-3.78c1-1.62,1.93-3.24,2.83-4.87.84-1.5,1.65-3.01,2.41-4.51.7-1.35,1.37-2.71,2-4.06v0c.42-.85.83-1.72,1.21-2.57v0c.18-.38.35-.77.52-1.15v0c.42-.95.84-1.88,1.23-2.82c2.12-3.36,3.38-7.03,4.46-10.76.24-.79.47-1.58.69-2.37-.04.62-.06,1.23-.1,1.85-.02.43-.03.84-.05,1.27-.14,2.72-.44,5.4-2.12,7.84-.13.52-.27,1.03-.4,1.55-.32,1.32-.66,2.63-1.02,3.95-.09.4-.19.8-.31,1.21c0,.05-.02.1-.03.16-.33,1.29-.67,2.57-1.01,3.86-2.03,7.86-4.19,15.71-6.6,23.5-.68,1.51-1.32,3.03-2.09,4.52-1.74,3.45-3.95,6.73-6.12,10.06-4.71,7.2-8.97,14.54-13.2,21.87-8.32,14.42-16.6,28.85-27.34,42.52-.26.32-.48.64-.7.97Z"
                fill="#984a4a"
              />
              <path
                d="M1505.79,454.75v.02c.99,4.14,2.42,8.24,3.98,12.43c3.2,8.58,5.05,17.37,8.24,25.91c3.27,8.74,6.52,17.44,9.42,26.24c2.11,6.41,3.85,13.14,7.31,19.35.41.74.84,1.47,1.31,2.19.57.9,1.19,1.79,1.86,2.66.21.28.57.4.93.4.39.01.78-.12,1.01-.37.1-.09.18-.21.2-.33c0-.02,0-.04.01-.07.07-.35.14-.71.18-1.05.06-.28.09-.55.12-.82.05-.27.06-.53.1-.8.21-2.27.15-4.56-.14-6.85-.02-.23-.05-.44-.07-.67-.02-.18-.06-.36-.08-.54-.12-.82-.27-1.64-.43-2.46-.79-4.03-2.05-8.02-3.26-11.91-2.62-8.48-5.69-16.88-8.98-25.24-3.05-7.76-8.38-15.18-12.37-22.77-3.01-5.71-5.8-11.52-7.72-17.45l-1.63,2.12Z"
                fill="#ea4e56"
              />
              <path
                d="M1468.81,508.2c3.03,9.03,6.67,17.9,12.96,26.18c6.64,8.73,15.5,16.57,23.23,24.84c1.69,1.81,3.13,3.71,4.32,5.67c1.95,3.16,3.25,6.5,3.86,9.94.8,4.42-1.53,9.97,2.03,13.83.1.11.21.21.34.3.19.16.44.3.69.39v0c.99.45,2.29.52,3.23-.15.62-.43,1.12-.88,1.54-1.35q0,0,.01-.01c.18-.19.33-.38.46-.58.98-1.35,1.3-2.81,1.32-4.33.01-.49,0-.99-.05-1.5-.03-.2-.04-.41-.07-.61-.07-.77-.18-1.57-.28-2.37-.2-1.78-.54-3.55-.94-5.33-.07-.34-.15-.68-.24-1.01-.73-3.02-1.63-6.05-2.45-9.06-1.38-5.08-1.97-10.28-3.87-15.28-1.9-5.03-4.86-9.8-7.44-14.67-5.43-10.22-13.75-19.68-18.36-30.11-2.27-5.13-4.3-10.21-6.88-15.29-4.63,6.79-9.12,13.61-13.44,20.48Z"
                fill="#ffbe9f"
              />
              <path
                d="M1581.86,472.09c1.15-2.82,3.05-5.83,5.52-8.41.94-1,1.99-1.93,3.11-2.77c4.28-3.17,7.94-6.71,12.33-9.77c9.36-6.49,18.61-12.72,26.35-20.19c4.62-4.46,8.7-9.08,12.63-13.76.91,8.35,1.66,16.65,2.16,24.94-5.73,4.42-8.68,10.76-16.88,14.23-2.39,1.7-4.84,3.36-7.32,4.98-5.17,3.38-11.47,5.86-17.27,8.73-4.87,2.4-11.59,3.86-17.57,4.37-1.15.1-2.16-.23-2.71-.79-.11-.1-.19-.22-.26-.34-.22-.35-.26-.77-.08-1.22Z"
                fill="#ea4e56"
              />
              <path
                d="M1536.21,570.56c-.76,1.07-1.6,2.12-2.4,3.18v0c-1.56,2.03-3.08,4.04-4.26,6.13h-.02c-.13.21-.24.42-.35.63-.55,1.03-1.05,2.08-1.51,3.14-1.45,3.29-2.54,6.68-3.58,10.02-.14.4-.26.8-.38,1.2-.41,1.31-.81,2.62-1.19,3.92-.41,1.35-.78,2.71-1.16,4.07-.48,1.7-.94,3.41-1.37,5.11-.15.55-.29,1.11-.43,1.66-.42,1.73-.85,3.44-1.24,5.16-1.49,6.35-2.82,12.72-4.1,19.11-.37,1.76-.72,3.52-1.07,5.28-.29,1.47-.59,2.94-.88,4.4-.19.97-.39,1.95-.58,2.92-.54,2.62-1.06,5.25-1.61,7.87-.18.83-.34,1.67-.53,2.5-.28,1.26-.54,2.5-.82,3.75-.32,1.45-.65,2.9-.98,4.35-.12.52-.24,1.02-.35,1.53v0v.02v0c-.79,3.46-1.64,6.89-2.53,10.32v0c-.31,1.27-.65,2.52-.99,3.79-.19.7-.37,1.41-.56,2.12-.45,1.65-.91,3.31-1.38,4.96-.1.36-.2.72-.31,1.08-.44,1.56-.9,3.12-1.37,4.68-.3,1.02-.62,2.04-.94,3.05-.38,1.23-.8,2.46-1.19,3.69-3.56,2.02-6.92,4.26-10.1,6.63-4.58,3.42-8.49,7.32-11.81,11.48-.52-1-.62-2.16-.09-3.44c2.81-6.71,5.63-13.42,8.4-20.14.96-2.32,1.92-4.66,2.87-6.98c2.68-6.56,5.3-13.11,7.83-19.7c1.17-3.05,2.33-6.11,3.46-9.16c3.58-9.7,6.29-19.51,9.27-29.31c3.01-9.92,5.8-19.87,6.44-29.99.06-.96.16-1.92.32-2.89.2-1.56.52-3.12.88-4.69.21-.9.44-1.79.67-2.67v0c.03-.11.07-.22.09-.31.33-1.18.67-2.35,1.03-3.52.47-1.57.97-3.14,1.46-4.71.06-.18.11-.37.17-.56.84-2.72,1.65-5.45,2.25-8.15.05-.19.09-.38.13-.57c1.99-9.27,7.39-17.96,11.04-26.95.82-2.04,1.54-4.02,2.31-5.91c1.25-3.16,2.66-6.09,5-8.7.45-.51.94-1.01,1.48-1.5.8-.73,1.69-1.43,2.7-2.11.46-.32.96-.62,1.49-.93c1.2-.69,2.53-1.34,4.02-1.96.75-.31,1.51-.61,2.26-.9c5.53-2.18,11.33-4.1,17.13-6.01c5.8-1.92,11.62-3.83,17.25-5.97c18.16-7.69,37.32-13.57,54.5-21.75-.56,3.08-1.16,6.15-1.78,9.22-.05.26-.12.52-.17.78-.59,2.82-1.21,5.64-1.89,8.44-.1.1-.21.2-.33.3-.19.18-.39.35-.59.52-1.88,1.65-4.03,3.2-6.38,4.65-1.89,1.19-3.9,2.3-6.02,3.37-1.08.55-2.18,1.08-3.3,1.59h-.02c-.72.35-1.47.69-2.21,1.02-1.47.64-2.95,1.26-4.46,1.86-2.23.91-4.49,1.77-6.76,2.59-3.72,1.37-7.46,2.64-11.11,3.86-1.44.57-2.9,1.13-4.37,1.68-.68.25-1.35.5-2.03.74-1.34.49-2.67.97-4.01,1.44-.71.25-1.42.48-2.16.72-2.08.66-4.3,1.3-6.55,1.93-2.01.56-4.04,1.14-6.03,1.75-1.08.33-2.15.66-3.18,1.02h-.02c-1.78.6-3.5,1.24-5.12,1.96h-.01c-2.34,1.04-4.46,2.21-6.2,3.61h-.01c-.3.24-.57.46-.84.71-.09.08-.17.17-.26.24-2.28,2.08-4.2,4.35-5.88,6.72-.89,1.23-1.71,2.49-2.49,3.77-1.04,1.7-2,3.43-2.95,5.15v0c-.58,1.05-1.15,2.09-1.71,3.13-1.17,2.15-2.37,4.26-3.66,6.3-.58.89-1.19,1.77-1.85,2.64Z"
                fill="#ffbe9f"
              />
              <path
                d="M1501.46,649.43c7.92-26.54,11.05-53.71,21.41-79.89c19.66-49.73,56.05-95.45,80.59-144.01c13.14-26,22.75-52.87,29.29-80.01l.17-.13c-11.11,49.37-31.45,97.19-60.15,143.16-14.68,23.51-29.87,46.82-40.91,71.3-11.9,26.36-15.57,53.55-23.24,80.52-6.83,24-15.04,48.35-26.65,71.66-4.96,4.78-8.93,10.14-12,15.72-.03-.17-.02-.35.07-.55c11.67-25.77,23.52-51.28,31.42-77.76Z"
                fill="#fee8e5"
              />
              <path
                d="M1514.55,596.55c-1.81-12.67-3.28-25.33-6.81-37.87-.05-.16.28-.2.36-.05c6.13,12.38,8.08,24.89,7.36,37.88-.02.34-.85.4-.9.04v0Z"
                fill="#fee8e5"
              />
              <path
                d="M1508.88,482.09c.9,6.65,3.87,12.58,7.06,18.85c2.71,5.33,6.38,10.57,6.69,16.27.07,1.3-2.75,1.9-3.89.92-11.82-10.19-9.62-23.91-10.04-36.02c0-.07.17-.08.18,0v0Z"
                fill="#ea4e56"
              />
              <path
                d="M1625.23,418.4c5.01-6.51,9.7-12.82,13.82-19.64.15-.26.31-.52.46-.78.43,3.4.85,6.79,1.25,10.16-2.74,4.91-6.62,9.26-12.99,12.2-1.82.84-3.34-.91-2.54-1.95Z"
                fill="#fee8e5"
              />
              <path
                d="M1627.2,349.69c.17,3.56.39,7.12.12,10.66-.2,2.69-1.36,5.2-2.2,7.78-1.08,3.31-1.1,6.52-3.09,9.66-.14.22-.61.11-.52-.12c1.79-4.7,1.49-7.94-.83-12.54-1.38-2.74-2.48-5.01-2.78-7.93-.02-.23-.03-.46-.05-.69c3.13-2.25,6.25-4.52,9.34-6.82Z"
                fill="#7b3d3a"
              />
              <path
                d="M1637.41,381.46c.1.78.18,1.55.28,2.33.04.33.09.66.13.99-6.9,9.27-14.74,18.23-21.5,27.64-.29.4-1.06.05-.95-.32c3.49-11.37,13.24-20.86,22.04-30.64Z"
                fill="#ea4e56"
              />
              <path
                d="M1584.28,397.05c1.22-7.43,4.3-14.74,6.96-21.97c2.04-1.4,4.07-2.8,6.11-4.2-.4,1.03-.78,2.05-1.12,3.06-2.85,8.35-6.26,16.67-7.94,25.17-3.05,15.43,1.48,31.01-.36,46.49-.04.3-.72.27-.69-.03c1.52-16.24-5.6-32.31-2.95-48.52Z"
                fill="#7b3d3a"
              />
              <path
                d="M1582.2,473.65c3.31-2.85,7.39-5.27,12.49-7.03c8.99-3.12,17.61-5.37,27.09-9.42c8.71-3.72,14.64-13.08,21.94-18.77.41,5.88.69,11.75.82,17.61-3.46,2.5-6.96,4.62-9.94,5.93-11.64,5.08-20.42,10.3-31.21,13.23-14.4,3.9-24.56,10.49-33.79,18.36c2.52-7.14,6.06-14.35,12.59-19.92Z"
                fill="#cea6c0"
              />
              <path
                d="M1473.48,565.66c3.7,2.51,5.6,7.84,3.98,11.22-.57,1.18-2.97,1.24-3.8.19-1.42-1.8-1.52-3.93-1.82-5.93-.27-1.79-.39-3.57.4-5.3.17-.38.86-.43,1.24-.17v0Z"
                fill="#e28078"
              />
              <path
                d="M1452.86,595.29c.57,2.27,1.41,4.42,2.14,6.66.65,2.02,1.95,4.14,1.1,6.18-.43,1.01-2.36,1.41-3.59.84-3.02-1.4-3.67-4.38-3.68-6.74c0-2.45,1.28-4.98,3.1-7.07.23-.26.86-.17.93.12v0Z"
                fill="#e28078"
              />
              <path
                d="M1481.54,604.25c8.17,2.41,7.63,12.63,3.78,17.04-.99,1.14-3.27.6-3.75-.5-1.29-2.96-1.38-6.38-1.56-9.45-.15-2.53-.66-4.86,1.38-7.06.03-.03.1-.05.15-.03v0Z"
                fill="#e28078"
              />
              <path
                d="M1470.06,636.98c1.28,4.43,3.34,8.42,5.62,12.65.12.23-.31.5-.57.27-3.97-3.59-6.06-8.39-6.43-12.85-.04-.54,1.23-.58,1.38-.06v0Z"
                fill="#e28078"
              />
              <path
                d="M1491.73,665.52c-1.07-1.91-1.17-3.86-1.65-5.86-.49-2-1.79-4-1.52-6.04.08-.63,1.27-1.17,2.1-.71c4.6,2.58,5.68,9.28,2.62,12.67-.33.37-1.3.37-1.55-.06v0Z"
                fill="#e28078"
              />
              <path
                d="M1487.01,673.62c-1.46-2.38-1.85-4.98-2.99-7.44-1.45-3.16-3.65-6.15-5.58-9.18-.27-.42.54-.86,1.02-.48c5.21,4.21,9.89,11.36,8.38,16.98-.07.26-.64.42-.83.12v0Z"
                fill="#e28078"
              />
              <path
                d="M1483.4,652c-1.57-1.67-4.51-3.54-4.6-5.65-.01-.33.62-.52.99-.34c2.49,1.21,3.11,3.94,4.26,5.75.19.3-.4.5-.65.23v0Z"
                fill="#e28078"
              />
              <path
                d="M1496.38,652.92c-1.71-.97-1.67-2.53-2.2-3.94-.64-1.72-1.53-3.39-1.57-5.18c0-.45.87-.6,1.28-.3c1.79,1.32,2.58,3,3.22,4.72.54,1.44,1.57,3.23.28,4.56-.2.21-.71.31-1.01.14v0Z"
                fill="#e28078"
              />
              <path
                d="M1488.34,647.08c-.7-.27-1.15-.86-1.62-1.3s-.98-.91-1.11-1.46c-.1-.43.54-.69,1.06-.49.71.26,1.19.76,1.64,1.21s1.11.93,1.25,1.48c.13.49-.63.8-1.23.57v0Z"
                fill="#e28078"
              />
              <path
                d="M1499.97,640.29c-1.12-.67-1.39-1.97-1.85-2.91-.46-.93-1.13-2.05-.57-3.01.22-.38.88-.56,1.4-.33c1.28.58,1.7,1.75,2.11,2.71.45,1.05,1.26,2.17.87,3.26-.23.64-1.37.62-1.95.27v0Z"
                fill="#e28078"
              />
              <path
                d="M1471.13,663.08c-.7-.86-1.05-1.96-1.48-2.9-.39-.87-.64-1.87-.72-2.78-.06-.65,1.21-.77,1.75-.41c2.02,1.34,3.52,3.75,3.35,5.69-.1,1.06-2.18,1.29-2.9.41v0Z"
                fill="#e28078"
              />
              <path
                d="M1462.07,647.51c-4.51-1.05-7.74-4.77-8.15-7.89-.11-.82,1.1-1.56,2.24-1.04c3.88,1.77,7.14,5.47,6.32,8.74-.03.13-.2.23-.41.19v0Z"
                fill="#e28078"
              />
              <path
                d="M1457.34,633.12c-3.12-2.23-4.57-5.85-5.18-8.82-.07-.37.73-.62.96-.23c1.65,2.78,3.96,5.92,4.69,8.89.05.18-.28.3-.47.16v0Z"
                fill="#e28078"
              />
              <path
                d="M1484.06,639.4c-.74-.57-1.04-1.36-1.45-2.05-.46-.77-.75-1.41-.91-2.24-.15-.77,1.21-1.05,1.81-.43.7.72,1.1,1.37,1.52,2.19.36.69.84,1.37.84,2.11c0,.63-1.25.87-1.82.43v0Z"
                fill="#e28078"
              />
              <path
                d="M1505.08,694.31c-9.21,5.47-16.57,14.45-22.01,21.85-5.85,7.97-9.77,16.54-12.67,25.21-3.16,9.43-5.23,19.02-7.49,28.56-2.32,9.77-3.95,20.25-8.88,29.6-.68,1.28-3.22.82-3.27-.45-.48-11.18,3.34-22.68,5.86-33.68c2.18-9.54,4.29-19.11,7.74-28.49c3.19-8.66,7.51-17.13,14.03-24.89c6.74-8.02,15.41-12.83,26.13-18.14.43-.21.98.18.56.43v0Z"
                fill="#984a4a"
              />
              <path
                d="M1496.64,686.24c-1.64,8.12-5.43,15.09-10.52,22.47-5.49,7.95-8.54,16.5-13.85,24.43-.32.48-1.52.56-1.66-.07-3.92-18.24,17.6-30.78,24.43-47.04.25-.6,1.73-.42,1.6.22v0Z"
                fill="#e28078"
              />
              <path
                d="M1568.65,637.65c-8.47,8.42-13.82,18.2-22.83,26.34-4.3,3.89-9.89,6.46-14.92,9.83-6.3,4.22-10.71,9.75-16.76,14.2-5.99,4.41-12.86,8.45-17.54,13.6-4.26,4.69-7.34,9.95-10.78,14.93-8.07,11.69-16.47,24.01-20.81,36.65-.35,1.02-2.33.68-2.48-.23-2.16-13.32,4.83-24.4,12.94-36.24c3.68-5.38,7.11-10.92,11.25-16.14c4.17-5.25,10.1-9.47,16.12-13.73c6.55-4.63,11.93-9.62,17.82-14.61c5.11-4.33,12.56-6.89,17.85-11.12c10.06-8.03,14.41-19.07,28.05-24.9c1.25-.53,2.95.55,2.08,1.42v0Z"
                fill="#984a4a"
              />
              <path
                d="M1488.78,700c13.28-15.11,16.25-33.22,26.56-49.31.38-.59,1.92-.31,1.81.33-1.78,9.74-5.15,19.55-8.98,29.01-1.57,3.88-2.81,8.04-5.63,11.62-2.9,3.69-7.9,6.25-11.9,9.33-.9.7-2.56-.2-1.87-.99v0Z"
                fill="#984a4a"
              />
              <path
                d="M1496.83,690.48c8.45-7.74,17.24-14.82,23.03-23.66c2.44-3.73,4.76-7.65,8.14-11.03c3.85-3.84,9.35-6.82,12.45-11.04.26-.36,1.06-.04.79.32-3.46,4.65-3.44,10.04-6.36,14.82-2.25,3.68-5.36,7.29-8.98,10.41-3.74,3.22-8.42,5.88-12.25,9.08-4.88,4.09-9.62,8.24-14.51,12.32-1.04.87-3.29-.3-2.3-1.21v0Z"
                fill="#984a4a"
              />
              <path
                d="M1544,640.5c1.31-2.68,1.48-5.64,3.17-8.28c1.76-2.74,6.32-3.7,8.66-6.1.36-.37,1.24-.15,1.07.31-.54,1.41-1.36,2.75-1.85,4.18-.54,1.61-.67,3.26-1.6,4.81-1.75,2.91-4.23,4.28-8.03,5.82-.7.28-1.7-.19-1.42-.75v0Z"
                fill="#984a4a"
              />
              <path
                d="M1593.1,589.79c1.7,3.08-.43,6.96-2.01,9.88-1.65,3.05-2.71,6.82-6.97,8.67-.99.43-2.18.1-2.8-.5-3.13-3.01-.12-6.41,2.36-9.12c2.65-2.9,4.9-6.62,8.2-9.14.4-.3,1.04-.11,1.22.22v0Z"
                fill="#984a4a"
              />
              <path
                d="M1582.22,611.88c-.61,1.36-.75,3.03-2.91,3.66-.42.12-.91.04-1.05-.29-.67-1.56,1.09-2.66,2.27-3.85.56-.57,2.01-.23,1.69.49v0Z"
                fill="#984a4a"
              />
              <path
                d="M1577.88,619.21c5.49,7.83-7.74,17.94-14.67,23.36-.82.64-2.16.07-2.25-.64-.49-3.74,2.16-7.75,4.94-10.9c3.42-3.86,5.97-7.94,9.23-11.82.56-.67,2.22-.75,2.75,0v0Z"
                fill="#984a4a"
              />
              <path
                d="M1537.05,626.8c-.18,2.74,1.52,6.74-1.32,9.04-.97.79-2.29.7-3.15,1.23-1.29-.21-1.64-.14-1.03.21-.23.84-.55,1.67-.97,2.47-1.71,3.54-4.92,6.6-7.64,9.8-2.68,3.15-2.77,7.98-6.94,10.19-1.24.65-2.51.68-3.75,0-8.35-4.56,4.38-14.96,8.03-19.26c2-2.36,2.99-6.5,6.51-8.11c1.14-.52,3.46-.27,4.21-.63c1.75.62,1.99.16.71-1.38.72-1.27,1.24-2.58,1.56-3.92.46-1.44,3.87-1.13,3.77.35v0Z"
                fill="#984a4a"
              />
            </g>
          </g>
          <g transform="translate(0-182.266488)">
            <g>
              <g>
                <g>
                  <path
                    d="M1011.41,676.26c1.6-.53,2.91-1.21,4.6-1.7c1.69-.5,3.79-.88,5.62-.98c3.67-.21,7.71-.5,11.26.07c3.14.51,5.12,3.07,4.01,5.99-1.29,3.38-4.43,4.11-7.74,4.06s-6.73-.53-10-.93c-1.6-.2-3.14-.51-4.59-1.14-1.45-.62-2.51-1.18-3.93-2.07-1.43-.89-.81-2.76.79-3.29Z"
                    fill="#ffead7"
                  />
                  <path
                    d="M1122.32,648.44c-.14.37-.27.75-.44,1.12-.35.78-.64,1.64-1.02,2.43-3.07,6.23-6.37,12.82-10.98,17.94-3.48,3.87-11.52,5.09-12.39-1.2-.86-6.3,2.94-10.21,6.7-15.29c3.13-4.23,7.68-9.07,12.8-11.45.12-.06.35-.08.43-.12s.07-.09.1-.14c1.29-2.63,2.3-5.11,4.77-6.83.75-.52,2.1-.55,2.56.27c1.46,2.61.43,4.81-.43,7.43-.65,1.97-1.37,3.89-2.1,5.83Z"
                    fill="#ffead7"
                  />
                </g>
                <path
                  d="M995.27,719.95c.96.18,1.79.43,2.53,1.08c4.41,3.91,8.54,7.43,13.86,10.2c4.87,2.53,10.25,4.65,15.47,6.61c5.21,1.97,10.54,3.32,15.85,5.11c2.89.97,5.67,2.06,8.44,3.22c16.76,6.12,34.09,15.6,35.01,35.4.5,3.11,1.2,6.13,1.64,9.24-.25-.11-.48-.06-.74-.18s-.49-.21-.76-.4c-1.69-1.2-3.46-2.16-5.28-3.23-.77-.45-1.77-.97-2.48-1.57-.35-.29-.39-.97-.56-1.27s-.12-.31-.24-.55c-1.76-.97-3.31-2.1-4.8-3.34-3.51-2.46-5.47-6.11-9.26-8.4-1.64-1.47-3.32-2.91-5.1-4.34-5.14-4.11-10.66-7.91-16.29-11.45-2.47-2.66-5.27-5.11-8.51-6.71-1.31-.65-2.68-1.09-4.07-1.47-1.71-.96-3.43-1.89-5.07-2.82-4.48-2.53-8.54-5.52-12.29-8.8s-7.09-6.45-11.01-9.37c-1.91-1.42-3.7-2.79-5.07-4.7-.55-.77-.77-1.48-1.24-2.26Z"
                  fill="#727536"
                />
                <path
                  d="M1121.31,760.95c.12-.38.2-.79.28-1.07.07-.28.12-.41.16-.57s-.03-.06-.02-.08c.14-.63.13-1.17.28-1.81.06-.26.27-.25.41-.63.14-.37.17-.9.33-1.4c1.24-3.9.05-7.2,2.06-11.19c4-7.98,10.44-13.94,17.55-19.82s15.22-11.24,22.88-16.74c6.34-4.54,13.01-9.16,18.53-14.75c1.17-1.19,1.84-2.52,2.9-3.73.55-.63,1.12-.92,1.91-1.15-6.68,11.92-11.98,24.4-17.28,36.96-1.74,2.17-3,4.13-4.95,6.24-5.69,6.14-11.34,11.56-18.6,16.24-5.14,3.32-11.41,6.45-17,9.27-.34.63-.45,1.25-.79,1.87-2.14,3.96-4.62,7.26-8.23,10.05-1.04.8-2.6.62-3.27-.6c1.08-2.31,2.09-4.69,2.84-7.1Z"
                  fill="#a2a360"
                />
                <g>
                  <path
                    d="M1141.05,726.16c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1125.82,743.78c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1155.44,738.87c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1138.65,728.93c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1167.99,711.3c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1141.86,739.29c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.5,731.27c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1145.35,747.38c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1153.59,726.22c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1133.53,733.05c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.78,719.4c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.76,735.26c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1160.61,719.32c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1134.92,739.81c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1151.86,729.95c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1134.98,736.86c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1137.96,746.53c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1126.79,744.6c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.69,728.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.13,749.17c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1141.97,732.5c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.75,722.14c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1135.02,731.4c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1135.66,743.97c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.09,733.46c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.4,733.2c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1133.14,738.44c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1136.66,748.37c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.35,746.08c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1124.93,747.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1126.16,746.63c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1151.67,736.38c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1158.48,716.25c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.2,738.33c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1138.08,748.7c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.4,747.2c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1159.05,725.12c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1162.52,726.96c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1138.53,735.75c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.79,736.31c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1150.83,725.43c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1159.81,728.18c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.2,741c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1163.92,720.39c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1141.3,734.1c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.31,730.4c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1134.78,734.93c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.67,745.66c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1138.15,740.82c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.14,737.57c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1164.1,714.71c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1132.38,741.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1143.54,730.67c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1143.22,728.13c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.26,741.77c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1137.5,738.11c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1128.23,739.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.24,719.61c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1139.02,741.77c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1145.55,743.5c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1139.4,731.26c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.58,744.16c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1161.46,711.77c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.81,727.98c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.1,740.64c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.67,734.71c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.6,717.05c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1155.88,724.83c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.14,725.17c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1154.5,732.07c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1128.65,744.84c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1130.38,742.12c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1141.61,747.93c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.22,740.54c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1145.55,721.72c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.53,749.6c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.76,727.15c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1153.92,721.96c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1127.47,741c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1157.35,727.7c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1161.55,715.52c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.92,742.28c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1143.22,724.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1169.95,719.42c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1132.15,739.31c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1137.92,733.89c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1162.74,730.72c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1133.52,747.23c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.17,749.23c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.74,721.29c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1132.59,734.91c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.49,736.35c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1127.43,747.57c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1138.38,743.56c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.88,742.17c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1137.71,744.66c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1162.39,723.89c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.34,728.18c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1133.6,744.15c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1165.25,728.16c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1162.6,728.99c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1139.96,746.34c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.09,732.13c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1128.35,749.2c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.59,746.61c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1165.53,721.65c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.28,738.6c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1155.44,718.47c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.72,743.29c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1134.04,742.56c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.34,749.44c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1157.92,713.98c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1142.71,744.42c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1136.44,730.24c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.24,734.57c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.15,723.88c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.16,730.8c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1141.12,740.68c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1143.78,746.46c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.13,739.98c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1165.39,730.37c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.85,736.61c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1150.97,732.18c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.14,733.75c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1130.71,736.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1143.03,726.35c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1158.69,733.02c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1136.46,740.41c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1135.66,746.35c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.05,739.03c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.5,732.55c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.41,747.47c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1157.71,718.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.73,730.47c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.95,744.5c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.55,743.31c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1147.77,743.16c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1135.9,738.65c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.03,741.52c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.35,743.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1136.88,736.38c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1157.68,736.87c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1157.96,730.88c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.33,737.08c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.58,744.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1131.09,737.9c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1159.09,735.04c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1153.13,737.61c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1153.1,730.6c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1154.88,727.96c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1127.86,742.85c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1133.74,748.91c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1139.3,739.06c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.4,722.83c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.8,738.97c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1151.21,740.65c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1139.08,727.65c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1151.18,743.31c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1153.83,734.43c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1156.11,734.14c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1140.85,730.29c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1135.48,748.47c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1172.05,714.72c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1161.7,734.37c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1144.01,748.34c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1129.56,737.32c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1167.6,707.53c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1168.07,725.17c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1150.65,724.06c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1146.12,745.52c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1136.73,733.16c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1155.42,715.76c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1149.76,727.4c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1152.47,723.34c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1156.84,721.48c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                </g>
                <path
                  d="M1097.49,736.81c-.74-1.07-1.38-3.19-1.66-4.59-.1-.49-.35-.88-.41-1.29-.26-1.77-.4-3.46-.64-5.21-.03-.21-.14-.49-.14-.68s.02-.28,0-.43c-.37-3.97-.87-7.79-.89-11.82-.01-2.24.18-4.41.55-6.74.38-2.32-.02-4.47.66-6.94c1.37-4.98,2.98-9.13,5.95-13.8c5.91-9.31,12.7-17.8,20.61-26.07s16.68-17.06,24.48-25.71c.68-.75,1.64-1.02,2.61-1.13-.09.27-.21.56-.33.82-.73,1.6-1.56,3.23-2.28,4.82-1.9,4.2-3.91,8.47-5.36,12.8-2.01,5.98-3.38,11.98-5.29,17.95-.43,1.34-.75,2.74-1.42,4-1.78,3.37-3.77,6.69-5.83,9.89-4.93,7.7-11.09,15.27-15.99,22.74-2.63,4-4.2,7.65-6.34,11.55-1.39,2.53-2.03,4.72-3.22,7.25-.58,4.79-1.48,9.54-2.32,14.32-.13.73-1.1.69-1.66.59-.26-1.11-.35-1.27-1.09-2.34Z"
                  transform="translate(.000001 0)"
                  fill="#a0ad77"
                />
                <path
                  d="M991.26,708.2c5.05.87,10.26,1.97,15.41,2.29s10.21-.16,15.24-1.11c4.14-.78,8.22-1.89,12.34-2.26c1.34-.12,2.81.08,3.98.25c4.83.7,11.22,1.74,15.34,3.42c9.09,3.69,14.24,10.62,20.24,17.12c4.64,5.04,7.93,8.89,12.2,13.78.28.32.37.59.56.94.62,1.16,1.13,2.23,1.72,3.43s.96,2.62,1.4,3.91c-.24.22-.49.38-.77.53-.67-.74-1.39-1.39-2.19-1.99-4.11-4.3-8.76-6.61-14.36-8.45-.99-.76-1.83-1.55-2.88-2.27-.63-.44-1.18-.82-1.92-1.21-3.42-1.81-5.93-3.47-9.85-4.83-7.99-2.77-16.98-4.56-25.45-6.28-.9-.18-1.94-.41-2.85-.6-5.39-2.41-10.84-4.13-16.6-5.4-2.45-.83-5.11-1.54-7.53-2.35s-4.86-1.46-7.1-2.54c-4.84-2.33-9.31-5.12-13.96-7.73-.26-.14-.4-.3-.63-.47c2.56.8,4.96,1.36,7.64,1.82Z"
                />
                <path
                  d="M1087.41,674.72c1.15,7.04,4.34,12.26,5.1,19.29.13,1.22,2.16,1.77,3.27,1.66c1.54-1.35,2.82-2.65,4.11-4.27c1.29-1.63,2.72-3.37,4.3-4.78c2.77-5.02,5.81-9.46,9.22-14.14c4.11-5.63,9.65-10.99,12.96-17.15c6-11.19,6.8-22.58,7.96-34.93.29-2.07.66-4.06.45-6.17-.11-1.09-.92-1.64-1.95-1.86-1.18,3.49-3.48,7.68-5.77,10.25-3.69,4.14-7.5,6.59-11.67,9.71-1.1.83-2.21,1.79-3.15,2.57-6.72,5.57-15.21,11.77-20.16,18.4-5.46,7.3-5.99,13.34-4.67,21.44Zm14.86-10.39c1.02-3.57,2.95-6.42,5.48-9.45c5.33-6.36,11.64-12.47,17.29-18.69-.16.62-.16,1.16-.36,1.79-2.21,6.74-5.18,12.19-9.47,18.01-4.01,5.44-8.87,11.01-13.04,16.51-.01-2.87-.73-5.24.1-8.17Z"
                  fill="#6d6d38"
                />
                <path
                  d="M976.3,674.85c.12.32-.02.58.3.84c8.66,7.25,17.26,10.13,28.58,11.04c7.91.63,15.81.16,24.06.65c8.25.48,17.35,1.56,25.74,2.54.23.03.51-.13.74.02.89.56,1.68,1.31,2.48,2c4.32,1.7,8.62,3.45,12.87,5.32.68.3,1.37.51,2.09.64.07.01.18-.03.13-.11-1.09-1.57-1.89-2.83-3.13-4.42-3.02-3.88-6.48-7.85-10.32-11.04s-7.93-5.58-12.1-8.3-8.56-5.16-13.24-6.99c-.6-.24-1.24-.49-1.91-.48-5.35.04-10.5.88-15.77,1.86-5.95,1.11-11.63,2.54-17.54,4.14-7.65,2.06-15.01,3.57-22.99,2.3Zm31.58,3.07c5.72-.66,11.58-1.47,17.29-1.09c4.44.29,8.3,1.49,12.49,2.7-8.41-.97-16.81-1.24-25.25-1.5-1.53-.05-3.01-.08-4.52-.11Z"
                  fill="#ba9e7e"
                />
                <g>
                  <path
                    d="M1046.82,679.37c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1043.19,684.22c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1059.26,687.98c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1028.45,683.67c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1048.89,677.15c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1046.48,681.72c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1060.34,685.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1036.76,685.04c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1066.02,692.32c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1030.56,681.84c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1051.5,682.76c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1068.17,693.96c-.41.22-.56.73-.34,1.13.22.41.73.56,1.13.34.41-.22.56-.73.34-1.13-.22-.41-.73-.56-1.13-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1061.82,690.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1052.39,686.93c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1051.98,685.03c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1040.65,672.85c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1061.38,687.82c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1027.02,685.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1032.37,672.67c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1020.5,684.48c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1042.2,672.41c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1025.5,669.26c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1023.94,685.96c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1044.46,677.51c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1044.93,686.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1033.49,687.01c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1063.1,691.55c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1045.53,676.04c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1054.59,685.48c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1038.64,683.86c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1047.98,684.79c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1061.87,689.08c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1034.15,675.11c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1053.98,680.37c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34s.55-.72.34-1.12c-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1043.35,674.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1057.62,689.25c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1060.11,683.48c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1067.66,692.14c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1050.71,677.87c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1048.29,686.53c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1056.71,687.97c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1039.28,674.92c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1052.43,679.12c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1047.01,674.81c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1061.83,686.38c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1015.89,683.61c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1034.36,676.88c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1030.46,670.51c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1043.66,678.95c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1057.33,682.27c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1050.59,683.46c-.4.22-.55.72-.34,1.12s.72.55,1.12.34c.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1046.37,683.87c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1052.63,682.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1062.57,685.36c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1034.36,667.4c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1040.08,681.69c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1036.02,669.88c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1055.66,683.34c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1040.21,685.91c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1042.79,686.38c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12s-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1044.13,672.41c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1036.05,674.43c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1043.3,680.9c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1037.63,681.96c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1029.03,677.72c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1055.44,687.09c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1063.15,687.1c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1027.1,674.07c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1025.26,683.6c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1056.37,680.71c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1029.94,667.26c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1041.55,678.11c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1069.71,694.62c-.41.22-.56.73-.34,1.14s.73.56,1.14.34.56-.73.34-1.14-.73-.56-1.14-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1064.97,690.1c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1035.01,680.39c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1057.07,684.99c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1049.23,683.14c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1059.13,689.64c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1058.75,686.58c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1060.45,690.41c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1038.32,686.68c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1039.1,669.77c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1050.22,680.22c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1032.2,683.68c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1034.62,684.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1066.11,690.2c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1058.86,684.44c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1037.65,676.94c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1036.65,672.3c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1044.94,683.5c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1063.72,690.62c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1058.5,683.11c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1024.02,680.01c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1018.92,676.02c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1040.46,680.41c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1050.14,685.28c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1031.41,677.07c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1054.83,682.32c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1041.23,683.22c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1064.03,688.26c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1048.43,675.53c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1039.56,677.82c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1064.61,691.86c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1036.95,679.04c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1031.16,685.67c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1032.4,680.22c-.4.22-.55.72-.34,1.12.22.4.72.55,1.12.34.4-.22.55-.72.34-1.12-.22-.4-.72-.55-1.12-.34Z"
                    fill="#4e531e"
                  />
                </g>
                <path
                  d="M1070.08,658.2c-.82-4.24-1.22-8.63-1.53-12.96-.02-.22-.17-.38-.13-.61.9-5.54.22-9.98,2.97-15.36c7.36-14.43,19.52-25.12,31.48-36.03c2.8-2.56,5.27-5.25,8.18-7.66c1.09-.9,2.37-1,3.72-.83-2.54,2.56-5.72,5.07-7.77,7.97-2.4,3.39-3.57,6.98-4.8,10.76-1.59,4.89-2.9,9.64-4.6,14.45-1.36,3.85-3.11,7.76-4.37,11.61-2.97,9.1-5.84,18.06-9.43,26.9-1.16,3.51-2.71,6.43-5.03,9.36-.63.79-1.06,1.87-1.85,2.67-1.33,1.34-3,1.43-4.67.55-.45-3.69-1.46-7.15-2.17-10.81Z"
                  fill="#4e6528"
                />
                <path
                  d="M985.98,637.83c6.6.07,13.5.01,20.16.48.13,0,.3-.02.43.03c4.77,1.82,9.97,4.14,14.41,6.36c5.81,2.91,11.65,6.18,16.78,9.54c5.12,3.37,9.04,6.26,13.05,10.59.65.7.12,1.24-.23,1.91-1.43-.91-2.99-1.25-4.53-1.86-2.44-.97-5.03-1.59-7.58-1.91-.74-.09-1.3-.12-1.91-.21-5.26-.79-11.12-1.81-16.08-3.23-5.83-1.66-12.42-4.03-17.4-6.33-10.45-4.84-18.85-10.27-28.23-16.27-.53-.34-.56-.63-.88-1.13c4.05,1.47,7.64,1.98,12.01,2.02Z"
                  fill="#707758"
                />
                <path
                  d="M1049.47,623.2c.13-6.42,1.23-12.22,3.58-18.08c2.18-5.44,5.57-10.44,8.44-15.41c2.48-2.59,4.38-5.3,5.94-8.64c1.04-2.23,1.97-4.64,2.48-7.11.52.81.97,1.65,1.3,2.51.69,1.17,1.14,2.39,1.47,3.61.32,1.22.5,2.44.73,3.55.32,5.99.64,11.5.25,17.55-.42,6.49-2.05,12.98-4.15,19.2-1.35,1.79-2.41,3.63-4.02,5.23-1.15,1.16-2.62,1.93-4.08,2.75-3.26,1.86-6.04,3.79-8.08,7.03-2.85-3.59-3.96-7.72-3.87-12.2Z"
                  fill="#8e934b"
                />
                <path
                  d="M970.19,590.5c2.87,3.17,6.12,4.73,10.24,5.57.98.2,1.83.18,2.72.28c1.79.2,3.48.27,5.21.62.71.15,1.29.36,1.95.64c2.65,1.11,4.88,2.03,7.62,3.24c3.85,1.7,7.3,4.33,10.19,7.56.66.74,1.22,1.54,1.86,2.38c1.92,2.52,3.76,5.1,5.75,7.65c1.53,1.95,3.28,3.81,5.12,5.56.61.58,1.26,1.14,1.93,1.77c3.26,3.01,6.6,5.7,8.69,9.75-4.41-1.09-8.83-.56-13.27-1.69-4.01-1.01-8.06-2.42-11.99-3.92-.9-.35-1.8-.76-2.71-1.28-5.47-3.15-10.63-7.17-15.24-11.39-2.51-2.3-4.35-4.62-6.51-7.09-.72-.83-1.36-1.67-2-2.51-.63-.85-1.23-1.66-1.81-2.5-.93-1.35-1.79-2.7-2.62-4.1-.22-.36-.33-.77-.51-1.14-1.51-3.12-3.07-6.2-4.67-9.27-.02-.03.03-.07.03-.11Z"
                  fill="#384512"
                />
                <path
                  d="M1025.52,611.3c-.6-5.23.23-9.38,1.05-14.7.93-6.05,4.88-11.07,9.07-15.56c1.74-1.87,3.58-3.48,5.48-5.13c2.76-1.29,5.52-2.48,8.2-3.93c3.29-1.78,6.3-3.36,9.57-5.38.37-.22.72-.46,1.06-.7c2.93-1.63,5.12-2.81,7.64-5.11c1.01,8.86-4.32,16.43-8.74,23.26-.82,1.15-1.65,2.27-2.5,3.38-2.54,3.33-5.15,6.5-7.42,9.54-1.61,1.86-3.29,3.69-5.05,5.5-3.7,2.08-6.97,3.67-10.56,6.26-1.69,1.22-3.87,3.51-4.97,5.53-1.13-.65-2.68-1.57-2.84-2.95Z"
                  fill="#7f8343"
                />
                <path
                  d="M1010.39,581.29c-1.07-2.53-1.91-5.01-2.41-7.66-.17-.88-.19-1.64-.18-2.51c0-.86.13-1.7.23-2.56.1-.85.19-1.68.39-2.53c1.13-4.94,2.68-9.7,4.57-14.4.29-.25.5-.47.75-.76c2.58-2.9,5.28-5.61,8.18-8.23.72-.65,1.48-1.29,2.24-1.98c6.79-6.2,12.56-12.5,16.75-20.78.47,1.42.68,2.62.44,4.14-.15,1-.43,2-.71,3.04-.48,1.8-.98,3.58-1.49,5.35-1.54,2.56-2.12,5.42-2.56,8.35-3.58,10.96-7.96,21.5-13.73,31.77-.13.23.01.59-.2.78-.62.55-1.27.92-1.91,1.49-3.05,2.7-5.97,5.51-8.55,8.69-.74-.57-1.46-1.38-1.81-2.21Z"
                  fill="#6f7e43"
                />
                <path
                  d="M960.58,568.34c4.35-.14,8.95-.8,13.3-1.56c3.12.17,6.14.44,9.19,1.16.76.18,1.37.34,2.17.68c10.06,4.28,15.39,10.39,16.32,21.48.1,1.14-.37,2.19-.32,3.33c0,.09-.17.09-.23.04-.79-.7-1.57-1.4-2.45-2.01-3.43-2.34-6.15-5.27-9.01-8.26-.8-.84-2.1-.99-3.13-1.34s-2.08-.58-3.06-.91c-9.76-3.27-19.19-7.25-28.38-11.73-1.22-.59-1.48-1.22-2.04-2.33c2.62,1.05,4.74,1.53,7.64,1.44Z"
                  fill="#93a059"
                />
                <path
                  d="M1002.38,560.22c-.11-1.05-.21-2.38-.25-3.57-.09-2.76-.53-5.51-1.29-8.2-.25-.89-.6-1.69-.92-2.59s-.71-1.87-1.06-2.8c-3.77-9.95-9.08-18.96-14.28-28.22-.43-.76-.6-1.61-.92-2.44-.65-1.67-1.17-3.21-1.83-4.95-.66-1.75-1.43-3.79-2.1-5.59.03,3.82.03,7.61-.11,11.45-.04.96-.11,1.95-.17,2.95-.56,8.83-1.06,17.61-.93,26.49.01.84.08,1.63.24,2.56.15.93.35,1.98.71,2.98c1.77,4.98,4.29,8.88,8.45,12.22.61.49,1.12,1.04,1.76,1.48c2.55,1.76,4.51,4.27,7.29,5.72c3.23,1.69,4.74-1.89,5.28-4.69.17-.88.25-1.74.14-2.79Z"
                  fill="#8b894e"
                />
                <path
                  d="M989.74,547.02c-.31-.43-.62-.85-.94-1.27.32.42.63.84.94,1.27Z"
                  fill="#3d470d"
                />
                <path
                  d="M1063.16,760.1c5.28,2.74,11.57,5.59,15.86,9.49s6.32,8.58,8.25,13.49c4.06,10.29,7.38,20.08,10.83,30.44c1.82-14.04,4.34-27.01,2.38-41.18-.19-1.36-.39-2.59-.67-3.94-.05-.25-.25-.43-.4-.69-.54-.92-1.01-1.76-1.62-2.71-.61-.94-1.41-2.02-2.03-3.01-.26-.41-.56-.83-.75-1.25-4.5-5.34-6.24-11.27-10-17.25-4.86-7.7-11.57-13.21-19.81-17.32c1.38.25,2.82.56,4.2.92.22.48.49.7.96.93c4.91,2.41,8.75,5.88,12.77,9.52.71,1.01,1.5,2.04,2.15,3.08c1.05,1.68,2.09,3.3,2.91,5.09.52,1.13.86,2.23,1.55,3.29s.76,1.97,1.31,3.21c1.86,4.22,5.08,7.7,8.05,11.26-2.38-11.42-6.12-22.49-8.61-33.89c0-.02-.02-.02-.03-.03c0-.01,0,.01,0,0-.69-.71-1-1.43-1.41-2.36-.41-.92-1.24-1.94-1.8-2.75s-.8-1.45-1.08-2.33c-.15-.48-.31-.99-.43-1.47-4.08-5.81-6.92-11.61-10.5-17.87-2.84-4.95-5.94-9.56-10.62-13.5-4.1-3.45-10.04-5.87-14.96-8.34-.12-.06-.17-.09-.16-.23c2.61,1.23,5.03,1.44,7.73,2.72c4.8,2.26,9.02,5.86,13,9.48c1.63,2.04,3.57,4.24,4.88,6.41c2.73,4.52,4.81,9.07,7.44,13.58c1.35,2.31,2.9,4.54,4.3,6.83.66.57,1.01,1.42,1.38,2.16.36.73.75,1.29,1.11,1.98.01.02.02.03.03.03-2.14-8.21-4.5-16.64-8.24-24.15-1.59-3.19-3.51-5.93-5.18-8.66-1.43-2.34-2.4-3.85-3.75-6.02-.36-.58-.35-1.37-.81-1.87-.65-.7-1.82-1.01-2.51-1.67-.7-.65-1.04-1.39-1.66-2.08-1.35-1.48-2.53-2.99-4.1-4.3-3.5-2.92-7.42-5.43-11.15-8.07-5.33-4.7-11.12-7.8-17.62-10.71-3.15-1.41-6.64-2.75-9.88-3.96c8.12,2.58,16.7,6.02,23.82,10.31c5.29,3.18,9.01,6.5,13.7,10.02c1.55,1.16,2.8,2.27,4.29,3.43.59.46,1.11.86,1.65,1.37-.52-.95-1.04-1.9-1.56-2.84.07-.39.13-.68-.06-1.05-1.56-3.05-3.43-5.87-5.23-8.8-1.17-1.9-2.13-4.01-3.16-6-.11-.02-.22-.02-.32-.08-1.12-.65-2.23-1.3-3.35-1.96-1.8-1.94-3.61-3.88-5.42-5.81c2.72,1.37,5.17,3.04,7.53,4.95-.73-1.21-1.5-2.39-2.29-3.56-1.35-.88-1.9-2.06-2.39-3.54-.09-.27-.27-.43-.4-.65-.94-1.52-1.95-2.9-3.23-4.14-.1-.1-.22-.21-.34-.27-.13-.06-.23-.03-.36-.11-7.34-4.79-15.74-7.09-23.53-10.98-2.89-1.44-5.45-3.43-8.15-5.18-1.36-1.67-2.77-3.24-4.29-4.76c4.77,3.33,8.92,6.91,14.16,9.68c5.96,3.15,12.91,5.09,19.06,7.99-3.67-4.8-8.54-8.34-12.85-12.5s-7.88-8.84-11.52-13.55c-.61-.8-.75-1.78-1.31-2.61-.89-.48-1.77-.98-2.62-1.56-.05-.04-.07-.1-.12-.15-2.54-2.72-5.54-5.04-8.16-7.65-2.94-2.92-5.26-6.19-7.59-9.59-2.02-2.95-3.99-5.96-6.29-8.67-.52-.62-1.06-1.1-1.65-1.58-.58-.48-1.14-.84-1.78-1.2-.63-.36-1.26-.63-1.94-.91s-1.42-.49-2.13-.73c-.12-.04-.24-.1-.36-.16s-.12-.23.06-.2c.93.2,1.92.49,2.79.84.86.36,1.69.79,2.45,1.27.75.48,1.51,1.03,2.12,1.61c3.04,2.91,5.25,6.66,7.61,9.98c2.88,4.07,5.68,7.55,9.23,11.01c2.35,2.29,5.37,4.11,7.78,6.41-1.59-3.22-3.26-6.42-4.69-9.71-.79-1.82-1.47-3.7-2.38-5.45-.49-.94-1.06-1.67-1.15-2.77-1.55-3.37-3.19-6.68-4.97-9.94-.36-.65-.78-1.26-1.11-1.93-4.38-8.83-7.93-17.88-10.95-27.26-.31-.97-.77-1.88-1.2-2.8-.43-.93-.96-1.8-1.5-2.68-.2-.33-.44-.64-.65-.96c1.11,1.65,2.19,3.32,3.15,5.07.48.87.98,1.75,1.38,2.65c3.71,8.42,7.15,16.93,11.23,25.17.41.83.82,1.66,1.23,2.49c1.22,2.5,2.37,5.04,3.53,7.56.1-.91.61-1.98.75-2.83.37-2.2.49-4.57.84-6.64s.9-3.61,1.59-5.5c.03-.08.06-.13.09-.22-.41,2.34-.81,4.67-1.02,7.04-.17,1.9-.35,3.81-.67,5.69.32,1.24.2,2.31.19,3.61s.34,2.72.46,4.04c4.43,9.66,9.13,18.84,15.59,27.3-.08-.3-.21-.72-.3-1-.78-2.35-1.58-4.61-1.39-7.08s.86-4.51,1.41-6.95c.55-2.45.94-5.25,1.55-7.75.01-.04.04-.08.08-.09-.5,2.16-.66,4.3-.83,6.51-.08,1.05-.34,2.11-.5,3.14-.29,1.85-.44,3.39-.67,5.34s.14,4.07,1.02,5.93c.17.35.2.77.31,1.14.26.84.53,1.69.9,2.49c7.41,7.07,15.24,13.46,21.48,21.64-.18-2.61-.02-5.19.4-7.75.08-.49.18-1.1.3-1.47.13-.37.33-.44.43-.71c1.48-3.99,2.58-8,3.58-12.13-.47,3.48-1.24,6.65-2.04,10.12-1.07,4.65-1.82,9.28-1.23,14.1.62.98,1.33,2.02,1.94,2.98c6.17,9.72,11.92,19.61,17.62,29.58.04-1.15.15-2.15.29-3.29.49-4.18.08-7.73-.21-12.04-.53-8.03,1.73-15.55,4.46-23.13.04-.11.26-.11.23,0-2.09,7.85-3.79,15.6-3.08,23.68.32,3.6.67,6.73.19,10.16-.36,2.58-.59,4.7-.41,7.25c4.05,7.17,7.95,14.44,11.46,21.88c6.44-5.02,7.83-11.26,9-18.89s4.29-13.78,7.34-20.67c.04-.1.26-.09.23.02-1.38,4.11-2.98,7.9-4.35,12.06-1.37,4.15-1.81,7.97-2.44,12.51-.72,5.23-2.65,10.08-6.64,13.89-.35.73-.82,1.27-1.13,2.01s-.35,1.62-.64,2.38c4.4,13.78,6.05,28.16,11.11,41.74.23-.57.52-1.07.85-1.6.13-.2.32-.37.42-.62.49-1.21.89-2.31.87-3.67s-.45-2.69-.91-3.97c-.28-.77-.58-1.47-1.08-2.11-.41-3.3-1.5-6.05-1.5-9.49c0-8.02,2.27-15.06,6.06-22.17.07-.13.34-.06.28.08-3.61,8.12-5.43,16.06-4.85,24.87.27,4.05,1.77,7.07,2.78,10.88.42,1.59.46,3.19.3,4.94-.08.88-.37,1.96-.55,2.92-.25,1.35-.56,2.79-1.04,4.11.13.42.28.85.39,1.27.68,2.38,1.06,4.81,1.51,7.23.22-.53.52-1.23.75-1.72c1.2-2.54,2.33-4.99,3.82-7.35-.13,1.48-.02,3.06-.3,4.51-.29,1.45-.73,2.76-1.09,4.16-.2.77-.69,1.42-.96,2.17-.41,1.13-.76,2.24-1.35,3.28.76,4.42,1.43,8.83,1.81,13.3c2.67-2.69,6.51-4.79,9.26-7.19c4.7-4.1,7.86-8.87,10.81-14.05c1.55-2.72,2.65-5.15,4.22-7.67c1.17-1.89,2.36-3.63,3.68-5.34c2.35-3.05,4.84-5.69,7.51-8.47c1.06-1.11,2.32-2.31,3.33-3.5.02-.02,0,.06-.03.09-3.81,4.28-7.6,8.64-10.7,13.46-2.76,4.3-4.53,8.59-7.11,13.1-2.35,4.1-5.05,8.11-8.63,11.53-2.11,2.01-5.11,3.7-7.51,5.48-.02.01-.02.02-.02.03-1.05,1.32-2.04,2.63-3.03,4.01-.52.71-1.06,1.49-1.69,2.13-.35,10.68-2.52,21.2-3.99,31.78-.85.66-1.7,1.32-2.55,1.97.13-.76.23-1.53.37-2.28-4.15-9.83-7.28-19.57-11.06-29.68-1.81-4.83-3.13-9.64-6.85-13.95-4.32-5-10.84-8.91-16.7-12.32-.07-.04,0-.12.07-.08Z"
                  fill="#3d470d"
                />
                <path
                  d="M1085.53,705.46c0,0-.02,0-.03.01c0,0,0,.02.01.02c0,0,.02-.03.01-.03Z"
                  fill="#3d470d"
                />
                <path
                  d="M1182.37,699.6c-1.92,3.28-3.62,6.7-4.79,10.28-1.07,3.26-.92,6.29-2.03,9.58-2.19,6.46-5.54,11.62-10.43,16.64-4.46,4.58-9.84,8.77-15.26,12.37-2.92,1.94-6.32,3.13-9.52,4.53s-6.57,2.64-9.83,3.77c-.71.25-1.05-.49-.49-.84c2.8-1.77,5.91-3.33,8.64-5.15s5.26-4,7.84-5.91c5.14-3.8,10.43-7.87,14.81-12.32c5.02-5.1,8.51-10.29,11.26-16.7c1.13-2.64,1.64-5.15,3.13-7.57c1.92-3.12,4.36-5.83,6.65-8.69.01-.01.04,0,.03.01c0,.02,0,0,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M1012.85,719.44c-1.39-.33-2.77-.91-4.15-1.27.03-.05.11-.05.18-.05c6.34.52,13.31,1.89,19.29,3.47c6.31,1.67,13.05,3.68,18.72,5.58c11.52,3.86,21.16,8.11,31.28,14.32.28.17.02.52-.29.4-10.74-4.16-21.22-7.84-32.33-11.46-4.1-1.34-9.24-2.88-13.54-4.16-6.18-3.17-12.42-5.23-19.15-6.83Z"
                  fill="#4e531e"
                />
                <path
                  d="M982.17,680.27c14.37,3.04,26.78,4.62,41.93,4.55c13.98-.06,28.1,1.67,40.46,9.62.05.03.2.13.15.11-1.56-.59-3.14-1.23-4.71-1.82-.38-.15-.71-.23-1.14-.26-13.11-3.97-26.68-4.08-40.1-4.14s-24.47-2.82-36.61-8c-.04-.02-.02-.07.01-.06Z"
                  fill="#4e531e"
                />
                <path
                  d="M1145.49,635.9c-3.84,14.53-5.52,29.32-12.82,42.72-7.31,13.4-18.44,24.36-27.24,36.78-.11.16-.44.03-.35-.15c1.58-3.1,3.13-5.64,4.72-8.87s3.11-6.61,5.26-9.82c4.2-6.24,9.84-12.55,13.28-19.26c6.9-13.48,10.03-28.03,16.94-41.41.05-.1.25-.09.22.02s-.02.01,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M1132,615.16c-.02,5.74-2.08,9.39-6.19,13.39-2.37,2.3-5.46,4.01-8.19,6.05-2.73,2.03-5.72,4.45-8.21,6.76-10.81,9.98-19.43,18.49-20.18,33.79-.01.26-.47.38-.52.14-1.3-5.61-3.03-9.67-1.07-15.63s6.3-10.68,10.98-15.47s9.91-9.66,15.92-13.5c6.72-4.3,13.91-7.67,17.32-15.51.03-.06.14-.08.14-.02s0,.01,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M976.22,637.33c2.29.93,4.35,2.15,6.57,3.25c2.22,1.11,4.27,1.96,6.56,3.12c4.33,2.19,7.98,4.14,12.67,6.28c9.42,4.31,19.73,8.33,29.86,11.33.13.04.04.18-.09.17-5.35-.58-10.82-1.93-15.84-3.65-5.4-1.85-10.94-3.76-15.99-5.87-4.57-1.91-8.34-3.82-12.5-6.18s-7.84-5.12-11.39-8.3c-.1-.09.06-.2.16-.16s.02,0,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M1026.65,609.41c-.02-12.13.15-22.16,8.37-31.93c4.09-4.87,10.75-6.68,16.58-9.26.07-.03.15-.06.22-.09c1.45-.32,2.9-.66,4.31-1.04s2.79-.8,4.11-1.3c1.92-1.13,4.84-2.7,7.03-3.88-2.86,3.42-4.6,7.18-9.09,9.12-1.33.81-2.71,1.58-4.08,2.36-2.73,1.55-5.42,3.11-7.56,5-5.59,4.05-8.37,8.91-12.25,13.96-4.11,5.35-5.85,10.72-7.34,17.13-.04.16-.3.11-.3-.06Z"
                  fill="#4e531e"
                />
                <path
                  d="M1071.27,605.23c.83-6.75.67-13.42.8-20.13.04-1.87-.32-3.52-.58-5.33s-.77-3.58-1.3-5.33c1.56,2.61,2.77,5.29,3.69,8.21.31.97.48,1.87.76,2.93.27,1.07.63,2.41.79,3.56.08,9.85-1.21,19.33-5.11,28.43.18-3.04.07-6.23.45-9.21.14-1.08.38-2.19.5-3.13Z"
                  fill="#4e531e"
                />
                <path
                  d="M960.26,571.47c9.37,3.13,18.9,4.77,28.17,8.48c5.37,2.15,8.24,7.23,10.99,12.12-1.17-.82-2.38-1.66-3.55-2.51-1.64-1.2-3.4-2.35-4.98-3.62-.71-.57-1.1-1.44-1.83-1.93-1.59-1.07-3.52-1.47-5.25-2.07-8.2-2.86-15.87-6.52-23.61-10.38-.05-.03,0-.1.05-.08Z"
                  fill="#4e531e"
                />
                <path
                  d="M1027.7,559.32c3.01-6.31,5.97-12.47,8.92-18.75-.14.93-.27,1.88-.41,2.82-2.88,9.09-6.05,17.98-10.35,26.56-.24.47-.59.79-.94,1.22-.34.43-.58,1.03-1.05,1.39-1,.78-2.16,1.38-3.11,2.24-.03.03-.07.05-.09.08c1.97-5.31,4.61-10.49,7.03-15.56Z"
                  fill="#4e531e"
                />
                <path
                  d="M1071.23,732.37c-3.22-1.01-6.19-2.15-9.52-2.97s-6.62-1.33-10.03-2.35c-7.35-2.2-14.86-4.81-22.29-6.97-.47-.14-.1-.7.38-.66c8.9.76,18.29.28,27,2.32c6.75,1.58,10.92,4.81,14.69,10.41.09.14-.11.25-.23.21s-.02,0,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1126.76,663.45c-1.21,5.87-3.16,11.06-5.88,16.47-2.71,5.42-6.33,10.79-8.98,16.31-.27.56-1.46.57-1.37-.07.76-5.48,2.26-10.61,4.83-15.48c3.08-5.84,6.84-11.32,9.45-17.31.44-1.02,2.17-1.03,1.95.08.13.03.1.03,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1025.62,655.32c-11.27-.98-21.1-4.91-31.4-9.35-.7-.3-.31-1.13.37-1.06c11.11,1.14,20.58,6.61,31.08,10c.27.09.27.44-.05.41-.02,0,.02.03,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1011.98,624.9c-.88.24-1.75.5-2.66.5s-1.72.05-2.65-.21c-3.69-1.02-6.88-3.16-9.65-5.71-4.93-4.54-9.35-9.28-14.31-13.71-.19-.17.06-.61.26-.51c5.13,2.5,10.1,4.9,15.16,7.63c2.25,1.22,4.53,2.99,6.49,4.69s3.41,3.81,5.31,5.55c.63.58,1.33,1.09,2.04,1.57.06.04.08.18,0,.2-.07.02-.01.01,0,0Z"
                  fill="#746633"
                />
                <path
                  d="M1047.48,573.71c-3.91,6.02-9.43,10.63-13.17,16.76-.24.38-.95.24-.97-.16-.27-3.9.18-5.81,3.14-8.76s6.91-5.95,10.8-7.93c.09-.04.26,0,.21.09-.05.08,0,.03,0,0Z"
                  fill="#8e934b"
                />
                <path
                  d="M997.93,554.82c-.17-2.31-.97-4.52-1.94-6.55-1.14-2.38-2.15-4.94-3.22-7.2s-2.27-3.99-3.45-6.08-2.01-4.29-3.19-6.39c-.11-.2-.44,0-.48.23-.88,4.53.06,9.01,2.26,12.82c1.54,2.67,3.39,3.58,5.11,5.88s2.97,5.08,4.68,7.44c.09.12.24,0,.23-.14c0-.14,0-.02,0,0Z"
                  fill="#bdbb7d"
                />
                <path
                  d="M1066.74,589.63c-2.36,12.13-1.53,24.46-4.97,36.4-.09.31-.6.16-.57-.12c1.2-12.36,1.48-24.42,5.38-36.3.02-.08.18-.06.16.02s0,.02,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M968.08,570.22c9-1.42,15.71.97,22.88,6.38.55.42-.16.79-.68.66-7.36-1.86-14.99-3.26-22.15-5.84-.67-.24-.81-1.07-.05-1.19.07,0-.1-.08,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1095.38,610.24c-2.04,3.99-4.32,8.15-5.64,12.37-1.22,3.88-1.99,7.61-3.18,11.38-2.37,7.55-4.39,15.09-7.38,22.41-.13.31-.77.55-.82.11-2.44-18.93,5.8-31.68,16.9-46.28.05-.06.15-.04.12.02s0,0,0,0Z"
                  fill="#ffead7"
                />
              </g>
              <path
                d="M1014.97,571.21c.09-.44-.03-.88.03-1.33.06-.43.24-.88.46-1.25.49-.82,1.16-1.61,2.15-1.66.55-.03,1.02.55.99,1.06-.04.85-.7,1.38-1.23,1.98-.23.26-.49.5-.77.71-.34.25-.8.4-1.07.73-.22.28-.63.11-.56-.25v0Z"
                fill="#b9a672"
              />
              <path
                d="M1012.84,564.77c-.02-.15-.11-.3-.16-.45-.1-.28-.13-.52-.1-.82.06-.52.18-1.06.61-1.41.41-.34,1.17-.35,1.41.22.23.55.18,1.05-.03,1.59-.11.3-.24.51-.47.73-.08.08-.08.09-.15.15-.03.03-.24.22-.17.13-.25.33-.88.34-.96-.16v0Z"
                fill="#b9a672"
              />
              <path
                d="M1019.63,557.19c-.36-.89-.07-1.92.59-2.6.47-.49,1.3-.07,1.29.58-.02.88-.54,1.83-1.36,2.17-.17.07-.43.05-.51-.15v0Z"
                fill="#b9a672"
              />
              <path
                d="M1027.75,547.3c-.12-.42.06-.91.25-1.29.21-.41.37-.84.69-1.19.17-.19.49-.25.72-.17.06.02.12.05.17.08.23.12.37.41.35.66-.03.51-.29.96-.54,1.4-.22.38-.61.82-1.08.88-.27.04-.5-.09-.58-.36v0Z"
                fill="#b9a672"
              />
              <path
                d="M1021.35,549.56c-.06-.7.05-1.39.53-1.93.56-.62,1.54.08,1.33.81-.13.46-.42.86-.55,1.33-.08.32-.43.52-.75.46-.35-.06-.53-.34-.56-.68v0Z"
                fill="#b9a672"
              />
              <path
                d="M1031.99,539.38c-.32-.61.06-1.63.27-2.23.23-.68.52-2.1,1.57-1.67.93.38.42,1.62.18,2.29-.23.63-.75,1.73-1.49,1.86-.2.04-.42-.05-.52-.24v0Z"
                fill="#b9a672"
              />
              <path
                d="M1011.07,568.64c.22.41.36.94.48,1.39.15.53.34,1.15.26,1.7-.06.42-.29.78-.72.88-.39.09-.85-.1-1.03-.47-.31-.65-.27-1.4-.08-2.08.14-.5.43-1.13.82-1.47.09-.08.22-.06.27.04v0Z"
                fill="#b9a672"
              />
              <path
                d="M1018.27,574.83c-.33.42-.63.87-.97,1.28-.33.39-.63.81-1.15.94-.29.07-.56-.17-.56-.46.02-1,1.18-1.81,1.87-2.4.42-.36,1.2.16.81.65v0Z"
                fill="#b9a672"
              />
              <path
                d="M1010.75,564.98c.04.46.29.76.48,1.16.25.52.2,1.02.12,1.57-.09.58-.49,1.07-1.13,1.05-.56-.02-1.1-.54-1.05-1.13.05-.57.1-1.14.45-1.61.29-.38.64-.63.8-1.11.06-.19.31-.13.32.05v0Z"
                fill="#b9a672"
              />
              <path
                d="M1014.3,572.2c.16,1.15-.03,2.11-.28,3.23-.24,1.07-.27,2.22-1.37,2.77-.24.12-.52.08-.71-.11-.9-.91-.5-2.1-.18-3.18.35-1.17.75-2.14,1.69-2.96.27-.23.79-.15.84.25v0Z"
                fill="#b9a672"
              />
              <path
                d="M1010.54,576c.11.23.27.41.36.65.09.21.14.44.19.66.11.48.22.94.2,1.44-.03.66-1.03.96-1.32.31-.2-.46-.28-.92-.35-1.41-.03-.22-.07-.45-.07-.67c0-.27.07-.49.09-.76.04-.45.67-.65.89-.21v0Z"
                fill="#b9a672"
              />
              <path
                d="M1107.94,695.25c.31.59.29,1.33.34,1.98.07.83.15,1.66-.01,2.47-.21,1.05-1.68.81-1.93-.06-.24-.86-.06-1.87.26-2.69.26-.64.61-1.41,1.27-1.72.02-.01.05,0,.07.02v0Z"
                fill="#ffead7"
              />
              <path
                d="M1108.21,704.45c-.1.44-.54.87-.77,1.27s-.5.96-.91,1.19c-.23.13-.6,0-.63-.29-.07-.54.3-1.11.65-1.51.32-.36.82-.94,1.31-1.03.22-.04.39.15.34.37v0Z"
                fill="#ffead7"
              />
              <path
                d="M1104.07,711.06c.25.77.04,1.82-.75,2.22-.55.28-1.07-.04-1.26-.57-.15-.41.01-.93.22-1.3s.47-.58.84-.78c.4-.21.81.03.94.43v0Z"
                fill="#ffead7"
              />
              <path
                d="M1102.04,719.24c.11.6-.14,1.18-.51,1.62-.3.36-1.02.14-1.07-.32-.06-.58.04-1.2.47-1.64.35-.36,1.02-.16,1.12.34v0Z"
                fill="#ffead7"
              />
              <path
                d="M1028.27,651.54c-.92.59-2.02.12-2.96-.23-.76-.29-2.32-.87-1.82-2c.47-1.07,1.88-.41,2.59-.06.92.46,2.09.98,2.28,2.09.02.09-.02.16-.09.2v0Z"
                fill="#ffead7"
              />
              <path
                d="M1018.04,646.79c-.13.21-.16.37-.44.44-.19.05-.38.02-.55-.07-.37-.18-.62-.6-.37-.98.13-.2.45-.27.61-.07.06.07.11.19.18.24.09.06.25.07.36.11-.09.02-.18.04-.27.06l.07-.06c.22-.19.57.07.4.33v0Z"
                fill="#ffead7"
              />
              <path
                d="M1011.64,645.67c-.37.03-.71-.07-1.05-.22-.33-.14-.51-.39-.71-.68-.18-.27.05-.57.3-.66.7-.25,1.41-.05,1.96.44.48.43,0,1.07-.5,1.12v0Z"
                fill="#ffead7"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv844" transform="translate(0-182.266475)">
            <g>
              <g>
                <g>
                  <path
                    d="M1367.24,785.01v0c-.1-1.58-.19-3.14-.32-4.71-.19-2.6-.42-5.2-.69-7.8-.02-.14-.02-.28-.04-.42-.55-5.2-1.11-10.38-1.55-15.55-.34-3.84-.6-7.68-.76-11.52c1.4-6.14,2.92-12.27,4.4-18.37.38-1.55.75-3,1.13-4.54.02-.07.04-.12.05-.17.11-.48.24-.95.36-1.42.39-1.54.79-3.1,1.19-4.64.16-.61.31-1.21.46-1.82.72-3.04,1.43-6.09,2.2-9.12.15-.6.31-1.19.46-1.79.14-.53.27-1.05.43-1.57.06-.27.14-.54.22-.8.65-2.37,1.32-4.73,2-7.09v0l.24-.87c1.01-3.39,2.07-6.79,3.1-10.17.95-3.12,1.91-6.23,2.87-9.33c3.31-7.86,6.51-15.76,9.19-23.8v0c.17-.5.33-.98.48-1.47.17-.48.32-.96.47-1.45.38-1.2.74-2.4,1.1-3.61.14-.49.3-.98.44-1.47.35-1.22.71-2.43,1.04-3.65.42-1.48.82-2.98,1.22-4.48.38-1.43.74-2.86,1.1-4.3.92-3.76,1.79-7.52,2.57-11.32.57-2.66,1.1-5.33,1.6-8c2-4.73,4.06-9.37,6.15-14.21c0-.02.01-.04.03-.06.03-.08.05-.14.09-.21v-.02c1.78-4.12,4.04-9.04,5.54-13.27c2.42-6.86,4.73-14.05,7.22-21.2c3.11-4.41,6.03-8.93,8.72-13.58v-.02c.43-.75.88-1.48,1.29-2.23.83-1.49,1.64-2.97,2.43-4.48.58-1.12,1.16-2.23,1.71-3.36.59-1.18,1.17-2.37,1.76-3.55c1.75-3.57,3.43-7.16,5.18-10.73.33-.67.66-1.34.99-2.01c1.27-2.54,2.56-5.06,3.91-7.54v0c.07-.15.16-.29.23-.43c4.41-5.29,8.87-10.18,13.45-15.01.05-.06.11-.12.17-.18c1.48-1.57,3-3.14,4.52-4.71.16.2.32.4.47.6c7.12,9.1,12.8,18.62,16.99,29.05.79,1.96,1.57,3.92,2.35,5.87.84,5.26,1.83,10.51,3.11,15.72.19.74.39,1.47.6,2.21.6,6.33,2.69,11.94,5.57,17.2c2.79,7.3,6.03,14.48,9.5,21.63c4.2,8.65,8.79,17.58,11.7,26.8.28.9.55,1.79.8,2.68.12.43.23.85.34,1.28.14.52.26,1.03.39,1.55.17.76.33,1.53.48,2.3.09.45.17.91.25,1.36.06.4.13.81.18,1.21.07.43.12.87.17,1.3.06.44.11.86.15,1.3.1.99.21,1.99.3,2.98-2.86,17.6-6.79,35.32-6.35,53.13.01.6.04,1.22.07,1.83.03.43.04.89.07,1.32c0,.06,0,.1,0,.15.04.86.11,1.73.18,2.59.03.47.07.95.12,1.42.05.6.1,1.21.17,1.81.8,7.74,2.32,15.42,4.19,23.03.25,1.03.51,2.07.79,3.1c1.46,5.67,3.09,11.31,4.74,16.9.59,3.65,1.33,7.34,2.03,11.23c0,.01,0,.02,0,.04.22,1.23.42,2.45.68,3.67.04.18.06.36.09.54.86,4.62,1.71,9.21,2.24,13.84.02.19.05.39.07.59.09.89.17,1.79.24,2.68c0,.02,0,.06,0,.08.3,4.16.51,7.84.67,11.55.17,3.75.26,7.53.33,11.89.1,5.38.35,10.66.58,15.85-.26,4.79-.64,9.57-1.13,14.35h-160.47c-.2-10.51-.31-20.94-.85-31.39-.05-1.06-.11-2.11-.17-3.17Z"
                    fill="#707758"
                  />
                  <path
                    d="M1446.78,681.81c2-3.53,4.2-5.7,7.41-8.64c19.7-18.09,39.55-36.13,57.39-56.14c1.23-1.38,2.7-3.23,4.31-5c1.35,4.26,2.33,8.58,2.76,12.97.1,1,.19,1.99.29,2.98-2.86,17.61-6.8,35.32-6.35,53.12.08,3.05.29,6.09.61,9.12-25.72,19.9-60.67,36.76-62.62,70.18c0,.05,0,.12,0,.24c0,.6-.62,2.9-.93,3.91-.13.41-.21,1.19-.3,1.66-.1.47-.16,1.01-.25,1.46.04-.54-.23-1.5-.17-2.04.26-2.51.2-7.53-.57-9.07-.6-1.19-.14-.27-.15-.28-11.85-20.53-3.46-41.71-2.71-63.5.13-3.67-.3-7.11,1.14-10.65.05-.12.08-.21.15-.33Z"
                    fill="#424327"
                  />
                  <path
                    d="M1375.15,701.6c.6-2.64,1.17-5.29,1.64-7.95.05-.29.18-.57.24-.86.08,3.12-.69,5.9-1.88,8.82Z"
                    fill="#a6a392"
                  />
                  <path
                    d="M1444.55,775.15c.08-.36.22-.77.32-1.1s.18-.58.28-.87.18-.55.3-.83c.96-2.33,2.11-4.55,3.48-6.7.14-.21.26-.42.39-.61.12-.19.23-.33.34-.5.51-.74,1.03-1.49,1.59-2.2c2.73-3.52,5.83-6.99,8.92-10.19c6.75-6.97,13.7-13.18,21.74-18.98c7.47-5.39,16.75-8.11,25.16-12.04c4.02-1.88,7.23-4.86,10.34-7.89.25,1.04.51,2.07.78,3.1-1.64,1.7-3.45,3.47-4.99,4.68-6.9,5.41-15.31,10.32-22.97,15.97s-15.33,12.36-22.26,19.34c-5.05,5.09-10.44,11.11-16.24,15.87-.69.57-1.47,1.2-2.31,1.82-.84.63-2.02,1.48-3,2.09-.31.2-.71.22-1.07.14s-.67-.42-.77-.63-.05-.3-.05-.4.02-.06.02-.09Z"
                    fill="#a6a392"
                  />
                  <path
                    d="M1445,816.54c.13-.34.17-.41.26-.62.34-.81.74-1.49,1.13-2.26.88-1.69,1.85-3.34,2.87-4.97.2-.31.4-.62.6-.93c1.85-2.8,3.87-5.45,5.98-8.11c3.55-4.47,6.43-9.21,10.57-13.34c4.14-4.12,9.13-7.81,13.91-11.3c10.05-7.33,22.01-12.88,31.42-20.59c4.62-3.79,8.33-6.78,13.28-9.96c1.12,7.15,2.61,14.21,3.33,21.39-7.84,6.85-14.95,12.56-24.65,17.72-10.24,5.44-22.41,10.16-32.96,15.61-2.31,1.19-4.67,2.65-6.59,4.24-3.1,2.57-5.85,5.17-7.72,8.54-1.36,2.45-2.05,5.11-3.1,7.6h-9.08c.06-.53.11-1.07.26-1.6.13-.48.35-1.09.49-1.43Z"
                    fill="#a6a392"
                  />
                  <path
                    d="M1411.54,664.85c-1.67-2.66-2.86-5.14-4.38-7.82-5.44-7.41-6.04-15.83-10.23-23.67c2.08-7.91,3.84-15.89,5.33-23.91c1.86-4.78,3.7-9.56,6.21-14.14.02-.03,0-.05.02-.03.72.39.15,1.5.25,2.13c1.85,11.53,2.17,24.52,7.04,35.19s11.47,19.28,17.07,29.37c2.63,4.74,4.75,9.54,7.05,14.42.6,1.28,1.18,2.63,1.53,3.98.92,3.47,1.2,6.94.87,10.44-.05.56-.41.91-.7,1.13s-.26.2-.48.25c-1.11.29-2.03.19-3.06-.39-5.38-3.01-10.77-6.97-14.45-11.42-4.39-5.3-8.59-9.98-12.07-15.53Z"
                    fill="#a6a392"
                  />
                  <path
                    d="M1439.68,817.73c-.12-1.13-.27-2.25-.42-3.41-.03-.2.07-.35-.05-.6v0c0,0-.06-.09-.1-.15-.05-.06-.1-.12-.16-.2-.62-.81-1.7-2.94-1.83-4.86-.06-.62-.01-1.22.19-1.74.01-.04.01-.11.03-.24.06-.46-.31-1.48-.67-2.38-.17-.4-.32-.79-.43-1.09-.37-.96-.59-1.96-.78-2.99-.42-2.34-.65-4.7-.93-7.12-.14-1.17-.66-2.26-.24-3.6l.05-.2c.26-1.1-.19-3.98-.55-5.71-.28-1.3-.31-3.03-.59-4.49-.53-2.8-1.24-5.7-2.36-8.41-.04-.1-.06-.18-.13-.34-.07-.15-.39-.78-.42-.88-.04-.1-.04-.06-.05-.08-.61-1.43-3.34-4.57-3.83-5.37-.09-.17-.16-.27-.2-.33-.03-.05-.06-.09-.06-.09-.78-1.35-2.74-2.82-3.55-3.39-.03-.02-.05-.04-.08-.05-.01,0-.02,0-.03-.02l-.07-.05h-.01c0,0,0-.02-.02-.02-.02-.03-.04-.03-.05-.04h-.01c0,0,0-.02,0-.02c0-.01-.02-.02-.02-.02-.65-.48-1.56-1.33-2.35-2.01-1.5-1.27-3.07-2.55-4.7-3.86-1.62-1.31-3.45-2.8-5.06-4.2-.56-.49-1.1-.97-1.64-1.47-1.02-.96-1.97-1.97-2.95-2.99-.49-.51-.97-1.04-1.47-1.55-1.11-1.11-2.05-2.29-3.17-3.41-2.74-2.75-5.48-5.47-8.13-8.32-1.61-1.73-3.27-3.53-4.8-5.32-1.04-1.22-2.13-2.49-3.05-3.73-.46-.64-.97-1.51-1.4-1.95-.03-.03-.05-.06-.07-.07v0c0,0-.04-.04-.04-.04v0c0,0-.02-.04-.04-.05-.53-.56-1.43-2-2.04-2.96-1.17-1.88-2.55-3.96-3.6-5.96-1.29-2.47-2.34-5.02-3.21-7.61-.09-.27-.2-.57-.24-.78-.06-.21-.17-.31-.14-.46.14-.53.27-1.05.41-1.58.06-.27.14-.54.22-.8.63-2.37,1.32-4.72,2-7.09v0l.24-.87c1.01-3.39,2.07-6.79,3.1-10.17c11.52,15.59,24.91,29.75,37.95,44.3c3.95,4.42,8.46,8.46,12.81,12.46c4.37,4,8.66,7.81,12.84,11.89.57.56,1.15,1.1,1.66,1.64c1.01,1.06,1.94,2.13,2.75,3.25v0v.03v0v.02c0,0,.02,0,.02,0c0,.01.02.03.03.05v0c.22.28.4.56.56.82c0,0,.01,0,0,.01.12.17.21.32.3.47.59.95,1.09,1.88,1.5,2.87v0c0,0,0,.02,0,.02.25.65.47,1.22.64,1.87v0c.84,3.35.81,6.44.5,9.87v.02c-.2,2.07-.47,4.26-.58,6.41-.48,9.51,0,19.04-1.2,28.53-.02.19-.06.38-.1.58v.02v0c-.27,1.82-.48,3.63-.68,5.44v.04c-.1.92-.19,1.85-.28,2.77c0,.18-.03.36-.05.56-.07.99-.06,1.98-.08,2.98h-8.95c-.05-.62-.08-1.23-.14-1.85Z"
                    fill="#a6a392"
                  />
                  <path
                    d="M1444.56,817.78v0c0-7.97.03-15.91.11-23.94.06-5.89,0-12.04-.14-18.27c0-.14,0-.28,0-.41-.17-7.9-.46-15.96-.8-23.89-.09-2.3-.19-4.59-.3-6.86-.35-7.96-.72-15.7-1.02-22.95-.08-1.69-.14-3.35-.21-4.98-.06-1.71-.12-3.37-.18-5.01-.19-5.48-.36-11.46-.5-17.84-.01-.55-.02-1.09-.03-1.63-.08-3.89-.14-7.92-.19-12.05-.46-49.91,2.61-115.7,23.91-148.26.03,0,.05.18.01.22-18.05,28.83-17.72,71.64-18.38,104.88-.3,14.99-.24,29.95,0,44.9.42,25.09,1.35,50.18,1.92,75.41c0,0,.01,0,0,.01.02.37.02.75.03,1.14c0,.01,0,.02,0,.05.04,2.34.1,4.69.14,7.04c0,.08.01.16,0,.25c0,.29.02.58.02.88.05,2.6.08,5.19.13,7.79.15,10.28.21,20.58.13,30.92-.01,1.21-.02,2.4-.03,3.6-.02,1.5-.03,2.98-.04,4.45v.04c-.03,2.13-.06,4.2-.08,6.3h-4.53c0-.6,0-1.19,0-1.79Z"
                    fill="#96301b"
                  />
                  <path
                    d="M1422.01,564.03c-2.22,20.59-8.91,39.09-.74,59.09.84,2.06,3.5.66,3.5-.94.01-10.07-1.21-19.56-1.55-29.82-.3-9.08.08-19.03-1.02-28.25-.01-.12-.19-.22-.2-.08s0,0,0,0Z"
                    fill="#96301b"
                  />
                  <path
                    d="M1397.83,658.96c-1.67-2.24-4.02-6.12-5.65-9.49.32-.96.65-1.93.96-2.9c1.82-5.8,3.44-11.64,4.89-17.51c5.62,9.65,6.83,22.05,13.55,30.75c6.25,8.09,14.36,13.43,21.1,20.29c3.81,3.88,6.69,7.63,8.32,12c3.19,8.58,2.38,15.91,1.28,24.55-5.46-12.56-11.45-21.92-22.3-31.85-8.13-7.44-15.24-16.54-22.15-25.84Z"
                    fill="#563217"
                  />
                </g>
                <path
                  d="M1444.46,676.96c-1.8,10.59.26,21.22,1.4,31.78c1.12,10.28,1.86,20.32,1.18,30.65-.67,10.25-.67,19.74,1.01,29.92.78,4.74.65,9.49.59,14.27-.06,4.58.45,9.63-1.73,13.86-.18.36-.87.42-1.08.05-2.42-4.14-2.23-9.04-2.55-13.62-.38-5.35-.66-10.66-1.65-15.95-1.89-10.17-1.18-20.02-.56-30.27c1.24-20.57-5.22-40.84,2.22-60.92.24-.64,1.29-.47,1.17.22v0Z"
                  fill="#96301b"
                />
                <path
                  d="M1445.62,778.73c3.15-10.64,1.75-21.89,5.83-32.48c3.22-8.36,9.8-18.12,17.36-23.97.26-.2.72.01.54.33-2.5,4.29-5.43,8.13-7.56,12.62-2.49,5.23-4.26,10.55-5.85,16.05-2.8,9.67-4.21,18.74-8.75,27.95-.38.76-1.8.32-1.56-.49v0Z"
                  fill="#96301b"
                />
                <path
                  d="M1441.52,720.19c-2.21-8.27-5.55-15.83-10.66-23.04-4.67-6.59-10.85-12.32-16.16-18.51-.13-.15.14-.36.29-.22c12.74,11.42,27.58,24.51,26.79,41.73c0,.12-.22.19-.26.05v0Z"
                  fill="#96301b"
                />
                <path
                  d="M1445.21,685.24c-1.26-15.48,8.25-29.44,19.14-40.86c12.91-13.54,27.72-25,37.65-40.64.11-.18.41-.04.32.15-13.97,30.05-56.64,45.32-56.19,81.3c0,.53-.88.58-.93.05v0Z"
                  fill="#96301b"
                />
              </g>
              <path
                d="M1435.21,735.34c-3.94-7.34-9.35-14.33-15.19-20.58-4.46-4.78-11.92-10.74-12.37-17.19-.14-1.93,2.11-4.06,4.43-3.39c7.54,2.18,11.97,10.4,15.11,16.44c4.17,8.03,6.6,15.94,8.98,24.43.16.57-.69.8-.96.29v0Z"
                fill="#424327"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv863" transform="translate(.000048-178.216104)">
            <g>
              <path
                d="M765.84,690.97c5.65-10.72,11.57-21.34,17.73-31.9c5.22-9.01,10.65-17.97,16.24-26.89c9.09-14.55,18.6-28.96,28.44-43.26v-.03l1.96-2.79c5.19-7.52,10.48-15,15.84-22.46c16.4-22.75,33.5-45.23,51.03-67.54c19.42-24.77,39.37-49.33,59.39-73.81c3.28-3.54,6.63-7.05,9.98-10.55c14.96-15.58,29.6-31.17,40.97-48.41c3.18-4.8,6.35-9.6,9.66-14.35c1.23,12.09,3.88,24.09,4.81,36.21-.41,20.54-3.79,41.21-6.36,61.61-2.73,21.55-9.78,42.72-11.37,64.36-.34,4.63-.47,9.26-.46,13.91-.02,6.57.17,13.14.25,19.71.03,1.64.04,3.28.03,4.93c0,.14,0,.29,0,.41.01,1.8-.01,3.59-.04,5.38-.05,1.92-.1,3.83-.21,5.74c0,.33-.03.66-.06.98c0,.46-.04.92-.08,1.38-.01.3-.04.61-.06.91-.06.77-.12,1.52-.18,2.29-1.83,7.21-3.35,14.41-4.7,21.6-2.86,15.15-4.98,30.24-7.51,45.25-.68,4.05-1.4,8.08-2.15,12.11-.06.34-.14.68-.2,1.02-.71,3.7-1.47,7.4-2.28,11.08-.15.7-.31,1.38-.45,2.06-.81,3.44-1.65,6.87-2.56,10.3-.16.68-.32,1.35-.48,2.03-.39,1.73-.8,3.45-1.23,5.19-.1.53-.23,1.05-.37,1.59c0,.07-.02.13-.04.21-.4,1.69-.81,3.37-1.22,5.06-2.45,10.32-5.06,20.63-7.97,30.85-.82,1.98-1.6,3.98-2.53,5.93-2.1,4.52-4.77,8.83-7.4,13.2-5.69,9.46-10.84,19.09-15.95,28.71-10.05,18.92-20.04,37.85-33.02,55.78h-163.45c-.49-.87-1.02-1.73-1.47-2.6-20.94-40.07-3.62-85.18,17.5-125.21Z"
                fill="#cab48b"
              />
              <path
                d="M868.64,694.83c.44-.78.9-1.57,1.34-2.35c2.05-3.59,4.11-7.19,6.14-10.77h.02c13.21-23.15,26.42-46.29,39.63-69.43c2.22-3.9,4.46-7.87,4.97-12.08.02-.15.04-.29.03-.43.38-4.2-.92-8.39-2.17-12.51-7.71-25.27-13.14-50.82-16.8-76.57-.52-3.55-1.61-10.61-4.73-14.58-17.52,22.3-34.63,44.79-51.03,67.54c1.05,3.06,2.31,6.07,3.57,8.99c15.76,36.57,29.56,75.42,21.45,113.04v.02c-.39,1.73-.81,3.47-1.28,5.2-.19.7-.38,1.4-.6,2.09-.18.61-.36,1.23-.55,1.84Z"
                fill="#f2ddc4"
              />
              <g>
                <path
                  d="M950.59,741.12c-.17.04-.33.09-.51.12-2.55.39-5.04-.83-5.56-2.73-.52-1.89,1.12-3.74,3.68-4.13c2.02-.31,3.98.4,4.98,1.64-.86,1.7-1.72,3.4-2.58,5.1Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M936.46,689.74c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M874.72,690.63c2.01.14,3.74,1.22,4.17,2.77.52,1.89-1.12,3.75-3.68,4.13-1.16.18-2.29,0-3.25-.4.92-2.17,1.84-4.33,2.75-6.5Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M885.44,689.93c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M873.18,749.86c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M940.19,720.27c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M921.29,717.66c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M949.8,726.85c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M864.35,715.96c.67-.69,1.66-1.21,2.87-1.39c2.55-.39,5.04.83,5.56,2.73.52,1.89-1.12,3.74-3.68,4.13-2.55.39-5.04-.83-5.56-2.73-.05-.17-.06-.34-.07-.51.29-.74.59-1.49.87-2.23Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M876.35,698.96c-2.55.39-4.2,2.24-3.68,4.13.52,1.9,3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13c-.52-1.9-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M960.58,705.17c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M877.31,743.88c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13c-.52-1.9-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M915.34,684.09c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M921.51,674.48c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M909.78,728.06c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M868.3,722.76c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M981.39,679.04c-1.49-.4-2.67-1.34-3.01-2.57-.52-1.89,1.12-3.74,3.68-4.13.31-.05.62-.06.93-.06-.53,2.26-1.06,4.51-1.6,6.77Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M869.11,703.9c.48-.23,1.01-.4,1.59-.49c2.55-.39,5.04.83,5.56,2.73s-1.12,3.75-3.68,4.13c-2.28.35-4.51-.6-5.33-2.16.61-1.4,1.24-2.81,1.84-4.21Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M976,693.75c-.2.05-.4.11-.62.14-2.55.39-5.04-.83-5.56-2.73-.52-1.89,1.12-3.75,3.68-4.13c2.07-.31,4.08.44,5.05,1.75-.84,1.66-1.67,3.32-2.54,4.97Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M890.93,707.42c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M883.56,698.37c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M938.38,743.76c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M921.41,738.18c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M855.79,736.9c.35-.12.71-.23,1.1-.29c2.55-.39,5.04.83,5.56,2.73.52,1.89-1.12,3.74-3.68,4.13-2.05.31-4.05-.43-5.03-1.72.68-1.62,1.36-3.24,2.04-4.86Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M935.93,670.68c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M885.33,746.84c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M862.94,719.56c.54.43.94.97,1.11,1.59.5,1.82-1,3.58-3.38,4.06.77-1.88,1.53-3.77,2.27-5.65Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M871.99,697.1c.46.42.81.91.96,1.47.49,1.8-.97,3.54-3.3,4.04.79-1.84,1.56-3.68,2.34-5.52Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M914.72,711.72c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13c-.52-1.9-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M912,748.78c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M930.34,701.01c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M896.65,740.62c-2.55.39-4.2,2.24-3.68,4.13.52,1.9,3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M896.78,681.34c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M969.29,706.12c-2.3.1-4.42-1.05-4.89-2.78-.52-1.89,1.12-3.74,3.68-4.13c1.68-.26,3.33.2,4.41,1.08-1.06,1.95-2.12,3.89-3.2,5.84Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M848.8,753.94c.17-.43.33-.86.5-1.3.5-1.27,1.02-2.53,1.53-3.79c2.39-.19,4.63.98,5.12,2.76.52,1.89-1.12,3.74-3.68,4.13-1.36.21-2.69-.06-3.72-.63.08-.39.16-.78.24-1.17Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M882.19,735.21c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M885.21,682.67c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M907.2,739.05c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M933.38,737.89c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M950.54,710.26c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M980.13,684.31c-1.82-.26-3.35-1.29-3.74-2.72-.52-1.89,1.12-3.75,3.68-4.13.58-.09,1.15-.08,1.71-.01-.54,2.29-1.09,4.57-1.64,6.86Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M862.16,732c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M865.71,740.78c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M874.76,729.37c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M958.53,725.71c-2.42.23-4.71-.95-5.2-2.76-.52-1.89,1.12-3.74,3.68-4.13c1.78-.27,3.51.25,4.58,1.23-1.04,1.88-2.05,3.77-3.05,5.66Z"
                  fill="#e2c8a6"
                />
                <path
                  d="M908.68,679.97c-2.55.39-4.2,2.24-3.68,4.13s3.01,3.12,5.56,2.73s4.2-2.24,3.68-4.13c-.52-1.9-3.01-3.12-5.56-2.73Z"
                  fill="#e2c8a6"
                />
              </g>
              <path
                d="M986.2,655.82c.8-3.05,1.58-6.09,2.56-9.02.06-.34.14-.68.2-1.02-2.04,3.21-2.55,6.62-2.76,10.04Z"
              />
              <path
                d="M924.5,787.17c.43-.81.85-1.6,1.24-2.4q0,0,.03-.03c.19-.36.37-.7.54-1.05v0c2.61-5.09,5.15-10.13,7.63-15.18v0c.11-.24.24-.48.35-.71.66-1.43,1.32-2.84,1.97-4.26v0c.48-1.06.96-2.1,1.43-3.15.61-1.34,1.21-2.67,1.8-4.01.22-.48.42-.94.63-1.41.76-1.7,1.51-3.4,2.24-5.09v-.02c.52-1.16,1.03-2.31,1.56-3.47.61-1.36,1.21-2.73,1.82-4.09.23-.55.47-1.09.7-1.64.92-2.13,1.81-4.25,2.72-6.36.09-.23.19-.44.28-.66.58-1.38,1.15-2.75,1.73-4.12.36-.86.72-1.71,1.09-2.55.45-1.1.92-2.18,1.41-3.27.65-1.5,1.31-3.01,1.99-4.51c0,0,0-.01.01-.02.3-.79.66-1.57,1.03-2.36c1.15-1.63,2.26-3.26,3.33-4.91c1.39-2.08,2.72-4.19,3.99-6.3.28-.46.56-.9.82-1.35v0c.99-1.67,1.94-3.31,2.84-4.96c1.2-2.13,2.33-4.26,3.42-6.4c1.02-1.97,1.99-3.95,2.91-5.92.84-1.77,1.66-3.55,2.42-5.33v0c.5-1.12,1-2.25,1.46-3.37v0c.21-.5.42-1.01.63-1.51v0c.51-1.25,1.02-2.47,1.49-3.7c2.56-4.41,4.08-9.23,5.39-14.13.29-1.03.57-2.07.84-3.11-.05.81-.08,1.61-.12,2.43-.02.56-.04,1.11-.06,1.67-.17,3.57-.53,7.09-2.56,10.3-.16.68-.32,1.35-.48,2.03-.39,1.73-.8,3.45-1.23,5.19-.1.53-.23,1.05-.37,1.59c0,.07-.02.13-.04.21-.4,1.69-.81,3.37-1.22,5.06-2.45,10.32-5.06,20.63-7.97,30.85-.82,1.98-1.6,3.98-2.53,5.93-2.1,4.52-4.77,8.83-7.4,13.2-5.69,9.46-10.84,19.09-15.95,28.71-10.05,18.92-20.04,37.85-33.02,55.78h-6.82c6.54-10.31,12.44-20.84,17.95-31.42.04-.06.08-.14.1-.2Z"
                fill="#e2c8a6"
              />
              <path
                d="M828.24,588.9v.03c1.2,5.44,2.93,10.82,4.81,16.31c3.87,11.26,6.1,22.81,9.96,34.02c3.95,11.47,7.88,22.89,11.39,34.44c2.55,8.42,4.65,17.25,8.84,25.39.5.97,1.01,1.93,1.58,2.88.69,1.18,1.44,2.36,2.25,3.49.25.36.68.53,1.13.53.47.01.94-.16,1.21-.48.12-.12.21-.28.25-.44.01-.03,0-.06.01-.09.09-.46.17-.93.22-1.38.07-.37.11-.72.15-1.08.06-.35.08-.7.12-1.05.26-2.98.18-5.99-.17-9-.02-.3-.06-.58-.09-.87-.03-.24-.07-.48-.1-.71-.14-1.08-.32-2.15-.52-3.22-.96-5.29-2.48-10.53-3.94-15.63-3.16-11.13-6.87-22.16-10.85-33.14-3.69-10.19-10.12-19.92-14.94-29.89-3.64-7.5-7.01-15.12-9.33-22.9l-1.97,2.79Z"
                fill="#8e934b"
              />
              <path
                d="M783.57,659.07c3.67,11.85,8.07,23.5,15.66,34.37c8.03,11.46,18.73,21.75,28.07,32.61c2.04,2.38,3.79,4.87,5.23,7.44c2.35,4.15,3.93,8.53,4.67,13.05.96,5.8-1.85,13.09,2.46,18.16.12.14.25.28.42.39.23.21.53.39.84.52v0c1.2.59,2.76.68,3.91-.19.75-.57,1.36-1.15,1.86-1.77q0,0,.01-.02c.22-.25.4-.5.56-.76c1.19-1.77,1.57-3.68,1.59-5.69.01-.65-.01-1.3-.06-1.96-.03-.27-.05-.54-.09-.8-.09-1.02-.22-2.05-.34-3.11-.24-2.34-.65-4.66-1.13-6.99-.08-.44-.19-.89-.29-1.33-.88-3.97-1.97-7.94-2.96-11.89-1.66-6.67-2.39-13.49-4.68-20.06-2.3-6.6-5.87-12.86-9-19.25-6.56-13.42-16.62-25.83-22.18-39.52-2.74-6.73-5.19-13.41-8.32-20.07-5.59,8.91-11.02,17.87-16.24,26.89Z"
              />
              <path
                d="M920.26,613.26c.08.16.18.32.32.45.66.73,1.88,1.16,3.27,1.03c7.23-.67,15.34-2.59,21.23-5.74c7.01-3.77,14.62-7.02,20.87-11.46c3-2.13,5.96-4.31,8.85-6.53c11.55-5.31,14.45-15.76,24.12-21.33c1.62-1.68,3.12-3.41,4.59-5.14.01-.3.04-.61.06-.91.03-.46.07-.93.1-1.39c0-.33.03-.65.04-.98.11-1.9.16-3.81.21-5.74.03-1.79.05-3.58.04-5.38c0-.13,0-.27,0-.41c0-1.65,0-3.29-.03-4.93-.07-6.57-.27-13.14-.25-19.71v-.04c-.45.57-.9,1.12-1.34,1.69-7.96,10.54-15.58,21.02-25.03,30.92-9.35,9.81-20.54,17.99-31.84,26.51-5.3,4.02-9.72,8.67-14.89,12.83-1.36,1.09-2.62,2.31-3.76,3.63-2.98,3.38-5.28,7.34-6.67,11.03-.22.59-.17,1.14.09,1.6Z"
                fill="#8e934b"
              />
              <path
                d="M838.66,779.07c.08-1.26.19-2.52.38-3.79.24-2.05.62-4.1,1.06-6.15.25-1.18.53-2.35.81-3.51v0c.04-.15.08-.28.11-.4.4-1.55.81-3.08,1.25-4.62.57-2.06,1.17-4.12,1.76-6.19.07-.24.13-.49.2-.73c1.02-3.57,2-7.15,2.72-10.69.06-.25.11-.5.16-.75c2.41-12.17,8.93-23.57,13.34-35.38.99-2.68,1.86-5.27,2.79-7.76c1.51-4.15,3.21-7.99,6.04-11.42.55-.67,1.14-1.33,1.79-1.97.97-.96,2.04-1.88,3.26-2.77.56-.41,1.16-.82,1.8-1.22c1.44-.91,3.06-1.77,4.86-2.57.91-.41,1.82-.81,2.73-1.19c6.68-2.86,13.69-5.38,20.7-7.89c7.01-2.52,14.04-5.03,20.85-7.84c21.94-10.09,45.09-17.81,65.86-28.55-.68,4.05-1.4,8.08-2.15,12.11-.06.34-.14.68-.2,1.02-.71,3.7-1.47,7.4-2.28,11.08-.12.13-.25.27-.39.39-.22.23-.47.46-.72.68-2.27,2.16-4.87,4.2-7.71,6.1-2.28,1.56-4.71,3.02-7.27,4.42-1.3.73-2.63,1.41-3.99,2.09h-.02c-.87.46-1.77.9-2.67,1.34-1.77.84-3.57,1.66-5.39,2.45-2.69,1.2-5.42,2.32-8.17,3.4-4.49,1.8-9.02,3.47-13.43,5.07-1.74.75-3.5,1.49-5.28,2.2-.82.32-1.63.66-2.45.97-1.61.65-3.23,1.28-4.85,1.89-.85.33-1.71.63-2.61.94-2.51.87-5.19,1.7-7.91,2.53-2.43.74-4.88,1.5-7.28,2.29-1.31.43-2.59.87-3.85,1.34h-.02c-2.15.79-4.23,1.63-6.19,2.57v.02c-2.84,1.34-5.4,2.89-7.51,4.73v.02c-.38.3-.7.59-1.03.91-.11.1-.21.22-.32.32-2.75,2.73-5.07,5.72-7.1,8.83-1.07,1.62-2.06,3.27-3.01,4.95-1.25,2.23-2.42,4.5-3.57,6.76v0c-.7,1.38-1.39,2.74-2.07,4.1-1.42,2.82-2.87,5.6-4.43,8.26-.7,1.16-1.44,2.32-2.24,3.47-.92,1.4-1.93,2.78-2.89,4.17v0c-1.89,2.66-3.72,5.3-5.14,8.04h-.02c-.16.27-.29.55-.43.83-.67,1.35-1.27,2.72-1.83,4.12-1.76,4.31-3.07,8.77-4.33,13.15-.16.53-.31,1.05-.45,1.57-.49,1.72-.98,3.44-1.43,5.15-.49,1.78-.95,3.56-1.4,5.34-.58,2.23-1.14,4.48-1.66,6.71-.18.73-.35,1.45-.52,2.18-.51,2.27-1.03,4.52-1.5,6.78-1.43,6.59-2.71,13.19-3.96,19.81h-8.67c.03-.12.06-.23.1-.35c3.64-13.02,7.01-26.08,7.78-39.37Z"
              />
              <path
                d="M946.26,550.54c17.58-37.79,29.99-76.98,37.84-116.51.01-.06.14-.06.13,0-12.8,68.83-38.36,135.37-75.06,199.24-17.73,30.87-36.09,61.47-49.43,93.59-12.51,30.12-17.5,61.07-24.69,91.93h-5.85c5.75-26.53,10.23-53.24,19.68-79.21c23.76-65.28,67.72-125.3,97.38-189.04Z"
                fill="#35180b"
              />
              <path
                d="M838.84,775.04c-2.18-16.63-3.96-33.25-8.23-49.71-.06-.21.34-.26.43-.07c7.41,16.26,9.76,32.67,8.89,49.72-.02.45-1.03.52-1.09.05v0Z"
                fill="#35180b"
              />
              <path
                d="M831.98,624.79c1.09,8.72,4.67,16.51,8.53,24.74c3.28,7,7.71,13.87,8.08,21.35.09,1.71-3.32,2.49-4.7,1.2-14.28-13.38-11.62-31.38-12.13-47.28c0-.09.21-.1.22-.01v0Z"
                fill="#8e934b"
              />
              <path
                d="M1004.53,492.07c-9.15,16.12-7.5,40.94-28.89,51.67-2.2,1.1-4.04-1.2-3.07-2.56c6.05-8.55,11.72-16.83,16.7-25.78c4.41-7.92,8.6-16.25,15.03-23.42.08-.09.3-.02.24.09v0Z"
                fill="#35180b"
              />
              <path
                d="M967.08,471.26c-1.67-3.59-3-6.58-3.36-10.41-.86-9.08-.65-18.18.59-27.23c1.17-8.56,3.46-17.72,6.72-26.67c3.81-4,7.57-8.01,11.24-12.05-1.28,4.86-2.65,9.72-3.55,14.6-1.73,9.4-2.87,18.91-3.73,28.38-.82,9.07.72,18.11.11,27.11-.24,3.53-1.65,6.82-2.66,10.21-1.3,4.35-1.33,8.56-3.73,12.68-.17.29-.74.15-.63-.16c2.17-6.17,1.8-10.43-1-16.46Z"
                fill="#f2ddc4"
              />
              <path
                d="M960.66,532.91c5.15-18.23,21.59-32.75,33.43-48.8c13.8-29.32,22.82-60.73,27.54-92.14-.9,18.31-3.81,36.69-6.1,54.85-.56,4.47-1.32,8.91-2.17,13.35-4.79,10.22-11.1,20.05-19.32,29.36-.35.39-.93.45-1.42.32-9.29,14.8-21.03,28.7-30.81,43.48-.35.53-1.28.06-1.14-.42Z"
                fill="#8e934b"
              />
              <path
                d="M926.65,576.85c1.84-21.32-6.77-42.41-3.56-63.69c1.48-9.8,5.24-19.44,8.45-28.98c3.45-10.23,5.4-22.21,12.04-31.59.54-.76,1.93-.22,1.94.49.14,9.83-5.01,20.23-8,29.75-3.44,10.96-7.56,21.88-9.6,33.04-3.69,20.26,1.79,40.71-.44,61.02-.04.4-.87.36-.84-.04v0Z"
                fill="#f2ddc4"
              />
              <path
                d="M905.36,639.86c11.15-10.33,23.42-18.98,40.82-24.1c13.04-3.84,23.64-10.69,37.71-17.36c4.39-2.1,9.72-5.74,14.74-9.97c1.35-7.2,2.87-14.39,4.7-21.6.06-.77.12-1.52.18-2.29.01-.3.04-.61.06-.91.03-.46.07-.93.1-1.39h-.02c-.51.18-1.02.37-1.52.58-12.63,5.19-20.5,23.17-33.73,29.31-11.46,5.31-21.87,8.27-32.73,12.36-6.16,2.31-11.1,5.49-15.1,9.23-7.89,7.3-12.17,16.77-15.21,26.14Z"
                fill="#f9d2c3"
              />
              <path
                d="M789.21,734.49c4.46,3.29,6.76,10.29,4.81,14.73-.68,1.55-3.59,1.63-4.59.24-1.71-2.36-1.84-5.16-2.2-7.79-.32-2.35-.47-4.68.49-6.96.21-.49,1.04-.56,1.5-.23v0Z"
              />
            </g>
          </g>
          <g transform="translate(0-183.27908)">
            <g>
              <path
                d="M387.2,779.06c-.7,1.47-1.32,3.05-1.96,4.55c1.37-5.39,2.85-10.87,4.22-16.25c1.73-6.82,3.11-13.97,4.6-20.72s2.82-12.67,1.22-19.4c-.33-1.37-2.25-1.62-2.96-.32-3.74,6.83-5.11,14.81-8.71,21.73-3.61,6.92-8.09,13.2-12.53,19.6-3.98,5.72-8.06,11.43-11.79,17.33.33-2.25.68-4.5,1.05-6.73.27-1.66.56-3.31.83-4.96c4.29-11.38,8.49-22.47,12.38-34.04c5.58-16.63,9.85-32.55,11.03-50.44.54-8.18-.21-17.9-1.51-26.26c1.06-9.93,1.69-19.67,1.35-29.61c3.41,14.91,6.42,30.03,11.18,44.55c4.98,15.2,9.39,29.47,19.77,41.9c1.3,3.39,2.85,6.67,4.24,10.03c3.88,9.38,8.66,18.18,10.85,28.23c3.97,18.29.46,35.03-4.33,52.85-1.5,1.99-2.95,3.95-4.42,5.92h-41.39c2.33-12.48,6.24-25.01,8.07-37.64.12-.81-.83-1-1.17-.3Z"
                fill="#a2a08f"
              />
              <path
                d="M430.03,805.68c9.81-14.58,17.48-30.22,24.54-46.27c3.65-8.3,6.39-16.89,10.02-25.13c2.06-4.67,4.82-8.88,6.52-13.64c1.69-4.76,2.92-9.52,4.15-14.37.2-.79.42-1.41.78-2.13.07,1.36.13,2.72.19,4.08-2.13,9.04-1.36,17.5.26,26.59-.26,10.1-.47,20.75-.82,30.73-.38,11.12-2.3,21.11-5.04,31.73-.09.36-.11.75-.3,1.07-3.83,6.51-8.19,12.65-12.77,18.65h-18.2c7.96-10.8,15.88-21.62,23.47-32.67.26-.38-.16-.94-.48-.56-9.22,11.29-17.84,22.15-26.49,33.22h-14.19c1.46-1.96,2.91-3.92,4.4-5.91c1.37-1.83,2.68-3.52,3.95-5.42Z"
                fill="#393922"
              />
              <path
                d="M356.63,813.71c.02-.58.04-1.11.06-1.66.07-1.81.16-3.6.27-5.4c0-.04,0-.1,0-.13.05-.75.14-1.87.19-2.52s.04-.57.09-1.2c.05-.62.16-1.81.22-2.44.06-.62.05-.56.12-1.22.06-.65.18-1.74.26-2.51.03-.32.08-.7.11-1.04.1-.87.21-1.77.31-2.65.03-.29.07-.59.11-.88.12-.93.24-1.89.37-2.8.03-.2.06-.46.09-.61.12-.8.35-2.4.42-2.95.01-.11.01-.09.01-.11c3.75-5.92,7.82-11.61,11.8-17.34c4.45-6.4,8.93-12.67,12.53-19.6c3.61-6.92,4.97-14.9,8.71-21.73.71-1.3,2.64-1.05,2.96.32c1.6,6.73.27,12.66-1.22,19.4-1.49,6.75-2.87,13.9-4.6,20.72-1.37,5.37-2.85,10.85-4.22,16.25-4.28,10.93-8.14,22.19-11.5,33.39h-17.16c0-.48.01-.97.02-1.44.01-.61.02-1.27.04-1.85Z"
                fill="#b1c5a1"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv934" transform="translate(-8.968781-222.68956)">
            <g>
              <path
                d="M615.08,705.53c0,.06.02.11.02.17c0,0,0-.03,0-.04c0-.05-.02-.09-.03-.13Z"
                fill="#3b4229"
              />
              <path
                d="M539.78,601.93c.14.56.29,1.13.45,1.68c13.99,9.62,27.54,19.85,39.53,31.81c12.89,12.87,23.19,27.6,30.7,44.16c1.36,3,2.36,5.92,3.07,8.81.02-3.89.04-7.77.04-11.66.02-4.11.03-8.24,0-12.35-.11-42.51-1.8-84.97-12.6-126.34-7.82-29.93-17.64-60.96-10.03-91.98.34-1.38,2.48-.79,2.15.6-7.1,29.4,1.77,58.98,9.28,87.37c7.41,28.03,11.4,56.17,12.59,85.13.5,12.22.76,24.47.89,36.71.44-1.29.91-2.52,1.4-3.73c3.77-9.4,8.92-18.42,10.5-28.42c1.97-12.39-1.75-25.31,1.21-37.5c3.14-12.96,13.64-24.87,10.78-37.88-.55-2.51-1.61-4.94-1.63-7.52-.04-3.03,1.34-5.85,2.46-8.65.56-1.41,1.07-2.85,1.51-4.3-.64-1.68-1.29-3.36-1.95-5-2.96-7.42-45.22-83.47-46.69-81.83-39.52,43.84-68.42,103.87-53.65,160.89Zm25.32-25.55c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm2.16,12.39c0,1.05-.85,1.89-1.9,1.89s-1.9-.84-1.9-1.89.86-1.89,1.9-1.89s1.9.85,1.9,1.89Zm4.58-7.96c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm0,19.45c1.05,0,1.9.84,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89.85-1.89,1.9-1.89Zm2.47-4.37c1.05,0,1.9.84,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89.86-1.89,1.9-1.89Zm1.09-7.73c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89.85-1.89,1.9-1.89Zm3.53-4.9c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89.85-1.89,1.9-1.89s1.9.84,1.9,1.89Zm.07,16.27c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89.85-1.89,1.9-1.89Zm1.14,13.43c0-1.05.86-1.89,1.9-1.89.32,0,.62.08.88.22.22-.8.95-1.4,1.83-1.4c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89c-.32,0-.62-.08-.88-.22-.22.8-.95,1.4-1.83,1.4-1.05,0-1.9-.85-1.9-1.89Zm1.58,9c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.85,1.9,1.89Zm2.57.97c-1.05,0-1.9-.85-1.9-1.89s.86-1.89,1.9-1.89c.66,0,1.24.33,1.58.83-.21-.3-.32-.67-.32-1.06s.11-.73.3-1.03c-.75-.26-1.28-.96-1.28-1.79c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89c0,.38-.11.73-.31,1.03.75.26,1.29.95,1.29,1.79c0,1.04-.86,1.89-1.9,1.89-.66,0-1.24-.33-1.58-.83.21.29.32.66.32,1.06c0,1.04-.85,1.89-1.9,1.89Zm3.18.43c1.05,0,1.9.85,1.9,1.89s-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89.86-1.89,1.9-1.89ZM586,608.02c-1.06,0-1.9-.85-1.9-1.89s.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89Zm-1.93-18.05c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm1.1,8.36c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89.85-1.89,1.9-1.89s1.9.84,1.9,1.89Zm3.98-5.83c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm.97,8.38c1.05,0,1.9.85,1.9,1.89s-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89.86-1.89,1.9-1.89Zm1.95,26.07c-.57-.32-.96-.94-.96-1.65c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89c0,.39-.11.75-.31,1.05.57.31.96.94.96,1.64c0,1.05-.85,1.89-1.9,1.89s-1.9-.84-1.9-1.89c0-.38.11-.74.31-1.04Zm1.83-4.42c0-1.05.85-1.89,1.9-1.89.83,0,1.53.52,1.79,1.26.35-.37.86-.6,1.41-.6c1.05,0,1.9.84,1.9,1.89s-.86,1.89-1.9,1.89c-.84,0-1.54-.54-1.8-1.28-.34.39-.85.62-1.4.62-1.05,0-1.9-.85-1.9-1.89Zm3.57,6.5c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89.85-1.89,1.9-1.89Zm5.02-2.17c-1.03-.03-1.84-.87-1.84-1.89s.85-1.89,1.9-1.89s1.9.84,1.9,1.89c0,.24-.05.47-.13.68.34,0,.66.1.93.27-.1-.23-.14-.46-.14-.72c0-.83.54-1.53,1.29-1.79-.74-.26-1.26-.96-1.26-1.79c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89c0,.84-.55,1.54-1.3,1.8.75.26,1.27.96,1.27,1.78c0,1.05-.85,1.89-1.9,1.89-.36,0-.69-.09-.98-.27.09.22.14.46.14.72c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.25.05-.47.12-.68Zm-5.85-11.85c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89.85-1.89,1.9-1.89Zm-2.47-6.89c-1.06,0-1.9-.85-1.9-1.89s.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89Zm-4.61,12.86c0-.91.66-1.67,1.52-1.85-.43-.35-.7-.88-.7-1.48c0-.79.5-1.48,1.21-1.76-.86-.18-1.52-.94-1.52-1.85c0-1.04.86-1.89,1.9-1.89.07,0,.12,0,.19,0-.67-.28-1.16-.96-1.16-1.74c0-1.05.86-1.89,1.9-1.89s1.9.84,1.9,1.89-.85,1.89-1.9,1.89c-.07,0-.13,0-.19,0c.68.28,1.16.96,1.16,1.74s-.49,1.48-1.21,1.76c.87.18,1.52.95,1.52,1.85s-.65,1.67-1.52,1.85c.43.35.7.88.7,1.48c0,1.05-.85,1.89-1.9,1.89s-1.9-.84-1.9-1.89Zm4.64-27.65c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm2.22,8.66c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.58.26-1.1.67-1.46-.1.02-.19.03-.29.03-1.05,0-1.9-.84-1.9-1.89s.86-1.89,1.9-1.89s1.9.85,1.9,1.89c0,.58-.26,1.1-.67,1.46.1-.02.19-.03.29-.03c1.05,0,1.9.84,1.9,1.89Zm.12,11.41c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm.04-4.75c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm4.22-6.35c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.84,1.9,1.89Zm.6,13.58c1.05,0,1.9.84,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89.85-1.89,1.9-1.89Zm5.27-4.59c0,1-.79,1.82-1.79,1.88.18.28.29.62.29.98c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89.78-1.82,1.78-1.88c-.17-.28-.28-.62-.28-.98c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89Zm2.35,5.29c0,1.05-.86,1.89-1.9,1.89s-1.9-.84-1.9-1.89.85-1.89,1.9-1.89s1.9.85,1.9,1.89Zm.32,14.99c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89.86-1.89,1.9-1.89s1.9.85,1.9,1.89Zm.6,6.04c0,1.05-.85,1.89-1.9,1.89-.62,0-1.17-.29-1.51-.75-.2.13-.43.23-.66.28.06.17.09.36.09.56c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.12,0-.25.04-.36-.25.11-.52.18-.81.18-1.05,0-1.9-.84-1.9-1.89c0-.69.38-1.3.94-1.63-.53-.33-.88-.93-.88-1.6c0-1.04.86-1.89,1.9-1.89.04,0,.08,0,.11,0-.07-.19-.1-.4-.1-.61c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89c-.04,0-.08,0-.11,0c.07.19.1.4.1.61c0,.7-.37,1.3-.93,1.63.52.34.87.94.87,1.6c0,.12,0,.25-.04.37.13-.07.27-.11.41-.14-.06-.18-.09-.37-.09-.57c0-1.04.85-1.89,1.9-1.89.62,0,1.17.3,1.51.76.3-.21.67-.33,1.06-.33c1.05,0,1.9.85,1.9,1.89Zm-2.19,4.27c1.05,0,1.9.85,1.9,1.89s-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89.85-1.89,1.9-1.89Zm.21,30.02c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm-3.27-16.27c-.39-.06-.73-.24-1-.49-.34.5-.92.83-1.58.83-1.05,0-1.9-.84-1.9-1.89s.86-1.89,1.9-1.89c.51,0,.97.2,1.31.52.33-.5.91-.83,1.57-.83.83,0,1.53.52,1.8,1.26.35-.36.85-.59,1.39-.59c1.05,0,1.9.84,1.9,1.89s-.86,1.89-1.9,1.89c-.32,0-.63-.09-.89-.23.23.31.36.69.36,1.11c0,.26-.05.49-.14.71.94.1,1.67.9,1.67,1.87c0,.2-.03.4-.09.58.56.31.94.93.94,1.62c0,.97-.73,1.77-1.67,1.87.11.17.2.36.25.56.33-.29.78-.48,1.26-.48c1.06,0,1.9.85,1.9,1.89c0,.71-.4,1.33-.99,1.65c0,.07,0,.13,0,.2c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.35.09-.67.26-.95-.15.05-.31.07-.48.07-1.05,0-1.9-.84-1.9-1.89c0-.96.73-1.76,1.67-1.87-.2-.3-.31-.66-.31-1.04c0-.2.03-.4.09-.58-.19-.09-.36-.24-.5-.41v.03c0,1.04-.85,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.45.16-.86.42-1.18-1.01-.05-1.82-.88-1.82-1.89s.86-1.89,1.9-1.89c.56,0,1.06.25,1.42.62.12-.43.4-.81.77-1.06Zm-10.7-8.27c0-.61.29-1.13.72-1.48-.32-.33-.5-.78-.5-1.28c0-.54.23-1.03.6-1.37-.31-.33-.5-.78-.5-1.3c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89c0,.54-.23,1.03-.6,1.38.31.33.5.78.5,1.29c0,.6-.28,1.13-.71,1.48.31.33.49.78.49,1.28c0,.09,0,.18-.02.26.24-.32.59-.56,1-.67-.34-.35-.56-.82-.56-1.34c0-1.04.86-1.89,1.9-1.89.16,0,.32.02.48.07-.13-.26-.2-.54-.2-.84c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89c-.16,0-.31-.02-.47-.06.12.26.19.53.19.83c0,.87-.59,1.61-1.4,1.82.34.35.56.82.56,1.35c0,.11,0,.23-.03.34.29-.66.96-1.13,1.74-1.13.14,0,.28.02.41.05-.34-.35-.55-.81-.55-1.33c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89c0,.57-.25,1.08-.64,1.42.16-.05.33-.07.5-.07c1.05,0,1.9.84,1.9,1.89s-.85,1.89-1.9,1.89c-.81,0-1.5-.51-1.78-1.22-.29.67-.96,1.15-1.75,1.15-1.06,0-1.9-.85-1.9-1.89c0-.11.01-.23.03-.34-.27.6-.84,1.04-1.53,1.12.33.34.55.8.55,1.33c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89c0-.98.75-1.78,1.7-1.88-.34-.34-.56-.81-.56-1.33c0-.09,0-.17.02-.26-.35.44-.89.73-1.5.73-1.05,0-1.9-.85-1.9-1.89Zm-9.77-12.95c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-1.05-5.1c0-1.05.86-1.89,1.9-1.89s1.9.84,1.9,1.89c0,.05,0,.09,0,.13.33-.26.74-.41,1.19-.41.48,0,.92.18,1.25.47.35-.44.89-.73,1.51-.73c1.05,0,1.9.84,1.9,1.89c0,.4-.12.77-.34,1.08.69.28,1.18.96,1.18,1.75c0,.05,0,.1,0,.15.33-.58.94-.96,1.65-.96c1.05,0,1.9.84,1.9,1.89c0,.7-.39,1.31-.96,1.64.44.34.71.87.71,1.47c0,1.05-.86,1.89-1.9,1.89-.54,0-1.04-.23-1.39-.59-.07.99-.88,1.76-1.89,1.76s-1.9-.84-1.9-1.89.86-1.89,1.9-1.89c.54,0,1.04.23,1.39.6.04-.64.4-1.2.94-1.5-.43-.35-.7-.88-.7-1.48c0-.05,0-.09,0-.14-.33.57-.94.95-1.65.95-1.05,0-1.9-.84-1.9-1.89c0-.4.12-.77.34-1.08-.2-.09-.38-.2-.54-.34-.34.44-.89.74-1.5.74-1.06,0-1.9-.85-1.9-1.89c0-.05,0-.09,0-.14-.32.26-.74.42-1.19.42-1.05,0-1.9-.85-1.9-1.89Zm-.57-1.83c-1.05,0-1.9-.85-1.9-1.89s.86-1.89,1.9-1.89s1.9.84,1.9,1.89-.85,1.89-1.9,1.89Zm-5.02,1.17c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.85,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-.68-13.27c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm-.72-5.49c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm.25,6.26c0,1.05-.86,1.89-1.9,1.89s-1.9-.84-1.9-1.89.85-1.89,1.9-1.89s1.9.85,1.9,1.89Zm-3.9,4.96c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-1.13-13.04c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm-3.51,11.79c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-1.3-7.41c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm-.27-6.11c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-2.4-5.62c-1.05,0-1.9-.84-1.9-1.89s.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89Zm-2.98,15.38c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-.98-9.05c0-1.05.86-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-4.05-1.26c0-1.05.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.86,1.89-1.9,1.89-1.9-.85-1.9-1.89Zm-1.63-12.22c-1.05,0-1.9-.85-1.9-1.89s.85-1.89,1.9-1.89s1.9.84,1.9,1.89-.85,1.89-1.9,1.89Zm-2.78,7.73c0-1.04.85-1.89,1.9-1.89s1.9.85,1.9,1.89-.86,1.89-1.9,1.89-1.9-.84-1.9-1.89Zm-3.28-14.83c0,1.04-.86,1.89-1.9,1.89s-1.9-.85-1.9-1.89.85-1.89,1.9-1.89s1.9.84,1.9,1.89Zm-3.88,14.56c0-1.04.86-1.89,1.9-1.89s1.9.85,1.9,1.89-.85,1.89-1.9,1.89-1.9-.84-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M617.73,739.29c20.86-12.78,34.87-39.06,41.83-61.4c3.12-10.03,5.18-20.32,6.49-30.72.09-1.78.16-3.56.24-5.33-.02-.22-.03-.43-.05-.65-3.34,17.43-6.94,34.85-12.99,51.52-3.59,9.89-8.28,19.8-16.32,26.62-4.68,3.97-10.37,6.79-14.46,11.37-1.96,2.2-3.46,4.71-4.64,7.37-.03.4-.06.8-.1,1.21Z"
                fill="#3b4229"
              />
              <path
                d="M616.73,799.83c0-.26.02-.54.02-.8.02-.38.03-.77.03-1.14.12-4.38.2-8.76.23-13.13c0-.68,0-1.37,0-2.05.05-7.17,0-14.33-.11-21.49-.02-1.48-.04-2.97-.07-4.44c3.42-2.97,6.66-6.12,9.74-9.42c1.53-1.85,3.07-3.69,4.56-5.56c15.37-19.24,25.29-42.04,34.32-65v.32c0,.76,0,1.52.03,2.29-.01.08,0,.16,0,.25c0,.75.02,1.5.03,2.26c0,.65.03,1.31.05,1.98c0,.88.03,1.76.06,2.64c0,.14,0,.29,0,.43.02.46.03.94.05,1.41.04,1.03.08,2.05.11,3.08c0,.16,0,.31.02.47.03.71.06,1.42.09,2.13.05,1.1.1,2.19.17,3.29-.91,11.35-2.38,22.61-4.48,33.59-.09.5-.18.99-.29,1.49-2.92,14.91-7,29.35-12.39,42.98-7.63,19.33-17.9,37.02-31.16,52.22h-2.87c.78-7.29,1.32-14.59,1.62-21.8.08-2,.16-4,.22-5.98Z"
                fill="#3b4229"
              />
              <path
                d="M616.25,726.52c0,0,.02.04.02.06v-.1c0,0,0,.03-.02.05Z"
                fill="#3b4229"
              />
              <path
                d="M615.85,655.88c.09,7.35.12,14.69.14,22.05.04,11.22.04,22.45.1,33.67.03,4.95.1,9.91.17,14.87c4.49-12.99,16.67-23.2,24.19-34.85c6.28-9.74,9.81-20.95,12.97-32.09c3.93-13.82,7.44-27.77,10.5-41.81v0c-2.95-23.37-7.78-45.96-14-66.61-2.41-8.06-5.05-15.84-7.86-23.24-.44,1.46-.95,2.89-1.51,4.3-1.12,2.8-2.5,5.63-2.46,8.65.03,2.57,1.08,5,1.63,7.52c2.86,13.02-7.64,24.92-10.78,37.88-2.96,12.19.76,25.1-1.21,37.5-1.58,10-6.73,19.02-10.5,28.42-.48,1.21-.96,2.45-1.4,3.73Z"
                fill="#3b4229"
              />
              <path
                d="M611.76,665.83c0-1.04-.85-1.89-1.9-1.89-.48,0-.93.19-1.26.48-.05-.2-.13-.39-.25-.56.94-.1,1.67-.9,1.67-1.87c0-.69-.38-1.3-.94-1.62.07-.18.09-.38.09-.58c0-.97-.73-1.77-1.67-1.87.1-.22.14-.45.14-.71c0-.42-.13-.79-.36-1.11.27.14.57.23.89.23c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89c-.54,0-1.04.23-1.39.59-.27-.74-.97-1.26-1.8-1.26-.66,0-1.24.33-1.57.83-.34-.32-.8-.52-1.31-.52-1.05,0-1.9.85-1.9,1.89s.86,1.89,1.9,1.89c.66,0,1.24-.33,1.58-.83.27.26.61.43,1,.49-.37.25-.65.62-.77,1.06-.35-.38-.86-.62-1.42-.62-1.05,0-1.9.84-1.9,1.89s.82,1.84,1.82,1.89c-.26.32-.42.73-.42,1.18c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89v-.03c.14.17.31.31.5.41-.07.18-.09.38-.09.58c0,.38.11.74.31,1.04-.94.11-1.67.91-1.67,1.87c0,1.05.86,1.89,1.9,1.89.16,0,.32-.02.48-.07-.16.28-.26.61-.26.95c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.07,0-.13,0-.2.59-.32.99-.95.99-1.65Z"
                fill="#3b4229"
              />
              <path
                d="M611.76,671.9c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89.85,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M609.93,637.61c0-1.04-.85-1.89-1.9-1.89-.39,0-.76.12-1.06.33-.34-.45-.89-.76-1.51-.76-1.05,0-1.9.85-1.9,1.89c0,.2.03.39.09.57-.14.03-.28.08-.41.14.03-.12.04-.25.04-.37c0-.66-.35-1.26-.87-1.6.56-.32.93-.93.93-1.63c0-.22-.04-.43-.1-.61.04,0,.08,0,.11,0c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89c0,.22.04.43.1.61-.04,0-.08,0-.11,0-1.05,0-1.9.85-1.9,1.89c0,.67.35,1.27.88,1.6-.56.32-.94.94-.94,1.63c0,1.05.86,1.89,1.9,1.89.28,0,.56-.07.81-.18-.03.11-.04.24-.04.36c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.2-.03-.39-.09-.56.24-.06.47-.15.66-.28.34.45.89.75,1.51.75c1.05,0,1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M607.75,645.67c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89.85,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M609.34,631.57c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M609.01,616.59c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89.85,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M606.66,611.3c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89c0,.36.1.7.28.98-1,.06-1.78.88-1.78,1.88s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.36-.1-.7-.29-.98c1-.06,1.79-.88,1.79-1.88Z"
                fill="#3b4229"
              />
              <path
                d="M602.49,626.86c-.08.21-.12.44-.12.68c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.26-.05-.5-.14-.72.29.18.62.27.98.27c1.06,0,1.9-.84,1.9-1.89c0-.82-.52-1.52-1.27-1.78.75-.26,1.3-.95,1.3-1.8c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89c0,.82.52,1.52,1.26,1.79-.75.26-1.29.96-1.29,1.79c0,.26.05.49.14.72-.28-.17-.59-.26-.93-.27.09-.21.13-.44.13-.68c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.82,1.86,1.84,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M601.4,619.67c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89-1.9.84-1.9,1.89.85,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M600.89,623.19c0-1.05-.86-1.89-1.9-1.89-.55,0-1.06.24-1.41.6-.26-.74-.96-1.26-1.79-1.26-1.05,0-1.9.84-1.9,1.89s.85,1.89,1.9,1.89c.55,0,1.06-.24,1.4-.62.26.74.96,1.28,1.8,1.28c1.05,0,1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M600.8,602.31c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M596.58,608.66c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M596.54,613.41c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M599.37,630.93c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89.85,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M596.64,615.02c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M597.39,648.52c0,.09-.02.17-.02.26c0,.52.22.99.56,1.33-.95.1-1.7.9-1.7,1.88c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.53-.22-.99-.55-1.33.69-.08,1.26-.52,1.53-1.12-.02.11-.03.23-.03.34c0,1.04.85,1.89,1.9,1.89.79,0,1.46-.48,1.75-1.15.28.71.97,1.22,1.78,1.22c1.05,0,1.9-.85,1.9-1.89s-.85-1.89-1.9-1.89c-.17,0-.34.02-.5.07.39-.34.64-.85.64-1.42c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89c0,.52.21.98.55,1.33-.13-.03-.27-.05-.41-.05-.78,0-1.44.46-1.74,1.13.02-.11.03-.23.03-.34c0-.53-.22-1-.56-1.35.81-.21,1.4-.95,1.4-1.82c0-.3-.07-.58-.19-.83.15.04.3.06.47.06c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89c0,.3.07.59.2.84-.15-.05-.31-.07-.48-.07-1.05,0-1.9.85-1.9,1.89c0,.52.22.99.56,1.34-.41.11-.76.35-1,.67c0-.08.02-.17.02-.26c0-.49-.18-.95-.49-1.28.44-.35.71-.88.71-1.48c0-.5-.19-.96-.5-1.29.37-.35.6-.84.6-1.38c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89c0,.51.19.96.5,1.3-.37.34-.6.83-.6,1.37c0,.49.18.95.5,1.28-.44.35-.72.88-.72,1.48c0,1.04.86,1.89,1.9,1.89.61,0,1.15-.28,1.5-.73Z"
                fill="#3b4229"
              />
              <path
                d="M596.42,602c0-1.05-.86-1.89-1.9-1.89-.1,0-.19,0-.29.03.41-.36.67-.88.67-1.46c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89.86,1.89,1.9,1.89c.1,0,.19,0,.29-.03-.41.36-.67.88-.67,1.46c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M592.26,606.23c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M592.07,626.95c-.2.3-.31.66-.31,1.04c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89c0-.7-.39-1.32-.96-1.64.2-.3.31-.66.31-1.05c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89c0,.71.39,1.32.96,1.65Z"
                fill="#3b4229"
              />
              <path
                d="M592.15,612.16c-.07,0-.12,0-.19,0-1.05,0-1.9.85-1.9,1.89c0,.92.66,1.67,1.52,1.85-.7.27-1.21.96-1.21,1.76c0,.6.28,1.13.7,1.48-.86.18-1.52.95-1.52,1.85c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89c0-.6-.28-1.13-.7-1.48.87-.18,1.52-.94,1.52-1.85s-.65-1.67-1.52-1.85c.71-.27,1.21-.96,1.21-1.76s-.48-1.46-1.16-1.74c.06,0,.12,0,.19,0c1.05,0,1.9-.85,1.9-1.89s-.85-1.89-1.9-1.89-1.9.84-1.9,1.89c0,.78.48,1.46,1.16,1.74Z"
                fill="#3b4229"
              />
              <path
                d="M594.19,593.34c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M590.12,600.88c-1.05,0-1.9.85-1.9,1.89s.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M589.37,625.26c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89.86,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M589.15,592.5c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M588.05,617.13c.2-.3.31-.65.31-1.03c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89c0,.82.53,1.53,1.28,1.79-.19.3-.3.65-.3,1.03s.11.76.32,1.06c.34.5.92.83,1.58.83c1.05,0,1.9-.85,1.9-1.89c0-.83-.54-1.53-1.29-1.79Z"
                fill="#3b4229"
              />
              <path
                d="M586.12,632.52c-1.05,0-1.9.84-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M584.09,606.14c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M585.07,631.2c.45,0,.86-.16,1.19-.42c0,.05,0,.09,0,.14c0,1.04.85,1.89,1.9,1.89.61,0,1.16-.29,1.5-.74.16.14.34.26.54.34-.22.31-.34.68-.34,1.08c0,1.05.86,1.89,1.9,1.89.71,0,1.32-.38,1.65-.95c0,.05,0,.09,0,.14c0,.6.28,1.13.7,1.48-.54.3-.9.86-.94,1.5-.35-.37-.85-.6-1.39-.6-1.05,0-1.9.85-1.9,1.89s.86,1.89,1.9,1.89s1.82-.77,1.89-1.76c.35.36.85.59,1.39.59c1.05,0,1.9-.84,1.9-1.89c0-.6-.28-1.13-.71-1.47.57-.32.96-.94.96-1.64c0-1.05-.86-1.89-1.9-1.89-.71,0-1.32.38-1.65.96c0-.05,0-.1,0-.15c0-.78-.48-1.46-1.18-1.75.22-.31.34-.68.34-1.08c0-1.05-.86-1.89-1.9-1.89-.62,0-1.16.28-1.51.73-.33-.29-.77-.47-1.25-.47-.45,0-.86.15-1.19.41c0-.04,0-.09,0-.13c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M586.18,621.04c0-.4-.11-.77-.32-1.06-.34-.5-.92-.83-1.58-.83-1.05,0-1.9.84-1.9,1.89s.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M585.17,598.34c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M590.1,446.09c.49-.98,1.22-2.11,2.32-2.07c1.51.06,1.9,2.1,1.87,3.6-.56,23.31,6.74,45.97,12.31,68.62c5.57,22.64,9.41,46.82,2.09,68.97-4.14-28.44-12.15-56.32-23.74-82.65-2.73-6.2-5.69-12.4-6.86-19.07-1.17-6.66-.46-13.62,1.98-19.93c1.2-3.1,2.95-4.32,4.69-6.77c2.22-3.11,3.64-7.28,5.35-10.7Z"
                fill="#3b4229"
              />
              <path
                d="M582.6,627.48c1.05,0,1.9-.85,1.9-1.89s-.85-1.89-1.9-1.89-1.9.84-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M584.06,589.98c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M582.04,614.85c.88,0,1.62-.6,1.83-1.4.27.14.56.22.88.22c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89c-.88,0-1.62.6-1.83,1.4-.27-.14-.56-.22-.88-.22-1.05,0-1.9.84-1.9,1.89s.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M581.72,621.96c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M581.38,628.65c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M579,599.53c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M578.8,617.27c1.05,0,1.9-.84,1.9-1.89s-.85-1.89-1.9-1.89-1.9.85-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M578.07,611.77c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89-1.9.84-1.9,1.89.85,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M578.93,583.26c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M575.4,588.16c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M576.42,616.14c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89.85,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M576.33,621.11c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M574.31,595.89c-1.05,0-1.9.84-1.9,1.89s.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M573.29,609.96c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M571.84,600.26c-1.05,0-1.9.84-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M571.84,580.81c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M571.69,619.86c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M568.49,614.34c1.05,0,1.9-.84,1.9-1.89s-.85-1.89-1.9-1.89-1.9.85-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M566.32,606.34c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M567.26,588.77c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89.86,1.89,1.9,1.89s1.9-.84,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M563.92,600.72c1.06,0,1.9-.84,1.9-1.89s-.85-1.89-1.9-1.89-1.9.85-1.9,1.89.86,1.89,1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M565.1,576.38c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.86,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M564.74,616.1c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M561.86,605.16c-1.05,0-1.9.84-1.9,1.89s.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M559.71,605.8c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M556.18,591.68c0-1.05-.85-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M553.39,599.42c-1.06,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M548.21,586.47c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89.85,1.89,1.9,1.89s1.9-.85,1.9-1.89Z"
                fill="#3b4229"
              />
              <path
                d="M544.33,601.03c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                fill="#3b4229"
              />
              <path
                d="M557.64,651.94c-.6-1.91-1.23-3.81-1.89-5.69-2.36-6.78-5.08-13.44-7.71-20.13v0c-.87-2.23-1.74-4.45-2.58-6.68-.86-2.32-1.71-4.64-2.5-6.99l-.16-.48v0c-.94-2.76-1.81-5.54-2.58-8.35c13.99,9.62,27.54,19.85,39.53,31.81c12.89,12.87,23.19,27.6,30.7,44.16c1.36,3,2.36,5.92,3.07,8.81v0c-.02,2.74-.03,5.48-.04,8.22v0c0,.21,0,.4,0,.59c0,0,0,.02,0,.02c0,2.05-.02,4.09-.02,6.14v.04c0,.98,0,1.96,0,2.94v0c0,3.65,0,7.29,0,10.92c0,1.04,0,2.09,0,3.13v3.22c.02,5.07.03,10.13.02,15.18-.02,21.4-.23,42.8-1.16,64.18-.03.65-.06,1.3-.09,1.96-.04.77-.08,1.53-.11,2.3-.36,6.85-.97,13.64-1.76,20.38h-2.16c-10.21-24.35-22.98-48.2-30.88-73.34-10.44-33.19-9.34-69.12-19.68-102.34Z"
                fill="#3b4229"
              />
              <path
                d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                fill="#3b4229"
              />
              <path
                d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                fill="#3b4229"
              />
              <path
                d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                fill="#3b4229"
              />
              <g>
                <path
                  d="M590.37,477.41c-.07,4.04.09,8.08.41,12.05.44,5.52.89,11.26,2.54,16.57c1,3.23,2.42,6.29,3.82,9.36.54,1.94,1.13,3.88,1.82,5.8.56,2.15,1.14,4.3,1.71,6.44s1.14,4.28,1.71,6.41c7.41,28.03,11.4,56.17,12.59,85.13.5,12.22.76,24.47.89,36.71-.95,2.73-1.77,5.61-2.28,8.52-.11-42.51-1.8-84.97-12.6-126.34-1.17-4.49-2.39-9-3.59-13.54-.6-2.27-1.19-4.54-1.77-6.8-4.44-12.95-6.03-26.54-5.24-40.3Z"
                  fill="#faede1"
                />
                <path
                  d="M616.25,726.52c0,0,.02.04.02.06v-.1c0,0,0,.03-.02.05Z"
                  fill="#faede1"
                />
                <path
                  d="M615.08,705.53c0,.06.02.11.02.17c0,0,0-.03,0-.04c0-.05-.02-.09-.03-.13Z"
                  fill="#faede1"
                />
                <path
                  d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                  fill="#faede1"
                />
              </g>
              <path
                d="M616.51,805.81c1.95-1.49,3.58-3.8,5.14-5.45c3.32-3.5,6.47-7.23,10.04-10.49c3.62-3.32,7.89-5.71,11.62-8.88c2.04-1.73,3.89-3.62,5.61-5.61c5.39-13.63,9.48-28.07,12.39-42.98.29-.79.55-1.6.82-2.4-.18.3-.35.61-.53.91-1.94,3.3-3.74,6.65-5.61,9.64-4.77,7.69-9.78,15.19-15.11,22.51-2.83,3.89-5.66,7.71-7.87,12-2.09,4.04-3.79,8.11-6.58,11.78-2.93,3.86-6.38,7.38-9.61,10.98l-.05.05c0,.38,0,.77-.03,1.14c0,.26,0,.54-.02.8-.06,1.99-.13,3.98-.22,5.98Z"
                fill="#fc9f95"
              />
              <path
                d="M616.75,799.02c19.92-18.17,35.72-41.38,44.57-66.61.29-.79.55-1.6.82-2.4-.18.3-.35.61-.53.91c2.1-10.99,3.56-22.24,4.48-33.59-.07-1.1-.12-2.19-.17-3.29-.04-.71-.07-1.42-.09-2.13c0-.16,0-.31-.02-.47-.04-1.03-.08-2.05-.11-3.08-.05-1.49-.09-2.99-.11-4.48-.04-1.42-.06-2.83-.08-4.24c0-.08,0-.17,0-.25-5.92,24.48-18.07,47.24-30.07,69.56-5.08,9.44-10.16,18.89-15.24,28.34-.94,1.75-2.08,3.56-3.16,5.41c0,.68,0,1.37,0,2.05-.03,4.38-.1,8.75-.23,13.13c0,.38,0,.77-.03,1.14Z"
                fill="#ffba96"
              />
              <path
                d="M617.01,782.69c0,.68,0,1.37,0,2.05c23.42-28.35,40.16-62.1,48.62-97.8c0-.14,0-.29,0-.43-.03-.88-.05-1.76-.06-2.64-.02-.66-.04-1.32-.05-1.98c0-.76-.02-1.51-.03-2.26c0-.08,0-.17,0-.25-.02-.77-.02-1.53-.03-2.29v-.32c-9.03,22.97-18.95,45.76-34.32,65-1.49,1.87-3.03,3.71-4.56,5.56-3.46,4.18-6.84,8.42-9.34,13.22-.11.22-.22.43-.33.64.1,7.16.16,14.32.11,21.49Z"
                fill="#917b5d"
              />
              <path
                d="M616.52,740.01c0,.47.02.95.03,1.42.03,1.18.05,2.36.07,3.54.08,3.93.15,7.87.22,11.8c3.42-2.97,6.66-6.12,9.74-9.42c1.53-1.85,3.07-3.69,4.56-5.56c15.37-19.24,25.29-42.04,34.32-65-.04-6.81.06-13.61.24-20.42.08-3.05.21-6.12.35-9.19-1.31,10.4-3.37,20.69-6.49,30.72-6.96,22.34-20.97,48.62-41.83,61.4-.17.11-.35.22-.53.32-.22.13-.45.26-.68.4Z"
                fill="#7f272d"
              />
              <path
                d="M626.58,747.34c5.51-5.88,10.52-12.24,15.12-18.85c8.9-12.76,16.41-26.59,21.09-41.4c1.04-3.28,1.92-6.62,2.67-9.98v-.32c-9.03,22.97-18.95,45.76-34.32,65-1.49,1.87-3.03,3.71-4.56,5.56Z"
                fill="#6d2427"
              />
              <path
                d="M617.73,739.29c20.86-12.78,34.87-39.06,41.83-61.4c3.12-10.03,5.18-20.32,6.49-30.72.09-1.78.16-3.56.24-5.33-.02-.22-.03-.43-.05-.65-3.34,17.43-6.94,34.85-12.99,51.52-3.59,9.89-8.28,19.8-16.32,26.62-4.68,3.97-10.37,6.79-14.46,11.37-1.96,2.2-3.46,4.71-4.64,7.37-.03.4-.06.8-.1,1.21Z"
                fill="#6d2427"
              />
              <path
                d="M615.08,705.53c0,.06.02.11.02.17c0,0,0-.03,0-.04c0-.05-.02-.09-.03-.13Z"
                fill="#f53d66"
              />
              <path
                d="M540.23,603.61c.77,2.81,1.63,5.59,2.58,8.34v0l.16.49c5.17,2.05,10.04,5.01,14.39,8.45c8.75,6.92,15.75,15.75,22.67,24.5c14.24,18,29.52,37.94,33.43,60.94c0-.98,0-1.96,0-2.94v-.04c0-2.04,0-4.08.02-6.14c0,0,0,0,0-.02c0-.19,0-.38,0-.58v0c0-2.74.02-5.48.04-8.22v0c-.71-2.9-1.71-5.82-3.07-8.82-7.51-16.56-17.81-31.3-30.7-44.16-11.99-11.97-25.54-22.2-39.53-31.81Z"
                fill="#f53d66"
              />
              <path
                d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                fill="#af966e"
              />
              <path
                d="M615.08,705.53c0,.06.02.11.02.17c0,0,0-.03,0-.04c0-.05-.02-.09-.03-.13Z"
                fill="#af966e"
              />
              <path
                d="M542.8,611.96l.16.48c.79,2.34,1.63,4.67,2.5,6.99.84,2.23,1.7,4.45,2.58,6.67v0c8.82,4.25,16.12,11.84,21.36,20.24c6.99,11.23,10.97,24.01,15.76,36.32c4.79,12.33,10.72,24.66,20.6,33.5c2.66,2.39,5.64,4.53,7.71,7.44v-3.22c0-1.04,0-2.09,0-3.13c0-3.63,0-7.27,0-10.91v0c0-.99,0-1.97,0-2.95v-.04c0-2.04,0-4.08.02-6.14c0,0,0,0,0-.02c0-.19,0-.38,0-.58v0c-1.47-6-3.71-11.85-6.42-17.38-6.03-12.22-14.39-23.14-22.88-33.81-5.16-6.49-10.41-12.94-16.59-18.47-7.23-6.48-15.69-11.58-24.8-15Z"
                fill="#af966e"
              />
              <path
                d="M616.27,726.47v.11c.08,4.47.16,8.95.25,13.43.23-.13.46-.26.68-.4.18-.1.36-.21.53-.32.05-.41.08-.81.1-1.21c1.18-2.67,2.68-5.17,4.64-7.37c4.09-4.59,9.78-7.4,14.46-11.37c8.04-6.83,12.73-16.73,16.32-26.62c6.05-16.67,9.66-34.09,12.99-51.52-.54-7.88-1.31-15.71-2.3-23.47-3.06,14.04-6.57,27.99-10.5,41.81-3.16,11.14-6.69,22.35-12.97,32.09-7.52,11.65-19.7,21.86-24.19,34.85Z"
                fill="#292614"
              />
              <path
                d="M617.73,739.29c20.86-12.78,34.87-39.06,41.83-61.4c3.12-10.03,5.18-20.32,6.49-30.72.09-1.78.16-3.56.24-5.33-.02-.22-.03-.43-.05-.65-3.34,17.43-6.94,34.85-12.99,51.52-3.59,9.89-8.28,19.8-16.32,26.62-4.68,3.97-10.37,6.79-14.46,11.37-1.96,2.2-3.46,4.71-4.64,7.37-.03.4-.06.8-.1,1.21Z"
                fill="#292614"
              />
              <path
                d="M616.25,726.52c0,0,.02.04.02.06v-.1c0,0,0,.03-.02.05Z"
                fill="#292614"
              />
              <path
                d="M615.5,729.02c.03-.12.07-.24.09-.36c0-.07-.02-.14-.04-.21-.02.19-.04.38-.06.57Z"
                fill="#efe5d4"
              />
              <path
                d="M545.47,619.43c.84,2.23,1.7,4.45,2.58,6.67v0c2.63,6.69,5.35,13.36,7.71,20.14c1.68.69,3.25,1.72,4.54,2.97c3.58,3.45,5.55,8.19,7.41,12.78l16.74,41.13c2.8,6.87,5.71,13.94,10.89,19.28c5.07,5.22,14.04,9.76,18.14,16.39c0-5.06,0-10.12-.02-15.18v-3.22c-2.67-4.77-6.34-9.54-10.45-14.89-12.82-16.68-18.08-35.74-26.96-54.44-6.44-13.56-16.77-26.78-30.58-31.63Z"
                fill="#efe5d4"
              />
              <g>
                <path
                  d="M645.41,642.79c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M626.04,668.52c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M634.21,676.45c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M643.02,670.96c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M638.23,664.49c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M653.62,638.75c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M639.87,632.61c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M652.93,644.09c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M627.67,695.35c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M650.62,628.04c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M635.93,680.56c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M629.72,699.1c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M631.89,659.02c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M654.35,626.1c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M640.31,679.35c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M635.93,651.56c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M651.18,648.51c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M621.75,696.71c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M647.49,633.11c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M624.03,707.05c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M645.2,636.39c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M620.16,705.35c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M654.98,633.58c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M635.57,647.13c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M640.38,655.15c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M623.18,673.54c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M640.63,645c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M643.27,624.76c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M633.44,692.53c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M620.33,700.43c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M618.19,714.8c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M636.94,639.15c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M636.48,687.55c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M634.62,655.31c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M644,618.66c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M622.69,693.58c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M627.86,676.67c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M648.05,655.49c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M642.25,675.52c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M620.92,689.83c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M623.52,686.63c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M630.13,668.73c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M626.95,673.1c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M646.5,671.86c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M643,650.88c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M633.2,679.83c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M637.08,672.95c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M634.65,668.3c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M638.13,668.53c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M646.83,661c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M631.64,672.63c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M630.31,664.03c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M631.48,683.75c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M621.65,677.62c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M656.93,617.38c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M650.32,653.37c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M625.36,678.96c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M639.01,682.92c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M627.21,689.35c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M627.41,683.8c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M655.29,622.61c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M646.88,608.78c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M622.91,683.14c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M626.37,661.77c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M652.08,598.11c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M643.14,662.14c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M619.73,710.61c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M647.49,667.73c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
                <path
                  d="M639.83,660.61c-1.05,0-1.9.85-1.9,1.89s.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89Z"
                  fill="#292614"
                />
              </g>
              <g>
                <path
                  d="M606.13,637.61c0,.43.14.82.39,1.14.34.45.89.75,1.51.75c1.05,0,1.9-.84,1.9-1.89s-.85-1.89-1.9-1.89c-.39,0-.76.12-1.06.33-.5.33-.84.91-.84,1.56Z"
                  fill="#292614"
                />
                <path
                  d="M591.75,627.99c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89c0-.7-.39-1.32-.96-1.64-.28-.16-.6-.26-.94-.26-.67,0-1.25.34-1.59.85-.2.3-.31.66-.31,1.04Z"
                  fill="#292614"
                />
                <path
                  d="M605.53,631.57c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M555.91,605.8c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M602.01,661.03c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89v-.03c0-.45-.17-.87-.44-1.19-.34-.4-.84-.65-1.4-.67h-.07c-.6,0-1.14.27-1.48.71-.26.32-.42.73-.42,1.18Z"
                  fill="#292614"
                />
                <path
                  d="M566.58,612.44c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M580.26,589.98c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M588.22,602.77c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M552.38,591.68c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M596.58,608.66c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M589.85,633.5c0,1.05.86,1.89,1.9,1.89.71,0,1.32-.38,1.65-.95.13-.24.22-.5.24-.79c0-.05,0-.1,0-.15c0-.78-.48-1.46-1.18-1.75-.22-.09-.47-.14-.72-.14-.65,0-1.22.32-1.56.81-.22.31-.34.68-.34,1.08Z"
                  fill="#292614"
                />
                <path
                  d="M607.96,671.9c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M551.49,601.31c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M583.17,629.31c0,1.04.86,1.89,1.9,1.89.45,0,.86-.16,1.19-.42.4-.32.67-.8.7-1.34c0-.04,0-.09,0-.13c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M576.17,609.88c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M585.54,618.92c0,.39.11.76.32,1.06.34.5.92.83,1.58.83c1.05,0,1.9-.85,1.9-1.89c0-.83-.54-1.53-1.29-1.79-.19-.07-.4-.1-.61-.1-.67,0-1.25.34-1.6.86-.19.3-.3.65-.3,1.03Z"
                  fill="#292614"
                />
                <path
                  d="M544.33,601.03c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M592.26,606.23c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M560.94,616.1c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M602.74,646.71c0,.52.21.98.55,1.33.25.26.58.43.94.51.13.03.27.05.41.05.18,0,.35-.02.51-.07.29-.08.54-.22.75-.41.39-.34.64-.85.64-1.42c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M561.3,576.38c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M601.44,631.81c0,.22.04.43.1.61.25.71.89,1.23,1.68,1.27.04,0,.08,0,.11,0c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M606.27,654.44c0,.22.04.43.1.61.06.17.14.33.25.48.17.24.4.44.66.57.27.14.57.23.89.23c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89c-.54,0-1.04.23-1.39.59-.32.35-.51.8-.51,1.31Z"
                  fill="#292614"
                />
                <path
                  d="M606.22,661.99c0,.38.11.74.31,1.04.33.51.92.85,1.59.85.08,0,.15,0,.23-.02.94-.1,1.67-.9,1.67-1.87c0-.69-.38-1.3-.94-1.62-.29-.18-.61-.27-.96-.27-.85,0-1.57.55-1.81,1.31-.07.18-.09.38-.09.58Z"
                  fill="#292614"
                />
                <path
                  d="M592.62,602c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89c-.1,0-.19,0-.29.03-.36.05-.68.2-.95.41-.41.36-.67.88-.67,1.46Z"
                  fill="#292614"
                />
                <path
                  d="M591.1,598.68c0,1.05.86,1.89,1.9,1.89.1,0,.19,0,.29-.03.36-.05.68-.2.95-.41.41-.36.67-.88.67-1.46c0-1.04-.85-1.89-1.9-1.89s-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M605.37,659.79v.02c0,.45.17.87.44,1.19.14.17.31.31.5.41.28.18.61.27.96.27.85,0,1.56-.55,1.81-1.31.07-.18.09-.38.09-.58c0-.97-.73-1.77-1.67-1.87-.08-.02-.15-.02-.23-.02-.8,0-1.48.48-1.77,1.18-.09.22-.13.46-.13.71Z"
                  fill="#292614"
                />
                <path
                  d="M605.11,625.21c0,.26.05.49.14.72.15.38.43.69.78.9.29.18.62.27.98.27c1.06,0,1.9-.84,1.9-1.89c0-.82-.52-1.52-1.27-1.78-.2-.08-.41-.11-.63-.11s-.42.04-.61.1c-.75.26-1.29.96-1.29,1.79Z"
                  fill="#292614"
                />
                <path
                  d="M573.5,590.05c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M581.36,598.34c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M599.47,637.53c0,1.05.86,1.89,1.9,1.89.28,0,.56-.07.81-.18.54-.26.94-.75,1.05-1.34.03-.12.04-.25.04-.37c0-.66-.35-1.26-.87-1.6-.29-.19-.65-.29-1.03-.29-.35,0-.67.09-.96.26-.56.32-.94.94-.94,1.63Z"
                  fill="#292614"
                />
                <path
                  d="M603.56,637.19c0,.2.03.39.09.57.24.77.96,1.32,1.82,1.32.13,0,.28-.02.4-.04.24-.06.47-.15.66-.28.5-.34.84-.92.84-1.57c0-.43-.14-.81-.39-1.13-.34-.45-.89-.76-1.51-.76-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M604.51,649.95c0,.24.04.45.12.66v0c.28.72.97,1.23,1.78,1.23c1.05,0,1.9-.85,1.9-1.89s-.85-1.89-1.9-1.89c-.17,0-.34.02-.5.07-.29.08-.54.22-.75.41-.22.19-.38.42-.49.68v0c-.1.23-.15.47-.15.74Z"
                  fill="#292614"
                />
                <path
                  d="M606.98,667.68c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.07,0-.13,0-.2-.1-.95-.91-1.69-1.89-1.69-.16,0-.32.02-.47.07-.15.03-.3.09-.44.16v0c-.3.17-.55.41-.73.71-.16.28-.26.61-.26.95Z"
                  fill="#292614"
                />
                <path
                  d="M568.04,580.81c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M599.53,634.3c0,.67.35,1.27.88,1.6.29.19.65.29,1.02.29s.69-.09.97-.26c.56-.32.93-.93.93-1.63c0-.22-.04-.43-.1-.61-.25-.71-.89-1.23-1.68-1.27-.04,0-.08,0-.11,0-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M590.37,617.65c0,.6.28,1.13.7,1.48.32.26.74.42,1.2.42.12,0,.26,0,.37-.04v0c.87-.18,1.52-.94,1.52-1.85s-.65-1.67-1.52-1.85c-.12-.03-.25-.04-.38-.04-.25,0-.48.05-.69.13-.7.27-1.21.96-1.21,1.76Z"
                  fill="#292614"
                />
                <path
                  d="M605.13,621.63c0,.82.52,1.52,1.26,1.79.2.07.41.1.64.1.21,0,.41-.04.6-.09.75-.26,1.3-.95,1.3-1.8c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M600.6,657.96c0,1.01.82,1.84,1.82,1.89h.08c.6,0,1.13-.27,1.47-.71.16-.19.28-.42.35-.66.05-.16.08-.34.08-.52c0-.48-.19-.93-.48-1.27-.35-.38-.86-.62-1.42-.62-1.05,0-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M593.4,634.59c0,.6.28,1.13.7,1.48.33.26.75.42,1.2.42.34,0,.67-.09.94-.26.57-.32.96-.94.96-1.64c0-1.05-.86-1.89-1.9-1.89-.71,0-1.32.38-1.65.96-.13.24-.22.5-.24.79c0,.05,0,.09,0,.14Z"
                  fill="#292614"
                />
                <path
                  d="M584.21,634.41c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M590.06,614.04c0,.92.66,1.67,1.52,1.85.12.03.25.04.38.04.25,0,.48-.05.69-.13.71-.27,1.21-.96,1.21-1.76s-.48-1.46-1.16-1.74c-.19-.02-.37-.07-.54-.14v0c-.07,0-.12,0-.19,0-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M580.7,625.59c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M582.86,611.77c0,.73.41,1.36,1.02,1.67.27.14.56.22.88.22c1.05,0,1.9-.84,1.9-1.89s-.86-1.89-1.9-1.89c-.88,0-1.62.6-1.83,1.4-.05.15-.07.32-.07.49Z"
                  fill="#292614"
                />
                <path
                  d="M572.41,597.78c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M584.56,616.1c0,.82.53,1.53,1.28,1.79.19.07.4.1.62.1.67,0,1.25-.34,1.59-.86.2-.3.31-.65.31-1.03c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M577.58,628.65c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M601.36,614.17c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.36-.1-.7-.29-.98-.33-.55-.93-.91-1.62-.91-.04,0-.09,0-.12,0-1,.06-1.78.88-1.78,1.88Z"
                  fill="#292614"
                />
                <path
                  d="M599.5,617.78c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M602.37,627.54c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.26-.05-.5-.14-.72-.15-.38-.43-.69-.78-.9-.28-.17-.59-.26-.93-.27h-.05c-.82,0-1.5.5-1.78,1.21-.08.21-.12.44-.12.68Z"
                  fill="#292614"
                />
                <path
                  d="M593.99,647.36c0,1.04.86,1.89,1.9,1.89.61,0,1.15-.28,1.5-.73.2-.26.33-.56.38-.9c0-.08.02-.17.02-.26c0-.49-.18-.95-.49-1.28-.34-.38-.85-.61-1.41-.61-.45,0-.86.15-1.18.41-.44.35-.72.88-.72,1.48Z"
                  fill="#292614"
                />
                <path
                  d="M593.15,637.69c0,.5.19.95.51,1.3.35.36.85.59,1.39.59c1.05,0,1.9-.84,1.9-1.89c0-.6-.28-1.13-.71-1.47-.32-.26-.74-.43-1.19-.43-.34,0-.67.09-.95.26-.54.3-.9.86-.94,1.5c0,.04,0,.09,0,.12Z"
                  fill="#292614"
                />
                <path
                  d="M603.09,653.77c0,.54.23,1.03.6,1.37.27.26.61.43,1,.49.1.02.2.03.3.03.39,0,.75-.11,1.05-.31.12-.08.24-.18.33-.29.32-.33.51-.78.51-1.29c0-.23-.04-.43-.1-.63-.27-.74-.97-1.26-1.8-1.26-.66,0-1.24.33-1.57.83-.21.29-.33.66-.33,1.06Z"
                  fill="#292614"
                />
                <path
                  d="M567.89,619.86c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M595.57,630.93c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M572.62,616.14c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M562.02,598.83c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M604.86,664.9c0,1.05.86,1.89,1.9,1.89.16,0,.32-.02.48-.07.29-.07.56-.21.79-.41.14-.13.28-.28.38-.46.16-.28.26-.61.26-.95c0-.17-.02-.33-.07-.48-.05-.2-.13-.39-.25-.56-.33-.51-.92-.85-1.59-.85-.08,0-.15,0-.23.02-.94.11-1.67.91-1.67,1.87Z"
                  fill="#292614"
                />
                <path
                  d="M602.14,639.6c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.2-.03-.39-.09-.56-.24-.78-.96-1.33-1.82-1.33-.13,0-.28.02-.4.05-.14.03-.28.08-.41.14-.54.25-.94.75-1.05,1.34-.03.11-.04.24-.04.36Z"
                  fill="#292614"
                />
                <path
                  d="M571.39,608.07c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M589.01,630.67c0,.56.25,1.07.64,1.41.16.14.34.26.54.34.22.09.47.14.72.14.65,0,1.22-.32,1.56-.81.22-.31.34-.68.34-1.08c0-1.05-.86-1.89-1.9-1.89-.62,0-1.16.28-1.51.73-.25.33-.39.73-.39,1.16Z"
                  fill="#292614"
                />
                <path
                  d="M597,602.31c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M589.87,638.86c0,1.05.86,1.89,1.9,1.89s1.82-.77,1.89-1.76c0-.04,0-.09,0-.13c0-.5-.19-.96-.51-1.3-.35-.37-.85-.6-1.39-.6-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M600.65,624.97c0,1.02.82,1.86,1.84,1.89h.06c.81,0,1.49-.5,1.77-1.21.09-.21.13-.44.13-.68c0-1.05-.86-1.89-1.9-1.89s-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M591.11,625.3c0,.71.39,1.32.96,1.65.28.16.6.25.94.25.66,0,1.24-.33,1.59-.84.2-.3.31-.66.31-1.05c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M593.9,622.53c0,1.04.85,1.89,1.9,1.89.55,0,1.06-.24,1.4-.62.32-.33.5-.78.5-1.27c0-.23-.04-.44-.11-.63-.26-.74-.96-1.26-1.79-1.26-1.05,0-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M585.56,625.26c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M605.85,643.78c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M603.84,657.21c0,.49.18.94.48,1.27.29.33.71.56,1.18.6.08.02.16.02.24.02.8,0,1.48-.48,1.76-1.18.1-.22.14-.45.14-.71c0-.42-.13-.79-.36-1.11-.17-.24-.4-.42-.66-.57-.18-.09-.37-.16-.58-.19-.1-.02-.2-.03-.3-.03-.39,0-.75.11-1.06.31-.37.25-.65.62-.77,1.06-.05.16-.08.34-.08.52Z"
                  fill="#292614"
                />
                <path
                  d="M586.25,630.93c0,1.04.85,1.89,1.9,1.89.61,0,1.16-.29,1.5-.74.25-.32.4-.72.4-1.15c0-.57-.25-1.08-.65-1.42-.33-.29-.77-.47-1.25-.47-.45,0-.86.15-1.19.41-.4.32-.67.8-.7,1.34c0,.05,0,.09,0,.14Z"
                  fill="#292614"
                />
                <path
                  d="M572.52,621.11c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M594.3,641.93c0,.51.19.96.5,1.3.35.37.85.6,1.4.6.5,0,.96-.19,1.3-.51.37-.35.6-.84.6-1.38c0-1.04-.86-1.89-1.9-1.89s-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M600.38,642.95c0,.3.07.59.2.84.25.49.69.86,1.24.99.15.04.3.06.47.06c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M598.21,645.61c0,.52.22.99.56,1.34.34.34.82.55,1.34.55.17,0,.34-.02.5-.08.81-.21,1.4-.95,1.4-1.82c0-.3-.07-.58-.19-.83-.25-.49-.68-.86-1.24-.99-.15-.05-.31-.07-.48-.07-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M597.09,623.19c0,.22.04.43.1.61.26.74.96,1.28,1.8,1.28c1.05,0,1.9-.85,1.9-1.89s-.86-1.89-1.9-1.89c-.55,0-1.06.24-1.41.6-.3.34-.49.79-.49,1.29Z"
                  fill="#292614"
                />
                <path
                  d="M589.56,620.98c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89c0-.6-.28-1.13-.7-1.48v0c-.33-.26-.74-.42-1.19-.42-.13,0-.26,0-.38.04-.86.18-1.52.95-1.52,1.85Z"
                  fill="#292614"
                />
                <path
                  d="M577.1,601.42c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M590.99,610.42c0,.78.48,1.46,1.16,1.74v0c.17.08.35.12.54.14.06,0,.12,0,.19,0c1.05,0,1.9-.85,1.9-1.89s-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M566.32,606.34c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M597.37,648.78c0,.52.22.99.56,1.33v0c.34.35.81.56,1.33.56.08,0,.14,0,.21,0c.69-.08,1.26-.52,1.53-1.12.03-.15.08-.29.13-.43.02-.11.03-.23.03-.34c0-.53-.22-1-.56-1.35-.35-.33-.82-.54-1.34-.54-.17,0-.34.02-.5.07-.41.11-.76.35-1,.67-.2.26-.33.56-.38.9c0,.09-.02.17-.02.26Z"
                  fill="#292614"
                />
                <path
                  d="M569.94,602.15c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M596.23,651.99c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.53-.22-.99-.55-1.33-.34-.34-.83-.56-1.35-.56-.07,0-.13,0-.19,0v0c-.95.1-1.7.9-1.7,1.88Z"
                  fill="#292614"
                />
                <path
                  d="M600.98,649.89c0,1.04.85,1.89,1.9,1.89.79,0,1.46-.48,1.75-1.15v0c.1-.24.15-.48.15-.74c0-.24-.05-.45-.12-.66v0c-.1-.26-.25-.48-.43-.67-.25-.26-.58-.43-.94-.51-.13-.03-.27-.05-.41-.05-.78,0-1.44.46-1.74,1.13-.06.13-.1.27-.13.43-.02.11-.03.23-.03.34Z"
                  fill="#292614"
                />
                <path
                  d="M607.96,665.83c0,.07,0,.13.01.19v0c0,.11.03.21.06.3.22.8.96,1.4,1.83,1.4.33,0,.65-.09.91-.24.59-.32.99-.95.99-1.65c0-1.04-.85-1.89-1.9-1.89-.48,0-.93.19-1.26.48-.39.35-.64.85-.64,1.41Z"
                  fill="#292614"
                />
                <path
                  d="M576.9,615.38c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M580.14,612.96c0,1.04.86,1.89,1.9,1.89.88,0,1.62-.6,1.83-1.4.05-.15.07-.32.07-.49c0-.73-.41-1.36-1.02-1.67-.27-.14-.56-.22-.88-.22-1.05,0-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M582.38,621.04c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89c0-.4-.11-.77-.32-1.06-.34-.5-.92-.83-1.58-.83-1.05,0-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M594.74,616.91c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M596.54,613.41c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M590.39,593.34c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M602.86,611.3c0,.36.1.7.28.98.33.54.93.91,1.63.91.04,0,.08,0,.11,0c1-.06,1.79-.88,1.79-1.88s-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M600.21,654.08c0,1.05.86,1.89,1.9,1.89.66,0,1.24-.33,1.58-.83.21-.3.32-.67.32-1.06c0-.54-.23-1.03-.59-1.37-.34-.32-.8-.52-1.31-.52-1.05,0-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M577.91,621.96c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M575.13,583.26c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M594.2,644.6c0,.49.18.95.5,1.28.34.38.85.61,1.4.61.46,0,.87-.15,1.19-.41.44-.35.71-.88.71-1.48c0-.5-.19-.96-.5-1.29-.35-.37-.85-.61-1.4-.61-.5,0-.96.19-1.3.52-.37.34-.6.83-.6,1.37Z"
                  fill="#292614"
                />
                <path
                  d="M605.21,616.59c0,1.05.85,1.89,1.9,1.89s1.9-.84,1.9-1.89-.86-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M585.35,592.5c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.85-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M559.96,607.06c0,1.04.86,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M584.09,606.14c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M563.46,588.77c0,1.05.86,1.89,1.9,1.89s1.9-.84,1.9-1.89-.85-1.89-1.9-1.89-1.9.85-1.9,1.89Z"
                  fill="#292614"
                />
                <path
                  d="M544.41,586.47c0,1.04.85,1.89,1.9,1.89s1.9-.85,1.9-1.89-.86-1.89-1.9-1.89-1.9.84-1.9,1.89Z"
                  fill="#292614"
                />
              </g>
              <path
                d="M612.12,807.23c-.36,6.85-.97,13.64-1.76,20.38h4.53c.78-7.29,1.32-14.59,1.62-21.8.08-2,.16-4,.22-5.98c0-.26.02-.54.02-.8.02-.38.03-.77.03-1.14.12-4.38.2-8.76.23-13.13c0-.68,0-1.37,0-2.05.05-7.17,0-14.33-.11-21.49-.02-1.48-.04-2.97-.07-4.44-.07-3.93-.14-7.87-.22-11.8-.02-1.17-.04-2.35-.07-3.54c0-.47-.02-.95-.03-1.42-.09-4.47-.17-8.95-.25-13.43c0-.02,0-.04-.02-.06c0-.02,0-.03.02-.05v0c-.08-4.97-.14-9.93-.17-14.88-.07-11.21-.07-22.44-.1-33.67-.02-7.36-.06-14.7-.14-22.05-.95,2.73-1.77,5.61-2.28,8.52.02,4.11,0,8.24,0,12.35c0,3.89-.02,7.77-.04,11.66v0c-.02,2.74-.03,5.48-.04,8.22v0c0,.21,0,.4,0,.59c0,0,0,.02,0,.02c0,2.05-.02,4.09-.02,6.14v.04c0,.98,0,1.96,0,2.94v0c0,3.65,0,7.29,0,10.92c0,1.04,0,2.09,0,3.13v3.22c.02,5.07.03,10.13.02,15.18-.02,21.4-.23,42.8-1.16,64.18-.03.65-.06,1.3-.09,1.96-.04.77-.08,1.53-.11,2.3Zm3.87-44c.02-.2.03-.39.05-.59l-.02.51c0,0-.03.05-.03.08Zm-.48-34.21c.02-.19.04-.38.06-.57.02.07.03.14.04.21-.03.12-.07.24-.09.36Zm-.42-23.49c0,0,.02.09.03.13c0,0,0,.03,0,.04c0-.06,0-.11-.02-.17Z"
                fill="#faede1"
              />
              <path
                d="M615.85,655.88c.09,7.35.12,14.69.14,22.05c4.08-13.69,9.98-24.95,17.09-37.95c1.82-3.33,3.67-6.73,4.27-10.48.9-5.54-1.02-11.1-1.94-16.64-3.53-21.12,7.38-41.55,14.52-61.75-2.41-8.06-5.05-15.84-7.86-23.24-.44,1.46-.95,2.89-1.51,4.3-1.12,2.8-2.5,5.63-2.46,8.65.03,2.57,1.08,5,1.63,7.52c2.86,13.02-7.64,24.92-10.78,37.88-2.96,12.19.76,25.1-1.21,37.5-1.58,10-6.73,19.02-10.5,28.42-.48,1.21-.96,2.45-1.4,3.73Z"
                fill="#190f07"
              />
              <path
                d="M564.41,483.49c-6.91,23.03,5.45,44.78,21.03,61.26c2.19,2.36,4.41,4.68,6.59,6.97s4.32,4.55,6.34,6.8c1.9,2.84,3.33,5.91,3.92,8.98s.36,6.15-1.07,8.98c-1.9,1.89-4.75,2.84-7.6,1.89-13.46-7.09-28.25-15.5-36.1-27.95-1.57-2.49-2.86-5.14-3.82-7.98-.63-2.84-.98-5.67-1.12-8.55-.78-16.98,3.02-34.95,11.82-50.41v0Z"
                fill="#af966e"
              />
              <path
                d="M634.44,542.13c7.17,25.39-3.75,23.36-9.36,43.55.31-9.92,6.42-32.93,9.36-43.55v0Z"
                fill="#af966e"
              />
              <path
                d="M611.92,696.21c-1.25-3.24-2.94-6.43-4.46-9.56-1.12-2.3-2.55-4.43-2.53-7.04c0-.29.32-.47.57-.33c5.23,2.91,6.03,11.64,6.64,16.9.02.13-.18.14-.22.03v0Z"
                fill="#190f07"
              />
              <path
                d="M600.28,669.27c-1.6-2.27-3.99-5.08-4.4-7.9-.1-.72.7-1.34,1.3-.75c2.08,2.02,2.97,5.64,3.89,8.32.17.49-.53.71-.79.33v0Z"
                fill="#190f07"
              />
              <path
                d="M591.23,654.57c-1.05-1.12-2.33-2.38-2.9-3.82-.11-.29.29-.6.54-.41c1.26.91,2.15,2.46,2.97,3.76.23.37-.31.79-.61.47v0Z"
                fill="#190f07"
              />
              <path
                d="M610.93,582.77c0,0-.04-.07,0-.07s.04.07,0,.07v0Z"
                fill="#faede1"
              />
              <path
                d="M610.59,581.95c-3.39-11.39-7.4-22.66-14.27-32.48-3.21-4.58-6.92-8.77-9.97-13.46-3.14-4.84-5.68-9.96-8.14-15.17-.05-.11.11-.21.17-.1c2.97,5.21,5.85,10.52,9.17,15.51c3.25,4.89,7.23,9.25,10.49,14.13c6.35,9.51,10.34,20.4,12.83,31.48.04.18-.23.26-.28.08v0Z"
                fill="#faede1"
              />
              <path
                d="M613.58,629.12c2.81-12.68,4.42-25.09,4.86-38.07c0-.17.25-.17.27,0c.98,12.67-.72,26.11-4.93,38.12-.04.12-.22.07-.19-.05v0Z"
                fill="#faede1"
              />
            </g>
          </g>
          <g
            transform="matrix(.975169 0.221463-.221463 0.975169 96.153933-231.351563)"
          >
            <g>
              <path
                d="M361.64,523.76c.46.33.86.61,1.27.9.73-.26,1.44-.49,2.13-.77c5.29-2.16,10.81-3.62,16.28-5.2c2.21-.64,4.47-.93,6.79-.81.98.05,1.99.03,2.96-.14c2.17-.37,4.32-.22,6.48-.04.68.06,1.36.07,2.04.03c1.6-.1,2.89.43,3.91,1.7c2.58,3.2,4.84,6.6,6.64,10.29c1.19,2.45,2.27,4.97,3.57,7.36c1.88,3.44,2.76,7.14,3.34,10.96.4,2.63.79,5.27,1.43,7.84.84,3.42,1,6.85.74,10.32-.2,2.65-.62,5.27-.06,7.95.52,2.47-.14,4.94-.43,7.39-.38,3.2-.86,6.39-1.35,9.57-.26,1.65-.55,3.31-.99,4.91-.66,2.42-.75,4.87-.85,7.35-.09,2.21-.63,4.41-1.03,6.6-.37,2-.8,4-1.28,5.98-.71,2.95-1.5,5.87-2.21,8.82-.62,2.58-1.18,5.18-1.77,7.78-.48,2.11-.91,4.24-1.47,6.33-1.13,4.18-2.3,8.35-3.54,12.5-.67,2.25-1.61,4.43-2.26,6.68-.83,2.85-1.65,5.71-2.19,8.62-.36,1.93-.3,3.95-.27,5.93.05,3.63-.42,7.17-1.65,10.59-.7,1.92-1.29,3.88-2.09,5.75-.92,2.16-2.39,3.88-4.55,4.97-1.01.51-1.93.53-2.78-.15-.86-.69-1.77-1.39-2.41-2.26-2.09-2.88-3.58-6.08-4.66-9.48-1.03-3.25-2.12-6.46-3.64-9.55-.81-1.64-1.3-3.52-1.5-5.34-.52-4.63-2.11-8.89-3.94-13.12-2.23-5.18-4.33-10.42-6.39-15.67-1.14-2.9-2.38-5.72-4.07-8.35s-2.76-5.53-3.83-8.46c-1.87-5.12-3.82-10.22-5.86-15.28-1.29-3.19-2.07-6.48-2.59-9.86-.46-3-1.04-5.98-1.66-8.95-.53-2.56-.86-5.1-.76-7.74.11-2.84-.07-5.69-.09-8.53-.01-1.43-.05-2.86.09-4.27.45-4.88.83-9.78,1.52-14.63.36-2.55,1.31-5.02,1.99-7.53.55-2.03.91-4.13,1.66-6.08c1.72-4.45,3.48-8.91,6.57-12.65.73-.88,1.3-2.01,2.75-2.28Z"
                fill="#549e88"
              />
              <path
                d="M388.53,440.31c.67.44,1.13.73,1.59,1.05c1.87,1.33,3.24,2.92,3.82,5.28.64,2.57,1.68,5.05,2.57,7.56.9,2.53,1.5,5.11,1.43,7.81-.02.78-.16,1.57-.26,2.57-.73-.04-1.29.05-1.74-.12-2.25-.84-4.58-.84-6.94-.96-5.05-.24-9.99.82-15,.96-1.24.03-2.48.21-3.71.15-1.87-.09-3.54.46-5.09,1.28-.48.97-.55,1.71-1.45,1.8-.8.08-1.19-.47-1.65-1.01-.8-.94-.72-2.1-.85-3.17-.55-4.54-.41-9.06,1.46-13.31c1.42-3.21,3.55-5.96,6.29-8.19.43-.35.97-.55,1.46-.83-.57-1.69-1.02-3.03-1.48-4.38-1.25-3.7-2.59-7.37-3.71-11.11-.74-2.49-1.25-5.05-1.71-7.61-.98-5.44-2.22-10.81-4.03-16.04-.37-1.05-.66-2.13-.9-3.22-1.05-4.85-2.12-9.69-3.08-14.56-1.09-5.51-2.61-10.85-5.25-15.83-1.32-2.49-2.18-5.14-2.82-7.86-.54-2.31-1.39-4.49-2.45-6.61-.96-1.94-1.69-4-2.55-5.99-.74-1.71-1.47-3.41-2.28-5.09-.53-1.11-1.19-2.06-2.33-2.78-.86-.54-1.55-1.65-1.92-2.65-.8-2.21-1.52-4.48-1.93-6.78-.24-1.35.05-2.84.32-4.23.23-1.19,1.12-1.69,2.35-1.69c1.51,0,2.75.5,3.72,1.74c2.94,3.72,4.06,7.75,2.33,12.33-.06.17-.08.36-.11.52c1.98,3.68,3,7.37,4.61,10.77c1.95,4.12,3.45,8.35,4.6,12.74.4,1.54,1.12,3.03,1.85,4.46c2.81,5.47,4.28,11.33,5.51,17.31c1.32,6.43,2.55,12.88,4.51,19.18c1.49,4.78,2.43,9.74,3.45,14.65.6,2.86,1.25,5.67,2.3,8.41c1.36,3.53,2.52,7.13,3.78,10.7.14.4.33.78.53,1.26c3.66-1.09,7.25-1.18,10.92.2.36-.82.71-1.6,1.04-2.39c2.36-5.53,4.85-11.01,7.02-16.62c2.73-7.05,5.41-14.13,7.73-21.32c3.15-9.76,7.2-19.14,11.19-28.56c2.19-5.19,4.11-10.51,6.24-15.73c2.04-5,4.38-9.86,7.2-14.48.55-.9,1.05-1.83,1.58-2.74.66-1.14,1.12-2.25.87-3.68-.16-.93.06-2,.37-2.93.88-2.61,2.54-4.82,4.17-6.98c1.62-2.17,4.94-1.69,5.98,1.37.27.78.3,1.74.13,2.56-.64,3.18-2.08,5.97-4.54,8.14-.64.56-1.43.94-2.33,1.52-4.22,7.03-8.39,14.32-11.22,22.35-2,5.66-4.42,11.19-6.89,16.67-4.29,9.52-7.64,19.37-10.89,29.26-2.73,8.31-5.99,16.42-9.51,24.43-1.5,3.4-2.84,6.86-4.3,10.42Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M387.11,444.49c.2.31.33.69.6.92c1.15,1.01,1.06,2.28.78,3.58-.34,1.61-1.83,2.23-3.26,1.41-1.82-1.06-2.3-3.18-1.11-4.91.27-.4.51-.82.77-1.23.74.08,1.48.16,2.22.24Z"
                  fill="#ffece5"
                />
                <path
                  d="M372.62,445.58c1.34.16,2.25,1.27,2.08,2.53-.22,1.61-1.97,3.1-3.46,2.94-1.42-.15-2.3-1.24-2.15-2.66.16-1.54,1.98-2.99,3.52-2.81Z"
                  fill="#ffece5"
                />
              </g>
              <g>
                <path
                  d="M372.79,568.64c-.13-1.07-.96-1.61-2.37-1.49-.92.08-1.83.28-2.75.36-3.31.3-6.62.57-9.93.87-.36.03-.73.14-1.07.28-.97.42-1.39,1.14-1.22,2.05.15.77.99,1.58,1.92,1.71.22-.03.58-.07.95-.11c2.75-.32,5.5-.66,8.26-.96c1.47-.16,2.95-.18,4.4-.41c1.43-.23,1.96-1.02,1.81-2.31Z"
                  fill="#ffece5"
                />
                <path
                  d="M390.84,583.02c-.56-.96-1.83-1.15-3.13-.27-2.07,1.39-4.42,1.89-6.81,2.28-1.46.24-2.95.38-4.4.68-1.19.24-1.65.97-1.57,2.16.07,1.01.64,1.49,2.05,1.63.09,0,.35.05.59.01c2.38-.43,4.79-.72,7.11-1.35c1.77-.48,3.5-1.26,5.12-2.14c1.25-.67,1.57-2.07,1.03-3Z"
                  fill="#ffece5"
                />
                <path
                  d="M378.08,605.05c-.23-.19-.53-.31-.81-.47-.32.09-.63.15-.9.28-1.87.88-3.79,1.46-5.9,1.26-.6-.06-1.23.1-1.82.27-.84.24-1.48,1.07-1.46,1.74.02.72.8,1.61,1.61,1.84c1.84.04,3.36.22,4.78-.06c1.6-.32,3.3-.62,4.58-1.87c1.04-1.02,1.04-2.04-.08-2.98Z"
                  fill="#ffece5"
                />
                <path
                  d="M402.5,617.38c-.8.09-1.58.3-2.38.42-3.43.52-6.86,1.01-10.28,1.55-1.23.19-2.01,1.07-1.98,2.09.03,1.01.65,1.5,2.53,1.69.47-.05,1.4-.11,2.31-.25c2.26-.35,4.51-.73,6.76-1.12c1.28-.22,2.58-.4,3.83-.74c1.17-.32,1.83-1.43,1.6-2.39-.22-.9-1.12-1.4-2.4-1.25Z"
                  fill="#ffece5"
                />
                <path
                  d="M389.88,657.58c-.64-.09-1.35.06-1.98.25-2.48.74-4.95,1.55-7.65,2.4-.18.27-.44.55-.58.88-.63,1.5.07,2.63,1.71,2.61.72,0,1.45-.23,2.15-.45c1.82-.57,3.63-1.16,5.42-1.81.68-.25,1.39-.59,1.89-1.09c1.01-1.01.46-2.59-.96-2.78Z"
                  fill="#ffece5"
                />
                <path
                  d="M394,673.41c-.76.15-1.52.47-2.2.84-.67.37-.81,1.1-.65,1.8.16.73.68,1.17,1.45,1.23.67.05,1.38.16,2.02.03c1.59-.31,3.17-.68,4.75-1.05.11-1.2.18-2.41.16-3.64-.19-.03-.37-.02-.59.02-1.64.29-3.3.45-4.94.76Z"
                  fill="#ffece5"
                />
                <path
                  d="M405.46,534.26c.27.91,1.16,1.54,2.11,1.43c1.71-.21,3.41-.44,5.12-.67-.6-1.22-1.2-2.44-1.78-3.68-1.45.25-2.89.51-4.3.88-.98.26-1.39,1.25-1.15,2.04Z"
                  fill="#ffece5"
                />
                <path
                  d="M412.25,542.48c-2.38.65-4.81,1.13-7.23,1.67-1.15.26-2.32.43-3.44.79-1.03.33-1.44,1.08-1.3,1.99.13.87,1.01,1.7,1.96,1.79.12,0,.31.01.49-.02c2.97-.62,5.97-1.15,8.91-1.9c1.73-.44,3.36-1.14,4.79-2.19-.33-1.5-.75-2.97-1.29-4.4-.71,1.11-1.67,1.94-2.89,2.28Z"
                  fill="#ffece5"
                />
                <path
                  d="M357.91,538.03c1.29.14,2.57.3,3.87.4c1.19.09,2.27-.64,2.4-1.55.14-.92-.73-1.92-1.9-2.12-2.59-.44-5.13-1.2-7.83-.87-.66,1.11-1.11,2.19-1.53,3.28.3.23.71.39,1.31.47c1.22.16,2.45.27,3.68.4Z"
                  fill="#ffece5"
                />
                <path
                  d="M355.2,556.55c1.9.02,3.81-.35,5.7-.65c1.16-.18,2.33-.42,3.41-.84c1.72-.67,2.01-1.3,1.85-3.36-.64-.73-1.44-1.29-2.42-.79-1.7.86-3.56.98-5.36,1.38-3.28.73-6.5.61-9.69-.15-.21,1.39-.36,2.63-.5,3.86c2.32.31,4.67.52,7.01.54Z"
                  fill="#ffece5"
                />
                <path
                  d="M413.07,570.11c-1.16.19-2.31.45-3.48.58-1.59.18-3.19.27-4.78.41-.61.05-1.25.05-1.83.23-1.35.41-1.81,1.92-.84,2.93.47.49,1.21.72,1.64.97.91-.04,1.53-.03,2.14-.11c1.83-.23,3.67-.45,5.49-.75c2.14-.34,4.29-.66,6.39-1.17.4-.1.79-.24,1.18-.37-.14-1.41-.07-2.81.05-4.21-2.05.89-4.01,1.17-5.96,1.49Z"
                  fill="#ffece5"
                />
                <path
                  d="M406.15,595.68c-1.22.2-2.2.76-3,1.84.48,2.23,1.24,2.69,3.23,2.16c1.55-.41,3.12-.75,4.69-1.08c1.66-.35,3.34-.65,5-1c.09-.52.2-1.04.34-1.56.21-.78.39-1.57.55-2.37-1.47.29-2.77.56-4.06.8-2.25.42-4.5.83-6.75,1.21Z"
                  fill="#ffece5"
                />
                <path
                  d="M391.3,563.88c1.03-.16,2.08-.21,3.13-.24c2.21-.06,4.43-.04,6.64-.15.65-.03,1.35-.28,1.9-.62c1.19-.74,1.25-1.81.19-2.73-.34-.3-.86-.53-1.31-.56-.98-.07-1.96,0-2.95.03-2.58.08-5.16.13-7.74.28-2.15.12-2.59.68-2.57,3.01.76.9,1.63,1.15,2.71.99Z"
                  fill="#ffece5"
                />
                <path
                  d="M405.66,640.84c-1.12.35-2.22.77-3.36,1.04-1.56.37-3.15.63-4.73.93-1.24.23-2.42.55-3.18,1.84.61,2.22.95,2.53,2.94,2.17c2.25-.41,4.47-.94,6.69-1.47.73-.17,1.46-.4,2.17-.65.36-1.29.71-2.58,1.07-3.87-.44-.17-.98-.18-1.59.01Z"
                  fill="#ffece5"
                />
                <path
                  d="M357.07,590.35c1.04-.49,1.86-1.21,2.04-2.39-1.17-1.86-1.55-1.96-3.51-1.32-1.94.64-3.88,1.31-5.86,1.76-.52.12-1.05.23-1.58.34.26,1.26.5,2.53.74,3.8c2.03-.43,4.03-1.04,6.08-1.42.72-.14,1.42-.45,2.09-.77Z"
                  fill="#ffece5"
                />
                <path
                  d="M390.67,684.66c-.42-1.05-1.3-1.51-2.38-1.2-.95.28-1.86.69-2.82.93-.99.24-1.98.46-2.97.67.49,1.2,1.06,2.37,1.69,3.5c1.84-.51,3.68-1.04,5.51-1.62c1-.32,1.34-1.4.98-2.3Z"
                  fill="#ffece5"
                />
                <path
                  d="M374.61,551.51c.55.53,1.18.88,2.01.76.61-.08,1.23-.02,1.84-.08c1.66-.18,3.31-.36,4.96-.59.91-.13,1.41-.71,1.49-1.63.16-1.22-.31-1.92-1.53-2.09-.6-.08-1.23,0-1.84.05-1.66.11-3.32.2-4.98.36-.54.05-1.12.17-1.59.42-1.12.6-1.28,1.93-.37,2.81Z"
                  fill="#ffece5"
                />
                <path
                  d="M379.06,646.16c1.42-.6,2.85-1.22,4.18-1.99.89-.51,1.06-1.56.65-2.45-.42-.9-1.25-1.24-2.34-.91-.59.18-1.15.45-1.7.73-1.78.9-3.6,1.72-5.6,1.88-2.02.17-4.06.13-6.1.21.41,1.37.96,2.72,1.52,4.08.4-.02.81-.03,1.22-.06c2.78-.17,5.56-.4,8.17-1.49Z"
                  fill="#ffece5"
                />
                <path
                  d="M371.77,627.67c.86-.44,1.24-1.7.88-2.57-.33-.8-1.12-1.14-2.18-.93-.18.03-.35.12-.53.16-3.38.82-6.77,1.63-10.25,1.52.58,1.35,1.24,2.67,2.03,3.93c2.56-.3,5.1-.75,7.64-1.18.84-.14,1.65-.53,2.42-.92Z"
                  fill="#ffece5"
                />
              </g>
              <path
                d="M352.38,492.84c.54-3.42.82-6.91,1.69-10.25.76-2.91,2.03-5.71,3.33-8.45c1-2.11,2.33-4.08,3.63-6.04c1.71-2.56,4.15-4.21,7.05-5.19c1.94-.66,3.87-1.32,5.82-1.95c5.63-1.85,11.26-2.18,16.93-.13c1.79.65,3.73.92,5.52,1.57c3.84,1.39,6.86,3.9,9.28,7.16.66.89,1.17,1.92,1.93,2.72c2.33,2.46,3.5,5.49,4.7,8.57c1.81,4.63,2.35,9.46,2.48,14.36.04,1.29-.19,2.6-.36,3.89-.55,4.17-.99,8.37-1.73,12.51-.71,3.98-2.17,7.73-4.35,11.18-1.09,1.72-2.01,3.56-3.07,5.3-1.77,2.91-3.54,5.87-6.32,7.95-3.37,2.52-7.2,4.12-11.26,5.13-.98.24-2.1.11-3.13-.03-1.96-.28-3.9-.64-5.84-1.06-2.47-.54-4.57-1.88-6.6-3.31-.96-.68-1.97-1.3-2.88-2.04-1.15-.93-2.25-1.92-3.31-2.95-.93-.91-1.88-1.83-2.62-2.88-1.53-2.17-3.03-4.38-4.38-6.67-1.66-2.82-3.48-5.55-4.68-8.64-.93-2.4-1.32-4.89-1.61-7.42-.03-.25,0-.5-.04-.74-.88-4.19-.74-8.37-.18-12.59Z"
                fill="#ffaa9c"
              />
              <g>
                <path
                  d="M397.63,478.87c-2.13-.22-3.85.76-4.84,2.66-.96,1.83-.94,3.82-1.15,5.77-.09,1.05-.33,2.11-.23,3.14.12,1.27.35,2.58.82,3.75.69,1.69,2.49,2.15,4.03,1.16c1.25-.82,2.4-1.79,2.99-3.22.66-1.59,1.26-3.2,1.86-4.82.89-2.38.41-4.59-.81-6.75-.62-1.09-1.48-1.57-2.67-1.7Z"
                  fill="#ff7159"
                />
                <path
                  d="M412.39,494.23c.06-1.66-.41-3.19-1.36-4.53-.96-1.35-2.29-1.63-3.73-.81-.88.5-1.49,1.21-1.95,2.15-.95,1.99-.76,4.08-.78,6.18-.02,1.78.37,3.44,1.08,5.03.23.52.7,1.14,1.2,1.3c2.2.72,3.96-.09,4.49-1.99.43-1.54.67-3.13,1-4.69-.1-.9.01-1.76.04-2.62Z"
                  fill="#ff7159"
                />
                <path
                  d="M379.21,514.76c-1.71.14-3.1.87-3.64,2.66-.27.88-.45,1.78-.67,2.68-.21,2.52.32,4.83,1.68,6.93c1.06,1.63,3.9,1.76,4.96.18.99-1.48,1.86-3.03,1.96-4.92.09-1.72-.29-3.32-.88-4.88-.67-1.8-1.87-2.76-3.4-2.63Z"
                  fill="#ff7159"
                />
                <path
                  d="M368.06,527.87c.03-.25.04-.49.06-.74.02-1.66.06-3.33-.05-4.99-.13-1.86-.6-3.66-1.48-5.32-.83-1.57-2.34-2.42-3.74-2.2-1.67.27-2.37,1.17-2.97,3.11-.57,1.85-.61,3.68-.35,5.49c1.18,1.93,2.44,3.82,3.75,5.67.56.79,1.23,1.49,1.92,2.18.17-.02.34,0,.51-.04c1.44-.35,2.16-1.32,2.35-3.15Z"
                  fill="#ff7159"
                />
                <path
                  d="M396.69,527.94c-.93-1.49-2.36-2.34-4.18-2.37-1.74-.03-2.68.74-2.82,2.49-.08,1.04,0,2.1.11,3.14.26,2.75,1.13,5.32,2.61,7.65.14.21.29.41.45.59c2.06-.86,4.03-1.92,5.86-3.26-.14-1.63-.25-3.26-.57-4.85-.23-1.19-.8-2.36-1.45-3.39Z"
                  fill="#ff7159"
                />
                <path
                  d="M376.36,533.02c-1.79-.01-3.31.82-4.07,2.67-.13.32-.25.65-.34.97c2.18,1.53,4.28,2.87,6.74,3.41.81.18,1.63.34,2.45.49-.08-1.67-.55-3.21-1.2-4.76-.68-1.63-1.86-2.78-3.58-2.79Z"
                  fill="#ff7159"
                />
                <path
                  d="M357.99,505.6c1.21-2.1,1.56-4.39,1.71-6.76.13-1.97-.21-3.81-1.05-5.58-1.32-2.76-3.64-3.87-5.86-3.27-.13.95-.26,1.91-.41,2.85-.56,4.21-.71,8.4.18,12.59.05.24.01.5.04.74.06.55.14,1.09.21,1.64.33.12.7.19,1.09.2c1.79.04,3.16-.82,4.08-2.42Z"
                  fill="#ff7159"
                />
                <path
                  d="M361.64,484.68c.82.26,1.55.09,2.01-.53c1.61-2.15,2.79-4.51,3.08-7.23c0-.25.05-.5.02-.74-.12-1.04-.18-2.1-.42-3.11-.26-1.07-.57-2.16-1.07-3.14-1.03-1.99-2.8-2.34-4.64-1.05-1.28,1.78-2.37,3.47-3.22,5.26-.2.42-.39.84-.59,1.26.04,1.74.4,3.44.94,5.1.62,1.93,1.78,3.52,3.89,4.18Z"
                  fill="#ff7159"
                />
                <path
                  d="M388.57,499.88c-1.5.12-2.75.8-3.15,2.42-.29,1.19-.5,2.41-.74,3.62-.2,2.4.04,4.71.98,6.94.51,1.21,1.43,1.93,2.72,1.89c1.69-.06,3.06-.71,3.89-2.36.87-1.72.94-3.56,1.12-5.41.19-1.88-.37-3.58-1.25-5.15-.74-1.32-2.02-2.07-3.56-1.94Z"
                  fill="#ff7159"
                />
                <path
                  d="M376.41,495.59c-.27-.6-.72-1.16-1.21-1.61-.82-.76-1.88-.9-2.72-.19-1.4,1.18-2.88,2.31-3.49,4.2-.91,2.77-.47,5.49.19,8.21.08.35.27.7.46,1.01c1.29,2.07,3.58,2.31,5.08.39c1.42-1.82,2.47-3.85,2.67-6c.17-2.24-.14-4.19-.98-6.02Z"
                  fill="#ff7159"
                />
                <path
                  d="M393.48,466.95c-.28,1.32.08,2.83.39,4.21.14.62.82,1.13,1.23,1.65c3.01-.79,4.83-2.41,5.35-5.32.19-1.07.14-2.09-.09-3.07-1.22-.82-2.55-1.5-3.99-2.02-1.76,1.06-2.49,2.75-2.88,4.55Z"
                  fill="#ff7159"
                />
                <path
                  d="M406.67,509.94c-1.38-1.5-3.29-.97-3.9.97-.36,1.17-.57,2.4-.84,3.6-.24,3.37.85,6.36,2.39,9.23.38.71.96,1.07,1.77,1.18.35.05.67.03.97,0c.4-.72.8-1.43,1.24-2.13.74-1.18,1.37-2.4,1.95-3.64-.01-1.92-.53-3.81-1.31-5.65-.55-1.28-1.33-2.54-2.27-3.56Z"
                  fill="#ff7159"
                />
                <path
                  d="M378.09,476c.37,2.13.85,4.25,1.96,6.15.58,1,1.34,1.86,2.59,1.82c1.35-.04,2.34-.75,2.81-2.06.23-.63.37-1.29.53-1.84-.04-1.31-.12-2.47-.11-3.64.02-2.21-.47-4.31-1.48-6.26-.94-1.81-2.35-3-4.57-2.91-.77.03-1.32.27-1.66.95-.47.94-.87,1.88-.68,3.01.27,1.58.34,3.19.61,4.77Z"
                  fill="#ff7159"
                />
              </g>
            </g>
            <g id="e0gYpSRcAlv1251" transform="translate(.000007 0)">
              <path
                d="M697.2,390.72c-.3-.88-.54-1.79-.68-2.7-.88-5.65-4.62-9.6-8.12-13.69-3.45-3.03-7.16-5.17-11.37-6.53-4.73-1.53-9.45-3.1-14.47-3.27-2.29-.08-4.58.12-6.87.18-4.03.11-8.07.04-12.08.36-6.31.5-12.6.99-18.94,1.04-2.33.02-4.72.33-6.98.89-5.02,1.25-10.1,1.96-15.25,2.24-3.88.21-7.6,1-11.18,2.56-4.29,1.86-8.77,3.11-13.37,3.91-4.5.78-8.78,2.21-12.82,4.32-3.93,2.05-8.07,3.56-12.34,4.65-5.04,1.29-9.76,3.23-14.11,6.09-3.82,2.51-8.12,3.99-12.37,5.57-4.38,1.63-8.55,3.66-12.5,6.15-6.99,4.41-14.25,8.32-21.7,11.89-4.67,2.24-8.99,4.99-12.91,8.4-1.73,1.5-3.59,2.87-5.5,4.14-4.45,2.94-8.95,5.81-13.47,8.65-5.26,3.31-10.47,6.68-14.76,11.26-1.1,1.18-2.22,2.35-3.42,3.42-5.87,5.17-11.77,10.3-17.65,15.46-3.03,2.66-6.07,5.32-9.04,8.04-3.25,2.97-6.44,6.01-9.65,9.04-.54.51-1.05,1.07-1.47,1.67-.68.98-.6,2.02.11,2.72.74.73,1.71.76,2.71.05.35-.25.64-.56,1.18-1.04.19.63.33,1.03.44,1.44.46,1.67.84,3.37,1.38,5.02.73,2.24,2.73,3.5,5.03,3.2c1.96-.26,3.92-.58,5.86-.99c5.43-1.14,10.9-1.7,16.45-1.3c3.36.25,6.68,0,10.01-.53c1.33-.22,2.72-.26,4.07-.16c2.35.19,4.67.62,7.02.83c2.72.24,5.44.43,8.17.49c5.93.14,11.69,1.38,17.5,2.36c1.83.31,3.69.5,5.51.85c5.07.95,10.02,2.36,14.88,4.08c5.49,1.94,11,3.88,16.17,6.62c5.43,2.87,10.83,5.8,16.24,8.71c1.69.91,3.37,1.85,5.05,2.79c3.41,1.91,6.82,3.81,10.22,5.73c2.43,1.38,4.84,2.78,7.24,4.19c2.94,1.73,5.87,3.47,8.81,5.21.91.54,1.87,1,2.72,1.62c4.64,3.38,9.79,5.86,14.88,8.43c1.94.98,3.97,1.65,6.16,2.01c2.37.39,4.69,1.13,7.03,1.73.48.12.95.3,1.44.36c6.13.8,12.12.31,17.93-1.94c4.66-1.81,8.45-4.8,12.02-8.26c7.38-7.15,12.24-15.87,16.24-25.16c2.24-5.21,3.27-10.79,4.56-16.28c1.1-4.71,1.99-9.46,3.11-14.16.66-2.77,1.29-5.6,2.43-8.18c3.56-8.03,8.69-14.99,15.13-21c4.49-4.19,8.9-8.47,13.2-12.85c2.12-2.16,4.29-4.43,5.75-7.04c3.95-7.04,7.24-14.31,8.24-22.55.87-7.12.49-13.96-1.85-20.72Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M613.78,405.18c-.83.38-1.56.67-2.26,1.03-1.37.7-2.69,1.51-4.08,2.13-2.26,1.01-4.29,2.4-6.41,3.66-.57.34-1.21.57-1.83.82-1.63.68-3.29,1.29-4.88,2.03-1.44.68-2.88,1.41-4.2,2.29-.87.58-1.72,1.11-2.67,1.56-1.77.85-3.41,1.96-5.15,2.89-1.49.8-3,1.54-4.65,2.06-2.14.68-4.11,1.84-5.97,3.14-.91.64-1.77,1.34-2.72,1.9-.79.46-1.68.72-2.51,1.11-1.26.59-2.52,1.19-3.75,1.83-2.1,1.09-4.1,2.38-6.06,3.66-1.93,1.26-4.13,2.1-5.88,3.65-.48.43-.89.56-1.46.12-1.57-1.19-3.18-2.34-4.78-3.49-1.44-1.04-1.92-2.48-1.29-4.07.49-1.25.48-2.41.12-3.61-.18-.58-.1-.91.43-1.21c1.71-.98,3.32-2.14,5.1-2.95c1.58-.73,2.96-1.69,4.39-2.65c3.01-2.02,6.19-3.78,9.31-5.63c2.38-1.41,4.77-2.82,7.18-4.19.9-.51,1.88-.88,2.8-1.35c1.74-.89,3.45-1.86,5.22-2.69c1.99-.93,4.05-1.68,6.04-2.59c1.38-.63,2.7-1.42,4.04-2.13.87-.46,1.7-1.08,2.63-1.33c1.28-.34,2.37-.96,3.5-1.62c2.23-1.3,4.65-2.19,7.13-2.89.29-.08.53-.39.81-.42.31-.03.83.04.92.23.31.67.86.78,1.47.97c2.11.7,4.17,1.53,6.02,2.8.93.64,1.84,1.25,1.82,2.59c0,.31.32.65.53.95.31.44.66.86,1.1,1.42Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M625.79,417.72c.78.77,1.52,1.72,2.47,2.38c1.6,1.1,2.06,2.59,2.23,4.41.11,1.21-.11,1.86-1.26,2.43-2.09,1.03-4.08,2.28-6.1,3.45-.27.15-.55.31-.76.53-1.67,1.69-3.8,2.74-5.71,4.09-.8.56-1.68,1.03-2.57,1.45-1.97.93-3.57,2.38-5.3,3.65-1.28.94-2.73,1.64-4.09,2.48-1,.61-2.04,1.18-2.93,1.93-2.17,1.86-4.71,3.15-7.07,4.73-1.64,1.09-3.39,2.06-4.89,3.31-1.76,1.48-3.61,2.72-5.72,3.65-1.22.54-2.34,1.39-3.37,2.26-2.27,1.93-4.77,3.51-7.33,5-.69.4-1.31,1.15-2.02,1.22-.68.07-1.42-.54-2.14-.83-.8-.32-1.61-.6-2.41-.92-1.17-.47-2.1-1.23-2.93-2.2-1.1-1.29-1.23-2.62-.63-4.14.31-.8.49-1.64.76-2.45.09-.27.26-.54.47-.72.37-.32.76-.69,1.21-.84c2.73-.94,4.7-2.96,6.78-4.79c1.51-1.33,3.26-2.22,5-3.13c1.87-.98,3.69-1.98,5.28-3.4c1.7-1.52,3.57-2.76,5.75-3.6c1.57-.61,3-1.62,4.46-2.5c1.53-.93,3.01-1.92,4.51-2.89c1.61.03,2.45-1.17,3.59-1.72c1.38-.66,2.7-1.47,3.99-2.3c1.6-1.03,3.16-2.13,5.11-2.42.28-.04.53-.3.79-.46c1.94-1.19,3.83-2.47,5.82-3.55c1.82-.98,3.75-1.76,5.64-2.61c1.05-.48,2.11-.94,3.36-1.49Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M622.7,414.28c-.19.21-.32.43-.51.56-.72.47-1.44.96-2.2,1.33-2.03.98-4.1,1.91-6.15,2.86-.22.1-.49.17-.65.34-1.62,1.75-3.84,2.48-5.88,3.52-1.15.59-2.27,1.24-3.38,1.89-2.71,1.57-5.36,3.28-8.14,4.71-2.63,1.36-5.09,2.94-7.5,4.63-1.81.25-2.84,2.07-4.68,2.34-.56.08-1.11.53-1.58.91-1.17.92-2.28,1.91-3.43,2.86-.61.5-1.13,1.13-2.03,1.21-.32.03-.6.4-.91.6-.83.54-1.6,1.19-2.5,1.57-1.54.65-2.71,1.67-3.76,2.92-.43.51-.99.93-1.53,1.34-.63.49-1.29.95-1.97,1.37-.94.58-1.9,1.14-2.88,1.64-.22.11-.67.06-.85-.1-2.81-2.48-6.24-3.99-9.32-6.05-.4-.27-.78-.6-1.11-.96-.12-.14-.16-.51-.06-.66.79-1.23,1.57-2.42,3.04-3.07c1.5-.67,2.84-1.72,4.29-2.51c1.55-.85,3.04-1.81,4.58-2.68c2.98-1.7,6.32-2.64,9.15-4.62c1.86-1.3,3.93-2.23,5.99-3.17c1.78-.81,3.65-1.54,5.24-2.64c1.5-1.04,3.32-1.22,4.8-2.2.82-.54,1.63-1.12,2.5-1.57c1.68-.88,3.46-1.59,5.08-2.56c2.08-1.23,4.41-1.82,6.59-2.79.78-.35,1.52-.81,2.25-1.26c1.93-1.2,3.93-2.24,6.01-3.2c1.84-.85,3.9-1.47,5.43-2.96.54-.53,1.1-.48,1.66-.02c1,.82,2.07,1.58,2.96,2.5c1.03,1.06.84,2.65,1.47,3.95Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M596.22,484.86c-.64-.95-1.2-1.82-1.79-2.67-.88-1.28-2.17-1.57-3.61-1.43-.85.08-1.7.29-2.55.39-2.23.24-4.2-.81-5.26-2.75-.4-.74-.33-1.07.41-1.5c1.82-1.05,3.65-2.06,5.47-3.1.32-.18.7-.35.9-.64c1.31-1.85,3.34-2.66,5.2-3.75c2.12-1.24,4.28-2.45,6.28-3.88c2.31-1.65,4.53-3.4,6.97-4.87c1.26-.76,2.4-1.73,3.6-2.61c1.14-.84,2.17-2,3.44-2.47c1.97-.73,3.14-2.6,5.16-3.19.5-.14.9-.64,1.32-1.01c1.77-1.56,3.72-2.81,5.93-3.66.34-.13.67-.32.97-.53c1.63-1.1,3.23-2.25,4.89-3.31c1.24-.8,2.56-1.46,3.82-2.23.63-.38.78.01.85.48.11.79.09,1.6.24,2.38.39,2.09,1.19,4.02,2.4,5.77.58.83.58,1.07-.25,1.7-1.11.84-1.9,2.11-3.32,2.54-1.52,2.13-4.2,2.5-6.12,4.01-.68.53-1.4,1.01-2.11,1.49-2.44,1.66-4.9,3.3-7.34,4.97-1.31.9-2.58,1.86-3.88,2.77-2.07,1.45-4.17,2.85-6.22,4.33-1.14.83-2.2,1.78-3.3,2.67-2.88,2.32-5.79,4.62-8.65,6.97-.83.69-1.53,1.54-2.32,2.28-.35.33-.77.57-1.15.85Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M632.21,429.96c1.53,2.18,2.95,4.2,4.35,6.22.17.25.27.55.41.83.21.4.14.63-.28.89-1.05.65-2.01,1.44-3.07,2.06-1.75,1.02-3.44,2.09-5.04,3.38-1.32,1.06-3.02,1.63-4.53,2.45-.64.35-1.23.79-1.83,1.2-.3.2-.56.48-.88.64-2.7,1.4-5.05,3.3-7.49,5.08-1.43,1.05-2.92,1.98-4.22,3.24-1.16,1.12-2.78,1.76-4.17,2.65-1.32.84-2.64,1.7-3.9,2.62-1.72,1.27-3.38,2.63-5.09,3.92-.59.44-1.25.78-1.88,1.17-.31.19-.72.33-.9.61-.46.75-1.19.94-1.92,1.29-1.31.62-2.69,1.34-3.66,2.37-1.17,1.25-2.67,1.98-3.9,3.08-.45.4-1.01.68-1.51,1.04-.61.44-1.12.55-1.46-.3-1.47-2.23-3.23-3.5-5.35-4.38-1.82-.75-2.56-1.42-3.6-2.8c1.81-.8,3.42-1.89,5.23-2.65c1.06-.44,2.09-1.08,2.96-1.82c2.57-2.17,5.41-3.88,8.43-5.31.77-.36,1.46-.9,2.18-1.39c1.93-1.32,3.86-2.66,5.79-3.97.87-.59,1.75-1.15,2.63-1.7.98-.62,2.14-1,2.81-2.06c2.6-1.52,4.92-2.78,7.22-4.11c1.12-.65,2.17-1.4,3.24-2.12c2.14-1.44,4.24-2.93,6.41-4.31c1.08-.69,2.35-1.01,3.41-1.83c1.75-1.35,3.65-2.51,5.53-3.69c1.25-.78,2.57-1.46,4.07-2.3Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M606.06,492.6c-.73-.29-1.52-.49-2.18-.9-1.69-1.03-3.32-2.14-4.98-3.22-.2-.13-.4-.29-.57-.46-.56-.56-.57-.82.06-1.36c1.59-1.38,3.19-2.76,4.83-4.08.89-.71,1.54-1.77,2.77-2.02c1.19-1.98,3.72-2.32,5.08-4.17.63-.85,1.73-1.36,2.66-1.97c1.44-.94,2.92-1.82,4.37-2.75.36-.23.69-.52,1.02-.8c1.9-1.64,3.86-3.15,6.16-4.26c1.48-.72,2.83-1.74,4.17-2.72c2.89-2.09,5.84-4.08,9.02-5.73c1.13-.59,2.1-1.5,3.14-2.27.3-.22.6-.43.9-.63c1.21-.83,1.51-.77,2.26.45c1.12,1.82,1.06,3.77-.33,5.49-.78.96-.89,1.83-.21,2.85.27.4.49.87.61,1.34.23.9-.01,1.34-.92,1.72-1.61.67-2.93,1.72-4.33,2.74-3.35,2.44-6.48,5.22-10.26,7.03-.22.11-.46.22-.62.4-.91,1.01-2.1,1.63-3.2,2.4-2.88,2.01-5.62,4.22-8.43,6.34-.54.41-1.13.74-1.72,1.07-1.07.6-2.27.98-2.96,2.13-.16.27-.65.33-.95.54-.55.38-1.14.72-1.58,1.2-1.13,1.22-2.12,1.66-3.8,1.66Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M541.71,424.94c-.22-.1-.43-.13-.55-.25-1.04-1.05-2.07-2.12-3.1-3.18-.36-.37-.35-.74-.07-1.17.66-1.04,1.28-2.1,1.93-3.14.39-.62.54-1.19.17-1.91-.39-.75-.26-1.25.45-1.43c2.33-.61,3.99-2.39,6.09-3.39c1.21-.57,2.45-1.08,3.64-1.68.65-.33,1.22-.83,1.85-1.21c2.8-1.69,5.78-2.98,8.76-4.3c2.05-.91,4.17-1.74,6.11-2.98c1.98-1.26,4.31-1.97,6.48-2.94.39-.17.75-.39,1.13-.58.54-.27,1.09-.52,1.63-.79.77-.38,1.54-.77,2.32-1.14.27-.13.55-.27.84-.36c2.78-.85,5.37-2.1,7.89-3.54c1.01-.58,2.1-1.05,3.2-1.44.53-.19,1.1-.19,1.77-.04c2.43.57,4.62,1.7,6.9,2.62.81.33.87.71.29,1.43-.26.32-.62.62-.99.76-1.83.71-3.56,1.66-5.35,2.44-2.24.98-4.46,2.02-6.66,3.09-1.05.51-2.06,1.12-3.11,1.64-1.31.65-2.65,1.27-3.98,1.87-.84.38-1.7.68-2.55,1.03-.74.3-1.47.62-2.19.94-.33.15-.65.34-.96.54-1.23.77-2.46,1.53-3.67,2.33-2.05,1.36-4.34,2.26-6.48,3.46-1.93,1.09-3.8,2.29-5.69,3.44-1.58.96-3.17,1.89-4.73,2.87-1.19.75-2.39,1.5-3.48,2.37-1.51,1.2-3.17,2.06-4.93,2.81-.83.36-1.54,1.01-2.31,1.51-.2.13-.43.21-.63.3Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M622.76,497.22c-1.75-.19-3.29-1.03-4.8-1.83-1.69-.89-3.32-1.89-5.17-2.43-.45-.13-.47-.53-.06-.81c1.52-1.05,3.05-2.07,4.57-3.13c2.17-1.5,4.31-3.03,6.49-4.51c1.27-.87,2.6-1.65,3.88-2.5c1.89-1.26,3.76-2.56,5.65-3.82c1.17-.78,2.38-1.51,3.55-2.31c1.67-1.15,3.31-2.35,4.98-3.51c1.01-.7,2.03-1.39,3.05-2.06.74-.48,1.33-.21,1.37.67.06,1.13-.11,2.26-.69,3.22-1.38,2.29-2.05,4.79-2,7.41.04,2.67-1.51,4.13-3.6,5.11-1.39.65-2.05,1.55-2,2.99.09,2.8-2.68,5.17-5.46,4.59-1.51-.31-2.98.01-4.37.49-.9.31-1.71.95-2.48,1.56-.88.7-1.79,1.09-2.92.87Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M585.45,388.29c-1.3.68-2.38,1.4-3.56,1.84-1.88.71-3.67,1.67-5.65,2.11-.24.05-.54.13-.67.3-1.06,1.41-2.81,1.62-4.21,2.42-1.37.79-2.95,1.23-4.31,2.03-1.71,1.01-3.68,1.57-5.2,2.92-.3.27-.77.33-1.16.5-2.25.98-4.69,1.54-6.79,2.87-.94.59-1.78,1.34-2.75,1.86-3.53,1.87-7.07,3.7-10.35,5.98-.29.2-.66.28-1.25.53.2-.53.24-.9.44-1.14c1.1-1.32,2.28-2.59,3.37-3.92c2.64-3.25,5.2-6.56,7.87-9.78c1.58-1.9,3.35-3.59,5.94-4.16c3.43-.76,6.84-1.59,10.21-2.57c1.7-.49,3.33-1.3,4.92-2.11c1.25-.64,2.51-.84,3.9-.88c2.23-.06,4.44.02,6.65.22.87.08,1.64.34,2.57.97Z"
                  fill="#ffaa9c"
                />
              </g>
              <g>
                <path
                  d="M668.18,381.5c-2.92.95-5.7,1.8-8.44,2.78-1.32.47-2.54,1.19-3.83,1.76-.56.25-1.19.33-1.73.6-2.59,1.31-5.46,1.86-8.11,3-1.23.53-2.45,1.08-3.68,1.62-.22.1-.43.27-.67.31-2.51.45-4.4,2.3-6.82,2.98-.81.23-1.57.73-2.25,1.23-.99.73-2.02.58-3,.2-2.52-.98-5.04-1.97-7.48-3.13-2.12-1.01-2.95-1.97-.5-4.05.88-.75,1.94-1.32,2.98-1.81c1.83-.86,3.79-1.4,5.51-2.54.5-.33,1.33-.1,1.93-.33c2.5-.97,5.18-1.32,7.62-2.52c1.33-.66,2.95-.76,4.45-1.02c1.4-.24,2.75-.51,4.08-1.07c1.38-.59,2.9-.83,4.36-1.22.47-.13,1.05-.1,1.41-.37c1.8-1.34,3.65-1.04,5.54-.31c2.18.84,4.35,1.71,6.52,2.56.74.29,1.42.65,2.09,1.35Z"
                  fill="#fec359"
                />
                <path
                  d="M635.94,407.56c-1.4-.38-2.33-1.12-3.21-2.05-.95-1-1.13-1.96-.46-3.17.48-.86.61-1.99,1.27-2.63.65-.64,1.77-.78,2.65-1.22c1.22-.6,2.39-1.28,3.6-1.89.76-.38,1.57-.68,2.35-1.03c1.56-.71,3.12-1.43,4.68-2.14.22-.1.45-.2.69-.25.97-.19,1.84-.56,2.7-1.11.75-.49,1.74-.61,2.6-.93c2.94-1.08,5.95-1.99,8.77-3.33c2.9-1.38,6.13-1.77,9.02-3.16c1.17-.56,1.4-.45,2.23.57c1.01,1.25,1.93,2.56,2.9,3.84.43.57.19.92-.35,1.15-.74.32-1.47.71-2.25.87-2.45.51-4.63,1.7-6.91,2.62-2.73,1.1-5.26,2.65-8.14,3.48-1.8.52-3.44,1.61-5.16,2.42-.89.42-1.77.87-2.7,1.15-1.89.59-3.56,1.59-5.28,2.51-.81.44-1.62.89-2.44,1.29-1.82.89-3.65,1.75-5.48,2.61-.38.18-.78.29-1.06.39Z"
                  fill="#fec359"
                />
                <path
                  d="M683.57,399.48c-2.19.7-4.01,1.22-5.78,1.88-1.49.56-2.89,1.34-4.36,1.94-1.46.6-2.68,1.71-4.32,1.97-.58.09-1.14.48-1.65.81-2.65,1.72-5.56,2.91-8.47,4.08-2.3.92-4.5,1.99-6.48,3.52-.62.48-1.44.7-2.12,1.12-2.04,1.26-4.29,2.15-6.29,3.51-.59.41-1.48.86-2.23.32-.74-.53-.48-1.47-.19-2.07.98-2.01,0-3.6-.92-5.21-.62-1.1-.67-1.11.42-1.6.74-.33,1.52-.54,2.24-.91c1.37-.7,2.69-1.49,4.04-2.23.65-.35,1.28-.75,1.96-1.02c2.85-1.13,5.8-2,8.46-3.57.37-.22.81-.31,1.21-.48c3.41-1.39,6.82-2.78,10.09-4.52c1.62-.86,3.46-1.3,5.21-1.92.92-.33,1.86-.61,2.77-.96.39-.15.7-.2.96.2.7,1.07,1.82,1.64,2.8,2.39.91.7,1.63,1.66,2.64,2.72Z"
                  fill="#fec359"
                />
                <path
                  d="M680.95,424.03c-.06.68-.11,1.36-.17,2.04-.21,2.2-1.37,3.72-3.51,4.23-1.68.4-3.01,1.37-4.47,2.16-1.83.99-3.6,2.06-5.47,2.98-1.65.81-3.16,1.9-4.73,2.87-2.2,1.36-4.39,2.73-6.6,4.07-.54.33-1.04.42-1.63-.16-1.01-.99-2.18-1.81-3.25-2.73-.71-.6-1.01-1.37-.81-2.33.14-.66.11-1.37.29-2.01.29-1.08.79-1.84,1.98-2.4c1.99-.93,3.75-2.33,5.65-3.48c1.3-.79,2.67-1.47,3.98-2.25c1.48-.88,2.85-1.96,4.39-2.69c2.09-.98,3.99-2.38,6.3-2.89.29-.06.55-.26.8-.42c1.61-.99,3.21-1.99,4.82-2.98.16-.1.35-.13.51-.21c1.66-.73,1.85-.63,1.94,1.22.08,1.66.07,3.32.1,4.98-.04,0-.08,0-.12,0Z"
                  fill="#fec359"
                />
                <path
                  d="M683.98,404.14c.22,2.06-.3,3.89-.83,5.72-.12.41-.27.81-.36,1.23-.21.99-.75,1.6-1.72,1.98-1.77.69-3.53,1.44-5.23,2.28-1.04.51-1.98,1.23-2.95,1.88-1.37.92-2.82,1.63-4.42,2.14-1.44.46-2.9,1.11-4.09,2.02-2.22,1.71-4.77,2.81-7.14,4.24-1.74,1.05-3.43,2.17-5.14,3.26-.31.2-.62.43-.97.52-.22.05-.66-.09-.72-.25-.28-.75-.51-1.52-.68-2.3-.38-1.7-.85-3.34-2.13-4.64-.58-.59-.53-.92.17-1.32c1.28-.73,2.62-1.36,3.93-2.04.87-.46,1.74-.93,2.58-1.43c2.17-1.29,4.31-2.62,6.68-3.53c3.39-1.3,6.65-2.86,9.77-4.73c1.25-.75,2.71-1.15,4.07-1.73c1.06-.45,2.12-.92,3.17-1.4.67-.3,1.31-.73,2.01-.93c1.28-.38,2.6-.63,4-.96Z"
                  fill="#fec359"
                />
                <path
                  d="M649.3,375.71c-.93.29-1.87.57-2.8.88-1.1.37-2.24.66-3.28,1.17-1.02.51-2.26-.02-3.15.84-1.53-.06-2.81.76-4.22,1.15-1.3.36-2.63.59-3.95.87-.24.05-.54.02-.71.16-1.43,1.21-3.27,1.37-4.93,2.01-.96.37-1.86.88-2.79,1.32-1.19.57-2.41.84-3.75.73-3.15-.26-6.17-1.03-9.17-1.95-.18-.05-.34-.14-.51-.21-2.05-.84-2.18-1.54-.54-2.93c1.85-1.57,3.93-2.81,6.16-3.69c1.34-.53,2.87-.54,4.3-.87c1.68-.38,3.36-.75,4.98-1.31c1.43-.49,2.83-.77,4.35-.58c1.66.2,3.35.52,4.99.38c1.81-.15,3.58-.07,5.35.17c2.61.36,5.2.89,7.8,1.33.6.1,1.22.11,1.84.16c0,.12.02.25.02.37Z"
                  fill="#fec359"
                />
                <path
                  d="M676.25,435.09c-1.57,3.04-3.6,5.2-5.57,7.41-1.43,1.61-2.88,3.21-4.34,4.79-.5.54-1,1.1-1.57,1.56-.92.74-1.45,1.62-1.53,2.83-.1,1.55-.16,1.56-1.88,1.73-.79.08-1.6.19-2.38.12-1.64-.15-2.22-.81-2.38-2.46-.12-1.22-.24-2.44-.37-3.66-.07-.6.05-1.13.59-1.46.57-.36,1.16-.69,1.76-.99c1.4-.72,2.81-1.38,4.12-2.3c1.81-1.27,3.64-2.5,5.67-3.46c2.27-1.07,4.39-2.47,6.59-3.7.29-.16.65-.21,1.29-.41Z"
                  fill="#fec359"
                />
              </g>
              <path
                d="M605.7,579.72c-.35-1.63-.44-3.31-.68-4.96s-.29-3.39-.84-4.93c-1.88-5.26-2.64-10.83-4.73-16.04-2.03-5.06-3.56-10.32-5.57-15.38-1.54-3.86-3.64-7.48-6.4-10.64-2.69-3.08-5.36-6.18-8.14-9.19-1.34-1.45-2.81-2.81-4.38-4-2.18-1.66-4.27-3.39-6.09-5.45-1.82-2.05-3.9-3.79-6.24-5.25-1.73-1.07-3.38-2.3-4.98-3.57-2.2-1.73-4.4-3.45-6.97-4.59-4.83-2.14-9.42-4.72-13.96-7.39-1.76-1.03-3.58-2-5.47-2.75-4.49-1.78-9.12-3.22-13.55-5.13-6.99-3.01-14.36-4.18-21.82-5.01-2.53-.28-5.07-.44-7.61-.66-4.01-.39-8.04-.62-12.06-.71-3.4-.08-6.83-.21-10.21.04-8.58.62-17.12,1.53-25.63,2.91-8.61,1.4-16.98,3.43-25.03,6.85-2.81,1.19-4.8,2.98-6.14,5.62-.42.82-.7,1.72-1.03,2.58-.5,1.33-.85,2.74-1.52,3.99-1.32,2.47-1.82,5.1-2.09,7.84-.16,1.66-.49,3.3-.76,4.95-.22,1.34-.57,2.67-.71,4.02-.42,3.98.22,7.92.68,11.84.71,6.14,1.7,12.26,2.66,18.37.97,6.24,2.14,12.45,3.07,18.69c1.5,10.13,3.56,20.12,6.36,29.97c1.36,4.77,2.54,9.58,3.31,14.49.91,5.81,1.92,11.6,2.91,17.4.47,2.76,1.17,5.45,2.34,8.01.7,1.52,1.26,3.1,1.91,4.64.45,1.09.84,2.22,1.42,3.23c2.17,3.83,4.41,7.62,6.62,11.43c1.15,1.98,2.33,3.95,3.4,5.97c1.34,2.54,2.87,4.92,4.84,7.03c1.1,1.18,2.2,2.39,3.09,3.72c3.01,4.46,7.3,7.77,10.57,11.99.37.48.91.84,1.4,1.22c4.53,3.51,9.52,6.27,14.59,8.9c4.72,2.45,9.76,3.5,15.02,3.76c3.9.2,7.8.4,11.7.65c2.48.16,4.94.46,7.42.61c4.11.25,8.21-.1,12.13-1.29c5.15-1.57,10.27-3.33,15.27-5.33c6.2-2.48,11.83-5.99,16.71-10.61.54-.51,1.17-.92,1.76-1.37c2.87-2.16,5.96-4.09,8.24-6.93c2.31-2.88,5.06-5.27,7.92-7.57c1.49-1.2,2.84-2.6,4.13-4.01c2.1-2.29,4.22-4.54,6.78-6.34c1.75-1.23,3.14-2.82,4.28-4.61c1.63-2.56,3.17-5.18,4.77-7.76c1.09-1.75,1.91-3.6,2.45-5.6.58-2.15,1.17-4.3,2.49-6.17c1.26-1.79,2.03-3.81,2.69-5.89.58-1.83,1.19-3.67,2-5.4c1.43-3.06,2.17-6.31,2.9-9.58c1.04-4.65,1.96-9.32,3.56-13.83c1.47-4.14,2.22-8.37,1.27-12.77Z"
                fill="#f37e5a"
              />
              <path
                d="M515.72,643.4c-.27-.41-.96-.62-1.09-1.04-.59-1.96-2.39-3.05-3.33-4.75-.18-.33-.79-.41-1.21-.6-.17-.43-.25-.94-.54-1.27-.71-.81-1.52-1.55-2.3-2.3-.74-.72-1.63-1.33-2.2-2.16-1.21-1.75-2.84-3.12-4.17-4.76-.09-.33-.21-.37-.36-.04-1.17-1.31-1.73-3.12-3.4-4.01-.15.26-.28.27-.38-.06-.57-.99-1.09-1.99-1.98-2.79-1.18-1.05-2.25-2.23-3.35-3.37-.29-.31-.64-.66-.73-1.04-.21-.9-.85-1.44-1.52-1.87-.72-.47-1.16-1.13-1.51-1.81-.77-1.51-1.87-2.7-3.1-3.84-.94-.87-1.69-1.95-2.62-2.83-1.01-.96-1.62-2.3-2.88-3.02-.24-.14-.46-.28-.69-.42.04-.91-.53-1.72-1.68-2.39-.23-.41-.42-.84-.69-1.21-.19-.27-.49-.46-.75-.69-.18.25-.36.51-.54.76.42-1.55-.23-2.68-1.25-3.7-.56-.56-1.05-1.18-1.58-1.76-.29-.31-.74-.54-.9-.91-.71-1.6-2.02-2.75-2.96-4.17-.3-.46-.56-.96-.91-1.37-1.84-2.14-3.73-4.22-5.53-6.39-.67-.8-1.93-1.15-1.96-2.46-1.21-1.54-2.5-3.02-3.59-4.64-.61-.92-1.35-1.57-2.25-2.13-.4-.25-.9-.54-1.06-.94-.87-2.1-2.53-3.59-3.92-5.29-.38-.47-.73-.8-1.37-.5-.1.04-.59.07-.25-.33.52-.62.06-1.04-.21-1.57-.49-.96-1.5-.69-2.29-1.02.58-1.45.09-2.51-1.05-3.38-.38-.29-.8-.65-.98-1.08-.3-.71-.9-.98-1.46-1.35-.23-.14-.46-.28-.69-.42-.15-.64-.15-1.38-1.01-1.56-.38.38-.72.24-.65-.25.17-1.2-.54-2.13-1.18-2.81-.99-1.06-1.96-2.1-2.78-3.29-.28-.4-.53-.83-.88-1.14-.32-.29-.85-.36-1.15-.66-.63-.66-1.32-1.33-1.69-2.13-.61-1.32-2.14-1.85-2.42-3.57-.23-1.37-2.25-1.93-2.7-3.49-.02-.07-.65.09-.71-.02-.18-.3-.11-.76-.32-1.03-.63-.82-1.34-1.58-2.01-2.36-.69.23-1-.22-1.28-.72.83-.72-.61-.57-.4-1.03.34-.77-.31-.9-.73-1.18-.2-.73-.61-.96-1.31-.57-.14.08-.34.04-.52.06.49,1.39.48,2.93,2.01,3.43.19.06.29.42.43.64.58.9.85,2.02,1.84,2.63-.18.83.5,1.19.93,1.68.36.41.79.75,1.12,1.17c1.21,1.5,2.65,2.8,3.57,4.55.46.88,1.53,1.46,1.9,2.35.39.93,1.01,1.65,1.53,2.46c1.09,1.69,2.39,3.18,4.14,4.22.19.11.53.31.52.33-.35.68.06,1.22.37,1.71.3.47.58,1.18,1.41.86.06.19.1.38.19.56.34.71.52,1.66,1.09,2.07c1.09.8,2.03,1.68,2.73,2.81.41.66,1,1.26,1.19,1.98.14.51.37.76.74.91.2.08.64-.21.75-.11.22.22.32.57.45.88-.1.76.06,1.34.58,2.01.72.94,2.25,1.21,2.3,2.69.53.34,1.27.64,1.24.81-.15.85.64.8.93,1.19.17.24.2.57.34.84.2.38.35.85.67,1.09c1.15.85,1.92,1.99,2.73,3.15c1,1.44,2.31,2.68,3.25,4.15c1.58,2.5,3.66,4.57,5.47,6.86.4.55.73,1.18,1.22,1.62.65.58,1.14,1.25,1.7,1.9.99,1.14,1.87,2.39,2.93,3.48.94.96,1.64,2.18,2.34,3.35.36.59.55,1.23,1.43,1.15.11-.01.37.31.36.33-.82,1.05.42,1.31.76,1.84.77,1.18,1.69,2.26,2.57,3.35.72.89,1.47,1.75,2.21,2.63.17.25.29.64.53.74c1.68.71,2.3,2.44,3.45,3.64.71.74,1.32,1.57,2.21,2.14.32,1.28,1.13,1.98,2.44,2.09.1.25.21.5.31.74.25.95.74,1.73,1.34,2.54.67.9,1.6,1.57,2.14,2.67.47.96,1.36,2.03,2.6,2.43.16.25.28.56.51.72.91.63,1.49,1.54,2.15,2.39.84,1.09,1.63,2.27,2.66,3.16c1.08.94,2.27,1.72,3.02,2.99.2.35.6.59.9.87.8.88,1.59,1.78,2.42,2.64.43.45.73,1.16,1.64.81.39-.15.12.3.17.48.13.47,1,.98,1.68,1.06.01.3-.06.65.08.87.4.67.89,1.28,1.36,1.91.18.24.33.55.58.67.93.46,1.37,1.26,1.87,2.12.44.77,1.29,1.29,1.81,2.02.5.7.77,1.56,1.21,2.32.26.45.86.18.92-.03.24-.78.57-1.66.4-2.4-.19-.89-.81-1.71-1.33-2.51Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M521.01,624.2c-.38-.61-.85-1.19-1.39-1.66-1.3-1.11-2.87-1.95-3.26-3.85-.06-.29-.51-.5-.77-.76-.61-.6-1.35-1.14-1.78-1.85-.39-.64-.95-.93-1.48-1.32-1.84-2.48-3.82-4.83-6.14-6.87-1.24-1.51-2.47-3.03-3.72-4.54-.46-.56-.96-1.1-1.44-1.65-1.17.37-1.16-.71-1.62-1.27-.7-.84-1.48-1.62-2.28-2.36-1.01-.93-2.08-1.73-2.92-2.88-1.04-1.43-2.45-2.58-3.67-3.88-.54-.57-.94-1.28-1.5-1.83-1-.96-2.08-1.85-3.13-2.77-.32-.26-.68-.75-.96-.71-1.04.14-.99-.84-1.47-1.25-.35-.3-.56-.86-.95-1.03-.97-.43-1.91-.8-2.14-2-.03-.14-.26-.25-.4-.37-1.99-1.68-3.99-3.35-5.8-5.24-1.43-1.49-3.11-2.75-4.71-4.08-.5-.42-1.11-.71-1.67-1.05-.29-.8-1.21-1.02-1.61-1.61-.88-1.29-1.96-2.28-3.26-3.1-.28-.17-.42-.56-.66-.8-.79-.77-1.61-1.52-2.41-2.27-.84-.83-1.67-1.65-2.5-2.48-1.12-1.13-2.25-2.24-3.35-3.39-.63-.66-1.07-1.62-1.83-2.02-1.04-.55-1.54-1.51-2.3-2.26-.66.1-1.61-.21-1.48-.41.63-.99-.21-1.47-.69-1.95-.41-.41-.35-1.51-1.4-1.13-.45-.58-.81-1.29-1.39-1.7-1.43-1.03-2.41-2.49-3.67-3.69-1.67-1.59-3.02-3.52-4.87-4.96-.37-.29-.56-.79-.87-1.17-.96-1.19-1.88-2.43-2.93-3.54-1.16-1.22-2.45-2.32-3.69-3.48-.98-.91-1.82-1.95-2.68-2.98-.43-.51-.81-1.35-1.79-.97.18-1.25-.75-.76-1.02-.96-.01-.24.62-.76-.16-.62-.65.11-.75-.15-.83-.6s-.13-.91-.19-1.37c-.4.11-.81.21-1.21.32-.59.13-.84.14-1.09.16.18.2.34.42.54.6.24.22.51.4.77.6.29.3.82.83.8.85-.76.82.04,1.09.49,1.47.14-.28.26-.23.37.05.17.06.49.15.48.19-.1.83.49,1.17,1.03,1.58.35.27.77.53.98.9c1.3,2.25,3.67,3.57,5.01,5.79c1.01.83,1.92,1.29,1.93,2.43c0,.15.2.3.33.44.83.86,1.63,1.75,2.71,2.3.14.07.45.05.47.11.21,1.07.66,1.95,1.7,2.44.37,1.61,1.71,2.49,2.76,3.58.26.27.71.35,1.07.52.76,1.81,2.42,2.66,3.98,3.59.22.13.54.02.53.45-.04,1.44,1.12,1.98,2.06,2.69.28.21.73.37.81.64.48,1.7,1.97,2.65,2.95,3.96c1.04,1.39,2.4,2.55,3.64,3.79.52.51,1.04,1.19,1.68,1.37.94.27,1.24,1.03,1.78,1.62.49.53.96,1.08,1.46,1.61.45.49.92.96,1.38,1.44.35.28.7.56,1.05.84.55.52,1.21.97,1.6,1.59c1.11,1.78,2.95,2.74,4.4,4.14.37.36.86.99,1.55.36.26.53.4,1.23.82,1.56.98.76,1.64,1.88,2.59,2.56c1.09.79,1.85,1.88,2.87,2.65c2.48,1.89,4.47,4.42,7.39,5.75.32.58.56,1.24,1,1.72c1.44,1.57,2.93,3.08,4.44,4.58.94.94,1.99,1.77,2.92,2.72.85.87,1.51,1.95,2.42,2.73c1.19,1.02,2,2.53,3.69,2.93.3.44.59.91.92,1.32.53.66,1.1,1.29,1.64,1.94.23.28.4.71.69.81.58.2.63.64.9,1.07.51.81,1.19,1.69,2.35,1.78.06.95.46,1.67,1.31,2.17.5.29.94.69,1.41,1.04.17.16.36.3.51.48.19.23.34.48.51.72.27.39.48.88.84,1.15c1.27.94,2.13,2.27,3.27,3.32c1.53,2.14,3,4.34,5.31,5.76.44.27.54.68.76,1.09.48.92,1.05,1.87,1.83,2.51.42.35.76.64.96,1.12.12.29.15.71.37.83.56.32,1.25.78,1.78.66.69-.15.48-.89.35-1.54-.42-2.1-2.02-3.46-3.08-5.15Z"
                  fill="#2b231d"
                />
                <path
                  d="M512.18,615.27c-.08-.25.03-.35.13-.45-.04.15-.09.3-.13.45Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M494.47,645.59c-.14-.27-.49-.42-.76-.62.02-.34.18-.8.03-1-1.12-1.44-1.96-3.09-3.3-4.35-.51-1.42-1.37-2.07-2.06-2.85-.36-.41-1.14-.61-.7-1.44.01-.02-.56-.52-.77-.46-.32.09-.62.56-.56-.21.04-.55-.25-.7-.69-.9-.43-.19-.86-.56-.27-1.08-.46-.41-.91-.82-1.37-1.24.2-.35.72-.72.24-1.1-1.14-.9-1.68-2.21-2.48-3.34-.45-.64-1.3-1.02-1.65-1.69-.94-1.78-2.24-3.32-3.24-5.05-.21-.36-.48-.96-.75-.98-.91-.07-.87-.74-1.12-1.31-.26-.61-.55-1.26-1.02-1.7-.86-.82-1.4-1.83-2.01-2.81-.63-1-1.26-2.01-1.9-3.01-.46-.42-1.03-.75-1.28-1.25-.55-1.06-1.21-2.06-1.59-3.21-.21-.62-.64-1.2-1.09-1.68-.78-.83-1.28-1.91-2.31-2.51-.64-2.18-2.69-3.44-3.57-5.5-.49-1.15-1.39-2.15-2.21-3.13-.92-1.11-1.23-2.7-2.64-3.43-.22-.39-.43-.78-.65-1.17-.47-.65-.89-1.32-1.4-1.93-1.03-1.23-2.14-2.39-2.7-3.95-.1-.27-.35-.51-.57-.72-.93-.89-1.67-1.91-2.25-3.06-.13-.26-.34-.52-.57-.68-1.53-1.03-2.18-2.92-3.79-3.87-.11-.07-.16-.33-.15-.5.06-.91-.64-1.42-1.06-2.07-.39-.61-.88-1.16-1.31-1.74s-.86-1.17-1.29-1.75c-1.38.24-.32-1.17-.99-1.48-.31-.14-.67-.78-.75-.74-1.12.62-1.07-.58-1.14-.9-.51-2.19-.84-2.95-2.12-4.39-.28-.31-.44-.73-.69-1.07-.57-.78-1.07-1.66-1.78-2.29-.74-.65-.99-.69-1.11-1.31-.26-1.35-.83-2.49-1.94-3.34-.18-.14-.37-.35-.42-.56-.36-1.67-2.01-2.62-2.38-4.28-1.74-1.21-1.69-3.31-3.2-4.25-.36-2.11-2.35-3.36-2.84-5.41-.94-.08-.54-1.05-.97-1.5-.5-.53-.87-1.19-1.19-1.85-.79-1.62-.77-1.64-1.99-2.34-.09-.63-.19-.88-.29-1.14-.14-.29-.26-.61-.47-.85-.25-.29-.58-.52-.87-.77-.24.13-.68.29-.66.38.09.51.15,1.12.89,1.14.08.48.24.95.23,1.43c0,.45,1.17.19.51.93.68,2.01,1.16,4.14,3.09,5.43.2.57.37,1.15.6,1.71.83,2.03,2.03,3.87,3.23,5.69.83,1.27,1.06,3.01,2.7,3.69-.12,1.42.85,1.98,1.33,2.76.29.46.79.83.94,1.33.38,1.19.78,2.31,1.88,3.07.17.12.11.55.24.79.25.47.49,1.2.86,1.28.87.21,1.04.67,1.05,1.43c0,.28.16.62.36.83c1.37,1.46,1.92,3.59,3.76,4.69.18.11.22.5.25.77.08,1,.56,1.56,1.58,1.6-.12.33-.38.85-.3.91.48.36.88,1.05,1.66.71-.07.46-.28.97-.14,1.36.17.47.69,1.19,1.01,1.16.79-.06.67.43.86.84.47,1.02.82,2.2,1.57,2.97c1.13,1.14,2.07,2.39,3.03,3.66.5.67.97,1.58,2.05,1.56.1.45.17.92.33,1.35.1.26.46.43.52.69.51,1.98,2.06,3.33,3.05,5.01.53.89,1.26,1.66,1.88,2.49c1.37,1.84,2.39,3.94,4.03,5.59.2.2.23.55.38.81.21.36.47.69.71,1.03.64.19.63.32.35.42.54.58.97,1.26,1.45,1.87c1.26,1.61,1.87,3.7,3.59,4.97.13.1.19.3.29.45c1.23,1.96,2.42,3.94,3.71,5.86.96,1.42,2.18,2.68,3.06,4.14c1.23,2.06,2.54,4.05,4.12,5.86.16.18.27.41.39.63.82,1.49,1.69,2.93,2.75,4.28c1.24,1.58,2.85,2.87,3.75,4.74.09.19.5.21.7.39.49.44,1.6.35,1.29,1.48.36.47.71.98,1.42.52-.13.92-.7,1.93.25,2.67.89.69,1.29,1.6,1.57,2.62.05.17.12.4.26.48.79.47.95,1.61,1.59,1.92.95.46.81,1.38,1.33,1.93.29.31.81.41,1.23.6c0,.26-.09.56.03.75.71,1.19,1.51,2.32,2.19,3.52.56,1,.5,1.03,1.26.06c1.48.31.99-.79.89-1.19-.2-.8-.58-1.56-.97-2.3Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M552.68,593.16c-.76-1.48-1.95-2.62-3.07-3.78-1.27-1.3-2.53-2.62-4.15-3.58-1.33-.79-2.58-1.81-3.65-2.94-1.98-2.11-4.19-3.92-6.53-5.59-.99-.7-2.33-1.04-2.97-2.1-.8-1.32-2.83-1.01-3.27-2.68-1.24-.35-2.39-1.01-2.91-1.48-1.36-1.24-2.73-2.53-4.46-3.22-1.36-.54-2.35-1.52-3.49-2.33-.38-.27-.62-.83-1.24-.62-.94-1.47-2.62-1.71-3.49-2.87-.24-.31-.7-.45-1.06-.67-1.79-1.02-3.57-2.05-5.35-3.08-1.25-1.52-2.75-2.72-4.55-3.57-.81-.38-1.37-1.2-2.38-1.28-.32-.03-.6-.41-.9-.61-.76-.49-1.33-1.18-2.2-1.59-1.04-.5-1.85-1.47-2.8-2.18-.57-.43-1.19-.84-1.85-1.09-.45-.17-.85-.2-1.13-.72-.23-.42-.73-.63-1.16-.11-.32-.5-.55-1.09-.97-1.48-.44-.41-1.06-.61-1.59-.93-1.2-.75-2.3-1.81-3.6-2.2-1.29-.39-2.2-1.22-3.13-1.98-.77-.62-1.59-1.24-2.37-1.8-1.73-1.24-3.67-2.22-5.59-3.17-.99-.49-1.92-1.03-2.73-1.74-1.54-1.35-3.44-2.08-5.19-3.04-.44-.24-1.05-.24-1.58-.23-.8.02-.09-1.12-.88-1.06-1.19-.55-2.24-1-3.2-1.59-.8-.5-1.44-1.26-2.24-1.74-1.42-.84-2.87-1.6-4.46-2.14-1.35-.46-2.48-1.55-4.02-1.67-.26-.02-.49-.48-.74-.74-.32-.34-.63-.69-.97-1-1.19-1.1-2.82-1.18-4.23-1.76-.96-.4-1.97-.68-2.91-1.11-.98-.44-1.91-1-2.96-1.56l-.22,2.62c.28-.52.38-.73.49-.93.07,1,.7,1.55.93,1.41.83-.49.93.42,1.39.57.61.19,1.24.39,1.77.73c1.15.73,1.13.76,3.04.95.85,1.3,1.92,1.63,2.92,2.05.2.08.55,0,.63.13.9,1.37,2.45,1.81,3.72,2.67.36.24.73.57,1.12.62.43.05.89-.19,1.34-.3-.05.59.12.84.78,1.09.9.33,1.87.58,2.58,1.5.42.55,1.1,1.59,2.25,1.12.38.53,1.04.41,1.55.64-.38,1.05.82.92,1.19,1.43.37.52,1.29.72,2.13.83.58.07.98,1.18,1.95.79.22,1.11.92,1.38,1.46,1.75c1.03.7,2.19,1.18,3.05,2.16.28.32.89.33,1.35.49.1.31.2.37.35.05c1.43.85,2.85,1.71,4.28,2.58.25-.28.32-.11.39.06.22.26.45.52.67.78.15-.28.28-.26.38.05.27.22.56.41.79.66.34.35.57.86.97,1.11c1.45.91,2.94,1.76,4.44,2.59.28.16.69.07,1.01.18.2.07.36.29.5.47.22.28.34.69.61.88c1.19.82,2.41,1.59,3.63,2.35.36.22.88.24,1.17.52c1.44,1.39,3.11,2.4,4.89,3.25.08.22.11.53.26.62c1.48.9,2.98,1.78,4.49,2.63.4.22,1.13.23,1.25.52.54,1.29,1.93,1.61,2.72,2.59.76.94.81.9,1.79-.01q.13,1.08,1.14,1.73c.1.37.22.3.35.04c1.09,1.18.68,1.29,2.2.58.07,1.22.25,1.47,1.2,1.79.54.18,1.06.43,1.59.65.15-.28.28-.23.38.06.64,1.59,1.77,2.74,3.25,3.56c1.18.65,2.37,1.29,3.54,1.96.42.24.91.48,1.18.86.32.46,1.05-.24,1.17.55.12.72.54.73,1.05.3.36-.31.74-.59,1.14-.91.21.47,1.14.64.39,1.33-.19-.08-.38-.18-.58-.23-.16.29.46.36.46.36.07,1.04.65.57,1.14.4.16-.29.28-.24.38.03.33.24.87.42.29.93-.42.37-.52.69,0,1.03c1.58,1.06,2.79,2.63,4.64,3.33.21.08.44.23.55.41.75,1.22,2.03,1.75,3.13,2.52c1.08.76,2.35,1.44,3.08,2.47.78,1.12,1.78,1.87,2.79,2.65c1.15.89,2.39,1.65,3.51,2.56.86.7,1.54,1.61,2.39,2.32c1.54,1.27,2.73,3.02,4.81,3.7.35-.51.73-1,1.02-1.54.07-.12-.13-.39-.22-.6v0Z"
                  fill="#2b231d"
                />
                <path
                  d="M478.58,540.81c.02-.35.15-.39.25-.45.02.4-.14.41-.25.45Z"
                  fill="#2b231d"
                />
              </g>
              <g>
                <path
                  d="M427.18,499.53c.22-.01.45.26.68.42.42.11.88.39,1.24.3c1.04-.27,1.9.24,2.85.38c1.8.28,3.59,1.28,5.46.25.1-.06.32.12.49.18.37.14.74.32,1.12.4c1.25.25,2.49.55,3.75.65c1.2.09,2.41-.16,3.63.03.32.05.66-.17,1-.2.86-.09,1.72-.14,2.58-.21c1.09,1.16,2.56.52,3.83.8.11-.19.04-.8.44-.34.81.93,1.85,1.12,2.95,1.22.66.06,1.41-.67,2,.22c0,.01.37-.18.55-.31.17-.13.31-.3.47-.45.05.27.16.55.12.81-.03.26-.07.59.23.37.37-.26.46-.07.79.03.99.3,2.05,1.02,3.1.2.3-.23.27-.1.47.08.29.25.73.4,1.12.47c1.73.29,3.5.3,5.16.99.37.15.85.03,1.28.04.8.01,1.65-.16,2.19.7.12.18.39.31.62.37c1.37.33,2.75.65,4.14.92.35.07.79-.21,1.1-.09c2.58,1.05,5.51.53,8.03,1.81c1.25-.37,2.16.49,3.19.89.57.22,1.13.48,1.72.61c2.85.64,5.75.92,8.66,1.2.83.08,1.95-.08,2.43.38c1.05,1.03,2.6.57,3.6,1.52.09.09.47-.13.73-.22.41.07.89.01,1.22.2c1.42.83,3,.88,4.56,1.07.54.06,1.06.31,1.58.49s1.03.41,1.57.55c1.61.41,3.2.84,4.71,1.54.31.14.69.13,1.02.24.78.26,1.64.1,2.33.85.45.48,1.36.81,2.02.73c1.12-.13,2.08.29,2.89.75c1.48.83,3.44.55,4.63,2.06.22.28.68.11.87-.34.08-.19.25-.34.39-.5-.19,1.09.35,1.73,1.35,2c1.9.51,3.63,1.37,5.3,2.37.47.28,1.02.42,1.45.74c1.08.78,2.1,1.64,3.17,2.43.16.12.49.09.7.02.33-.12.62-.33.98-.54.06.39.05.7.16.96.08.19.3.32.45.48.11-.13.25-.25.34-.39.31-.52.61-1.04.9-1.55-.97-.82-1.89-1.77-3.3-1.85-.15,0-.39-.14-.42-.25-.24-.97-1.17-1.11-1.8-1.62-.49-.4-1.29-.38-1.51-.72-.88-1.36-2.3-1.2-3.55-1.5-.79-.19-1.64-.14-2.06-1.08-.1-.23-.47-.47-.73-.49-.8-.06-1.29-.6-1.92-.96-1.42-.8-2.92-1.72-4.48-1.92-1.36-.18-2.48-.73-3.71-1.11-1.91-.6-3.61-1.84-5.71-1.87-.17,0-.36-.09-.52-.18-2.21-1.22-4.54-2.05-7.04-2.43-1.27-.19-2.57-.37-3.8-.72-2.34-.68-4.64-1.5-6.96-2.25-.23-.07-.48-.13-.72-.14-1.2-.05-2.41-.08-3.61-.14-.22,0-.56-.04-.64-.18-.3-.52-.63-.41-1.09-.27-.32.1-.71-.03-1.07-.09-.91-.16-1.81-.33-2.71-.5-.31-.14-.6-.36-.92-.43-.87-.18-1.82-.15-2.63-.47-2.05-.82-4.09-1.49-6.32-1.55-.97-.02-2.03,0-2.87-.39-1.67-.79-3.45-.76-5.17-1.1-.82-.16-1.79-.06-2.45-.47-1.05-.65-2.09-.77-3.24-.76-.47,0-.94-.17-1.41-.26-.54-.1-1.07-.23-1.61-.27-.5-.04-1.22-.65-1.42.41-1.74-1.32-3.56-1.03-5.28-1.22-.29-.03-.68.15-.88.01-1.56-1.08-3.62-.21-5.15-1.34-1.89-.04-3.4-.2-4.92-.34-1.25-.12-2.5-.17-3.78-.08-1.99.14-4.01-.05-6.01-.06-.33,0-.69.37-.98.3-.32-.07-.56-.47-.85-.69-.76.1-1.19.36-1.58.31-.52-.06-1-.37-1.51-.54-.28-.09-.6-.18-.88-.14-1.53.2-2.98-.14-4.43-.53-.74-.2-1.5-.38-2.26-.47-.41-.05-.86.07-1.26.18-.43.12-.52.3-.23.78.29.49.45.87,1.12.83Z"
                  fill="#2b231d"
                />
                <path
                  d="M540.58,522.99c.21.04.4.14.6.22-.46.22-.71.14-.96.05.06-.22.21-.3.36-.27Z"
                  fill="#2b231d"
                />
                <path
                  d="M535.65,520.34l-.26.52c-.11-.42.08-.47.26-.52Z"
                  fill="#2b231d"
                />
                <path
                  d="M494.11,507.84c-.18.24-.32.15-.46.06.15-.02.31-.04.46-.06Z"
                  fill="#2b231d"
                />
                <path
                  d="M475.97,504.87c.49.17.09.42.02.65-.2-.15-.41-.29-.61-.44.2-.08.44-.26.59-.21Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M467.39,655.44c.25.02.51.04.76.06.19-.12.4-.23.56-.38.21-.2.38-.44.56-.67-.8-.43-.19-1.28-.57-1.89-.39-.64-.46-1.48-.72-2.21-.23-.63-.52-1.25-.81-1.86-.08-.16-.28-.4-.37-.38-.38.1-.94.47-.49-.39.23-.45.28-.83-.06-1.19-1.19-1.24-1.04-3.12-2.13-4.4.09-.98-.91-1.35-1.18-2.03-.45-1.17-.92-2.28-1.52-3.4-.97-1.82-1.52-3.86-2.44-5.72-.46-.93-.65-1.96-1.14-2.84-.58-1.03-.8-2.19-1.44-3.2-.44-.69-.5-1.61-.84-2.38-.39-.89-.91-1.72-1.37-2.57-.17-.33-.39-.65-.47-1-.58-2.38-1.62-4.55-2.85-6.66-.56-.97-1.43-1.88-1.3-3.17.02-.21-.18-.45-.3-.66-.42-.72-.85-1.44-1.27-2.16-.56-.78-.69-1.89-1.73-2.3-.59-1.6-1.49-3.02-2.32-4.5-.52-.94-1-1.95-1.59-2.85-.21-.32-.19-.59-.27-.87-.24-.78-.74-1.49-1.14-2.22-.86.34-.66-.76-1.05-.82-1.32-.21-.2-.61-.14-.95.02-.12-.13-.33-.25-.42-.45-.31-.92-.58-1.38-.87.1-.4.4-.93.25-1.16-.59-.89-.29-2.14-1.29-2.89-.49-.37-.73-1.1-1.03-1.69-.67-1.3-1.31-2.62-1.97-3.94-.52-2.18-2.04-3.89-2.82-5.97-.44-1.18-1.11-2.3-1.8-3.36-.55-.85-.21-2.26-1.59-2.6-.05-.01-.04-.31-.04-.48c0-.29.12-.66-.01-.85-.68-.97-1.64-1.78-1.56-3.13-.72-1.14-1.37-1.94-1.65-2.86-.23-.74-.37-1.44-1.02-1.92.2-1.12-.52-1.81-1.15-2.56-.16-.19-.22-.49-.25-.75-.15-1.16-.72-1.92-1.91-2.14.03-.65.08-1.3.1-1.95c0-.15-.06-.4-.16-.45-.76-.37-.53-1.37-1.07-1.77-.78-.56-.66-1.4-.95-2.12-.17-.42-.44-.76-.53-1.27-.1-.58-.74-1.1-1.24-1.53-.1-.09-.66.55-.62-.32.03-.59-.26-1.17-.31-1.81-.05-.84-.32-1.83-1.19-2.38-.26-.07-.58-.26-.7-.17-.85.64-.97,1.3-.44,2.24.21.37.48.72.76,1.05.2.23.63.36.69.6.09.37-.07.8-.11,1.2.61,1.87,1.53,3.35,2.72,4.68.1.27.14.62.33.79.94.87,1.43,1.86,1.23,3.19-.05.36.22.78.4,1.14.75,1.52,1.6,3,2.28,4.55.8,1.83,1.44,3.73,2.21,5.57.23.55.9,1.04.89,1.54-.04,1.32.79,2.11,1.46,3.03.23.15.33.29,0,.39.47.98.91,1.97,1.41,2.94.52,1.02,1.31,1.96,1.59,3.04.28,1.1.63,1.98,1.53,2.68.29.23.47.69.56,1.08.22.92.23,1.9.54,2.78.38,1.07,1.17,1.92,2.01,2.7-.05.68-.12,1.3.57,1.81.79.58.86,1.74,1.41,2.4.74.87,1.09,1.85,1.55,2.82.31.15.24.27-.02.38.32.56.88,1.11.91,1.69.05.99.47,1.51,1.34,1.69.57.12.26.35.21.61-.05.21-.07.59.03.64.76.39,1.01.98.85,1.79c1.08.78.97,2.1,1.44,3.15.14.32.45.56.66.84.43.58,1.22,1.17,1.21,1.76c0,1.31,1.18,1.88,1.43,2.94.27,1.14.88,1.99,1.82,2.66.21.15.34.51.4.79.24,1.19.92,2.12,1.68,3.02-.34.1-.26.22-.04.35.25-.19.34-.06.02.03-.05.72.01,1.31.54,2c.93,1.22,1.83,2.69,1.96,4.17.13,1.5.75,2.72,1.42,3.83c1.06,1.76,1.86,3.6,2.6,5.49.01.63.1,1.28.75,1.53.55.21.38.47.24.82-.06.15-.02.48.04.5c1.09.36.65,1.48,1.07,2.18.5.85.69,1.88,1.05,2.82.14.37.38.7.58,1.05.42.88.88,1.74,1.27,2.63.32.73.36,1.76.9,2.18.72.57.58,1.34.96,1.94c1.05.65.29,2.17,1.61,2.15-.51,1.14.5,1.48,1.06,2.06-.55.68-.43,1.4-.02,2.07.6.99,1.24,1.95,1.86,2.93.14-.27.26-.21.37.05Z"
                fill="#2b231d"
              />
              <path
                d="M534.32,618.87c-.83-1.02-1.71-2.04-2.76-2.82-1.64-1.22-2.98-2.72-4.42-4.14-.81-.89-1.57-1.83-2.45-2.64-.69-.63-2.12-1.94-2.5-2.59-.5-.85-1.46-1.75-2.26-2.1-.01-.18.04-.42-.05-.52-.4-.43-.79-.94-1.29-1.2-.62-.31-.79-.87-1.15-1.33-1.05-1.33-2.3-2.5-3.42-3.78-.61-.7-1.76-.8-2.03-1.87-1.11.12-1.46-.48-1.73-.98-.55-1.02-1.33-1.79-2.18-2.56-.81-.73-1.42-1.67-2.26-2.36-1.64-1.35-3.39-2.58-5.06-3.89-.8-.63-1.53-1.34-2.29-2.02-.87-.72-1.76-1.41-2.58-2.18-.53-.49-.96-1.1-1.46-1.64-1.68-1.82-3.73-3.17-5.75-4.56-.75-.51-1.54-1.14-1.95-1.91-.45-.85-1.13-1.27-1.86-1.7-.47-.28-.98-.37-1.18-1.1-.2-.71-.85-1.19-1.78-.77-.29.13-.7.01-1.08,0c.29-.89.15-.83-.32-1.82-.56-1.19-1.84-1.54-2.55-2.52-.66-.59-1.26-1.28-2-1.73-1.28-.76-2.5-1.62-3.49-2.67-1.31-1.39-2.95-2.36-4.32-3.65-.15-.14-.6-.74-1.09-.27-.27-.3-.57-.57-.81-.89-.3-.38-.56-.79-.84-1.18-1.15-1.23-2.47-2.19-3.85-3.08-.56-.36-.9-.96-1.72-.52-.35.19-.27-.19-.23-.43.03-.15-.05-.46-.09-.46-1.03-.03-1.09-.95-1.48-1.58-.37-.59-.85-1.04-1.61-1.11-.22-.02-.52-.18-.62-.37-.86-1.56-.85-1.56-2.57-1.96-.06-.01-.06-.31-.08-.49-.27-.12-.67-.18-.78-.39-.72-1.34-1.92-2.15-3.11-3-.4-.28-.71-.69-1.03-1.07-.81-.92-1.56-1.89-2.41-2.78-.86-.9-2.22-1.29-2.7-2.59-1.65-1.13-3.02-2.28-4.07-3.79-.23-.33-.62-.61-.99-.77-1.36-.58-2.05-2.06-3.53-2.51-.51-.16-.89-.38-1.32.06-.31.34-.37.55-.31.7.66,1.67,2.34,2.4,3.43,3.68.11.13.47.12.68.05.45-.15.86-.41,1.3-.57.19-.07.45-.04.63.05.1.05.15.32.13.47-.05.32.19,2.05.37,2.34.17.26.31.53.51.76.68.77,1.13,1.8,2.26,2.09c1.81,1.77,3.59,3.57,5.44,5.3c1.25,1.16,2.61,2.21,3.92,3.31.14-.22.29-.44.43-.67.35,1.02,1.55,1.57,1.57,2.78c1.1.96,2.19,1.94,3.32,2.86.68.55,1.71.85,2.12,1.53.91,1.53,2.43,2.3,3.66,3.42.88.67,1.74,1.34,2.64,1.96.1.07.37-.1.57-.18.36.91.82,1.74,1.6,2.37.85.69,1.64,1.44,2.46,2.17.87.77,1.71,1.57,2.62,2.3.37.3.96.34,1.29.67c1.51,1.5,3.03,2.97,4.9,4.03.15-.25.28-.26.38.04.3.21.62.39.87.65.2.2,1.77,1.91,1.99,2.03.98.57,1.87,1.2,2.37,2.29.2.43.56.82.94,1.11.8.62,1.65,1.18,2.49,1.76.25.28.46.54.68.8.23.59.53,1.08,1.26,1.13.19.01.42.11.55.25c1.31,1.31,2.56,2.69,3.93,3.93c1.33,1.21,2.8,2.27,4.21,3.4.36,1.24,1.45,1.66,2.27,2.31.5.4,1.14.69,1.52,1.18.62.81,1.39,1.12,2.34,1.15.11.33.14.8.37.94.92.54,1.41,1.48,2.18,2.16.81.72,1.66,1.4,2.39,2.19.57.62.91,1.45,1.94,1.5.19,0,.44.36.54.6.46,1.22,1.36,2.01,2.41,2.7.38.25.73.56,1.01.92.4.51.62,1.34,1.12,1.56.83.36,1.16,1.16,1.87,1.61.75.48,1.68,1.07,1.94,1.82.4,1.17,1.45,1.72,1.98,2.72.28.53.72,1.07,1.23,1.37c1.32.78,2.17,2,3.19,3.07.33.35.75.61,1.12.91l2.02,1.55c1.1,1.57,2.6,2.69,4.15,3.77.81.57.78-.54,1.28-.52-.19-.17-.39-.35-.58-.52-.11-.52-.05-1.18-.35-1.55Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M545.69,608.23c-.2-.13-.41-.26-.62-.4-.07-.23-.07-.52-.22-.67-1-1.05-2.05-2.05-3.04-3.11-.54-.58-.88-1.4-1.5-1.83-1.11-.77-1.99-1.72-2.84-2.75-.58-.7-1.15-1.42-1.83-2.02-1.08-.95-2.26-1.78-3.36-2.69-.55-.46-.99-1.07-1.55-1.52-1.32-1.05-2.72-2.01-4.04-3.07-.78-.62-1.59-1.25-2.18-2.04-1.27-1.7-3.1-2.72-4.66-4.07-1.23-1.07-2.73-1.84-3.97-2.91-.76-.65-1.55-1.1-2.46-1.41-.15.27-.28.26-.38-.04-.23-.15-.45-.3-.68-.44.67-.31.3-.68-.04-.92-.8-.55-1.68-.99-2.47-1.56-.74-.55-1.4-1.21-2.11-1.81-.13-.11-.38-.25-.49-.2-.78.36-.88-.36-1.24-.71-.47-.47-.99-1.27-1.47-1.26-.71.02-.95-.17-1.25-.71-.16-.3-.62-.73-.81-.67-.85.27-.86-.43-1.18-.83-.42-.52-.89-1.08-1.62-.32-.08.08-.43-.1-.65-.16.05-.16.06-.41.16-.46.62-.3.22-.6-.02-.81-1.16-.99-2.23-2.12-3.73-2.65-.8-.29-1.89-.48-2.28-1.08-.71-1.1-1.77-1.69-2.69-2.47-1.48-1.27-3.09-2.39-4.64-3.57-1.54-.19-2.21-1.12-3.04-1.8-1.68-1.37-3.69-2.32-5.15-3.99-.77.17-.99-1.47-1.99-.62-.49-.57-.64-.98-.93-1.25-.66-.63-1.37-1.21-2.08-1.79-.96-.78-1.84-1.77-2.93-2.26-1.73-.77-2.91-2.22-4.51-3.12-.69-.68-1.38-1.36-2.07-2.05-.77-.46-1.13-1.73-2.4-1.19-.51-1.44-1.93-1.79-3.06-2.45-1.08-.63-1.92-1.44-2.59-2.46-.13-.2-.31-.43-.52-.51-.49-.2-1.11-.19-1.49-.5-.39-.32-.43-1.07-.82-1.36-.93-.68-1.74-1.44-2.55-2.25-1.26-1.26-2.94-2.03-4.22-3.31-.34-.34-.78-.29-.98.31-.07.2-.27.35-.41.52.1.26.2.52.3.78.55.47.71.91.94,1.31.38.68,1.4.43,1.66.76.42.54.65,1.24,1.32,1.61.27.15.57.25.81.44.23.18.43.43.57.68.26.47.54.37.85.08.09.28.17.57.29.84.07.16.23.29.37.4c1.56,1.28,3.12,2.56,4.68,3.83.04.91,1.06.59,1.49,1.17.55.74.81.57,1.09-.57.55,1.3.85,2.5,2.37,2.82.36.98,1.32,1.19,2.09,1.66-.32.11-.23.23-.03.35.29.88,1.18.86,1.76,1.27.11-.73.93-.47,1.26-.94-.04.59-.14,1.11-.31,1.62s.07.46.43.42c.1-.01.26.27.35.43.17.29.24.8.46.86c1.54.46,2.39,2.1,4.04,2.33.52,1.44,1.7,1.72,2.5,2.4.17.24.29.55.51.71c2.04,1.46,4.09,2.89,6.15,4.34-.07.64.43.96.86,1c.47.04.7.21,1.05.49c1.35,1.08,2.89,1.94,4.12,3.13.48.46,1.12-.03,1.49.73.38.78,1.16,1.63,1.94,1.87.81.24,1.39,1.04,2.33.9-.36.99.39.98.75,1.2.26.15.48.38.72.56.99.72,1.9,1.62,3,2.07.72.29,1.48.54,2.21.85.16.07.61.06.2.36-.36.27-.34.46-.05.7.42.36.89.66,1.28,1.06c1,1.03,2.7.92,3.41,2.18.42-.31.75-.55,1.08-.78-.19.9.05,1.58.98,1.93.26.31.49.67.81.91.42.31.92.52,1.38.77.4.23.8.66,1.2.66.94,0,.15,1.07.83,1.17.24.03.48.14.69.26.37.22.86.4,1.05.73.56.99,1.57,1.35,2.4,1.96.39.29.85.54,1.15.91c1.02,1.3,2.41,2.04,3.83,2.77.43.22.94.47,1.18.85c1.15,1.79,2.97,2.9,4.51,4.24c2.2,1.91,4.47,3.77,6.65,5.71.74.66,1.71.26,2.29.99.04.05.36-.13.55-.2.07.29.15.58.23.86-.38.1-.3.22-.04.35.57-.42,1.09-.5,1.65-.58-.29,1.5-.34,1.53.47,2.74.97,1.46,2.16,2.76,3.44,3.96.4.38.83.83,1.32.99c1.77.54,2.52,2.17,3.66,3.22.36-.26.77-.5,1.13-.82.41-.37.34-.75-.13-1.06Z"
                  fill="#2b231d"
                />
                <path
                  d="M505.48,576.79c.07-.38.15-.46.21-.55.02.47-.11.5-.21.55Z"
                  fill="#2b231d"
                />
              </g>
              <g>
                <path
                  d="M549.14,545.95c-.14.07-.44-.07-.61-.19-.61-.47-1.27-.91-1.78-1.48-1.04-1.17-2.9-1.23-3.66-2.74-1.81-.53-3.61-1.07-5.43-1.57-.63-.18-1.7-.07-1.86-.42-.31-.67-.92-.7-1.28-1.09-1.77-1.96-4.11-2.79-6.54-3.45-.82-.22-1.66-.39-2.49-.58-.13.11-.25.21-.38.32-.67-1.27-1.55-2-2.68-2.33-1.87-.53-3.55-1.49-5.41-2.06-2.22-.69-4.33-1.71-6.52-2.52-1.12-.41-2.29-.66-3.44-.98-.88-.38-1.72-.85-2.62-1.13-1.63-.51-3.34-.83-4.95-1.39-1.44-.5-2.92-.88-4.28-1.66-1.04-.6-2.29-1.06-3.48-1.13-2.08-.13-3.88-1.14-5.86-1.55-.6-.12-1.21-.29-1.76-.54-2.21-1.02-4.38-2.11-6.88-2.21-.29.48-.66.6-1.13.27-.54-.63-1.11-1.15-1.61-1.09-1.71.23-2.84-1.14-4.38-1.38-1.02-.16-1.91-.96-2.93-1.25-2.88-.81-5.79-1.5-8.69-2.24-.73.44-1-.54-1.65-.5-1.93.1-3.58-.72-5.16-1.74-.15-.1-.33-.19-.51-.2-.54-.03-1.1.05-1.63-.03s-1.04-.34-1.57-.45c-1.27-.25-2.56-.41-3.82-.69-.45-.1-.88-.68-1.25-.62-1.47.25-2.58-.47-3.77-1.08-.13-.06-.39.13-.6.23-.51.2-.94-.81-1.5-.11-.56-.63-1.01-1.01-1.47-.71-.31.19-.33.85-.46,1.3.45.86.95.78,1.46.48.15-.25.29-.32.39.03.54.21.85,1.14,1.53.73c1.05-.63,1.56-.1,1.95.72.38.82,1.07.73,1.7.65.96-.11,2.03-.06,2.42.53.5.74.76.38,1.01-.08.49-.89.45-.18.59.16c1.13.39,1.87.82,2.83.87.53.03,1.01.97,1.64.07.52.38,1.09,1.13,1.56,1.07.76-.09,1.09.22,1.57.61.23.19.85.15,1.15-.03.51-.31.6-.06.78.31.17.35.24,1.03.81.75.77-.37,1.32.43,1.92.25.8-.24,1.16.44,1.75.58.51.12,1.05.11,1.58.16.33.48.69.5,1.09.09.61.18,1.21.35,1.82.53.25-.18.36-.83.75-.28.76,1.06,1.2,1.4,2.52,1.75c1.11.99,2.22,1.02,3.23,1.32c2.71.97,5.23,1.65,7.71,2.43.99.31,2.03.43,2.97,1.03.79.5,1.77.84,2.8.68.28.52.55.86,1.3,1c2.02.36,4,.93,5.97,1.5.89.26,1.67.95,2.7.6-.27.93.55.73.87.87.51.22,1.03.42,1.55.61.57-.2.76-.4.97-.59.13.24.19.62.39.7c1.11.49,2.14,1.14,3.39,1.28.88.1,1.79.24,2.59.58c1.97.84,4.02,1.49,6.04,2.18.25.09.61.14.73.32.53.83,1.42.94,2.22,1.16.97.27,1.95.46,2.89.86.85.36,1.9.7,2.59-.46.06-.1.32-.08.5-.12-.07.18-.18.36-.21.55c1.23.43,1.8,1.41,2.5,2.05.66.61.79-.06,1.15-.17.09-.15.19-.3.28-.45.26.53.41.58.57.63-.16.07-.33.15-.49.22.31.72.68,1.26,1.64,1.11.35-.05.83.25,1.13.53.66.62,1.51.75,2.3,1.04.69.25,1.4.44,2.07.73.82.35,1.67.7,2.38,1.21.56.4.88-.33,1.13-.15.34.26.44.82.75,1.15.21.22.62.37.93.37.47,0,.83-.05.83.6c0,.07.55.15.84.22c1.52.6,3.03,1.22,4.55,1.8.3.11.64.21.74-.43.08-.47.28-.29.6.12.67.83,1.05,2.07,2.38,2.2.35.26.7.53,1.04.8.11-.21.13-.79.43-.34.5.75,1.13,1.11,1.9,1.53c1.19.64,2.63.86,3.56,1.95.72.84,1.65,1.21,2.7,1.36.19.35.34.73.59,1.03.53.66.63.62,1.02-.18.15-.32.43-.6.5-.92.03-.12-.45-.52-.5-.49-.28.18-.5.46-.71.67q-.15-1.68-1.61-2.81c-.93-.44-.89-1.55-1.96-1.33-.59.12-.9-.91-1.56-1.13-.56-.19-1.01-.75-1.72-.4Z"
                  fill="#2b231d"
                />
                <path
                  d="M457.34,513.22c.05-.35.17-.38.26-.44-.07.36-.17.4-.26.44Z"
                  fill="#2b231d"
                />
              </g>
              <g>
                <path
                  d="M529.92,552.71c-.15-.9-.71-1.51-1.5-1.83-.88-.34-1.82-.53-2.74-.78-.12-.2-.2-.46-.38-.59-1.39-.99-2.87-1.81-4.54-2.26-.44-.12-.86-.33-1.26-.55-2.14-1.2-4.23-2.49-6.41-3.61-1.76-.9-3.62-1.59-5.43-2.41-1.06-.48-2.08-1.05-3.15-1.53-.18-.08-.46.07-.7.13-.63-.57-1.21-1.2-1.9-1.67-.36-.25-.95-.14-1.34-.36-1.75-.98-3.71-1.52-5.39-2.64-.46-.31-.86-.78-1.36-.93-2.03-.62-3.69-2.05-5.78-2.51-.81-.18-1.66-.46-2.33-.92-1.71-1.19-3.98-1.15-5.52-2.63-1.83-.33-3.24-1.7-5.02-2.08-1.13-.24-2.01-1.54-3.37-.84-1.35-1.82-3.33-1.58-4.69-2.48-1.11.76-1.5.07-1.96-.42-.24-.26-.54-.76-.73-.73-1.79.34-3.05-1.11-4.68-1.34-.85-.12-1.59-.88-2.44-1.2-1.18-.44-2.41-.73-3.62-1.08-.57-.29-1.11-.67-1.71-.84-.85-.25-1.79-.22-2.62-.52-.82-.29-1.52-.95-2.34-1.24-1.19-.43-2.45-1.36-3.69.01-.07.08-.56-.09-.72-.27-.08-.09.1-.42.18-.66-.64-.98-1.26-1.61-2.28-1.32-.27.08-.73.15-.84.02-1.06-1.36-2.44-.99-3.8-.8-.87-.38-1.29-.88-2-.67-.39-.35-.71-.41-.77-.56-.22-.54-.54-.27-.84-.19-.02.24-.04.49-.06.73.73.15.97,1.6,2.1.82.02-.02.48.59.74.91.59.31,1.15.67,1.77.88.53.18,1.12.19,1.21-.61c1.01-.9,1.07-.42,1.11.11.42,1.02.94,2.02,2.23,1.89.56-.06.86.13,1.31.36c1.78.92,3.5,1.97,5.42,2.57.34.11.85.39,1.01.26.68-.54,1.35.4,1.65.15c1.16-.97.84.54,1.29.68.23.07.46.17.68.27c1,.46,1.99.93,2.98,1.4.9.43,1.85.73,2.74,1.19.47.25,1.04.32,1.57.47.22-.14.44-.29.65-.43.03.17.06.33.09.5.52.29,1.01.72,1.57.84c1.75.39,3.26,1.74,5.22,1.32c1.03,1.33,2.5,1.38,3.47,2.26.79.71,1.93,1.32,2.96,1.4c1.22.09,2.05.88,3.12,1.14c1.4.2,2.54.53,3.3,1.62.04.06.34-.07.54-.13.55.37,1.03.79,1.71,1.02.5.17.96.02,1.31.16.53.21.87.85,1.36,1.22.38.29.85.49,1.31.67c1.24.49,2.6.71,3.66,1.65.24.22.7.19,1.05.3.28.09.58.19.81.37c2.31,1.72,4.82,3.02,7.67,3.53.49.09.53.37.76.6.25.23.75.61.8.57.6-.59.77.08,1.13.31c1.04.65,2.09,1.3,3.18,1.85c1.42.72,2.92,1.28,4.33,2.02c1.25.66,2.63,1.05,3.75,1.99.64.53,1.47.9,2.27,1.11.73.2,1.22.69,1.83,1.01c1.41.74,2.9,1.35,4.4,1.91.88.33,1.89.3,2.52,1.22.15.22.7.14,1.04.26.25.09.48.27.71.41.25.02.5.05.75.08-.28.7.69.44.71.91.19-.13.38-.27.57-.4.19-.12.38-.24.57-.35.02-.52.31-.72.8-.69Z"
                  fill="#2b231d"
                />
                <path
                  d="M453.53,517.95c-.16-.13.12-.43.12-.43-.04.14-.08.28-.12.43Z"
                  fill="#2b231d"
                />
                <path
                  d="M480.93,530.98c-.3-.14-.27-.24.03-.33c0,.11-.02.22-.03.33Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M559.07,575.07c-.8-1-1.25-2.21-2.37-3.04-1.1-.82-1.97-1.98-2.84-3.07-.86-1.08-2.31-1.61-2.82-3.04-.1-.27-.57-.48-.91-.59-1.12-.37-2.07-.92-2.81-1.88-.3-.39-.93-.53-1.41-.79-1.61-1.73-3.11-3.58-5.53-4.26-.27-.08-.5-.33-.72-.54-.31-.3-.55-.69-.91-.92-1.79-1.15-3.6-2.26-5.46-3.43-.12.52-.23.98-.37,1.61-.32-.72.07-1.31-.5-1.89-.79-.8-1.56-.76-2.46-.49-.05.48-.3.73-.79.69.14.26.34.5.39.78.04.22-.09.47-.16.71.4.29.75.7,1.18.8.67.16,1.22.39,1.79.79c1.08.76,2.3,1.33,3.46,1.98c1.11,1.86,3.38,2.08,4.87,3.41.21.18.7,0,1.01.13.3.12.71.39.75.66.19,1.07.5,1,1.08.24.1-.13.51-.03.77,0-.5,1.24-.48,1.34.29,1.9.37.27.71.56,1.07.85.25.34.43.81.76.99c1.46.77,2.7,1.85,4.02,2.81.65.47,1.2,1,1.71,1.62c1.01,1.24,1.95,2.55,3.44,3.3.19.1.34.31.49.48.55.64,1.04,1.34,1.65,1.92.25.23.86.38,1.12.23.29-.16.44-.69.51-1.08.04-.27-.1-.63-.28-.86Z"
                fill="#2b231d"
              />
              <path
                d="M439.62,524.5c-.76-1.73-1.97-2.54-3.49-2.92-.68-.4-1.09-1.11-1.85-1.47-.7-.33-1.07-1.36-2.12-.94-.12-1.48-1.31-1.05-1.86-1.46-.21-.15-.69-.3-.68-.34.34-1.1-.69-.98-1.19-1.67-.06.68-.14,1.05-.09,1.39.02.11.62.2.62.21-.24,1.04.58,1.41,1.17,1.92c1.01.87,2.03,1.69,3.23,2.35c1.52.84,2.82,2.07,4.26,3.07.57.4,1.26.64,1.89.95.02-.24.04-.48.06-.72-.26-.15-.21-.27.04-.38Z"
                fill="#2b231d"
              />
              <path
                d="M428.38,514.81c.21-.06.54-.05.62-.19.24-.39.38-.84.55-1.24-.97-.39-1.98-.57-2.66-1.14-.78-.66-1.15-.65-1.76.11-.46.57-.7.45-1.01-.26-.29-.66-.57-1.34-.94-1.96-.32-.54-.89-.05-1.36-.16-.29-.07-.39.19-.41.04-.12-.66-.5-.92-1.17-.89-.4.02-.81-.13-1.23-.16-.38-.02-.61.19-.39.56.18.3.44.66.74.77c1.31.48,2.67.82,3.41,2.18c1.32.2,1.34,1.14,1.66,1.78.34.39.67.79,1.01,1.18.15-.29.27-.26.38.05.67.35,1.34.7,2.16,1.13-.12-.68.35-1.42-.73-1.6-.19-.03-.36-.43-.46-.69-.05-.12.07-.31.11-.47.55.58,1.11-.6,1.66-.02-.19.54-.17.75-.18.97Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M430.63,524.49c-.48-.49-.98-.97-1.43-1.48-.79-.89-1.51-1.84-2.72-2.22-.15.28-.27.22-.37-.04-.27-.05-.62-.21-.79-.1-.16.1-.2.53-.15.77.06.27.28.51.44.76.49.3.96.59,1.43.88.56,1.05,1.5,1.72,2.4,2.43.41-.51.67-.86,1.2-1.01Z"
                  fill="#2b231d"
                />
                <path
                  d="M426.11,522.12c-.38-.07-.3-.22-.19-.33.26.06.28.27.19.33Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M413.26,537.77c-1.11-.32-.74-1.23-.82-1.98-.02-.17-.31-.46-.43-.44-.72.12-.88-.28-.85-.84.04-.8-.48-.87-1.05-.9.31,1.23.64,2.46.93,3.69.3,1.27,1.71,1.99,1.55,3.47.23-.33.42-.6.46-.89.11-.7.14-1.4.21-2.11Z"
                fill="#2b231d"
              />
              <path
                d="M444.09,529c-.18-.32-.53-.64-.51-.94.08-1.11-.68-1.51-1.34-2.17-.7-.7-1.54-.62-2.28-.96-.14.23-.29.46-.43.68.41.52,1.17.75,1.12,1.67-.02.3.59.8.99.9.43.1.99-.11,1.28.35.21.33.26.76.37,1.14.26-.22.53-.44.79-.66Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M434,507.28c.2.02.49-.34.63-.59.05-.09-.21-.39-.38-.54-.19-.17-.65-.36-.63-.4.3-.81-.26-.8-.77-.85-1.16-.12-2.32-.26-3.48-.33-.25-.02-.51.21-.77.33.3.28.61.54.89.84.72.78.96.81,1.99.18.07.34.07.89.24.94.73.24,1.51.38,2.28.44Z"
                  fill="#2b231d"
                />
                <path
                  d="M430.38,505.69c-.17-.14-.33-.29-.5-.44.07-.06.14-.11.5-.4.06.21.14.43.18.66c0,.05-.18.19-.19.18Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M422.02,518.69c.39,1.26,1.78.73,2.62,1.26.17.11.68-.31,1.05-.5-1.29-1.41-2.81-2.38-4.43-3.23-.3-.35-.56-.74-.9-1.04-.2-.17-.53-.19-.8-.28.08.26.18.52.22.79.03.19.07.45-.03.57-.3.39-.22.51.25.44.29-.04.58-.11.87-.17.17.15.28.88.28,1.29c0,.13.27.39.38.38.44-.06.37.12.48.47Z"
                fill="#2b231d"
              />
              <path
                d="M426.45,505.32c.04.12.35.16.53.23.08-.27.32-.7.22-.8-.42-.41-.89-.84-1.42-1.04-.6-.23-1.28-.24-1.93-.34-.17.46-.39-.06-.39-.06-.12-.19-.23-.41-.4-.53-.42-.3-.92-.69-.82.36.01.11-.4.27-.64.4.97,1.38,2.56,1.36,3.97,1.75.27.07.59-.87.88.04Z"
                fill="#2b231d"
              />
              <path
                d="M432.97,516.27c.53.37,1.1.31,1.62.5.46.17.8,1.08,1.32.51.24-.26-.13-1.1-.27-1.67-.04-.15-.23-.35-.37-.37-1.43-.2-2.53-1.53-4.1-1.18.11.26.21.52.32.79.13.19.24.44.42.53.2.1.74-.49.6.33-.06.34.2.38.46.56Z"
                fill="#2b231d"
              />
              <path
                d="M432.38,526.12c-.62-.48-.69-1.55-1.7-1.61.29.8-.36.85-.84,1.04.12.24.21.65.37.68.71.11,1,.5,1.12,1.17.06.34.36.64.41.98.14.95.7.52,1.16.42.02-.93.63-1.96-.52-2.67Z"
                fill="#2b231d"
              />
              <path
                d="M418.46,527.22c-.33-.74-.61-1.49-.99-2.18-.29-.53-.79-.79-1.39-.45-.62.35-.29.82-.12,1.27.29.21.83.46.8.61-.28,1.58.9,1.82,1.91,2.22-.13-.28-.29-.55-.35-.85-.04-.19.08-.41.13-.62Z"
                fill="#2b231d"
              />
              <path
                d="M558.04,554.6c.18-.35.43-.68.53-1.05.05-.18-.14-.43-.24-.65-.19-.08-.38-.15-.57-.23.2-.05.4-.1.6-.15-.09-.36-.33-.88-.64-.53-.4.45-.62,1.16-.66,1.77-.02.26.63.56.98.84Z"
                fill="#2b231d"
              />
              <path
                d="M426.74,509.21c.58.44,1.17.88,1.77,1.34.19-.53.31-.84.42-1.16-.3-.27-.59-.56-.91-.79-.72-.51-.82-.46-1.28.61Z"
                fill="#2b231d"
              />
              <path
                d="M468.13,655.52c-.28.35-.52.34-.74-.06-.22.35-.19.86.08,1.05.38.27.93.32,1.42.42.05,0,.21-.28.23-.44.07-.72-.38-.93-.99-.96Z"
                fill="#2b231d"
              />
              <path
                d="M421.33,499.71c-.03-.4-.07-.74-.07-1.07-.01-1.02-.59-.61-1.08-.45-.25.32-.51.65-.76.97.77-.57,1.19.42,1.92.55Z"
                fill="#2b231d"
              />
              <path
                d="M421.04,522.92c-.11-.62-.53-.55-1.04-.58-.39-.02.39-.99-.49-1.02-.5,1.5-.12,1.85,1.53,1.6Z"
                fill="#2b231d"
              />
              <path
                d="M431.16,514.07c-.53-.58-.89-.25-.95.16-.08.46.1.96.17,1.44.63-.07,1.11-.18,1.08-.82-.8-.22-.8-.23-.3-.78Z"
                fill="#2b231d"
              />
              <path
                d="M417.52,499.21c.12.04.35-.22.69-.46-.33-.27-.53-.52-.8-.64-.13-.06-.49.08-.54.21-.21.56.26.76.65.89Z"
                fill="#2b231d"
              />
              <path
                d="M420.88,507.45c-.11-.31-.13-.59-.22-.61-.36-.1-.74-.11-1.12-.16.02.22,0,.62.08.64.36.1.76.1,1.26.14Z"
                fill="#2b231d"
              />
              <path
                d="M424.08,499.44c.23,0,.45-.27.67-.42-.17-.16-.33-.32-.5-.47-.38.08-.75.17-1.12.27.3.46.63.63.95.63Z"
                fill="#2b231d"
              />
              <path
                d="M416.09,515.62c-.06-.19-.25-.34-.38-.5-.09.24-.27.49-.25.71.01.12.36.2.57.3.03-.17.11-.36.06-.51Z"
                fill="#2b231d"
              />
              <path
                d="M430.06,510.02c-.18.1-.31.32-.45.54.32.18.65.36.97.54-.17-.36-.35-.72-.52-1.08Z"
                fill="#2b231d"
              />
              <path
                d="M553.16,529.88c-.29-.11-.54-.23-.8-.28-.11.33.19.51.49.67.02,0,.13-.17.3-.39Z"
                fill="#2b231d"
              />
              <path
                d="M425.68,509.06c.14.23.28.46.42.68.2-.18.4-.36.6-.54-.14-.09-.28-.21-.43-.23-.19-.02-.39.05-.59.09Z"
                fill="#2b231d"
              />
              <path
                d="M421.11,503.37c.02.09.3.1.47.15.01-.18.07-.39,0-.51-.11-.18-.33-.29-.5-.44c0,.27-.04.55.03.8Z"
                fill="#2b231d"
              />
              <path
                d="M417.07,507.1c-.16.52,0,.67.12.83.15-.48.01-.66-.12-.83Z"
                fill="#2b231d"
              />
              <path
                d="M409.7,531.46c-.2.11-.37.3-.51.48.41.19.66.09,1.03-.04-.26-.23-.46-.47-.52-.44Z"
                fill="#2b231d"
              />
              <path
                d="M422.77,498.15c-.06.34.12.47.3.6-.1-.2-.2-.4-.3-.6Z"
                fill="#2b231d"
              />
              <path
                d="M412.31,526.49c-.03.22-.06.44-.09.66.2-.02.41-.05.61-.07-.17-.2-.35-.39-.52-.59Z"
                fill="#2b231d"
              />
              <path
                d="M425.27,508.34c-.34-.14-.68-.29-1.02-.44.19.47.34,1.05,1.02.44Z"
                fill="#2b231d"
              />
              <path
                d="M424.23,507.86c-.17-.08-.34-.16-.52-.24.16.09.33.18.49.27.04,0,.03-.01.03-.03Z"
                fill="#2b231d"
              />
              <path
                d="M423.04,507.51c-.23-.17-.36-.35-.48-.34-.13.01-.25.2-.37.3.5.25.63.13.85.04Z"
                fill="#2b231d"
              />
              <path
                d="M414.89,522.47c-.13-.17-.28-.32-.44-.5-.05.46.13.59.3.72.05-.08.16-.2.14-.22Z"
                fill="#2b231d"
              />
              <path
                d="M431.51,510.34c.23.02.46.04.69.06-.07-.21-.13-.41-.2-.62-.16.19-.33.37-.49.55Z"
                fill="#2b231d"
              />
              <path
                d="M444.38,529.78c-.35-.03-.7-.06-1.05-.09.31.46.66.51,1.05.09Z"
                fill="#2b231d"
              />
              <path
                d="M414.2,528.16c-.1.16-.2.32-.3.48.17-.07.35-.14.52-.21-.07-.09-.15-.18-.22-.27Z"
                fill="#2b231d"
              />
              <path
                d="M526.32,573.35c-.01.23-.03.46-.04.69.13-.22.27-.43.4-.65-.35-.04-.36-.04-.36-.04Z"
                fill="#2b231d"
              />
              <path
                d="M436.68,507.91c.09-.15.17-.29.26-.44-.31.13-.28.29-.26.44Z"
                fill="#2b231d"
              />
              <path
                d="M460.69,522.57c-.23-.02-.46-.04-.7-.06.2.49.43.45.7.06Z"
                fill="#2b231d"
              />
              <path
                d="M432.08,511.87c.02-.23.04-.45.06-.68-.4.19-.42.42-.06.68Z"
                fill="#2b231d"
              />
              <path
                d="M413.19,527.5c-.09-.16-.2-.29-.31-.43.08.16.2.29.31.43Z"
                fill="#2b231d"
              />
              <path
                d="M485.57,500.44c.25.43.53.84.84,1.22c1.56,1.97,3.53,3.49,5.68,4.73c3.76,2.17,7.27,4.72,10.87,7.13c1.66,1.11,3.47,1.83,5.51,2.04c1.21.12,2.39.54,3.57.89.65.19,1.24.6,1.89.77c2.02.54,4.04,1.31,6.1,1.43c3.1.19,5.81-1.07,7.92-3.42.9-1,2.1-1.95,2.52-3.15c1.96-5.6.71-10.76-2.8-15.38-2.01-2.64-4.87-4.38-7.51-6.32-3.61-2.66-7.94-3.72-12.09-5.13-2.5-.85-5.16-1.24-7.71-1.97-1.68-.48-3.37-.37-4.91.1-2.84.85-5.56,2.06-8.43,3.15-1.33,2.07.98,3.35,1.46,5.13-.35.21-.61.35-.86.52-3.21,2.07-3.93,4.96-2.04,8.26Z"
                fill="#ffece5"
              />
              <path
                d="M485.06,626.92c-2.06-.96-4.34-.9-6.56-.98-.51-.02-1.03.32-1.72.55-.14,1.69-.27,3.16-.39,4.64-.07.77.33,1.27.91,1.71c1.95,1.48,4.17,2.15,6.6,2.06c2.46-.08,4.4-2.12,4.05-4.34-.27-1.7-1.38-2.93-2.89-3.63Z"
                fill="#2b231d"
              />
              <path
                d="M529.23,545.15c.7,1.5,1.75,2.83,2.53,4.29.53.99,1.31,1.41,2.37,1.53c2.14.24,3.73-.71,4.53-2.99.47-1.33.66-2.75.98-4.13-.14-.97.01-1.89,0-2.82-.02-1.91-.2-3.82-.15-5.72.03-1.21-.27-2.18-1.07-3.05-.54-.59-.97-1.31-1.58-1.82-.79-.66-1.64-1.33-2.58-1.72-1.76-.73-3.51.12-4.23,1.9-.32.8-.52,1.65-.83,2.45-1.53,4.03-1.83,8.08.03,12.07Z"
                fill="#ffece5"
              />
              <path
                d="M564.66,641.41c-.26-.41-.63-.77-1-1.09-1.35-1.18-2.76-2.3-4.07-3.53-.85-.79-1.57-1.71-2.3-2.51c1.81-3.88,6.41-9.65,9.81-12.33c2.09,1.05,3.89,2.55,5.46,4.32c2.13,2.41,4.04,5.02,6.75,6.88.74.51,1.29,1.34,1.85,2.08c1.72,2.24,3.63,4.3,5.65,6.25.51-.84,1.02-1.68,1.54-2.52.11-.18.21-.37.32-.56-1.83-2.18-3.66-4.37-5.51-6.54-.44-.52-.96-.96-1.44-1.45-1.91-1.94-3.91-3.8-5.69-5.85-1.52-1.76-3.19-3.27-5.16-4.49-.55-.34-.99-.84-1.51-1.29c2.22-3.86,3.71-7.81,4.59-12.13c1.53,1.41,2.79,2.67,4.15,3.82c2.93,2.48,5.95,4.86,8.84,7.38c1.49,1.29,2.8,2.8,4.18,4.22c1.06,1.09,2.13,2.19,3.22,3.31.65-1.27,1.15-2.61,1.59-3.99-.8-.78-1.55-1.61-2.18-2.59-1.04-1.64-2.24-3.24-3.85-4.48-3.48-2.68-6.88-5.46-10.31-8.21-1.78-1.43-3.54-2.87-5.22-4.23-.38-5.94-.81-11.8.34-17.75.44.22.83.38,1.18.6c1.62,1.03,3.25,2.05,4.83,3.15c1.17.81,2.26,1.73,3.37,2.62c2.21,1.79,4.42,3.58,6.6,5.41c1.42,1.19,2.89,2.34,4.15,3.69c2.05,2.21,4.03,4.48,6.02,6.75.39-1.75.77-3.47,1.16-5.18-1.49-1.98-3.23-3.74-5.09-5.4-2.63-2.35-5.17-4.81-7.85-7.09-1.84-1.56-3.81-2.97-5.82-4.29-2.22-1.46-4.57-2.72-6.85-4.09-.25-.15-.43-.42-.63-.62c1.24-5.55,3.46-10.7,5.16-16.2.63.39,1.04.63,1.45.89c2.44,1.59,4.85,3.2,7.31,4.76c1.93,1.23,3.91,2.35,5.46,4.13c1.04,1.2,2.32,2.25,3.64,3.15c2.8,1.89,5.26,4.08,7.33,6.69-.03-1.12-.16-2.25-.41-3.39-.22-1.01-.33-2.05-.45-3.08-2.14-2.01-3.94-4.06-5.86-5.99-1.67-1.67-3.55-3.03-5.6-4.24-3.99-2.37-7.83-4.98-11.88-7.59c1.09-5.14,1.58-10.3.79-15.82c1.11.7,1.91,1.16,2.67,1.69c2.17,1.53,4.24,3.24,6.52,4.59c1.88,1.11,3.7,2.25,5.28,3.75.98.94,1.86,1.99,2.86,2.91.04-.54-.24-1.36-.57-2.17-.67-1.67-1.28-3.36-1.87-5.05-1.92-1.42-3.84-2.83-5.79-4.21-3.28-2.32-6.6-4.6-9.9-6.89-.37-.33-.55-.85-.62-1.39-.26-1.84-.45-3.68-.73-5.52-.3-1.96-.52-3.95-1.06-5.84-.58-2.01-1.44-3.95-2.27-5.88-.38-.9-1-1.69-1.48-2.55-.39-.7-.83-1.39-1.1-2.13-.85-.66-1.69-1.33-2.5-2.03c1.02,2.05,1.8,4.2,2.98,6.23c1.46,2.52,2.26,5.49,3.02,8.34.65,2.44.86,5,1.26,7.51.1.66.2,1.33-.32,1.92-3.43-1.18-5.93-3.63-8.63-5.78-.34-.27-.53-.84-.61-1.31-.43-2.31-.91-4.62-1.19-6.95-.4-3.45-.8-6.89-2.2-10.12-1.43-3.29-3.27-6.34-5.3-9.26-1.19-.82-2.36-1.67-3.5-2.57-2.2-1.73-4.4-3.45-6.97-4.59-4.83-2.14-9.42-4.72-13.96-7.39-1.76-1.03-3.58-2-5.47-2.75-1.74-.69-3.49-1.32-5.25-1.96.88.78,1.76,1.57,2.6,2.4c1.5,1.48,3.02,3.02,3.77,5.03.82,2.2,1.6,4.44,2.06,6.73.71,3.58,1.93,6.77,4.91,9.1.66.52,1.09,1.34,1.62,2.02c1.76,2.26,2.39,5.02,3.37,7.62c1.68,4.45,2.58,9.01,1.94,13.83-.53,3.93-.59,7.89-.31,11.86.24,3.5.77,6.87,2.54,9.98c1.14,2,1.96,4.15,2.24,6.46.41,3.33.5,6.66.08,10-.34,2.7-.73,5.39-1.03,8.1-.24,2.16-.37,4.33-.56,6.49-.04.49-.07,1-.2,1.47-1.37,5.09-3.03,10.09-5.34,14.84-1.49,3.05-3.6,5.61-6.38,7.62-3.06,2.21-6.16,4.37-9.08,6.76-2.9,2.38-4.62,5.68-5.83,9.14-.96,2.73-1.55,5.61-1.57,8.55c0,1.22-.49,2.3-1.33,3.19-2.41,2.56-5.14,4.66-8.55,5.72-5.27,1.64-10.72,1.78-16.17,1.61-2.6-.08-5.19-.48-7.79-.63-1.72-.1-3.47-.14-5.19.05-4.01.42-7.98,1.12-11.83,2.34-2.78.88-5.56,1.74-8.3,2.74-2.14.79-4.38,1.52-6.27,2.74-3.15,2.03-6.53,2.59-10.1,2.35-1.64-.11-3.24-.74-4.87-1.06-1.42-.28-2.49-1.04-3.38-2.13-1.2-1.47-2.71-2.51-4.46-3.26-.71-.31-1.4-.66-2.1-1.02c1.29,2.22,2.58,4.43,3.87,6.65c1.15,1.98,2.33,3.95,3.4,5.97c1.34,2.54,2.87,4.92,4.84,7.03c1.1,1.18,2.2,2.39,3.09,3.72.24.36.51.7.76,1.04c2.65.39,5.21.26,7.75.36c2.91.11,5.81.23,8.72.32.37.01.74-.14,1.1-.11c1.41.09,2.81.23,4.33.36.57,2.71,1.12,5.34,1.7,8.09-1.07,0-2.05.06-3.02,0-2.09-.14-4.18-.28-6.25-.52-2.01-.24-3.92-1.19-6.15-.83-.17.26-.34.53-.5.78.74.81,1.46,1.63,2.14,2.5.37.48.91.84,1.4,1.22.57-.04.91-.43,1.35-1.05.06-.09.21-.12.69-.36l10.93.93c1.05,2.31,2.16,4.77,3.28,7.22.08.17.19.32.28.48.55,1.09,1.11,2.18,1.66,3.26c1.27.47,2.57.85,3.88,1.15c0-1.32-.49-2.48-1.09-3.6-1.36-2.58-2.48-5.25-3.2-8.16c1.76-.03,3.49-.21,5.17-.03c1.69.17,3.45-.68,5.23.34.15,2.63,1.44,4.92,2.68,7.15c1.02,1.83,1.99,3.69,2.91,5.56c1.72.09,3.44.18,5.17.29-.04-.22-.11-.46-.22-.75-.53-1.38-1.16-2.75-1.93-4.01-1.67-2.71-2.82-5.62-3.91-8.73c4.52-1.06,8.69-2.84,13.26-3.49c1.08,2.15,2.36,4.16,3.14,6.35c1.46,4.13,3.88,7.66,6.37,11.15.88-.11,1.75-.24,2.61-.42-1.24-2.75-2.51-5.5-3.62-8.31-1.35-3.44-3.93-6.3-4.74-9.88c3.01-1.59,5.89-3.1,8.88-4.68c1.61,2.33,3.17,4.48,4.6,6.72.8,1.25,1.3,2.69,2.08,3.94c1.72,2.72,3.51,5.42,5.34,8.21c1.21-.44,2.41-.88,3.61-1.35-1.21-2.11-2.42-4.21-4.15-5.95-1.24-1.24-2.24-2.62-2.95-4.22-.58-1.3-1.09-2.65-1.81-3.87-1.06-1.79-2.28-3.49-3.38-5.15c2.96-2.34,6-4.74,9.21-7.28c1.52,1.93,3.1,3.75,4.48,5.72c1.66,2.38,3.06,4.93,5.31,6.89c1.24,1.08,2.18,2.49,2.92,4.04.63,1.32,1.31,2.63,2.15,3.84.71-.48,1.4-.97,2.09-1.48-1.21-3.08-2.92-5.91-4.75-8.69-2.67-4.04-5.42-7.99-8.95-11.34-.3-.28-.47-.69-.79-1.15c1.34-1.03,2.64-1.95,3.85-2.98c1.18-1,2.25-2.12,3.38-3.17c1.15-1.07,2.32-2.13,3.59-3.3.92,1.12,1.66,2.11,2.49,3.03c1.2,1.34,2.45,2.62,3.69,3.92.73.76,1.56,1.43,2.19,2.26c1.16,1.52,2.06,3.27,3.34,4.68c1.81,2,3.4,4.15,4.88,6.37.56-.55,1.11-1.11,1.61-1.73.45-.57.94-1.1,1.42-1.63-.19-.25-.36-.52-.56-.76-2.16-2.64-4.37-5.24-6.6-7.83-.81-.93-1.65-1.86-2.59-2.66-2.43-2.05-4.5-4.43-6.49-6.89-.3-.37-.53-.79-.84-1.26c1.91-1.67,3.84-3.14,5.5-4.88c1.69-1.77,3.11-3.8,4.69-5.76.5.33.89.53,1.21.8c1.03.89,2.09,1.75,3.05,2.71.87.86,1.67,1.81,2.43,2.77c1.34,1.7,2.48,3.58,3.97,5.13c1.94,2.02,3.8,4.05,5.21,6.5.45.78.99,1.53,1.59,2.22c1.21-1.32,2.38-2.56,3.63-3.73-1.02-1.22-2.13-2.38-3.23-3.53-2.82-2.95-6.01-5.54-8.2-9.05Zm-82.6,37c-2.22,0-4.44-.07-6.66-.11-.93-.02-1.56-.51-1.78-1.36-.58-2.21-1.09-4.45-1.6-6.68-.04-.16.09-.35.2-.74c3.01-.1,6.07-.2,9.23-.31c1.33,2.4,2.81,6.63,3.11,8.9-.83.11-1.66.3-2.49.3Zm91.83-99.77c-1.34-.9-2.45-1.64-3.69-2.46c1.5-5.85,1.66-11.78,1.37-18.16c2.7,1.43,5.02,2.66,7.34,3.88c0,.52.11.91,0,1.23-1.63,5.09-3.29,10.16-5.03,15.51Zm-2.36-42.28c.69.43,1.42.93,2.19,1.37c1.39.8,2.75,1.7,4.23,2.29c1.89.76,2.7,2.03,3.05,4c.68,3.81,0,7.54-.27,11.29-.05.77-.38,1.52-.61,2.41-2.93-1.35-5.67-2.61-8.36-3.85-.11-5.97-1.15-11.67-.23-17.51Zm-2.13,43.98c1.06.68,2.18,1.39,3.44,2.19-1.49,6.02-.91,12.1-.66,18.38-3.08-1.79-5.36-4.18-7.72-6.43c1.65-4.73,3.28-9.36,4.95-14.14Zm-7.01,18.98c1.71,1.18,3.25,2.31,4.85,3.34c1.54.99,3.14,1.88,4.66,2.77-.67,4.37-1.99,8.29-4.42,11.97-.47-.4-.83-.64-1.09-.95-1.91-2.31-4.2-4.18-6.64-5.9-.79-.56-1.45-1.29-2.2-1.97c1.64-3.12,3.18-6.07,4.85-9.26Zm-66,77.2c-2.14.76-4.36,1.28-6.48,1.89-1.1-1.6-2.25-5.8-2.79-10.14c3.48-1.09,6.27-3.46,9.83-4.71.91,1.99,1.66,3.87,2.61,5.65.96,1.78,2.12,3.46,3.3,5.37-2.02,1.18-4.36,1.21-6.46,1.96Zm10.47-2.8c-2.3-3.73-3.93-7.55-5.51-11.75c2.78-.83,5.32-1.58,8.02-2.37c1.96,3.22,4.69,5.9,5.81,9.82-2.68,1.39-5.4,2.8-8.32,4.3Zm11.59-6.36c-1.78-2.91-3.48-5.71-5.35-8.76c3.96-.33,7.41-1.39,10.76-3.16c1.67,1.3,2.54,3.1,3.48,4.84-2.64,2.94-5.39,5.46-8.9,7.08Zm11.79-8.98c-1.13-1.77-2.15-3.36-3.12-4.89c2.87-3,5.73-5.98,8.63-9c1.56,1.46,3.09,2.89,4.79,4.48-2.99,3.57-6.7,6.3-10.29,9.41Zm12.78-11.81c-1.7-1.71-3.84-3.13-4.75-5.86c3.14-3.51,6.17-6.9,9.32-10.41c2.09,1.5,4.23,3.01,5.88,5.32-2.72,4.38-6.14,7.98-10.45,10.95Zm12.7-14.17c-2.33-2-4.41-3.8-6.54-5.63c2.14-4.93,4.19-9.68,6.37-14.72c3.34,2.83,6.47,5.49,9.78,8.29-3.72,3.77-7.07,7.54-9.61,12.06Z"
                fill="#2b231d"
              />
              <path
                d="M443.69,621.57c.38,1.81.75,3.66,1.42,5.37c1.37,3.5,3.81,6.34,6.13,9.23.53.66,1.28,1.16,1.98,1.66c1.32.94,2.72.76,4.04.05c1.57-.85,3.04-1.91,4.62-2.74c2.51-1.31,3.6-3.44,3.85-6.13.17-2.16.26-2.22-.89-4.05-1.16-1.84-1.72-3.86-1.89-5.95-.25-3.06-1.58-5.7-2.91-8.35-.59-1.18-1.57-1.96-2.92-2.4-2.44-.8-4.92-1.19-7.46-1.28-1.42-.05-2.69.41-3.55,1.63-.68.96-1.29,1.97-1.99,2.91-1.19,1.61-1.31,3.43-1.11,5.31.17,1.59.35,3.18.68,4.74Z"
                fill="#ffece5"
              />
            </g>
            <g id="e0gYpSRcAlv1349" transform="translate(-1.999982-14)">
              <path
                d="M361.24,500.17c-1.82-2.44-3.65-4.86-5.53-7.25-3.18-4.04-6.41-8.06-9.62-12.08-.85-1.07-1.76-2.09-2.62-3.15-2.66-3.28-5.34-6.54-7.94-9.85-2.26-2.88-4.49-5.78-6.64-8.74-2.19-3.02-4.44-5.98-7.17-8.54-3.67-3.43-7.36-6.85-11.1-10.21-4.38-3.95-8.8-7.83-12.53-12.45-2.95-3.64-6.71-6.41-10.44-9.22-5.5-4.13-10.98-8.32-16.25-12.75-4.76-4.01-9.48-7.99-14.96-11.01-3.86-2.12-7.59-4.49-10.83-7.52-3.25-3.04-6.95-5.39-11.01-7.21-4.6-2.06-8.99-4.49-13.02-7.55-3.08-2.34-6.42-4.24-10.08-5.54-5.29-1.87-10.31-4.29-15.03-7.33-2.53-1.63-5.31-2.66-8.23-3.37-5.43-1.31-10.78-2.86-15.92-5.13-2.08-.92-4.33-1.5-6.56-2.01-3.99-.92-8.02-1.62-12.02-2.5-2.05-.45-4.04-1.2-6.1-1.65-5.27-1.15-10.54-2.28-15.85-3.25-2.61-.48-5.29-.79-7.94-.78-4.35,0-8.64.75-12.91,1.57-3.87.75-7.21,2.62-10.49,4.64-.83.51-1.52,1.27-2.23,1.96-1.11,1.09-2.15,2.24-3.26,3.32-1.58,1.54-2.81,3.28-3.53,5.4-.43,1.29-.96,2.57-1.63,3.75-1.9,3.32-3.23,6.88-3.97,10.59-1.57,7.88-1.78,15.77.43,23.6.35,1.25.69,2.51,1.02,3.77c1.02,3.86,2.52,7.49,4.66,10.9c3.5,5.59,7.46,10.84,11.49,16.03c4.33,5.58,7.95,11.55,10.37,18.21c1.43,3.92,2.59,7.88,2.77,12.1.31,7.07.74,14.13,1.12,21.19.35,6.53,1.2,12.95,3.22,19.22c2.38,7.37,5.44,14.32,9.82,20.78c6.27,9.26,14.94,14.07,25.83,15.3c1.28.14,2.6,0,3.9-.08c2.16-.13,4.32-.29,6.48-.46c1.79-.15,3.64-.1,5.34-.56c5.33-1.44,10.62-3.02,15.69-5.27c2.09-.93,4.26-1.7,6.39-2.54c3.92-1.56,7.81-3.2,11.77-4.66c5.7-2.1,11.45-4.11,17.2-6.08c4.46-1.53,9.01-2.82,13.43-4.44c6.19-2.28,12.48-4.11,18.97-5.36c6.9-1.33,13.83-2.38,20.86-2.49c4.65-.07,9.31-.04,13.96.06c2.91.07,5.82.34,8.72.57c3.89.3,7.78.66,11.67.97c2.59.21,5.22.1,7.72,1.02c3.39,1.25,6.89,1.99,10.5,2.39c5.51.62,10.85,2.01,15.98,4.15c1.66.69,3.37,1.25,5.09,1.79c2.41.77,4.62-.11,5.83-2.37.79-1.48,1.42-3.03,2.13-4.55.18-.37.42-.72.69-1.18.39.42.67.75.98,1.03.9.8,1.9.91,2.71.32.76-.55,1.03-1.64.48-2.69-.51-.98-1.15-1.92-1.82-2.81Z"
                fill="#2b231d"
              />
              <g>
                <path
                  d="M173.54,391.21c.76-.97,1.47-1.96,2.28-2.87c1.11-1.27,2.65-1.79,4.22-2.19c1.25-.32,2.53-.52,3.79-.79.41-.09.95-.11,1.18-.37.68-.77,1.36-.43,1.98-.08c2.42,1.36,4.82,2.76,6.94,4.59.92.79,2.05,1.34,3.04,2.06c1.78,1.3,3.5,2.67,5.3,3.95.93.67,1.97,1.19,2.94,1.81.92.6,1.8,1.28,2.73,1.85c1.73,1.07,3.21,2.44,4.78,3.7c1.05.84,2.21,1.53,3.23,2.4c1.49,1.26,3.2,2.25,4.49,3.78.53.63,1.3,1.1,2.03,1.53c1.94,1.15,3.24,3.02,4.97,4.4c1.1.88,2.29,1.71,3.19,2.78c1.55,1.81,3.69,2.84,5.39,4.43.76.71,1.49,1.47,2.26,2.18.53.49.36,1.08.15,1.54-.44.96-.41,1.86-.25,2.88.31,1.95-.65,3.46-2.73,4.56-1.31.69-2.65,1.32-3.99,1.95-1.05.49-1.19.44-2.07-.45-.48-.48-.98-.94-1.5-1.37-1.32-1.1-2.84-1.95-3.92-3.36-.39-.51-1.08-.79-1.64-1.17-.2-.14-.49-.21-.61-.39-1.17-1.74-3-2.73-4.52-4.08-.45-.4-1.02-.65-1.52-1-2.32-1.62-4.24-3.69-6.39-5.5-1.15-.98-2.37-1.96-3.71-2.62-2.66-1.3-4.84-3.18-6.97-5.17-.39-.37-.9-.62-1.3-.98-.82-.73-1.85-1.13-2.63-1.97-1.12-1.21-2.37-2.42-3.81-3.17-1.81-.94-3.39-2.16-5.07-3.26-1.12-.73-2.08-1.72-3.13-2.56-.96-.77-1.96-1.49-2.92-2.25-1.97-1.56-4.26-2.69-6.05-4.5-.08-.08-.11-.21-.15-.29Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M214.35,452.02c-.08.76-.44,1.26-.97,1.78-1.71,1.67-3.68,2.66-6.11,2.69-.41,0-.84.16-1.21.35-.72.37-1.25.22-1.83-.32-1.57-1.47-3.2-2.87-4.76-4.35-.92-.88-1.75-1.86-2.62-2.79-1.44-1.53-3.03-2.89-4.77-4.06-.36-.24-.76-.46-1.02-.79-2.89-3.64-6.6-6.46-9.87-9.71-2.1-2.09-4.24-4.11-6.47-6.05-1.9-1.65-3.54-3.6-5.33-5.38-.78-.78-1.66-1.45-2.51-2.16-1.08-.91-2.18-1.8-3.27-2.69-.29-.23-.63-.42-.85-.7-1.66-2.09-3.7-3.79-5.75-5.48-1.04-.86-2.02-1.8-3.09-2.62-.51-.4-.73-.8-.63-1.42.22-1.35.5-2.65,1.74-3.52c1.11-.78,2.22-1.56,3.27-2.42.67-.55,1.2-.42,1.83,0c1.38.94,2.77,1.86,4.17,2.75.66.42,1.44.67,2.03,1.17c1.55,1.31,3.04,2.69,4.51,4.09.9.86,1.87,1.55,2.94,2.2c1.57.95,3.04,2.09,4.43,3.3c1.94,1.69,3.97,3.26,6.04,4.8c2.01,1.5,3.78,3.34,5.71,4.95c1.03.86,2.23,1.53,3.29,2.36c1.24.99,2.62,1.9,3.56,3.13c1.17,1.53,2.34,2.96,3.92,4.12c2.84,2.08,5.48,4.4,7.6,7.26.99,1.33,2.24,2.38,3.65,3.33.98.66,2.06,1.49,1.92,3.1-.09,1,.3,2.05.47,3.07Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M227.95,439.66c-.21.16-.41.4-.67.52-.97.41-1.94.83-2.94,1.16-2.76.9-5.46,1.93-7.86,3.61-.35.25-.63.27-.98-.04-1.27-1.13-2.58-2.23-3.85-3.37-.37-.33-.71-.71-.96-1.14-1.16-2.01-2.7-3.62-4.57-5.01-2.63-1.96-4.88-4.33-6.93-6.9-.56-.7-1.36-1.24-2.11-1.76-.64-.44-1.51-.59-1.72-1.53-.03-.15-.25-.33-.4-.36-1.19-.22-1.86-1.2-2.69-1.89-1.32-1.1-2.51-2.36-3.79-3.51-.82-.74-1.69-1.42-2.56-2.11-1.83-1.45-3.69-2.87-5.51-4.34-1.08-.88-2.08-1.87-3.16-2.76-.75-.62-1.59-1.12-2.35-1.72-.91-.71-1.79-1.47-2.67-2.22-.89-.75-1.74-1.57-2.67-2.26-1.82-1.35-3.7-2.61-5.52-3.97-1.1-.82-.99-.93-.55-2.33.78-2.44,2.78-3.49,4.84-4.52.51-.25.9-.12,1.35.23c1.59,1.27,3.15,2.58,4.84,3.7c2.42,1.6,4.51,3.59,6.76,5.38c1.45,1.16,3.05,2.2,4.84,2.94c1.26.52,2.28,1.64,3.39,2.52c1.84,1.45,3.64,2.94,5.5,4.36c1.26.97,2.59,1.84,3.88,2.77.5.36.93.8,1.43,1.16c1.14.82,2.27,1.67,3.47,2.41c1.74,1.07,3.29,2.36,4.81,3.71c1.38,1.22,2.81,2.42,4.37,3.41c3.02,1.91,5.79,4.09,8.44,6.47c1.6,1.44,3.3,2.77,4.98,4.11.55.44,1,.85,1.04,1.64.03.52.33,1.02.54,1.63Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M143.35,423.1c1.83,1.11,3.16,2.61,4.53,4.1c1.23,1.35,2.72,2.49,4.18,3.61c1.7,1.3,3.39,2.57,4.83,4.2c1.66,1.89,3.63,3.5,5.46,5.23c1.03.97,2.07,1.93,3.06,2.94.73.74,1.44,1.44,2.32,2.06c1.24.88,2.16,2.18,3.24,3.28.78.79,1.57,1.56,2.37,2.33.27.25.63.42.85.71c1.66,2.18,3.59,4.09,5.84,5.64c2.62,1.82,4.61,4.23,6.63,6.63.31.37.76.62,1.14.93c1,.81,2.02,1.61,3.01,2.45.53.45.52.97.02,1.43-.59.54-1.2,1.08-1.86,1.55-.28.2-.69.34-1.02.3-1.16-.13-2.3-.38-3.46-.53-1.35-.18-2.73-.51-4.05-.36-.78.09-1.61.87-2.17,1.55-1.36,1.63-1.55,1.72-2.63,0-1.65-2.62-3.71-4.88-5.93-7.03-.8-.77-1.46-1.69-2.17-2.54-2.62-3.13-5.35-6.14-8.44-8.82-.78-.68-1.44-1.49-2.18-2.21-2.96-2.86-6.05-5.56-8.79-8.65-1.17-1.32-2.7-2.31-4.04-3.49-.63-.56-1.19-1.21-1.78-1.83-1.06-1.12-2.12-2.24-3.17-3.37-.25-.27-.54-.54-.69-.87-.1-.22-.09-.66.05-.8c1.26-1.13,2.32-2.38,2.95-3.97.59-1.48,1.23-2.93,1.89-4.49Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M203.53,459.74c-1.76.94-3.32,1.82-5.08,2.13-1.62.28-2.77,1.28-3.96,2.23-.29.23-.52.54-.8.77-.74.6-1.27.57-1.95-.1-1.09-1.08-2.2-2.13-3.22-3.27-.85-.95-1.45-2.1-2.48-2.95-1.47-1.2-2.76-2.63-4.21-3.86-1.37-1.16-2.49-2.54-3.75-3.78-1.97-1.93-3.57-4.25-5.98-5.77-1.07-.67-1.88-1.76-2.78-2.69-2.79-2.88-5.5-5.84-8.38-8.63-1.24-1.2-2.61-2.26-3.7-3.62-.3-.37-.8-.57-1.19-.87-1.3-1.03-2.63-2.03-3.87-3.14-1.89-1.68-3.71-3.43-5.55-5.15-.27-.25-.55-.49-.81-.75-1.06-1.04-1.1-1.37-.14-2.37.98-1.02,2.03-1.98,3.06-2.97.27-.26.58-.47.84-.74c1.29-1.36,1.24-1.31,2.82-.19c2.68,1.89,5.13,4.02,7.15,6.61.19.24.4.48.64.67c1.16.89,2.42,1.69,3.5,2.66c2.29,2.06,4.5,4.21,6.74,6.31.27.25.55.5.83.73c1.8,1.5,3.63,2.96,5.39,4.5c1.16,1.01,2.2,2.15,3.32,3.21c2.55,2.41,5.09,4.83,7.69,7.18c2.68,2.43,5.59,4.62,8.1,7.21c2.33,2.41,5.14,4.21,7.79,6.61Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M165.81,478.78c-1.55-.23-2.45-1.16-3.18-2.24-1.1-1.65-2.55-2.97-4.03-4.25-.93-.81-1.86-1.61-2.73-2.48-1.74-1.74-3.46-3.51-5.15-5.31-1.1-1.17-2.16-2.34-3.41-3.37-.69-.57-1.17-1.52-1.95-2.15-.76-.62-1.48-1.29-2.2-1.97-.94-.89-1.94-1.73-2.77-2.71-1.8-2.12-3.69-4.15-5.78-5.99-.27-.24-.55-.49-.86-.68-1.8-1.08-1.82-1.13-.82-2.91.09-.16.16-.34.28-.48.84-.98.76-1.96.25-3.1-.84-1.86-.43-3.63.73-5.23.7-.97,1.22-1,2.13-.22.14.12.27.26.38.41c1.59,2.25,3.79,3.85,5.89,5.58c1.66,1.37,3.11,2.98,4.67,4.46c1.11,1.06,2.21,2.15,3.4,3.12c2.49,2.03,4.86,4.18,6.9,6.66c1.4,1.71,3.24,2.95,4.73,4.57.46.5,1.11.9,1.37,1.48.52,1.14,1.45,1.81,2.34,2.56.19.16.41.28.58.45c1.03,1.06,2.11,2.09,3.05,3.22c1.68,2.03,3.27,4.13,4.91,6.19.41.51.37.93-.22,1.18-2.27.98-4.54,1.95-6.83,2.86-.56.22-1.2.23-1.68.32Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M197.7,379.43c.12.04.32.06.47.15c1.5.85,2.97,1.7,4.28,2.86c1.73,1.54,3.66,2.84,5.74,3.93c1.66.87,3.14,2.1,4.7,3.18.49.34.96.73,1.46,1.06c2.18,1.39,4.5,2.58,6.34,4.47.58.6,1.38.99,2.1,1.45c2.27,1.47,4.59,2.86,6.79,4.41c1.39.98,2.61,2.2,3.91,3.3.89.75,1.75,1.58,2.72,2.21c1.97,1.29,3.81,2.69,5.43,4.42.61.65,1.51,1.02,2.29,1.5.35.22.65.48.3.87-1.18,1.31-.42,2.53.12,3.78.29.67.5,1.38.8,2.04.25.56.14.96-.35,1.27-1.19.76-2.38,1.52-3.6,2.24-.17.1-.49.04-.7-.05-.22-.09-.37-.32-.56-.48-1.12-.93-2.26-1.86-3.38-2.8-1.46-1.23-2.92-2.44-4.34-3.71-.54-.48-.9-1.15-1.44-1.62-3.14-2.77-6.28-5.54-9.48-8.24-1.16-.97-2.53-1.69-3.72-2.63-1.44-1.13-2.85-2.31-4.18-3.56-1.98-1.87-4.14-3.51-6.58-4.69-1.59-.77-2.76-2.03-4.15-3.04-2.37-1.73-4.6-3.69-7.29-4.96-.27-.13-.53-.33-.75-.53-1.14-1.03-2.29-2.07-3.71-2.69-.79-.34-1.19-.99-1.68-1.61-.38-.48-.32-.8.25-.95c2.56-.66,5.13-1.27,7.75-1.61.12-.02.25,0,.43,0Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M159.68,477.67c-.38.15-.65.34-.95.37-2.29.28-4.39,1.21-6.55,1.93-1.41.48-2.8.41-4.21.24-.85-.1-1.52-.59-1.96-1.28-.86-1.35-2.22-1.95-3.61-2.43-1.09-.38-2.26-.59-3.41-.77-2.55-.38-3.93-2.04-3.74-4.59.04-.49.14-1,.09-1.48-.08-.74-.36-1.37-1.02-1.88-.92-.71-1.71-1.59-2.54-2.42-.85-.85-1.06-1.92-1-3.06.05-.93.09-1.87.24-2.78.31-1.83.02-3.59-.64-5.27-.49-1.24-.2-2.45-.09-3.67.05-.53.51-.72.94-.43.46.31.91.65,1.3,1.04c1.25,1.29,2.44,2.62,3.69,3.9.64.66,1.37,1.23,2.04,1.86c1.11,1.07,2.16,2.2,3.3,3.23c2.19,1.98,4.11,4.25,6.57,5.94.9.62,1.63,1.5,2.39,2.31.73.78,1.26,1.9,2.14,2.37c1.61.85,2.42,2.42,3.75,3.51c1.18.97,2.15,2.18,3.28,3.35Z"
                  fill="#ffaa9c"
                />
                <path
                  d="M204.25,379.41c.62-.19.97-.42,1.31-.39c1.98.14,3.95.31,5.93.52.48.05.94.39,1.4.4c1.77.02,3.16.78,4.5,1.86c1.58,1.27,3.3,2.36,5.19,3.15c2.67,1.12,5.27,2.4,7.97,3.42c2.8,1.06,4.55,3.11,5.82,5.66c1.29,2.6,2.62,5.16,4.21,7.59c1.47,2.27,2.77,4.65,4.13,6.99.09.16.18.34.2.52.03.22-.02.44-.03.66-.21-.08-.47-.1-.62-.24-2.74-2.39-5.34-4.95-8.24-7.13-1.58-1.19-2.93-2.61-4.5-3.77-1.63-1.2-3.44-2.16-5.15-3.25-.56-.35-1.08-.77-1.6-1.18-.15-.11-.24-.3-.38-.4-1.68-1.21-3.38-2.38-5.03-3.62-2-1.5-4.25-2.67-5.97-4.55-.24-.27-.56-.48-.88-.67-1.95-1.14-3.93-2.22-5.84-3.42-.81-.52-1.47-1.29-2.42-2.16Z"
                  fill="#ffaa9c"
                />
              </g>
              <g>
                <path
                  d="M123.9,358.66c.42-.2.72-.43,1.06-.5c3.01-.63,6-1.33,9.03-1.79c1.2-.18,2.52.01,3.54,1.01.42.41,1.01.73,1.58.9c1.73.51,3.26,1.37,4.78,2.34.97.62,2.11,1,3.2,1.41c1.14.43,2.34.73,3.48,1.19.5.2.87.7,1.35.95c1.92,1.02,3.87,2,5.81,2.99.27.14.56.29.85.33c1.15.15,2.02.71,2.89,1.47c1.05.92,2.24,1.75,3.49,2.36c1.7.83,2.76,2.25,3.86,3.64.61.77.34,1.65-.65,2.13-1.05.51-2.15,1.02-3.28,1.28-2.09.48-4.24.72-6.33,1.2-.78.18-1.33.02-1.89-.39-2.26-1.67-4.49-3.37-6.76-5.02-.59-.43-1.3-.69-1.92-1.08-1.25-.79-2.47-1.64-3.71-2.44-1.02-.65-2.01-1.46-3.13-1.85-2.12-.74-3.73-2.32-5.73-3.24-1.09-.51-1.99-1.42-3.04-2.04-1.79-1.05-3.54-2.14-5.5-2.9-1.03-.4-1.9-1.24-2.97-1.96Z"
                  fill="#fec359"
                />
                <path
                  d="M155.63,386.69c-.27.46-.49.95-.81,1.37-.22.29-.53.55-.85.71-.83.41-1.68.79-2.55,1.1-1.14.41-1.65-.69-2.35-1.16-2.13-1.41-4.26-2.87-6.19-4.54-2.1-1.82-4.51-3.15-6.78-4.69-1.33-.9-2.62-1.85-3.96-2.72s-2.74-1.63-4.07-2.51c-1.48-.97-2.84-2.13-4.38-2.99-2.33-1.31-4.23-3.37-6.94-4.02-.29-.07-.58-.25-.8-.45-1.19-1.06-1.98-1.09-.21-2.57.89-.75,1.69-1.62,2.52-2.45.66-.66,1.36-.76,2.17-.23.71.47,1.45.92,2.2,1.32c1.13.6,2.25,1.25,3.44,1.7c2.28.86,4.04,2.54,6.14,3.69c1.23.67,2.43,1.39,3.63,2.11c1.59.95,3.16,1.92,4.74,2.87c1.16.69,2.32,1.36,3.49,2.04.21.12.45.21.65.35c1.79,1.28,3.58,2.57,5.37,3.85c1.2.86,2.37,1.76,3.61,2.56.73.47,1.19,1,1.32,1.88.13.91.39,1.79.62,2.79Z"
                  fill="#fec359"
                />
                <path
                  d="M131.66,416.11c.17,1.6-.65,2.64-2.11,3.27-.28.12-.56.26-.83.4-.86.45-1.72,1.27-2.57,1.26-.75,0-1.55-.86-2.24-1.44-1.5-1.28-2.92-2.64-4.41-3.93-1.54-1.33-2.93-2.8-4.65-3.93-1.53-1.01-2.92-2.26-4.3-3.47-1.34-1.18-2.69-2.28-4.34-3.08-.86-.42-1.71-1.37-2.04-2.27-.65-1.73-.94-3.58-.19-5.42.2-.5.19-1.09.3-1.63.22-1.08.44-2.17.68-3.24.11-.49.49-.54.86-.36.5.24,1.01.51,1.43.87c1.16.99,2.22,2.09,3.41,3.04c1.38,1.1,2.79,2.23,4.32,3.09c1.9,1.07,3.41,2.59,5.02,3.99c1.21,1.05,2.32,2.19,3.69,3.07.71.46,1.27,1.15,1.93,1.71c1.73,1.47,3.48,2.93,5.22,4.38.74.62.82,1.5.94,2.34.06.42-.06.86-.1,1.35Z"
                  fill="#fec359"
                />
                <path
                  d="M146.06,392.26c-.26.26-.47.48-.69.69-1.43,1.34-2.32,2.86-1.77,4.93.1.39.08.93-.11,1.26-.17.29-.71.59-1.01.53-.58-.13-1.18-.42-1.62-.81-2.19-1.89-4.47-3.66-6.78-5.4-.2-.15-.42-.27-.59-.44-1.88-2.06-4.12-3.66-6.51-5.06-2.66-1.55-5.14-3.36-7.47-5.36-.5-.43-1.16-.66-1.72-1.02-.92-.6-1.8-1.24-2.71-1.86-1.57-1.06-2.96-2.35-4.82-3.02-1.29-.47-2.42-1.41-3.61-2.14-.42-.26-.65-.63-.28-1.07.39-.46.78-.98,1.29-1.28c1.27-.75,2.59-1.42,3.93-2.05.33-.15.86-.16,1.18,0c2.2,1.1,4.39,2.2,6.52,3.43.89.51,1.55,1.42,2.42,1.98c2.68,1.71,5.42,3.34,8.13,5c.16.1.35.16.47.29c2.21,2.21,5.14,3.33,7.66,5.07c1.16.8,2.35,1.62,3.35,2.61.9.89,1.84,1.6,3,2.1.49.21.92.61,1.34.96.17.14.24.4.38.65Z"
                  fill="#fec359"
                />
                <path
                  d="M137.51,401.65c-2.13,1.65-3.05,3.68-3.95,5.72-.87,1.98-.79,1.91-2.45.45-2.81-2.49-5.71-4.88-8.58-7.3-1.55-1.31-3.07-2.65-4.67-3.9-.91-.71-1.91-1.36-2.95-1.85-1.57-.74-2.39-2.28-3.72-3.25-.4-.29-.71-.69-1.12-.96-1.67-1.12-3.38-2.19-5.05-3.33-.31-.22-.6-.63-.68-1-.22-1.02-.39-2.05-.47-3.09-.09-1.16-.08-2.33-.09-3.5c0-.98.31-1.21,1.24-.74c1.63.83,3.42,1.32,4.8,2.67.73.71,1.73,1.15,2.64,1.65c2.56,1.41,4.74,3.32,7.06,5.05c1.71,1.28,3.6,2.32,5.35,3.54c2.48,1.72,5,3.38,7.12,5.58.76.79,1.73,1.38,2.6,2.05.91.7,1.83,1.39,2.91,2.21Z"
                  fill="#fec359"
                />
                <path
                  d="M143.68,356.17c1.36-.05,2.27-.14,3.18-.12c2.84.09,5.71-.03,8.5.4c3.06.48,6.13.74,9.19,1.12.89.11,1.8.47,2.58.92c1.99,1.14,4.03,2.15,6.24,2.73c2.67.7,4.68,2.43,6.7,4.16.56.48,1.15.95,1.6,1.53c1.09,1.38.87,1.92-.51,2.54-.87.38-1.77.44-2.69.58-2.91.45-5.81.29-8.67-.16-1.22-.19-2.37-.99-3.49-1.61-1.49-.84-2.99-1.69-4.38-2.69-1.77-1.28-3.79-1.97-5.76-2.83-1.4-.61-2.73-1.38-4.05-2.16-.73-.44-1.32-1.17-2.32-.75-1.68-1.36-3.37-1.96-5.04-2.59-.31-.12-.52-.49-1.1-1.07Z"
                  fill="#fec359"
                />
                <path
                  d="M107.38,411.02c.41.25.84.46,1.22.75c1.74,1.34,3.37,2.86,5.22,4.02c1.95,1.22,3.18,3.15,4.98,4.5c1.53,1.14,2.96,2.41,4.52,3.49.79.55,1.02.98.76,2.04-.33,1.37-.71,2.72-1.06,4.08-.22.85-.71,1.4-1.53,1.31-1.46-.16-2.91-.46-4.34-.78-.2-.04-.46-.6-.4-.86.38-1.79-.6-3.02-1.56-4.34-1.19-1.64-2.24-3.38-3.29-5.11-1.34-2.2-2.64-4.43-3.91-6.68-.39-.68-.64-1.43-.95-2.15.12-.09.23-.18.35-.27Z"
                  fill="#fec359"
                />
              </g>
              <path
                d="M363.88,520.55c.09-1.71-.15-3.45-.42-5.15-.31-2.01-.8-4-1.23-6-.18-.85-.28-1.73-.6-2.53-.73-1.83-1.34-3.8-3.17-4.9-3.6-2.19-7.15-4.48-10.88-6.43-2.9-1.52-5.99-2.7-9.08-3.8-5.42-1.94-10.86-3.85-16.38-5.5-4.91-1.47-9.92-2.63-14.92-3.78-3.49-.8-7.03-1.48-10.57-1.97-3.32-.46-6.67-.6-10.01-.89-4.63-.41-9.28-.5-13.91-.87-4.94-.4-9.76.15-14.58,1.12-4.01.81-7.99,1.77-12.03,2.41-4.01.63-7.84,1.72-11.63,3.16-4.05,1.54-8.25,2.67-12.37,4.03-1.88.62-3.76,1.27-5.55,2.1-2.98,1.38-5.84,3.02-8.83,4.36-2.29,1.02-4.37,2.29-6.39,3.75-2.1,1.52-4.36,2.82-6.58,4.17-1.06.64-2.26,1.08-3.25,1.8-1.54,1.13-2.96,2.43-4.44,3.64-1.44,1.17-2.83,2.43-4.39,3.43-4.17,2.67-7.32,6.33-10.09,10.3-2.02,2.89-3.85,5.94-5.49,9.06-2.66,5.04-5.64,9.92-7.83,15.21-.66,1.6-1.54,3.11-2.22,4.7-.79,1.81-1.53,3.65-2.18,5.52-.72,2.04-1.2,4.18-1.99,6.19-1.28,3.29-1.42,6.66-.98,10.07.6,4.61,1.15,9.21,1.34,13.86.14,3.46.46,6.92.93,10.35.45,3.31,1.18,6.59,1.85,9.87.25,1.21.59,2.42,1.08,3.55.76,1.72,1.25,3.49,1.41,5.36.25,2.98.84,5.88,2.11,8.62.62,1.35,1.04,2.79,1.6,4.17c1.25,3.11,2.45,6.28,4.96,8.65c2.02,1.9,3.55,4.15,4.96,6.47c1.59,2.62,3.46,4.99,5.5,7.25c1.53,1.71,2.92,3.51,4.1,5.51c1.19,2.02,2.57,3.96,4.1,5.73c2.39,2.76,4.91,5.4,7.31,8.16c3.79,4.35,8.15,8.17,13.19,11.09c4.02,2.33,8.13,4.51,12.21,6.74c3.91,2.15,8.15,3.35,12.53,3.9c4.8.6,9.64.85,14.47,1.27c1.42.13,2.86.23,4.24.54c3.31.73,6.66.79,9.98.37c6.53-.82,12.54-3.39,18.57-5.86c3.19-1.31,6-3.2,8.56-5.51.6-.54,1.26-1,1.88-1.52c2.56-2.14,5.12-4.29,7.68-6.44.86-.72,1.64-1.54,2.57-2.14c2.44-1.58,4.35-3.66,6.04-5.98.8-1.1,1.57-2.23,2.46-3.27c2.57-3.02,5.13-6.05,7.81-8.97c3.77-4.11,6.14-9.15,9.24-13.7.1-.15.19-.32.25-.5c1.77-4.63,3.82-9.18,5.25-13.91c2.41-7.98,5.6-15.62,9.06-23.18c2.4-5.24,4.64-10.56,6.7-15.94c1.64-4.27,2.89-8.7,4.36-13.04c2.38-6.98,4.8-13.94,7.2-20.91c1.05-3.04,2.16-6.07,3.12-9.14.88-2.84,1.62-5.72,2.36-8.59.65-2.53,1.19-5.11.99-7.72-.21-2.8-.12-5.56.03-8.35Z"
                fill="#f37e5a"
              />
              <path
                d="M255.95,615.12c.49-.25.95-.41,1.37-.83.94-.95,2.01-1.79,2.99-2.71.8-.74,1.58-1.52,2.35-2.3.47-.48.82-1.24,1.38-1.46c1.01-.4,1.96-.72,2.31-1.88c1.45-.38,2.31-1.57,3.39-2.47.79-.67,1.57-1.37,2.37-2.02.91-.74,1.88-1.41,2.76-2.18c1.34-1.17,2.62-2.4,3.93-3.6c1.17-1.08,2.49-2.04,3.49-3.26c1.29-1.59,2.67-3.04,4.31-4.28c1.76-1.33,3.22-3.01,4.99-4.34c1.61-1.22,3.02-2.71,4.5-4.1c1.44-1.35,2.87-2.72,4.31-4.07.62-.58,1.26-1.13,1.86-1.73c1.23-1.2,2.17-2.72,3.85-3.41.21-.09.4-.32.49-.53.57-1.23,1.83-1.76,2.72-2.66c1.15-1.16,2.46-2.16,3.7-3.23.98-.84,1.18-2.47,2.74-2.74c1.26-1.93,2.59-3.22,4.35-4.12.61-.31,1.05-.98,1.52-1.53.5-.59.77-1.32,1.71-1.55.5-.12,1.02-.73,1.25-1.25.36-.81,1-1.18,1.65-1.65c1.34-.98,2.69-1.96,3.92-3.06c1.17-1.05,2.04-2.39,3.25-3.44c1.56-1.36,2.93-2.94,4.39-4.41.21-.21.48-.37.7-.57c1.26-1.14,2.88-1.86,3.82-3.42.59-.98,1.39-1.96,2.34-2.57.82-.53,1.4-1.21,1.97-1.9.7-.84,1.06-1.98,2.38-2.16.22-.03.37-.46.57-.7.3-.36.57-.75.92-1.06.42-.39.61-.78.28-1.29-.32-.49-.96-.58-1.43-.06-.54.58-1.07,1.24-1.36,1.97-.38.94-.73,1.7-1.95,1.47-.17-.03-.42.21-.58.38-.46.5-.93.99-1.32,1.54-.51.71-.97,1.32-1.95,1.57-.72.18-1.43.8-1.91,1.42-1.14,1.47-2.68,2.45-4.02,3.67-.58.53-1.32.94-1.43,1.87-.03.23-.39.42-.61.62-.77.71-1.52,1.44-2.3,2.13-.82.72-1.49,1.66-2.7,1.86-.26.04-.48.36-.71.55-1.31,1.09-2.63,2.17-3.93,3.28-.32.28-.58.64-.83.98-.69.97-1.02,2.29-2.46,2.55-.13.02-.2.31-.33.43-.45.41-.9.82-1.38,1.18-1.16.89-2.36,1.73-3.51,2.64-.33.26-.69.65-.75,1.03-.18,1.16-.69,1.8-1.91,1.98-.37.05-.71.66-.95,1.07-.31.52-.71.82-1.21,1.18-1.74,1.26-3.63,2.42-4.85,4.27-.5.76-1.09,1.3-1.95,1.61-.88.31-1.6.84-2.27,1.54-1.61,1.7-3.28,3.35-5,4.94-1.31,1.22-2.74,2.29-4.08,3.48-1.89,1.67-3.78,3.35-5.62,5.08-1.35,1.27-2.6,2.64-3.91,3.94-.35.34-.78.6-1.17.91-.71.58-1.47,1.12-2.12,1.76-.64.64-1.11,1.45-1.76,2.07-.78.75-1.88,1.25-2.48,2.11-1.38,1.99-3.56,3.01-5.24,4.62-.98.94-2.03,1.85-3.16,2.59-1.26.82-2.41,1.7-3.36,2.88-.57.72-1.21,1.45-1.96,1.94-.69.45-1.3.9-1.77,1.57-.27.39-.65.73-1.04,1.03-1.47,1.13-2.98,2.21-4.44,3.34-.53.41-.96.95-1.47,1.4-.5.44-.99,1.06-1.58,1.22-.77.2-1.14.65-1.5,1.24-.16.26-.33.61-.58.7-1.75.66-2.85,2.13-4.22,3.25-.57.47-1.34.73-1.8,1.27-1.3,1.55-3.13,2.38-4.61,3.69-1.29,1.15-2.71,2.15-4.02,3.28-1.33,1.15-2.59,2.39-3.89,3.58-.98.9-1.56,2.04-2.07,3.22.14.65.23,1.26.43,1.84.04.11.53.2.71.11.32-.16.71-.42.82-.73.39-1.15,1.44-1.65,2.2-2.44c1.03-1.06,1.98-2.19,3.35-2.86.31-.15.55-.5.75-.8.87-1.3,2.12-2.25,3.45-2.88c1.64-.78,3.04-1.84,4.47-2.9c1.18-.88,2.08-2.05,3.35-2.87c1.84-1.18,3.64-2.47,5.08-4.18.55-.65,1.28-1.21,2.03-1.59Z"
                fill="#2b231d"
              />
              <path
                d="M283.11,608.97c1.01-1.07,1.95-2.23,2.97-3.29c1.49-1.55,3.08-3.02,4.55-4.59c1.39-1.48,2.68-3.06,4.02-4.59.12-.14.23-.33.38-.4c1.48-.65,2.27-2.03,3.33-3.12c1.34-1.36,2.56-2.85,3.99-4.11c2.33-2.05,4.29-4.42,6.3-6.76.6-.7,1.12-1.47,1.8-2.09c1.51-1.37,3.1-2.65,4.64-3.98.69-.6,1.47-1.12,1.76-2.09.1-.33.41-.63.71-.84c1.03-.77,2.21-1.38,2.65-2.72c1.21-.23,1.45-.99,1.89-1.58.48-.63,1.25-1.03,1.27-1.97c0-.18.3-.46.49-.5c1.42-.24,1.95-1.57,2.87-2.38c1.37-1.22,1.91-3.23,3.73-4.08.14-.07.19-.31.31-.45.53-.6,1.06-1.19,1.6-1.77.34-.36.86-.64,1.02-1.06.46-1.22,1.27-2.05,2.27-2.84.64-.51.91-1.48,1.53-2.05c2.99-2.72,5.15-6.11,7.73-9.17.39-.46.59-1.12,1.04-1.49.93-.75,1.75-1.56,2.34-2.61.43-.75.86-1.49,1.32-2.21.68-1.08,1.2-2.27,2.12-3.21.31-.32.19-.75-.19-.93-.21-.1-.56.02-.81.12-.14.06-.21.3-.32.44-.55.73-.99,1.61-1.69,2.14-1.61,1.2-2.72,2.81-3.99,4.29-.84.98-1.65,1.99-2.49,2.97-.48.56-1.05,1.05-1.49,1.64-.68.91-1.2,1.93-2.18,2.58-.56.79-.93,1.54-1.52,2.04-1.33,1.11-2.42,2.42-3.47,3.79-.34.44-.64.96-1.08,1.25-1.24.81-1.98,1.97-2.61,3.25-.16.32-.43.82-.67.83-1.25.08-1.74,1.15-2.43,1.85-1.33,1.36-2.47,2.9-3.71,4.35-.82.96-.99,2.52-2.63,2.72-.21.03-.37.46-.55.7-.14.19-.22.47-.41.58-1.92,1.11-3.14,2.95-4.68,4.44-.47.45-.77,1.09-1.26,1.52-2.62,2.32-5.28,4.6-7.92,6.92-.27.24-.42.61-.65.9-.8,1-1.52,2.06-2.72,2.71-.74.4-1.38.99-1.72,1.88-.17.46-.77.77-1.18,1.14-.5.44-1.02.86-1.5,1.32-.48.47-.9,1.01-1.38,1.49-1.16,1.18-2.37,2.31-3.5,3.52-1.41,1.52-2.75,3.1-4.13,4.64-.12.14-.3.22-.44.35-1.58,1.35-3.37,2.5-4.24,4.53-.09.21-.32.37-.49.55-1.28,1.31-2.57,2.61-3.82,3.95-.58.62-.94,1.51-1.62,1.95-1.93,1.25-2.82,3.56-4.88,4.63-.15.08-.21.3-.33.44-.86.97-1.7,1.96-2.59,2.9-.8.85-1.54,1.84-2.51,2.44-1.66,1.02-2.42,2.93-4.11,3.89-.12.07-.11.33-.22.47-.75,1-1.39,2.14-2.32,2.93-.76.64-1.53,1.25-2.25,1.96-2.47,2.44-5.08,4.74-7.19,7.52-.7.92-1.29,1.94-1.86,2.96-.29.51.47,1.85,1.06,1.92.12-.04.34-.05.45-.16.75-.81,1.55-1.6,2.2-2.49.56-.77,1.11-1.47,2-1.87.27-.12.5-.36.69-.59.97-1.17,2.03-2.23,3.16-3.25.99-.9,1.8-2.01,2.65-3.06.22-.28.39-.65.45-1c.09-.57.26-.85.85-1.21c1.41-.84,2.63-1.99,3.92-3.03.86-.69,1.49-1.59,2.5-2.16.89-.5,1.76-1.24,2.32-2.08c1.7-2.56,4.07-4.47,6.1-6.7c1.54-1.68,3.17-3.28,4.74-4.94Z"
                fill="#2b231d"
              />
              <path
                d="M233.61,611.7c1.06-.54,1.91-1.3,2.69-2.21.84-.98,1.73-2.02,2.81-2.66c2.45-1.45,4.26-3.76,6.83-5.01.22-.11.43-.25.61-.41c1.32-1.17,2.61-2.38,3.96-3.52c1.21-1.02,2.67-1.82,3.65-3.02.68-.83,1.62-.79,2.32-1.38c1.6-1.36,3.29-2.61,4.96-3.88.49-.37,1.02-.68,1.53-1.03.91-.63,1.82-1.26,2.71-1.91.48-.36.91-.8,1.38-1.18c1.14-.93,2.44-1.73,3.39-2.83.73-.84,1.53-1.36,2.52-1.73.63-.24,1.25-.52,1.81-.88c1.4-.9,2.71-1.96,4.15-2.76c1.42-.79,2.42-2.24,4.14-2.56.36-.07.63-.57.98-.83c1.17-.87,2.24-2.01,3.55-2.52c3.46-1.33,5.73-4.44,9.11-5.85c1.16-1.55,3.08-1.95,3.99-3.52.11-.18.41-.27.63-.37c2.89-1.32,5.38-3.23,7.71-5.36.27-.25.51-.53.82-.72.96-.62,1.58-1.54,2.34-2.34.77-.83,1.91-1.32,2.85-2.01.28-.2.43-.58.66-.86.15-.18.31-.36.51-.46c4.25-2.16,8.12-4.82,11.15-8.57.22-.27.56-.48.89-.61c1.38-.51,2.39-1.54,3.45-2.48c1.27-1.14,2.49-2.34,3.75-3.5.22-.2.55-.28.8-.45.45-.31.9-.61,1.32-.97c1.07-.92,2.08-1.9,3.18-2.78c1.05-.83,2.18-1.55,3.26-2.35.17-.13.36-.43.32-.59-.22-.86.45-1.06.95-1.38.4-.25.83-.43,1.41-.72-.53-.32-.89-.52-1.23-.74-.96-.61-1.13-.54-1.47.58-.1.33-.19.86-.41.93-1.04.36-1.56,1.54-2.8,1.61-.48.03-1.07.45-1.38.87-1.15,1.54-2.9,2.26-4.38,3.35-1.88,1.4-3.69,2.89-5.48,4.39-.69.57-1.2,1.37-1.9,1.92-1.31,1.02-2.73,1.9-4.06,2.9-.98.73-1.89,1.58-2.86,2.33-.78.61-1.6,1.15-2.4,1.73-1.12.82-2.05,1.89-3.47,2.34-.59.19-1.15.78-1.52,1.32-.64.94-.93,2.19-2.45,2.1-.15,0-.29.4-.49.53-.5.34-1.04.61-1.55.93-.3.19-.59.4-.87.63-1.64,1.31-3.21,2.7-4.91,3.92-2.29,1.65-4.93,2.81-6.85,4.98-.31.35-.84.51-1.26.76-.68.4-1.39.76-2.03,1.21-1.26.88-2.45,1.86-3.73,2.7-1.34.88-2.78,1.61-4.13,2.47-1.34.87-2.73,1.72-3.92,2.78-1.77,1.58-4.41,1.99-5.66,4.25-1.88.33-2.95,1.31-3.98,2.37-.12.12-.34.13-.5.21-.43.21-.9.38-1.29.65-1.65,1.17-3.42,2.15-4.9,3.59-1.17,1.13-2.53,2.11-3.99,2.92-.57.31-.96.94-1.43,1.43-.25.26-.45.67-.75.77-2.07.69-3.57,2.16-5.08,3.63-.17.16-.36.42-.55.43-1.67.08-2.4,1.58-3.57,2.38-1.56,1.06-2.84,2.52-4.27,3.78-1.2,1.05-2.39,2.15-3.69,3.05-1.34.93-2.38,2.18-3.78,3.09-1.32.87-2.86,1.76-3.58,3.38-.08.19-.39.28-.6.41-1.08.71-2.24,1.31-3.22,2.14-1.21,1.02-2.26,2.23-3.38,3.36-.8.8-1.33,1.78-1.61,2.86-.08.31-.01.85.19.99.29.2.81.26,1.16.14.37-.12.66-.5.95-.8.34-.35.6-.78.96-1.11.57-.54,1.27-.96,1.78-1.56.93-1.1,1.96-2.05,3.24-2.71Z"
                fill="#2b231d"
              />
              <path
                d="M213.59,572.73c1.94-1.28,4.4-1.73,5.84-3.79.15-.22.56-.26.8-.44c1.9-1.38,4.38-1.78,6.01-3.61.15-.17.43-.25.67-.3c1.75-.36,3.05-1.59,4.58-2.38.25-.13.64-.45.6-.6-.21-.96.32-.88.99-.91.96-.05,1.01-.22,1.07-1.43.48-.17.74-.08.89.09.52.56.87.42,1.56.07c1.8-.92,3.71-1.62,5.6-2.34c1.46-.56,2.81-1.21,3.75-2.54.5-.71,1.16-1.24,2.19-1.16.43.04.9-.3,1.33-.51.27-.14.5-.56.73-.54c1.65.16,2.8-1.09,4.27-1.44.35-.08.79-.24.96-.51.5-.76,1.35-.83,2.04-1.2.68-.37,1.31-.85,2.01-1.19c1.59-.76,3.3-1.32,4.81-2.22c2.06-1.21,4.58-1.55,6.32-3.34.11-.11.35-.08.52-.14c2.05-.73,4.15-1.37,5.8-2.92.16-.15.45-.17.67-.26c1.73-.66,3.45-1.31,5.18-1.98.34-.13.79-.26.96-.53.61-1.01,1.66-1.3,2.63-1.61c2.13-.68,3.93-2.3,6.33-2.23.21,0,.42-.24.63-.36.75-.42,1.49-.87,2.26-1.24.89-.42,1.88-.65,2.49-1.54.11-.17.41-.23.63-.3.99-.29,2.03-.44,2.97-.85c2.07-.91,4.15-1.8,6.21-2.71c1.91-.84,3.67-1.91,5.83-1.97.28,0,.56-.23.83-.36c1.43-.7,2.8-1.61,4.31-2.04c2.01-.57,3.93-1.4,5.91-2.02c2.21-.7,4.77-.81,6.51-2.74.14-.15.5-.07.68-.21.97-.74,2.27-.23,3.26-.89.56-.37,1.05-.73,1.87-.41.63.25.75-.46.74-.96c0-.45-.09-.88-.73-.79-1.86.25-3.78.32-5.17,1.9-.18.2-.62.18-.93.27-.77-.14-1.58-.12-2.15.26-1.75,1.13-3.78,1.1-5.69,1.32-1.42.16-2.67.67-3.76,1.35-1,.62-1.93,1.2-3.11,1.45-1.2.25-2.38.63-3.54,1.03-1.51.52-3.09.94-4.47,1.71-.91.51-1.85.97-2.73,1.51-1.11.68-2.55.5-3.51,1.51-.13.14-.47.09-.71.14-.71.16-1.44.3-2.14.5-2.02.6-3.96,1.38-5.69,2.6-.3.21-.61.44-.96.56-1.68.58-3.38,1.11-5.07,1.68-.35.12-.67.32-1.01.47-2.72,1.14-5.06,2.99-7.95,3.9-2.54.8-4.86,2.29-7.28,3.45-.7.34-1.44.59-2.13.95-2.05,1.08-4.06,2.27-6.15,3.28-1.59.77-3.27,1.34-4.91,2-1.2.48-2.5.77-3.23,2.02-.13.23-.52.3-.78.47-1.83,1.2-3.99,1.58-5.96,2.42-.51.22-1.11.37-1.46.75-.54.57-1.15.87-1.87,1.08-.28.08-.53.3-.79.45-1.63.94-3.21,1.98-5.02,2.59-1.16.39-2.31.84-3.41,1.37-.77.37-1.41.98-2.16,1.4-.8.46-1.65.82-2.47,1.23-1.17-.67-1.21,1.06-2.09,1-.96.37-1.55.7-2.12,1.05-.47.28-.9.65-1.39.88-1.74.78-3.6,1.32-4.99,2.75-.24.25-.66.31-.97.5-.94.57-2.06,1-2.76,1.8-.94,1.07-2.1,1.74-3.31,2.27-2.46,1.08-4.64,2.55-6.65,4.28-.74.64-1.46,1.34-2.1,2.08-.7.81-.73,1.75-.12,2.32.66.61,1.28.13,1.83-.25c1.52-1.04,3.02-2.13,4.55-3.17.92-.62,1.89-1.16,2.82-1.77Z"
                fill="#2b231d"
              />
              <path
                d="M349.97,543.43c-.44.12-.94.37-1.21.73-.4.52-.65,1.18-.91,1.79-.33.77-.46,1.66-1.57,1.81-.29.04-.6.44-.79.74-1.01,1.58-1.9,3.24-3.18,4.65-.43.47-.71,1.19-.78,1.82-.1.88-.49,1.3-1.28,1.6-.42.16-.84.55-1.06.95-.88,1.6-2.17,2.9-3.01,4.54-.97,1.89-2.73,3.29-3.59,5.29-.09.21-.33.36-.49.55-.79.97-1.63,1.9-2.36,2.92-1.18,1.65-2.26,3.38-3.44,5.03-.93,1.3-2.17,2.42-2.88,3.82-1.1,2.17-2.83,3.86-4.04,5.91-.66,1.11-1.92,1.7-2.34,3.02-.2.63-.54,1.17-.52,1.92.02.76-1.14.44-1.43,1.08.18,1.22-.72,1.54-1.07,1.64-1.17.33-1.63,1.27-2.22,2.1-.92,1.3-1.62,2.81-2.72,3.93-1.01,1.04-1.79,2.19-2.56,3.38-.16.24-.46.39-.68.59-.32.28-.7.53-.94.87-1.81,2.49-3.6,4.99-5.39,7.49-.53.74-1.01,1.54-1.59,2.24-.99,1.2-1.33,2.78-2.25,3.97-2.06,2.68-3.71,5.62-5.51,8.45-.52.82-1.21,1.57-1.55,2.46-.81,2.11-2.46,3.65-3.59,5.55-1.12,1.88-2.67,3.5-3.89,5.32-.71,1.06-.99,2.4-2.14,3.18-.17.12-.2.44-.32.65-.24.41-.5.81-.75,1.22-.46.73-.93,1.45-1.38,2.18-.28.46-.53.94-.82,1.39-.55.82-.96,1.68-.89,2.71.02.29.03.57.04.86-.17.35-.19.9-.03.96.36.13.81.01,1.22-.01c1.19-1.49,2.39-2.78,3.2-4.28.43-.8.54-1.69,1.29-2.46c1.18-1.2,2.06-2.69,3.04-4.08c1.45-2.06,2.89-4.13,4.32-6.2.17-.25.29-.55.43-.82.56-1.06.98-2.24,1.71-3.16c1.1-1.37,2.19-2.71,2.77-4.39.08-.23.23-.44.38-.64c1.38-1.8,2.78-3.6,4.15-5.41.21-.28.38-.64.45-.98.39-1.82,1.74-3.07,2.75-4.5.32-.45.68-.78.79-1.37.07-.39.37-.75.56-1.12c1.3-2.58,3.75-4.21,5.35-6.54.52-.75.88-1.67,1.54-2.26c1.31-1.16,2.37-2.42,3.12-4.03.5-1.08,1.59-1.89,2.12-2.96.43-.86,1.49-1.09,1.7-1.81.31-1.07,1.14-1.72,1.59-2.63.85-1.71,2.43-2.87,3.37-4.51c1.29-1.38,2.33-2.5,3.29-3.68.38-.47.65-1.05.87-1.63.53-1.38,1.04-2.74,2.34-3.66.47-.34.77-.95,1.09-1.47.23-.36.31-.83.57-1.16c1.4-1.78,3.04-3.38,3.94-5.51.07-.17.16-.39.31-.46.94-.43,1.25-1.3,1.6-2.16.11-.28.28-.55.48-.77.93-1.07,1.76-2.16,2.3-3.52.47-1.18,1.32-2.2,2.06-3.26.98-1.42,2.03-2.79,3-4.22.23-.33.31-.81.34-1.23.06-.67.4-1.11.85-1.58c1.27-1.32,2.47-2.71,3.68-4.08.2-.23.39-.49.5-.77.48-1.2,1.1-2.28,2.04-3.21.46-.45.75-1.12.97-1.75.2-.56-.37-1.18-.95-1.03Z"
                fill="#2b231d"
              />
              <path
                d="M217.02,513.66c0,0,.4-.09.43-.2.19-.62.47-.77,1.09-.43.25.14.71.02,1.02-.12c2.18-.99,4.25-2.22,6.57-2.92c1.1-.33,2.06-1.15,3.33-.85.21.05.55-.05.7-.2.95-.96,2.46-.64,3.44-1.54.17-.15.49-.3.69-.25c1.42.34,2.62-.61,3.94-.66c1.91-.07,3.7-.53,5.53-1.07c1.17-.35,2.51-.41,3.76-.67c2.71-.55,5.44-1.03,8.21-1.08c1-.02,1.97-.51,2.84-.39.91.13,1.65.06,2.5-.17c1.18-.31,2.41-.56,3.63-.61c2.45-.12,4.92-.16,7.37-.1c1.56.04,3.07-.16,4.58-.51.84-.19,1.68-.57,2.52-.58c2.24-.02,4.43-.58,6.71-.45c1.37.08,2.77-.3,4.19,0c.51.1,1.1-.08,1.64-.19c1.43-.29,2.84-.67,4.28-.89.9-.14,1.84-.06,2.77-.07c2.28-.04,4.55-.06,6.83-.11.85-.02,1.86.15,2.53-.23c1.26-.71,2.56-.33,3.7-.21c1.28.13,2.4,0,3.59-.3.46-.12,1.06-.27,1.42-.08c1.05.55,2.04.23,3.07.08.78-.12,1.61-.17,2.38-.04c1.5.27,2.97.7,4.46,1.04.36.08.74.1,1.11.07c1.47-.13,2.93-.3,4.4-.44.29-.03.61-.07.88.01c1.44.43,2.88.49,4.38.27c1.21-.18,2.45-.12,3.68-.18.3-.01.68.03.89-.13.55-.41,1.12-.42,1.76-.39s1.47-.64,1.26-.97c-.23-.37-.73-.56-1.12-.83-1.27.1-2.38.15-3.45.39-.74.17-1.37.29-2.15.02-.79-.28-1.74-.41-2.55-.25-.92.18-1.73.33-2.66.04-.53-.17-1.2.18-1.79.11-1.96-.23-3.91-.53-5.86-.82-.78-.12-1.55-.38-2.34-.44-.98-.08-1.97-.09-2.94,0-1.99.16-4.03-.96-5.98.24-1.41,0-2.5-.2-3.48.06-1.11.29-2.04-.28-3.08-.23s-2.09-.24-3.1.28c-.22.11-.57-.06-.86-.06-2.64,0-5.31-.46-7.89.52-.17.06-.36.1-.54.1-1.54,0-3.08,0-4.62,0-.43,0-.94-.15-1.28.03-1.32.66-2.68.3-4.03.29-.73-.01-1.47.05-2.2.12-3.24.31-6.4,1.16-9.69,1.13-1.95-.02-3.9.24-5.85.38-.88-.23-1.76-.39-2.6-.27-1.88.28-3.73.74-5.6,1.07-.91.16-1.83.25-2.75.32-3.37.24-6.76.33-9.9,1.84-.32.15-.71.16-1.07.21-.6.08-1.22.09-1.82.2-2.66.51-5.3,1.05-7.96,1.55-1.29.24-2.5.64-3.64,1.3-1.15.67-2.69.42-3.69,1.56-.21.24-.8.16-1.22.21-.97.11-2.08-.04-2.9.37-1.52.77-3.27,1.16-4.5,2.47-.14.15-.45.22-.67.22-1.08,0-1.79.77-2.65,1.24-.45.25-.41.55-.24.92.19.43.39.86.61,1.28Z"
                fill="#2b231d"
              />
              <path
                d="M207.99,535.46c1.46-.89,2.94-1.75,4.43-2.57.36-.2.82-.22,1.24-.34.89-.25,1.88-.33,2.64-.78c1.27-.77,2.66-1.27,3.94-1.95c1.38-.73,2.76-.81,4.19-1.07c1.74-.31,3.43-.85,5.15-1.3.24-.06.57-.12.67-.29.53-.86,1.43-.75,2.22-.92.6-.13,1.22-.27,1.76-.54.79-.41,1.62-.47,2.46-.63c1.71-.33,3.36-.99,5.03-1.53.4-.13.77-.33,1.15-.49.67-.28,1.35-.52,2.01-.83.81-.38,1.51-1.35,2.55-.38.11.1.47-.1.71-.1c3.19,0,6.12-1.31,9.18-1.91c1.57-.31,3.11-.97,4.68-1.03c2.79-.11,5.41-1.18,8.17-1.24c1.05-.02,1.71-1.29,2.87-.76c1.76-.65,3.62-.66,5.46-.83.97-.09,2.1,0,2.86-.48c1.53-.95,3.29-.78,4.89-1.36c1.24-.44,2.68-.32,4.01-.53c3.03-.48,6.11-.78,8.98-1.97.16-.06.4-.11.52-.03.74.48,1.13-.1,1.61-.47.51-.4.94-1.05,1.74-.54c1.24-.55,2.49-.27,3.75-.08.28.04.59-.14.89-.2.6-.11,1.2-.24,1.8-.3.77-.08,1.66.13,2.27-.19.69-.36,1.27-.75,2.05-.52s1.21-.61,2.08-.49c1.09.15,2.27-.25,3.39-.5.99-.23,1.96-.59,2.94-.87.16-.05.43-.04.54.06.7.65,1.43.21,2.11.04.74-.18,1.46-.38,2.16,0c.57.32.92.11,1.25-.35.61-.87,1.35-1.21,2.37-.65.19.11.58.14.72.03.98-.81,2.33.41,3.25-.61c1.3.7,2.52-.12,3.77-.15s1.9-.7,2.98-1.68c-1.38-.04-2.4-.17-3.41-.09-.95.07-1.99-.06-2.75.81-.1.11-.62.04-.79-.12-.43-.4-.75-.45-1.3-.18-.46.23-1.06.18-1.59.23-.79.06-1.59.07-2.38.14-2.26.19-4.52.39-6.77.62-1.77.18-3.56.28-5.29.65-3.47.74-6.95,1.33-10.51,1.35-.24,0-.48.09-.73.12-2.68.35-5.32.94-7.96,1.5-1.79.38-3.48,1.13-5.38,1.19-1.15.03-2.3.22-3.48.2-1.09-.02-2.26.08-3.25.49-2.67,1.09-5.51,1.41-8.29,1.79-2.57.35-5.11.67-7.62,1.33-1.42.37-2.89.57-4.34.81-1.51.24-3.08.28-4.55.69-1.36.38-2.7.72-4.1.97-2.3.41-4.55,1.08-6.83,1.6-1.02.23-2.07.28-3.08.53-1.55.39-3.09.85-4.62,1.32-.4.12-.93.29-1.1.6-.46.83-1.13.66-1.88.8-1.85.35-3.87-.07-5.53,1.15-1.66,0-2.94,1.02-4.15,1.87-.83.58-1.68.9-2.5.86-1.29-.06-2.42.37-3.62.57-2.05.35-3.73,1.49-5.53,2.39-.93.46-1.85,1.08-2.84,1.27-.86.16-1.77.12-2.4.77-.67.69-1.66.48-2.43,1.14-.83.71-1.85,1.31-2.78,1.98-.95.69-1.02.62-.62,1.67.21.55.47.61.97.31Z"
                fill="#2b231d"
              />
              <path
                d="M221.09,584.94c.99-.33,1.98-.74,2.85-1.31c1.58-1.05,3.31-1.84,4.83-3.03c1.28-1,2.99-1.44,4.13-2.74.15-.17.45-.19.66-.32.78-.49,1.55-1,2.33-1.5.46-.3.9-.65,1.39-.9c1.31-.67,2.93-1.03,3.9-2.02c1.17-1.19,2.78-1.25,3.97-2.2.19-.15.39-.3.58-.47.92-.8,2.12-1.09,3.1-1.88.69-.56,1.77-.76,2.52-1.44.7-.63,2.01-.46,2.25-1.72c2.35.06,4.16-.66,5.66-1.94c1.02-.87,1.77-2.06,3.36-1.87.14.02.31-.19.47-.28.6-.31,1.19-.65,1.81-.92c1.01-.44,1.79-1.21,2.67-1.81.81-.54,2.11-.46,3.08-1.06c2.08-1.21,3.8-2.29,5.58-3.27c1.67-.92,3.4-1.74,5.1-2.6.65-.33,1.31-.65,1.94-.99c1.3-.71,2.87-1.18,3.82-2.21c1.11-1.2,2.71-1.36,3.82-2.48.8-.8,2.12-1.17,3.26-1.53c1.04-.33,1.58-1.1,2.11-1.89.31-.47.38-1.09.57-1.67c1.26,1.09,1.25,1.08,2.5.17.95-.69,1.85-1.54,2.91-1.94.94-.36,1.63-.8,2.11-1.65.07-.12.42-.24.45-.2.63.73,1.14.06,1.61-.18c1.97-.99,3.67-2.41,5.64-3.44c2.05-1.06,3.91-2.52,5.85-3.8.2-.13.42-.32.64-.34.89-.09,1.42-.67,1.98-1.27.24-.26.57-.54.89-.6c1.07-.19,1.68-1.46,2.92-1.24.91-.89,1.52-1.57,2.13-2.25-.89-.58-1.71-.67-2.7-.05-.83.52-1.53.95-1.67,2.02-.05.39-.56.82-.95.27-.55-.77-1-.45-1.55-.06-.35.25-.71.55-1.11.64-1.47.36-2.56,1.4-3.79,2.16-1.25.77-2.37,1.77-3.56,2.64-.24.17-.56.34-.83.32-.72-.03-1.14.3-1.51.87-.87,1.34-2.39,1.82-3.71,2.37-1.75.72-3.47,1.49-5.1,2.44-.68.4-1.22,1.05-1.9,1.45-1.58.93-3.13,1.93-4.89,2.55-1.03.36-2.1.81-2.94,1.48-2.29,1.81-5.03,2.82-7.46,4.38-1.24.79-2.69,1.24-3.95,2.01-1.51.92-3.17,1.51-4.71,2.3-2.66,1.36-5.57,2.38-7.71,4.64-.11.12-.33.14-.5.19-.82.21-1.69.3-2.46.64-1.12.5-2.13,1.23-3.23,1.78-.83.41-.27,1.44-.65,1.66-.45.26-1.34-.3-1.84-.07-1.63.73-3.06,1.86-4.77,2.47-.16.06-.27.26-.43.35-.37.21-.73.47-1.13.57-2.2.56-3.97,1.98-6,2.88-.22.1-.5.27-.55.46-.24.93-1.06.89-1.73,1.12-.46.15-.96.26-1.38.5-1.33.76-2.58,1.7-3.97,2.33-2.53,1.16-4.83,2.67-7.02,4.35-.8.61-1.57,1.18-2.53,1.5-.28.09-.55.28-.79.45-1.38.98-2.69,2.09-4.14,2.93-2.39,1.39-4.75,2.79-6.79,4.69-.57.53-1.33.87-1.99,1.31-.35.24-.69.5-1.01.77-1.71,1.47-3.36,3.01-5.13,4.41-.53.42-.62.71-.3,1.18.31.46.68,1.02,1.32.43c1.46-1.35,3.34-1.97,5.04-2.9.64-.35,1.16-.93,1.71-1.42.23-.2.38-.52.63-.65c1.51-.81,2.37-2.08,2.71-3.68.56.05,1.14.25,1.59.1Z"
                fill="#2b231d"
              />
              <path
                d="M230.59,597.8c.9-.78,1.76-1.6,2.63-2.41c1.72-1.59,4.11-2.29,5.56-4.25.17-.22.55-.27.8-.45.85-.6,1.81-1.12,2.47-1.89.38-.44.71-.77,1.23-.99.38-.15.72-.39,1.06-.62.7-.5,1.38-1.03,2.08-1.53.65-.46,1.4-.81,1.98-1.35c1.04-.96,2.16-1.7,3.45-2.31c1.72-.8,3.3-1.92,4.92-2.93c1.25-.78,2.47-1.62,3.7-2.44s2.47-1.63,3.68-2.47c1.23-.86,2.13-2.26,3.84-2.34.16,0,.38-.15.46-.29.55-1.02,1.58-1.31,2.52-1.78.65-.32,1.21-.84,1.76-1.32c1-.88,1.8-2.03,3.26-2.26.22-.04.42-.26.63-.39c1.43-.9,2.54-2.35,4.39-2.51.17-.01.32-.18.47-.28c1.28-.83,2.51-1.75,3.84-2.46c3.22-1.71,6.3-3.59,8.93-6.14.17-.16.42-.27.64-.32c2.06-.43,3.76-1.65,5.37-2.82s3.33-2.08,5.03-3.07c1.38-.81,2.97-1.5,3.7-3.19.17-.4.84-.68,1.34-.84c2.57-.84,4.66-2.48,6.81-4.02c1.05-.75,2.03-1.58,3.09-2.31c1.32-.91,2.7-1.72,4.01-2.65.64-.45,1.41-.97,1.69-1.63.27-.64.01-1.5-.03-2.27-1.1.52-2.06,1.31-3.11,1.87-1.68.9-3.12,2.13-4.7,3.15-1.44.93-2.77,2.04-4.08,3.14-1.31,1.11-3.09,1.56-4.12,3.04-.13.18-.43.39-.62.37-1.17-.17-1.79.68-2.56,1.28-.33.26-.68.62-1.06.68-1.02.17-1.7.81-2.22,1.56-.54.78-1.33,1.2-2.1,1.4-2.21.56-4.01,1.82-5.79,3.12-1.05.77-1.71,2.11-3.29,2.09-.24,0-.48.37-.74.53-.31.2-.64.35-.96.53-.9.52-1.81,1.03-2.7,1.57-.68.42-1.32.9-2.01,1.3-1.12.65-2.29,1.21-3.39,1.88-1.16.7-2.32,1.41-3.38,2.23-.71.55-1.9.82-1.67,2.17.02.09-.58.45-.68.38-.99-.66-1.58,0-2.28.54-.58.44-1.27.73-1.9,1.11-.41.25-.96.46-1.14.83-.49.99-1.35,1.38-2.26,1.8-2.18,1.01-4.37,2.02-6.24,3.6-1.12.95-2.25,1.92-3.48,2.71-1.49.96-3.16,1.59-4.6,2.68-2.03,1.54-4.66,2.18-6.37,4.22-1.77.88-3.14,1.68-4.05,3.08-.16.24-.45.55-.69.56-1.53.08-2.46,1.26-3.62,1.97-1.25.76-2.29,1.87-3.44,2.79-1.79,1.43-3.69,2.72-5.36,4.27-.96.89-2.03,1.58-3.03,2.38-.87.69-1.89,1.23-2.62,2.04-1.09,1.2-2.48,2.02-3.76,2.9-1.25.85-2.57,1.56-3.78,2.54-.89.73-1.09,1.76-1.82,2.49-.05.05.19.57.39.65.25.1.63.04.88-.09c1.41-.73,2.87-1.38,4.01-2.58.5-.52,1.14-1.07,1.81-1.23c1.24-.29,2.01-1.16,2.94-1.85.74-.55,1.52-1.05,2.27-1.6.69-.51,1.37-1.03,2.01-1.59Z"
                fill="#2b231d"
              />
              <path
                d="M330.73,510.35c-.43-.08-1.02.06-1.37.31-.52.38-.92.38-1.51.21-1.04-.3-1.99-.05-2.5,1.01-.21.43-.38.56-.83.34-1.07-.53-2.19-.41-3.25-.04-1.46.51-2.93.84-4.47,1.02-1.26.14-2.47.64-3.73.86-1.69.29-3.44.25-4.96,1.27-.43.29-1.07.41-1.6.37-1.47-.12-2.7,1.27-4.23.6-1.83.91-3.43,1.25-5.11,1.28-.3,0-.67.02-.89.19-1.01.75-2.14.99-3.37.9-1.61.41-2.86.78-4.11,1.11-1.21.33-2.23,1.33-3.65,1.03-.21-.04-.5.33-.77.48-.27.14-.56.34-.84.33-2.1-.07-3.9,1.08-5.9,1.43-1.43.26-2.81.82-4.2,1.28-1.28.43-2.55.88-3.82,1.35-.75.28-1.46.64-2.21.9-2.24.79-4.75.77-6.76,2.25-.14.1-.35.11-.53.14-3.23.49-6.19,1.96-9.37,2.69-1.96.45-3.76,1.56-5.65,2.33-.8.33-1.64.55-2.46.81-1.35.43-2.76.71-4.03,1.3-1.28.6-2.5,1.22-3.95,1.39-.54.06-1.15.52-1.49.98-.16.21.22.85.38,1.28.42,1.12.39,1.06,1.33.58.58-.3,1.26-.41,1.89-.6.45-.14.92-.26,1.36-.43.28-.11.53-.45.79-.44c1.85.08,3.52-.61,5.16-1.26c2.1-.83,4.44-1.05,6.34-2.42.14-.1.34-.17.51-.19c1.79-.16,3.4-.95,5.1-1.44c2.65-.76,5.21-1.78,7.69-2.99.21-.1.48-.07.73-.09c1.43-.09,2.78-.41,4.12-.96c2.33-.95,4.7-1.78,7.06-2.64.29-.11.6-.14.9-.2c1.46-.28,2.92-.54,4.12-1.52.18-.15.45-.3.66-.28c1.76.2,3.08-1.01,4.64-1.4.59-.15,1.19-.27,1.79-.37.36-.06.74-.02,1.1-.11c2.75-.7,5.51-1.33,8.07-2.61.95-.47,1.93-.95,3.11-.81.71.08,1.46-.13,2.18-.29.96-.21,2.02-.32,2.82-.81.95-.57,1.88-.1,2.81-.35c2.42-.65,4.68-1.82,7.19-2.18.21-.03.43-.25.57-.45.26-.38.51-.32.93-.23c1.96.45,3.86-.11,5.73-.61c1.09-.29,2.1-.92,3.16-1.36.33-.14.77-.37,1.05-.26c1.19.47,1.84-.07,2.42-1.03.48-.79.56-.79,1.31-.05.44.43.83.7,1.46.46c1.33-.49,2.67-.97,4.01-1.42.78-.26,1.15-.77,1.23-1.58-2.25.84-4.13,1.27-6.17.89Z"
                fill="#2b231d"
              />
              <path
                d="M213.57,551.06c.73-.32,1.39-.67,2-1.26.81-.78,1.87-1.3,2.81-1.95.44-.3.81-.75,1.29-.94c1.18-.48,2.45-.75,3.61-1.28c2.29-1.05,4.52-2.22,6.78-3.31.43-.21.92-.41,1.37-.38.98.05,1.29-.55,1.53-1.3.12-.37-.32-1.57-.83-1.8-.32-.15-.87-.15-1.16.03-.59.37-1.1.73-1.86.63-.32-.05-.71.17-1.01.36-1.89,1.17-4.11,1.72-5.85,3.17-.14.11-.32.23-.49.24-1.65.07-2.77,1.22-4.1,1.95-2.19,1.21-3.95,3.2-6.57,3.63-.17.03-.34.15-.48.27-1.61,1.24-3.23,2.48-4.83,3.73-.73.57-1.46,1.15-2.14,1.78-.93.88-1.83,1.8-2.71,2.73-.19.2-.21.56-.34.94.11.29.15.77.39.91.23.14.68-.03,1.01-.14.22-.07.4-.28.61-.42c1-.72,2-1.43,2.99-2.16.49-.36.97-.73,1.42-1.14c1.97-1.77,4.15-3.22,6.57-4.28Z"
                fill="#2b231d"
              />
              <path
                d="M329.36,531.6c.85-.58,1.7-1.18,2.52-1.8.76-.57,1.71-1.04,2.2-1.8.72-1.13,1.63-1.81,2.78-2.47c1.76-1.02,3.33-2.37,4.96-3.6.12-.09.24-.35.19-.46-.08-.19-.29-.46-.45-.46-.42,0-.86.05-1.25.21-1.34.52-2.47,1.39-3.45,2.42-.5.52-.69,1.48-1.77.97-.13-.06-.54.27-.7.5-.53.8-1.72,1.06-1.83,2.21-.78.17-1.13.23-1.43.39-1.51.82-3.01,1.65-4.48,2.54-.31.19-.47.64-.69.98.26.12.55.21.78.36c1.16.77,1.47.79,2.62.01Z"
                fill="#2b231d"
              />
              <path
                d="M331.74,522.08c.44-.2.84-.51,1.27-.75.42-.23.86-.43,1.28-.65.59-.31,1.17-.67,1.78-.93c1.45-.61,2.35-1.86,3.4-2.92.12-.12.2-.48.12-.58-.12-.15-.44-.26-.61-.2-.28.09-.5.35-.75.52-.39.26-.77.54-1.19.74-1.28.62-2.59,1.17-3.87,1.8-1.3.63-2.43,1.52-3.89,1.95-1.36.4-2.94,1.11-2.74,3.11.23-.03.48-.02.69-.1c1.51-.64,3.01-1.3,4.51-1.97Z"
                fill="#2b231d"
              />
              <path
                d="M344.94,511.7c-.2.21-.22.58-.4.82-.23.32-.52.5-.9.12-.9-.9-.9-.87-2.03-.38-.62.27-1.28.46-1.91.7-.7.26-.9.78-.5,1.41.08.12.54.18.57.13.49-.88,1.14-.3,1.81-.4-.26.88-1.74.86-1.09,2.07c1.66-.23,3.08-.71,4.16-2.28.54-.79,1.68-1.27,2.48-1.99.12-.11.35-.09.53-.13.77-.19,1.55-.36,2.31-.59.28-.08.57-.26.75-.48.12-.15.1-.45.05-.67-.02-.08-.31-.17-.46-.14-1.37.23-2.75.41-4.09.76-.48.13-.89.64-1.26,1.03Z"
                fill="#2b231d"
              />
              <path
                d="M348.36,516.54c-.28-.06-.68-.26-.81-.15-.9.8-2,1.17-3.09,1.6-.39.15-.79.33-1.1.6-.41.35-.77.78-1.05,1.24-.08.14.19.49.27.67c1.28.19,3.35-.67,4.01-1.82.39-.68.72-1.25,1.47-1.53.15-.06.19-.4.29-.61Z"
                fill="#2b231d"
              />
              <path
                d="M343.15,505.3c2.26.13,4.45-.05,6.73-1.87-1.07-.2-2-.68-2.39-.4-.9.65-1.77.65-2.76.67-.61.01-1.25.41-1.8.74-.32.2-.13.83.23.85Z"
                fill="#2b231d"
              />
              <path
                d="M354.23,536.88c-1.39,1.33-2.55,2.83-3.16,4.68-.07.2-.01.44-.01.66.29,0,.61.06.85-.05.32-.15.68-.39.86-.68.81-1.36,1.57-2.74,2.29-4.04-.17-.35-.2-.58-.33-.65-.12-.06-.39-.02-.5.08Z"
                fill="#2b231d"
              />
              <path
                d="M341.25,509.87c.51-.1.97-.58,1.68-.08.15-.11.36-.24.54-.41-.8-.11-.99-.93-1.53-1.08-.62-.18-1.24.16-1.4.81-.05.21-.03.52.09.68.1.12.42.12.62.08Z"
                fill="#2b231d"
              />
              <path
                d="M205.82,537.05c.65-.16.92-.65.8-1.24-.09-.43-.4-1.12-.65-1.14-.71-.04-.72.65-.79,1.2-.07.92.18,1.29.65,1.18Z"
                fill="#2b231d"
              />
              <path
                d="M347.87,522.99c-.71.08-1.04.43-1.33.82-.04.05.16.28.23.41.58.02,1.19-.67,1.09-1.22Z"
                fill="#2b231d"
              />
              <path
                d="M351.17,499.36c-.28-.3-.48-.51-.67-.72-.18.2-.48.39-.5.61-.03.21.23.46.36.69.23-.17.47-.33.81-.58Z"
                fill="#2b231d"
              />
              <path
                d="M352.21,517.24c-.04.09.14.28.23.42.17-.11.34-.22.56-.36-.17-.23-.26-.36-.36-.49-.15.14-.35.26-.43.44Z"
                fill="#2b231d"
              />
              <path
                d="M353.72,499.87c.19.03.4-.07.76-.15-.26-.24-.38-.44-.48-.43-.19.01-.38.15-.57.24.1.12.19.33.3.35Z"
                fill="#2b231d"
              />
              <path
                d="M350.26,508.02c-.22-.18-.34-.32-.49-.38.06.55.23.45.49.38Z"
                fill="#2b231d"
              />
              <path
                d="M338.5,510.53c.21-.06.41-.14.64-.22-.36-.23-.56-.13-.75-.01-.01,0,.09.24.11.24Z"
                fill="#2b231d"
              />
              <path
                d="M215.36,513.47c-.38-.15-.52-.26-.66-.24.22.52.37.39.66.24Z"
                fill="#2b231d"
              />
              <path
                d="M304.31,616.62c-.12,0-.25-.02-.5-.04-2.04-.24-4.19-.17-6.29.44-.74.21-1.59.55-2.07,1.11-1.16,1.35-2.19,2.82-3.17,4.31-.57.86-1.09,1.82-1.37,2.8-.76,2.71-1.77,5.25-3.68,7.4-.56.62-1.11,1.45-1.23,2.24-.41,2.83.22,5.45,2.36,7.47c1.39,1.31,2.91,2.49,4.42,3.67c1.74,1.36,4.32,1.33,5.99-.11c1.55-1.33,3.01-2.74,4.51-4.13c1.79-1.66,3.3-3.53,4.27-5.78.78-1.81,1.31-3.73,2.18-5.49c1.69-3.42,1.66-6.75-.05-10.11-1.12-2.21-2.55-3.99-5.38-3.77Z"
                fill="#ffece5"
              />
              <path
                d="M305.46,661.65c-1.83.09-3.54-.24-5.31-.46-2.08-.25-3.85-1.03-5.4-2.28-2.95-2.39-6.03-4.5-9.48-6.16-3.85-1.85-7.5-4.09-11.56-5.52-3.8-1.34-7.62-2.57-11.68-2.81-1.55-.09-3.09-.28-4.64-.37-4.91-.31-9.64-1.52-14.29-3.04-4.47-1.46-7.93-4.19-10.45-8.17-.99-1.56-1.37-3.09-.79-4.91.25-.8.24-1.72.19-2.58-.2-3.47-.69-6.89-2.05-10.13-.84-2.01-1.7-4.01-3.19-5.62-2.97-3.23-6.09-6.33-9.01-9.6-.97-1.08-1.68-2.45-2.28-3.79-1.58-3.54-2.24-7.33-2.88-11.13-.6-3.56-.87-7.1-.48-10.71.34-3.19.58-6.39.58-9.63c0-3.38.26-6.8,1.12-10.14.74-2.86,1.87-5.5,3.62-7.88.84-1.15,1.79-2.26,2.41-3.52c1.57-3.19,2.39-6.63,2.89-10.12.58-4.04.96-8.11,1.44-12.17.04-.37.17-.72.25-1.08.67-3.08,2.28-5.74,3.8-8.43c1.09-1.93,1.89-4.07,3.6-5.6c1.48-1.32,2.92-2.7,4.48-3.91c1.68-1.3,2.78-2.96,3.6-4.87.8-1.88,1.62-3.75,2.52-5.59c1.16-2.36,2.63-4.51,4.83-6.04c1.22-.85,2.5-1.6,3.73-2.42c1.13-.75,2.26-1.51,3.35-2.31-2.75.59-5.51,1.18-8.28,1.62-4.01.63-7.84,1.72-11.63,3.16-4.05,1.54-8.25,2.67-12.37,4.03-1.48.49-2.94,1.02-4.38,1.62-.28.24-.58.45-.86.7-2.05,1.87-3.95,3.92-5.86,5.94-3.76,3.97-6.64,8.48-8.07,13.81-.74,2.75-1.49,5.49-2.72,8.08-.42.88-.98,1.51-1.8,2.04-2.31,1.5-4.84,2.51-7.4,3.45-1.19.44-2.43.72-4.03,1.19.32-1.4.51-2.41.79-3.4c1.25-4.37,2.92-8.56,5.62-12.25c1.72-2.35,3.62-4.56,5.33-6.92c1.1-1.53,2.21-2.98,4.07-3.89l-.04-1.11c-.48.32-.97.61-1.44.95-1.81,1.3-3.74,2.45-5.65,3.6-1.26,1.71-2.52,3.41-3.8,5.09-2.28,2.99-4.03,6.26-5.19,9.82-.97,2.98-1.75,6.03-2.69,9.29-.47.2-1.21.48-1.93.82-2.4,1.14-4.81,2.27-7.19,3.46-2.65,1.33-5.44,2.49-7.86,4.17-1.16.8-2.29,1.64-3.4,2.5-1.38,2.52-2.69,5.07-3.85,7.71c1.74-1.53,3.61-2.91,5.63-4.12c1.11-.66,2.09-1.55,3.16-2.27c1.13-.76,2.22-1.71,3.48-2.11c3.04-.97,5.77-2.57,8.6-3.95.97-.47,2-.83,3.21-1.32l-1.25,14.75c-.27.19-.41.32-.58.39-4.39,1.88-8.77,3.78-13.18,5.61-1.68.69-3.2,1.6-4.65,2.67-2.09,1.54-4.22,3.03-6.39,4.45-2.06,1.35-3.95,2.84-5.41,4.78-.58,1.94-.78,3.91-.74,5.89c1.15-.93,2.28-1.86,3.28-2.92c2.17-2.3,4.7-3.97,7.51-5.34c1.99-.97,3.85-2.22,5.78-3.34c1.38-.8,2.73-1.69,4.18-2.36c2.47-1.14,5-2.15,7.51-3.18.83-.34,1.69-.6,2.53-.89c1,2.98.65,14.13-.52,17.61-.83.33-1.75.68-2.66,1.06-2.06.85-4.22,1.52-6.13,2.62-3.85,2.23-7.57,4.68-11.32,7.09-1.14.73-2.25,1.54-3.28,2.43-1.79,1.55-3.54,3.15-5.28,4.75.08,1.62.19,3.24.34,4.85.4-.08.79-.25,1.18-.57c3.01-2.48,6.02-4.97,9.13-7.33c1.47-1.12,3.12-1.99,4.72-2.92c2.4-1.4,4.85-2.73,7.25-4.13c1.8-1.04,3.51-2.25,5.72-2.64.54,5.4.98,10.66.28,15.8-1.58.97-2.93,1.85-4.33,2.65-3.28,1.87-6.52,3.83-9.91,5.49-1.99.98-3.84,2.08-5.33,3.65-1.85,1.97-3.91,3.61-6.23,4.97.24,1.07.54,2.14.98,3.13.2.45.38.91.54,1.37c1.44-1.14,2.88-2.28,4.36-3.37c2.19-1.61,4.36-3.26,6.67-4.69c3.59-2.2,7.29-4.22,10.93-6.33.88-.51,1.71-1.1,2.83-1.82.28,4.2,1.76,7.8,3.11,11.58-.66.41-1.19.82-1.78,1.1-2.43,1.12-4.66,2.52-6.71,4.28-1.54,1.33-3.3,2.39-4.93,3.62-1.78,1.34-3.55,2.69-5.26,4.1-1.99,1.64-3.91,3.36-5.91,4.98.44,1.1.82,2.23,1.27,3.33c3.05-1.7,5.77-3.74,8.34-6c3.54-3.11,7.89-5.13,11.31-8.43.87-.84,2.04-1.39,3.13-1.98.69-.38,1.46-.59,2.26-.91.38.59.71,1.02.98,1.5c1.55,2.83,3.06,5.65,5.18,8.13.8.93,1.72,1.98,1.75,3.61-.6.47-1.23,1.05-1.95,1.51-1.72,1.1-3.64,1.95-5.19,3.24-3.76,3.14-7.58,6.18-11.57,9.03-1.2.86-2.21,1.99-3.43,2.81-.61.41-1.15.88-1.66,1.37.26.41.53.82.78,1.23.68,1.12,1.42,2.19,2.2,3.24c1.01-.59,1.96-1.26,2.75-2.18c1.74-2.02,3.55-3.96,5.66-5.62c1.84-1.44,3.59-3.01,5.38-4.52c1.32-1.1,2.33-2.55,3.94-3.35c1.58-.79,3.08-1.75,4.61-2.64c2,4.8,3.93,9.41,5.94,14.22-1.45,1.02-2.82,2.08-4.28,2.99-2.68,1.68-5.43,3.22-7.48,5.73-.34.42-.86.71-1.32,1.02-2.45,1.66-4.65,3.59-6.54,5.85.88,1.31,1.8,2.59,2.83,3.77.72-.42,1.26-1.06,1.82-1.67.96-1.04,2.03-1.98,3.09-2.94c1.32-1.19,2.91-2.17,3.98-3.56c2.7-3.49,6.64-5.24,10.06-7.82c2.41,2.91,5.24,5.22,8.06,7.54.64.53,1.11,1.26,1.77,2.04-1.67,1.27-3.23,2.29-4.59,3.54-2,1.84-3.82,3.87-5.77,5.77-2.86,2.78-5.09,6.01-7.21,9.34.67.63,1.34,1.25,2.04,1.85c1.54-1.46,2.81-3.17,4.09-4.87.77-1.03,1.66-2.07,2.71-2.77c2.2-1.45,4.08-3.2,5.89-5.08c1.54-1.6,3.12-3.17,4.77-4.66c1.62-1.47,1.92-1.56,3.75-.41c2.1,1.31,4.06,2.83,6.04,4.32.45.34.71.94,1.08,1.44-.81,1.02-1.35,1.99-2.47,2.46-.43.18-.82.57-1.13.95-1.05,1.3-2.05,2.63-3.06,3.96-.86,1.13-1.59,2.38-2.56,3.4-1.41,1.47-3.02,2.75-4.48,4.17-1.37,1.33-2.85,2.58-3.86,4.23c1.26.7,2.52,1.41,3.79,2.1.46-.54.91-1.08,1.39-1.61c2.12-2.33,4.38-4.55,6.35-7.01c1.78-2.22,3.54-4.45,5.58-6.44c1.27-1.24,2.53-2.5,3.82-3.78c2.64,1.39,5.24,2.76,7.97,4.21-1.75,2.67-2.92,5.42-4.97,7.62-.84.9-1.6,1.91-2.24,2.96-1.97,3.23-3.97,6.44-6.35,9.39c1.05.33,2.13.58,3.22.79.14-.14.27-.28.42-.41c2.74-2.45,5.11-5.2,7.09-8.31c1.79-2.82,3.65-5.61,5.53-8.38.62-.92,1.39-1.74,2.12-2.64c4.62.35,7.96,3.19,11.55,5.53-.1.25-.14.44-.23.6-1.05,1.75-2.24,3.43-3.14,5.25-1.17,2.37-2.86,4.34-4.41,6.42-.7.94-1.39,1.88-2.07,2.84-.18.25-.32.5-.43.75.23.02.46.04.69.06c1.42.13,2.86.23,4.24.54.23.05.47.07.71.12.44-.62.88-1.23,1.38-1.79c2.35-2.66,4.41-5.46,5.8-8.75.57-1.34,1.34-2.59,2.05-3.93c3.13,1.31,6.47,1.07,9.37,2.54-.61.99-1.13,1.76-1.56,2.57-1.12,2.14-2.25,4.25-3.74,6.19-.74.97-1.52,1.97-1.99,3.1c1.91-.35,3.78-.83,5.63-1.4c1.12-1.64,2.22-3.29,3.34-4.93.21-.3.39-.72.69-.85c1.13-.5,1.38-1.5,1.65-2.53.22-.83.39-1.69,1.01-2.12c3.5.61,6.84,1.19,10.18,1.76.45.07.93.13,1.37.06.41-.34.83-.67,1.22-1.03.33-.3.69-.58,1.05-.86-1.2.03-2.39.02-3.58-.06-2.52-.18-5.03-.62-7.53-1.01-.63-.1-1.22-.45-1.93-.73.75-1.97,1.41-3.73,2.07-5.46.62,0,.99-.05,1.35.01c1.22.2,2.42.48,3.64.65c2.76.39,5.52.74,8.28,1.1.31.04.62.06.92.13.87.2,1.74.38,2.62.52.9-.75,1.79-1.5,2.69-2.25.86-.72,1.64-1.54,2.57-2.14c2.44-1.58,4.35-3.66,6.04-5.98.8-1.1,1.57-2.23,2.46-3.27c1.51-1.77,3.03-3.54,4.55-5.3-2.1,1.61-4.18,2.33-6.59,2.45ZM186.53,531c3.43-1.18,6.9-2.37,10.57-3.63-.27,2.31-.22,4.51-.79,6.69-.83,3.15-1.51,6.34-2.31,9.77-2.76.76-5.65,1.56-8.54,2.36-.39-1.23.32-11.56,1.07-15.19Zm-1.56,20.26c2.81-.92,5.48-1.79,8.5-2.78-1.4,5.95-2.15,11.6-1.68,17.48-2.12,1.35-4.42,2.3-7.08,3.14.16-6.02,1.47-11.81.26-17.84Zm-.84,23.16c2.57-1.19,5.13-2.37,7.77-3.6.8,4.82,1.58,9.47,2.39,14.34-2.89,2.07-5.89,4.27-9.71,5.29-.15-5.42-.3-10.61-.46-16.03Zm4.28,32.26c-.19.14-.42.22-.82.42-1.49-3.88-2.86-7.66-2.93-11.7c3.61-1.47,7.13-2.9,10.67-4.34.6.69,2.78,6.43,3.4,9.02-.33,1-1.31,1.32-2.12,1.63-3.05,1.16-5.59,3.12-8.2,4.98Zm8.66,16.95c-2.37-4.29-6.03-7.76-7.49-12.67c3.37-2.35,6.85-4.27,10.64-6.4c1.28,5.15,2.46,9.88,3.64,14.62-.61,1.45-2.16,1.57-3.26,2.3-1.08.71-2.21,1.35-3.53,2.15Zm7.02,18.07c-.63-1.39-1.31-2.75-1.88-4.15-1.09-2.63-2.13-5.28-3.16-7.93-.62-1.6-.47-2.09.91-2.95c1.67-1.04,3.36-2.04,5.08-3.08c2.51,4.03,4.92,7.89,7.27,11.66-1.08,1.84-4.4,4.43-8.21,6.45Zm12.2,13.53c-3.46-3.31-7.28-5.88-10.01-9.69c2.27-2.67,5.63-3.63,8.09-5.86c2.28,3.41,4.46,6.68,6.74,10.1-1.53,1.74-3.13,3.55-4.82,5.45Zm15.07,4.99c-.77,1.02-1.74,1.89-2.59,2.79-2.93-2.1-5.82-4.16-8.9-6.36c1.45-1.37,2.9-2.74,4.44-4.19c2.92,2.29,6.02,3.85,9.49,4.71-.27,1.57-1.68,2.05-2.44,3.06Zm8.69,10.1c-2.82-1.31-5.44-2.62-8.08-4.23c1.23-3.1,4.03-4.53,5.86-6.94c2.61.8,4.85,2.16,7.28,3.51-1.73,2.62-3.35,5.08-5.05,7.66Zm15.86,6.44c-.92-.54-1.8-.88-2.45-1.48-1.83-1.67-3.96-2.7-6.32-3.37-.52-.15-1.01-.43-1.69-.73c1.41-2.16,2.68-4.11,4.07-6.25c1.52,1.11,2.9,2.1,4.27,3.12s2.73,2.07,4.32,3.28c-.43,1.71-1.41,3.4-2.2,5.43Zm14.61,4.2c-3.48-.14-6.66-.86-9.88-1.99.9-2.21,1.65-4.29,3.43-5.84c1.46.34,2.87.77,4.32.97c1.46.2,2.89.42,4.41,1.1-.77,1.93-1.5,3.79-2.29,5.77Z"
                fill="#2b231d"
              />
              <path
                d="M240.88,527.71c-.17-.32-.26-.68-.34-1.04-.46-2.01-2.07-3.11-4.11-2.76-1.91.32-3.4,1.24-4.66,2.76-3.25,3.92-5.39,8.28-5.81,13.4-.16,1.89.53,3.11,2.26,3.85c1.82.79,3.71,1.25,5.75.91c2.57-.43,4.88-2.78,5.11-5.4.13-1.51.54-2.91,1.34-4.2.73-1.18,1.25-2.42,1.21-3.68.19-2.14.18-2.14-.74-3.85Z"
                fill="#ffece5"
              />
              <path
                d="M274.03,632.38c-2.12-.9-4.24-.42-6.37-.3-1.37.08-2.48.74-3.42,1.65-.94.9-1.37,2.01-1.09,3.35.45,2.11,1.7,3.1,3.37,3.24c3.93.42,6.47-.64,8.61-2.73c1.81-1.77,1.22-4.24-1.1-5.22Z"
                fill="#2b231d"
              />
              <path
                d="M288.75,498.47c-.41-.66-1.02-1.19-1.62-1.86.61-.84,1.25-1.58,1.75-2.41.95-1.59.53-2.62-1.15-3.41-1.22-.57-2.47-1.16-3.52-1.97-2.79-2.15-6-2.55-9.32-2.41-2.46.11-4.93.4-7.36.77-2.87.44-5.81.77-8.55,1.68-2.85.95-5.51,2.49-8.21,3.84-4.34,2.17-7.25,5.65-8.35,10.33-.78,3.32-1.73,6.88,1.32,9.78.17.16.21.45.35.65c1.29,1.86,2.76,3.56,5.05,4.17c2.34.63,4.71.7,7.13.3c2.18-.36,4.27-1.11,6.58-.98c2.58.14,5.12-.34,7.51-1.65c2.49-1.37,5.16-2.4,7.78-3.54c1.47-.64,3.05-1.08,4.46-1.82c2.35-1.22,4.69-2.44,6.3-4.74c1.01-1.45,1.42-2.85.79-4.51-.29-.75-.51-1.55-.93-2.23Z"
                fill="#ffece5"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv1401" transform="translate(.000005-194.417579)">
            <g>
              <path
                d="M351.7,701.78c.44,7,.67,14.12,1.19,21.12.24,3.2.51,6.43,1.11,9.53.72,3.64,2.01,6.95,3.46,10.42c4.88,11.66,11.16,21.81,22.05,30.36c5.11,4.01,11.14,6.43,17.68,8.42c3.79,1.15,7.88,1.67,11.78,2.56.21.05.34.05.55.11.23.05.14.02.49.1s1.25.28,1.7.4c-1.87-.62-3.74-1.23-5.62-1.83-5.65-1.82-11.33-3.59-16.92-5.51-.28-.09-.06-.41.23-.35c9.53,2.02,19.07,4.11,28.57,6.27c8.8,2.01,17.95,3.93,26.08,7.27c8.14,3.34,14.6,7.63,20.83,12.94c2.49,2.12,4.33,4.53,6.28,6.98-.3-.6-.6-1.19-.93-1.77-.2-.36-.41-.72-.62-1.09-.18-.33-.38-.67-.59-.99-.21-.35-.42-.7-.65-1.04-.83-1.3-1.71-2.54-2.68-3.78-.21-.29-.44-.58-.66-.86-.01-.02-.03-.05-.04-.07-.03-.07-.01-.14.01-.2.08-.14.27-.23.44-.19.04.01.07.02.1.05.24.18.48.35.7.55.22.17.45.36.66.54.44.35.86.72,1.26,1.1.81.76,1.57,1.53,2.28,2.31.69.79,1.32,1.6,1.91,2.42.31.41.59.83.86,1.25s.53.85.79,1.3c.25.43.49.86.72,1.31.22.42.44.85.65,1.28.03.06.06.13.08.2.2.4.38.8.55,1.23.2.46.39.92.56,1.39.18.47.37.95.52,1.41.18.49.34.97.49,1.45.32.98.62,1.97.91,2.99.17-.43.37-1.16.38-1.59.03-.9.42-2.84.65-3.41c1.01-2.54.97-4.45.53-6.83-.63-3.37-1.41-6.7-2.84-9.81-2.75-5.93-6.06-11.55-10.69-16.53-4.26-4.56-9.02-8.53-14.56-11.91-5.52-3.37-11.99-5.53-18.31-7.37-12.37-3.63-24.69-6.38-36.41-11.21-2.64-1.08-4.97-2.48-7.49-3.71-.91-.45-2.02-.51-3.04-.8-3.71-1.06-7.27-1.74-10.27-4.06-2.99-2.31-5.58-5.04-7.77-8-4.97-6.71-8.15-13.98-11.06-21.47-.18-.45-.46-.88-.66-1.33-1.26-2.75-2.01-5.6-2.73-8.48-.39-1.56-1.08-3.07-1.55-4.62-.65.44-1.01.86-.96,1.61Zm16.72,44.64c3.23,1.53,5.79,3.73,8.9,5.46c3.11,1.72,6.39,3.57,9.05,5.74c2.64,2.17,4.6,4.74,7.62,6.49c2.22,1.28,4.61,1.61,7.14,2.18.63.14,1.31.15,1.9.37c9.64,3.62,19.8,5.87,28.65,10.8-5.76-.6-11.58-1.11-17.34-.62-3.19.27-6.06.91-9.16,1.33-2.22-.3-4.15-.46-6.44-1-.62-.15-2.23-.7-2.89-.98-.38-.15-.41-.58-.72-.84-1.57-1.31-3.84-2.02-5.73-2.8-3.05-1.27-5.87-2.44-8.73-3.87-1.43-.72-3.04-1.35-4.22-2.33-1.01-.84-1.43-2.25-2.15-3.23-.06-.08.17-.13.21-.16c2.23-1.41,2.15-3.98.53-5.55-2.43-2.39-4.52-4.27-6.79-6.64-.45-.89-1.05-2.17-1.34-3.03-.27-.86.63-1.72,1.5-1.31Z"
                fill="#7b6d4b"
              />
              <path
                d="M463.49,732.29c0,0-.24-.13-.25-.14s.19.1.23.12c0,0,.02.02.02.01Z"
                fill="#cfc395"
              />
              <path
                d="M377.33,651.36c0,0,.04.05.06.06.07.04.14.06.21.08c5.76,2.58,10.79,5.69,15.44,9.52s8.77,8.04,13.34,11.96c2.23,1.93,4.45,3.82,6.59,5.87.76.72,1.49,1.45,2.16,2.19.22.25.45.49.66.75.13.13.24.28.34.41.39.48.74.98,1.07,1.49.37.6.69,1.23.94,1.88.03.08,0,.16-.07.23s-.21.11-.34.03c-.24-.14-.52-.34-.76-.51.24.27.52.51.76.79c5.31,6.08,9.36,12.21,12.35,19.36c1.46,3.5,2.56,7.37,4.03,10.91.06.11.07.26.15.34.58.58,1.35,1.24,1.97,1.72.62.49,1.05.75,1.69,1.16.03.01-.03-.01.1.06s.67.4.83.48l.15.08c.15.09.73.4.86.47.13.06.08.03.11.06c1.7.85,3.37,1.61,5.1,2.45.63.31,1.14.56,1.88.92.01,0,.04.01.08.04.06.02.13.06.2.09s.15.08.27.13c1.76.84,6.79,3.26,9.23,4.46.06.03.18.09.25.13.34.17.7.35,1.07.54l-.06-.05c-.77-.65-1.53-1.33-2.28-2.02-.46-.44-.93-.9-1.38-1.35-.22-.22-.44-.43-.63-.65-.21-.22-.42-.46-.62-.68-.31-.34-.62-.69-.9-1.04-.25-.3-.51-.61-.74-.92-.25-.34-.51-.68-.74-1.02-.24-.34-.48-.69-.7-1.04-.89-1.39-1.76-2.75-2.59-4.12-.55-.92-1.08-1.83-1.59-2.77-.49-.92-.97-1.86-1.42-2.82-.22-.48-.45-.97-.65-1.46s-.39-.99-.56-1.48c-.37-1-.66-2.01-.94-3.01-.17-.63-.32-1.26-.46-1.9-.28-1.23-.52-2.45-.73-3.69-.13-.69-.24-1.38-.35-2.08c0-.05.08-.06.08-.02c1.45,7,4.17,13.2,8.8,19.18-.06-.15-.1-.3-.14-.47-.01-.02-.01-.05-.03-.07-.04-.15-.08-.32-.14-.47v-.03c.17.22.32.43.49.65.32.43.66.86,1.01,1.29.17.21.34.43.51.64.52.64,1.05,1.26,1.67,1.87.07.07.13.14.2.2.13.14.27.27.42.41.84.77,1.69,1.54,2.54,2.3c2.02,1.76,4.06,3.52,6.1,5.29.58.49,1.17,1,1.76,1.51.2.17.39.34.6.51.07.06.13.12.2.18.55.44,1.1.9,1.64,1.37c2.07,1.73,4.15,3.52,6.08,5.36.38.36.76.74,1.12,1.11.03.03.07.07.11.12.11.12.22.26.35.39.08.06.15.17.18.12.37-.7.63-1.68.37-2.44-1.91-5.32-5.78-9.26-10.13-13.31-1.07-.99-2.08-1.73-3.16-2.65-1.49-5.86-1.12-12.22-3.15-17.99-5.4-15.43-13.66-28.79-30.19-37.56-15.71-8.34-32.95-10.4-50.7-13.5Zm27.33,12.05c3.58.18,6.65,1.42,9.46,3.14c3.7,2.24,6.97,4.56,10.12,7.23c6.16,5.19,11.16,10.76,15.26,17.2.32.49-.66.92-1.04.54-5.23-5.22-10.5-10.68-16.03-15.57-5.52-4.89-10.96-9.02-17.8-12.48-.04-.02,0-.06.04-.06Z"
                fill="#cfc395"
              />
              <path
                d="M377.1,657.72c-.87-.33-2.01-.53-2.85-.82-.64-.23-1.43-.96-1.68-1.24-.17-.21-.04-.05-.04-.05.42-.12.48.44.78.57c1.22.53,2.56.99,3.78,1.54Z"
                fill="#cfc395"
              />
              <path
                d="M498.84,691.97c0,0-.05.04-.05.04s.04-.04.05-.04c0,0,0,0,0,0Z"
                fill="#958e50"
              />
              <path
                d="M494.76,694.42c0,0-.09.06-.11.06-.03,0-.12,0-.15,0c0,0,0-.01,0-.01.05,0,.24-.04.26-.04Z"
                fill="#958e50"
              />
              <path
                d="M426.31,614.49c.27.23.52.48.76.72.32.32.62.65.89.99.2.21.37.43.53.67.18.23.35.48.51.72.15.22.28.44.41.66.53.93.96,1.9,1.25,2.88c1.18,3.97,1.19,7.71.83,11.68c0,.06-.08.21-.14-.01-.06-.17-.14-.54-.22-.86-.03-.09-.04-.19-.07-.26.07.34-.08.72.01,1.09c1.17,4.19,1.87,8.45,3.15,12.63c2.11,3.15,4.36,6.32,6.49,9.44c2.39,3.49,4.81,7.07,7.42,10.36c3.05,3.86,6.35,7.19,10.33,10.33c1.91,1.52,3.86,2.68,6.17,3.76c2.3,1.07,4.86,2.31,7.38,2.72.58.09.56.01.89.04.32.02.28.09.56.19c1.14.4,2.16.97,3.27,1.47c1.87.86,3.85,1.53,5.59,2.65c1.26.8,2.25,1.96,3.2,3.02.21.23.41.46.65.67-.06-.06-.1-.12-.15-.19-.03-.03-.07-.08-.1-.12-.17-.2-.32-.4-.49-.61-.42-.54-.83-1.11-1.17-1.62-.01-.04.04-.06.07-.06h.01c.27.19.53.37.79.57.25.19.51.39.76.57.76.57,1.5,1.16,2.29,1.72.37.26.73.51,1.11.75.07.05.14.09.21.13.37.25.76.47,1.15.68.2.12.31.16.58.34-.01-2.68-.06-5.26.25-7.96.32-2.7.77-5.82.11-8.41s-.41-4.56-.08-7.04c.32-2.49.32-4.78-.37-7.22-.13-.48-.3-.79-.51-1.32-.22-.52-.67-1.26-1.04-1.81-.07-.09.1-.2.18-.15.01.01.01,0,.01,0-.38-.76-.76-1.49-1.17-2.23-.39-.7-.8-1.39-1.24-2.05-.08-.14-.18-.29-.28-.43-.07-.12-.15-.23-.24-.35-.11-.19-.24-.36-.38-.54-.44-.63-.93-1.25-1.45-1.86-.28-.33-.58-.65-.89-.98-.27-.28-.53-.55-.8-.81-.08-.09-.2-.2-.31-.29-.17-.17-.35-.34-.53-.49-.2-.17-.38-.34-.58-.5-.39-.33-.8-.67-1.19-.98-.93-.72-1.88-1.41-2.85-2.08-.32-.22-.65-.44-.97-.67.03.05.06.07.08.12.03.01.04.02.04.05.29.35.58.71.84,1.09.2.26.37.52.53.78.11.19-.25.39-.41.22-.18-.19-.38-.37-.58-.55-.21-.17-.41-.34-.62-.51-.25-.21-.52-.41-.79-.61-.52-.37-1.04-.71-1.59-1.04s-1.1-.64-1.67-.94c-.37-.19-.73-.37-1.1-.55-.31-.15-.62-.29-.93-.44-1.31-.61-2.63-1.19-3.92-1.8-4.38-2.05-8.47-4.13-12.56-6.48-7.87-4.53-14.99-9.61-21.91-15.08-.08-.07.06-.19.15-.14.6.37,1.21.74,1.81,1.11c1.21.74,2.42,1.47,3.64,2.19.6.35,1.19.7,1.8,1.04.01.01.03.01.04.02-.03-.03-.07-.07-.08-.12-.01-.01-.03-.02-.03-.03-.07-.09-.13-.2-.17-.33-.06-.13-.11-.26-.14-.39-.06-.15-.1-.3-.14-.45-.01-.09-.04-.19-.06-.27-.01-.05-.03-.11-.03-.15-.01-.09-.03-.17-.03-.23v-.09v0c-3.27-1.67-6.49-3.33-9.89-4.77-.96-.41-1.97-.79-2.92-1.19Zm22.3,28.72c.46-.81,1.29-1.55,2.47-1.47c5.07.33,9.88.6,14.67,2.26c5.62,1.96,9.77,5.16,13.31,9.42c3.13,3.78,5.49,7.06,7.03,11.96c1.22,3.93,1.73,9.74-1.6,13.5-.07.08-.15.16-.22.21-2-1.68-4-3.36-5.97-5.08c1.01-.91,1.63-2.28.86-3.4-2.95-4.29-6.69-7.62-11.02-10.96-1.32-1.02-2.85-2-4.3-2.89.14-.13.31-.3.44-.44c1-1.05.97-2.73-.27-3.51-5.23-3.29-10.57-5.96-15.39-9.6Zm-9.49-22.78c0,0,0-.01.01-.01c0-.04-.01-.07-.01.01Z"
                fill="#958e50"
              />
              <path
                d="M492.31,693.44c0,0-.01,0-.02-.01c0-.04-.11-.15-.1-.18s.16-.13.17-.11c0,.02-.05.25-.06.3Z"
                fill="#958e50"
              />
              <path
                d="M459.57,612.59c1,.21,2.13.44,3.12.63c2.04.41,4.13.75,6.22,1.04s4.19.53,6.24.7c2.41.04,4.83.07,7.23,0c16.86-5.24,34.24,4.04,51.65,3.92c2.38.91,5.65,1.09,8.27,1.81-.56,1.11-1.31,2.08-2.19,2.98-17.97,10.84-40.79,3.16-59.65-.32-2.17-.66-4.28-1.35-6.3-2.03-.93-.74-1.75-1.58-2.81-2.2-2.44-1.43-4.97-2.55-7.61-3.7-.73-.32-1.12-.82-1.88-1.28-.75-.46-1.77-1.23-2.59-1.72.1.03.18.15.3.17Z"
              />
              <path
                d="M486.31,611.59c0,0,.41.05.4.05c0,0-.42-.04-.45-.05-.03,0,0,0,.04,0Z"
              />
              <path
                d="M467.99,611.8c-1.31.15-2.61.28-3.93.37c1.31-.09,2.62-.23,3.93-.37Z"
              />
              <path
                d="M460.83,575c-.35-.17-.92-.61-1.35-.78c2.03.37,4.01.88,5.96,1.53c4.44,1.46,9,3.43,13.66,4.11c4.67.68,9.04.81,13.61.13s7.26-2.97,9.98-5.95c.52-.57-.01-1.77-.93-1.89-.91-.11-1.7-.2-2.57-.4c2.3.21,4.59.42,6.87.74.25.04.5.09.77.13-.22.84-.32,1.69-1,2.39-6.97,7.26-15.56,7.45-25.9,5.57-1.17-.21-2.22-.37-3.31-.7-.54-.16-.93-.58-1.54-.7-1.72-.32-3.47-.67-5.18-.94-.56-.09-1.21-.23-1.66-.35-.44-.12-.69-.27-1.02-.4-1.94-.77-3.89-1.32-5.88-1.95-.26-.08-.18-.38-.53-.55Z"
                fill="#958e50"
              />
              <path
                d="M446.21,573.7c-.61,0-.13,0-.13,0c1.54,0,3.36.09,4.93.22-1.24-.13-3.9-.21-4.81-.22Z"
                fill="#958e50"
              />
              <path
                d="M495.57,571.15c-2.22-.22-4.47-.03-6.68-.15-4.41-.23-8.8-.9-13.2-.85s-8.74.51-13.09.86c-3.56.29-6.99.73-10.47,1.34-.67.12-1.36-.14-2.04-.03c7.91-2.49,15.95-4.39,24.19-5.99c2.83-.19,5.67-.32,8.51-.37.06,0,.11.02.16.03c4.91.9,9.68,1.51,14.72,1.11.48.2.98.06,1.47.17c2.05.48,4.05,1.01,6,1.77.24.09.38.3.59.52.2.22.64.59.85.85s.12.65.23.94c-3.61-.38-7.1-.46-10.71-.15-.19.02-.35-.04-.53-.06Z"
                fill="#958e50"
              />
              <path
                d="M487.88,526.99c-.06-.06-.37-.36-.37-.37c0,0,.3.28.36.33c0,0,.01.04,0,.03Z"
                fill="#b5be72"
              />
              <path
                d="M476.31,506.63c.83,2.08,2.29,4.48,3.25,6.65.74,1.68,1.26,3.6,2.14,5.26-.78-.78-1.71-1.66-2.54-2.37-3.76-3.22-8.12-6.01-12.1-8.94-4.55-3.35-8.46-7.01-11.25-11.42-3.53-5.59-6.42-11.28-10.17-16.69-.23-.34-.63-.22-.51.22.12.45.51,1.45.69,1.98-1.13-2.11-2.44-4.47-3.54-6.55-1.39-2.64-2.84-5.19-4.23-7.71s-2.56-4.7-5.11-6.47c-.52-.36-1.32.01-1.22.59.53,3.06,2.31,5.91,2.92,8.98.62,3.07.89,6.39,1.2,9.44.3,3.05.56,5.85,1.04,8.83-.51-.8-1.32-1.88-1.75-2.62s-.94-1.24-1.21-1.9c-1.91-4.72-3.74-9.5-5.63-14.17-2.7-6.7-5.59-12.68-10.3-18.69-2.15-2.75-5.22-5.65-8.12-8.02-2.45-3.41-5-6.66-7.99-9.76c5.66,4,10.97,8.01,17.09,11.6s12.07,7.21,19.52,8.69c1.51.81,2.97,1.43,4.5,2.21c4.29,2.17,8.32,3.61,12.29,6.49c7.21,5.25,11.37,12.35,15.36,19.59c1.07,8.56,2.35,16.54,5.66,24.79Z"
                fill="#b5be72"
              />
              <path
                d="M483.64,526.3c.42.46.87.95,1.31,1.42-.91-.09-1.84-.14-2.75-.1.37-.15,1.09.15,1.38-.07s.04-.94.06-1.26Z"
                fill="#b5be72"
              />
              <path
                d="M466.56,520.34c2.39,1.14,4.88,2.13,7.28,3.25-2.4-1.13-4.89-2.11-7.28-3.25Z"
                fill="#b5be72"
              />
              <path
                d="M457.07,434.25c.06.33.15.57.31.86.93,1.84,1.83,3.63,2.54,5.57.73,1.93.87,3.86,1.45,5.88c1,3.56,2.37,6.78,3.51,10.45c2.18,7.11,3.99,14.43,5.34,21.81.17.94.29,1.9.42,3v0c0,0,.01.05.01.07.13,1.05.27,2.1.41,3.15.15,1.04.3,2.09.46,3.13.31,2.08.67,4.13,1.11,6.18.35,1.63.73,3.27,1.19,4.89.15.55.31,1.09.48,1.63.25.89.55,1.79.86,2.67.18.51.37,1.03.55,1.54.2.51.39,1.03.6,1.54s.45,1.05.72,1.61c.13.28.27.56.42.84.55,1.12,1.17,2.26,1.71,3.37.03.07.07.15.11.23.1.2.18.4.28.6.3.63.52,1.29.76,1.96c0,.03.01.07.03.09.27.79.53,1.6.94,2.34c0,.02.01.05.03.07c0,.01.01.02.01.03.01.05.04.09.06.13.13.21.24.42.38.62.08.14.18.27.3.41.01.01.01.02.03.03.41.5.88.98,1.35,1.49.04.04.07.07.11.12.31.34.62.7.9,1.11.08.12.15.23.24.36.03.05.07.08.08.13.45.68.91,1.44,1.33,2.19.21.38.41.77.59,1.14.1.19.18.36.27.54.01.01.01.03.03.06q0,0,.01.02c.07.09.17.17.27.27.08.06.14.13.2.18.03.03.06.06.08.09l.03.02c0,0,.03.04.06.05c0,.01.01.02.03.03.01.02.04.05.07.07.01,0,.01.01.03.01.01.01.01.02.03.02.01.01.03.02.04.05v.02h.04c1.35,1.13,2.85,2.11,4.57,2.77.55.22.89.21,1.43.2v0c-.98-.91-1.94-1.82-2.84-2.74-.44-.43-.86-.88-1.25-1.32-.44-.46-.86-.92-1.25-1.4-1.6-1.9-3.01-3.91-4.13-6.11-.06-.12.08-.16.15-.06c2.29,3,4.69,5.9,7.49,8.59.35.34.72.66,1.1.98.37.32.73.62,1.1.95h.01c-3.27-5.93-4.64-12.21-5.07-18.65-.01-.34.03-.54-.03-.75-.58-2.64-1.07-6.02-1.48-8.49-1.35-8.33-2.64-16.57-3.54-24.68-.39-3.64-.6-6.46-1.35-9.91-.03-.17-.14-.3-.23-.44-2.22-4.17-4.6-8.05-7.79-11.8-2.85-3.36-5.86-6.78-8.74-10.16-3.25-2.48-5.92-5.05-7.76-8.39-.29-.53-.89-.79-1.22-1.28Zm18.16,28.97c0-.25.34-.13.37.09c1.21,10.41,2.23,20.02,3.99,30.7.81,5.02,1.45,11.14,3.57,16.48c2.12,5.32,6.76,10.56,9.6,15.8.21.4-.21.51-.49.27-8.81-7.77-12.73-19.36-13.97-28.87-1.67-12.87-2.75-22.3-3.06-34.47Z"
                fill="#1f2107"
              />
              <path
                d="M534.81,534.24c0,0,.07.44.07.43c0,0-.06-.4-.07-.45c0-.03,0-.02,0,.01Z"
                fill="#ecd5b1"
              />
              <path
                d="M536.61,554.06c0-.08-.12-.15-.18-.09-.72.64-.77,1.44-1.07,2.23s-.84,1.5-1.3,2.2c-.79-3.28-2.83-7.34-4.18-10.23-3.26-6.95-5.88-13.17-7.88-20.22-.07-.26-.49-.24-.47.01.53,6.34,2.82,12.26,4.66,18.41.87,2.89,1.64,5.84,2.65,8.71-.13.02-.24.08-.23.21.17,2.54,1.19,4.74,2.56,6.95.22.35.36.82.43,1.06.03.1-.32-.12-.46-.19-.98-.5-2.06-.87-2.97-1.57-.91-.71-1.72-1.61-2.48-2.49-.23-.28-.18-.57-.41-.98s-.13-1.17-.42-1.66c-.69-1.14-1.63-2.24-2.42-3.39-3.67-5.35-7-10.86-9.4-16.68-.33-.79-.67-1.56-.72-2.32-.24-3.56-.89-7.43-.8-10.92.11-4.19-.15-9.18.36-12.98.42-3.09,3.77-8.51,1.34-10.09-1.24-.8,0,0,0,0-.52,0-.4.36-.4.68c0,1.24.16,2.22.7,3.52.67,1.63,1.61,3.43,2.62,5.06c2.25,3.64,5.07,6.98,7.8,10.41c2.99,3.75,5.7,7.5,7.47,11.82c1.97,4.81,3.53,9.85,4.95,14.8.09.32.27.43.6.51.03,0,0-.03,0-.03s0-.04,0-.04.01.02.01.04c-.13,2.63-.11,4.94-.31,7.67-.11,1.53-.7,3.59-1.08,5.18.15-1.87.98-3.67,1.07-5.57Z"
                fill="#ecd5b1"
              />
              <path
                d="M534.87,564.06c0,0,.02.32,0,.33-.01.01-.15-.17-.15-.19s.14-.15.15-.13Z"
                fill="#ecd5b1"
              />
              <path
                d="M621.05,458.71c-.03.29-.21.72-.4,1.06-.2.33-.44.74-.64,1.08.27-.65.51-1.4.75-2.02.03-.08.3-.18.3-.11Z"
                fill="#f0d9cf"
              />
              <path
                d="M611.55,468.12c-1.2,1.18-2.48,2.26-3.74,3.39c1.11-1.18,2.24-2.35,3.33-3.54c2.63-2.89,5.15-5.77,8.3-8.29-.22.22-.39.47-.61.7-2.43,2.58-4.74,5.25-7.28,7.74Z"
                fill="#f0d9cf"
              />
              <path
                d="M603.27,549.02c-1.41,4.24-4.35,7.85-7.19,11.4s-6.02,6.59-9.46,9.62c-6.61,5.83-13.41,10.84-19.03,17.5-2.81,3.32-4.46,6.76-6.13,11.02-1.2,3.05-1.47,7.23-.58,10.68.03.13.04.28-.08.43-.12.14-.51.35-.76.42-.49-1.8-1.73-3.67-2.52-5.32-2.03-4.26-2.41-8.41-2.61-12.88-.07-1.48.07-2.83.09-4.29c1.1-2.34,2.34-4.61,3.74-6.83-.08-.82-.24-1.61-.13-2.43.39-2.72,1.21-5.25,2.54-7.76c2.27-4.28,4.89-8.27,7.53-12.43c4.94-7.81,9.77-15.48,12.69-24.08c2.68-7.88,3.26-16.22,4.45-24.36.01-.08-.05-.16.03-.24.6-.6.88-1.03,1.04-1.85.8-4.24,1.38-8.51,3.39-12.53c1.7-3.4,4.11-6.37,6.38-9.58s4.87-6.66,7.73-9.5c2.86-2.85,6.08-5.09,8.92-7.88.58-.57,1.09-1.14,1.63-1.73-.61,1.27-1.21,2.6-1.74,3.89-1.74,4.29-3.35,8.53-4.39,12.97c0,.04.05.05.07.01c1.61-3.33,3.08-6.73,4.61-10.07-2.11,5.22-4.28,10.69-5.67,16.01s-2.35,10.32-2.89,15.69.01,10.76-.02,16.18c-.01,1.78.58,3.52.5,5.37-.13,3.1-.54,6.2-.75,9.37-.28,4.34,0,8.99-1.42,13.23Z"
                fill="#efe5d4"
              />
              <path
                d="M594.05,488.32c-.87,1.35-1.71,2.71-2.51,4.09.77-1.39,1.61-2.75,2.51-4.09Z"
                fill="#f0d9cf"
              />
              <path
                d="M680.82,613.74c-.78.78-1.54,1.57-2.28,2.38.74-.81,1.5-1.6,2.28-2.38Z"
                fill="#ecd5b1"
              />
              <path
                d="M694.72,608.49c0,0,.35.15.34.16c0,0-.45-.1-.45-.1s.44.1.45.1c0,0-.34-.16-.34-.16Z"
                fill="#ecd5b1"
              />
              <path
                d="M550.52,673.74c-1.11.69-2.52,1.59-3.7,2.31c1.8.11,3.32.33,4.95,1.02c2.19.93,4.16,2.08,6.13,3.3.14.09.37.08.53.16c3.92,1.96,7.32,3.57,12.09,3.92c6.35.48,12.7.7,19.13-.75c12.52-2.82,23.74-7.93,33.66-15.01s17.86-15.87,26.29-24.13c.32-.56.73-1.08,1.12-1.6h-.01v-.05c0,0,.01-.07.03-.11.27-.38.53-.76.81-1.13.23-.3.45-.61.69-.9.59-.73,1.19-1.43,1.83-2.14.37-.4.73-.79,1.11-1.18c2.36-2.46,4.96-4.8,7.41-7.21c1.12-1.1,2.18-2.22,3.2-3.34c1.03-1.12,2.04-2.25,3.04-3.37.51-.57,1.01-1.13,1.52-1.7.51-.56,1.01-1.13,1.53-1.69.45-.49.9-.98,1.38-1.47.6-.63,1.21-1.26,1.84-1.88c1.11-1.1,2.25-2.21,3.46-3.27.37-.33.73-.64,1.11-.96.2-.18.39-.35.62-.51.2-.16.41-.33.62-.49.41-.31.83-.63,1.26-.95.87-.62,1.78-1.21,2.73-1.74.22-.13.44-.25.66-.36.06-.03.11-.06.17-.08.28-.15.58-.29.87-.42.37-.17.77-.31,1.18-.42.79-.21,1.66-.33,2.42-.4.11-.01.21-.02.31-.02.41-.03.76-.05,1.03-.05h.21c-.17-.07-.35-.16-.55-.23-4.69-1.6-9.67-2.29-14.67-2.35-3.57-.03-6.73.37-10.09,1.06-.55.1-.91.48-1.36.72-1.98,1.05-3.84,2.25-5.69,3.48-8.14,3.4-15.46,7.99-23.06,12.09-9.7,5.22-19.88,8.89-30.72,11.87-9.85,2.71-19.9,3.66-29.45,7-2.6,2.05-5.45,4.04-8.28,5.87-1.39.9-2.64,1.72-3.99,2.61-2.52,3.14-5.07,6.1-7.6,9.26-3.29,4.11-6.46,8.35-9.39,12.69-.55.82-1.24,1.77-1.77,2.6.93-.79,1.91-1.55,2.92-2.26.69-.47,1.38-.93,2.08-1.39.37-.23.73-.45,1.11-.68c2.61-1.54,5.4-2.87,8.22-4.05.25-.12.52-.21.77-.33.79-.33,1.56-.63,2.35-.92.45-.17.9-.34,1.34-.51.42-.17.84-.35,1.28-.51c1.26-.5,2.47-.99,3.68-1.48.62-.25,1.25-.48,1.87-.71.06-.02.1-.05.15-.06.55-.21,1.11-.42,1.67-.62c1.56-.55,3.12-1.09,4.68-1.61c3.88-1.33,7.79-2.6,11.69-3.85c2.35-.75,4.69-1.49,7.04-2.25c2.66-.84,5.31-1.68,7.95-2.53c2.05-.66,4.09-1.33,6.13-2.01.31-.09.46.27.15.4-11.55,4.78-23.48,8.32-35.19,13.02-5.64,2.26-11.3,5.09-16.72,7.93-2.52,1.32-5.26,2.79-7.76,4.33Zm57.11-29.24c-.42,1.69-2.19,2.62-3.88,3.2-4.06,1.39-8.21,1.49-12.28,2.32-4.08.83-7.66,2.03-11.44,3.49-2.21.84-4.41,1.86-6.58,2.82-2.16.98-4.36,1.51-6.56,2.52-2.22,1.03-4.03,2.29-6.16,3.69-2.11,1.4-4.62,2.99-6.7,4.61-.79.61-1.86-.16-1.24-.9.63-.72.97-1.58,1.62-2.22c3.92-3.86,7.94-7.69,12.45-11.05c2.09-1.55,4.16-3.16,6.93-3.57c2.78-.42,4.99.01,7.28-1.61c2.3-1.62,4.13-3.5,6.87-4.76.46-.21.98-.44,1.52-.65.35-.14.72-.26,1.08-.36.11-.02.22-.05.34-.07.11-.02.22-.05.34-.07.17-.03.32-.06.49-.07.17-.02.32-.03.49-.03.14,0,.28.01.41.02.03,0,.06.01.08.01.13.01.25.04.37.07.14.02.28.07.41.12.42.15.83.41,1.18.79.15.16.31.32.46.43h.01c.08.07.17.13.25.17.08.06.17.11.25.14.11.06.22.11.35.14s.24.07.38.08c.11.02.25.03.38.03h.07c.17,0,.34-.01.52-.05.08-.01.18-.02.28-.06.08-.01.18-.03.28-.07.03,0,.04-.01.06-.04c0-.01.01-.01.01-.01.03-.03.06-.06.25-.01h.04c0,0,.08.05.14.07.03,0,.07.02.11.03.07.03.15.06.24.09h.01c.1.05.23.08.35.12.41.12.93.23,1.53.34.25.05.52.09.79.13.01-.01.03-.01.04,0c.28.02.59.06.89.09.25.02.51.05.76.07c1.48.08,3.01.03,4.19-.25.06,0,.11-.01.17-.03.06-.01.1-.02.15-.03.11.13.03.22,0,.3Zm25.39-12.74c.44-.33,1.08-.76,1.59-1.1-.42.36-.9.82-1.31,1.14-.07.06-.35,0-.28-.05Zm17.71,11.2c0,0,.01-.02.03-.02h-.01c0,0,0,.02-.01.02Z"
                fill="#dcc395"
              />
              <g>
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(622.82 639.35)"
                  fill="#f0debf"
                />
                <path
                  d="M593.22,674.27c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(569.09 663.62)"
                  fill="#f0debf"
                />
                <path
                  d="M588.05,653.23c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M566.2,677.03c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M564.02,657.52c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M559.7,674.66c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M604.37,657.84c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(570.59 654.25)"
                  fill="#f0debf"
                />
                <path
                  d="M580.82,669.68c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M610.33,644.74c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M602.56,668.1c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M594.46,655.19c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M578.06,671.86c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M577.94,666.11c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(558.63 665.57)"
                  fill="#f0debf"
                />
                <path
                  d="M604.62,637.19c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M575.73,676.36c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M617.43,646.44c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M625.65,645.93c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M575.22,658.95c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M560.88,676.41c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M589.56,637.16c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M568.88,675.25c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M629.32,648.96c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M619.28,665.82c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M568.8,648.3c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M610.56,659.89c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M574.53,667.47c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M563.11,678.05c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M590.67,662.43c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M616.25,631.44c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(613.27 644.41)"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(575.25 671.87)"
                  fill="#f0debf"
                />
                <path
                  d="M570.39,678.66c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M593.83,638.68c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M567.5,653.97c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M580.34,677.16c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M574.87,661.99c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M574.46,680.11c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(579.05 663)"
                  fill="#f0debf"
                />
                <path
                  d="M590.97,643.56c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M584.46,661.04c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(611.54 650.71)"
                  fill="#f0debf"
                />
                <path
                  d="M596.68,672.65c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M571.21,674.74c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(561.52 671.62)"
                  fill="#f0debf"
                />
                <path
                  d="M589.43,658.76c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(585.98 665.18)"
                  fill="#f0debf"
                />
                <path
                  d="M620.95,633.65c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M591.51,676.47c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(599.9 655.47)"
                  fill="#f0debf"
                />
                <path
                  d="M576.7,645.12c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M620.42,642.18c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M605.76,661.48c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M620.97,629.88c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M600.41,675.8c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(586.61 674.58)"
                  fill="#f0debf"
                />
                <path
                  d="M579.4,657.5c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M632.13,641.66c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M566.68,655.63c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M587,641.76c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M583.11,652.94c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M589.27,678.1c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M570.19,672.88c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M585.77,658c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M599.5,660.52c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M595.92,641.49c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(595.41 658.97)"
                  fill="#f0debf"
                />
                <path
                  d="M584.45,639.85c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M581.1,656.55c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M589.42,667.98c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M630.57,654.67c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M571.94,648.99c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M641.8,637.21c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M590.99,679.84c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M616.93,654.52c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(562.81 656.05)"
                  fill="#f0debf"
                />
                <path
                  d="M567.37,666.13c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M581.18,641.7c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M601.51,634.52c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M565.01,678.98c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M614.87,668.12c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M592.64,672.22c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M622.02,653.86c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M564.09,660.63c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M604.82,641.58c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M610.29,672.56c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M564.13,666.86c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M596.92,678.16c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M607.2,665.17c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(619.25 658.65)"
                  fill="#f0debf"
                />
                <path
                  d="M611.13,655.47c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M559.31,667.35c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M603.59,675.53c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(580.89 663.16)"
                  fill="#f0debf"
                />
                <path
                  d="M555.94,665.9c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M583.57,667.18c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M607.28,656.05c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M593.74,676.83c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M600.8,639.48c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M568.02,658.53c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M594.17,666.68c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M616.77,660.84c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M625.32,628.8c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M596.86,651.42c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M573.4,655.94c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M584.78,644.98c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M606.85,669.71c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(579.51 682.03)"
                  fill="#f0debf"
                />
                <path
                  d="M589.86,655.95c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(568.27 672.13)"
                  fill="#f0debf"
                />
                <path
                  d="M606,646.09c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M600.15,658.3c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M556.19,668.43c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M610.57,668.53c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M593.51,649.44c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M613.15,662.35c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M626.13,635.24c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M586.71,675.67c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M570.33,666.65c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M578.51,674.23c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M576.75,678.24c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M590.08,672.08c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M602.48,662.57c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M564.76,670.62c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M552.77,668.53c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M599.93,667.34c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M576.54,663.92c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M602.45,672.29c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M562.5,663.88c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M558.58,669.87c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M599.67,646.65c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M607.75,649.77c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M633.71,632.17c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M574.21,673.94c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M559.78,673c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(596.89 637.09)"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(582.32 666.86)"
                  fill="#f0debf"
                />
                <path
                  d="M584.54,677.65c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M634.87,650.39c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(614.87 653.34)"
                  fill="#f0debf"
                />
                <path
                  d="M596.12,662.67c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M610.88,635.26c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M569.46,680.46c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M604.98,651.16c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M586.05,668.89c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M639.32,648.68c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(586.08 681.53)"
                  fill="#f0debf"
                />
                <path
                  d="M563.5,673.76c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M623.73,650.59c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M558.12,661.48c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M614.98,639.83c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M572.31,670.42c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M566.06,651.51c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M553.39,673.85c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M561.12,658.45c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M563.45,652.75c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M571.2,660.6c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M585.42,671.06c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M633.68,623.7c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M574.15,645.24c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(566.56 664.14)"
                  fill="#f0debf"
                />
                <path
                  d="M625.1,659.84c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.4-.52,1.4-1.17-.63-1.17-1.4-1.17Z"
                  fill="#f0debf"
                />
                <path
                  d="M555.79,673.86c-.78,0-1.41.52-1.41,1.17s.63,1.17,1.41,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
                <ellipse
                  rx="1.41"
                  ry="1.17"
                  transform="translate(643.48 645.09)"
                  fill="#f0debf"
                />
                <path
                  d="M582.31,673.93c-.78,0-1.4.52-1.4,1.17s.63,1.17,1.4,1.17s1.41-.52,1.41-1.17-.63-1.17-1.41-1.17Z"
                  fill="#f0debf"
                />
              </g>
              <path
                d="M527.84,794.16c4.1.62,6.89-.07,9.87-2.79c3.71-3.4,7.66-7.48,11.41-11c1.49-.41,2.88-.74,4.3-1.31c6.2-2.54,11.23-6.03,15.98-10.19c3.96-3.47,7.48-7.2,11.45-10.66.41-.34,1.01-.88,1.36-1.18s.66-.51.96-.72c1.04-.76,2.45-1.74,3.44-2.35c2.37-1.45,4.61-2.66,7.01-3.84c4.99-2.44,9.61-4.57,15.22-5.99c4.95-1.25,10.34-1.41,15.56-1.38c5.23.04,10.46.64,15.65.93c6.2,1.38,12.21,2.39,18.66,2.57c1.53.05,2.87-.7,3.88-1.61-3.23.92-6.14.55-9.11-.72-1.59-.68-2.57-1.56-3.78-2.52-.41-.32-.9-.44-1.34-.69-3.13-1.79-5.82-4.07-9.12-5.65-1.81-.86-3.85-1.53-5.76-2.11-.76-.25-1.87-.16-2.49-.27-.62-.1-1.19-.08-1.53-.13-.35-.03-.27-.08-.38-.12-9.49-2.37-17.99-5.22-28.16-5.03-13.01.24-24.35,4.1-36.02,9.22-8.83,3.87-17.03,9.07-23.72,15.4-.15.15-.31.34-.46.5-1.35,1.48-2.57,3.02-3.68,4.63-1.39,4.2-2.39,8.48-3.33,12.75-.93,4.26-1.94,8.46-3.27,12.64c1.41-1.62,2.8-3.19,4.36-4.71c1.62-1.56,3.22-3.12,4.86-4.66.77-.72,1.55-1.45,2.33-2.17.44-.41.89-.82,1.34-1.21.44-.4.87-.79,1.31-1.18-.3.23-.59.47-.89.71-.96.79-1.93,1.54-2.89,2.31-.8.65-1.6,1.31-2.39,1.96-.17.15-.37.2-.59.23c3.19-6.2,7.22-12,11.09-17.9c1.8-2.01,3.57-3.99,5.51-5.9c1.21-1.2,2.52-2.39,3.99-3.36.41-.26.76-.45,1.19-.63.04-.01.03.06.08.09c1.8,1.07,3.57.14,4.79-1.13c2.63-2.74,6.13-3.79,9.98-4.92.11-.02.22.05.34.08c1.03.39,1.55,1.35,1.26,2.21-.48,1.45-1.69,2.53-2.8,3.54-1.67,1.52-3.15,2.89-4.9,4.25-.45.35-.9.69-1.35,1.04-.91.68-1.84,1.34-2.77,2.01-1.39.99-2.81,1.97-4.2,2.96-.93.65-1.85,1.33-2.77,2.01-.56.42-1.11.84-1.66,1.28-1.21.98-2.39,2-3.58,2.99-.39.34-.79.66-1.18,1h.01c1.81-1.38,3.68-2.71,5.62-3.97.97-.62,1.94-1.23,2.94-1.82c1-.61,2-1.18,3.02-1.74-2.22,1.77-4.41,3.58-6.59,5.41-1.1.91-2.18,1.83-3.26,2.77-3.01,2.59-5.94,5.24-8.8,7.95-.44.4-.84.79-1.25,1.19-.8.75-1.57,1.51-2.35,2.28-.03.02-.06.06-.08.09-1,.97-1.97,1.95-2.92,2.94-1.5,1.55-3.01,3.05-4.24,4.61-2.67,3.36-3.61,6.88-5,10.64-.03.06-.04.12-.07.17-.03.06-.06.12-.08.19Zm55.58-55.34c6.77-3.05,13.43-4.81,21.16-5.16.25-.01.2.34-.06.36-7.41.78-14.24,2.44-21.02,5.06-.22.09-.3-.18-.08-.27Z"
                fill="#4b491b"
              />
              <path
                d="M393.04,661.02c4.65,3.83,8.77,8.04,13.33,11.95c2.25,1.93,4.46,3.82,6.6,5.87s4.15,4.09,5.17,6.72c.07.19-.17.4-.41.26s-.51-.33-.76-.52c-2.11-1.57-3.81-3.47-5.78-5.16-2.41-2.08-4.95-4.06-7.51-6.01-4.85-3.69-9.87-7.2-15.09-10.52-3.61-2.3-7.48-4.15-11.49-5.92-1.24-.54-2.56-1-3.79-1.54-.31-.14-.52-.4-.79-.59-.69-.51-1.33-1.04-2.02-1.56-2.37-1.78-4.72-3.55-7.33-5.1-1.04-.62-2.17-1.13-3.21-1.77-.23-.14-.32-.31-.53-.57s.25-.68.64-.51c5.48,2.49,11.53,3.34,17.24,5.32.09.03.19.06.28.1c5.77,2.58,10.79,5.69,15.45,9.52Z"
                fill="#5c542c"
              />
              <path
                d="M501.22,690.12c-1.46.63-2.87,1.48-4.17,2.26-.83.5-1.5.77-2.41,1.1.8-4.63,1.1-9.2,1.32-13.88.07-1.44.08-2.94-.12-4.43-.36-2.71-.59-5.5-1.19-8.17-.14-.6-.23-1.36-.32-1.89-.39-2.27-3.07-5.39-4.3-6.58-.79-.76-.17-.16-.18-.17-1.65-3.16-3.21-5.89-5.7-8.5-2.11-2.22-4.61-4.03-7.25-5.82-5.19-5.23-12.42-8.07-19.18-11.54-6.24-3.2-11.96-6.52-17.94-9.95-.39-.67-.64-1.34-.66-2.09c0-.02-.02-.02,0-.03.01,0,0,0,0,0c.57-.18,1.1.49,1.48.69s.7.32,1.03.46c.32.15.23.1.61.26s1.12.46,1.59.64c.48.18,1.3.46,1.7.59s.31.1.64.2.86.26,1.18.35.4.11.71.19.81.21,1.12.29.41.1.72.17.87.19,1.18.25.36.07.68.14c.32.06,1.18.22,1.45.26.26.04.25.04.37.06.68.11,1.27.19,1.93.29.12.02.23.02.35.04c1.26.22,2.57.21,3.83.43.83.15,1.64.37,2.46.61c8.12,2.45,16.33,3.7,23.79,7.71c15.31,8.23,23.84,19.52,26.52,34.56.31,1.76.27,3.6-.28,5.39-.9,2.95-2.46,5.94-4.13,8.73s-4.16,5.19-6.78,7.4c0-.02-.02-.04-.05-.03Z"
                fill="#cfc395"
              />
              <path
                d="M494.98,671.52c-.1-1.01-.16-2.02-.22-3.04.11,1.01.18,2.02.22,3.04Z"
                fill="#cfc395"
              />
              <path
                d="M498.83,691.97c0,0,.03-.02-.08.06s-.55.38-.73.49c1-.74,2.02-1.48,3.03-2.22-.74.57-1.46,1.12-2.23,1.67Z"
                fill="#cfc395"
              />
              <path
                d="M434.65,470.15c-.62-3.07-2.39-5.91-2.92-8.97-.1-.58.7-.96,1.22-.59c2.54,1.8,3.73,3.92,5.11,6.48s2.86,4.99,4.23,7.73c1.08,2.16,2.46,4.17,3.52,6.61c2.24,5.16,4.69,10.57,7.33,15.8c2.14,4.25,5.04,8.21,8.84,11.66.66.6,1.45,1.13,2.12,1.71c2.81,2.45,6.03,4.83,9.1,6.95c3.08,2.12,5.71,4.18,8.33,6.62.67.63,1.55,1.46,2.05,2.14.26.36.17,1.06,0,1.26-.17.21-1.15-.01-1.34.05s-.13,0-.2.01c-.07,0-.08-.03-.11-.05-.62-.33-1.23-.68-1.85-.99-.12-.06-.25-.12-.36-.18-1.02-.51-2.36-1.15-3.31-1.6s-1.72-.81-2.55-1.19c-2.46-1.16-4.87-2.1-7.3-3.26-3.75-3.18-7.5-6.48-11.04-9.78-.51-.48-1.08-1.04-1.44-1.39s-.26-.26-.53-.54c-.27-.27-.67-.66-.93-.92s-.35-.35-.6-.6c-.24-.24-.59-.59-.82-.84-.24-.25-.38-.4-.62-.64-.23-.24-.53-.56-.76-.81s-.39-.43-.62-.67c-.22-.25-.5-.55-.72-.8s-.4-.45-.62-.7-.47-.54-.68-.79c-.22-.25-.41-.47-.61-.72-.21-.25-.43-.52-.64-.77s-.43-.52-.62-.75c-.19-.24-.36-.45-.53-.68-.58-.72-1.13-1.4-1.72-2.13-.01-.02.05.06-.07-.08-.11-.14-.59-.75-.75-.97-.17-.22-.19-.24-.36-.47-.18-.23-.56-.73-.74-.98-.18-.24-.18-.24-.37-.49-.18-.25-.56-.75-.74-1-.18-.24-.16-.22-.34-.46-.18-.25-.57-.79-.74-1.03s-.11-.15-.28-.39c-.17-.23-.58-.82-.74-1.04-.16-.23-.05-.07-.2-.29-.16-.23-.65-.94-.78-1.13-.09-.13-.03-.04-.03-.04v0c-.5-2.99-.74-5.78-1.05-8.83s-.58-6.37-1.2-9.44Z"
                fill="#e5d3ae"
              />
              <path
                d="M501.77,572.16c.91.09,1.45,1.31.93,1.88-2.72,2.97-5.41,5.27-9.98,5.95s-8.95.54-13.61-.13-9.22-2.64-13.66-4.11c-1.95-.64-3.92-1.15-5.96-1.53-2.33-1.07-4.71-1.59-7.35-1.84c3.47-.68,6.91-1.06,10.47-1.36c4.35-.37,8.69-.81,13.09-.87c4.4-.05,8.8.62,13.2.85c2.21.11,4.5-.07,6.66.15.17.02.54.04.48.06-.14.04-1.05.09-1.24.12s-.09.11-.02.12c1.45.2,2.96.11,4.43.32.86.12,1.66.3,2.57.39Z"
                fill="#e5d3ae"
              />
              <path
                d="M486.08,665.38c1.22,3.93,1.73,9.74-1.59,13.5-.07.08-.16.17-.23.21-2-1.68-4-3.37-5.98-5.07c1.01-.91,1.63-2.27.85-3.4-2.95-4.29-6.68-7.62-11.01-10.95-1.31-1.01-2.85-1.99-4.3-2.9.14-.13.31-.3.44-.44c1-1.06.96-2.73-.27-3.51-5.22-3.3-10.57-5.97-15.39-9.6.46-.81,1.28-1.55,2.47-1.48c5.07.33,9.88.6,14.67,2.27c5.61,1.96,9.77,5.16,13.3,9.41c3.14,3.78,5.5,7.06,7.03,11.97Z"
                fill="#e5d3ae"
              />
              <path
                d="M573.46,656.34c-2.17.98-4.36,1.5-6.57,2.52s-4.03,2.29-6.14,3.68c-2.12,1.4-4.63,2.98-6.71,4.61-.79.61-1.86-.16-1.24-.89s.96-1.57,1.61-2.22c3.92-3.87,7.94-7.7,12.45-11.05c2.09-1.55,4.16-3.16,6.93-3.57s4.98.02,7.28-1.6c2.29-1.62,4.13-3.51,6.86-4.77c2.05-.94,4.93-2.16,6.71-.24.86.93,1.85,1.22,3.25.83.11-.03-.08-.18.33-.07.27.08-1.05-.43.33.13s6.67,1.34,9.05.49c.12.14.04.23.02.32-.43,1.69-2.2,2.62-3.88,3.2-4.06,1.39-8.21,1.5-12.28,2.32-4.07.83-7.67,2.03-11.45,3.48-2.21.85-4.4,1.86-6.57,2.83Z"
                fill="#f0debf"
              />
              <path
                d="M537.87,773.84c3.19-6.19,7.22-11.99,11.09-17.9c1.8-2,3.56-3.99,5.51-5.9c1.21-1.19,2.51-2.39,3.99-3.35.41-.27.76-.45,1.2-.63.04-.02.03.05.09.08c1.8,1.08,3.56.15,4.79-1.13c2.63-2.74,6.13-3.79,9.98-4.92.11-.03.22.04.33.08c1.03.38,1.54,1.34,1.26,2.2-.48,1.44-1.69,2.53-2.79,3.53-1.67,1.52-3.15,2.9-4.91,4.26-3.59,2.78-7.43,5.31-11.09,8.01-2.25,1.66-4.3,3.54-6.43,5.26s-4.22,3.44-6.26,5.18c-2.04,1.73-4.16,3.27-6.16,5-.18.15-.36.19-.6.23Z"
                fill="#958e50"
              />
              <path
                d="M459.45,574.21c.51.23,1.11.62,1.35.78.24.17.75.47.55.56s0,0,0,0c-.61.29-1.8-.36-2.4-.53-.13-.04-.38-.07-.52-.1-.52-.11-1.36-.26-1.8-.33s-.39-.06-.79-.12-1.32-.19-1.67-.23-.51-.07-.72-.09c-.72-.07-1.75-.21-2.38-.23-1.29-.04-4.07-.07-4.81-.19-.69-.11-.17-.03-.17-.03.18-.89,1.84-.73,2.65-.95.37-.1.98-.33,1.2-.4s.06-.02.12-.04.01,0,.02,0c.68.01,1.37.01,2.05.07c2.6.22,5.08.8,7.32,1.82Z"
              />
              <path
                d="M536.93,546.81c-.33-.08-.51-.2-.6-.51-1.42-4.95-2.98-9.99-4.95-14.8-1.77-4.32-4.48-8.07-7.47-11.82-2.74-3.43-5.55-6.77-7.8-10.41-1.01-1.63-1.93-3.43-2.62-5.06-.54-1.3-.67-2.29-.71-3.52-.01-.31.16-.64.17-.79s0-.04,0-.04c.59.06.5.86.66,1.24c0,.02.03.05.04.07.18.31.52.84.68,1.08s.08.11.23.32c.14.21.45.63.61.84.15.2.15.19.31.38.15.19.44.54.6.73s.21.23.37.42c.16.18.43.48.6.66s.26.27.43.45.41.42.59.6.32.31.5.48.38.36.57.54.39.35.59.54.59.52.76.68c.16.16.21.24.3.35c2.14,2.44,4.36,4.79,6.54,7.19.11.12.2.26.29.39c1.27,1.9,2.81,3.75,3.72,5.79.75,1.68,1.14,3.46,1.78,5.16.42,1.12.82,2.34,1.14,3.42.31,1.08.33,2,.55,3.05.04.17.04.29.08.51s.11.72.14.92c.03.21.05.31.07.47.23,1.59.45,3.15.69,4.72.02.1.04.22.05.31.07.42.17,1.06.23,1.41s.05.3.11.61.18.96.24,1.24.08.38.12.58c.13.61.26,1.16.4,1.75c0,.01.01.03,0,.04c0,0,.02.04,0,.03Z"
              />
              <path
                d="M650.74,642.82c3.18-4.68,7.72-8.48,11.84-12.55c4.46-4.4,8.02-9.02,12.5-13.45c3.3-3.26,6.94-6.63,11.45-8.77c1.43-.68,3.91-.89,4.99-.89.73,0,.12,0,.16,0c.19.01.14.04.18.05.54.22,1.4.61,1.82.8s.76.34.98.45.36.15.39.18-.38-.09-.47-.1-.14-.04-.27-.06-.47-.08-.6-.1-.04,0-.17-.03c-.14-.02-.46-.05-.62-.06s.05,0-.18-.02-1.1-.02-1.34,0s.05,0-.18,0c-.23.01-.99.13-1.2.17-.21.05-.13.02-.24.05-.12.03,0,0-.15.04-.15.03-.36.11-.58.16-1.16.27-2.15.57-3.21,1.17-1.83,1.03-3.44,2.39-4.91,3.79-.03.02-.05.05-.08.08-.78.77-1.55,1.58-2.28,2.38-.19.2-.34.37-.51.56-.51.56-.99,1.12-1.47,1.69-.13.15-.25.31-.38.45-.41.48-.77.99-1.18,1.47-2.09,2.48-3.78,5.24-6.14,7.56-1.45,1.42-3.07,2.66-4.7,3.98-2.12,1.71-4.4,3.43-6.54,5.17-.55.45-1.18.83-1.74,1.28-.12.09-.22.16-.36.27s-.44.34-.59.45c-.15.12-.17.14-.32.26s-.44.35-.59.48c-.15.12-.16.13-.3.25-.15.12-.43.37-.57.49-.14.13-.16.14-.3.27s-.4.37-.54.5-.16.16-.29.29-.37.37-.49.5c-.13.13-.18.2-.29.33-.11.12-.35.41-.43.49s-.06.1-.09.1-.02-.09.02-.14Z"
              />
              <path
                d="M491.58,675.82c-.66-2.59-.41-4.56-.09-7.04s.33-4.79-.35-7.23c-.13-.48-.3-.78-.51-1.31-.22-.53-.67-1.26-1.04-1.81-.06-.09.1-.2.18-.15.05.03.02,0,.03.01c2.14,2.07,3.75,4.14,4.53,6.8.18.63.21,1.25.31,1.89-.09-.39-.18-.78-.27-1.17.13.93.34,1.72.38,2.68s.2,2.02.21,3.03c.06,7.27-1.09,14.45-2.59,21.58-.01.07-.15.16-.18.11-.25-.35-.55-.75-.97-1.03-.02-2.68-.06-5.26.26-7.96s.77-5.82.1-8.41Z"
              />
              <path
                d="M495.8,675.17c.32,1.49.3,2.93.13,4.43c0-1.48-.04-2.96-.13-4.43Z"
              />
              <path
                d="M450.02,720.73c-2.37-3.72-4.61-7.22-6.24-11.17s-2.39-8.03-3.05-12.16c0-.05.08-.06.09-.01c1.44,7,4.16,13.19,8.79,19.17c2.8,6.46,8.21,10.89,13.89,15.72-.21-.11-.01,0-.31-.17-.3-.16-1-.53-1.42-.75s-.97-.5-1.4-.73-1.1-.53-1.46-.74c-.36-.2-.65-.26-.88-.45-3.12-2.62-5.95-5.5-8-8.71Z"
              />
              <path
                d="M453.57,720.6c3.42,3.06,6.93,6.04,10.4,9.06-3.6-2.93-7.16-5.86-10.4-9.06Z"
              />
              <path
                d="M549.25,672.9c-.93.47-1.84.97-2.71,1.51c5.72-4.57,11.71-8.09,18.85-10.97.05-.02.03-.08-.01-.06-.91.25-1.82.53-2.72.81c3.26-1.35,6.57-2.7,9.91-3.89c12.36-4.37,25-8.11,37.47-12.25.3-.1.46.27.15.39-11.54,4.78-23.48,8.32-35.18,13.01-5.64,2.26-11.3,5.09-16.73,7.94-2.52,1.32-5.25,2.78-7.75,4.32-1.12.69-2.52,1.59-3.7,2.31-.02,0,.01,0-.08,0s-.45-.03-.58-.04c1.01-1.03,2.13-1.99,3.17-2.99.08-.08.02-.18-.08-.12Z"
              />
              <path
                d="M521.52,527.96c-.02-.25.4-.27.47-.01c2,7.05,4.62,13.27,7.88,20.22c1.36,2.89,3.39,6.95,4.18,10.23-.09.25-.18.34-.27.57-.4.97-.68,1.98-.75,3.02-1.55-2.18-2.88-4.4-3.95-6.78-.04-.1-.13-.13-.25-.14-1.02-2.87-1.79-5.82-2.66-8.71-1.85-6.14-4.14-12.07-4.66-18.41Z"
              />
              <path
                d="M532.12,563.54c-.16-.15-.32-.02-.48-.24-.16-.21-.31-.77-.45-1.06.3.43.61.86.93,1.29Z"
              />
              <path
                d="M453.15,497.2c-2.61-5.28-5.17-10.52-7.29-15.83-.3-.75-.55-1.5-.71-2.01s.27-.57.5-.23c3.74,5.39,6.63,11.09,10.17,16.68c2.79,4.41,6.7,8.06,11.25,11.42c3.99,2.94,8.32,5.7,12.11,8.95.84.72,1.67,1.47,2.56,2.4.88.92,1.83,1.93,2.72,3.12s1.88,2.95,2.51,4.35c-.9-.87-1.96-1.94-2.92-2.74-2.45-2.03-5.31-3.8-7.97-5.49-5.82-3.71-11.22-7.3-15.93-11.95-.04-.04-.09,0-.06.04c1.18,1.66,2.51,3.19,4.03,4.65-.7-.56-1.46-1.11-2.12-1.71-3.8-3.47-6.72-7.37-8.84-11.66Z"
              />
              <path
                d="M478.29,497.69c-1.67-12.87-2.75-22.3-3.06-34.47c0-.24.33-.13.36.09c1.22,10.41,2.24,20.03,3.99,30.71.82,5.02,1.45,11.14,3.57,16.47s6.76,10.57,9.6,15.81c.21.39-.21.51-.49.26-8.82-7.77-12.73-19.36-13.97-28.86Z"
                fill="#e5d3ae"
              />
              <path
                d="M478,646.29c-3.01-3-7.23-4.59-11.18-6.44-4.39-2.06-8.48-4.14-12.56-6.48-7.86-4.52-15-9.61-21.91-15.08-.08-.07.06-.19.15-.13c2.44,1.48,4.81,2.95,7.3,4.38c5.95,3.43,11.71,6.74,17.93,9.95c6.75,3.48,14.01,6.3,19.16,11.55.62.63,1.06,1.33,1.51,2.03.12.18-.24.38-.41.22Z"
                fill="#fcead3"
              />
              <path
                d="M422.43,675.95c-5.53-4.89-10.97-9.01-17.81-12.48-.04-.02,0-.06.04-.06c3.59.18,6.64,1.42,9.46,3.14c3.69,2.24,6.96,4.57,10.12,7.23c6.15,5.2,11.16,10.76,15.27,17.2.32.5-.67.93-1.05.54-5.21-5.21-10.49-10.69-16.02-15.57Z"
                fill="#fcead3"
              />
              <path
                d="M583.41,738.81c6.77-3.05,13.44-4.8,21.16-5.16.26-.01.21.33-.06.36-7.41.79-14.23,2.44-21.01,5.07-.23.09-.3-.18-.09-.27Z"
                fill="#fcead3"
              />
              <path
                d="M608.95,483.26c0,0-.08.02-.07-.02.93-4.46,2.64-8.67,4.39-12.96.53-1.29,1.12-2.62,1.74-3.89-.54.59-1.05,1.16-1.62,1.73-2.83,2.8-6.03,5.01-8.93,7.84-2.91,2.83-5.43,6.37-7.77,9.55s-4.45,6.25-6.45,9.53c0,.01-.03.06-.01.02.02-.05.1-.3.13-.39.03-.08.03-.17.07-.24.36-.67.74-1.35,1.13-2.02.81-1.37,1.63-2.75,2.51-4.09c2.65-4.01,5.53-7.93,8.62-11.69c1.53-1.87,3.32-3.46,5.14-5.11c1.26-1.14,2.54-2.21,3.74-3.39c2.55-2.51,4.84-5.15,7.29-7.75.22-.23.33-.41.63-.72.29-.31.85-.9,1.24-1.24.05-.04.18-.04.15.06s-.07.22-.11.33c-.23.69-.45,1.37-.75,2.05-1.4,3.25-3.24,6.38-4.97,9.5-.53.96-1,1.88-1.45,2.83-1.59,3.36-2.98,6.75-4.63,10.08Z"
              />
              <path
                d="M503.74,789.68c-.27-.06-.46-.08-.63-.29-1.38-1.61-1.6-3.14-1.97-5.11-.46-2.42-2.19-4.12-4.53-5.61-.2-.13.04-.36.24-.31.98.2,1.87.5,2.75.92-.28-.46-.51-.9-.8-1.34-2.23-3.41-4.06-6.51-6.53-9.91-4.95-6.76-10.22-13.79-15.08-20.66-1.11-1.56-2.28-3.02-3.5-4.5-1.21-1.48-2.5-2.74-3.79-4.21-1.93-2.17-3.64-3.94-6.13-6.11-.04-.02-.07-.06-.11-.09-.03-.02-.06-.05-.11-.08-.01-.03-.03-.05-.06-.06h-.01v-.02c0,0-.01,0-.01-.01h-.03c0,0-.04-.05-.06-.07-.03-.01-.04-.03-.07-.06-.15-.14-.35-.3-.59-.5-.14-.12-.31-.27-.51-.43-.22-.2-.45-.38-.67-.57-.48-.42-1.05-.92-1.69-1.47-1.71-1.54-3.85-3.52-5.71-5.58h-.01c-.14-.16-.28-.33-.41-.48-1.97-2.21-3.57-4.46-4-6.28v-.02l-.04-.17c-.03-.13-.13-.33-.21-.53-.01-.02-.01-.05-.03-.07-.07-.19-.14-.36-.14-.47v-.03c.17.22.32.43.49.65.32.43.66.86,1.01,1.29.17.21.34.43.51.64.53.64,1.08,1.26,1.67,1.87.07.07.13.14.2.2.13.14.27.28.41.42.03.03.07.07.1.1l.03.02c.39.4.8.78,1.19,1.17.74.71,1.49,1.4,2.25,2.07.49.43.98.86,1.48,1.28.86.75,1.74,1.48,2.63,2.22.89.72,1.78,1.46,2.7,2.21l.03.02c.21.16.41.34.62.5.07.06.13.12.2.18.55.44,1.1.9,1.64,1.37c2.07,1.73,4.15,3.52,6.08,5.36.38.37.76.74,1.14,1.11.03.03.07.07.1.12.11.12.22.26.35.39c1.14,1.26,2.11,2.32,3.22,3.7c1.1,1.38,2.26,2.91,3.3,4.45c4.31,6.37,8.33,13.29,12.73,19.57c2.3,3.28,4.24,6.36,6.25,9.6c1.1,1.76,1.98,3.29,2.97,5.03.24.44.45.86.73,1.25.27.37.59.57.86.93.03-.44.04-.9.07-1.34.91-13.03,4.44-25.44,6.6-38.34-.83-.72-1.19-1.83-1.76-2.66-1.1-1.63-2.49-2.92-3.68-4.48-.24-.3.28-.74.66-.65.86.19,1.59.51,2.32.84-2.47-4.92-5.03-10.79-7.69-15.43-3.11-5.43-6.23-9.95-8.29-15.43-.91-2.44-1.28-4.5-1.22-6.98.03-1.3.74-2.53.83-3.84-.34-.84-.93-1.68-1.76-2.18s-1.62-.6-2.35-1.11c-.74-.51-1.15-.94-1.77-1.63-.04-.05-.08-.09-.14-.15-.03-.03-.07-.08-.1-.12-.17-.2-.32-.4-.49-.61-.42-.54-.83-1.11-1.17-1.62-.01-.04.04-.06.07-.06h.01c.27.19.53.37.79.57.25.19.51.39.76.57.76.57,1.5,1.16,2.29,1.72.37.26.73.51,1.11.75.07.05.14.09.21.13.37.25.76.47,1.15.68.2.12.31.16.58.34c0,.01.01.01.03.02.07.05.15.12.24.2.03.02.06.05.08.08.2.18.41.41.53.62.04.05.07.09.08.13h.01c.01.06.04.12.07.15c0,.01.01.02.01.04.01.01.01.02.01.02.01,0,0,.03.01-.01v0c0,0,.01-.09.03-.16.01-.04.03-.09.03-.14q0,0,.01-.02c.18-.86.35-1.74.52-2.61.17-.86.34-1.73.49-2.6.31-1.74.59-3.48.81-5.22.1-.76.2-1.52.27-2.28.1-.83.17-1.67.24-2.5.03-.41.06-.81.08-1.2.04-.63.07-1.27.1-1.9.06-1.1.07-2.18.07-3.28v-.23c0,0,0-.11-.01-.16v-.22c-.01-.3-.03-.61-.06-.91-.03-.37-.07-.76-.11-1.13c0-.13-.01-.24-.03-.37-.01-.12-.03-.22-.04-.33v0c-.04-.36-.08-.69-.13-1.03-.07-.43-.14-.86-.22-1.33.08.4.18.79.27,1.18.21,1,.41,2.02.56,3.05.01.02.01.05.01.07.21,1.23.37,2.46.46,3.69v.02c.01.12.03.22.04.34.03.34.06.68.07,1.02.04.45.07.92.07,1.39.01.06.01.11.01.16v.07c.01.37.03.75.03,1.12.01.42.03.83.03,1.24v.13c-.01.11-.01.21-.01.31-.01,1.18-.06,2.35-.13,3.5-.06,1.16-.15,2.31-.27,3.47-.03.29-.06.57-.08.86-.2,2.02-.48,4.03-.79,6.06.9-.33,1.57-.61,2.4-1.1c1.29-.78,2.71-1.63,4.17-2.26.03-.01.04.01.04.02-.01.02,0,.01,0,.02l-.21.14c-.98.71-1.97,1.44-2.95,2.17-.03.01-.06.03-.08.06-.52.37-1.03.76-1.55,1.14-.51.37-1.05.57-1.69.76h-.07c-.06,0-.11-.02-.15.02h-.01c0,0-.01.01-.01.02-.03.01-.03.02-.04.05-.01.05-.01.12-.01.19-.03.71-.93,2.87-.91,4.24.03,2.11.32,4.17,1.24,6.48c2.08,5.23,5.06,9.75,7.94,15.12c2.89,5.37,5.97,11.88,7.81,17.79.21.23.51.6.63.78.13.17.08.12.18.27c1.34-15.87-1.15-33.06,4.85-48.27c1-2.53,3.29-7.09,4.71-9.19c10.75-15.86,37.75-42.27,21.43-60.48-.1.09-.18.14-.3.16-.03,0-.04.01-.07.01-.08.01-.17,0-.25-.02-.32-.12-.63-.22-.96-.32-1.28-.37-2.6-.62-3.93-.87-1-.19-2-.37-2.98-.63-.63-.16-1.24-.36-1.87-.47-.78-.29-1.66-.46-2.52-.48-1.66-.26-3.27-.45-5.07-.55-1.01-.06-2.01-.12-3.01-.17-2-.11-3.98-.21-5.96-.32-1.49-.08-2.97-.16-4.45-.23-1.5-.07-2.99-.15-4.5-.23-2.01-.11-4.03-.22-6.08-.34-8.22-.48-16.89-1.12-25.25-1.97-4.09-.42-8.39-.97-12.46-1.77-.98-.2-2.12-.42-3.12-.63q0,0-.03-.01c0,0-.06-.04-.07-.04-.01-.01-.03-.02-.04-.02l-.08-.07h-.01c0,0,0-.01-.01-.01-.01-.01-.01-.02-.03-.04-.06-.05-.41-.19-.29-.2.11-.02.39.02.76.03.38,0,1.33.04,1.84.01h.35c.6-.01,1.22-.03,1.83-.07.08-.01.2-.01.28-.02c1.32-.09,2.63-.22,3.94-.37.59-.06,1.19-.14,1.78-.2c5.56-.55,10.92-.5,16.47,0h.03c0,0,.04,0,.06.01h.03c.13.01.27.02.39.03c1.18.13,2.36.26,3.54.41c6.73.88,13.35,1.68,20.18,1.46.67-.01,1.28-.12,1.94-.17.11-.01.23-.02.34-.05.62-.08,1.25-.17,1.84-.28.11-.01.27-.04.35-.06.98-.23,3.05-.68,3.74-.74.06-.01.1-.01.13-.01c2.74.15,5.34.19,8.01.44.07,0,.13,0,.2.01.04,0,.07,0,.1.01h.06c3.23.41,6.35.99,9.39,1.98.53.18,1.04.38,1.48.63h.01c.2.12.38.22.55.34.1.06.18.12.25.17.08.06.17.12.25.19.11.09.22.19.34.28.11.09.21.2.31.29.21.21.39.41.58.63.08.1.17.22.25.34.1.11.17.22.25.35.17.23.34.48.49.74v0c.42.69.83,1.44,1.12,2.16c4.05,2.15,6.42,3.73,6.72,7.89.14-2.03,1.57-4.05,1.26-6.07-.29-2.02-1.55-3.59-1.77-5.69-.73-6.53-5.31-11.52-9.35-17.04-3.48-1.83-7.11-3.45-10.79-4.96-.2-.07-.17-.39.06-.34c3.06.72,5.9,1.63,8.68,2.93-2.57-2.66-4.83-5.23-7.35-8-1.74-1.9-3.53-4.22-5.28-6.2-2.32-2.59-5.16-5.09-8.31-6.79-3.13-1.7-5.99-3.1-9.49-3.87-.27-.06-.51-.09-.76-.13-2.29-.33-4.58-.54-6.87-.75-.14-.01-.29-.02-.44-.03-.22-.01-.45-.03-.67-.05-.38-.01-.74-.03-1.11-.06-.18-.01-.38-.01-.56-.02-.55-.03-1.11-.07-1.64-.13-.01,0-.04-.01-.06-.02-.06-.01-.1-.06-.01-.07.01-.01.06-.02.1-.02.07,0,.15-.01.25-.02.08-.01.2-.02.29-.03.15-.01.31-.02.48-.03.07-.01.15-.02.23-.03h.07c.74-.06,1.49-.11,2.23-.14.37-.01.74-.02,1.11-.03c1.93-.06,3.84,0,5.78.18.2.02.41.03.62.06.17.01.35.03.53.06.13.01.27.04.41.05c3.63.45,6.96,1.68,10.09,3.3c2.39,1.25,4.24,2.95,6.1,4.73-2.63-3.91-4.83-7.92-7.63-11.8-1.69-2.32-3.46-4.76-4.9-7.23-2.05-3.49-4.16-6.93-6.34-10.34-2.18-3.42-4.47-6.58-6.55-10.08-.87-1.47-1.66-2.91-3.04-4.32-1.36-1.41-3.72-2.71-5.37-3.97-1.64-1.25-2.84-2.51-4.22-3.94h-.01c-.44-.48-.77-.86-1.29-1.42-.01-.01-.03-.03-.04-.05-.07-.07-.14-.14-.22-.22c0-.02-.03-.03-.06-.07h-.01c-.2-.23-.44-.49-.69-.75v0c-.2-.2-.38-.38-.55-.56-.18-.19-.37-.36-.53-.51-.49-.45-.97-.89-1.46-1.32l-.18-.15c-.11-.09-.22-.19-.34-.29-.32-.28-.66-.56-1-.84-.51-.42-1.01-.82-1.53-1.23s-1.04-.8-1.59-1.2c-.72-.52-1.45-1.05-2.22-1.59-1.15-.8-2.33-1.63-3.5-2.48-1.56-1.13-3.11-2.32-4.54-3.56-.37-.3-.72-.61-1.07-.91v0c-1.53-1.4-2.85-3.02-4.03-4.64q0,0-.01-.02c0,0,.01-.05.04-.03q0,0,.03.01c4.71,4.64,10.1,8.24,15.94,11.95c2.66,1.69,5.51,3.47,7.97,5.5.97.79,2,1.84,2.92,2.73v0c0,0,.03.05.04.06q0,0,.01.02c.07.09.17.17.27.27.08.06.14.13.2.18.03.03.06.06.08.09l.03.02c0,0,.03.04.06.05c0,.01.01.02.03.03.01.02.04.05.07.07.01.02.03.03.06.06.01.01.01.03.06.05c0,.01.01.02.03.03v0c1.57,1.61,3.34,3.3,5.09,4.7c2.63,2.15,4.48,4.43,6.04,7.13c1.1,1.89,2.19,3.62,3.4,5.44-.65-1.76-1.01-3.57-1.5-5.37-.62-2.24-1.46-3.94-3.29-5.72-1.07-1.04-2.36-2.02-3.49-3.03-.08-.07-.15-.13-.25-.22v0c-.98-.91-1.94-1.82-2.84-2.74-.44-.43-.86-.88-1.25-1.32-.44-.46-.84-.92-1.25-1.4-1.6-1.9-3.01-3.91-4.13-6.11-.06-.12.08-.16.15-.06c2.29,3,4.69,5.9,7.49,8.59.35.34.72.66,1.1.98.37.32.73.62,1.1.95c1.63,1.43,3.18,2.5,4.65,4.13c2.68,2.99,3.56,6.48,4.3,10.15.07-.16.08-.34.22-.5.13-.17.34-.05.39.16.39,1.44.81,2.89.51,4.39.28.42.55.81.83,1.23c2.35,3.57,4.3,7.32,6.7,10.88c1.26,1.89,2.77,3.68,4.03,5.57-.65-3.49-1.21-7.01-1.63-10.51-.06-.36.39-.63.59-.25c1.55,2.94,2.33,5.66,2.94,8.89.49,2.63,1.5,5.54,1.52,8.3c0,.03-.01.07-.03.09c9.39,14.6,24.21,27.4,30.9,42.95-.13-9.66-1.85-20.33-4.82-29.66-1.95-6.18-5.4-11.46-9.61-16.74-.66-.84-1.48-1.65-2.12-2.47-.81-.21-1.28.02-2.12-.37-.84-.4-1.71-1.13-2.56-1.77-1.52-1.17-2.71-2.66-3.5-4.28-.03-.06.03-.09.07-.06.06.05.1.11.14.15.13.13.24.27.37.4.01.02.04.03.06.06.15.17.32.36.49.54.18.2.37.39.55.57.17.16.32.32.49.45.17.16.37.33.55.47.46.35.94.61,1.45.85.13.06.25.12.38.17.38.19.76.36,1.15.56.07.03.15.07.23.11.01,0,.03.01.04.02.06.02.11.05.17.07.03.01.04.01.06.02.01.01.04.01.06.02.07.02.13.05.2.08.01,0,.04.01.06.01.06.04.13.06.18.08-.32-.44-.65-.84-.94-1.3v0c-.18-.29-.35-.56-.52-.84-.32-.55-.62-1.11-.87-1.68-.25-.56-.48-1.13-.66-1.72-.18-.58-.32-1.18-.42-1.8-.04-.3-.08-.62-.11-.93c0-.12.11-.19.24-.2.06,0,.1.01.14.03.04.01.07.05.1.09c1.07,2.37,2.4,4.6,3.95,6.78.07-1.04.35-2.07.76-3.02.03-.06.04-.11.07-.15.03-.05.04-.09.07-.13.01-.05.04-.09.07-.14.03-.03.04-.08.07-.13.11-.19.22-.37.35-.55.35-.55.72-1.06.94-1.67.29-.8.35-1.59,1.07-2.24.07-.06.2.01.18.09-.08,1.9-.91,3.69-1.07,5.58-.01.18,0,.33.01.51.14,1.35.24,2.71-.67,3.9l-.04.03c0,0-.03.02-.04.05c0,0,0-.01-.01.01-.01.01-.03.01-.03.02-.01.01-.01.02-.01.03c0,.02,0,.03.01.05.03.06.08.1.13.15h.01c1.08,1.46,2.32,2.72,3.44,4.18c3.4,4.45,6.24,8.84,7.97,14.01c3.88,11.6,5.99,24.05,5.02,36.1.37-1.1.89-2.21,1.56-3.21.17-.24.34-.07.28.13-.37,1.44-.77,2.88-1.05,4.34.72,7.93-2.57,18.6-5.66,26.16c3.74-5.34,7.29-10.72,9.22-16.52.79-2.38,1.28-3.91,1.7-6.02.41-2.11.65-3.71,1.07-5.8.42-2.08.66-4.33,1.19-6.45.15-.62.25-1.33.37-1.97c0-.02.01-.06.01-.08.01-.06.03-.13.04-.2.01-.05.01-.08,0-.12-.59-3.4.35-7.53,1.48-10.52c1.56-4.19,3.32-7.62,6.08-10.93c5.55-6.65,12.39-11.66,19.04-17.42.44-.37.86-.75,1.28-1.13.84-.75,1.67-1.52,2.49-2.29.52-.5,1.03-1.02,1.53-1.53.41-.41.8-.83,1.21-1.26.53-.57,1.07-1.17,1.59-1.77.46-.53.91-1.07,1.36-1.62.72-.89,1.45-1.77,2.14-2.68.37-.46.7-.91,1.04-1.37.31-.42.6-.84.9-1.26.2-.28.38-.56.56-.84.21-.34.42-.66.62-1c.29-.49.56-.98.82-1.47.2-.41.39-.82.58-1.23.22-.51.44-1.03.6-1.56.35-1.06.59-2.15.76-3.24v0c.1-.56.15-1.11.21-1.67.08-.81.14-1.61.18-2.42-.01-.06,0-.12,0-.17l.08-2.28v-.14c.01-.57.03-1.14.06-1.7.01-.55.04-1.1.08-1.65.07-.98.14-1.95.21-2.91c0-.09.01-.17.01-.27.01-.13.03-.26.04-.37.11-1.41.22-2.8.39-4.21v-.05c.04-.52.1-1.05.17-1.58.03-.25.06-.47.08-.71.46,3.59.96,7.18,1.25,10.78.01.24.06.49.04.74-.2,3.45.1,7.05-.65,10.47-1.78,8.1-7.63,15.29-12.56,21.98-5.44,7.37-11.27,13.42-17.36,20.06-2.98,3.26-5.54,6.31-8.38,9.55-1.31,1.49-2.66,2.93-3.65,4.55-.98,1.63-1.39,3.36-2.3,5.01-.18,2.1-.58,4.46-.83,6.49-.53,4.53-1.39,8.27-2.81,12.77-.59,1.84-.9,3.56-2.18,5.73-8.36,14.21-20.03,27.65-28.94,41.81-1.55,2.45-3.48,5.32-4.83,7.57-2.71,4.52-5.57,9.38-6.75,13.93-1.05,4.07-.2,7.19-.73,11.11c4.62-7.23,9.81-13.21,16.05-19.63c2.81-2.88,6.21-6.31,9.3-9.16c1.43-1.94,2.88-3.97,4.76-5.57.96-.8,1.93-1.58,2.92-2.3.69-.47,1.38-.93,2.08-1.39.37-.23.73-.45,1.11-.68c2.59-1.55,5.33-2.87,8.22-4.05.25-.12.52-.21.77-.33.8-.31,1.62-.62,2.43-.91.17-.06.32-.12.48-.16.29-.09.6-.19.9-.28.44-.13.87-.25,1.36-.4.06-.01.06.05.01.07-4.9,1.98-9.28,4.26-13.39,6.98-.73.49-1.46.98-2.18,1.51-1.08.78-2.16,1.6-3.23,2.45.86-.53,1.74-1.03,2.67-1.48.1-.05.15.05.08.13-1.05,1.03-2.15,1.9-3.18,2.99h-.01c-5.1,5.4-10.78,10.64-15.78,16.08-3.53,3.82-7.12,7.47-10.2,11.48c0,0,.03-.01.04-.02.17-.13.62-.05.51.27-.81,2.05-1.74,4.01-2.94,5.94-.44.7-.96,1.45-1.36,2.16-.42.72-.65,1.49-1.1,2.18-.08.12-.17.15-.32.14-1.59,37.18-12.19,73.5-10.59,110.83h-1.47c-.5-11.69-.24-23.39.81-35.4Z"
                fill="#30340f"
              />
              <path
                d="M430.65,621.14c1.19,3.96,1.19,7.71.83,11.68c0,.06-.08.2-.14-.02s-.2-.76-.29-1.15c-.71-3.03-1.19-6.21-2.47-9.14-.82-1.88-1.85-3.61-3.03-5.34-.9-1.32-1.96-2.49-2.54-3.94-.06-.14.11-.3.29-.25c1.12.35,2.13.77,2.99,1.51c2.14,1.84,3.63,4.2,4.36,6.64Z"
                fill="#30340f"
              />
              <path
                d="M536.36,624.62c0,0-.06-.04-.04-.07.69-.84,1.42-1.45,2.49-2c1.06-.55,2.43-.93,3.66-1.22.06-.01.08.05.09.07c0,.02,0,.02,0,.03-.09.61-1.06,1.07-1.55,1.27s-.93.27-1.24.37c-1.32.44-2.28.92-3.4,1.54Z"
                fill="#30340f"
              />
              <path
                d="M398.74,777.18c-.62-.15-2.24-.7-2.9-.97-.37-.16-.41-.58-.72-.84-1.57-1.32-3.84-2.02-5.73-2.81-3.06-1.27-5.88-2.43-8.74-3.87-1.43-.72-3.03-1.35-4.21-2.33-1.02-.85-1.43-2.26-2.15-3.23-.06-.08.17-.13.21-.16c2.23-1.41,2.14-3.99.54-5.56-2.43-2.38-4.53-4.26-6.8-6.64-.45-.88-1.05-2.17-1.32-3.03-.28-.86.63-1.72,1.49-1.3c3.23,1.53,5.79,3.74,8.9,5.46s6.4,3.57,9.05,5.75c2.65,2.17,4.6,4.74,7.62,6.48c2.22,1.29,4.62,1.61,7.15,2.18.63.14,1.3.16,1.89.38c9.64,3.61,19.8,5.87,28.65,10.8-5.76-.59-11.58-1.11-17.33-.62-3.2.27-6.06.91-9.17,1.33-2.21-.3-4.14-.46-6.43-1.01Z"
                fill="#7b6d4b"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv1630" transform="translate(.000012-181.253872)">
            <g>
              <g>
                <path
                  d="M567.07,809c.46-.58.91-1.15,1.39-1.72.22-.29.47-.59.71-.88c2.12-2.6,4.24-5.18,6.38-7.75v0l.77-.95c3.13-3.68,6.32-7.36,9.48-11.02c2.9-3.38,5.82-6.75,8.72-10.11c8.56-8.19,16.99-16.46,24.79-25.09v0c.48-.54.95-1.05,1.4-1.58.47-.51.93-1.03,1.39-1.56c1.13-1.3,2.25-2.6,3.37-3.91.45-.54.91-1.07,1.36-1.59c1.11-1.32,2.22-2.65,3.3-3.99c1.33-1.62,2.66-3.26,3.97-4.9c1.26-1.57,2.5-3.15,3.72-4.74c3.19-4.15,6.32-8.34,9.35-12.58c2.14-2.97,4.25-5.97,6.32-8.97c5.16-4.93,10.36-9.72,15.69-14.74.02-.02.04-.05.07-.07.08-.08.14-.15.23-.22l.02-.02c4.53-4.28,10.15-9.34,14.37-13.84c6.84-7.32,13.69-15.06,20.78-22.71c6.49-4.14,12.78-8.48,18.84-13.06l.02-.02c.97-.74,1.95-1.45,2.9-2.2c1.9-1.47,3.77-2.96,5.61-4.47c1.36-1.12,2.72-2.25,4.05-3.39c1.42-1.2,2.82-2.4,4.22-3.61c4.21-3.63,8.36-7.31,12.57-10.94.79-.68,1.59-1.37,2.38-2.05c3.03-2.57,6.08-5.11,9.21-7.59v0c.17-.15.36-.29.53-.43c8.7-4.72,17.26-8.95,25.96-13.05.1-.05.21-.1.32-.15c2.82-1.34,5.68-2.66,8.55-3.99.11.3.23.59.33.88c4.87,13.44,7.59,26.86,7.83,40.83.04,2.63.08,5.25.12,7.86-1.61,6.59-2.99,13.21-3.97,19.89-.13.95-.23,1.9-.35,2.86-2.49,7.77-2.58,15.23-1.43,22.56-.03,9.73.6,19.47,1.57,29.27c1.17,11.85,2.72,24.18,1.85,36.24-.08,1.17-.19,2.34-.32,3.49-.06.55-.14,1.1-.21,1.64-.09.67-.18,1.33-.28,1.99-.16.97-.35,1.94-.54,2.92-.12.58-.24,1.15-.37,1.72-.13.5-.24,1.02-.39,1.51-.13.54-.29,1.08-.44,1.62-.14.55-.3,1.07-.48,1.6-.37,1.22-.76,2.45-1.15,3.66-10.37,15.91-21.64,31.68-30.2,48.25h-212.73c2.26-2.99,4.52-5.98,6.84-8.95.52-.66,1.04-1.31,1.55-1.96Z"
                  fill="#4e593b"
                />
                <path
                  d="M645.68,799.73c-3.17-7.92-6.4-15.02-8.22-22.91-.87-3.78-1.18-7.18-1.84-10.92-3.49-10.82.08-21.08-1.5-31.96c6.92-8.7,13.45-17.59,19.64-26.63c5-5.04,9.97-10.08,15.73-14.64.04-.03.02-.06.05-.03.77.72-.58,1.85-.77,2.63-3.5,14.43-9.83,30.07-8.81,44.57c1.03,14.5,5.45,27.18,7.76,41.24c1.09,6.62,1.44,13.11,2.01,19.77.15,1.75.22,3.57,0,5.3-.56,4.48-2,8.73-4.26,12.78-.3.54-.81.81-1.27.98h-2.36c-.98-.22-1.85-.58-2.62-1.32-5.7-5.54-10.91-12.22-13.57-18.86Z"
                  fill="#858673"
                />
                <path
                  d="M779.19,637.23c0,0-.03.23-.1.27-39.36,27.9-61.19,79.14-79.38,118.59-8.2,17.79-15.9,35.67-23.35,53.61-1.41,3.4-2.78,6.8-4.18,10.2h-8.34c1.89-4.62,3.88-9.39,5.94-14.28c25.35-59.77,63.73-137.21,109.41-168.39Z"
                  fill="#77150a"
                />
                <path
                  d="M704.04,660.22c-13.71,23.79-32.37,43.45-31.74,70.29.06,2.76,4.38,2.05,5.22.14c5.26-12.02,8.54-23.79,13.43-36.16c4.32-10.95,10.01-22.69,13.33-34.1.04-.14-.14-.32-.23-.17-.09.16,0,0,0,0Z"
                  fill="#77150a"
                />
                <path
                  d="M622.02,764.83c-1.08-3.28-2.24-8.77-2.69-13.38.93-1.04,1.88-2.06,2.8-3.11c5.47-6.26,10.7-12.65,15.72-19.15c2.57,13.56-2.26,28.8,2.29,41.62c4.23,11.93,12.4,21.24,17.93,31.86c3.11,5.98,5.03,11.47,4.98,17.23h-16.68c-1.96-5.28-4.51-10.59-7.89-16.21-7.1-11.83-11.96-25.26-16.45-38.87Z"
                  fill="#331707"
                />
              </g>
              <path
                d="M672.29,813.35c6.35-18.94,26.46-32.17,47.09-41.86c24.48-11.5,50.43-19.82,71.97-34.91.25-.17.57.1.35.29-34.49,30.82-100.04,33.63-118.14,76.76-.26.63-1.49.37-1.27-.27v0Z"
                fill="#77150a"
              />
            </g>
          </g>
          <g transform="translate(0-131.636912)">
            <g>
              <g>
                <path
                  d="M148.61,757.87c-.21-1.42-.4-2.78-.55-4.16-.25-2.22-.4-4.39-.49-6.6-.02-.57.1-1.14.12-1.69.2-4.71.32-9.4.39-14.11c0-.05.08-.07.1-.11c1.39,5.65,4.28,9.61,8.67,13.26c1.05.87,2.07,1.4,3.08,2.09c2.02,1.39,3.99,2.56,5.83,4.1.76.63,1.31,1.26,1.93,2.02c2.46,3.03,4.53,5.57,7.03,8.79.74.95,1.4,1.96,2.05,2.98h-26.88c-.16-.75-.33-1.51-.51-2.28-.33-1.45-.55-2.87-.77-4.29Z"
                  fill="#384512"
                />
                <path
                  d="M202.21,746.07c.35-3.72.94-7.23,2.05-10.72.37-1.16.83-2.09,1.4-3.12.56-1.03,1.25-1.96,1.93-2.91.67-.95,1.32-1.89,2.09-2.77c4.53-5.19,9.45-9.88,14.74-14.3.5-.11.9-.24,1.39-.42c4.96-1.8,9.93-3.32,15.08-4.58c1.28-.31,2.61-.59,3.96-.93c12.12-3.05,23.09-6.88,33.43-14.08-.36,2-.88,3.57-2.14,5.24-.83,1.1-1.8,2.11-2.8,3.18-1.73,1.84-3.47,3.66-5.23,5.45-3.49,2.07-6.03,5.12-8.44,8.34-11.35,10.81-23.38,20.61-36.9,29.18-.3.19-.36.71-.74.8-1.1.25-2.11.29-3.24.55-5.39,1.27-10.7,2.75-15.83,4.89-.52-1.15-.85-2.59-.74-3.81Z"
                  fill="#6f7e43"
                />
                <path
                  d="M150.93,698.5c5.3,2.64,11.22,4.81,16.92,6.7c3.63,2.22,7.06,4.48,10.25,7.31.8.71,1.42,1.29,2.16,2.22c9.28,11.6,11.73,22.34,5.7,36.22-.62,1.42-1.86,2.39-2.52,3.78-.05.11-.26,0-.3-.1-.5-1.35-.97-2.69-1.64-3.98-2.6-5.01-3.97-10.27-5.46-15.69-.42-1.52-1.88-2.54-2.88-3.62-1-1.09-2.12-2.03-3.07-3.05-9.57-10.2-18.29-21.04-26.42-32.32-1.08-1.5-.98-2.42-.95-4.11c2.46,2.95,4.69,4.89,8.22,6.65Z"
                  fill="#93a059"
                />
                <path
                  d="M206.19,715.7c.55-1.32,1.28-2.98,2-4.43c1.67-3.36,2.92-6.94,3.73-10.64.27-1.23.37-2.41.57-3.7s.36-2.69.54-4.03c1.9-14.34,1.35-28.54,1.09-42.97-.02-1.18.32-2.31.47-3.52.3-2.41.67-4.59,1-7.11s.73-5.45,1.09-8.05c-2.42,4.59-4.86,9.13-7.51,13.64-.66,1.13-1.39,2.26-2.1,3.42-6.36,10.2-12.61,20.4-18.17,31.11-.52,1.01-.95,2.01-1.37,3.22s-.85,2.6-1.07,4.02c-1.09,7.11-.58,13.39,2.25,20.07.42.99.67,1.96,1.15,2.9c1.91,3.75,2.65,8.01,5.04,11.54c2.78,4.1,6.89.79,9.34-2.22.77-.94,1.42-1.93,1.97-3.25Z"
                  fill="#8b894e"
                />
                <path
                  d="M199.58,691.76c-.09-.71-.19-1.41-.3-2.12.11.7.21,1.41.3,2.12Z"
                  fill="#3d470d"
                />
                <path
                  d="M199.74,693.33c0,.12,0,.24,0,.35-.06-.64-.1-1.28-.16-1.92.05.52.13,1.05.16,1.57Z"
                  fill="#3d470d"
                />
                <path
                  d="M194.21,763.5c.02-1.44-.19-2.68.41-4.06.32-5.03.49-10.06.45-15.1c0-1.01-.12-2.02-.09-3.03.45-13.39,2.03-26.5,4.45-39.68.25-1.37.29-2.74.37-4.13.07-1.27,0-2.54-.06-3.82.18,2.05.33,4.11.34,6.17c0,1.35.04,2.72-.06,4.06-.99,12.46-2.34,24.87-2.77,37.36-.04,1.27-.09,2.52-.14,3.78-.16,3.78-.41,7.56-.64,11.32.7-1.02,2-1.98,2.72-2.91c1.86-2.39,3.53-5.15,5.28-7.4s3.4-3.74,5.44-5.56c.08-.07.16-.12.24-.2-2,2.53-3.98,5.07-5.76,7.76-1.43,2.17-2.87,4.33-4.47,6.38-.42,1.69-1.24,2.9-2.09,4.44s-1.35,3.48-2.05,5.13c0,.15-.01.29-.02.43h-1.61c.01-.32.06-.63.06-.95Z"
                  fill="#3d470d"
                />
                <path
                  d="M180.95,739.09c-.23-1.08-.56-2-.95-2.95s-.83-1.74-1.36-2.58-1.1-1.57-1.74-2.34-1.39-1.51-2.09-2.24c-.12-.12-.22-.28-.32-.43s0-.36.19-.2c.98.84,1.99,1.82,2.79,2.81s1.52,2.04,2.11,3.1s1.15,2.21,1.5,3.3c1.77,5.45,2,11.35,2.68,16.85.43,3.5.95,6.79,1.62,10.05h-.91c-.72-3.6-1.18-7.23-1.58-10.93-.51-4.83-.94-9.7-1.95-14.43Z"
                  fill="#3d470d"
                />
                <path
                  d="M148.54,702.04c9.2,9.78,19.55,17.88,28.26,28.29c5.04,6.03,5.21,13.96,5.35,21.58-.88-1.73-1.78-3.51-2.63-5.3-1.19-2.49-2.56-5-3.63-7.53-.48-1.14-.39-2.44-.94-3.49-1.21-2.31-3.27-4.03-4.95-5.86-7.98-8.71-14.8-18.02-21.57-27.63-.05-.07.06-.12.12-.07Z"
                  fill="#4e531e"
                />
                <path
                  d="M237.09,730.93c7.67-5.61,15.18-11.08,22.75-16.69-.77,1.03-1.53,2.07-2.31,3.11-9.3,9.02-18.82,17.63-29.49,25.12-.59.41-1.22.56-1.91.85s-1.35.86-2.15.99c-1.7.28-3.48.25-5.17.67-.05.01-.12.02-.16.03c5.78-5.08,12.27-9.59,18.43-14.09Z"
                  fill="#4e531e"
                />
                <path
                  d="M204.35,706.38c1.29-2.87,1.75-6.04,1.89-9.09.17-3.59.61-7.29.79-10.69s-.15-6.24-.21-9.5.37-6.43.3-9.71c0-.32-.52-.29-.73-.04-3.97,4.85-5.73,10.83-5.55,16.8.13,4.18,1.76,6.46,2.33,10.33s.28,7.99.8,11.92c.03.2.3.15.37-.02.08-.17.02-.02,0,0Z"
                  fill="#bdbb7d"
                />
                <path
                  d="M158.7,705.58c11.69,4.1,18.18,11.27,23.28,22.38.39.85-.7.84-1.24.34-7.61-6.97-15.84-13.55-22.75-21.26-.65-.72-.28-1.81.71-1.46.08.03-.07-.16,0,0Z"
                  fill="#ffead7"
                />
              </g>
              <path
                d="M214.19,736.97c.39-.47.53-1.08.89-1.57.35-.47.85-.9,1.35-1.2c1.11-.66,2.42-1.18,3.64-.6.68.32.87,1.31.5,1.91-.6.99-1.72,1.21-2.75,1.58-.45.16-.91.28-1.38.35-.56.08-1.21-.04-1.75.19-.44.19-.83-.28-.51-.66v0Z"
                fill="#b9a672"
              />
              <path
                d="M215.78,727.88c.07-.2.07-.43.1-.64.06-.4.18-.71.41-1.04.41-.58.9-1.15,1.63-1.3.71-.14,1.63.33,1.55,1.18-.07.8-.46,1.37-1.06,1.89-.33.28-.62.45-1.03.57-.15.05-.15.06-.28.09-.06.01-.43.11-.28.04-.51.24-1.26-.16-1.04-.8v0Z"
                fill="#b9a672"
              />
              <path
                d="M228.79,723.19c.14-1.29,1.15-2.34,2.38-2.73.88-.28,1.6.76,1.17,1.52-.59,1.04-1.82,1.84-3.03,1.72-.25-.03-.55-.22-.51-.51v0Z"
                fill="#b9a672"
              />
              <path
                d="M244.88,716.58c.13-.58.67-1.05,1.13-1.37.52-.36.99-.77,1.59-.98.33-.12.74.02.98.26.06.06.11.13.16.2.19.29.18.73,0,1.02-.37.59-.96.96-1.54,1.32-.51.32-1.26.59-1.85.36-.35-.13-.54-.43-.46-.81v0Z"
                fill="#b9a672"
              />
              <path
                d="M235.77,715.15c.38-.88.95-1.64,1.87-1.97c1.07-.38,1.78,1.09,1.06,1.83-.46.47-1.06.76-1.51,1.24-.31.33-.85.34-1.19.07-.38-.3-.42-.74-.23-1.17v0Z"
                fill="#b9a672"
              />
              <path
                d="M255.07,709.83c.01-.94,1.12-1.9,1.77-2.49.72-.66,1.98-2.18,2.95-.99.87,1.06-.54,2.21-1.26,2.85-.68.6-2.01,1.58-2.98,1.26-.27-.09-.48-.33-.47-.62v0Z"
                fill="#b9a672"
              />
              <path
                d="M211.17,731.37c0,.63-.18,1.35-.32,1.98-.16.74-.33,1.59-.79,2.21-.34.46-.84.74-1.43.58-.52-.14-.96-.67-.93-1.22.05-.98.57-1.84,1.24-2.54.49-.51,1.24-1.07,1.93-1.23.15-.03.3.07.3.23v0Z"
                fill="#b9a672"
              />
              <path
                d="M215.81,743.42c-.67.29-1.31.63-1.98.9-.65.26-1.28.56-1.98.38-.4-.1-.56-.57-.37-.91.66-1.19,2.58-1.41,3.79-1.67.74-.16,1.33.96.55,1.3v0Z"
                fill="#b9a672"
              />
              <path
                d="M213.14,726.79c-.25.58-.15,1.1-.18,1.7-.04.78-.42,1.35-.87,1.96-.48.64-1.28.97-2.03.53-.66-.39-.97-1.36-.53-2.03.43-.65.85-1.3,1.58-1.63.59-.27,1.18-.34,1.67-.8.2-.18.45.05.35.27v0Z"
                fill="#b9a672"
              />
              <path
                d="M212.74,737.71c-.55,1.47-1.4,2.51-2.41,3.69-.97,1.12-1.75,2.48-3.42,2.43-.36-.01-.67-.24-.78-.59-.49-1.67.76-2.84,1.84-3.92c1.17-1.18,2.28-2.08,3.93-2.46.47-.11,1.04.32.84.84v0Z"
                fill="#b9a672"
              />
              <path
                d="M205.8,739.84c0,.34.05.67.02,1.01-.03.3-.12.61-.2.91-.18.65-.34,1.27-.68,1.85-.45.77-1.85.49-1.77-.48.05-.68.25-1.28.48-1.91.1-.29.21-.58.35-.85.17-.32.4-.55.6-.85.34-.51,1.22-.35,1.2.33v0Z"
                fill="#b9a672"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv1665" transform="translate(-122.977593-176.186561)">
            <g>
              <g>
                <path
                  d="M-24.29,565.04c-.76-.03-1.53-.06-2.29-.09v104.04c18.1,18.48,47.72,25.46,56.01,50.49-24.71-9.97-39.27-27.46-56.01-44.44v70.02c17.25,8.55,35.87,15.82,53.05,24.93c5.33,3.62,9.85,7.73,13.96,12.48c2.47,2.83,4.4,6.41,5.7,9.85-3.31-.66-6.8-1.52-9.95-2.47-3.16-.94-5.96-1.1-9.22-1.76-18.92-3.89-36.81-12.82-53.54-23.1v53.71h377.52c3.52-6.13,7.01-12.27,10.55-18.4c9.95-17.22,20.16-34.32,31.86-50.79-.57-3.7-1-7.6-1.96-11.2-4.77-18.05-13.73-33.32-25.71-48.61-2.05-2.62-5.13-5.9-7.04-8-16.37-18.21-29.67-37.2-45.47-55.44-3.86,12.27-3.42,23.93-2.23,36.46.29,3.13.78,6.04.86,9.25.38,16.25-1.05,32.16-6.07,47.87-1.26,3.93-2.88,7.58-4.83,11.12-6.14,11.18-14.93,19.41-25.94,27.31-.29-.86-.74-1.71-1.2-2.55-.35-.66-.74-1.32-1.08-1.98-.59-1.15-1.07-2.31-1.14-3.53c2.23-4.58,4.32-9.14,6.25-13.73c9.6-22.47,15.72-45.03,16.89-69.45.22-4.3-.02-8.6-1.17-12.81-.52-1.9-1.06-3.82-2.06-5.61-4.99-8.88-10.51-17.59-19.16-24.26-13.84-10.7-29.26-18.76-46.23-25.23-19.17-7.31-39.02-13.1-59.23-17.83v0c-5.29-1.26-10.63-2.43-15.97-3.53-26.6-5.5-53.72-9.36-80.75-12.65c19.13,24.38,34.71,50.72,41.29,79.49.92,4.07.11,7.78-5.41,8.37-.71.07-1.35-.01-1.94-.19-2.32-.75-3.83-3.26-5-5.32-3.15-5.5-6.23-10.99-9.2-16.48-10.91-20.15-20.37-40.42-26.58-62.35-29.18-1.24-58.37-2.43-87.55-3.6Zm264.3,219.51c.45-6.17,4.45-9.37,9.92-13.05.74-.27,1.48-.49,2.22-.63c2.39-.5,4.73-.26,6.85,1.17c2.75,1.87,3.66,4.18,4.59,6.9.78,2.22,1.58,4.24,1.3,6.68-.57,5.1-2.61,9.43-6.88,13.33-2.62,2.42-6.98,3.15-10.16.91-1.47-1.05-2.56-2.29-3.69-3.65-1.59-1.91-2.7-3.84-3.37-5.89-.59-1.82-.86-3.72-.78-5.78ZM118.36,686.22c-.02-1.33.34-2.49.93-3.57.74-1.36,1.81-2.59,2.9-3.87.47-.54.77-1.08,1.56-1.35.01,0,.02-.03.04-.05c1.6-1,3.71-1.28,4.9.37c1.17,1.64,2.14,3.46,2.83,5.34.32.82.63,1.64.55,2.57-.27,3.32-2.11,6.07-4.42,8.71-.73.82-2.03,1.12-3.13.84-.45-.1-.86-.29-1.19-.57-2.79-2.4-4.91-4.98-4.97-8.42ZM62.32,789.24c.6-2.31-.16-5.39,2.39-6.98c5.21-3.26,10.03-2.33,15.27-1.27c2.49.49,5.08,1.02,7.84,1.14c1.86.74,3.13,2.1,3.68,3.65.52,1.46.4,3.08-.46,4.48-1.73,2.85-3.94,4.85-7.26,6.21-9.96,2.58-16.21.34-21.45-7.24Z"
                  fill="#7c8161"
                />
                <path
                  d="M407.89,763.03c1.46-2.32,2.83-4.58,4.13-7.01c2.58-4.85,4.52-9.8,6.26-14.99-.67,26.55,9.47,51.61,11.62,77.68h-60.36c14.99-16.7,23.42-38.48,38.35-55.69Z"
                  fill="#7c8161"
                />
              </g>
              <g>
                <path
                  d="M167.59,611.36c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M192.81,673.59c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M159.57,740.64c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M165.58,712.89c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M146.1,702.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M164.47,668.46c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M109.88,665.45c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M120.61,698.14c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M158.02,656.88c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M141.5,701.75c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M129.38,713.89c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M108.71,582.28c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M203.38,662.75c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M195.28,740.18c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M157.34,725.03c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M164.74,724.22c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M182.82,679.51c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M222.78,718.98c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M149.92,735.89c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M126.01,707.23c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M129.79,658.44c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M150.1,707.14c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M170,709.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M204.94,712.62c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M93.13,582.87c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M150.92,741.51c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M202.69,732.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M205.61,725.18c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M203.4,720.2c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M117.1,654.62c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M123.95,662.46c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M118.5,599.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M144.61,687.15c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M121.27,610.31c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M141.34,716.26c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M181.99,673.94c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M186.4,746.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M163.73,693.91c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M99.45,594.04c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M154.01,731.13c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M155.38,645.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M182.34,708.23c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M147.07,592.45c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M209.72,704.46c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M102.17,573.85c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M139.31,722.1c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M221.29,693.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M161.51,683.77c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M110.4,670.34c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M200.88,741c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M138.02,674.09c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M174.35,643.57c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M211.08,749.57c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M161.22,674.18c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M196.53,682.88c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M209.3,691.64c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M156.74,748.51c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M124.12,617.62c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M191.07,731.55c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M219.93,711.88c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M109.8,591.14c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M149.53,748.73c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M131.16,637.44c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M199.73,699.84c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M166.15,730.8c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M121.31,580.56c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M136.68,743.63c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M207.69,741.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M162.62,637.13c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M198.33,639.41c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M141.96,638.55c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M215.58,744.73c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M116.93,626.41c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M177.8,732.39c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M117.37,671.34c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M135.31,618.27c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M137.12,604.98c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M131.61,666.58c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M150.07,676c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M109.89,612.97c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M145.01,614.22c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M172.45,735.45c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M127.69,651.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M135.33,705.28c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M160.05,695.35c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M112.92,603.7c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M155.6,608.97c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M135.04,728.17c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M173.29,665.93c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M153.64,653.71c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M162.69,702.59c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M173.59,695.3c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M142.47,581.54c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M207.07,676.46c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M179.52,700.49c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M155.87,699.81c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M145.04,727.57c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M106.28,609.42c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M210.81,737.93c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M127.73,627.16c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M193.12,713.32c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M147.61,667.78c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M146.39,630.57c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M136.55,711.28c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M134.64,733.76c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M129.16,725.49c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M143.41,734.01c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M120.36,648.8c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M158.74,706.9c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M173.62,747.82c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M171.26,720.01c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M189.06,701.91c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M222.6,702.6c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M158.84,714.89c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M135.69,682.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M172.21,685.96c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M109.41,661.27c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M138.62,665.1c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M175.61,709.86c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M161.57,734.55c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M150.53,717.24c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M216.63,670.91c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M147.88,694.37c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M179.59,714.85c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M190.48,648.15c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M151.86,687.54c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M146.43,680.55c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M138.58,693.12c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M142.31,744.56c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M142.22,656.88c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M137.94,697.24c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M218.34,724.12c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M120.91,631.62c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M128.8,600.86c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M118.31,638.77c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M184.1,663.8c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M124.92,590.24c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M119.86,658.73c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M136.25,647.38c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M113.44,677.43c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M138.97,736.66c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M183.34,739.97c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M112.28,620.33c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M176.18,726.33c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M195.66,690.91c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M160.09,744.82c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M142.62,738.68c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M132.07,718.28c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M145.91,711.22c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M165.43,748.36c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M198.9,746.7c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M218.76,736.46c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M183.93,722.18c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M175.89,742.22c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M126.56,644.52c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M187.48,619.07c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M165.1,661.9c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M186.05,688.78c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M146,650.56c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M195.96,725.17c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M171.19,653.25c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M211.59,730.78c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M166.98,738.87c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M106.06,603.78c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M131.09,701.23c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M87.62,575.22c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M165.5,627.4c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M184.02,733.16c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M218.84,682.58c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M128.16,696.54c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
                <path
                  d="M172.23,702.16c-1.41.95-1.64,2.68-.52,3.87s3.18,1.39,4.59.44s1.64-2.68.52-3.87-3.18-1.39-4.59-.44Z"
                  fill="#454f27"
                />
              </g>
              <g>
                <path
                  d="M160.06,795.78c-3.93-8.58-8.16-16.97-14.07-24.84-13.28-17.73-28.48-34.4-43.59-51.08-2.99-4.05-5.94-8.12-8.88-12.21c17.45,17.31,34.14,35.11,49.07,54.12.36.47.73.93,1.08,1.41c13.84,17.77,25.43,36.16,34.95,55.53h-6.65c-.31-.67-.59-1.36-.91-2.03-3.3-7.1-6.99-14.07-11-20.91Z"
                  fill="#393b20"
                />
                <path
                  d="M160.06,795.78c-3.93-8.58-8.16-16.97-14.07-24.84-13.28-17.73-28.48-34.4-43.59-51.08c3.3,4.47,6.65,8.92,10.07,13.29.03.03.05.05.06.08c6.71,7.46,13.24,15.03,19.5,22.74c4.54,5.6,8.93,11.27,13.13,17.04c5.36,7.38,10.35,14.98,14.91,22.77Z"
                  fill="#393b20"
                />
              </g>
              <path
                d="M142.59,761.77c.36.47.73.93,1.08,1.41-1.89-18.24-4.31-36.36-13.56-53.07-1.37-2.95-2.53-5.53-3.33-7.61-.32-2.62-1.22-5.01-2.27-7.28-.45-.1-.86-.29-1.19-.57-2.79-2.4-4.91-4.98-4.97-8.42-.02-1.33.34-2.49.93-3.57-1-2.14-2.09-4.23-3.23-6.3-4.32-7.82-9.53-15.31-13.94-22.85-1.9-3.16-3.81-6.35-5.63-9.56-2.39-4.24-4.66-8.54-6.64-12.95-10.91-20.15-20.37-40.42-26.58-62.35-29.18-1.24-58.37-2.43-87.55-3.6c13.66,12.58,27.17,25.41,39.58,38.81c3.21,3.46,6.33,6.96,9.38,10.51c5.98,6.44,11.53,12.96,16.75,19.61c2.6,3.32,5.11,6.67,7.56,10.08c3.06,3.33,5.84,6.94,8.41,10.72c2.34,3.06,4.54,6.31,6.63,9.72c2.09,3.38,4.09,6.92,6.02,10.53c1.61,2.21,3.17,4.6,4.74,7.08c6.41,8.42,12.57,17,18.73,25.55c17.45,17.31,34.14,35.11,49.07,54.12Z"
                fill="#454f27"
              />
              <path
                d="M132.02,755.97c-6.26-7.71-12.79-15.28-19.5-22.74c6.14,7.83,12.55,15.48,19.5,22.74Z"
                fill="#454f27"
              />
              <path
                d="M59.48,691.27c37.14,31.64,73.67,67.19,84.28,110.81-8.85-10.61-19.94-20.03-33.18-26.62-26.95-13.43-60.43-14.23-88.33-26.21-20.22-8.68-35.8-22.37-48.84-38.13v-15.45c25.29,20.45,56.2,35.97,89.7,44.62-18-21.25-35.99-42.49-53.99-63.74-14.02-16.55-28.35-33.74-35.71-52.89v-15.77c22.49,31.28,55.28,57.16,86.07,83.38Z"
                fill="#849a67"
              />
              <path
                d="M-26.58,786.87v-21.87c16.73,10.28,34.63,19.21,53.54,23.1c3.26.66,6.06.82,9.22,1.76c3.15.95,6.63,1.81,9.95,2.47-1.29-3.45-3.23-7.02-5.7-9.85-4.11-4.75-8.63-8.87-13.96-12.48-17.18-9.11-35.81-16.38-53.05-24.93v-17.52c16.48,14.17,35.44,26.2,56.9,35.21c16.15,6.78,33.29,11.87,49.66,18.24-5.24-1.06-10.06-1.99-15.27,1.27-2.55,1.59-1.79,4.67-2.39,6.98c5.23,7.58,11.49,9.82,21.45,7.24c3.33-1.36,5.54-3.35,7.26-6.21.86-1.41.99-3.02.46-4.48.96.43,1.93.87,2.88,1.32c11.09,5.2,21.44,11.45,31.78,17.69c7.68,4.64,15.36,9.27,23.05,13.91h-34.05c-37.52-10.84-79.35-12.59-117.39-23.4-8.32-2.37-16.45-5.2-24.35-8.44Z"
                fill="#466430"
              />
              <path
                d="M130.7,791.5c-17.13-14.12-36.24-27.72-61.66-26.48-.74.04-.9-.82-.16-.95c23.92-4.29,45.42,9.06,61.71,22.16c10.17,8.16,20.71,16.03,30.83,24.23c1.12.92,2.29,1.89,3.47,2.9-.42-.79-.84-1.6-1.23-2.41-6.71-13.29-12.02-26.89-21.46-39.07-9.18-11.86-19.37-23.18-28.94-34.82-9.82-11.96-18.94-24.28-28.65-36.3-.2-.25.21-.55.43-.29c5.7,6.5,11.52,12.95,17.35,19.38c15.11,16.68,30.31,33.35,43.59,51.08c5.91,7.88,10.15,16.27,14.07,24.84c1.59,3.45,3.13,6.93,4.69,10.42c1.91,4.22,3.97,8.38,6.08,12.51h-5.65c-3.41-3.14-7.18-5.99-10.95-8.8-8.07-5.98-15.84-12.08-23.53-18.41Z"
                fill="#afb187"
              />
              <path
                d="M224.71,734.89c.04-.15.32-.13.28.03-4.98,23.85-11.74,47.39-16.69,71.25-.86,4.17-1.66,8.36-2.4,12.54h-3.68c.69-3.63,1.42-7.22,2.2-10.71c5.46-24.58,14.14-48.65,20.29-73.11Z"
                fill="#afb187"
              />
              <path
                d="M222,759.89c17.85-8.77,40.36-10.92,55.27-22.98.18-.14.35-.29.51-.43c9.6-22.47,15.72-45.03,16.89-69.45.22-4.3-.02-8.6-1.17-12.81-.52-1.9-1.06-3.82-2.06-5.61-4.99-8.88-10.51-17.59-19.16-24.26-13.84-10.7-29.26-18.76-46.23-25.23-24.22-9.23-49.49-16.05-75.21-21.36c27.19,21.85,46.76,50.39,64.6,78.62c5.63,8.9,11.23,18.01,13.38,27.93c1.81,8.31,1.13,16.84.28,25.24-1.71,16.84-4.07,33.63-7.11,50.33Z"
                fill="#5f7a47"
              />
              <path
                d="M336.59,689.7c10.93,17.07,4.24,42.21-.46,60.01-5.41,20.51-15.15,43.29-39.55,52.09-6.03,2.17-10.87-3.75-7.63-8.08c12.18-16.32,20.84-33.24,27.95-51.55c3.31-8.53,6.7-17.02,9.67-25.64c3.06-8.86,4.79-17.91,7.47-26.78.33-1.09,2.05-.82,2.55-.04v0Z"
                fill="#849a67"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv1853" transform="translate(-17.999989-186.316848)">
            <g transform="translate(-124.588299-.000001)">
              <g>
                <path
                  d="M212.93,486.71c-.45.83-.89,1.69-1.41,2.51-1.1,1.75-2.04,3.69-3.21,5.43-9.33,13.84-19.3,28.44-31.99,39.31-9.57,8.2-29.25,9.12-29.35-5.81-.09-14.93,10.26-23.18,20.88-34.14c8.84-9.13,21.27-19.35,34.31-23.67.31-.1.87-.11,1.08-.18.21-.06.2-.19.27-.3c3.93-5.84,7.13-11.39,13.6-14.81c1.96-1.04,5.22-.78,6.06,1.25c2.68,6.46-.48,11.37-3.37,17.28-2.18,4.45-4.51,8.78-6.87,13.14Z"
                  fill="#ffead7"
                />
                <path
                  d="M-7.15,688.57c6.62,2.97,12.96,6.19,19.24,9.58c38.3,18.38,76.9,44.76,72.89,91.29.22,7.4.95,14.63,1.02,22.02-.56-.33-1.12-.26-1.71-.61s-1.12-.62-1.7-1.12c-3.67-3.21-7.62-5.9-11.66-8.84-1.71-1.25-3.94-2.71-5.47-4.27-.75-.77-.64-2.37-.95-3.11s-.18-.75-.41-1.35c-3.92-2.69-7.29-5.72-10.46-8.97-7.66-6.61-11.22-15.61-19.57-21.9-3.48-3.83-7.04-7.62-10.88-11.39-11.05-10.87-23.09-21.09-35.5-30.73-3.65-4.88-7.76-9.52-12.46-13.45v-24.61c5.86,2.43,11.75,4.83,17.6,7.45Z"
                  fill="#727536"
                />
                <path
                  d="M175.18,749.64c.4-.86.74-1.81,1-2.44s.41-.94.56-1.3-.05-.14-.03-.19c.53-1.45.68-2.69,1.23-4.16.22-.59.73-.53,1.18-1.37s.7-2.07,1.25-3.21c4.21-8.82,2.39-16.83,8.45-25.68c12.11-17.69,29.43-30.07,48.34-42.11c18.9-12.04,40.05-22.62,60.17-33.6c16.64-9.09,34.11-18.28,49.1-30.02c3.18-2.49,5.21-5.46,8.13-8.03c1.53-1.34,2.99-1.88,4.95-2.21-19.78,26.26-36.4,54.19-53.07,82.28-4.86,4.66-8.5,8.94-13.83,13.39-15.58,12.99-30.83,24.29-49.73,33.48-13.38,6.51-29.4,12.32-43.71,17.57-1.01,1.4-1.47,2.81-2.48,4.19-6.37,8.75-13.36,15.86-22.91,21.52-2.75,1.63-6.44.83-7.65-2.2c3.31-5.14,6.48-10.46,9.05-15.91Z"
                  fill="#a2a360"
                />
                <g>
                  <path
                    d="M233.49,673.06c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M191.4,710.58c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M264.01,706.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M226.85,678.95c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M302.79,644.82c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06s1.55-1.55,1.16-2.54-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M231.29,703.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M235.35,685.34c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M237.13,723.73c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M263.56,676.24c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M213.27,687.35c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M256.56,659.35c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M239.52,695.23c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M282.57,661.79c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M214.49,703.5c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M258.23,684.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M215.55,696.61c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M184.19,730.03c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M219.68,719.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M193.48,712.72c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M260.73,681.01c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M180.92,747.08c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M224.05,726.64c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M233.69,688.11c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M197.36,733.76c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M255.63,665.76c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M217.37,683.85c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M214.95,713.41c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06s1.55-1.55,1.16-2.54-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M200.82,734.69c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M257.68,692.81c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M239.3,690.34c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M210.63,699.85c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M185.12,746.98c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M215.96,723.94c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M199.15,716.82c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M187.96,720.1c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M191.31,717.32c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M255.75,699.52c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M278.41,654.09c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M237.21,702.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M219.27,725.06c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M198.01,730.04c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M190.59,744.71c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M198.93,719.44c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M276.99,674.99c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M184.46,725.34c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M284.75,680.12c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M224.43,694.88c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M234.47,697.22c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M257.18,673.72c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M277.87,682.33c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M248.39,709.75c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M290.18,665.09c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M231.59,691.69c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M181.28,737.3c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M193.85,726.25c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M251.97,684.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M193.73,731.27c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M215.68,692.05c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M185.92,740.31c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M243.24,720.26c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M221.91,706.65c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M232.51,700.01c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M292.38,651.84c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M207.83,707.1c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M238.04,684.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M238.07,678.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M200.27,706.72c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M221.21,700.15c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M198.48,701.42c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M262.39,660.43c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M223.72,709.06c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M238.84,714.71c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M188.62,749.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M227.91,684.59c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M226.7,715.04c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M286.97,644.33c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M232.33,677.25c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M190.2,728.65c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M236.25,707.66c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M234.68,693.45c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M264.06,654.55c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M206.77,727.56c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M269.49,673.53c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M246.01,671.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M263.89,690.14c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M197.87,713.74c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M202.87,707.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M181.11,749.5c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M227.99,724.11c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M243.76,708.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M245.68,663.75c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M198.49,725.08c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M249.28,676.99c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M265.67,666.35c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M196.24,704.47c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M272.12,680.6c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M286.02,653.13c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M228.11,710.73c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M239.25,669.36c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M304.95,664.29c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M208,701.65c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M223.55,690.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M206.68,731.49c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M284.09,688.97c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M208.8,720.51c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M228.93,727.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M251.06,663.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M210.44,691.47c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M243.34,698.19c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M194.07,719.84c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M210.93,732.02c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M190.27,731.17c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M203.34,731.94c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M221.62,713.1c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M256.84,713.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M219.65,715.52c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M285.41,672.9c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M245.54,679.07c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M209.95,713.32c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M290.92,683.6c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M284.31,684.89c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06s1.55-1.55,1.16-2.54-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M224.52,719.98c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M229.3,686.79c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M195.77,723.88c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M196.15,737.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M230.75,721.27c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M194.44,734.12c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M293.64,668.43c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M249.32,704.14c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M270.43,658.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M200.91,710.39c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M211.5,709.71c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M202.86,725.15c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M186.45,743.04c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M277.78,648.65c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M231.72,716.16c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M221.13,681.48c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M250.5,694.7c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M246.43,668.95c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M246.67,685.39c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M229.09,707.04c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M233.65,721.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M205.34,702.97c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M290.57,688.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M246.52,699.13c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M255.4,689.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M243.31,692.02c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M205.48,694.4c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M238.18,673.98c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M273.65,693.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M187.95,725.83c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M182.24,742.76c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M217.98,705.27c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M214.2,718.97c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M241.43,704.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M246.95,689.56c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M203.65,720.55c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M211.31,728.7c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M275.84,659.45c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M240.95,684.01c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M249.09,718.11c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M205.3,710.88c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M244.26,714.45c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M217.2,701.03c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M240.61,710.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M247.91,715.9c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M219.56,730.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M192.53,741.36c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M190.47,739.3c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M220.26,695.95c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M270.01,702.13c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M272.59,688.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M188.77,733.31c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M192.31,736.62c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M228.32,698.43c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M204.86,714.7c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M205.9,698.11c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M273.98,698.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M258.87,702.76c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M215.55,729.66c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M261,686.35c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M266.09,680.62c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M196.6,708.91c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M208.8,724.51c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M222.21,729.6c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M225.24,702.81c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M242.56,666.07c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M202.46,700.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M253.3,709.4c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M228.28,676.06c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M252.4,715.62c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M261.54,695.48c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M267.11,695.36c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M231.69,682.66c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M184.06,733.42c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M213.1,723.88c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M311.46,653.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06s1.55-1.55,1.16-2.54-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M280.46,697.25c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M233.61,725.66c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M186.18,736.82c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M202.39,696.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M303.03,635.9c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M298.63,677.29c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M257.17,670.46c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M239.57,719.57c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M220.91,688.37c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M271.23,652.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M253.99,678.06c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M261.78,669.22c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M272.85,665.92c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                </g>
                <path
                  d="M125.61,687.4c-1.44-2.68-2.3-7.79-2.55-11.13-.09-1.18-.55-2.15-.57-3.12-.08-4.2.13-8.2.09-12.34c0-.51-.19-1.18-.13-1.62s.14-.65.16-1c.36-9.39.36-18.43,1.57-27.86.67-5.25,1.81-10.28,3.44-15.62s1.36-10.47,3.77-16.09c4.86-11.32,10.02-20.64,18.6-30.84c17.11-20.35,36.08-38.57,57.65-55.99s45.38-35.86,66.81-54.2c1.87-1.6,4.25-1.98,6.61-2.01-.3.61-.69,1.25-1.05,1.83-2.26,3.57-4.76,7.18-6.98,10.73-5.88,9.37-12.03,18.87-16.88,28.65-6.69,13.5-11.87,27.2-18.33,40.72-1.45,3.04-2.66,6.23-4.66,9.01-5.33,7.44-11.15,14.73-17.09,21.73-14.25,16.82-31.4,33.03-45.52,49.32-7.56,8.72-12.47,16.88-18.83,25.48-4.13,5.59-6.36,10.55-9.99,16.17-2.89,11.07-6.55,21.97-10.06,32.94-.54,1.68-2.86,1.36-4.18.97-.27-2.65-.45-3.05-1.89-5.73Z"
                  fill="#a0ad77"
                />
                <path
                  d="M-16.83,602.64c3.24.04,6.73.86,9.48,1.54c11.38,2.81,26.37,6.79,35.74,11.71c20.65,10.83,30.85,28.28,43.18,44.95c9.56,12.91,16.23,22.72,24.96,35.18.57.81.71,1.46,1.05,2.34c1.12,2.87,2.01,5.5,3.06,8.45s1.48,6.36,2.12,9.48c-.64.45-1.3.78-2.02,1.06-1.37-1.9-2.9-3.59-4.64-5.18-8.52-11.06-18.94-17.59-31.8-23.25-2.15-2.01-3.91-4.07-6.2-6.01-1.38-1.17-2.57-2.21-4.22-3.3-7.65-5.06-13.15-9.55-22.13-13.68-17.51-8.05-37.48-14.21-56.5-20.06v-43.02c2.64-.16,5.28-.25,7.91-.22Z"
                />
                <path
                  d="M120.92,539.72c.55,16.76,6.56,29.73,6.18,46.35-.07,2.9,4.62,4.65,7.32,4.66c4.11-2.79,7.59-5.5,11.2-8.99s7.6-7.23,11.83-10.13c8.23-11.08,16.91-20.73,26.58-30.85c11.62-12.16,26.61-23.36,36.49-36.99c17.91-24.72,23.42-51.16,30.07-79.78c1.34-4.78,2.85-9.34,3.01-14.33.08-2.57-1.69-4.07-4.09-4.81-3.92,7.88-10.77,17.13-17.07,22.57-10.17,8.79-20.07,13.59-31.05,19.89-2.91,1.67-5.85,3.64-8.37,5.25-17.87,11.4-40.19,23.86-54.16,38.15-15.41,15.76-18.57,29.75-17.94,49.01Zm38.92-20.7c3.56-8.11,9.09-14.31,16.12-20.78c14.78-13.59,31.85-26.35,47.35-39.54-.58,1.41-.74,2.68-1.43,4.1-7.43,15.22-16.26,27.26-28.37,39.84-11.33,11.76-24.74,23.61-36.49,35.46.87-6.71-.11-12.44,2.81-19.09Z"
                  fill="#6d6d38"
                />
                <path
                  d="M0,538.9c-8.29-3.29-16.07-6.43-24.75-8.39v-23.73c5.55-.07,11.09.04,16.68.56c1.62.15,3.07.9,4.44,1.59c10.66,5.42,20.42,12.17,29.57,19.56c9.15,7.38,18.22,13.97,26.43,22.36c8.21,8.38,15.25,18.51,21.29,28.32c2.48,4.02,3.99,7.16,6.12,11.1.11.2-.17.27-.34.22-1.69-.48-3.29-1.14-4.82-2-9.61-5.4-19.36-10.55-29.2-15.57-1.71-1.8-3.37-3.75-5.32-5.27-.52-.4-1.24-.11-1.78-.23-19.83-4.31-41.34-9.05-60.97-12.18-.7-.11-1.39-.18-2.09-.28v-20.62c8.28,1.33,16.54,2.79,24.75,4.57Z"
                  fill="#ba9e7e"
                />
                <g>
                  <path
                    d="M22.04,540.76c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M11.81,551.23c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M49.21,563.92c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M27.71,536.07c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M20.49,546.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M52.44,559.41c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M64.05,575.71c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M32.21,549.82c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M68.71,580.07c-1.04.41-1.57,1.56-1.17,2.57.4,1,1.57,1.48,2.61,1.07s1.57-1.56,1.17-2.57-1.57-1.48-2.61-1.07Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M54.4,571.47c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M33.06,559.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M32.66,555.25c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M9.29,524.04c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M54.33,564.07c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M13.14,523.37c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M16.97,535.85c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M15.24,557.26c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M57.29,573.21c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M20.01,532.66c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M38.77,556.95c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1.01,549.3c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M23.13,553.73c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M55.12,567.12c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M38.93,544.84c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M15.3,528.21c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M44.86,566.49c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M52.67,553.6c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M68.04,575.68c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M31.85,538.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M23.33,557.87c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M43.08,563.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M5.36,528.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M35.6,541.55c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M23.93,530.14c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M55.87,560.81c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M14.6,539.02c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M46.37,550.11c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M29.82,551.26c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M19.55,551.19c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M35.06,549.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M57.96,558.59c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M5.16,544.56c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-0.87,515.96c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M42.03,552.19c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M4.13,554.47c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M10.18,556.2c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M17.78,523.83c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-2.24,526.61c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M13.13,543.51c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-0.82,544.61c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M40.31,560.92c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M58.81,562.81c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M44.56,546.22c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M9.81,536.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M72.2,582c-1.05.42-1.58,1.57-1.18,2.58s1.58,1.49,2.63,1.08c1.05-.42,1.58-1.57,1.18-2.58s-1.58-1.49-2.63-1.08Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M62.24,570.28c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M44.89,556.41c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M26.66,550.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M48.38,567.78c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M48.41,560.52c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M51.3,569.89c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-0.65,555.8c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M6.54,516.45c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M29.93,543.58c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M64.95,570.79c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M49.36,555.54c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M0.81,532.86c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-0.13,521.78c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M16.23,549.98c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M59.07,571.18c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M48.9,552.35c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M6.46,541.67c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M28.17,555.4c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M40.35,549.61c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M7.44,548.42c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M60.57,565.75c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M27.13,532.17c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M5.11,535.38c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M60.83,574.3c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M-1.52,537.6c-1.03.41-1.55,1.55-1.16,2.54s1.55,1.47,2.59,1.06c1.03-.41,1.55-1.55,1.16-2.54s-1.55-1.47-2.59-1.06Z"
                    fill="#4e531e"
                  />
                </g>
                <path
                  d="M84.52,496.89c-.63-10.13-.22-20.49.41-30.69.03-.52-.28-.94-.13-1.45c3.9-12.73,3.66-23.28,11.95-35.21c22.19-31.97,54.73-54.04,86.85-76.66c7.53-5.31,14.3-11,22.05-15.93c2.9-1.84,6-1.77,9.2-1.05-6.9,5.38-15.33,10.46-21.16,16.75-6.82,7.36-10.76,15.46-14.89,24.01-5.34,11.06-9.98,21.85-15.58,32.69-4.48,8.67-9.9,17.39-14.13,26.1-10,20.57-19.68,40.83-31.09,60.64-3.88,7.93-8.52,14.37-15.01,20.67-1.76,1.71-3.13,4.12-5.29,5.79-3.62,2.8-7.65,2.63-11.38.15.08-8.74-1.26-17.07-1.81-25.82Z"
                  fill="#4e6528"
                />
                <path
                  d="M8.18,479.81c11.24,9.11,19.73,16.84,28,27.93c1.34,1.8-.11,2.94-1.16,4.42-3.14-2.47-6.78-3.64-10.28-5.45-5.54-2.87-11.58-4.95-17.58-6.31-1.75-.4-3.07-.59-4.52-.95-8.89-2.24-18.45-4.85-27.39-7.81v-35.41c11.55,7.45,22.94,15.48,32.93,23.58Z"
                  fill="#707758"
                />
                <path
                  d="M46.06,410.01c2.32-14.99,6.8-28.3,14.27-41.42c6.94-12.19,16.64-23.08,25.1-34.01c6.78-5.46,12.17-11.34,16.97-18.78c3.21-4.97,6.18-10.39,8.18-16.04c1,2.01,1.8,4.1,2.33,6.18c1.28,2.89,1.99,5.87,2.38,8.81s.44,5.83.63,8.48c-1.12,14.1-2.07,27.06-4.9,41.11-3.04,15.09-8.99,29.88-15.98,43.91-3.81,3.87-6.93,7.9-11.29,11.27-3.13,2.42-6.9,3.87-10.65,5.46-8.41,3.57-15.7,7.4-21.59,14.49-5.71-9.08-7.07-19.02-5.45-29.46Z"
                  fill="#8e934b"
                />
                <path
                  d="M-7.69,376.38c.2-12.38,3.51-21.88,7.14-34.14c4.13-13.92,15.2-24.72,26.64-34.21c4.76-3.94,9.68-7.27,14.76-10.67c7.03-2.35,14.02-4.47,20.92-7.22c8.44-3.36,16.16-6.33,24.66-10.26.95-.42,1.87-.89,2.77-1.38c7.55-3.11,13.17-5.33,19.95-10.1-.37,20.97-15.53,37.39-28.27,52.29-2.32,2.48-4.69,4.91-7.07,7.3-7.14,7.17-14.41,13.95-20.8,20.51-4.45,3.95-9.06,7.82-13.84,11.65-9.54,3.97-17.88,6.89-27.32,12.08-4.43,2.44-10.39,7.28-13.65,11.73-2.52-1.8-5.95-4.32-5.89-7.6Z"
                  fill="#7f8343"
                />
                <path
                  d="M-19.02,233.77c.77-.51,1.34-.98,2.05-1.59c7.1-6.15,14.42-11.85,22.2-17.26c1.94-1.35,3.97-2.67,5.99-4.1c18.25-12.86,34.07-26.21,46.72-44.55.68,3.44.8,6.29-.24,9.8-.68,2.3-1.66,4.57-2.65,6.94-1.72,4.09-3.47,8.14-5.25,12.16-4.49,5.61-6.8,12.16-8.77,18.91-12.04,24.78-25.86,48.37-42.94,70.99-.38.5-.15,1.38-.73,1.77-1.67,1.13-3.33,1.85-5.04,3.02-5.88,4.02-11.63,8.21-17.07,12.78v-58.19c1.83-3.59,3.71-7.15,5.72-10.68Z"
                  fill="#6f7e43"
                />
                <path
                  d="M71.94,766.61c-8.81-12.75-23.21-23.47-36.21-32.88-.15-.11.02-.27.18-.17c11.82,7.7,26.02,15.88,35.08,26.03s12.46,21.61,15.56,33.55c2.68,10.32,5.05,20.39,7.3,30.44h-4.65c-1.67-7.5-3.37-15.04-5.2-22.69-2.82-11.75-4.48-23.3-12.06-34.28Z"
                  fill="#3d470d"
                />
                <path
                  d="M-24.65,372.85c-.03-.09-.07-.19-.1-.28v-10.74c5.43,14.21,11.69,27.98,19.68,41.27-.09-.73-.27-1.73-.41-2.41-1.13-5.68-2.34-11.17-1.12-16.9s3.48-10.33,5.57-15.93s3.91-12.04,6.16-17.75c.04-.1.13-.17.23-.2-1.87,4.93-2.94,9.9-4.04,15.03-.52,2.43-1.47,4.84-2.18,7.23-1.27,4.27-2.12,7.82-3.28,12.33s-.95,9.55.59,14.12c.29.86.23,1.84.39,2.75.37,2.03.75,4.08,1.38,6.05c15.57,18.33,32.35,35.17,44.75,55.83.39-6.16,1.58-12.14,3.39-18.04.35-1.13.77-2.53,1.19-3.37s.94-.95,1.26-1.55c4.81-8.97,8.7-18.1,12.41-27.5-2.22,8.03-5.07,15.26-8.08,23.17-4.04,10.62-7.28,21.27-7.39,32.69c1.18,2.45,2.55,5.04,3.71,7.44c11.74,24.22,22.44,48.75,33,73.47.47-2.67,1.03-4.98,1.72-7.63c2.49-9.65,2.61-18.06,3.28-28.21c1.24-18.91,9.03-35.96,17.98-53.02.13-.25.66-.18.56.07-7.49,17.87-14,35.56-14.83,54.64-.37,8.49-.51,15.9-2.74,23.81-1.68,5.94-2.9,10.85-3.27,16.86c7.45,17.75,14.55,35.71,20.64,53.96c17.03-10.19,22.33-24.44,27.53-42c5.21-17.57,14.62-31.2,24.11-46.56.14-.23.66-.14.54.09-4.61,9.27-9.64,17.77-14.22,27.15-4.59,9.39-6.85,18.19-9.78,28.68-3.37,12.06-9.52,22.94-20.29,30.87-1.06,1.62-2.37,2.77-3.33,4.43-.97,1.65-1.34,3.7-2.28,5.41c6.24,33.3,5.68,67.33,13.54,100.32.74-1.29,1.58-2.38,2.55-3.54.37-.44.89-.79,1.21-1.35c1.55-2.72,2.85-5.2,3.25-8.37.39-3.17-.23-6.41-.95-9.51-.43-1.87-.94-3.59-1.93-5.21.05-7.82-1.69-14.53-.61-22.57c2.53-18.76,10.17-34.68,21.5-50.39.21-.29.83-.06.64.25-11.22,18.13-18.08,36.26-19.45,57.01-.63,9.54,2.03,16.97,3.26,26.13.52,3.83.1,7.58-.82,11.62-.46,2.04-1.51,4.49-2.24,6.69-1.03,3.09-2.23,6.4-3.78,9.35.17,1.02.39,2.06.55,3.06.88,5.73,1.02,11.5,1.35,17.28.7-1.2,1.64-2.75,2.35-3.85c3.69-5.66,7.16-11.11,11.47-16.27-.77,3.44-1,7.16-2.14,10.47s-2.62,6.28-3.93,9.47c-.72,1.76-2.1,3.16-2.97,4.83-1.33,2.54-2.53,5.04-4.28,7.35.45,10.52.67,21,.17,31.54c7.25-5.66,17.13-9.63,24.48-14.57c12.57-8.44,21.64-18.84,30.36-30.24c4.59-5.99,7.98-11.39,12.54-16.93c3.41-4.14,6.81-7.92,10.5-11.59c6.61-6.56,13.4-12.15,20.68-18c2.9-2.33,6.28-4.85,9.1-7.39.06-.05,0,.14-.09.21-10.49,9.09-20.95,18.36-29.9,28.88-7.98,9.39-13.57,18.99-21.18,28.91-6.92,9.02-14.66,17.75-24.33,24.88-5.7,4.2-13.41,7.43-19.73,11-.04.03-.05.05-.07.07-2.93,2.82-5.71,5.67-8.53,8.64-1.47,1.55-3.01,3.23-4.72,4.58-1.29,7.63-3.01,15.18-4.93,22.69h-6.28c4.1-17.01,7.07-34.12,6.94-52.37-.02-3.23-.12-6.16-.36-9.38-.04-.59-.46-1.07-.73-1.7-1-2.27-1.87-4.36-3.04-6.72s-2.75-5.07-3.92-7.54c-.49-1.03-1.09-2.07-1.42-3.1-9.11-13.58-11.42-27.88-18.59-42.76-9.25-19.2-23.61-33.7-42.11-45.32c3.24.91,6.58,2,9.79,3.18.38,1.17.95,1.76,2.01,2.42c11.02,6.82,19.14,15.87,27.66,25.37c1.4,2.53,2.97,5.14,4.2,7.72c1.99,4.19,3.98,8.22,5.39,12.61.89,2.78,1.37,5.42,2.69,8.06c1.33,2.65,1.22,4.78,2.15,7.83c3.14,10.33,9.77,19.24,15.78,28.3-2.14-27.29-7.64-54.09-10.01-81.37c0-.04-.05-.04-.07-.08-.02-.03,0,.04-.01.01-1.43-1.83-1.94-3.6-2.64-5.86-.69-2.26-2.37-4.84-3.45-6.87s-1.46-3.59-1.87-5.72c-.22-1.16-.44-2.39-.56-3.54-7.96-14.57-12.95-28.83-19.59-44.34-5.25-12.27-11.24-23.8-21.24-34.16-8.76-9.08-22.26-16.15-33.28-23.13-.27-.17-.39-.25-.31-.58c5.87,3.5,11.62,4.59,17.7,8.23c10.81,6.46,19.82,15.9,28.23,25.33c3.27,5.17,7.23,10.78,9.7,16.18c5.13,11.24,8.69,22.38,13.59,33.56c2.51,5.72,5.53,11.32,8.17,17.02c1.39,1.5,1.99,3.58,2.63,5.38.64,1.81,1.39,3.19,2.05,4.91.02.05.04.07.07.08-2.56-19.71-5.58-40.02-12.18-58.49-2.8-7.85-6.55-14.72-9.7-21.5-2.7-5.82-4.55-9.59-7.11-14.99-.69-1.45-.41-3.3-1.36-4.57-1.34-1.78-4.04-2.81-5.51-4.51s-2.05-3.5-3.34-5.27c-2.77-3.78-5.13-7.61-8.49-11.05-7.49-7.67-16.09-14.51-24.21-21.58-11.32-12.29-24.24-20.95-38.92-29.31-7.11-4.05-15.08-8.04-22.47-11.66c18.68,7.99,38.18,18.13,53.93,29.89c11.68,8.73,19.59,17.39,29.73,26.75c3.36,3.1,6.01,5.99,9.23,9.06c1.28,1.22,2.4,2.27,3.53,3.6-.94-2.35-1.89-4.69-2.84-7.02.29-.89.51-1.56.17-2.48-2.77-7.52-6.38-14.57-9.78-21.86-2.21-4.74-3.85-9.9-5.71-14.81-.26-.07-.52-.1-.74-.26-2.48-1.78-4.95-3.59-7.42-5.39-3.71-4.98-7.43-9.94-11.18-14.9c6.1,3.87,11.45,8.35,16.52,13.42-1.36-3.01-2.84-5.96-4.37-8.89-2.97-2.38-3.91-5.28-4.62-8.87-.13-.64-.5-1.06-.76-1.61-1.79-3.78-3.76-7.25-6.44-10.48-.21-.25-.45-.54-.74-.71-.29-.16-.55-.13-.82-.35-16.11-12.98-35.53-20.4-53.02-31.39-2.21-1.39-4.3-2.95-6.34-4.55v-3.59c3.32,2.77,6.78,5.44,10.55,7.94c13.31,8.81,29.37,15.02,43.24,23.31-7.31-12.11-17.88-21.59-26.91-32.36s-16.14-22.58-23.38-34.48c-1.22-2.01-1.25-4.36-2.33-6.41-.4-.27-.77-.59-1.16-.86v-2.32c0,0,.07.07.1.11Z"
                  fill="#3d470d"
                />
                <path
                  d="M106.76,611.18c0,0-.06.01-.06.02c0,0,.01.06.02.05.02,0,.05-.06.04-.08Z"
                  fill="#3d470d"
                />
                <path
                  d="M31.82,758.43c8.37,8.67,16.71,17.65,25.24,25.99s17.4,15.68,25.43,24.38c.2.21-.14.36-.34.25-11.44-5.83-21.8-13.64-31.23-21.88s-17.94-16.62-26.61-25.3C15.64,753.2,7.3,744.5,-0.53,735.21c-1.23-1.45-2.46-2.89-3.71-4.32-1.58-2.44-3.19-4.87-4.84-7.27-4.42-6.45-9.56-12.71-15.66-17.81v-.49c9.66,7.95,18.23,16.74,27.69,25.09c9.95,8.79,19.65,18.44,28.88,28.02Z"
                  fill="#4e531e"
                />
                <path
                  d="M340.98,620.93c-5.64,7.21-10.78,14.81-14.72,22.9-3.59,7.36-4.18,14.49-7.88,21.91-7.28,14.59-16.95,25.83-30.25,36.4-12.14,9.64-26.37,18.13-40.51,25.23-7.62,3.83-16.15,5.78-24.28,8.29s-16.58,4.59-24.78,6.44c-1.78.4-2.36-1.39-.91-2.08c7.28-3.45,15.22-6.35,22.35-9.95s13.87-8.09,20.66-11.93c13.54-7.65,27.49-15.88,39.42-25.23c13.65-10.7,23.65-22,32.26-36.33c3.55-5.91,5.55-11.65,9.88-16.96c5.59-6.85,12.29-12.59,18.69-18.72.03-.03.1,0,.07.03-.03.04,0,0,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M7.19,652.59c26.44,11.82,48.23,24.1,70.56,41.07.61.46-.12,1.23-.82.88-24.48-12.32-48.46-23.47-73.98-34.65-8.36-3.66-18.56-7.87-27.69-11.59v-9.01c11.1,4.33,22.23,8.97,31.94,13.31Z"
                  fill="#4e531e"
                />
                <path
                  d="M59.9,580.35c.11.09.43.34.34.29-3.55-1.75-7.16-3.63-10.72-5.41-.88-.44-1.64-.72-2.66-.88-22.93-9.45-47.17-13.77-71.6-16.79v-8.48c30.33,3.74,60.04,11.69,84.64,31.27Z"
                  fill="#4e531e"
                />
                <path
                  d="M272.47,463c-13.79,33.06-22.44,67.25-44.19,96.82-21.74,29.57-51.9,52.51-76.91,79.43-.32.35-1.08-.03-.8-.43c4.76-6.87,9.27-12.44,14.1-19.61s9.53-14.72,15.71-21.7c12.03-13.59,27.56-26.96,37.92-41.84c20.79-29.86,32.87-63.15,53.64-92.76.15-.22.62-.15.51.1-.1.24-.04.03,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M246.62,411.2c-1.86,13.42-7.93,21.46-19.06,29.82-6.4,4.82-14.36,8.06-21.56,12.16-7.19,4.1-15.12,9.03-21.83,13.81-29.08,20.72-52.42,38.54-59.03,74.16-.11.62-1.24.78-1.3.21-1.35-13.44-4.24-23.36,2.34-36.83s18.47-23.45,31.22-33.52c12.74-10.07,26.82-20.19,42.44-27.72c17.48-8.42,35.78-14.58,46.43-32.08.09-.14.37-.14.35,0s0,.03,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M-4.39,372.24c3.76-28.37,7.33-51.8,30.1-72.65c11.35-10.39,27.9-13.03,42.69-17.65.18-.06.38-.11.57-.16c3.58-.4,7.16-.84,10.67-1.38c3.51-.55,6.96-1.21,10.28-2.05c4.97-2.19,12.46-5.15,18.08-7.38-7.94,7.31-13.29,15.67-24.67,19.13-3.45,1.57-7,3.05-10.52,4.53-7.05,2.97-13.98,5.96-19.72,9.86-14.69,8.11-22.9,18.82-33.78,29.69-11.54,11.52-17.42,23.67-23,38.29-.14.38-.75.19-.69-.22Z"
                  fill="#4e531e"
                />
                <path
                  d="M104.01,373.26c4.1-15.6,5.82-31.23,8.25-46.89.68-4.37.34-8.32.27-12.61s-.73-8.56-1.44-12.78c2.93,6.49,4.98,13.05,6.28,20.09.44,2.35.57,4.49.89,7.04.32,2.56.75,5.79.77,8.51-2.91,23.07-8.97,44.93-21.19,65.27c1.4-7.06,2.11-14.56,3.98-21.44.67-2.48,1.6-5.03,2.17-7.2Z"
                  fill="#4e531e"
                />
                <path
                  d="M13.88,255.31c9.21-14.03,18.25-27.72,27.29-41.69-.63,2.15-1.24,4.32-1.87,6.49-9.76,20.56-20.17,40.6-33.17,59.62-.72,1.05-1.67,1.7-2.63,2.62s-1.7,2.27-2.95,3.01c-2.65,1.57-5.63,2.7-8.17,4.48-.08.06-.19.1-.25.15c6.4-11.93,14.36-23.42,21.75-34.68Z"
                  fill="#4e531e"
                />
                <path
                  d="M68.97,785.59c-2.73-1.65-4.3-3.35-6.91-5.55s-6.56-4.12-9.51-6.37c-5.07-3.89-9.74-8.67-13.85-13.48-9.28-10.86-18.32-21.6-28.07-32.03-.67-.71.34-1.62,1.33-1.02c13.45,8.2,27.62,16,39.93,25.79c5.43,4.32,9.58,9.68,12.65,15.46c1.69,3.18,1.93,6.47,3.2,9.33c1.27,2.85,2.05,4.5,2.23,7.44.03.47-.59.69-1.02.42s-.08-.02,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M32.62,642.29c15.69,5.33,24.69,13.91,31.98,27.92.18.35-.35.55-.62.44-7.42-3.15-14.19-6.54-21.92-9.26s-15.46-4.7-23.33-7.92c-14.37-5.88-28.93-12.43-43.49-18.48v-3.53c19.16,3.08,39.24,4.67,57.37,10.83Z"
                  fill="#ffead7"
                />
                <path
                  d="M218.88,522.89c-4.75,13.44-11.06,25.09-19.27,37.11s-18.57,23.72-26.66,35.98c-.82,1.24-3.68.97-3.27-.51c3.53-12.63,8.76-24.26,16.44-35.04c9.22-12.92,19.98-24.83,28.11-38.2c1.38-2.27,5.54-1.88,4.65.66.3.11.23.09,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M56.82,293.78c-11.28,13.12-25.96,22.59-36.88,36.01-.69.84-2.35.34-2.29-.6.59-9.19,2.26-13.56,10.29-19.74c8.02-6.19,18.44-12.25,28.41-15.92.22-.08.62.08.47.26s0,.06,0,0Z"
                  fill="#8e934b"
                />
                <path
                  d="M98.05,335.68c-9.48,27.81-11.34,56.86-23.36,83.94-.31.7-1.49.23-1.34-.41c6.77-28.61,11.21-56.76,24.32-83.61.08-.17.44-.1.38.08s-.01.04,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M160.3,390.83c-6.15,8.84-12.92,18.03-17.42,27.56-4.14,8.77-7.17,17.31-11.2,25.85-8.07,17.09-15.27,34.24-24.75,50.63-.41.7-2.01,1.1-2.01.05.08-44.88,23.88-72.69,55.09-104.17.13-.13.38-.06.28.09-.1.14,0,.02,0,0Z"
                  fill="#ffead7"
                />
              </g>
              <path
                d="M-4.82,248.38c-.58-2.16.42-4.5,2.23-5.93c1.29-1.03,3.15.16,2.91,1.67-.32,2.05-1.87,4.15-3.96,4.75-.44.13-1.05.02-1.18-.48v0Z"
                fill="#b9a672"
              />
              <path
                d="M17.76,227.21c-.16-1.01.44-2.12,1.01-2.94.63-.91,1.16-1.88,2.02-2.61.47-.4,1.25-.47,1.79-.23.13.06.27.14.39.22.5.33.76,1.05.64,1.62-.24,1.19-.99,2.17-1.73,3.13-.64.84-1.73,1.77-2.86,1.8-.66.02-1.18-.34-1.28-.99v0Z"
                fill="#b9a672"
              />
              <path
                d="M1.69,230.94c.07-1.65.55-3.24,1.87-4.38c1.54-1.32,3.66.57,2.93,2.22-.46,1.05-1.28,1.91-1.73,2.98-.3.72-1.2,1.11-1.94.9-.83-.23-1.17-.91-1.13-1.72v0Z"
                fill="#b9a672"
              />
              <path
                d="M30.44,209.7c-.57-1.51.67-3.79,1.36-5.15.77-1.52,1.92-4.79,4.29-3.54c2.12,1.12.5,3.9-.3,5.39-.75,1.41-2.34,3.86-4.16,3.98-.5.03-1-.21-1.18-.68v0Z"
                fill="#b9a672"
              />
              <path
                d="M163.74,592.72c.57,1.45.27,3.19.2,4.72-.09,1.95-.16,3.91-.81,5.78-.82,2.4-4.29,1.49-4.61-.62-.31-2.07.44-4.39,1.48-6.22.82-1.44,1.91-3.16,3.59-3.73.06-.02.13,0,.15.06v0Z"
                fill="#ffead7"
              />
              <path
                d="M161.49,614.3c-.37,1.01-1.57,1.91-2.24,2.79s-1.5,2.13-2.55,2.56c-.59.24-1.43-.15-1.43-.83c0-1.29,1.06-2.53,2.03-3.38.88-.77,2.27-2.01,3.47-2.09.55-.04.89.45.71.94v0Z"
                fill="#ffead7"
              />
              <path
                d="M149.48,628.76c.36,1.85-.47,4.27-2.49,5.01-1.4.51-2.56-.34-2.84-1.64-.22-1.01.32-2.16.94-2.99.62-.82,1.32-1.25,2.26-1.61c1.03-.4,1.94.27,2.13,1.23v0Z"
                fill="#ffead7"
              />
              <path
                d="M142.05,647.42c.08,1.42-.71,2.72-1.74,3.68-.83.77-2.48.09-2.46-1.01.03-1.37.48-2.81,1.63-3.72.95-.76,2.5-.12,2.57,1.05v0Z"
                fill="#ffead7"
              />
            </g>
          </g>
          <g
            id="e0gYpSRcAlv2186"
            transform="matrix(.985999 0.166753-.166753 0.985999-557.946807 321.788363)"
          >
            <g transform="translate(-2 0)">
              <g>
                <path
                  d="M1451.77,181.17c.13.17.27.34.42.53.11-.04.21-.09.31-.12c1.25-.35,2.5-.7,3.74-1.04c1.95-.85,3.87-1.21,5.75-1.68c1.52-.38,2.88-1.16,4.26-1.86c1.49-.75,2.97-1.52,4.46-2.28.24-.12.5-.17.84-.28.06.33.12.54.12.76.06,1.56.18,3.13.16,4.69-.02,1.81-.17,3.62-.25,5.43-.04.88-.06,1.76-.1,2.63-.05,1.07-.13,2.15-.18,3.22-.04.85-.08,1.7-.1,2.55-.02,1.11-.04,2.21-.04,3.32.01,2.25.05,4.49.07,6.74.02,2.07.04,4.15.05,6.22.01,1.68.05,3.35.03,5.03-.01,1.1-.1,2.21-.16,3.31-.01.28,0,.57-.02.85-.06.99-.13,1.97-.19,2.96-.05.76-.06,1.53-.12,2.29-.09,1.21-.21,2.42-.32,3.63-.09,1.04-.19,2.08-.27,3.13-.23,2.79-.51,5.57-1.08,8.31-.38,1.82-1.29,3.38-2.56,4.72-.54.57-1.17,1.07-1.81,1.54-.25.19-.63.29-.95.29-.82,0-1.65-.01-2.46-.11-.76-.09-1.38-.54-1.92-1.04-1.59-1.46-2.76-3.18-3.45-5.27-.87-2.61-1.52-5.27-2.11-7.94-.15-.69-.22-1.4-.29-2.11-.13-1.47-.29-2.94-.35-4.42-.39-9.72-.76-19.45-1.11-29.17-.1-2.93-.19-5.86-.13-8.78.03-1.37-.04-2.72-.2-4.07-.06-.53-.2-1.06-.28-1.59-.02-.12.03-.24.05-.36.06-.01.13-.03.19-.04Z"
                  fill="#2b231d"
                />
                <path
                  d="M1455.77,102.43c-.95-3.92-2.76-7.4-4.41-10.98-.81-.16-1.41-.58-1.75-1.35-.42-.95-.54-1.94-.26-2.91.38-1.33,1.72-1.69,2.76-.8.53.45.81,1.04.87,1.71.06.73.05,1.47.07,2.46c1.53,3.44,3.4,7.02,4.48,11.04.41-.13.76-.21,1.09-.34.87-.36,1.77-.6,2.71-.69c1.15-.1,2.26.04,3.35.42.51.18,1.02.35,1.63.56.13-.81.26-1.59.38-2.36.33-2.08.77-4.13,1.43-6.14.34-1.02.64-2.06.92-3.11.08-.29.04-.62,0-.92-.09-1.08.14-2.1.64-3.05.61-1.16,2.09-1.38,3.01-.43.21.22.35.59.38.91.15,1.49-.73,2.98-2.23,3.76-1.38,3.96-2.5,8.02-2.81,12.34.23.19.47.39.71.58c1.52,1.25,2.65,2.82,3.56,4.52.49.91.73,1.96.99,2.97.49,1.87.62,3.8.81,5.72.03.33-.01.67-.02,1.06-.21.04-.39.07-.67.12-.11-.54-.2-1.04-.27-1.41-.27.08-.54.22-.8.21-1.36-.06-2.72-.09-4.07-.26-1.41-.18-2.81-.27-4.24-.28-1.73,0-3.45-.17-5.18-.26-.82-.04-1.64-.1-2.46-.1-1.7,0-3.41.03-5.11.04-.23,0-.46.02-.68-.02-.28-.05-.51-.08-.79.1-.22.14-.58.08-.81.1-.43-.3-.33-.67-.29-.99.32-3.25,1.57-6.11,3.52-8.73c1-1.34,2.16-2.48,3.53-3.51Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M1479.89,132.57c.14,3.75.29,7.51.43,11.26-.05.27-.12.54-.13.81-.02.37.03.74.01,1.11-.06,1.02-.14,2.03-.21,3.04-.05.71-.08,1.41-.15,2.12-.1.96-.23,1.91-.34,2.86s-.16,1.92-.32,2.86c-.41,2.37-.86,4.74-1.33,7.1-.4,2.03-.84,4.05-1.31,6.07-.38,1.66-.72,3.33-1.24,4.94-.6,1.86-1.3,3.7-2.43,5.33-.44.63-.85,1.28-1.29,1.9-.26.37-.52.77-.86,1.05-1.02.85-2.07,1.68-3.15,2.46-.79.57-1.7.89-2.69.99-.13.01-.25.11-.37.17-.97.04-1.93.07-2.9.11-1.44-.39-2.8-.75-4.19-1.03-1.53-.31-2.81-1.06-3.89-2.15-.68-.68-1.3-1.43-1.99-2.1-.73-.7-1.26-1.52-1.69-2.43-1.18-2.53-1.95-5.21-2.84-7.84-.85-2.52-1.59-5.09-2.13-7.7-.26-1.25-.49-2.5-.69-3.76-.14-.89-.19-1.8-.3-2.7-.02-.13-.11-.25-.17-.37-.13-3.53-.27-7.05-.4-10.58.05-.21.13-.43.13-.64c0-1.27-.09-2.54,0-3.82.14-1.86.11-3.73.15-5.6.02-1.02.04-2.04.06-3.06c0-.14,0-.28.02-.42.07-.67.14-1.35.22-2.02.14-1.21.26-2.42.42-3.62.1-.79.23-1.57.39-2.34.36-1.72.65-3.46,1.13-5.14.67-2.38,1.98-4.33,4.33-5.39c1.42-.64,2.84-1.29,4.3-1.84c1.06-.4,2.16-.65,3.31-.68.54-.02,1.08-.24,1.62-.38.11,0,.23,0,.34-.01.13.05.26.14.39.14.99.03,1.98.03,2.97.08.68.03,1.35.11,2.03.2c1.95.26,3.75,1.1,5.66,1.54.21.05.42.18.61.29.87.53,1.76,1.04,2.6,1.6.42.28.83.62,1.12,1.02.53.73.99,1.51,1.45,2.29.23.39.43.8.6,1.21.63,1.55,1.1,3.15,1.48,4.78.54,2.27.9,4.55.99,6.88.01.31.01.63.05.94.02.16.11.31.17.46Z"
                fill="#81c6b2"
              />
              <g>
                <path
                  d="M1476.46,133.65c-.94.12-1.37-.22-1.73-.76-.75-1.15-1.52-2.28-2.28-3.42-.11-.16-.24-.32-.32-.5-.64-1.28-1.55-2.35-2.56-3.35-.49-.49-.89-1.07-1.29-1.64-.88-1.24-1.7-2.52-2.78-3.62-.73-.74-1.3-1.61-1.83-2.51-.23-.38-.54-.72-.81-1.07-.14-.18-.28-.35-.4-.55.29-.56.57-.91.92-1s.77.08,1.07.39c.99,1.02,2.23,1.73,3.33,2.61.86.69,1.62,1.49,2.24,2.42.85,1.26,1.67,2.52,2.58,3.75.67.91,1.52,1.75,1.83,2.92.12.43.44.85.75,1.19.45.48.81,1.01,1.07,1.6.84.67.93,1.5,1.32,2.15.12.21.1.55.04.81-.07.36-.3.61-.72.57-.14-.01-.28,0-.43.01Z"
                  fill="#549e88"
                />
                <path
                  d="M1445.73,132.5c.27-.85.45-1.5.83-2.01.32-.42.59-.88.94-1.26.86-.93,1.44-2.01,2.04-3.1.37-.66.85-1.27,1.36-1.83c1.09-1.2,1.88-2.6,2.83-3.9.71-.97,1.59-1.8,2.64-2.46c1.07-.67,2.03-1.52,3.03-2.3.6-.47,1.26-.44,1.81.12.15.16.09.49-.15.75-.22.25-.44.49-.67.73-.54.57-.79,1.35-1.39,1.9-.35.32-.59.76-.91,1.11-.7.78-1.41,1.53-1.99,2.42-.46.7-1.05,1.32-1.58,1.97-.39.48-.71,1-1.24,1.38-.49.35-.87.86-1.25,1.35-.26.33-.41.74-.64,1.09-.42.63-.88,1.24-1.31,1.87-.51.73-1.06,1.45-1.52,2.21-.38.64-.84.95-1.59.73-.16-.05-.34,0-.51,0-.61-.01-.71-.11-.73-.76Z"
                  fill="#549e88"
                />
                <path
                  d="M1474.79,164.3c.04.88-.48,1.28-1.2,1.23-.93-.07-1.55-.41-1.86-1.35-.2-.6-.59-1.15-.92-1.71-.21-.35-.38-.76-.92-.75-.13,0-.28-.17-.41-.28-.64-.57-1.18-1.21-1.61-1.95-.46-.78-1.01-1.5-1.51-2.25-.23-.35-.39-.75-.64-1.08-.66-.91-1.38-1.78-2.03-2.71-.35-.5-.62-1.06-.87-1.62-.12-.27-.15-.61-.14-.91.01-.5.5-.91.96-.78.29.08.48.02.69-.17.2-.19.42-.15.61.03.21.19.47.37.59.61.26.54.71.88,1.1,1.29.43.45.84.92,1.25,1.38.09.1.15.25.26.33.71.55,1.18,1.29,1.66,2.03.06.09.17.17.21.27.34.98.96,1.78,1.59,2.59.48.62.89,1.3,1.27,1.98.61,1.11,1.18,2.24,1.76,3.36.1.2.16.41.18.48Z"
                  fill="#549e88"
                />
                <path
                  d="M1476.23,156.22c-.67.09-1.13-.21-1.56-.83-.81-1.15-1.44-2.42-2.22-3.58-.61-.91-1.05-1.93-1.81-2.74-.44-.47-.83-1-1.21-1.52-.63-.86-1.23-1.75-1.85-2.61-.66-.91-1.32-1.82-2.01-2.71-.34-.45-.74-.85-1.12-1.27-.76-1.05-.55-1.55.54-1.91.32-.1.66-.12.99-.2.28-.06.49.02.7.21.56.53,1.13,1.04,1.68,1.57.12.11.21.26.3.4.46.73.87,1.5,1.4,2.18c1.01,1.29,1.84,2.69,2.72,4.06s1.73,2.74,2.58,4.13c.59.96,1.14,1.93,1.71,2.89.1.17.19.35.27.53.32.78-.03,1.33-.86,1.38-.06,0-.11,0-.23,0Z"
                  fill="#549e88"
                />
                <path
                  d="M1449.62,165c-.3.06-.61.08-.88.2-.28.13-.43.01-.59-.16-.41-.44-.46-.86-.17-1.38.67-1.21,1.31-2.44,2.02-3.62.5-.85,1.02-1.7,1.74-2.39.22-.21.41-.48.54-.76.89-1.98,2.31-3.52,3.91-4.94.58-.52,1.16-1.06,1.63-1.71.43-.59.34-.52.95-.21.17.09.36.14.55.17.85.12,1.18.65.83,1.43-.27.59-.59,1.16-.96,1.69-.4.58-.9,1.09-1.33,1.65-.44.58-.86,1.19-1.27,1.79-.58.83-1.14,1.68-1.73,2.5-.36.5-.76.98-1.18,1.45-.35.39-.64.89-1.27.91-.29.38-.62.73-.87,1.13-.43.69-.8,1.41-1.24,2.09-.11.17-.41.21-.63.3-.02-.05-.03-.09-.05-.14Z"
                  fill="#549e88"
                />
                <path
                  d="M1462.4,128.47c.07-.69.27-.92.9-.98.17-.02.38.03.5-.05.6-.38,1.04,0,1.46.31.72.55,1.44,1.11,2.07,1.76.7.73,1.3,1.55,1.94,2.34.27.33.6.63.77,1c.5,1.08,1.57,1.66,2.24,2.63.62.9,1.24,1.81,1.86,2.72.63.93,1.27,1.86,1.89,2.81.34.52.68,1.04.93,1.6.12.28.07.67,0,.98-.12.46-.28.52-.76.47-.16-.02-.33-.06-.47,0-.55.21-.58.24-.89-.17-.44-.59-.88-1.18-1.25-1.81-.55-.95-1.27-1.78-1.93-2.65-.39-.52-.75-1.06-1.11-1.6-.58-.87-1.26-1.65-1.97-2.43-.72-.79-1.34-1.67-1.97-2.54-.64-.88-1.4-1.62-2.29-2.24-.55-.38-1.03-.86-1.5-1.35-.2-.2-.28-.52-.41-.79Z"
                  fill="#549e88"
                />
                <path
                  d="M1459.12,139.74c.02.77-.43,1.27-.96,1.71-.7.59-1.22,1.31-1.7,2.07-.09.14-.16.3-.27.43-.64.76-1.3,1.5-1.92,2.27-.41.5-.75,1.06-1.14,1.57-.4.52-.83,1-1.23,1.51-.3.38-.58.77-.85,1.16-.21.3-.39.62-.58.93-.31.5-.59,1.01-.92,1.5-.55.85-1.11,1.7-1.7,2.52-.27.37-.61.59-1.17.44-.47-.12-.94-.11-1.17-.66-.1-.23-.1-.4.02-.63.47-.96,1.09-1.82,1.68-2.71.56-.85,1.04-1.75,1.56-2.62.12-.19.27-.36.4-.54.14-.18.32-.34.41-.54.45-1.05,1.23-1.89,1.88-2.81.73-1.04,1.49-2.05,2.2-3.1.8-1.18,1.66-2.28,2.78-3.18.22-.18.44-.31.69-.21.37.14.7.27,1.12.12.21-.08.91.58.89.75Z"
                  fill="#549e88"
                />
                <path
                  d="M1446.12,142.83c-.05-.31.01-.63.29-.95.29-.33.52-.74.73-1.13.67-1.29,1.66-2.34,2.47-3.53.52-.77,1.04-1.54,1.63-2.26.37-.45.86-.81,1.3-1.21.08-.07.23-.11.27-.2.6-1.3,1.76-2.18,2.52-3.37.19-.3.53-.5.81-.73.79-.63,1.6-1.24,2.38-1.89.3-.25.58-.31.93-.14.22.11.42.16.71.09.42-.11.89.7.74,1.19-.13.42-.42.71-.78.98-.92.69-1.84,1.39-2.71,2.15-.42.36-.73.86-1.07,1.31-.37.49-.72,1.01-1.09,1.51-.08.11-.18.23-.29.32-1.32,1.1-2.31,2.49-3.29,3.88-.55.78-1.18,1.51-1.75,2.28-.37.5-.7,1.02-1.05,1.53-.2.28-.41.54-.62.8-.27.33-.53.7-1.02.26-.1-.09-.33-.04-.49-.03-.57.05-.57.05-.62-.45c0-.11,0-.23-.02-.41Z"
                  fill="#549e88"
                />
                <path
                  d="M1472.51,176.1c.1.43-.12.73-.43.96-.13.1-.36.11-.53.1-.13,0-.26-.14-.39-.16-1.22-.15-1.68-1.09-2.13-2.05-.28-.58-.57-1.15-.95-1.69-.44-.61-.8-1.29-1.1-1.97-.47-1.06-1.13-2.01-1.77-2.96-.71-1.06-1.36-2.15-2.07-3.2-.41-.61-.33-1.16,0-1.75.17-.3.39-.39.7-.34.25.04.51.15.74.1.57-.1.92.14,1.17.6.11.2.23.39.35.58.58.94,1.18,1.87,1.73,2.82.7,1.19,1.42,2.38,2.04,3.62.58,1.16,1.22,2.29,1.93,3.37.39.6.62,1.26.71,1.96Z"
                  fill="#549e88"
                />
                <path
                  d="M1449.7,175.94c.12-.31.21-.57.33-.82.45-1,1.11-1.88,1.65-2.84.57-1.01,1.09-2.04,1.68-3.03.61-1.01,1.28-1.99,1.92-2.98.33-.52.65-1.06.98-1.58.26-.4.51-.81.79-1.2.2-.28.44-.51.86-.31.15.07.39.02.57-.03.79-.19,1.41.38,1.2,1.17-.11.42-.35.82-.59,1.2-.37.6-.76,1.18-1.16,1.76-.56.81-1.17,1.59-1.7,2.42-.52.83-.97,1.7-1.46,2.56-.24.41-.5.8-.74,1.21-.31.53-.59,1.08-.9,1.61-.11.19-.27.36-.41.54-.12.16-.32.3-.34.47-.07.44-.31.54-.7.57-.27.02-.55.13-.79.26-.31.16-.54.13-.72-.17-.16-.26-.31-.52-.47-.79Z"
                  fill="#549e88"
                />
              </g>
              <g>
                <path
                  d="M1458.56,103.81c.69.81.76,1.2.21,2.11-.73,1.21-1.63,2.24-3.05,2.66-.29.09-.61.15-.91.14-.59-.01-.94-.41-.87-1.01.04-.32.17-.65.31-.95.63-1.32,1.71-2.2,2.94-2.91.46-.02.91-.03,1.36-.05Z"
                  fill="#ffece5"
                />
                <path
                  d="M1469.3,107.5c0,.77-.75,1.36-1.43,1.19-1.19-.3-2.27-.82-2.99-1.89-.24-.35-.51-.68-.72-1.04-.51-.89-.08-1.65.94-1.68.36,0,.77.02,1.06.19.81.45,1.64.89,2.15,1.73.23.38.54.72.79,1.09.11.15.16.34.19.41Z"
                  fill="#ffece5"
                />
              </g>
              <g>
                <path
                  d="M1458.17,213.89c-.22.69-.03,1.41-.64,1.86-.23.82-1.09.76-1.62,1.14-.19.14-1.04-.35-1.1-.63-.06-.31-.29-.61-.1-.97.09-.17.03-.43.03-.64.36-.6.38-1.1.61-1.51.24-.43.41-.44.9-.28.29.09.59.19.9.2.21,0,.43-.2.59.09.15.26.3.52.43.74Z"
                  fill="#ffece5"
                />
                <path
                  d="M1460.47,229.54c-.07.27-.06.6-.23.79-.35.41-.51.88-.57,1.37-.07.58-.6.56-.92.75-.23.13-.6-.06-.84-.39-.4-.56-.7-1.09-.41-1.79.05-.12.01-.28.02-.42.04-.58.15-.77.73-.83.44-.05.65-.33.87-.61.25-.31.48-.24.72-.06.39.28.59.68.62,1.18Z"
                  fill="#ffece5"
                />
                <path
                  d="M1457.34,196.98c0,.83-.32,1.57-.72,2.26-.1.17-.33.32-.59.2-.28-.13-.55-.1-.78.13s-.41.12-.55-.1c-.51-.81-.43-1.65-.11-2.49.09-.23.24-.45.39-.65.19-.27.41-.45.79-.29.15.06.37-.02.56-.06.7-.16,1.02.1,1.02.85c0,.06,0,.11,0,.17Z"
                  fill="#ffece5"
                />
                <path
                  d="M1464.92,205.72c.07-.51.09-.94.21-1.33.08-.28.31-.52.47-.78.23-.37.5-.02.76-.04.11,0,.23-.03.34,0c.21.05.43-.24.61,0c.22.31.61.51.56,1-.04.36.02.7-.2,1.05-.18.28-.15.68-.27,1.01-.08.22-.17.49-.53.42-.11-.02-.25.07-.37.13-.53.28-.92.15-1.18-.42-.16-.35-.27-.72-.39-1.02Z"
                  fill="#ffece5"
                />
                <path
                  d="M1458.78,222.42c.05.37.04.75-.31,1.05-.08.07-.13.19-.17.29-.08.24-.07.55-.23.7-.14.14-.46.06-.67.15-.75.31-1.7-.22-1.73-1.03-.01-.5.07-1.01.22-1.49.12-.41.44-.66.93-.75.54-.1,1.02.01,1.52.14.26.06.39.21.41.46.01.14.01.28.02.47Z"
                  fill="#ffece5"
                />
                <path
                  d="M1464.98,196.96c-.05-.77.43-1.3.84-1.86.06-.08.23-.11.36-.11.37-.01.73,0,1.1,0c.59,0,.92.26.89.86-.02.4-.26.78-.35,1.19-.1.45-.39.63-.8.74-.33.09-.57.33-.72.67-.07.17-.25.2-.43.07-.38-.28-.87-1.12-.89-1.55Z"
                  fill="#ffece5"
                />
                <path
                  d="M1464.89,222.46c.13-.45.23-.92.41-1.35.1-.24.28-.5.66-.33.09.04.25-.07.36-.12.2-.09.4-.21.61-.28.67-.23,1.29.33,1.15,1.03-.04.22-.11.44-.13.66-.05.78-.57,1.16-1.18,1.48-.4.23-.61.47-.98.27-.34-.18-.62-.37-.7-.78-.03-.19-.12-.37-.2-.58Z"
                  fill="#ffece5"
                />
                <path
                  d="M1457.13,206c-.12.57-.21,1.1-.34,1.61-.03.11-.19.2-.3.26-.33.15-.68.25-1,.42-.27.14-.48.18-.77,0-.4-.25-.54-.41-.51-.83.02-.27.02-.55-.02-.82-.1-.6.11-1.04.68-1.25.47-.18.95-.34,1.43-.49.11-.03.32.02.36.09.19.34.34.7.49,1.02Z"
                  fill="#ffece5"
                />
                <path
                  d="M1464.81,214.57c-.11-.55.17-.97.39-1.39.05-.1.2-.25.23-.23.6.32.84-.55,1.42-.41.84.2.95.37.93,1.26-.03,1.19-.83,1.7-1.72,2.17-.31.16-.58-.02-.75-.23-.28-.34-.63-.68-.49-1.17Z"
                  fill="#ffece5"
                />
                <path
                  d="M1466.52,236.53c-.14.22-.24.5-.44.66-.35.28-.77.47-1.13.74-.36.26-.68.19-1-.05-.29-.21-.33-.45-.23-.81.09-.34.02-.73.03-1.1c0-.65.16-.86.77-1.02.32-.09.66-.16.99-.19.13,0,.34.11.4.23.22.48.4.98.63,1.54Z"
                  fill="#ffece5"
                />
                <path
                  d="M1466.33,191.21c-.02-.37-.47-.42-.49-.84-.02-.39-.22-.79,0-1.15.23-.38.53-.71.82-1.05.66.02,1.01.11,1.37.13.52.03.85.27.73.77-.16.65-.27,1.4-.98,1.77-.72-.08-1.04.25-1.46.37Z"
                  fill="#ffece5"
                />
                <path
                  d="M1457.5,189.44c-.09.16-.2.42-.38.63-.36.43-.75.83-1.14,1.23-.21.22-.8.13-1.05-.14-.5-.54-.56-1.31-.15-1.94.12-.19.24-.38.38-.55.07-.08.19-.22.25-.2.44.15.87-.07,1.3-.02.4.04.79.54.79.99Z"
                  fill="#ffece5"
                />
                <path
                  d="M1464.01,229.74c-.03-.52.05-.88.64-.92.15,0,.29-.25.44-.37.45-.36.98-.31,1.37.11.45.48.55.88.21,1.44-.29.48-.48,1.1-1.16,1.25-.27.06-.49.05-.71-.14-.43-.38-.84-.77-.79-1.37Z"
                  fill="#ffece5"
                />
                <path
                  d="M1461.5,237.44c.02.53-.18.78-.86,1.05-.13.05-.25.13-.35.22-.17.14-.28.36-.57.22-.28-.14-.57-.27-.66-.61-.07-.24-.1-.49-.19-.73-.16-.44.1-.99.54-1.11.27-.07.55-.13.8-.24.62-.26,1.04-.05,1.16.6.03.17.07.33.12.6Z"
                  fill="#ffece5"
                />
              </g>
            </g>
            <g id="e0gYpSRcAlv2221" transform="translate(.000022 0)">
              <path
                d="M1455.66,200.38c-.11-.9-.21-1.8-.35-2.7-.18-1.23-.41-2.46-.57-3.7-.21-1.63-.38-3.27-.53-4.9-.15-1.75-.27-3.51-.38-5.27-.08-1.31-.08-2.62-.16-3.92-.06-1.05-.17-2.09-.28-3.14-.06-.62-.16-1.24-.25-1.85-.18-1.29-.27-2.6-.55-3.87-.41-1.89-.95-3.74-1.44-5.61-.31-1.18-.63-2.36-.95-3.54-.39-1.48-.77-2.97-1.16-4.45-.41-1.54-.83-3.07-1.25-4.61-.25-.91-.27-1.9-.92-2.67-.13-.38-.28-.58-.35-.8-.44-1.46-.9-2.92-1.28-4.41-.26-1.01-.39-2.05-.57-3.07-.3-.22.13-.36.07-.63-.04-.09-.13-.24-.19-.39-.22-.51-.6-.69-1.16-.64-.74.07-1.29.44-1.67,1.04-.58.91-1.14,1.83-1.67,2.78-.42.76-1,1.37-1.6,1.98-1.17,1.2-2.3,2.43-3.42,3.68-.76.84-1.33,1.84-2.27,2.52-1.03.76-2.03,1.56-2.88,2.52-.47.53-1,1.01-1.52,1.49-.98.91-1.99,1.77-3.15,2.46-3.15,1.89-6.21,3.9-8.57,6.8-.79.97-1.69,1.84-2.54,2.76-.4.44-.84.86-1.19,1.34-1.13,1.53-2.51,2.78-4.05,3.87-1.56,1.09-3.05,2.26-4.36,3.67-.6.64-1.27,1.23-1.98,1.73-.99.69-1.84,1.51-2.64,2.4-1.19,1.33-2.37,2.7-3.82,3.76-.66.49-1.43.85-2.05,1.38-1.23,1.05-2.38,2.19-3.57,3.28-.77.71-1.57,1.4-2.33,2.12-.62.59-1.26,1.16-1.78,1.82-1.22,1.53-2.42,3.08-3.39,4.79-.4.71-.85,1.41-1.21,2.15-.77,1.59-1.23,3.3-1.75,4.98-.29.91-.45,1.84-.4,2.76.17,3.57.03,7.17.72,10.7.33,1.66.75,3.29,1.95,4.56.7.74,1.51,1.37,2.3,2.02c1.12.92,2.29,1.77,3.39,2.71c1.18,1,2.49,1.78,3.92,2.37c2.49,1.03,5.16,1.34,7.76,1.93.76.17,1.46.42,2.15.78c1.72.89,3.43,1.8,5.17,2.63c1,.48,2.08.82,3.2.83c2.53.01,5.04-.24,7.5-.9c1.86-.5,3.77-.45,5.67-.31.68.05,1.35.28,2.02.28c1.7,0,3.43.03,5.09-.38c2.53-.62,4.88-1.69,7.04-3.15.75-.51,1.42-1.14,2.19-1.62c1.64-1.03,3.35-1.93,5.27-2.33.53-.11,1.08-.1,1.59-.28c1.32-.45,2.42-1.21,3.28-2.34c1.09-1.45,2.26-2.84,3.33-4.31.55-.75,1.1-1.56,1.4-2.43.54-1.61,1.01-3.27,1.29-4.95.29-1.76.44-3.55.45-5.33c0-2.1-.2-4.2-.34-6.3-.05-.71-.17-1.41-.26-2.11Z"
                fill="#f68a78"
              />
              <path
                d="M1445.9,222.07c.03-.34.13-.74,0-1-.26-.48-.14-.93-.1-1.39.04-.42.17-.84.14-1.26-.06-.83-.2-1.66-.3-2.5-.03-.3-.03-.6-.04-.9-.08-.28-.2-.56-.25-.86-.13-.8-.32-1.58-.33-2.41-.02-1.16-.27-2.31-.37-3.46-.03-.38,0-.81.15-1.15.34-.78.35-1.58.39-2.48-.38-.04-.71-.07-.99-.09-.14-.57-.43-1.17-.41-1.76.03-.76-.09-1.46-.27-2.17-.03-.13-.02-.27-.03-.41-.03-.61.08-1.26-.11-1.81-.26-.76-.37-1.53-.49-2.3-.11-.73-.28-1.45-.35-2.18-.08-.78-.06-1.57-.1-2.35-.01-.31-.07-.63-.11-1.01.41-.81.59-1.31.69-1.83.18-.97.41-1.93.44-2.92.02-.61.11-1.23.23-1.84.2-.99.5-1.96.5-2.99c0-.94-.12-1.93.43-2.8.24.34.48.68.71,1.03.07.11.14.26.14.39c0,.88.41,1.67.49,2.53.02.22.14.43.23.64.15.33.34.64.48.98.28.65.53,1.31.79,1.95.23.09.43.17.54.22-.01.31-.1.59-.01.77.45.97.92,1.93,1.78,2.48.15.35.25.62.37.89.42.89,1.11,1.63,1.42,2.6.17.55.54,1.05.85,1.55.56.94,1.19,1.84,1.68,2.81.24.48.4.99.74,1.42.12.15.23.35.24.54.05.48.29.83.58,1.09.02.46.04.85.05,1.24c0,.31.04.63-.03.93-.14.66-.03,1.23.38,1.7-.05-.65-.1-1.29-.14-1.94-.05-.71-.17-1.41-.26-2.11-.11-.9-.21-1.8-.35-2.7-.14-.46-.25-.73-.41-.99-.34-.56-.62-1.19-.94-1.77-.41-.74-.81-1.49-1.21-2.23-.17-.32-.4-.62-.53-.96-.46-1.23-1.33-2.14-1.91-2.71-.76-1.25-1.29-2.12-1.82-2.98-.04-.26-.05-.56-.14-.83-.12-.35-.32-.67-.45-1.01-.4-1.03-.83-2.04-1.14-3.1-.16-.54-.23-1.1-.61-1.55-.06-.07-.04-.21-.06-.32-.14-.65-.29-1.31-.43-1.92-.18-.12-.31-.21-.49-.32.28-1.47.56-2.9.82-4.34.11-.58.29-1.18.22-1.75-.08-.65.25-1.21.2-1.87-.06-.81.26-1.66.47-2.48.18-.69.22-1.36.18-2.07-.03-.69.15-1.39.24-2.09.04-.33.11-.66.14-.99.02-.19-.06-.4,0-.58.21-.71.12-1.36-.32-2.01-.12.77-.55,1.44-.34,2.26.19.76-.54,1.48-.17,2.28-.37.39-.2.91-.33,1.34-.24.78-.18,1.58-.51,2.37-.4.94-.43,2.03-.59,3.06-.07.44.01.92-.09,1.35-.25,1.04-.17,2.16-.78,3.12-.07.11-.02.28-.05.42-.14.83-.2,1.68-.44,2.48-.22.75-.44,1.49-.55,2.26-.13.84-.14,1.7-.33,2.52-.21.87-.26,1.72-.12,2.45-.14.4-.28.68-.33.97-.33,1.82-.63,3.65-.98,5.64-.29-.54-.53-.95-.73-1.38-.4-.87-.77-1.76-1.16-2.63-.24-.54-.46-1.09-.76-1.6-.18-.31-.5-.54-.81-.86c0-.09.05-.32-.03-.47-.46-.88-.86-1.81-1.47-2.58-1.02-1.3-1.53-2.79-2.01-4.32-.11-.34-.21-.67-.3-.95.02-.28.04-.53.05-.77.03-.79-.05-1.59.1-2.35.16-.85.11-1.67.02-2.51-.03-.31-.04-.63-.14-.92-.31-.86-.08-1.64.33-2.39.24-.44.52-.87.84-1.41.7-.12.56-1.05,1.06-1.51.51-.47.87-1.03.8-1.68.2-.32.37-.57.51-.84.19-.35.29-.77.54-1.05.43-.49.54-.98.18-1.54.19-.04.37-.03.46-.11.27-.24.55-.5.75-.79.34-.49.65-1.03.58-1.65-.05-.49.11-.85.42-1.2.16-.19.31-.41.38-.64.15-.48.24-.97.35-1.42.2-.18.42-.3.53-.49.23-.38.5-.78.58-1.21.1-.53.68-.66.79-1.16.07-.31.34-.57.45-.88.47-1.34,1.01-2.64,1.75-3.86-.11-.4-.23-.8-.34-1.21-.03-.11-.05-.22-.07-.33-.05.12-.1.24-.16.35-.41.83-.93,1.6-1.39,2.4-.09.17-.13.36-.19.55-.18.56-.3,1.14-.54,1.68-.33.74-.75,1.45-1.09,2.18-.1.21-.08.48-.11.72-.51.02-.89.21-1.03.79-.06.24-.24.44-.35.67-.1.2-.21.4-.24.62-.15.88-.26,1.77-.98,2.43-.1.09-.11.26-.19.38-.5.82-.77,1.79-1.41,2.52-.52.59-.56,1.38-.9,2.04-.65,1.29-1.3,2.56-2.38,3.57-.2.18-.31.47-.45.71-.36.63-.7,1.27-1.06,1.9-.2.36-.42.71-.67,1.14-.03,0-.19.02-.36.05l.02.48c-.42.04-.64.26-.79.66-.1.27-.35.49-.56.71-.17.18-.39.32-.56.5-.56.59-1.12,1.19-1.66,1.8-.63.72-1.25,1.46-1.85,2.2-.84,1.03-1.67,2.07-2.51,3.1-.14.17-.3.37-.5.46-.85.41-1.38,1.18-2,1.82-1.04,1.07-1.93,2.29-2.94,3.51-.02.15.5.27.18.63-.13-.11-.26-.21-.35-.29-.38.38-.74.76-1.11,1.12-.57.54-1.1,1.12-1.65,1.67-.37.37-1.09.43-.82,1.21l-.48.02c-.17.26-.3.51-.47.73-.37.49-.73,1-1.15,1.46-.42.45-.85.95-1.38,1.23-.95.51-1.97.9-2.93,1.43-.87.48-1.68,1.02-2.41,1.63-.21-.02-.38-.04-.35-.03-.73.51-1.29.96-1.91,1.31-.57.33-1.3.41-1.68,1.05-.05.08-.2.09-.3.14-.66.38-1.39.69-1.96,1.17-1.02.85-2.27,1.4-3.13,2.45-.86.72-1.61,1.21-1.94,2.03-.84.4-.99.53-1.49,1.18-.15.2-.32.39-.5.57-.72.72-1.46,1.41-2.15,2.14-.5.53-.93,1.12-1.39,1.68-.7.87-1.35,1.77-1.78,2.82-.06.15-.19.28-.3.41-.61.7-1.23,1.39-1.83,2.09-.11.13-.16.3-.23.46-.3.67-.36,1.44-.85,2.03-.07.08-.06.21-.1.32-.24.66-.45,1.33-.74,1.98-.32.72-.77,1.38-1.05,2.11-.18.48-.32.97-.46,1.46.19.29.39.56.63.82.08.08.16.16.24.23.26-.78.49-1.22.69-1.68.26-.6.2-1.34.85-1.77.12-.08.06-.41.08-.62.28-.29.49-.61.62-.97.28-.76.52-1.54.78-2.3.81-.96,1.17-1.9,1.88-2.66c1.09-1.18,2.04-2.51,2.43-4.02.35-.26.68-.41.87-.67.72-.99,1.75-1.71,2.36-2.8.08-.14.24-.23.36-.34.48-.43.97-.83,1.54-1.17.68-.42,1.18-1.12,1.77-1.68.9-.87,1.6-1.99,2.89-2.39.85-.56,1.51-.96,2.1-1.45.53-.44,1.27-.68,1.44-1.35.41-.05.77,0,1.04-.15.72-.38,1.39-.85,1.91-1.5.84-.56,1.49-.87,2.09-1.26.68-.45,1.3-.97,1.95-1.45.13-.1.31-.12.66-.25-.45.73-.82,1.26-1.13,1.83-.72,1.33-1.4,2.68-2.11,4.01-.14.27-.35.51-.53.76l.02.5c-.13.15-.31.27-.38.44-.29.77-.31,1.64-.87,2.31.11.62-.37,1.04-.55,1.55-.28.77-.89,1.39-.96,2.25-.25.84-.64,1.41-.88,2.03-.09.23-.2.5-.17.74.08.63-.21,1.16-.39,1.72-.23.71-.48,1.42-.74,2.12-.06.15-.16.31-.28.41-.43.35-.55.85-.67,1.34-.36,1.41-.71,2.82-1.07,4.23-.06.22-.14.45-.29.61-.76.86-.98,1.98-1.28,3.01-.29.98-.5,2.03-.77,3.02s-.66,1.96-.92,2.97c-.18.72-.39,1.44-.6,2.16-.05.19-.13.37-.19.55.5.1,1,.2,1.5.3.06-.21.12-.43.16-.65.21-1.08.49-2.14.9-3.17.15-.38.14-.81.18-1.09.68-1.3,1.02-2.59,1.26-3.86.18-.29.39-.53.5-.81.41-1.02.79-2.04,1.17-3.07.13-.34.21-.7.29-1.06.18-.74.21-1.52.56-2.22.29-.58.59-1.16.84-1.76.39-.95.8-1.91,1.1-2.89.16-.51.57-1.03.16-1.61.44-.39.67-.85.54-1.31.2-.28.44-.46.48-.68.16-.88.61-1.63,1-2.41.19-.38.31-.79.43-1.19.23-.77.24-1.6.72-2.3.17-.25.29-.55.41-.84.18-.41.3-.85.51-1.24.33-.59.72-1.14,1.07-1.72.12-.19.2-.4.29-.6.15-.32.25-.68.44-.97.39-.6.84-1.17,1.24-1.77.3-.46.47-1.07.88-1.38.36-.27.37-.68.66-.91.61-.49,1.05-1.07,1.25-1.84.04-.17.23-.31.37-.45.54-.54,1.1-1.06,1.64-1.6.53-.51,1.06-1.02,1.58-1.54s.81-1.22,1.42-1.66c.11-.08.17-.22.24-.32-.07-.17-.13-.31-.23-.54.63.1,1-.11,1.22-.63.08-.2.31-.33.46-.5.5-.57,1.01-1.14,1.5-1.72.34-.41.67-.81,1.13-1.12.55-.38,1.04-.87,1.49-1.37.49-.54.77-1.26,1.43-1.65.09-.05.13-.19.19-.28.23-.31.47-.62.7-.94.15-.2.35-.39.43-.62.13-.41.4-.67.72-.91.27-.2.63-.42.72-.7.26-.8.9-1.27,1.41-1.85.45-.51.96-.98,1.32-1.54.39-.61.69-1,1.38-1.28-.36.87-.21,1.64-.34,2.34-.07.38-.12.79-.07,1.17.1.72-.02,1.4-.22,2.08-.07.24-.08.49-.11.74-.02.17.03.36-.04.49-.29.57-.25,1.18-.3,1.79-.08.86-.19,1.72-.15,2.59c0,.18-.12.37-.19.57.18.26.22.49.14.84-.22,1.01-.29,2.04-.42,3.07-.12,1.01-.19,1.86-.4,2.67-.11.43-.37.79-.23,1.3.06.21-.15.52-.29.76-.2.35-.39.66-.34,1.11.1,1.06-.36,2.03-.56,3.05-.18.92-.52,1.81-.77,2.64.21.33.36.55.62.94-.36-.14-.52-.2-.7-.27-.2.31-.5.58-.54.88-.05.45-.35.77-.43,1.14-.1.43-.17.86-.35,1.28-.05.12-.09.28-.07.4.13.65-.15,1.27-.38,1.78-.4.89-1.06,1.66-1.61,2.48-.48.72-1.34,1.2-1.33,2.17-.89.4-1.07,1.18-1.23,1.93-1.28.65-2.06,1.66-2.45,2.97-.56.4-1.15.76-1.36,1.46-.03.09-.14.16-.21.25-.22.25-.44.49-.64.75-.31.4-.58.83-.92,1.2-.54.58-1.05,1.18-1.37,1.92-.09.19-.3.33-.44.5-.51.59-1.2.98-1.62,1.68-.44.74-1.02,1.39-1.59,2.05-.84.98-1.72,1.93-2.58,2.9-.13.15-.21.33-.33.49-.57.72-.73,1.71-1.49,2.32-.19.16-.25.5-.35.76-.08.21-.13.43-.21.64-.32.75-.65,1.49-.97,2.24-.04.1-.03.22-.04.33-.02.27-.03.54-.07.81-.12.85-.26,1.7-.39,2.55-.02.11-.03.22-.04.33.2.1.4.2.6.3.15.07.31.13.46.2.1-.52.19-1.04.26-1.56.17-1.35.48-2.66.97-3.93.17-.45.39-.88.62-1.3.27-.5.56-.98.85-1.46.13-.22.26-.44.4-.64.38-.53.78-1.04,1.16-1.57.21-.29.41-.56.7-.8.57-.49,1.21-.96,1.32-1.72.29-.28.6-.47.75-.74.16-.29.16-.66.23-1.03.81-.29.78-.31,1.32-1.15.22-.35.54-.71.9-.87.64-.28,1.14-.78,1.39-1.3.33-.7.77-1.25,1.24-1.82.65-.79,1.05-1.77,1.84-2.48.34-.31.47-.84.79-1.44.97-.41,1.25-1.69,2.09-2.48.11-.1.11-.31.17-.48.04-.17.1-.34.15-.51.28-.04.32-.26.36-.49.3-.05.4.07.42.1-.24.52-.43.95-.64,1.37-.37.76-.71,1.53-1.12,2.26-.5.89-.99,1.81-1.12,2.81-.1.76-.46,1.37-.73,2.04-.27.65-.64,1.25-.93,1.89-.17.38-.3.78-.42,1.18-.41,1.27-1.12,2.48-.89,3.9-.4.07-.41.38-.44.69-.01.19-.05.38-.1.56-.16.68-.45,1.34-.48,2.02-.06,1.29-.44,2.53-.46,3.83-.01.58-.07,1.11.24,1.59-.08.18-.14.32-.22.5.4-.03.72-.06,1.13-.1c0-.48-.03-.92,0-1.35.03-.48.04-.97.17-1.42.31-1.11.3-2.23.28-3.28.17-.38.35-.7.44-1.04.13-.49.09-1.04.32-1.47.42-.81.17-1.84.91-2.53.09-1.11.59-1.82.84-2.61.91-.77.9-1.96,1.35-2.94.2-.44.18-.99.24-1.39.33-.45.64-.82.89-1.22.26-.43.39-.96.7-1.34.82-1,1.02-2.26,1.43-3.41.3-.84.43-1.72,1-2.47.3-.4.29-.93.09-1.46.74-.2,1.03-.72,1.02-1.46c0-.14-.02-.3.04-.42.55-1.12.75-2.33.93-3.56.52-.49.89-1.02.34-1.77.95-.79,1.31-1.77,1.09-2.84.19-.28.4-.47.45-.7.16-.74.26-1.48.38-2.23.14-.85.2-1.74.46-2.55.19-.58.37-1.11.32-1.71.21-.49.42-.99.47-1.5.04-.34,0-.65.17-.98.1-.2.06-.49.06-.75c0-.37-.03-.73-.03-1.1c0-.65.04-1.29.05-1.94c0-.42-.16-.89-.02-1.25.24-.63.19-1.22,0-1.83.13-.29.24-.56.42-.97.08.29.12.44.15.6.11.55.14,1.14.35,1.65.32.77.77,1.48,1.16,2.22.5.94,1,1.89,1.5,2.84.52.97,1.02,1.94,1.56,2.89.5.89,1,1.77,1.23,2.77.07.33.22.64.33.96.32.94.69,1.86.93,2.81.32,1.26.55,2.54.81,3.81.11.55.14,1.13.31,1.67.13.43.16.83-.06,1.22.17.26.33.49.48.72-.07.39-.08.76.03,1.09.12.33.18.62.13.98-.06.47-.11,1.01.07,1.42.61,1.39.24,2.59-.56,3.73-.85,1.2-1.76,2.35-2.58,3.57-.94,1.41-1.8,2.87-2.57,4.37-.23.44-.47.89-.73,1.28-.34.5-.54,1.05-.82,1.57-.25.47-.25,1.02-.49,1.48-.76,1.45-1.48,2.91-1.58,4.57-.16.16-.31.31-.71.71.29.1.5.18.79.28-.89.19-1.16.79-1.22,1.57-.03.36-.09.72-.18,1.08-.11.46-.17.92-.39,1.37-.23.49-.34,1.09-.33,1.63.01.63.19,1.25-.06,1.88-.08.2.04.46.07.71.96-.08.45-.97.9-1.24-.13-.24-.23-.42-.34-.63.18-.06.3-.1.42-.15.27-.55.54-1.12.56-1.71.03-.62.54-1.23.04-1.84.7-.47.8-1.26,1.08-1.92.45-1.06.78-2.17,1.2-3.25.19-.5.48-.96.69-1.45.34-.81.64-1.63.99-2.44.15-.33.47-.6.57-.93.27-.95.87-1.7,1.39-2.5.32-.5.64-.99.97-1.49.73-1.11,1.19-2.38,2.03-3.43.46-.58.89-1.16,1.12-2.01.24.44.41.77.55,1.04-.22,1.1.03,2.06.31,2.91.02.61-.1,1.19.1,1.61.27.56.34,1.06.21,1.62.12.45.19.91.23,1.37.06.84-.1,1.7.2,2.53-.14.11-.24.1-.32.09-.04.5-.12.94-.11,1.38.02,1.04.09,2.09.12,3.13c0,.25-.03.5-.08.75-.04.24-.18.47-.18.71-.01.46-.05.91-.08,1.36.25-.07.5-.13.76-.19.14-.03.28-.05.42-.07.01-.39.04-.77.09-1.17.23-1.53.32-3.08.46-4.63Zm-56.18-13.21l-.33-.28c.25-.05.35.06.44.17l-.11.11Z"
                fill="#2b231d"
              />
              <path
                d="M1419.12,233.16c-.31-.02-.55-.04-.79-.05-.05.44-.08.89-.17,1.32-.06.31-.03.6.06.86.27-.06.55-.11.82-.14.27-.59.15-1.27.07-1.99Z"
                fill="#2b231d"
              />
              <path
                d="M1412.88,171.44l.03.91c.6.29,1.09.1,1.35-.39.32-.59.5-1.26.75-1.89-.27-.38.19-.61.19-.93.31-.32.74-.59.87-.97.22-.61.42-1.21.76-1.78.48-.82.88-1.68,1.3-2.53.15-.31.31-.62.46-.93-.69.64-1.34,1.32-1.95,2.06-.51.62-1.07,1.21-1.62,1.79-.56.98-1,1.93-1.2,3.04-.27.46-.59,1.01-.95,1.62Z"
                fill="#2b231d"
              />
              <path
                d="M1380.28,210.08c.61-.85,1.34-1.64,1.8-2.56.63-1.27,1.7-2.11,2.61-3.12.39-.44.91-.81,1.17-1.31.3-.59.78-.99,1.25-1.33.45-.32.75-.66.82-1.03.63-.56,1.16-1,1.66-1.49.77-.75,1.49-1.54,2.36-2.17.25-.18.56-.27.82-.44c1.1-.73,2.18-1.5,3.29-2.21.37-.24.83-.34,1.21-.56c1.45-.84,2.88-1.7,4.33-2.54c1.05-.61,2.11-1.2,3.15-1.81.24-.14.47-.32.68-.51.37-.34.69-.74,1.09-1.06.55-.44,1.09-.93,1.72-1.21.54-.24.91-.53,1.01-1.02.72-.44,1.39-.8,2.01-1.24.77-.55,1.48-1.16,2.22-1.75.73-.56,1.46-1.12,2.19-1.68-.1-.39-.17-.71-.24-1c.43-.06.8-.02,1.06-.17.39-.21.76-.51,1.03-.86.58-.75,1.44-1.27,1.82-2.2.09-.23.49-.33.74-.5.2-.14.42-.27.59-.44.32-.34.55-.81.93-1.06c1.24-.84,1.86-2.17,2.64-3.36.41-.62.83-1.22,1.34-1.73.97-.98,1.83-2,2.16-3.23.31-.31.63-.49.72-.74.32-.87.83-1.6,1.41-2.3.43-.52.87-1.04,1.26-1.59s.56-1.24,1.15-1.67c.15-.11.13-.45.17-.6.82-.76,1.48-1.6,1.87-2.55.4-.95,1.32-1.46,1.69-2.39.36-.26.59-.41.78-.61.75-.81,1.43-1.66,2.09-2.54.54-.72,1.06-1.37,1.12-2.26.84-.21,1.29-.82,1.76-1.41.21-.26.41-.54.66-.75.83-.69,1.29-1.6,1.69-2.51.21-.18.4-.33.73-.6-.34-.08-.56-.21-.67-.15-.34.18-.69.39-.94.67-.83.93-1.6,1.9-2.41,2.84-.35.4-.75.75-1.09,1.09.04.23.06.37.08.5-.69.71-1.66.97-1.62,2.01-.59.36-1.06.77-1.43,1.34-.33.52-1.01.83-.92,1.63-.86.15-1.19.87-1.74,1.41.19.26.33.44.57.78-.39-.14-.61-.22-.8-.29-1.03,1.44-2.04,2.83-3.01,4.24-.74,1.07-1.41,2.18-2.14,3.26-.72,1.07-1.47,2.12-2.22,3.17-.94,1.3-2.21,2.35-2.85,3.87-.1.23-.21.54-.4.62-.55.25-.55.72-.56,1.16-1.1.54-1.83,1.45-2.61,2.29-.75.81-1.43,1.7-2.26,2.41-.55.48-1.15.91-1.58,1.49-.35.48-.7.95-1.19,1.3-.77.56-1.53,1.15-2.27,1.75-.24.19-.42.45-.6.7-.16.22-.28.46-.46.77-.22-.23-.39-.41-.6-.63.68-.38.68-.91.42-1.49.41-.28.58-.73.55-1.16-.04-.75.23-1.4.5-2.05.26-.64.5-1.29.51-2c0-.19.04-.39.09-.58.17-.52.37-1.02.52-1.54.05-.16,0-.36-.01-.56-.45.09-.81.16-1.22.24-.01.51-.02.98-.03,1.46-.5,1.08-.91,2.17-.68,3.52-.29.55-.84,1.17-.47,1.96-.26.54-.49,1.03-.67,1.41.16.56.3,1,.43,1.47-.83.35-1.44.83-1.78,1.59-.27.07-.52.13-.8.2-.28.54-.86.71-1.36,1.01-.65.39-1.21.92-1.79,1.41-.17.14-.26.37-.37.55-.23.07-.51.11-.74.24-.51.3-1,.62-1.47.99-.9.7-1.97,1.09-2.97,1.6-.48.24-.89.57-1.36.81-.75.39-1.48.82-2.21,1.24-.65.38-1.4.61-1.85,1.29-.05.08-.2.11-.31.14-1.05.33-1.78,1.16-2.65,1.77-.15.1-.23.31-.35.46-.29.07-.46.04-.62.01-.81.76-1.68,1.45-2.4,2.27-.6.68-1.26,1.29-1.87,1.95-.74.8-1.69,1.46-1.98,2.64-.73-.01-.82.6-1.05,1.03-.79.43-1.51.88-1.75,1.79-.8.89-1.24,1.7-1.56,2.51-.2.96-.18,1.74-.16,2.52.31-.41.44-.64.59-.84Zm33.19-28c.11.25.06.44.02.62-.1-.03-.19-.05-.36-.1.13-.21.23-.36.34-.52Zm-5.32,3.68c.12,0,.13.27.13.27-.12,0-.13-.27-.13-.27Z"
                fill="#2b231d"
              />
              <path
                d="M1385.08,209.06c.14-.74.4-1.48.41-2.23.02-1.2.32-2.3.86-3.34.59-1.15,2.36-1.99,3.61-1.74.48.1.9.33,1.18.77.53.85.92,1.74.96,2.78.05,1.27.25,2.54.27,3.82.02,1.58-.52,3.03-1.44,4.28-.47.64-1.17,1.08-1.97,1.26-1.16.27-2.76-.5-3.19-1.73-.19-.56-.41-1.11-.61-1.66-.03-.74-.06-1.48-.09-2.22Z"
                fill="#2b231d"
              />
              <path
                d="M1405.33,229.83c-.34.01-.69,0-1.02.05-1.68.27-3.06-.41-4.36-1.34-1.59-1.13-2.54-2.74-3.2-4.52-.95-2.55-1.42-5.21-1.28-7.92.1-1.88.38-3.77.75-5.62.21-1.04.73-2.02,1.2-2.99.43-.89,1.16-1.53,2.06-1.97c1.25-.61,2.51-1.21,3.75-1.84c1.25-.64,2.63-.88,3.96-1.25.21-.06.46-.06.68-.01c1.95.43,3.73,1.16,5.06,2.75.37.45.61.94.82,1.47.52,1.32,1.27,2.55,1.53,3.96.47,2.61.77,5.22-.03,7.83-.58,1.9-.88,3.86-1.21,5.82-.19,1.13-.67,2.16-1.23,3.16-.41.73-1.02,1.22-1.8,1.48-1.37.47-2.76.86-4.22.89-.48.01-.97.04-1.45.05v.02Z"
                fill="#2b231d"
              />
              <path
                d="M1436.97,222.74c.07,1.3-.11,2.56-.41,3.81-.23.94-.64,1.73-1.43,2.35-.54.41-.98.94-1.47,1.42-.7.68-1.58,1.04-2.5,1.2-1.95.34-3.86.19-5.6-.87-.83-.5-1.66-1-2.46-1.53-.82-.54-1.47-1.25-1.83-2.19-.6-1.54-1.23-3.07-1.16-4.76.03-.7.1-1.42.29-2.09.57-2.02.65-4.08.72-6.15.04-1.3.21-2.6.36-3.89.08-.63.38-1.18.75-1.7.38-.53.69-1.1,1.03-1.66.34-.55.69-1.1,1.04-1.65.41-.67,1.09-.93,1.79-1.03.78-.11,1.58-.12,2.38-.1.29,0,.62.15.84.34c2.01,1.72,3.57,3.77,4.76,6.15c1.31,2.61,1.95,5.38,2.36,8.22.2,1.37.37,2.75.55,4.13Z"
                fill="#2b231d"
              />
              <path
                d="M1451.99,216.51c0,.26.03.51.03.77-.02.77-.27,1.44-.93,1.91-1.11.79-2.2,1.59-3.18,2.56-.85.84-2.76.83-3.73-.01-1.49-1.28-2.95-2.58-3.72-4.48-.41-1-.95-1.93-1.13-3.02-.13-.8-.2-1.57-.03-2.36.22-1,.42-2,.61-3c.19-1.02.53-1.97,1.12-2.83.86-1.24,1.97-2.08,3.55-2.13.66-.02,1.31-.09,1.91.25.17.1.37.16.51.3.99.98,1.99,1.95,2.93,2.97.75.82,1.07,1.83,1.18,2.95.12,1.21.35,2.41.54,3.61.13.84.27,1.68.41,2.51h-.07Z"
                fill="#2b231d"
              />
              <path
                d="M1406.29,227.41c-1.28.16-2.72-.52-3.94-1.59-.75-.66-1.31-1.56-1.88-2.41-1.37-2.04-2.07-4.37-2.48-6.75-.36-2.11-.34-4.25.71-6.24.36-.68.65-1.39.95-2.1.61-1.41,1.62-2.38,3.09-2.86c1.05-.34,2.1-.7,3.18-.96.77-.19,1.55-.12,2.33.16.93.34,1.68.93,2.46,1.5.15.12.28.28.39.45.41.62.81,1.23,1.2,1.86.53.88.54,1.86.41,2.82-.3,2.22-.71,4.42-.99,6.64-.13,1.06-.1,2.15-.1,3.23.01,1.65-.51,3.11-1.4,4.48-.83,1.28-2.07,1.68-3.93,1.78Z"
                fill="#81c6b2"
              />
              <path
                d="M1426.9,206.45c1.01.1,1.6.63,2.16,1.27c1.11,1.24,1.76,2.7,2.18,4.28.3,1.13.71,2.19,1.35,3.2.7,1.11,1.06,2.38,1.32,3.66.14.72.33,1.44.4,2.17.06.67,0,1.36-.07,2.03-.17,1.38-.45,2.74-1.19,3.96-.52.86-1.29,1.54-2.17,1.84-1.18.41-2.43.38-3.6-.32-1.54-.93-2.34-2.43-3.16-3.92-.52-.94-.71-1.97-.69-3.04.01-.59.09-1.18.12-1.78.04-.59.07-1.19.08-1.78c0-1.93,0-3.85.55-5.73.21-.7.26-1.45.35-2.18.15-1.23.79-2.23,1.55-3.16.21-.26.61-.37.83-.5Z"
                fill="#81c6b2"
              />
              <path
                d="M1441.33,212.39c0-1.48.11-2.94.72-4.32.07-.16.12-.33.23-.46c1.08-1.37,1.76-1.77,3.38-.75c1.7,1.07,2.78,2.56,3,4.61.04.36-.02.73-.01,1.1.02.76-.02,1.53.1,2.28.19,1.2,0,2.25-.83,3.16-.17.19-.36.36-.52.56-.25.31-.57.41-.96.46-1.96.27-2.97-.61-3.92-2.24-.77-1.33-1.17-2.83-1.18-4.4Z"
                fill="#81c6b2"
              />
              <path
                d="M1390.86,206.97c-.18.94-.35,1.88-.55,2.82-.11.53-.28,1.04-.38,1.57-.11.56-.43.98-.82,1.36-.53.5-1.25.45-1.7-.11-.59-.75-1.02-1.57-.99-2.56c0-.31-.02-.62-.03-.93q-.1-2.44.88-4.66c.21-.47.44-.96,1.05-.99.69-.03,1.3.23,1.66.84.48.81.83,1.68.89,2.68Z"
                fill="#81c6b2"
              />
              <path
                d="M1450.19,125.85c-.18-1.03-.31-2.08-.61-3.08-.41-1.35-.98-2.66-1.44-3.89c0-.65.01-1.2.02-1.77.21-.09.41-.17.7-.29-.27-.46-.59-.32-.88-.29-.65.07-1.29.16-1.94.2-.36.02-.73-.1-1.1-.11-1.63-.02-3.21.32-4.8.6-.47.08-.95.16-1.41.26-1.02.22-2.03.54-3.06.65-.9.1-1.79.23-2.68.43-.8.18-1.61.36-2.42.46-1.18.14-2.37.2-3.56.32-1.35.15-2.67.54-4.04.5-1.45.29-2.82.47-4.21.49-.26,0-.52,0-.77.05-1.33.28-2.65.59-4.02.67-1.5.09-2.98.32-4.47.48-.79.09-1.59.12-2.36.28-1.65.36-3.31.47-4.99.51-.28,0-.57.03-.85.08-1.59.31-3.16.66-4.79.65-.45,0-.91.05-1.36.11-.84.11-1.68.24-2.52.37-.73.11-1.45.23-2.18.35-1.06.18-2.12.36-3.18.54-.81.14-1.62.25-2.42.41-1.22.25-2.37.75-3.63.89-1.09.12-2.18.32-3.23.7-1.04.38-2.11.67-3.17.96-.6.17-1.23.22-1.82.42-1.7.56-3.38,1.16-5.12,1.59-1.82.44-3.6,1.03-5.4,1.55-2.64.76-5.28,1.55-7.93,2.28-1.56.43-3.14.76-4.7,1.18-1.07.28-2.1.73-3.18.93-1.04.19-2.05.46-3.02.86-1.18.49-2.36.96-3.63,1.2-.36.07-.7.22-1.04.37-1.2.51-2.37,1.11-3.61,1.52-1.68.56-3.27,1.28-4.82,2.14-1.39.77-2.86,1.41-4.24,2.19-1.03.58-2,1.28-2.98,1.96-.54.37-1.02.81-1.55,1.19-.83.59-1.7,1.14-2.53,1.74-1.14.82-2.16,1.8-2.95,2.93-1.11,1.61-2.07,3.32-2.2,5.37-.05.77-.09,1.52.08,2.28.26,1.13.46,2.28.72,3.41.27,1.19.43,2.4,1,3.51.34.66.6,1.35.95,2c.61,1.12,1.1,2.31,1.95,3.29.84.97,1.62,1.98,2.17,3.15.06.13.16.24.25.35c1.07,1.32,2.05,2.73,3.25,3.93c1.64,1.65,3.45,3.13,5.19,4.68.42.37.88.72,1.34,1.05c1.43,1.02,2.87,2.03,4.31,3.03c2.93,2.04,5.88,4.06,8.8,6.12c1.49,1.05,3.03,2.01,4.7,2.75c1.61.71,3.21,1.47,4.88,1.99c2.25.7,4.54,1.26,6.88,1.59c1.8.26,3.6.49,5.42.34c1.53-.13,3.06-.22,4.58-.36.62-.06,1.23-.18,1.83-.33c1.4-.36,2.78-.78,4.18-1.16.93-.25,1.88-.43,2.8-.71.7-.22,1.36-.58,2.05-.82c1.18-.41,2.41-.7,3.55-1.2c1.9-.83,3.75-1.77,5.6-2.69c2.87-1.42,5.3-3.51,8.01-5.17c1.51-.93,2.68-2.29,3.88-3.55c1.32-1.38,2.74-2.65,4.19-3.86c1.62-1.35,3.01-2.92,4.59-4.31c1.13-.99,2.22-2.03,3.4-2.95c1.68-1.31,3.24-2.75,4.75-4.25.91-.9,1.83-1.78,2.77-2.64c1.18-1.07,2.4-2.08,3.57-3.15.67-.61,1.36-1.22,1.91-1.93c1.22-1.58,2.65-2.96,4.12-4.29c1.01-.92,2.03-1.82,2.97-2.8c1.06-1.11,2.03-2.3,3.05-3.44c1.23-1.37,2.68-2.52,3.85-3.95.68-.83,1.55-1.5,2.26-2.31.9-1.02,1.73-2.1,2.56-3.17.38-.49.64-1.08,1.04-1.56c1.15-1.38,2.17-2.83,2.91-4.48.69-1.53.83-3.11.57-4.73-.25-1.54-.52-3.07-.79-4.6Z"
                fill="#ffc7b5"
              />
              <path
                d="M1333.11,146.98c.29.31.52.68.79,1c.58.7,1.1,1.48,1.78,2.06c1.21,1.01,2.24,2.18,3.28,3.35.74.83,1.06,1.81.82,2.91-.35,1.57-1.1,3.01-1.98,4.31-.82,1.2-1.59,2.43-2.25,3.71-.44.85-.83,1.75-1.08,2.67-.36,1.3.47,2.56,1.79,2.81.64.12,1.29.14,1.78.2.7-.1,1.24-.14,1.77-.25.55-.11,1.1-.27,1.64-.44c2.32-.74,4.42-1.92,6.49-3.18c1.16-.71,2.41-1.26,3.44-2.2c1.99-1.84,3.7-3.84,4.36-6.56.09-.36.26-.7.33-1.06.11-.52.27-1.07.21-1.59-.1-.95-.31-1.9-.54-2.83-.51-2.04-1.53-3.86-2.6-5.63-1.16-1.91-2.69-3.51-4.66-4.65-.71-.41-1.41-.85-2.08-1.33-.8-.57-1.42-1.28-1.82-2.2-.28-.63-.63-1.24-.99-1.83-1.15.47-2.31.93-3.54,1.16-.36.07-.7.22-1.04.37-1.2.51-2.37,1.11-3.61,1.52-1.68.56-3.27,1.28-4.82,2.14-.52.29-1.05.55-1.58.82.3.6.68,1.16,1.18,1.67c1,1.01,1.98,2.03,2.96,3.06Z"
                fill="#2b231d"
              />
              <path
                d="M1359.59,198.77c.07-.96.26-1.91.45-2.85.38-1.89.94-3.74.91-5.69-.03-1.79.03-3.59-.13-5.36-.16-1.74-.47-3.48-.86-5.19-.36-1.6-.89-3.16-1.39-4.72-.23-.73-.73-1.27-1.43-1.62-.36-.18-.69-.41-1.05-.56-1.61-.68-3.25-.85-4.85-.06-2.91,1.44-5.97,2.48-9.07,3.4-.94.28-1.93.43-2.91.55-1.78.22-3.52.11-5.09-.9-.65-.41-1.3-.81-1.96-1.2-.74-.43-1.25-1.06-1.67-1.78-.5-.85-.71-1.79-.81-2.75-.05-.44-.15-.83-.46-1.16-.93-.98-1.86-1.3-3.17-.37-.78.56-1.5,1.21-2.2,1.88-1.33,1.27-2.03,2.87-2.53,4.59c1.01,1.26,1.95,2.6,3.09,3.74c1.64,1.65,3.45,3.13,5.19,4.68.42.37.88.72,1.34,1.05c1.43,1.02,2.87,2.03,4.31,3.03c2.93,2.04,5.88,4.06,8.8,6.12c1.49,1.05,3.03,2.01,4.7,2.75c1.61.71,3.21,1.47,4.88,1.99c1.96.61,3.95,1.1,5.98,1.44-.05-.34-.09-.68-.06-1.01Z"
                fill="#2b231d"
              />
              <path
                d="M1320.42,170.74c1.3-1.85,3.01-3.22,4.94-4.35.32-.19.64-.37.94-.58c1.28-.89,2.54-1.81,3.83-2.69c1.09-.74,2-1.68,2.89-2.63.4-.43.73-.95,1-1.48.53-1.04.55-2.14.13-3.21-.29-.74-.73-1.41-1.08-2.12-.49-1.01-1.36-1.48-2.4-1.73-.17-.04-.33-.07-.5-.09-1.32-.1-2.25-.88-3.1-1.78-1.02-1.07-1.99-2.18-2.79-3.43-.29-.44-.62-.78-.98-1.04-.52.36-1,.79-1.52,1.16-.83.59-1.7,1.14-2.53,1.74-1.14.82-2.16,1.8-2.95,2.93-1.11,1.61-2.07,3.32-2.2,5.37-.05.77-.09,1.52.08,2.28.26,1.13.46,2.28.72,3.41.27,1.19.43,2.4,1,3.51.34.66.6,1.35.95,2c.61,1.12,1.1,2.31,1.95,3.29.21.24.41.48.6.72.12-.19.26-.38.41-.57.19-.24.43-.46.61-.71Z"
                fill="#2b231d"
              />
              <path
                d="M1351.22,136.16c1.16.82,2.31,1.65,3.5,2.43c2.05,1.35,3.51,3.2,4.6,5.37c1.04,2.09,1.83,4.28,2.62,6.47.45,1.24,1.15,2.27,2.11,3.15.31.29.63.58.94.87.74.7,1.6,1.19,2.57,1.46c1.86.52,3.72,1.04,5.59,1.51.93.24,1.89.37,2.86.31c1.11-.07,2.22-.12,3.33-.15.36,0,.76.03,1.07.18.69.33,1.36.72,2,1.14c2.63,1.72,5.34,2.04,8.21.58c1.06-.54,2.16-1.05,3.3-1.36c1.55-.41,2.91-1.11,4.14-2.1c1.53-1.23,3.01-2.5,4-4.26.95-1.68,1.57-3.48,1.93-5.35.34-1.75.43-3.54.69-5.3.21-1.43.46-2.85,1.16-4.16c1.3-2.42,3.13-4.39,5.23-6.11c1.61-1.31,2.98-2.8,3.9-4.67.39-.8.65-1.64.64-2.54c0-.92-.1-1.82-.24-2.72-.46.07-.92.13-1.39.16-1.5.09-2.98.32-4.47.48-.79.09-1.59.12-2.36.28-1.65.36-3.31.47-4.99.51-.28,0-.57.03-.85.08-.41.08-.82.16-1.22.24-.06.34-.11.68-.16,1.03-.15,1.09-.16,2.22-.03,3.31.19,1.63.62,3.22.88,4.84.27,1.69.02,3.22-.77,4.69-.54,1.01-.93,2.06-1.25,3.16-.2.7-.46,1.42-.85,2.03-.71,1.09-1.72,1.78-3.11,1.78-.92,0-1.64-.41-2.3-.98-.47-.41-.85-.92-1.32-1.33-.7-.61-1.21-1.35-1.59-2.19-.28-.62-.57-1.24-.83-1.87-.46-1.15-.75-2.35-.55-3.58.36-2.17.55-4.34.35-6.52-.08-.92-.24-1.83-.43-2.73-.28.05-.56.09-.84.14-.81.14-1.62.25-2.42.41-1.22.25-2.37.75-3.63.89-1.09.12-2.18.32-3.23.7-1.04.38-2.11.67-3.17.96-.22.81-.16,1.57,0,2.32.35,1.59.84,3.17,1.88,4.43c1.26,1.52,2.42,3.13,4.06,4.34c1.53,1.12,2.89,2.48,4.28,3.77.73.68,1.33,1.48,2.04,2.17.5.49.89,1.03,1.17,1.66.25.57.51,1.15.68,1.74.27.96.43,1.94.16,2.94-.22.85-.74,1.27-1.63,1.35-1.23.11-2.43-.18-3.63-.31-1.41-.16-2.81-.24-4.23.04-1.16.23-2.34.46-3.55.19-1.24-.28-2.53-.4-3.68-1.01-1.93-1.03-3.51-2.5-4.94-4.13-1.56-1.78-2.52-3.91-3.3-6.12-.25-.71-.31-1.49-.43-2.24-.07-.42-.06-.85-.1-1.27-.15-1.38-.34-2.76-.44-4.15-.05-.77-.17-1.52-.33-2.27-.12.04-.25.07-.37.11-2.64.76-5.28,1.55-7.93,2.28-1.55.43-3.12.76-4.67,1.17.24.69.69,1.27,1.34,1.74Z"
                fill="#2b231d"
              />
              <path
                d="M1393.68,130.32c.29.23.72.37,1.09.38.82.02,1.35-.62,1.38-1.63.03-1.36-.09-2.72-.4-4.06-.14-.62-.31-1.22-.47-1.83-.96.13-1.8.26-2.64.39-.43.07-.86.14-1.29.21-.06.75-.07,1.51-.01,2.26.12,1.73.97,3.2,2.35,4.3Z"
                fill="#2b231d"
              />
              <path
                d="M1366.96,132.44c.61,2.64,1.47,5.23,2.39,7.79.78,2.17,2.14,4.02,4.13,5.27c1.3.81,2.63,1.57,3.84,2.52.32.25.75.43,1.15.52.91.2,1.34-.21,1.3-1.14c0-.2-.02-.4-.07-.59-.61-2.54-1.63-4.89-3.28-6.95-.37-.47-.7-.96-1.05-1.45-.84-1.18-1.66-2.36-2.88-3.22-.54-.38-1.08-.91-1.36-1.49-.53-1.12-.93-2.31-1.29-3.5-.12-.41-.21-.82-.3-1.24-.56.17-1.12.33-1.68.47-.38.09-.77.2-1.15.3-.06.91.03,1.83.23,2.72Z"
                fill="#2b231d"
              />
              <path
                d="M1421.37,124.83c.16.8.26,1.62.3,2.43.04.87-.04,1.75-.03,2.63c0,.59.31,1.05.85,1.28.86.37,1.78.56,2.72.57.22,0,.44-.09.65-.17.32-.12.64-.25.93-.42c1.34-.79,2.75-1.5,3.99-2.43c1.43-1.07,2.54-2.52,3.59-3.97.36-.5.65-1.06.93-1.61.3-.58.51-1.21.86-1.76.73-1.17,1.24-2.44,1.74-3.71-.75.18-1.49.38-2.24.46-.9.1-1.79.23-2.68.43-.8.18-1.61.36-2.42.46-1.18.14-2.37.2-3.56.32-1.35.15-2.67.54-4.04.5-.47.09-.85.16-1.24.22-.04.12-.09.23-.14.35-.64,1.45-.51,2.92-.21,4.41Z"
                fill="#2b231d"
              />
              <path
                d="M1399.98,168.93c-1.55.38-3.06.86-4.45,1.65-.52.29-1.05.59-1.61.76-1.87.56-3.74,1.14-5.65,1.56-1.17.25-2.38.04-3.46-.55-.83-.46-1.01-.91-.79-1.84.3-1.26.86-2.4,1.63-3.44.81-1.09.96-2.27.53-3.55-.33-.97-.82-1.45-1.85-1.48-1.05-.03-2.11-.02-3.15.12-1.57.22-3.12.57-4.67.87-2.15.41-4.14.04-6.06-1.03-2.12-1.18-4.34-1.42-6.59-.29-.92.46-1.78.99-2.59,1.63-1.09.85-1.7,1.92-1.98,3.25-.17.79-.09,1.51.26,2.23.29.58.53,1.19.77,1.8.54,1.37,1.37,2.46,2.74,3.13.53.26,1,.64,1.45,1.02.31.26.42.61.35,1.07-.31,2.19-.55,4.39-.33,6.61.05.47.15.97.36,1.38.37.73.8,1.44,1.3,2.1.61.8,1.41,1.34,2.49,1.13.58-.11,1.19-.21,1.7-.49c1.18-.65,2.44-1.07,3.72-1.46.45-.14.95-.18,1.42-.16.61.03.97.51.9,1.11-.05.39-.09.79-.21,1.17-.33,1.05-.66,2.11-1.06,3.14-.53,1.36-.15,2.54.6,3.72c1.42.14,2.67-.15,3.89-.69c1.84-.81,3.7-1.59,5.54-2.42.96-.43,1.91-.88,2.81-1.42c1.05-.62,2.12-1.29,2.7-2.41.8-1.54,1.91-2.82,3.12-4.03.36-.36.74-.72,1.18-.96c1.18-.64,2.28-1.39,3.39-2.12c1.31-.85,2.6-1.74,3.91-2.57c1.61-1.02,2.8-2.38,3.83-3.93.52-.78.69-1.66.31-2.51-.5-1.14-1.38-1.96-2.65-2.2-1.27-.25-2.54-.18-3.8.13Z"
                fill="#2b231d"
              />
              <path
                d="M1421.77,135.7c-.79-.17-1.64-.11-2.46-.09-.48,0-.95.13-1.43.18-1.81.18-3.53.65-5.03,1.68-1.24.85-2.14,1.97-1.89,3.64.03.17.02.34.02.51.07.99.27,1.96.45,2.93.2,1.06.93,1.57,2.06,1.22c1.54-.47,3.09-.94,4.7-1.15.47-.06.95-.16,1.4-.33c2.27-.87,3.44-2.7,4.06-4.93.16-.58.18-1.28,0-1.84-.29-.88-.94-1.62-1.88-1.82Z"
                fill="#2b231d"
              />
              <path
                d="M1428.26,155.64c-.51-1.8-1.32-3.44-2.59-4.84-.91-1-1.96-1.53-3.33-1.18-.19.05-.38.11-.57.18-1.72.59-3.44.59-5.19.13-1.44-.38-2.87-.29-4.26.27-.42.17-.84.35-1.26.53-1.88.81-3.45,2.07-4.54,3.76-1.2,1.86-1.69,4.01-1.47,6.27.03.31.17.61.17.92-.02,1.13.32,2.19.71,3.22.48,1.25,1.07,2.45,2.14,3.33.81.67,1.64,1.32,2.43,2.01.7.61,1.48.93,2.42.78.25-.04.51-.02.82-.04c1.61.04,3.17-.3,4.62-1.07.34-.33.68-.66,1.02-.99.91-.9,1.83-1.78,2.77-2.64c1.18-1.07,2.4-2.08,3.57-3.15.32-.29.64-.58.96-.89.22-.32.44-.65.66-.99c1.12-1.74,1.48-3.59.92-5.61Z"
                fill="#2b231d"
              />
              <path
                d="M1442.45,142.07c.02-1.22.01-2.44.03-3.66.02-1.12.25-2.2.73-3.21.57-1.21.72-2.5.68-3.82-.07-2.2-1.86-3.16-3.65-3.29-.21-.02-.45.08-.65.17-1.45.65-2.38,2.14-2.32,3.75.03.7-.07,1.36-.41,1.97-1.19,2.11-2.59,4.01-4.95,4.94-.42.17-.84.36-1.22.6-.5.32-1.06.61-1.42,1.06-.66.84-1.31,1.74-1.76,2.71-.64,1.41-.58,2.87.3,4.22.71,1.09,1.74,1.67,2.99,1.93.91.19,1.82.43,2.73.64c1.29.3,2.59.4,3.86-.03.54-.18,1.05-.39,1.57-.63.91-.89,1.86-1.75,2.67-2.74.14-.17.29-.33.44-.49.15-.31.26-.64.3-1c.09-1.04.06-2.09.08-3.14Z"
                fill="#2b231d"
              />
              <path
                d="M1373,196.98c-.77-.55-1.64-.88-2.55-1.16-1.11-.33-2.08-.88-2.81-1.82-.66-.84-.93-.88-1.88-.38-.13.07-.26.12-.36.22-1.24,1.19-2.42,2.39-2.6,4.25-.07.76.04,1.47.23,2.14.98.09,1.96.12,2.95.04c1.53-.13,3.06-.22,4.58-.36.62-.06,1.23-.18,1.83-.33.24-.06.47-.13.71-.19.84-1.01.73-1.81-.1-2.4Z"
                fill="#2b231d"
              />
              <path
                d="M1370.93,140.28c.74,1.3,1.7,2.47,2.62,3.65.38.49.88.88,1.36,1.28.36.3.8.45,1.26.19.43-.25.63-.7.43-1.26-.25-.71-.5-1.47-.94-2.07-.89-1.2-1.84-2.38-2.92-3.41-.96-.92-1.55-1.99-2-3.2-.25-.68-.67-1.3-1.06-1.93-.23-.38-.58-.53-1.1-.18.02.59-.06,1.17.08,1.7.49,1.84,1.31,3.57,2.25,5.22Z"
                fill="#81c6b2"
              />
              <path
                d="M1357.74,180.5c-.52-.7-1.05-1.43-1.69-2.01-1.35-1.23-2.91-1.76-4.7-.97-1.17.51-2.3,1.09-3.46,1.63-.87.41-1.72.91-2.64,1.18-1.51.44-3.04.8-4.68.6-1.1-.14-2.18-.31-3.25-.59-.24-.06-.47-.18-.7-.29-.62-.29-1.2-.68-1.85-.86-1.27-.36-2.18-1.23-3.06-2.08-.74-.72-1.48-1.47-2.06-2.37-.57-.9-1.4-1.57-2.5-1.79-.8-.16-1.54-.12-2.02.67l.05,1.36c.36.32.74.62,1.09.95.39.37.72.8,1.11,1.17c1.8,1.7,3.62,3.36,5.59,4.86c1.24.95,2.43,1.96,3.68,2.88c1.1.8,2.26,1.51,3.39,2.25c1.02.67,2.03,1.35,3.07,1.98c2.01,1.23,4.1,2.31,6.27,3.25.83.36,1.71.62,2.54,1c1.19.54,2.43.74,3.73.67c1.37-.07,2.24-.7,2.62-2.02.21-.73.31-1.49.45-2.25.11-.58.26-1.17.27-1.76c0-1.25-.03-2.51-.14-3.75-.11-1.3-.31-2.61-1.11-3.7Z"
                fill="#81c6b2"
              />
              <path
                d="M1333.78,143.29c.2,1.36.66,2.65,1.82,3.55c1.55,1.66,2.94,3.1,4.65,4.2c1.6,1.02,2.3,2.61,2.64,4.4.06.3,0,.62-.05.93-.26,1.48-.88,2.81-1.64,4.09-.64,1.08-.93,2.24-.9,3.41.09.57-.06,1.09.38,1.52.6.6,1.27.63,2.04.49c1.58-.29,2.91-1.14,4.17-2.03c1.65-1.17,3.01-2.67,4.2-4.32.28-.39.56-.79.79-1.21.2-.36.37-.76.46-1.16.11-.46.1-.96.2-1.43.26-1.33.26-2.63-.09-3.95-.28-1.03-.59-2.01-1.31-2.83-.34-.38-.67-.77-1.05-1.12-1-.92-1.92-1.98-3.06-2.69-1.38-.85-2.34-1.96-3.01-3.36-.72-1.5-1.75-2.65-3.12-3.61-.49-.34-.97-.52-1.46-.6-.16.06-.32.13-.47.2-1.14.48-2.25,1.04-3.42,1.45-.58.71-1.03,1.5-1.41,2.34-.24.53-.45,1.17-.37,1.72Z"
                fill="#f37e5a"
              />
              <path
                d="M1420.58,137.86c-.25-.04-.51-.02-.76-.08-1.29-.31-2.52-.19-3.72.36-.28.13-.61.18-.87.34-.62.39-1.27.75-1.79,1.25-.65.62-1.01,1.43-.97,2.37.03.63.21,1.06.6,1.45.9.88,2.61,1.06,3.7.39.69-.43,1.31-.98,2.22-.96.25,0,.52-.22.75-.37.65-.42,1.17-.97,1.59-1.63.42-.67.52-1.37.38-2.11-.11-.58-.53-.92-1.12-1.01Z"
                fill="#f37e5a"
              />
              <path
                d="M1402.81,172.32c-.81-.52-1.68-.58-2.54-.29-2.1.72-4.12,1.64-6.02,2.79-1.27.77-2.59,1.42-3.96,1.96-1.03.41-2.12.73-3.24.58-2.57-.36-4.71-1.59-6.52-3.41-.33-.33-.63-.79-.71-1.23-.15-.8-.11-1.62.2-2.43.28-.74.44-1.52.58-2.3.15-.89-.2-1.4-1.07-1.67-.4-.12-.8-.16-1.25-.09-1.09.17-2.19.25-3.3.33-.82.06-1.65.08-2.47.1-1.45.02-2.88-.12-4.29-.44-.47-.11-.94-.23-1.42-.29-.5-.06-1.04-.18-1.51-.05-1.81.5-2.57,1.64-2.73,3.38-.06.69.07,1.37.46,1.96.44.67,1,1.22,1.69,1.66c1.01.65,2.08,1.17,3.2,1.57.91.32,1.54.82,1.72,1.92-.12.38-.18.83-.39,1.18-.62,1.02-.85,2.16-1.19,3.27-.14.46-.06.88.16,1.31.54,1.09,1.58,1.25,2.6,1.33c1.01.08,2.04-.05,3.03-.34.9-.26,1.8-.51,2.72-.69c1.39-.27,2.55.38,3.68,1.03.15.09.25.3.32.48.31.8.3,1.62-.01,2.41-.33.85-.73,1.67-1.03,2.52-.21.62-.28,1.28.23,1.84.52.55,1.11.7,1.85.45c1.07-.35,2-.93,2.9-1.59c1-.75,2-1.49,2.77-2.5.58-.77,1.2-1.51,1.8-2.26.18-.22.36-.44.54-.66.75-.96,1.49-1.92,2.25-2.87.16-.2.36-.37.57-.51c1.21-.79,2.42-1.58,3.65-2.35.72-.45,1.47-.86,2.22-1.27c1.12-.61,2.27-1.16,3.36-1.82.8-.48,1.54-1.07,1.88-2.04-.07-.44-.34-.72-.73-.97Z"
                fill="#f37e5a"
              />
              <path
                d="M1425.1,121.16c-.56.85-.93,1.82-.86,2.89.03.48,0,.96,0,1.44c0,.71-.08,1.42,0,2.12.12,1.1.98,1.74,2.07,1.63.67-.06,1.26-.35,1.78-.75c1.08-.83,1.98-1.83,2.85-2.87c1.06-1.26,2.15-2.48,2.87-3.98.25-.54.44-1.11.74-1.62.35-.6.35-1.16.1-1.76-.56.08-1.12.17-1.67.3-.8.18-1.61.36-2.42.46-.34.04-.69.07-1.03.1-1.03.34-2.06.69-3.08,1.07-.51.19-1.07.53-1.35.96Z"
                fill="#81c6b2"
              />
            </g>
            <g id="e0gYpSRcAlv2254" transform="translate(.000008 0)">
              <path
                d="M1611.47,147.29c-.18-.65-.26-1.35-.55-1.95-1.34-2.76-3.39-4.86-6.06-6.38-1.38-.79-2.71-1.66-4.07-2.48-.63-.38-1.27-.76-1.94-1.06-2.24-.99-4.49-1.94-6.74-2.89-.36-.15-.75-.27-1.13-.39-1.36-.41-2.72-.81-4.08-1.22-.92-.28-1.83-.62-2.75-.87-1.31-.36-2.64-.66-3.95-1-.63-.16-1.26-.41-1.9-.48-1.42-.14-2.79-.45-4.18-.74-1.5-.32-3.02-.51-4.52-.81-2.31-.46-4.61-.97-6.92-1.44-2.81-.57-5.62-1.1-8.42-1.68-1.5-.31-2.98-.74-4.47-1.06-1.74-.37-3.5-.7-5.25-1.03-.42-.08-.84-.1-1.26-.16-1.26-.17-2.52-.34-3.78-.52-.56-.08-1.11-.24-1.67-.29-.7-.07-1.41-.05-2.12-.11-1.69-.15-3.38-.29-5.07-.48-1.64-.19-3.28-.22-4.92-.15-.7.03-1.42-.03-2.12-.13-1.04-.14-2.08-.23-3.13-.18-.82.03-1.64-.03-2.46-.06-.65-.02-1.3-.08-1.95-.1-.91-.03-1.82,0-2.72-.09-1.64-.18-3.28-.23-4.92-.14-.33.02-.68-.04-1.01-.08-1.26-.18-2.53-.38-3.81-.24-.28.03-.57.01-.85,0-1.1-.06-2.2-.12-3.3-.18-.34-.02-.68-.03-1.02-.06-1.1-.09-2.2-.28-3.3-.27-1.73.02-3.45.06-5.16-.31-.58-.12-1.18-.09-1.78-.13-.9-.06-1.81-.1-2.71-.2-.61-.07-1.22-.24-1.83-.31-.98-.11-1.97-.21-2.96-.25-1.27-.04-2.55-.01-3.82,0-.31,0-.61.14-.91.13-.59-.03-1.18-.14-1.77-.19-.24-.02-.53-.07-.62.27.22.58.83.24,1.19.5-.02.21-.06.4-.06.6s.01.41.09.58c.15.35.06.65-.07.98-.81,2.11-1.28,4.28-1.43,6.53-.1,1.5-.24,2.99-.36,4.48-.03.34-.1.67-.11,1.01-.06,1.96.63,3.69,1.75,5.24.84,1.17,1.83,2.24,2.74,3.35c1.11,1.36,2.16,2.78,3.5,3.94c1.67,1.45,3.31,2.95,4.96,4.42.11.09.22.19.32.28c1.48,1.33,3.04,2.58,4.42,4.01.8.83,1.7,1.49,2.57,2.21.99.81,2.03,1.56,2.98,2.4.89.79,1.67,1.71,2.56,2.5c1.28,1.12,2.57,2.24,3.94,3.24c1.79,1.3,3.62,2.55,5.21,4.1.63.61,1.31,1.17,2.02,1.69c1.22.88,2.5,1.67,3.71,2.56c1.43,1.07,2.8,2.21,4.2,3.32c1.33,1.05,2.67,2.1,4.01,3.15c1.05.82,2.1,1.64,3.13,2.48.81.66,1.57,1.41,2.4,2.03.97.73,1.99,1.41,3.02,2.04c1.19.73,2.43,1.35,3.62,2.08c1.56.95,3.19,1.74,4.9,2.38c1.52.57,3.01,1.19,4.52,1.79.24.09.49.15.73.22c1.45.4,2.91.77,4.35,1.21.84.26,1.66.55,2.55.64c1.01.1,2.04.22,3.01.49c2.27.63,4.57.77,6.9.76.68,0,1.37-.08,2.05-.07c2.41.06,4.74-.44,7.03-1.13c2.55-.77,5.11-1.51,7.5-2.75c1.77-.91,3.52-1.85,5.13-3.03c1.26-.92,2.43-1.95,3.65-2.93c1.06-.85,2.13-1.69,3.19-2.55c1.82-1.49,3.61-3.01,5.46-4.47c1.74-1.38,3.38-2.86,4.93-4.43c1.79-1.82,3.53-3.7,4.93-5.85.47-.71.92-1.43,1.36-2.16.43-.73.78-1.51,1.24-2.22.69-1.05,1.39-2.07,1.84-3.25.21-.56.46-1.1.66-1.66.37-1.04.79-2.07,1.04-3.15.25-1.07.3-2.19.46-3.28.11-.75.28-1.49.42-2.23l-.07-1.88c-.06-.15-.14-.3-.19-.45Z"
                fill="#ffc7b5"
              />
              <g>
                <g>
                  <path
                    d="M1546.29,202.89c0-.65-.23-1.22-.51-1.78-.12-.25-.21-.52-.3-.79-.64-1.92-1.48-3.76-2.63-5.41-1.02-1.46-2.21-2.81-3.38-4.16-.74-.86-1.53-1.69-2.4-2.41-1.87-1.53-3.81-2.96-5.7-4.45-.74-.58-1.49-1.13-2.34-1.55-1.91-.95-3.41-2.45-4.91-3.93-.82-.81-1.71-1.49-2.67-2.09-.67-.42-1.35-.86-1.93-1.39-1.24-1.13-2.56-2.16-4-3.03-1.72-1.05-3.43-2.1-4.84-3.6-.91-.97-1.89-1.89-2.86-2.81-1.09-1.04-2.15-2.12-3.3-3.1-2.02-1.72-4.34-3.01-6.69-4.2-1.66-.84-3.19-1.83-4.6-3.06-1.26-1.1-2.52-2.21-3.97-3.08-.62-.38-1.19-.89-1.68-1.43-1.52-1.7-3.15-3.27-4.93-4.7-.37-.3-.72-.65-1.01-1.03-.73-.98-1.41-1.99-2.12-2.99-.65-.91-1.5-1.35-2.64-1.12-.43.35-.57.85-.71,1.34-.81,2.69-1.31,5.44-1.69,8.22-.24,1.79-.47,3.58-.79,5.36-.38,2.17-.85,4.32-1.26,6.49-.48,2.53-.96,5.05-1.42,7.58-.18,1-.36,2.01-.45,3.02-.12,1.29-.12,2.6-.23,3.9-.13,1.47-.21,2.94-.15,4.41.08,1.85.17,3.7.21,5.54.03,1.39,0,2.78-.03,4.17-.03,1.22-.12,2.43-.18,3.65-.07,1.53-.12,3.06-.19,4.58-.03.62-.09,1.24-.14,1.86-.06.87-.18,1.75-.17,2.62.03,2.08.11,4.15.19,6.23.06,1.47.24,2.93.51,4.39.3,1.66.93,3.2,1.42,4.8.39,1.26,1,2.41,1.89,3.4c1.54,1.71,3.06,3.43,4.67,5.07.93.96,2.18,1.39,3.51,1.56.81.1,1.65.13,2.42.36c2.02.6,3.93,1.44,5.65,2.7c1.51,1.1,3.27,1.69,5.03,2.25.96.31,1.96.63,2.96.71c1.52.12,3.06.04,4.59.03.22,0,.45-.06.66-.13c1.72-.56,3.52-.51,5.29-.74.17-.02.34,0,.51.03c1.68.21,3.33.64,5.05.6.12,0,.24.12.36.18l3.92-.15c1.97-.46,3.43-1.48,4.94-2.36c1.05-.61,2.09-1.27,3.1-1.95.7-.47,1.48-.69,2.27-.91c1.5-.41,3.04-.72,4.49-1.26c2.45-.91,4.8-2.04,6.64-4.01.93-.99,2.02-1.83,2.99-2.79.9-.9,1.83-1.8,2.58-2.83.86-1.19,1.07-2.66,1.22-4.11.07-.7.07-1.41.12-2.12.01-.16.12-.31.18-.46l-.32-8.53c-.08-.2-.23-.41-.23-.61Z"
                    fill="#f68a78"
                  />
                  <path
                    d="M1474.77,151.31c-.09,0-.1-.32-.1-.32.09,0,.1.32.1.32Z"
                    fill="#f68a78"
                  />
                  <path
                    d="M1476.14,144.71c-.37,1.97-.78,3.92-1.3,5.89-.04-.13-.11-.27-.1-.4.27-2.33.81-4.62,1.32-6.9.05-.22.19-.41.3-.62-.07.68-.09,1.36-.22,2.03Z"
                    fill="#f68a78"
                  />
                </g>
                <path
                  d="M1499.74,158.98c-.1.17-.19.33-.32.56.86.94,1.08,2.31,2.05,3.21.08.77.64,1.23,1.1,1.75.43.7.74,1.19,1.04,1.68-.23.43.1.72.32.97.33.38.74.68.99.9.05.4.02.67.12.87.39.73.56,1.62,1.46,2.01.25-.08.51-.16.73-.24-.05-.37-.1-.69-.14-1-.19-.21-.5-.4-.53-.62-.04-.37-.34-.5-.48-.75-.25-.16-.18-.33-.02-.51-.49-.84-.96-1.69-1.46-2.52-.21-.34-.48-.65-.79-1.06-.14-.34-.21-.92-.54-1.22-.3-.28-.49-.57-.64-.9-.44-.95-.98-1.83-1.62-2.65-.65-.39-1.32-.76-1.99-1.11.38.42.55.53.71.64Zm4.94,8.21c.15.2.21.29.28.38q-.28.03-.28-.38Z"
                  fill="#2b231d"
                />
                <path
                  d="M1475.39,145.81c-.28.22-.36.68-.45,1.14.27-.25.35-.69.45-1.14Z"
                  fill="#2b231d"
                />
                <path
                  d="M1518.19,231.3c-.1-.07-.2-.16-.31-.24.09-.53.17-1.02-.33-1.38.29-.37.18-.74-.02-1.1-.08-.14-.2-.28-.24-.43-.23-.92-1.02-1.57-1.23-2.5-.04-.19-.29-.33-.44-.5-.1-.12-.21-.23-.3-.36-.46-.65-.82-1.39-1.38-1.94-.83-.83-1.69-1.63-2.48-2.49-.19-.2-.51-.33-.61-.56-.2-.45-.53-.69-.94-.88-.23-.36-.33-.7-.7-.67-.03-.18-.06-.37-.1-.57-.33-.2-.66-.39-.98-.59-.17-.18-.31-.38-.5-.52-.26-.18-.53-.31-.61-.66-.03-.15-.17-.29-.28-.42-.53-.68-1.24-1.19-1.69-1.94-.06-.11-.2-.17-.31-.25-.29-.37-.46-.85-1.01-.9-.32-.68-.78-1.21-1.4-1.37-.37-.58-.68-1.06-.99-1.53-.37-.38-.75-.76-1.14-1.15-.23-.04-.48-.08-.75-.12-.08-.61-.12-1.24-.78-1.55-.05-.32-.28-.33-.53-.32-.08-.54-.29-1.04-.73-1.38-1.09-.85-1.85-1.97-2.58-3.1-.32-.5-.54-1.11-.54-1.78c0-.4-.14-.83-.53-1.08.03-.22.05-.44.08-.66-.21-.15-.39-.27-.56-.39.22-.6-.2-.92-.46-1.3-.31-.09-.47.07-.63.24-.35-.5.27-.62.32-.96-.13-.45-.27-.9-.41-1.36.05-.23-.29-.22-.18-.6.06-.2-.18-.63-.58-.69.17-.33.17-.66-.03-.96-.45-.67-.37-1.51-.7-2.21-.03-.43-.08-.7-.24-.87-.29-.3-.41-.59-.37-1.03.04-.41-.1-.85-.44-1.17-.01-.17-.02-.35-.03-.52-.11-.5-.23-.83-.31-1.17-.18-.73-.33-1.47-.5-2.2-.05-.14-.15-.26-.16-.39-.02-.23.31-.44,0-.73-.17-.16-.26-.47-.27-.72-.01-.21.14-.43.23-.69-.21-.25-.32-.57-.31-1c0-.33.24-.79-.18-1.07-.08-.4-.19-.63-.21-.87-.02-.23.08-.47.07-.7-.05-.72-.55-1.34-.51-2.09c0-.1-.08-.21-.13-.31-.35-.75-.46-1.54-.42-2.36c0-.17.06-.34.02-.5-.15-.67-.33-1.33-.52-2.1-.08-.07-.26-.21-.44-.36-.64,2.46.29,4.61.27,6.93-.04.05-.15.2-.26.35.21.14.37.25.53.36.33.38.68.8.55,1.3-.22.86.35,1.59.29,2.42c0,.1.2.22.31.33-.12.02-.24.05-.33.06.08,1.18.16,2.3.25,3.42.01.16.11.31.16.47.07.26.14.53.2.79.07.29.08.61.2.87.13.28.36.51.54.76-.07,1.1.48,1.78.66,2.59.13.64.29,1.03.29,1.43c0,.62.15,1.15.6,1.55-.21.63-.07.91.66,1.44-.04.11-.09.23-.13.35-.07.87.27,1.52.94,2.05.15.12.21.35.33.55-.26.36-.27.63-.15.83.15.25.28.65.73.46-.18.76.22,1.43.33,2.15.07.43.52.77.43,1.28.48.13.37.57.42.89.1.65.43,1.04,1.07,1.19.1.02.2.09.28.16-.36.88-.15,1.26.17,1.61.13.13.25.28.34.44.19.32.35.65.46.85.03.32,0,.54.09.71.64,1.24.96,2.66,2.05,3.65.09.73.59,1.21,1.08,1.65.32.29.56.51.46.99-.04.19.07.43.16.63.17.36.53.69.55,1.05.05.75.49,1.23.91,1.76.16.21.29.45.41.68.26.5.5,1,.8,1.6c0,.07-.02.26-.04.49.54.33.84.78.77,1.45-.02.2.14.42.23.63.07.15.22.29.23.44.06.68.39,1.26.59,1.9.13.11.27.21.38.3c0,1.2.04,2.35.49,3.46.11.27.1.6.19.88.05.16.21.29.32.43-.24.13-.37.32-.28.61.11.38.22.75.33,1.13-.09.52-.12,1.04-.07,1.56.04.39.07.57.24.76.24-.02.48-.04.72-.06.02-.28.03-.56.02-.83-.02-.44-.14-.88-.21-1.32-.17-.03-.34-.06-.59-.1.1-.23.16-.39.23-.55.14.23.31.36.61.15l-.28-.4c.22-.57.44-1.13.02-1.69.3-.59-.09-.88-.11-1.21-.02-.32-.25-.63-.39-.94.1-.49.12-.96-.22-1.36.09-.27.16-.54-.19-.68-.01-.11-.02-.23-.03-.34-.21-.83-.4-1.48-.63-2.13-.03-.1-.19-.15-.3-.22.02-1.24-.48-2.3-1.09-3.34-.19-.33-.44-.66-.51-1.02-.12-.67-.41-1.23-.8-1.78-.3-.42-.52-.89-.78-1.35-.27-.27-.35-.62-.44-.96-.3-1.12-.78-2.16-1.49-3.07-.72-.93-1.26-1.96-1.6-3.09.17,0,.33-.01.5-.02c0,.19-.18.45.19.5.14.26.27.54.44.77.24.33.55.62.78.96.36.52.79.94,1.44,1.07l.02.63c.53.55,1.15,1.19,1.8,1.86.1.19.21.47.39.71.57.78,1.56,1.21,1.85,2.24.04.14.22.25.35.35.22.17.46.32.68.48.74.32,1.38.75,1.63,1.63.36.54.98.3,1.22.47.07.42.08.68.17.92.18.47.6.63,1.04.69c0,.78.77,1.59,1.61,1.86.35.5.61.91.92,1.28.31.38.72.69,1,1.09.64.91,1.32,1.82,1.83,2.81.47.92.75,1.93,1.11,2.91.27.74.41,1.51.59,2.27.03.14.21.26.2.39-.02.31.03.59.1.88l.59-.02c.22-1.37.05-2.21-.12-3.04Zm-13.65-9.08c-.03.15-.06.3-.31.06.14-.03.22-.04.31-.06Zm-.55.13c.06.12.13.25.2.37-.19-.06-.25-.18-.31-.31.04-.02.08-.04.12-.06Zm-7.01-15.26c-.1,0-.11-.43-.11-.43.17.15.14.29.11.43Zm.86.49c-.16-.04-.33-.08-.58-.14.22-.25.37-.42.52-.59.35.23.06.49.06.74Zm.53-.02c.03-.25.12-.22.42-.15-.26.09-.34.12-.42.15Z"
                  fill="#2b231d"
                />
                <path
                  d="M1542.97,220.23c-.19-.53-.38-1.06-.61-1.57-.4-.89-.57-1.87-1.26-2.64-.37-.41-.57-.97-.83-1.47s-.59-.99-.72-1.52c-.12-.46-.24-.85-.54-1.01-.35-1.02-.7-1.88-1.49-2.47-.58-1.07-1.72-1.39-1.96-2.38-.76-.65-1.04-1.69-1.91-2.27-.38-.25-.65-.66-.99-.99-.54-.51-1.11-1-1.64-1.52-.35-.35-.82-.52-1.15-.94-.49-.62-.96-1.36-1.89-1.44-.49-.82-1.11-1.19-1.63-1.64-.37-.32-.8-.58-1.21-.87-.14-.13-.26-.34-.42-.38-.77-.18-1.36-.69-1.93-1.17-1.02-.85-2.5-.83-3.4-1.87-.94.01-1.54-.81-2.44-1.03-.12-.14-.29-.33-.45-.52-.22.1-.39.17-.43.19-.36-.2-.61-.35-.87-.49-.12-.1-.23-.21-.35-.31-.24-.11-.47-.22-.7-.33-.27-.34-.62-.41-1.02-.3.07-.45-.29-.55-.57-.54-.51.02-.86-.29-1.27-.49-.31-.15-.57-.23-.85.02-.13-.16-.12-.27-.12-.35-.35-.22-.73-.37-.98-.64-.74-.79-1.42-1.63-2.16-2.49l-.52.02c.19-.54-.09-.81-.5-.93-.38-.11-.59-.39-.86-.63-.22-.2-.44-.42-.67-.61-.5-.4-1.01-.79-1.5-1.2-.11-.1-.16-.27-.26-.46-.12.2-.22.38-.32.56-.09-.35-.02-.64.04-.85-1-1.01-1.96-2.01-2.95-2.97-.88-.85-1.75-1.72-2.93-2.17-.61-.87-1.18-1.46-1.76-2.02-.72-.7-1.25-1.59-2.16-2.1-.74-.79-1.47-1.59-2.24-2.35-.4-.4-.87-.73-1.31-1.09-.09-.15-.15-.3-.25-.41-.14-.15-.31-.28-.47-.41-.43-.17-.38-.37-.3-.67-.24.11-.37.18-.48.23-.12-.31-.16-.66-.36-.86-.32-.33-.56-.68-.79-1.08-.28-.48-.75-.84-.9-1.42-.04-.17-.23-.38-.39-.42-.47-.12-.57-.58-.88-.85-.33-.29-.57-.7-.82-1.07-.45-.68-.87-1.37-1.32-2.06c0-.88-.62-1.35-1.24-1.83-.1-.71-1.04-2.13-1.84-2.78-.15-.56-.27-1.17-.5-1.74-.22-.56-.56-1.07-.9-1.7-.15-.1-.39-.26-.56-.38-.25.06-.43.09-.83.18.54-.4.62-.68.19-.97-.1-.07-.12-.25-.18-.37-.25-.44-.51-.86-.75-1.31-.2-.37-.36-.77-.54-1.15-.1.39-.19.79-.3,1.18-.04-.13-.11-.27-.1-.4.05-.43.12-.86.18-1.28-.05-.14-.1-.27-.15-.41-.1.61-.19,1.23-.28,1.85.11.35.19.5.27.64.31.56.67,1.08,1.14,1.52.27.49.53.97.79,1.44.55.28.46.86.96,1.1-.05.13-.11.25-.18.42.41.55.84,1.11,1.17,1.55.02.39-.02.64.04.87.2.7.57,1.29,1.24,1.65.13.12.25.22.37.33.1-.05.21-.11.45-.25-.18.46-.29.77-.39,1.03.4.61.87,1.13,1.11,1.74.16.4.43.55.62.67.05.3.04.52.12.7.34.83,1.17,1.32,1.52,2.15.07.16.37.21.56.31.23.4.26.93.73,1.17.55.6.56,1.41.77,2.17.22-.04.4-.07.46-.08.57.37,1.03.68,1.51.99-.07.11-.15.22-.2.31.13.1.27.19.39.3.69.64,1.38,1.28,2.07,1.92.14.14.4.27.4.42.02.6.49.78.86,1.06.25.18.58.35.69.6.37.87,1.17,1.36,1.74,2.04.37.44.84.87,1.29,1.29.43.4.84.83,1.31,1.18.77.57,1.63,1.03,2.13,1.9.08.14.22.26.35.36.66.48,1.3.99,1.71,1.71l.86-.03c-.07.3-.16.43-.26.6.41.31.8.6,1.23.93.01.05,0,.23.07.31.3.33.62.66.97.94c1.09.89,2.2,1.76,3.3,2.64.09.07.22.17.21.25-.04.65.55.92.82,1.37.18.29.45.4.79.38.02.22.05.43.07.67.18.04.34.08.39.09.46.65.75,1.37,1.29,1.76.55.4.48,1.26,1.23,1.41.03.39.53.58.43,1.06-.03.13.24.32.39.49.48.66.96,1.32,1.45,1.99-.23.4.19.58.38.85l.75,1.51c.38,1.28.65,2.36,1.49,3.2.22.55.42,1.11.68,1.64.12.24.34.42.53.62.12.18.06.28-.04.44.23.31.47.64.73.98-.05.11-.12.27-.2.44.29.63.57,1.25.86,1.88.03.14.02.32.09.46.63,1.23,1.26,2.45,1.91,3.67.06.12.2.19.3.29.14.68.27,1.19.4,1.69.33.87.64,1.57.98,2.26.23.45.29.76.67.93-.04.55.1,1.01.59,1.22.31,1.32.78,2.51,1.38,3.63.15.01.26.02.39.04-.3.67-.19,1.2.27,1.66.17.69.59,1.29.71,2.01.09.49.34.95.51,1.43.09.26.19.52.27.78.42-.16.85-.29,1.28-.41-.09-.69-.36-1.34-.57-2.01-.29-.92-.74-1.78-.94-2.75-.08-.4-.42-.75-.65-1.12-.2-.66-.4-1.32-.6-1.97-.07-.24-.12-.49-.22-.71-.22-.51-.47-1.02-.71-1.53-.23-.94-.67-1.77-1.29-2.51-.06-.11-.12-.22-.18-.33-.05-.22-.04-.48-.16-.66-.61-.89-.7-1.97-1.09-2.94-.29-.71-.45-1.42-1.1-1.85q-.11-.71-.58-1.14c-.33-.9-.69-1.6-.83-2.35-.14-.73-.51-1.36-.71-2.06-.34-.45-.47-.79-.6-1.12-.08-.24-.13-.5-.26-.71-.48-.79-.99-1.57-1.48-2.35.02-.89-.51-1.13-.86-1.5.33-.58-.28-.97-.25-1.47-.23-.07-.41-.13-.63-.2.06-.13.11-.22.15-.31.07-.33-.07-.54-.37-.67-.2-.28-.18-.44-.24-.5-.59-.58-.91-1.33-1.32-2.02-.42-.71-.93-1.36-1.39-2.04-.27-.4-.51-.81-.78-1.22.56-.25.59.28.86.42.07-.07.15-.14.27-.26.06.2.11.37.18.59.21.04.45.1.69.15.07.12.13.27.23.34.2.13.43.2.65.3.57.2.97.41,1.43.65.19.1.31.04.44-.04.02.17.04.33.04.37.27.21.45.38.66.51.25.16.51.3.77.45.35.28.7.58,1.21.45.15-.11.29-.22.46-.35.12.38.2.64.28.89.14.05.26.07.35.12c1.35.73,2.52,1.79,4.07,2.15.61.53,1.07.86,1.47,1.25c1.16,1.15,2.42,2.15,3.87,2.89.03.12.06.25.09.38.17-.02.31-.03.44-.05.26.4.49.82.79,1.19.16.2.43.31.65.46.36.37.74.72,1.06,1.12.28.35.6.55,1.05.52.32,1.27,1.13,2.24,2,3.16.33.71,1.09,1.02,1.53,1.68.36.54.71,1.17,1.27,1.6.12.09.14.35.17.54.09.61.39,1.06.92,1.37.06.92.39,1.61,1.01,2.14.19.12.36.23.53.33-.08.11-.16.22-.24.32.2.41.37.82.59,1.2.21.37.47.71.72,1.07-.19.51.05.91.33,1.4.54-.05.45.35.41.75.1.05.19.11.28.17.09-.09.19-.17.28-.26.13-.13.26-.26.39-.39-.17-.23-.12-.35-.15-.44Zm-24.6-16.15c-.05.11-.1.21-.15.32-.06-.1-.12-.21-.25-.44.22.07.32.1.4.12Zm2.96-8.2c0-.12,0-.23,0-.35.07.13.04.24,0,.35Zm.83.48c-.09-.08-.19-.17-.28-.25l.35.15-.07.1Zm10.8,9.2c-.25-.32,0-.57.14-.84.11.08.21.15.4.28-.2.2-.37.38-.54.56Zm7.43,10.79l-.04-.4c.1.13.07.27.04.4Z"
                  fill="#2b231d"
                />
                <path
                  d="M1493.15,232.71c.01-.11,0-.23,0-.35-.05-.12-.13-.26-.13-.39.02-.88-.07-1.72-.66-2.44-.07-.08-.11-.21-.11-.31-.02-.97-.54-1.79-.74-2.73-.24-.07-.45-.13-.66-.19-.16-.06-.31-.12-.54-.22.27-.18.5-.34.78-.52-.27-.18-.45-.3-.63-.42.03-.14.07-.26.11-.42-.12-.39-.05-.85-.51-1.23-.08-.06-.13-.18-.16-.29-.25-.98-.81-1.78-1.35-2.61-.11-.16-.07-.42-.11-.68-.75-.5-.54-1.75-1.43-2.12-.13-.32-.21-.57-.34-.79-.2-.33-.46-.63-.68-.95-.13-.19-.18-.45-.35-.57-.78-.57-.89-1.63-1.69-2.17-.44-1.23-1.71-1.83-2.29-2.96-.26-.29-.38-.51-.53-.7-.44-.55-.96-1.04-1.31-1.64-.55-.92-.5-1.91-.01-2.94-.51-1.03.09-2.16-.15-3.29.31-.45.29-.45.21-1.02-.03-.21.01-.44.03-.66.03-.36.06-.73.12-1.08.15-.85-.02-1.75.41-2.55.06-.11.04-.28.04-.42-.08-1.24.34-2.4.6-3.59.11-.52.36-1.02.42-1.55.12-1.13.55-2.15,1.03-3.16.31-.65.6-1.31.89-1.96.46-1.05.92-2.1,1.38-3.15.11-.26.18-.54.34-.76.21-.3.12-.71.4-.97.23-.56.46-1.12.7-1.68.07-.22-.01-.51.07-.72.21-.52.14-1.04.11-1.57h-.38c-.14.34-.31.62-.38.93-.06.26-.01.54-.01.81-.91,1.94-1.82,3.72-2.67,5.37.04.36.06.58.09.81-.5-.05-.63.31-.75.6-.49,1.19-.99,2.38-1.41,3.6-.29.85-.46,1.74-1.05,2.54.02-.4.06-.73.06-1.07c0-.22.02-.51-.11-.65-.64-.68-.5-1.57-.68-2.36-.21-.9-.42-1.78-.91-2.62.05-.47.08-.97-.07-1.5-.27-.95-.39-1.94-.58-2.91-.07-.35-.09-.71-.21-1.03-.14-.39-.46-.71-.41-1.17.04-.42-.48-.7-.3-1.16-.54-.96-.51-2.09-1.04-3.08-.53-1-.6-2.19-.82-3.31-.03-.16-.04-.32-.08-.47-.16-.64-.28-1.29-.49-1.91-.2-.59-.09-1.32-.67-1.67c0-.6.02-1.12-.38-1.54.22-.61-.11-1.02-.5-1.41.28-.25.44-.5.08-.8-.08-.47-.24-.95-.22-1.41-.19.76-.29,1.31-.39,1.86.05.25.09.51.14.76.15.47.28.73.2,1.13s.07.85.17,1.27c.12.52.28,1.03.43,1.55.14.51.29,1.01.47,1.66q-.11.42.2.89c.14.8.24,1.42.37,2.03.13.63.28,1.27.45,1.89.17.61.37,1.21.51,1.64.06.51.1.84.14,1.23-.1.05-.26.14-.36.19-.1.54-.19,1-.28,1.45-.05.84-.27,1.44-.49,2.03-.05.14-.1.27-.15.41-.32,1.56-.65,2.96-1.2,4.31-.09.21,0,.5.02.86-.4.36-.77.87-.79,1.57-.3.2-.53.43-.51.86c0,.18-.19.36-.29.55-.25.35-.56.68-.83,1.03-.04,1.05-.1,2.1-.15,3.14.2-.67.53-1.25.84-1.85.27-.52.48-1.08.76-1.74.83-.7,1.19-1.83,1.63-2.89-.18-.14-.3-.24-.47-.36.27-.13.47-.23.66-.33.15-.39.32-.77.45-1.17.17-.52.2-1.14.51-1.56.3-.43.39-.85.45-1.32.06-.49.02-.99.27-1.45.07-.13-.01-.35-.03-.53.07-.24.07-.52.21-.69.28-.37.39-.76.42-1.2.37.3.44.8.57,1.19.23.68.22,1.45.27,2.19.05.62.13,1.2.43,1.78.24.47.29,1.04.42,1.57.22.89.16,1.82.5,2.7.21.53.2,1.13.55,1.65.19.29.16.74.23,1.16.14.04.34.1.57.16-.13.2-.25.39-.36.56.08.28.2.52.21.77c0,1.06,0,2.12-.04,3.18-.03.77-.09,1.55-.2,2.32-.09.63-.45,1.23-.15,1.9.05.12-.07.32-.1.48-.03.13-.11.3-.06.39.23.39.03.76.01,1.15-.02.47.01.94-.01,1.41-.02.26-.1.52-.16.78-.02.43-.04.86-.06,1.29-.36-.29-.68-.05-1.03.06l.03.66c.17.04.28.07.38.09-.17.14-.32.26-.36.3.28,1.16.93,2.01.76,3.15-.13.93.03,1.9-.17,2.84-.03.13-.05.34.02.41.31.3.03.65.13.96-.07.13-.21.27-.19.38.09.61-.08,1.16-.35,1.65.08.23.17.4.19.59.1.81-.12,1.61-.13,2.42c0,.54.18,1.01.23,1.51.06.56.18,1.05-.1,1.56.15.68.35,1.37.47,2.07.13.76.18,1.54.29,2.31.05.34.08.69.14,1.03.4.32.85.56,1.32.75.16-.48-.17-.89-.19-1.35-.37-.21-.24-.54-.2-.84-.14-1.07-.32-1.97-.14-2.9.03-.17-.08-.37-.11-.56-.03-.21-.05-.42-.08-.63.03-.44-.14-.49-.35-.49.03-.16.12-.32.12-.48-.02-.66-.02-1.33-.13-1.98-.09-.54-.08-1.03.19-1.47-.22-.51-.39-.91-.02-1.43.25-.35.16-.88-.09-1.31.14-.62.17-1.25.28-1.85.11-.59-.04-1.08-.13-1.61.17-.32.35-.64.54-1.01.14.37.19.67.35.87.81,1.04,1.69,2.02,2.36,3.17.36.61.84,1.15,1.26,1.72s.84,1.15,1.25,1.73c.23.22.47.44.7.66.18.43.3.91.55,1.3.54.83,1.1,1.62,1.41,2.58.13.41.41.77.62,1.15.06.11.12.22.18.33.25.51.5,1.01.75,1.52.48,1.07.97,2.14,1.48,3.25.2.12.42.25.71.42-.16.03-.23.04-.38.07.09.99.4,1.92.83,2.81.13.09.26.17.38.25c0,.33.16.4.42.52-.24.14-.36.21-.49.28.32.18.64.3.95.42-.15-.22-.07-.38-.04-.49Zm-13.3-22.85l-.16-.29c.23.26.2.28.16.29Zm9.45,15.3c.09-.1.18-.21.27-.31.07.1.14.19.21.29-.16,0-.32.01-.48.02Zm3.83,7.21c0,.11,0,.22.01.34-.17-.11-.15-.22-.01-.34Z"
                  fill="#2b231d"
                />
                <path
                  d="M1489.3,169.7c.02.29.12.31.34.35-.17-.17-.24-.25-.34-.35Z"
                  fill="#2b231d"
                />
                <path
                  d="M1446.11,158.04c.04.43-.52.69-.34,1.21.55-.4.63-.65.34-1.21Z"
                  fill="#2b231d"
                />
                <path
                  d="M1546.45,209.51c-.09-.58-.08-1.02-.55-1.24-.12-.06-.25-.27-.24-.41.02-.35-.17-.56-.33-.84-.66-1.14-1.33-2.25-2.26-2.73-.62-.86-1.07-1.49-1.51-2.11-.01,0-.35-.17-.35-.17-.1-.26-.2-.52-.31-.81-.52-.33-.9-.96-1.64-.99l-.58-1.06c-.35,0-.59-.13-.84-.26.01-.12.08-.28.04-.33-.63-.64-1.26-1.29-1.93-1.89-.54-.49-1.22-.85-1.7-1.39-.77-.87-1.73-1.49-2.57-2.26-.19-.18-.49-.23-.75-.33-.08.23-.15.3-.26.39-.04-.21-.07-.39-.1-.57-.4-.24-.85-.43-1.18-.74-.47-.43-1.04-.63-1.61-.86-.33.31-.48-.14-.57-.24-.36-.39-.76-.65-1.26-.8-.21-.07-.4-.2-.61-.3-.68-.34-1.36-.7-2.05-1.01-.63-.28-1.28-.51-1.91-.79-.82-.36-1.56-.9-2.5-.96-.63-.72-1.53-.85-2.1-1.42-.32.04-.58.06-.83.09.06-.2.17-.28.28-.37-.26-.18-.5-.34-.74-.5-.6-.25-1.11-.7-1.65-1.1-.15-.11-.41-.06-.54-.08-.27-.19-.48-.35-.7-.51-.1-.11-.2-.22-.34-.37-.11.18-.18.3-.25.41-.2-.25-.46-.48-.6-.76-.34-.65-.91-.87-1.6-.95.06-.41.06-.82.18-1.18.22-.7-.07-1.12-.63-1.46.04-.25-.29-.51.04-.78.08-.06-.05-.38-.09-.58-.25-.39-.51-.77-.79-1.19.14-.04.28-.08.43-.12-.14-.41-.28-.82-.42-1.22-.12-.45-.24-.9-.36-1.35-.05-.18-.11-.32-.34-.21-.06-.63-.12-1.27-.19-1.89l-1.34.05c.09.28.17.5.24.72.09.15.18.29.27.42-.04.17-.07.35-.11.52.17.1.29.17.41.24.13-.08.25-.16.4-.25-.06.24-.23.25-.4.26-.09.22-.04.39.18.5.14.87.14,1.47.4,1.91.19.31.38.64.57.96.55.12-.16.36-.02.59.13.09.26.17.38.26-.07.15-.14.3-.21.47.29.32.26.89.79,1.04-.03.32-.15.66-.08.96.05.21.33.37.5.54-.06.18-.11.36-.17.54-.22.08-.27.13-.32.18-.1-.23-.19-.3-.25-.38-.21-.13-.28,0-.36.13-.05-.21,0-.39.06-.56-.23-.44-.53-.78-1.06-.83-.4-.28-.67-.76-1.22-.81-.63-.5-1.42-1.16-1.73-1.49-.48-.51-.92-1.13-1.52-1.43-.9-.46-1.6-1.12-2.23-1.83-.66-.75-1.52-1.27-2.15-2.04-.07-.08-.19-.12-.28-.19-.2-.18-.39-.37-.59-.56-.11-.11-.23-.21-.34-.31-.37-.52-.82-.95-1.38-1.42-.02-.12-.05-.37-.08-.53-.33-.33-.59-.6-.86-.86-.76-.95-1.49-1.66-2.21-2.36-.12-.12-.33-.21-.36-.34-.15-.69-.78-.96-1.18-1.42-.34-.46-.53-1.04-1.07-1.33-.15-.32-.22-.73-.47-.95-1.05-.96-1.62-2.36-2.84-3.16-.38-.58-.68-1.02-1-1.43-.32-.42-.67-.81-1.04-1.25-.09.04-.24.12-.39.19.1-.71.1-.71-.43-1.02-.33-.69-.79-.82-1.3-.93.01-.19.03-.38.04-.53-.87-.74-1.44-1.8-2.53-2.19-.12-1.1-1.08-1.3-1.76-1.78-.2.82.15,1.5.73,1.99s.9,1.17,1.5,1.64c.67.53,1.11,1.33,1.98,1.62.1.03.23.16.23.24-.04.42.38.47.55.71s.45.4.68.6c.11.11.23.22.34.33-.02.14-.04.28-.05.42.46.56.96,1.09,1.38,1.68.25.35.55.55.96.6-.03.18-.14.24-.24.3.16.46.46.69.9.65.02.2-.01.41.07.52.57.71,1.17,1.4,1.76,2.1s1.37,1.26,1.68,2.18c.04.11.07.24.15.3.21.16.44.29.67.44.08.18.18.4.28.62.32.41.41.94.83,1.3.84.74,1.62,1.54,2.42,2.32.21.78.64.95,1.03,1.16.15.95.72,1.37,1.22,1.79.75.63,1.57,1.2,2.2,1.97.09.11.3.2.43.18.59-.1.85.29.97.72.09.32.24.49.5.61.1.05.26.06.3.14.3.6.87.95,1.34,1.36.38.33.83.93,1.51.44.18.14.36.27.59.44-.52.18-.44.46-.35.74.71.5,1.4.98,2.09,1.46.23.1.46.21.69.32.18.2.66.06.6.54c0,.06.15.16.24.22.36.21.78.36,1.08.64.29.26.79.1.94.55.42-.29.42.35.57.3.67-.21.53.39.72.65q.7.39.99.21c.21.23.39.48.63.66.33.25.72.42,1.07.65.83.56,1.54,1.24,2.49,1.68c1.22.56,2.43,1.16,3.64,1.74c1.29.62,2.55,1.3,3.84,1.93.27.13.59.15.97.25.07.04.23.14.38.23.28.31.62.47,1.04.48.09.1.16.23.27.29c1.03.58,2.07,1.15,3.11,1.73.21.12.43.25.62.41.58.52,1.14,1.06,1.71,1.59.13-.05.25-.1.37-.15.11.16-.12.5.25.51.02.35.31.27.53.32.12.17.24.35.36.53.09.14.15.32.27.41.56.4,1.14.78,1.72,1.16.07.19.09.42.21.55.38.37.79.71,1.21,1.03.11.09.31.07.47.09.43.39.41,1.27,1.02,1.12.35.44.65.81.95,1.18.34.39.41,1.05,1.09,1.11-.11.61.44.83.7,1.22.74.64,1.09,1.65,2.02,2.11-.08.4.14.7.37,1c.31.41.73.8.86,1.26.23.8.63,1.47,1.1,2.13.11.1.21.18.31.27.02-.15.11-.29.17-.43l-.06-1.48c-.12-.19-.23-.38-.34-.57h.01Zm-48.98-38.62c.06.12.11.25.19.42-.47-.07-.34-.25-.19-.42Zm10.1,9.03c-.12.08-.22.04-.32,0c.11,0,.21,0,.32,0Zm-.31,1.17c-.04-.24-.08-.47-.12-.72h.33c.08.18.16.38.26.63-.17.03-.32.06-.47.1Zm4.42,2.06c-.07-.1-.14-.19-.22-.29.1.06.2.12.3.18l-.08.11Zm1.06.46c.17.13.28.21.39.29-.38.22-.44.08-.39-.29Zm24.91,15.33c0,.21.02.42.03.63-.16-.2-.18-.41-.03-.63Z"
                  fill="#2b231d"
                />
                <path
                  d="M1477.25,147.66c-.21,0-.27-.05-.32-.1-.36-.39-.72-.78-1.07-1.16-.22.24-.31.66-.4,1.07.25.21.51.39.81.55.39.88,1.14,1.17,1.68,1.64.14-.04.27-.08.41-.12.09-.22.19-.43.24-.56-.35-.65-1.02-.8-1.35-1.32Z"
                  fill="#2b231d"
                />
                <path
                  d="M1543.03,205.84c-.15.47-.34.93-.44,1.42-.4,1.81-2.81,2.79-4.42,1.71-.6-.41-1.13-.84-1.5-1.46-1.08-1.78-1.47-3.7-1.22-5.77.07-.59.03-1.19-.01-1.78-.08-1.09.3-2.05.8-2.98.22-.42.62-.67,1.06-.8c1.28-.37,3.17.34,3.89,1.47.66,1.03,1.06,2.15,1.17,3.4.06.7.37,1.38.56,2.08.03.91.07,1.82.1,2.73Z"
                  fill="#2b231d"
                />
                <path
                  d="M1523.69,226.45c-1.1-.03-2.22,0-3.31-.11-1.03-.11-2.06-.34-3.05-.63-1.02-.29-1.58-1.16-2.07-2.03-.68-1.18-1.15-2.46-1.38-3.8-.26-1.54-.8-3-1.32-4.46-.47-1.32-.75-2.65-.78-4.05-.04-1.76-.11-3.52.36-5.23.28-1.01.65-1.98.99-2.97.82-2.42,2.58-3.78,4.92-4.63.94-.34,1.79-.28,2.72-.15c2.16.3,4.06,1.33,6.09,1.99c2.89.94,4.15,3.17,4.91,5.81.46,1.62.8,3.29,1.02,4.96.17,1.34.18,2.71.08,4.08-.11,1.5-.34,2.97-.75,4.41-.71,2.49-1.96,4.62-4.31,5.95-.81.46-1.62.79-2.56.75-.51-.02-1.02.03-1.53.05v.05Z"
                  fill="#2b231d"
                />
                <path
                  d="M1490.4,221.55c.08-1.36.2-2.71.23-4.07.04-1.82.4-3.59.68-5.37.04-.22.08-.45.15-.66.97-3.13,2.19-6.13,4.46-8.59.33-.35.64-.72.98-1.05.16-.15.36-.32.57-.36c1.26-.24,2.53-.28,3.76.13.65.22,1.03.78,1.44,1.28.27.32.44.73.68,1.07.35.51.68,1.05,1.1,1.5.8.85,1.03,1.92,1.25,3c.39,1.92.47,3.88.76,5.8.19,1.24.6,2.46,1.01,3.66.51,1.51.46,3,.13,4.51-.16.71-.38,1.41-.58,2.12-.31,1.11-.98,1.96-1.9,2.63-.69.5-1.37,1.01-2.05,1.51-1.59,1.17-3.4,1.71-5.34,1.6-1.39-.08-2.71-.53-3.78-1.51-.48-.44-1-.84-1.51-1.24-.65-.51-1.04-1.19-1.29-1.96-.41-1.3-.75-2.61-.76-4Z"
                  fill="#2b231d"
                />
                <path
                  d="M1474.31,216.26c.11-1.21.24-2.41.34-3.62.07-.84.19-1.69.17-2.53-.04-1.46.37-2.72,1.35-3.82.79-.89,1.52-1.84,2.33-2.71.31-.33.76-.64,1.2-.74c1.08-.24,2.24-.32,3.25.18c1.31.65,2.33,1.69,2.84,3.1.45,1.24.8,2.52,1.16,3.79.18.65.37,1.31.4,1.98.06,1.11-.15,2.19-.56,3.23-.2.5-.42.99-.61,1.49-.45,1.15-1.04,2.19-1.96,3.05-.41.39-.74.86-1.15,1.26-.95.93-2.1,1.19-3.36.84-.36-.1-.69-.37-1.01-.59-.79-.54-1.54-1.15-2.36-1.65-1.33-.81-1.95-1.09-2.03-3.25Z"
                  fill="#2b231d"
                />
                <path
                  d="M1539.58,197.93c1.03.86,1.27,2.19,1.94,3.26.11.18.09.44.1.67.05,1.08.07,2.16.13,3.24.05.93-.32,1.73-.85,2.45-.42.57-1.16.61-1.72.14-.4-.33-.71-.72-.86-1.24-.39-1.33-.83-2.65-1.2-3.98-.37-1.32.1-2.52.68-3.68.08-.16.3-.25.44-.38.17-.15.33-.3.49-.45.28-.01.57-.02.85-.03Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1522.4,224.38c-2.68.15-4.04-1.01-4.97-2.78-.65-1.24-1.05-2.56-1.04-3.99.01-1.62-.4-3.2-.76-4.77-.36-1.54-.78-3.07-1.07-4.63-.26-1.38-.18-2.71.63-4c.61-.98,1.28-1.88,2.17-2.57.7-.55,1.5-.97,2.44-1.1.93-.13,1.8.03,2.67.25c1.01.26,2.06.38,3.01.88.93.49,1.71,1.13,2.21,2.05.72,1.35,1.41,2.72,2.06,4.11.21.45.26.97.36,1.47.07.36.15.73.16,1.09.01.76.05,1.53-.05,2.28-.19,1.29-.41,2.58-.74,3.83-.42,1.59-1.15,3.06-2.03,4.48-.57.91-1.21,1.65-2.07,2.3-1.07.8-2.24,1.04-2.97,1.1Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1504.21,220.14c-.03,1.16-.27,2.15-.71,3.08-.33.69-.69,1.37-1.07,2.04-.84,1.45-2.07,2.4-3.73,2.7-.51.09-1.11.07-1.59-.11-.98-.37-1.91-.87-2.55-1.76-.94-1.3-1.39-2.78-1.61-4.35-.44-3.07.15-5.95,1.5-8.73.4-.83.64-1.77.79-2.68.29-1.81.99-3.43,2.07-4.89.36-.48.79-.88,1.4-1.07.74-.23,1.33-.07,1.78.57.08.12.15.24.24.35.71.8,1.17,1.7,1.35,2.79.18,1.05.59,2.07.85,3.11.21.85.39,1.71.49,2.58.15,1.24.21,2.49.34,3.73.07.65.21,1.28.32,1.92.05.28.1.56.13.72Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1484.84,211.61c-.04,1.79-.42,3.46-1.2,5.04-.75,1.52-2.22,2.34-3.9,2.18-.17-.02-.37-.04-.48-.14-.59-.52-1.29-.93-1.61-1.7-.3-.71-.5-1.41-.41-2.22.09-.83-.03-1.69-.09-2.54-.13-1.68-.03-3.3,1.2-4.61.52-.56,1.08-1.08,1.64-1.6.16-.15.38-.26.58-.35.93-.41,1.73-.26,2.38.5.69.8,1.23,1.68,1.37,2.78.12.89.35,1.77.52,2.66Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1508.17,124.41c.86,1.81,2.15,3.29,3.78,4.42c1.6,1.11,3.09,2.32,4.44,3.71c1.44,1.47,2.65,3.11,3.12,5.17.37,1.62.71,3.25,1.03,4.88.5,2.55,1.42,4.93,2.85,7.11c1.19,1.8,2.94,2.97,4.7,4.13c1.05.69,2.18,1.2,3.43,1.4c1.38.23,2.67.7,3.95,1.24c2.79,1.18,5.36.65,7.75-1.07.64-.46,1.3-.9,1.94-1.37.36-.26.76-.35,1.19-.36c1.19-.03,2.39-.04,3.58-.13.73-.05,1.47-.17,2.16-.39c1.69-.54,3.34-1.24,5.04-1.72c2.16-.61,3.58-2.09,4.9-3.75.6-.75.9-1.62,1.17-2.52.66-2.22,1.22-4.46,2.13-6.6.84-1.98,1.88-3.81,3.6-5.18c1.3-1.05,2.58-2.13,3.87-3.2.76-.64,1.2-1.42,1.31-2.36-1.49-.31-3.01-.51-4.5-.81-2.31-.46-4.61-.97-6.92-1.44-.61-.13-1.23-.24-1.85-.37-.25,1.79-.14,3.59-.24,5.38-.07,1.25-.03,2.5-.05,3.75c0,.14-.02.28-.06.42-.27.98-.54,1.96-.83,2.93-.93,3.15-2.86,5.64-5.26,7.79-.71.63-1.53,1.21-2.4,1.58-1.97.84-4.03,1.35-6.2.99-1.55-.25-3.04.01-4.54.31-1.13.22-2.25.57-3.43.53-.8-.03-1.37-.35-1.63-1.1-.14-.42-.23-.88-.26-1.33-.08-1,.18-1.96.48-2.91.29-.93.71-1.77,1.38-2.51.88-.96,1.67-2.01,2.53-2.99.5-.57,1.09-1.08,1.62-1.62.72-.72,1.45-1.44,2.15-2.18.47-.49.92-1.01,1.34-1.54.42-.54.76-1.13,1.18-1.67c1.71-2.17,2.31-4.7,2.24-7.39c0-.34-.05-.68-.07-1.02-1.41-.29-2.83-.56-4.24-.82-.42-.08-.84-.1-1.26-.16-1.26-.17-2.52-.34-3.78-.52-.56-.08-1.11-.24-1.67-.29-.7-.07-1.41-.05-2.12-.11-.18-.02-.36-.03-.55-.05-.19,1.01-.27,1.98-.28,2.94-.04,2.22.3,4.4.78,6.57.14.63.25,1.3.18,1.93-.34,3.04-1.64,5.63-3.85,7.74-1.21,1.16-2.89,1.31-4.28.38-.91-.61-1.47-1.43-1.82-2.39-.51-1.39-1.12-2.71-1.91-3.96-.59-.94-.97-2-.93-3.13.04-1.21.18-2.42.28-3.63.11-1.27.39-2.52.25-3.8-.06-.51-.09-1.02-.23-1.51-.18-.65-.37-1.3-.57-1.95-.76-.08-1.53-.12-2.3-.08-.82.03-1.64-.03-2.46-.06-.65-.02-1.3-.08-1.95-.1-.91-.03-1.82,0-2.72-.09-1.64-.18-3.28-.23-4.92-.14-.22.01-.44-.01-.66-.04-.04.39-.08.77-.1,1.16-.08,1.34-.08,2.66.52,3.91Z"
                  fill="#2b231d"
                />
                <path
                  d="M1488.05,123.74c.25.41.5.83.8,1.19.5.58,1.06,1.11,1.57,1.68.9,1.04,1.94,1.95,3.13,2.6c1.43.79,2.96,1.4,4.48,2.03.37.15.84.16,1.24.1.55-.09,1.08-.31,1.61-.5.96-.36,1.28-.8,1.22-1.78-.05-.85-.23-1.68-.25-2.53-.02-.79.1-1.57.14-2.36.04-.9.31-1.8,0-2.69-.3-.85-.61-1.69-.96-2.52-.53-.03-1.06-.06-1.58-.09-.34-.02-.68-.03-1.02-.06-1.1-.09-2.2-.28-3.3-.27-1.73.02-3.45.06-5.16-.31-.58-.12-1.18-.09-1.78-.13-.9-.06-1.81-.1-2.71-.2-.27-.03-.53-.08-.8-.13.63,1.32,1.26,2.65,2.11,3.86.47.67.83,1.42,1.25,2.12Z"
                  fill="#2b231d"
                />
                <path
                  d="M1527.6,126.98c.3,1.22,1.69,1.39,2.47.58.85-.87,1.46-1.87,1.76-3.06.19-.74.23-1.47.14-2.26-.08-.64-.17-1.28-.28-1.92-.35-.04-.7-.07-1.05-.11-.87-.1-1.75-.15-2.62-.17-.21,1.27-.42,2.53-.58,3.8-.14,1.03-.09,2.09.16,3.12Z"
                  fill="#2b231d"
                />
                <path
                  d="M1553.3,127.55c-.15.4-.31.79-.39,1.21-.11.55-.38,1-.75,1.4-.33.35-.69.67-1.02,1.03-.38.41-.8.81-1.11,1.28-.71,1.06-1.33,2.18-2.04,3.24-.76,1.14-1.39,2.34-1.86,3.62-.5,1.36-.89,2.75-.94,4.2-.03,1.01.55,1.42,1.49,1.04.51-.21.96-.59,1.41-.93.81-.61,1.57-1.32,2.42-1.87c2.38-1.54,3.82-3.75,4.61-6.41.37-1.24.62-2.51.91-3.78.3-1.32.72-2.63.81-3.97.07-1.08.07-2.16-.13-3.22-.82-.16-1.63-.32-2.45-.49-.32.21-.36.49-.37.77-.06,1-.25,1.96-.59,2.89Z"
                  fill="#2b231d"
                />
                <path
                  d="M1491.08,150.5c.76-.22,1.5-.48,2.25-.72.67-.21,1.37-.37,2.01-.64c1.34-.58,2.21-1.66,2.42-3.07.2-1.4-.05-2.77-1.07-3.89-.34-.37-.66-.78-.96-1.19-.49-.66-1.15-1.09-1.9-1.39-.71-.29-1.41-.58-2.14-.83-.69-.24-1.27-.62-1.78-1.13-.64-.64-1.3-1.28-1.89-1.96-.79-.91-1.32-1.93-1.37-3.2-.04-1.14-.58-2.14-1.48-2.86-.64-.51-1.4-.91-2.28-.64-.51.16-.99.41-1.45.68-.92.55-1.39,1.45-1.42,2.47-.04,1.33.2,2.67.87,3.84.78,1.37,1.09,2.85,1.27,4.36.21,1.74.3,3.5.38,5.26.02.32.08.61.18.89c1.02.91,2.04,1.83,3.06,2.74.11.09.22.19.32.28.33.3.66.59,1,.88c1.31.42,2.63.51,3.97.13Z"
                  fill="#2b231d"
                />
                <path
                  d="M1513.07,169.65c.37-.01.74-.05,1.11-.04.73.03,1.31-.23,1.83-.73.61-.59,1.28-1.13,1.88-1.73.63-.64,1.27-1.27,1.72-2.1c1.14-2.09,1.36-4.35,1.38-6.65.02-1.95-.72-3.69-1.64-5.37-.13-.24-.33-.46-.52-.67-1.72-1.88-3.85-3.04-6.31-3.65-1.09-.27-2.18-.26-3.28.03-.84.22-1.68.49-2.54.62-1.16.18-2.31.06-3.45-.25-1.37-.38-2.52,0-3.39,1.13-.3.38-.58.77-.84,1.18-.82,1.31-1.31,2.74-1.57,4.27-.22,1.24-.15,2.44.36,3.57.18.4.39.78.62,1.15c1.49,1.32,2.78,2.44,4.15,3.44c1.79,1.3,3.62,2.55,5.21,4.1.49.48,1.02.91,1.56,1.33c1.19.37,2.42.49,3.72.38Z"
                  fill="#2b231d"
                />
                <path
                  d="M1513.6,139.31c.05-.86-.33-1.53-.88-2.13-.58-.64-1.28-1.11-2.09-1.43-2.57-1.02-5.23-1.06-7.92-.75-.81.09-2.11,1.47-2.11,2.22c0,.56.02,1.16.21,1.67.68,1.82,1.71,3.38,3.54,4.25.56.26,1.13.46,1.78.49.9.04,1.79.21,2.68.36.92.15,1.83.35,2.74.53.93.19,1.68-.18,1.84-1.24.16-1.03.24-2.06.36-3.1-.12-.3-.16-.58-.14-.87Z"
                  fill="#2b231d"
                />
                <path
                  d="M1578.05,133.83c-.62.53-1.27,1.05-1.96,1.48-1.3.82-2.34,1.92-3.2,3.15-1.86,2.68-3.09,5.64-3.59,8.88-.11.7-.23,1.44-.09,2.11.33,1.55.84,3.08,1.72,4.39c1.23,1.81,2.7,3.44,4.64,4.55.98.56,2.01,1.02,3.03,1.52c1.65.81,3.3,1.61,5.07,2.15c1.52.47,3.03.9,4.66.88.64-.11,1.29-.18,1.91-.35c1.39-.37,2.09-1.66,1.6-3.04-.73-2.05-1.95-3.83-3.36-5.46-1.1-1.28-1.85-2.77-2.59-4.26-.53-1.07-.38-2.2.28-3.14.79-1.14,1.74-2.16,2.62-3.24.58-.7,1.26-1.34,1.71-2.11c1.05-1.77,2.53-3.2,3.75-4.83.59-.79,1.1-1.58,1.41-2.48-1.18-.5-2.36-1.01-3.54-1.51-.36-.15-.75-.27-1.13-.39-1.36-.41-2.72-.81-4.08-1.22-.92-.28-1.83-.62-2.75-.87-1.14-.31-2.29-.58-3.44-.87-.39.78-.82,1.55-1.11,2.37-.32.92-.84,1.67-1.56,2.29Z"
                  fill="#2b231d"
                />
                <path
                  d="M1565.74,158.78c-.51-.4-.98-.87-1.53-1.19-1.9-1.07-3.85-1.94-6.13-1.29-.85.24-1.71.47-2.4,1.02-1.57,1.24-3.4,1.59-5.33,1.65-.39.01-.79-.07-1.18-.11-1.04-.11-2.08-.18-3.11-.35-1.42-.24-2.83-.15-4.25-.03-.9.07-1.51.57-1.74,1.49-.33,1.28-.22,2.47.67,3.51.17.19.32.4.48.6.7.87,1.19,1.85,1.53,2.91.26.81.12,1.26-.6,1.76-1.07.73-2.29.98-3.55.88-1.04-.08-2.07-.28-3.08-.51-1.4-.32-2.82-.56-4.15-1.17-2.34-1.08-4.8-1.69-7.41-1.45-1.31.12-2.38.67-3.14,1.78-.68.99-.75,2.06-.09,3.02.9,1.31,1.91,2.56,3.34,3.35c1.66.92,3.2,2.05,4.97,2.77.18.07.34.2.52.29.92.49,1.85.97,2.78,1.46.42.23.89.41,1.24.73c1.32,1.16,2.66,2.3,3.6,3.84.27.45.64.88,1.06,1.21c1.28,1.01,2.74,1.7,4.27,2.24c2.15.75,4.31,1.52,6.47,2.26c1.22.42,2.47.59,3.83.33.32-.89.89-1.75.55-2.79-.19-.59-.38-1.19-.67-1.72-.6-1.08-.91-2.24-1.2-3.42-.14-.58.2-1.1.8-1.19.42-.06.87-.11,1.27,0c1.31.35,2.65.56,3.88,1.19.35.18.74.31,1.12.36.88.12,1.73.15,2.47-.53.98-.9,1.42-2.1,1.91-3.26.13-.3.13-.66.14-1c.05-2.25-.35-4.46-.84-6.64-.1-.46-.02-.8.26-1.08.44-.43.92-.84,1.43-1.18.77-.51,1.5-1.06,1.85-1.94.53-1.34,1-2.69,1.48-4.05.07-.2.05-.46,0-.68-.29-1.12-.52-2.27-1.51-3.05Z"
                  fill="#2b231d"
                />
                <path
                  d="M1561.68,188.25c-.28.28-.63.53-.85.87-.44.66-1,1.17-1.68,1.54-.47.26-.96.49-1.46.67-.79.28-1.47.73-2.1,1.26-.52.44-.65,1.19-.28,1.74c1.83.36,3.69.46,5.55.45.68,0,1.37-.08,2.05-.07c1.05.02,2.07-.06,3.09-.21.33-2.82-1.51-5.29-4.32-6.26Z"
                  fill="#2b231d"
                />
                <path
                  d="M1599.98,160.34c-1.26-.72-3.04.29-3.16,1.66-.04.48-.06.96-.12,1.44-.17,1.4-.73,2.61-1.88,3.48-.74.56-1.51,1.1-2.26,1.65-.9.65-1.94.93-3.01,1.05-1.56.17-3.11-.02-4.65-.28-1.25-.21-2.48-.53-3.7-.88-1.73-.51-3.46-1.03-5.14-1.68-1.33-.52-2.64-.65-3.98-.24-1.89.58-3.45,1.48-3.91,3.66-.37,1.8-.79,3.58-.93,5.41-.11,1.41-.32,2.82-.31,4.23.01,1.76.21,3.51.33,5.27.1,1.48.58,2.87.98,4.28.41,1.45.99,2.88,1,4.4.23-.06.46-.13.69-.2c2.55-.77,5.11-1.51,7.5-2.75c1.77-.91,3.52-1.85,5.13-3.03c1.26-.92,2.43-1.95,3.65-2.93c1.06-.85,2.13-1.69,3.19-2.55c1.82-1.49,3.61-3.01,5.46-4.47c1.74-1.38,3.38-2.86,4.93-4.43c1.79-1.82,3.53-3.7,4.93-5.85.24-.37.47-.74.7-1.12-.07-.18-.14-.35-.2-.53-.91-2.65-2.94-4.26-5.23-5.58Z"
                  fill="#2b231d"
                />
                <path
                  d="M1600.6,138.38c-.73,1.15-1.46,2.29-2.3,3.37-1.02,1.31-2.11,2.3-3.8,2.61-1.03.19-1.84.84-2.26,1.88-.23.58-.5,1.14-.74,1.71-.68,1.62-.42,3.1.7,4.43c1.02,1.2,2.23,2.17,3.57,3c.43.27.86.55,1.3.8c1.27.73,2.52,1.52,3.84,2.17c1.73.85,3.27,1.93,4.62,3.28.3.3.55.65.86.94.28.27.56.53.78.82.81-1.25,1.51-2.28,1.96-3.46.21-.56.46-1.1.66-1.66.37-1.04.79-2.07,1.04-3.15.25-1.07.3-2.19.46-3.28.11-.75.28-1.49.42-2.23l-.07-1.88c-.06-.15-.14-.3-.19-.45-.18-.65-.26-1.35-.55-1.95-1.34-2.76-3.39-4.86-6.06-6.38-1-.57-1.97-1.19-2.95-1.79-.53.3-.97.68-1.31,1.22Z"
                  fill="#2b231d"
                />
                <path
                  d="M1496.46,120.01c-1.66-.36-3.31-.78-4.94-1.27-.93-.28-1.84-.24-2.81-.14-.35.44-.49.83-.21,1.3.29.49.52,1,.82,1.48.58.94,1.12,1.9,1.94,2.67.45.42.82.94,1.25,1.39c1.02,1.07,2.04,2.16,3.36,2.85.61.32,1.34.48,2.03.55.87.09,1.53-.67,1.49-1.68-.07-1.41-.14-2.84-.35-4.23-.23-1.46-.95-2.57-2.56-2.92Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1510.8,138.22c-1.33-.95-2.89-1.24-4.54-1.43-.78.17-1.61.33-2.43.55-.53.14-.73.56-.77,1.1-.08,1.03.4,1.8,1.09,2.48.49.48,1.03,1.04,1.71,1.03.86,0,1.55.29,2.22.7c1.04.62,2.09.46,3.09.02.67-.29,1.06-.89,1.07-1.7.01-1.19-.52-2.1-1.43-2.75Z"
                  fill="#f37e5a"
                />
                <path
                  d="M1560.82,160.97c-.72.02-1.45.28-2.14.52-1.29.46-2.65.7-3.99.82-1.97.18-3.97.07-5.96.09-.96-.27-1.54.05-2.09.41-.2.13-.36.45-.4.7-.05.33,0,.69.09,1.01.23.76.49,1.51.79,2.25.54,1.33.44,2.53-.58,3.62-1.22,1.3-2.61,2.37-4.23,3.11-1.01.47-2.07.83-3.21.7-1.74-.2-3.37-.76-4.94-1.52-.71-.35-1.43-.69-2.17-.99-1.32-.53-2.64-1.03-3.97-1.54-.78-.3-1.58-.48-2.42-.35-.82.13-1.54.4-1.88,1.44.23.28.42.61.69.83.44.35.91.68,1.42.93c1.09.54,2.22,1.01,3.33,1.52c1.39.65,2.78,1.3,4.16,1.98s2.67,1.48,3.64,2.74c.6.78,1.31,1.49,2,2.2.66.7,1.42,1.33,2.02,2.07c1.16,1.44,2.74,2.29,4.3,3.14.63.34,1.39.53,2.11.58c1.04.06,1.65-.83,1.37-1.83-.08-.3-.22-.58-.36-.86-.4-.85-.86-1.67-1.19-2.54-.38-.99-.28-2.51,1.07-3.04.34-.13.65-.35.98-.52.68-.35,1.39-.43,2.15-.29c1.11.21,2.23.44,3.35.57c1.27.15,2.53.17,3.72-.47.78-.42,1.25-1.31.95-2.14-.35-.96-.77-1.89-1.18-2.82-.14-.31-.34-.59-.48-.9-.38-.86-.19-1.67.54-2.27.28-.23.59-.44.91-.63.98-.58,2-1.08,2.93-1.72c1.93-1.32,2.46-3.28,1.33-5.26-.58-1.01-1.54-1.56-2.68-1.52Z"
                  fill="#f37e5a"
                />
                <path
                  d="M1549.9,141.29c1.42-1.35,2.38-3.02,3.33-4.69.67-1.19,1.21-2.47,1.7-3.75.61-1.56,1.16-3.15,1.33-4.85.06-.58-.12-.98-.51-1.54-.79.63-1.17,1.4-1.47,2.19-.29.77-.48,1.57-.75,2.35-.6,1.78-2.02,3.01-3.13,4.43-.81,1.03-1.61,2.05-2.14,3.23-.42.92-.8,1.91-.42,2.95.94.44,1.32.36,2.05-.33Z"
                  fill="#81c6b2"
                />
                <path
                  d="M1583.85,131.41c-1.22.87-2.18,1.95-2.76,3.35-.25.6-.55,1.19-.8,1.79-.29.68-.77,1.23-1.36,1.6-1.86,1.2-3.13,2.94-4.43,4.65-.97,1.27-.94,2.86-1.07,4.54.13.58.36,1.28.44,2c.12,1.03.47,1.9,1.14,2.72c1.64,2.01,3.46,3.77,5.82,4.9.15.07.28.17.42.24c1.02.49,2.07.85,3.22.8.81-.03,1.19-.43,1.41-1.2.22-.75-.09-1.39-.25-2.07-.27-1.11-1-1.98-1.55-2.95-.6-1.06-1.2-2.09-1.22-3.41-.03-1.97.72-3.47,2.2-4.69.69-.57,1.4-1.14,2-1.79.83-.9,1.55-1.9,2.35-2.82.6-.68.91-1.47,1.08-2.34.12-.65.2-1.29-.1-1.92-.58-1.22-1.32-2.32-2.35-3.21-.18-.16-.39-.28-.61-.39-.19-.06-.37-.11-.56-.17-.17-.05-.35-.11-.52-.17-.87-.13-1.8.04-2.5.54Z"
                  fill="#f37e5a"
                />
                <path
                  d="M1598.81,165.97c-.75,1.03-1.51,2.06-2.23,3.11-.92,1.32-2.04,2.37-3.45,3.09-.44.23-.87.48-1.3.74-1.71,1.04-3.54,1.62-5.54,1.59-.38,0-.76.02-1.13.04-1.18.05-2.32-.17-3.41-.6-1.6-.64-3.2-1.28-4.77-2-2.23-1.02-4.76-.39-6,1.83-1.37,1.69-1.82,3.44-1.81,5.35c0,.36-.01.73-.02,1.09-.01.54-.11,1.1-.02,1.63.22,1.4.5,2.79.79,4.18.12.59.29,1.18.51,1.74.33.87,1.05,1.37,1.86,1.49.76.11,1.56-.04,2.33-.13c1.12-.14,2.08-.71,3.05-1.25c1.51-.84,3.09-1.54,4.53-2.48c1.86-1.22,3.66-2.55,5.41-3.95c1.85-1.49,3.57-3.17,5.41-4.68c1.74-1.42,3.18-3.17,4.79-4.73c1.08-1.05,2.04-2.24,3.02-3.4.61-.72,1.16-1.49,1.73-2.23-.19-.64-.37-1.1-.55-1.57-1.29-.1-2.41.05-3.2,1.15Z"
                  fill="#81c6b2"
                />
              </g>
            </g>
          </g>
          <g
            id="e0gYpSRcAlv2296"
            transform="matrix(.370742-.928736 0.928736 0.370742 1600.915564 1268.701047)"
          >
            <g id="e0gYpSRcAlv2297" transform="translate(.000003 0.000014)">
              <path
                d="M1089.2,141.74c-.67-.7-1.31-1.42-1.96-2.13-.19-.21-.38-.41-.58-.61-.63-.64-1.26-1.28-1.89-1.91-.4-.4-.85-.75-1.21-1.17-1.15-1.33-2.33-2.63-3.6-3.85-.24-.23-.45-.49-.67-.74-.57-.64-1.13-1.3-1.7-1.94-.66-.73-1.4-1.4-1.96-2.2-.76-1.07-1.65-2-2.57-2.93-.41-.41-.77-.86-1.11-1.33-.53-.73-1.07-1.44-1.77-2.01-.76-.62-1.35-1.37-1.91-2.17-.24-.34-.51-.67-.81-.97-.78-.79-1.59-1.55-2.24-2.44-.85-1.17-1.82-2.23-2.79-3.3-.46-.51-.89-1.04-1.31-1.58-.88-1.11-1.71-2.27-2.67-3.33-.46-.5-.83-1.09-1.17-1.68-.51-.87-1.04-1.71-1.8-2.39-.68-.61-1.25-1.33-1.8-2.06-.4-.53-.85-1.04-1.36-1.46-.9-.74-1.72-1.54-2.43-2.47-.36-.47-.78-.9-1.17-1.35-.6-.69-1.21-1.36-1.79-2.07-.7-.86-1.26-1.82-1.79-2.8-.12-.23-.21-.49-.52-.51-.16.14-.2.21-.23.29-.19.65-.47,1.24-.84,1.81-.51.8-1.01,1.61-1.52,2.41-.41.66-.88,1.26-1.58,1.66-.64.37-.94.92-.91,1.7.09,2-.02,4,.12,6.01.09,1.36-.06,2.74-.05,4.11.02,2.72-.08,5.45.11,8.17.07,1.02.04,2.04.03,3.06c0,.54-.04,1.09-.11,1.63-.06.52-.18,1.03-.26,1.55-.06.4-.09.79-.13,1.21-.77-.34-.91-.3-.89.24.47.15.82.44.98.93.6.25,1,.72,1.38,1.2.98,1.23,1.62,2.63,2.13,4.1.63,1.83,1.21,3.67,1.87,5.49.4,1.11.86,2.19,1.36,3.26.41.86.97,1.65,1.7,2.26.83.69,1.76,1.24,2.8,1.55c1.04.32,2.1.59,3.16.81c1.45.3,2.9.58,4.2,1.32c1.11.49,2.05.83,2.84,1.48.67.54,1.34,1.08,2.04,1.58.69.49,1.37,1.01,2.13,1.35c1.27.56,2.64.83,4.01,1.1c1.05.2,2.11.35,3.17.51.38.06.77.11,1.15.11c1.32,0,2.64,0,3.96-.02.32,0,.64-.01.94-.08c1.03-.24,2.05-.49,3.07-.76.61-.16,1.22-.35,1.72-.77.7-.58,1.42-1.15,2.1-1.75.49-.43.92-.91,1.41-1.34.81-.73,1.63-1.44,2.47-2.14.78-.66.9-1.97.25-2.65Z"
                fill="#f37e5a"
              />
              <path
                d="M1077.71,150.05c-.07-.04-.13-.12-.17-.2-.21-.42-.55-.72-.88-1.04-.48-.48-.92-.99-1.29-1.56-.5-.78-.96-1.58-1.57-2.28-.42-.49-.83-.99-1.24-1.49-.15-.19-.3-.39-.44-.59-.13-.18-.21-.41-.36-.56-.79-.8-1.4-1.73-2.02-2.66-.28-.42-.52-.88-.84-1.26-.53-.62-1.07-1.25-1.7-1.77-.58-.48-.91-1.14-1.41-1.67-.13-.32-.18-.5-.27-.67-.21-.4-.41-.79-.64-1.18-.24-.4-.5-.8-.77-1.17-.3-.41-.64-.78-.96-1.18-.23-.43-.42-.76-.59-1.1-.35-.66-.7-1.32-1.03-1.99-.25-.5-.45-1.02-.68-1.54-.04-.1-.11-.2-.1-.29.05-.4-.1-.77-.21-1.14-.16-.56-.44-1.09-.59-1.65-.13-.5-.38-.93-.59-1.39-.14-.31-.19-.68-.38-.96-.2-.3-.41-.56-.4-.94-.35-.34-.4-.84-.65-1.24-.31-.5-.53-1.06-.78-1.6-.14-.3-.27-.61-.41-.91-.08-.17-.18-.34-.25-.51-.08-.21-.15-.43-.23-.64-.21-.53-.43-1.06-.63-1.6-.11-.29-.19-.59-.31-.87-.21-.48-.42-.95-.67-1.41-.27-.51-.59-.99-.86-1.49-.32-.59-.89-1.04-1.02-1.75-.01-.08-.08-.15-.13-.22-.16-.23-.35-.44-.48-.69-.2-.38-.45-.73-.51-1.18s-.2-.88-.3-1.32c-.11-.49-.21-.99-.32-1.48-.11-.46-.19-.92-.36-1.36-.21-.55-.43-1.09-.77-1.6-.38-.55-.63-1.2-.94-1.8-.14-.27-.32-.54-.6-.63-.27-.09-.4-.27-.5-.5-.19-.42-.4-.84-.56-1.28-.17-.48-.29-.99-.44-1.48-.12-.38-.23-.76-.36-1.14-.31-.42-.59-.86-.85-1.31-.17-.03-.33.06-.47.15-.17.11-.05.24-.02.37.09.43.17.85.24,1.28-.3.79-.32,1.44-.64,1.99-.07.5-.14.94-.2,1.39-.03.25,0,.53-.09.76-.18.47-.13.96-.18,1.43-.07.71-.05,1.42-.18,2.12-.06.36-.06.69-.02,1.03.06.47.11.93-.03,1.4-.03.1-.01.21-.02.32-.03,1.24.03,2.47-.07,3.71-.11,1.29.08,2.59-.1,3.89-.06.46.08.95-.2,1.38-.07.61-.13,1.1-.3,1.59-.08.21-.09.44-.12.67-.05.38,0,.79-.13,1.14-.28.79-.11,1.65-.38,2.43.11.6.02,1,0,1.39-.01.38.07.74.03,1.13-.06.47.05.94,0,1.42-.04.36.09.74.03,1.09-.12.7.18,1.39-.02,2.07.07.9.16,1.59.21,2.29.03.35,0,.7.16,1.03.04.08.07.17.06.25-.09.91.35,1.76.29,2.68c0,.08,0,.16,0,.25.38,1.15.76,2.29,1.17,3.43.1.26.2.52.31.79-.01-.31-.02-.61,0-.91c0-.17.08-.35.06-.52-.03-.22-.17-.43-.17-.65c0-.24.09-.46,0-.71-.1-.29-.19-.63-.13-.92.1-.48-.02-.94-.05-1.39-.04-.6-.18-1.2-.2-1.81-.02-.43-.14-.86-.21-1.28-.04-.22-.1-.44-.1-.67-.02-.78-.04-1.55-.1-2.33-.04-.49.12-.98,0-1.5-.07-.31.02-.66.07-.98.05-.33-.1-.64-.04-.98s.02-.7.02-1.05c0-.46-.02-.92,0-1.37c0-.26.12-.53.08-.77-.05-.25,0-.48.02-.71.03-.35.06-.69.1-1.04.01-.12.03-.24.05-.36.16-.7.33-1.39.38-2.1.02-.25-.04-.52.05-.75.1-.26.14-.5.14-.77c0-.1.02-.22.08-.29.13-.15.13-.32.13-.49.01-.51.04-1.01.07-1.52.07-1.1,0-2.2.02-3.31c0-.59-.08-1.19.07-1.78.06-.24-.01-.52-.02-.78-.01-.35-.03-.69-.04-1.04-.22-.76.19-1.34-.04-1.89.05-.31.09-.51.09-.72c0-.66-.02-1.33,0-1.99c0-.45.06-.89.1-1.34.04-.49.06-.97.11-1.46.02-.22.1-.43.17-.72.1.14.18.21.2.3.12.49.38.94.37,1.46c0,.26.04.53.14.77.24.58.28,1.18.29,1.79c0,.26.05.52.09.78.04.28.11.55.12.83.03.8-.03,1.61.11,2.41.08.49.08,1,.12,1.49.01.14.02.28.04.42.05.48.2.98.14,1.45-.1.77-.03,1.54-.04,2.31c0,.45,0,.92.03,1.36.04.59-.02,1.18,0,1.76.03.52-.05,1.02-.02,1.53.03.49-.04,1,.04,1.47.09.49.06.98.06,1.47c0,.34-.06.67-.04,1.01.04.85.13,1.7.17,2.56.02.44,0,.88,0,1.32c0,.11-.01.22,0,.32.17.8.16,1.61.21,2.42c0,.09,0,.18.01.26.07.43.19.86.19,1.29s.33.82.16,1.27c.13.25.16.34.18.42.13.66.23,1.33.38,1.99.2.86.43,1.72.66,2.57.13.5.3,1,.43,1.5.08.28.09.59.2.86.06.16.13.31.17.48.14.57.31,1.14.5,1.7.17.5.39.97.55,1.47s.42.96.47,1.49c.44.61.65,1.35,1.16,1.92.07.08.13.16.18.25.27.44.49.91.8,1.32.41.08.82.17,1.22.26-.24-.4-.46-.81-.69-1.21-.35-.62-.72-1.22-1.04-1.86-.51-1.02-.81-2.11-1.24-3.15-.07-.16-.08-.34-.13-.51-.24-.71-.53-1.4-.54-2.17-.23-.49-.29-.81-.3-1.14c0-.29-.06-.55-.2-.81-.08-.15-.09-.33-.14-.5-.06-.25-.13-.5-.2-.75-.11-.4-.29-.8-.32-1.2-.05-.54-.34-1.01-.35-1.56c0-.23-.09-.47-.1-.72c0-.16,0-.33-.06-.46-.29-.61-.28-1.28-.35-1.93-.08-.81-.15-1.63-.23-2.45-.09-.89-.1-1.78-.13-2.67-.02-.49.06-1-.03-1.47-.09-.5,0-.99-.07-1.48-.09-.69-.03-1.39-.12-2.09-.07-.54-.04-1.09-.02-1.63.02-.55-.07-1.1-.03-1.66.05-.62-.02-1.26.01-1.88.05-.91-.15-1.81-.02-2.71-.16-.42-.08-.81-.11-1.2-.03-.45-.07-.9-.11-1.35-.03-.26-.04-.52-.11-.77-.13-.49-.22-.97-.11-1.47-.2-.6-.07-1.22-.1-1.83c0-.07.05-.14.1-.23.38.43.4.93.53,1.39.06.2.09.4.15.6.08.28.21.56.23.84.03.33.07.64.18.95.1.27.31.5.31.82c0,.43.06.87.12,1.3.09.65.2,1.3.31,1.95.1.58.21,1.16.31,1.74.04.2.12.42.08.61-.05.19,0,.34.04.5.05.24.09.48.11.72.02.16-.01.32.02.47.13.78.2,1.55.22,2.34c0,.45.05.91.12,1.35.13.81.13,1.63.21,2.45.03.29.06.59.1.88.04.28.12.55.11.83-.04,1.05.22,2.07.34,3.1.02.19.07.37.1.56.05.34.07.69.14,1.03.09.44.12.9.38,1.3.11.9.4,1.65.6,2.42.15.58.49,1.09.64,1.68.17.63.46,1.22.69,1.84.37.98.7,1.96,1.1,2.93.22.54.48,1.09.91,1.52.41.61.68,1.05.97,1.48.27.41.58.79.8,1.23.26.5.56.96.95,1.36.08.08.12.2.18.31.05.11.1.22.15.32.06.12.12.24.18.37.11.22.21.44.33.65.04.08.16.14.16.2c0,.62.51,1.02.68,1.56.07.21.21.39.32.59.25.42.5.84.74,1.26.25.43.49.88.74,1.31.1.07.19.14.28.21.54.38,1.07.78,1.64,1.09-.15-.53-.48-.96-.75-1.42-.41-.7-.85-1.38-1.13-2.15-.42-.7-.76-1.21-1.08-1.73-.07-.12-.09-.26-.14-.39-.09-.26-.14-.54-.26-.79-.45-.95-1-1.84-1.56-2.73-.32-.51-.62-1.05-.93-1.57-.06-.1-.14-.2-.22-.29-.07-.1-.15-.19-.22-.29-.19-.29-.36-.59-.55-.89-.19-.29-.38-.58-.57-.88-.18-.28-.32-.58-.53-.83-.25-.3-.18-.66-.3-.98-.36-.91-.65-1.67-.94-2.44-.22-.57-.44-1.13-.66-1.69-.04-.1-.1-.2-.09-.3.03-.32-.14-.57-.28-.83-.04-.08-.1-.14-.14-.22-.25-.49-.23-1.06-.42-1.58-.2-.55-.25-1.15-.37-1.72-.05-.24-.08-.48-.15-.71-.17-.59-.26-1.19-.31-1.8-.06-.64-.19-1.27-.18-1.92-.08-.64-.16-1.17-.21-1.71-.05-.59-.08-1.18-.12-1.78-.31-.71-.11-1.33-.31-1.9.06-.15.11-.22.17-.23.27.47.42.82.54,1.18.19.58.27,1.18.55,1.73.18.35.28.74.42,1.11.06.16.12.32.18.48.12.31.25.61.36.92.16.5.3,1,.46,1.5.11.33.23.66.39.97.32.66.59,1.34.91,2c.17.36.37.69.55,1.04.35.67.81,1.26,1.24,1.88.42.62.79,1.28,1.15,1.94.22.4.37.83.55,1.25.21.52.62.94.72,1.51.02.1.11.18.16.27.09.13.19.25.26.39.39.78.76,1.57,1.15,2.34.12.24.31.45.45.69.38.63.95,1.12,1.19,1.84.11.32.36.59.38.96c0,.14.13.28.21.42.06.12.12.25.18.37.3.63.59,1.26.9,1.88.35.71.76,1.39,1.05,2.12.23.58.61,1.05.92,1.57.43.72.82,1.45,1.19,2.2.35.7.59,1.46,1.12,2.06.17.19.27.45.4.67.4.07.81.14,1.21.2-.23-.33-.47-.66-.66-1.01-.32-.59-.6-1.21-.88-1.83-.17-.36-.33-.73-.48-1.09-.12-.3-.41-.53-.38-.89-.45-.82-.96-1.41-1.22-2.17-.23-.66-.68-1.24-.95-1.9-.31-.75-.81-1.41-1.02-2.21-.1-.36-.33-.68-.49-1.02-.04-.08-.08-.16-.1-.24-.12-.58-.45-1.05-.78-1.52-.44-.65-.95-1.24-1.21-2.01-.15-.44-.46-.82-.65-1.25-.19-.42-.59-.75-.6-1.26-.44-.51-.47-1.25-.97-1.73-.37-1.23-.96-2.16-1.62-3.06-.33-.45-.65-.91-.96-1.37-.1-.15-.11-.37-.22-.51-.28-.36-.49-.75-.59-1.2-.26-.45-.48-.75-.6-1.09-.34-.9-.64-1.81-.96-2.71-.19-.54-.38-1.08-.59-1.61-.2-.53-.43-1.04-.62-1.57-.15-.41-.22-.86-.43-1.23-.24-.41-.15-.87-.36-1.29-.28-.58-.38-1.25-.54-1.88-.16-.65-.36-1.3-.51-1.95-.07-.3-.19-.59-.26-.88-.06-.27-.09-.55-.13-.82-.04-.28-.07-.55-.09-.83.14-.14.22-.11.28-.05.34.66.53,1.19.85,1.61.38.5.62,1.05.84,1.62.17.44.32.89.48,1.33.09.24.23.47.3.72.16.57.33,1.14.57,1.68.21.46.41.93.6,1.4.16.39.28.79.45,1.17.29.65.63,1.28.91,1.93.13.32.26.64.44.95.05.09.11.19.13.29.16.8.58,1.5.88,2.24.08.21.15.42.21.64.09.32.11.67.25.95.24.47.32.99.47,1.48.15.48.3.95.54,1.4.28.52.54,1.06.77,1.6.42,1,.98,1.92,1.66,2.76.26.32.52.66.76,1c.44.63.6,1.4,1.07,2.02.04.51.58.72.71,1.18.51.55,1,1.13,1.55,1.63.72.65,1.27,1.44,1.83,2.22.31.44.5.96.95,1.3.08.06.12.17.17.26.26.42.56.8.93,1.14.1.09.18.22.26.33.27.34.52.7.8,1.03.27.32.56.63.84.94.16.18.34.35.48.54.13.18.2.39.32.57.35.5.67,1.04,1.1,1.46.47.47.8,1.04,1.31,1.48.59.5,1.15,1.04,1.71,1.58.21,0,.43-.02.63-.07.16-.04.33-.08.49-.12-.27-.35-.54-.69-.94-.93Z"
                fill="#ffece5"
              />
              <path
                d="M1121.18,117.43c-.02-.4-.04-.81-.13-1.2-.25-1.02-.5-2.05-.82-3.05-.25-.79-.67-1.51-1.3-2.08-.82-.75-1.61-1.52-2.42-2.28-.55-.52-.93-.9-1.32-1.28-.54-.53-1.06-1.07-1.64-1.56-.5-.42-1.07-.74-1.58-1.14-.83-.65-1.64-1.33-2.45-1.99-.94-.76-2.03-1.26-3.12-1.75-.85-.38-1.66-.84-2.4-1.41-.65-.5-1.32-.99-2.02-1.43-.97-.61-1.97-1.16-2.96-1.73-.59-.34-1.16-.74-1.78-1.02-1.55-.68-3.02-1.49-4.42-2.46-.47-.33-1.01-.56-1.53-.83-.83-.42-1.71-.77-2.5-1.26-1.02-.63-2.09-1.16-3.16-1.69-.75-.38-1.5-.77-2.25-1.16-.76-.39-1.51-.82-2.3-1.17-.64-.29-1.32-.49-1.98-.73-1.34-.49-2.67-1-4.01-1.46-.81-.28-1.66-.46-2.47-.76-1.2-.45-2.42-.84-3.67-1.16-1.56-.4-3.1-.91-4.71-1.11-1.83-.23-3.65-.52-5.46-.81-1.94-.3-3.88-.64-5.82-.94-.92-.14-1.84-.29-2.76-.36-1.17-.08-2.35-.07-3.53-.11-.34-.01-.58.1-.72.44.07.67.63.57,1.12.65.09.63,0,1.2-.18,1.75-.12.34-.2.67-.19,1.03c0,.32,0,.63-.02.95-.05.66-.11,1.33-.17,1.99-.03.28-.05.56-.1.83-.12.55-.26,1.09-.39,1.64-.12.49-.23.99-.36,1.48-.12.49-.3.98-.36,1.48-.05.43-.05.9.08,1.3.21.67.54,1.3.83,1.93.38.81.78,1.61,1.15,2.43.78,1.69,1.55,3.39,2.32,5.08.28.62.56,1.25.85,1.87.36.76.68,1.55,1.09,2.28.57,1.01,1.22,1.97,1.83,2.96.99,1.61,1.84,3.28,2.47,5.06.26.73.53,1.45.85,2.16.41.91.86,1.81,1.31,2.71.39.78.78,1.58,1.24,2.32.72,1.18,1.31,2.4,1.74,3.72.16.48.38.95.58,1.41.49,1.11.96,2.23,1.49,3.32.29.62.63,1.22,1.02,1.78.6.86,1.29,1.67,1.89,2.53.39.56.7,1.18,1.05,1.76.8,1.34,2.03,2.27,3.15,3.3.43.39.85.79,1.23,1.22.97,1.12,2.09,2.02,3.47,2.6.79.34,1.55.75,2.33,1.12.57.27,1.14.55,1.74.76c1.09.38,2.21.71,3.31,1.06.91.28,1.84.45,2.79.49.44.01.88.05,1.31.12c1.1.17,2.19.24,3.3.08c1.32-.19,2.64-.45,3.89-.93s2.51-.9,3.81-1.22c1.65-.41,3.29-.9,4.92-1.38.69-.21,1.32-.56,1.87-1.04.48-.41,1-.77,1.51-1.15.34-.25.67-.51,1-.77.47-.37.91-.77,1.39-1.12.84-.61,1.71-1.18,2.41-1.96.07-.08.15-.15.23-.21.78-.57,1.55-1.15,2.33-1.71.6-.43,1.16-.91,1.59-1.52.52-.73,1.03-1.47,1.55-2.19.45-.62.76-1.31,1-2.03.25-.75.61-1.43,1.12-2.01.6-.68,1.07-1.43,1.52-2.21.87-1.51,1.38-3.12,1.41-4.86.01-1.12-.06-2.25-.12-3.37Z"
                fill="#81c6b2"
              />
              <g>
                <path
                  d="M1106.45,118.07c-.15-.77-.28-1.56-.53-2.31-.58-1.72-1.45-3.31-2.19-4.96-.07-.16-.16-.32-.25-.46-.79-1.16-1.58-2.32-2.37-3.48-.28-.37-.58-.59-1.02-.48-.43.26-.68.6-.89,1-.31.59-.72,1.13-.96,1.75-.22.56-.5,1.07-.78,1.6-.62,1.13-1.51,1.91-2.7,2.4-.59.25-1.15.61-1.69.97-.49.33-.74.84-.73,1.44c0,.16.01.32,0,.47-.02.31.1.55.35.73.82.57,1.64,1.14,2.47,1.71.48.33.96.65,1.43.98.25.17.48.37.74.5.92.48,1.87.89,2.89,1.14.37.09.74.23,1.11.34.42.12.84.28,1.27.33.72.08,1.41.27,2.09.53.55.21,1.11.18,1.66.08.46-.08.59-.26.6-.72c0-.21.01-.43-.02-.63-.15-.97-.29-1.94-.47-2.91Z"
                  fill="#2b231d"
                />
                <path
                  d="M1085.65,113.39c-.06-.07-.13-.12-.2-.17-.49-.4-.97-.81-1.47-1.21-.25-.2-.5-.38-.77-.55-.96-.61-1.85-1.34-2.89-1.84-.12-.06-.22-.17-.34-.25-.23-.15-.46-.33-.71-.45-1.06-.5-1.87-1.37-2.86-1.97-.13-.08-.23-.22-.35-.32-.15-.13-.29-.25-.45-.36-.62-.43-1.24-.87-1.89-1.25-.34-.2-.73-.36-1.11-.45-.35-.08-.53.15-.47.5.38,1.17.74,2.12,1.23,3.02.24.45.49.89.73,1.34.39.73.78,1.46,1.18,2.18.56,1.01,1.2,1.99,1.51,3.13.03.12.09.23.13.35.23.66.71,1.03,1.36,1.2.14.04.27.08.41.1c1.1.18,2.2.18,3.31.18.18,0,.35-.04.53-.02.73.08,1.44-.04,2.15-.14.62-.08,1.25-.17,1.87-.26.45.06.83.12.98-.27.14-.37-.03-.72-.31-.94-.58-.46-1.1-.98-1.58-1.54Z"
                  fill="#2b231d"
                />
                <path
                  d="M1104.7,126.6c-.36-.33-.75-.64-1.08-1-.5-.54-1.05-.97-1.78-1.17-.47-.13-.93-.34-1.36-.56-.58-.3-1.12-.65-1.68-.99-.18-.11-.38-.21-.52-.36-.58-.61-1.36-.94-2.01-1.43-.38-.28-.75-.57-1.14-.84-.18-.13-.37-.27-.58-.34-.1-.04-.3.02-.37.1s-.05.25-.04.38c.56.85,1.01,1.52,1.49,2.17c1.25,1.73,2.51,3.44,3.74,5.17.52.73.95,1.52,1.47,2.25.81,1.13,1.62,2.26,2.64,3.21.17.15.3.35.44.52.54.63,1.2,1.14,1.9,1.58.43.27.85.56,1.29.82.37.23.76.44,1.15.64.31.16.61.08.89-.11.53-.35,1.07-.68,1.6-1.02.29-.19.58-.39.87-.6.18-.13.28-.32.26-.55-.11-.65-.29-1.25-.87-1.68-.73-.55-1.41-1.16-1.96-1.9-.16-.21-.34-.4-.53-.59-.76-.76-1.51-1.52-2.28-2.27-.5-.49-1.02-.97-1.53-1.45Z"
                  fill="#2b231d"
                />
                <path
                  d="M1081.35,105.1c-.4.96-.32,1.52.43,2.22.31.29.58.62.89.9.43.38.87.77,1.34,1.1.71.49,1.46.91,2.18,1.38.29.19.59.4.82.66.75.81,1.64,1.42,2.64,1.89.55.26,1.02.25,1.55-.05.71-.4,1.22-1,1.7-1.63.42-.57.92-1.06,1.48-1.49.3-.23.56-.53.83-.81.39-.4.75-.83,1.15-1.22.5-.48.85-1.06,1.18-1.67.11-.21.21-.44.34-.64.34-.55.7-1.09,1.08-1.67-.09-.11-.16-.19-.23-.27-.82-.82-1.63-1.65-2.47-2.45-.89-.85-1.78-1.7-2.7-2.51-.66-.58-1.36-1.1-2.17-1.47-1.23-.57-2.42-1.21-3.63-1.82-.22-.11-.44-.23-.67-.3-.57-.16-.93-.02-1.17.52-.4.9-.83,1.78-1.13,2.72-.29.9-.72,1.71-1.2,2.51-.81,1.33-1.62,2.67-2.23,4.12Z"
                  fill="#2b231d"
                />
                <path
                  d="M1079.34,126.74c-.17-.42-.39-.83-.61-1.23-.75-1.4-1.47-2.8-1.97-4.31-.18-.53-.41-1.04-.64-1.56-.65-1.46-1.36-2.9-1.96-4.38-.5-1.25-1.12-2.43-1.87-3.54-.56-.83-1.12-1.66-1.48-2.61-.09-.24-.23-.48-.36-.7-.75-1.23-1.5-2.46-2.25-3.69-.11-.18-.22-.36-.32-.55-.32-.58-.74-1.06-1.23-1.5-.5-.44-.99-.91-1.39-1.44-.51-.67-1.11-1.21-1.79-1.7-.6-.43-1.14-.93-1.72-1.39-.36-.28-.72-.56-1.09-.82-.52-.36-1.07-.68-1.57-1.07-1.27-1-2.53-2.02-3.78-3.05-1.64-1.35-3.45-2.48-5.08-3.86-.26-.22-.56-.37-1.01-.15.03.24.03.46.08.68.15.67.3,1.34.5,1.99.26.84.45,1.72.99,2.43.91,1.21,1.86,2.39,2.8,3.57.77.96,1.59,1.88,2.36,2.84.57.72,1.12,1.44,1.79,2.08.34.32.67.68.93,1.07.49.74,1.12,1.35,1.78,1.93.39.35.78.72,1.08,1.15.5.71,1.1,1.31,1.75,1.9.44.4.81.87,1.19,1.33.43.53.82,1.1,1.27,1.61.72.82,1.4,1.67,1.98,2.6.55.88,1.17,1.71,1.75,2.57.37.55.73,1.11,1.09,1.68.31.49.59,1,.92,1.48.86,1.29,1.78,2.53,2.52,3.9.28.52.61,1.03.98,1.5.58.74,1.01,1.55,1.39,2.41.55,1.24,1.08,2.48,1.83,3.62.36.54.64,1.13.96,1.7.32.55.61,1.11.97,1.63.63.91,1.3,1.79,1.96,2.68.09.12.21.22.29.31.31-.05.32-.24.33-.44.07-1.3-.13-2.57-.6-3.77-.9-2.31-1.85-4.6-2.79-6.89Z"
                  fill="#2b231d"
                />
                <path
                  d="M1111.28,112.82c.28-.35.27-.69.06-1.07-.4-.74-.92-1.37-1.58-1.89-.37-.29-.73-.6-1.1-.91-.76-.63-1.5-1.26-2.43-1.66-.49-.21-.93-.56-1.39-.86-.41-.26-.82-.54-1.24-.79-.15-.09-.33-.11-.49-.16-.16.04-.3.06-.43.11-.35.15-.45.38-.28.71.28.57.57,1.13.87,1.69.65,1.22,1.36,2.42,1.92,3.7.47,1.08,1.04,2.12,1.58,3.16.2.39.47.75.73,1.09.17.22.38.42.6.59.22.18.5.22.73.03.33-.29.72-.56.93-.93.42-.76,1.02-1.44,1.24-2.31.05-.18.14-.36.26-.51Z"
                  fill="#2b231d"
                />
                <path
                  d="M1115.76,129.89c-.87-.64-1.59-1.43-2.29-2.25-.19-.23-.4-.45-.63-.63-.95-.77-1.77-1.66-2.48-2.65-.19-.27-.43-.51-.69-.72-.51-.41-1.1-.32-1.55.17-.21.23-.46.42-.7.63-.14.13-.31.23-.44.37-.41.43-.45.68-.13,1.17.25.38.53.74.84,1.08.75.79,1.52,1.57,2.28,2.34.27.28.53.56.82.82.8.71,1.61,1.42,2.43,2.11.57.47,1.17.89,1.88,1.13.39-.56.78-1.12,1.18-1.67.19-.27.35-.55.5-.83-.27-.42-.63-.76-1.03-1.05Z"
                  fill="#2b231d"
                />
                <path
                  d="M1091.12,118.58c-.26-.27-.54-.45-.9-.5-.24-.03-.49-.04-.73-.05-.84-.03-1.69-.06-2.53-.09-1.03-.03-2.07-.08-3.11-.09-.44,0-.88.05-1.29.07-.99-.09-1.92.12-2.86.28-.15.03-.31.07-.45.13-.36.17-.48.44-.36.82.09.3.2.6.34.89.53,1.15,1.06,2.3,1.62,3.43.67,1.36,1.35,2.71,2.07,4.04.52.96,1.09,1.89,1.65,2.83.37.64.71,1.3,1.15,1.89.51.69,1.1,1.33,1.69,1.96.7.74,1.43,1.45,2.17,2.15.26.25.54.24.72-.06.32-.54.71-1.05.85-1.69.29-1.3.63-2.59.85-3.91.2-1.21.28-2.44.4-3.66.05-.44.06-.88.14-1.31.27-1.36.32-2.72.02-4.08-.25-1.13-.62-2.2-1.44-3.07Z"
                  transform="translate(.000001 0)"
                  fill="#2b231d"
                />
                <path
                  d="M1051.88,87.07c.42.31.86.63,1.22,1c.41.42.85.78,1.36,1.08.47.27.93.57,1.39.86.42.26.83.53,1.24.8.35.23.74.43,1.04.71c1.03.96,2.02,1.96,3.04,2.93c1.81,1.71,3.73,3.26,5.92,4.46.23.13.47.25.67.42.59.49,1.26.83,1.95,1.15.24.11.47.24.7.37c1.06.59,2.11,1.19,3.17,1.78.15.09.32.14.47.23.5.28,1,.58,1.51.86.57.31,1.14.63,1.72.91.49.23.93.07,1.29-.31.12-.13.22-.28.3-.43.48-.96.97-1.91,1.43-2.88.51-1.07,1.02-2.12,1.79-3.04.25-.29.41-.66.59-1c.21-.39.39-.79.59-1.18.28-.53.57-1.04.9-1.63-.17-.15-.28-.27-.41-.34-1.3-.69-2.58-1.44-3.92-2.05-1.73-.79-3.55-1.35-5.41-1.76-.53-.12-1.06-.25-1.59-.39-1.19-.31-2.38-.62-3.57-.94-1.88-.51-3.77-1.01-5.65-1.53-1.1-.31-2.18-.69-3.29-.96-2.25-.55-4.52-1.09-6.82-1.37-.93-.11-1.89,0-2.84.01-.22,0-.41.11-.44.41.05.1.1.23.18.34.4.59.92,1.06,1.49,1.48Z"
                  fill="#2b231d"
                />
                <path
                  d="M1078.65,138.75c-.28-.58-.68-1.06-1.14-1.5-.54-.51-1.02-1.06-1.38-1.72-.32-.58-.74-1.11-1.13-1.65-.27-.37-.58-.71-.82-1.1-.59-.92-1.15-1.86-1.73-2.78-.76-1.21-1.54-2.39-2.12-3.71-.55-1.24-1.25-2.4-2.06-3.49-.43-.58-.75-1.23-1.15-1.83-.3-.46-.61-.9-.94-1.34-.5-.68-1.06-1.32-1.52-2.02-.82-1.23-1.63-2.46-2.63-3.56-.36-.4-.61-.9-.9-1.35-.28-.43-.55-.86-.84-1.27-.52-.73-1.07-1.44-1.59-2.17-.88-1.25-1.74-2.52-2.6-3.79-.24-.35-.47-.7-.66-1.08-.38-.76-.84-1.46-1.41-2.09-.36-.4-.68-.85-1.02-1.28-.42-.54-.78-1.13-1.25-1.63-.75-.79-1.56-1.53-2.35-2.27-.19-.18-.42-.32-.65-.45-.19-.11-.39-.17-.61.06-.01.35.18.61.34.88.12.19.25.38.37.58.38.61.73,1.25,1.15,1.83.81,1.11,1.53,2.28,2.16,3.5.41.8.89,1.56,1.34,2.33.42.73.89,1.44,1.26,2.19.7,1.4,1.34,2.83,2.32,4.07.18.23.32.5.45.77.66,1.41,1.53,2.69,2.38,3.98.39.58.71,1.21,1.07,1.82.31.53.6,1.08.95,1.58.74,1.07,1.53,2.11,2.12,3.27.45.88,1.01,1.69,1.61,2.47.36.47.68.99.92,1.53.62,1.37,1.37,2.65,2.2,3.9.32.48.59,1,.89,1.49.29.48.54,1,.9,1.42.79.93,1.47,1.93,2.16,2.93.55.79,1.18,1.53,1.8,2.27.46.55.97,1.07,1.45,1.6.54.61,1.13,1.17,1.86,1.54.54.28.81.18.99-.41.17-.55.27-1.13.45-1.68.11-.35.07-.65-.11-.95s-.38-.6-.53-.91Z"
                  fill="#2b231d"
                />
                <path
                  d="M1105.5,139.88c-.81-1.01-1.6-2.05-2.36-3.1-.77-1.07-1.49-2.17-2.24-3.26-.31-.45-.64-.89-.91-1.36-.91-1.59-1.98-3.08-3.13-4.49-.4-.49-.88-.91-1.34-1.34-.28-.25-.53-.14-.6.23-.03.15-.02.32-.02.47.04.93.46,1.76.68,2.64.17.68.46,1.33.62,2.01.22.93.55,1.81.92,2.68.49,1.15,1.01,2.28,1.53,3.41.13.28.31.55.5.8.67.86,1.51,1.57,2.1,2.5.77.75,1.41,1.34,1.93,2.04.38-.19.73-.43,1.07-.71.48-.41,1-.77,1.51-1.15.21-.16.42-.32.63-.48-.31-.29-.64-.57-.9-.9Z"
                  fill="#2b231d"
                />
                <path
                  d="M1115.22,108.19c-.37.43-.72.86-1.1,1.28-.43.48-.67,1.04-.82,1.68-.16.67-.01,1.21.39,1.72.11.14.21.28.34.4.97.92,1.85,1.92,2.68,2.98.96,1.23,1.93,2.46,2.87,3.71.37.49.67,1.03,1.04,1.52.19.26.41.37.61.36.05-.38.09-.77.09-1.17.01-1.12-.06-2.25-.12-3.37-.02-.4-.04-.81-.13-1.2-.25-1.02-.5-2.05-.82-3.05-.04-.14-.1-.28-.16-.41-.27-.49-.57-.97-.9-1.42-.08-.08-.15-.17-.24-.25-.76-.69-1.5-1.4-2.25-2.11-.34-.23-.68-.47-.88-.84-.37-.12-.49.03-.62.18Z"
                  fill="#2b231d"
                />
                <path
                  d="M1050.78,79.59c-.3.02-.6.01-.89.07-.35.07-.45.3-.31.63.03.08.08.15.13.23.41.67.83,1.35,1.04,2.12.04.15.12.29.19.44.13.28.34.44.65.47.44.04.87.1,1.31.14c1.78.19,3.56.39,5.34.59c2.22.25,4.43.59,6.62.98.21.04.41.1.61.16c1.18.34,2.36.71,3.55,1.03c1.69.45,3.45.68,5.05,1.46c1.15.56,2.33,1.07,3.55,1.47c1.73.88,3.43,1.54,5.16,2.15.53.19,1.07.35,1.61.49.53.14.92-.03,1.21-.51.15-.26.31-.52.42-.79.22-.58.2-1.17-.31-1.52-.1-.07-.2-.14-.3-.21-.66-.33-1.31-.68-1.97-1.02-.14-.07-.27-.14-.41-.22-.72-.33-1.44-.65-2.15-1.01-.25-.13-.51-.24-.77-.35-.32-.11-.63-.22-.95-.33-.56-.2-1.12-.41-1.68-.62-.2-.07-.4-.13-.61-.2-1.72-.59-3.47-1.03-5.23-1.44-1.87-.44-3.71-.97-5.57-1.44-1.16-.29-2.32-.6-3.49-.82-3.1-.59-6.21-1.14-9.32-1.68-.84-.15-1.66-.22-2.47-.33v.04Z"
                  fill="#2b231d"
                />
                <path
                  d="M1104.36,101.05c-.04.1-.03.21-.06.31-.1.49-.07.97,0,1.46.08.54.26,1.01.67,1.39.28.26.54.56.82.82.33.32.66.64,1.01.93.73.61,1.47,1.21,2.21,1.8.68.54,1.36,1.07,2.19,1.34.61.2.85.13,1.18-.43s.79-1.04.97-1.68c.04-.14.18-.26.26-.39.1-.15.19-.3.29-.45-.11-.1-.22-.21-.33-.31-.5-.42-1.07-.74-1.58-1.14-.83-.65-1.64-1.33-2.45-1.99-.94-.76-2.03-1.26-3.12-1.75-.28-.12-.55-.26-.81-.4-.83-.24-1.02-.14-1.26.49Z"
                  fill="#2b231d"
                />
                <path
                  d="M1087.66,92.47c-.19.47-.08.82.36,1.08.29.17.6.28.91.42.87.41,1.75.81,2.62,1.23.26.13.5.33.72.53c1.46,1.32,2.94,2.62,4.37,3.97c1.34,1.26,2.96,2.01,4.68,2.55.87.27,1.34-.05,1.52-.93.16-.8.09-1.61.09-2.42-.32-.4-.61-.6-.9-.78-.97-.61-1.97-1.16-2.96-1.73-.59-.34-1.16-.74-1.78-1.02-1.55-.68-3.02-1.49-4.42-2.46-.47-.33-1.01-.56-1.53-.83-.8-.41-1.64-.75-2.41-1.21-.61.5-1.02.99-1.26,1.59Z"
                  fill="#2b231d"
                />
                <path
                  d="M1088.91,142.82c-.19-.91-.51-1.79-.76-2.68-.35-1.29-1.08-2.35-2.01-3.29-.08-.08-.2-.13-.32-.21-.12.1-.27.16-.33.27-.36.58-.92.96-1.37,1.45-.72.77-1.42,1.55-1.77,2.59-.19.56-.46,1.1-.71,1.64-.4.88-.85,1.73-1.22,2.63-.07.17-.11.31-.12.45.69.22,1.38.43,2.07.65.91.28,1.84.45,2.79.49.44.01.88.05,1.31.12.8.12,1.61.19,2.42.16.03-.74.14-1.47.16-2.2.02-.68,0-1.38-.14-2.04Z"
                  fill="#2b231d"
                />
                <path
                  d="M1097.9,141.81c-1.4-2.7-1.76-3.19-3.76-5.3-.19-.2-.38-.42-.73-.39-.05.07-.12.13-.14.21-.14.54-.35,1.08-.39,1.63-.11,1.42-.39,2.81-.7,4.2-.26,1.16-.56,2.32-.81,3.49-.08.37-.11.73.02,1.05.77-.16,1.53-.36,2.27-.64c1.25-.48,2.51-.9,3.81-1.22.54-.13,1.07-.27,1.6-.42-.08-.19-.17-.38-.26-.58-.3-.67-.57-1.36-.91-2.02Z"
                  fill="#2b231d"
                />
                <path
                  d="M1116.47,118.95c-.53-.85-1.12-1.66-1.71-2.47-.58-.79-1.42-1.3-2.17-1.91-.27-.22-.62-.14-.8.18-.11.2-.19.42-.26.63-.3.98-.63,1.93-1.3,2.74-.08.09-.12.22-.19.32-.18.27-.22.57-.13.86.11.37.21.76.43,1.07.64.93,1.31,1.83,2,2.71.63.8,1.29,1.58,1.94,2.36.25.3.5.59.78.85.72.67,1.46,1.32,2.18,1.99.19.17.37.27.54.3.17-.31.37-.6.61-.86.6-.68,1.07-1.43,1.52-2.21.08-.13.15-.27.22-.4-.11-.26-.24-.51-.38-.76-1.09-1.81-2.17-3.62-3.29-5.41Z"
                  fill="#2b231d"
                />
              </g>
            </g>
            <g id="e0gYpSRcAlv2320" transform="translate(.000001 0.000014)">
              <path
                d="M1025.23,124.17c-.05-.23-.1-.45-.13-.67-.08-.5-.13-1.01-.21-1.51-.1-.66-.25-1.31-.24-1.98.04-1.74.08-3.47.08-5.21-.01-2.51.03-5.03-.1-7.54-.08-1.49.05-2.98.06-4.48c0-1.48-.03-2.96,0-4.43.01-.74-.27-1.26-.88-1.61-.72-.4-1.21-1-1.64-1.68-.48-.77-.98-1.54-1.48-2.31-.39-.59-.71-1.21-.91-1.89-.03-.12-.13-.21-.26-.39-.19.23-.33.37-.43.54-.34.57-.64,1.18-1,1.74-.78,1.19-1.64,2.33-2.66,3.33-.28.27-.56.54-.78.85-.75,1.05-1.6,1.99-2.61,2.81-.42.34-.82.73-1.14,1.17-.77,1.05-1.62,2.03-2.54,2.96-.36.35-.65.79-.91,1.22-.49.81-.92,1.66-1.57,2.37-.39.43-.75.88-1.11,1.34-1.11,1.45-2.16,2.95-3.42,4.28-.4.42-.79.85-1.13,1.32-.91,1.21-1.84,2.4-2.95,3.44-.36.34-.68.72-.95,1.13-.57.86-1.24,1.61-1.97,2.33-.52.52-1.07,1.03-1.49,1.64-.7,1.01-1.5,1.9-2.36,2.76-.42.42-.81.88-1.15,1.37-.63.9-1.35,1.71-2.12,2.48-.42.42-.83.86-1.2,1.33-.72.92-1.47,1.8-2.3,2.61-.43.42-.85.85-1.25,1.28-.79.85-1.55,1.72-2.35,2.57-1.49,1.59-3,3.16-4.49,4.75-.25.26-.51.59-.58.92-.14.63-.08,1.27.45,1.76.23.21.47.42.71.63.78.69,1.58,1.35,2.33,2.06.98.93,1.95,1.88,3.09,2.63.42.28.88.52,1.35.69.54.2,1.11.33,1.67.45.79.18,1.55.47,2.37.46.19.08,4.73.06,4.73.06.51-.11,1.02-.23,1.53-.32.78-.14,1.56-.22,2.33-.38c1.01-.21,2.02-.47,3.02-.74.79-.21,1.53-.53,2.18-1.03.79-.61,1.6-1.21,2.39-1.81.67-.51,1.3-1.07,2.09-1.41.85-.37,1.69-.79,2.54-1.16.38-.17.79-.3,1.2-.4c1.4-.34,2.81-.6,4.2-.98c2.5-.68,4.44-2.09,5.48-4.54.56-1.32,1.1-2.67,1.57-4.02.5-1.42.9-2.89,1.37-4.32.45-1.36,1.01-2.67,1.87-3.82.45-.6.85-1.26,1.62-1.53.16-.49.53-.77.97-.95-.05-.5-.27-.54-.88-.16Z"
                fill="#f37e5a"
              />
              <path
                d="M1021.9,126.91c0-.17.06-.34.06-.52c0-.26,0-.52-.01-.78c0-.14-.09-.3-.04-.41.15-.36.07-.72.08-1.08.02-.83-.08-1.66-.01-2.49.04-.49-.16-1,.07-1.49-.24-.37-.07-.66-.08-.95c0-.19.03-.38-.12-.55-.05-.06-.03-.19-.02-.28c0-.14.04-.28.02-.42-.09-.65-.19-1.29-.3-1.94-.13-.71-.29-1.42-.43-2.13-.07-.34-.17-.67-.22-1.01-.09-.58-.15-1.17-.21-1.75c0-.1.05-.2.07-.3-.22-.35-.08-.57-.07-.78c0-.14.06-.27.05-.4-.02-.45-.06-.91-.08-1.36-.01-.19,0-.39,0-.58c0-.46-.15-.9-.05-1.37.04-.17-.04-.37-.05-.55-.01-.17,0-.34,0-.51-.03-.47.11-.95-.03-1.4-.14-.46-.08-.89-.01-1.34.04-.28.04-.56.02-.84-.06-.64-.17-1.27-.2-1.9-.03-.56-.13-1.12-.15-1.69-.02-.65-.19-1.3-.3-1.95-.05-.27-.09-.57-.23-.8-.15-.23-.11-.5-.25-.74-.36-.61-.33-.77-.16-1.53.04-.19.13-.36.17-.55.06-.29,0-.43-.21-.51-.18-.07-.68.09-.75.25-.1.22-.18.45-.26.69-.29.94-.55,1.89-.87,2.83-.19.57-.46,1.12-.7,1.67-.03.08-.13.17-.21.18-.34.05-.5.26-.64.55-.22.42-.33.91-.73,1.23-.08.72-.76,1.03-.7,1.65-.3.25-.28.64-.42.96-.35.8-.25,1.71-.63,2.51-.07.55-.13.95-.2,1.34-.03.17-.04.35-.12.5-.26.48-.49.98-.85,1.41-.08.09-.14.21-.18.32-.21.56-.57,1.02-.9,1.5-.55.8-.98,1.67-1.37,2.56-.05.12-.02.26-.07.38-.12.27-.28.52-.39.79-.25.64-.48,1.3-.72,1.94-.14.37-.3.74-.45,1.1-.19.47-.37.94-.59,1.4-.35.73-.74,1.45-1.11,2.18-.26.66-.45,1.18-.66,1.69-.08.19-.16.37-.28.54-.17.25-.27.52-.36.8-.14.43-.32.85-.46,1.28-.15.45-.39.89-.34,1.39-.24.16-.04.42-.13.62-.26.59-.5,1.19-.77,1.77-.38.8-.82,1.57-1.21,2.37-.29.61-.73,1.1-1.08,1.66-.23.38-.55.72-.83,1.07-.05.07-.08.15-.12.23-.07.14-.13.28-.2.41-.25.46-.5.91-.75,1.37-.14.26-.27.53-.44.77-.59.87-1.39,1.55-2.1,2.3-.37.4-.65.83-.95,1.27-.57.84-1.09,1.71-1.76,2.48-.28.32-.55.65-.78,1.03-.28.46-.6.88-.98,1.28-.33.35-.58.78-.87,1.17-.67.68-1.01,1.36-1.43,1.98-.3.45-.51.94-.95,1.32-.36.31-.68.7-.98,1.08-.31.38-.61.75-.97,1.08-.27.25-.49.55-.72.84.13.01.25.02.38.02.19.08.66.08.66.08.4-.45.91-.75,1.31-1.18.43-.47,1.01-.8,1.28-1.42.63-.53.94-1.06,1.29-1.55.3-.42.57-.87.88-1.29.37-.49.76-.95,1.14-1.43.17-.19.36-.37.52-.58.36-.47.77-.91,1.11-1.38.46-.65,1.05-1.2,1.42-1.91.15-.29.44-.51.56-.81.22-.56.69-.9,1.05-1.34.36-.43.79-.79,1.17-1.2.25-.26.46-.56.68-.84.15-.21.3-.41.45-.62.14-.49.36-.73.51-1c.18-.33.3-.69.47-1.02.27-.53.68-.99,1.03-1.47.67-.92,1.3-1.86,1.72-2.92.17-.42.34-.83.53-1.23.17-.38.34-.76.54-1.12.2-.37.14-.8.3-1.18.23-.56.3-1.17.51-1.74.2-.54.43-1.07.63-1.61.34-.93.69-1.86,1.12-2.75.3-.63.6-1.26.86-1.9.34-.82.64-1.66.96-2.49.2-.53.38-1.07.58-1.61.22-.62.44-1.25.67-1.87.03-.1.07-.19.11-.29.12-.27.26-.53.36-.81.09-.25.19-.48.37-.69.16-.19.35-.4.32-.7.4-.39.47-.74.61-1.06.32.11.35.38.31.63-.09.5-.19.99-.34,1.47-.15.49-.19,1-.4,1.47-.04.09-.07.2-.1.3-.2.99-.44,1.96-.75,2.92-.11.32-.16.66-.31.97-.18.39-.24.83-.36,1.24-.09.32-.16.64-.28.94-.22.56-.5,1.11-.7,1.68-.19.55-.33,1.12-.54,1.65-.35.86-.48,1.83-1.11,2.58-.05.06-.06.16-.09.24-.11.34-.14.72-.44.99-.08.07-.14.16-.18.26-.37.87-1.08,1.53-1.43,2.4-.33.12-.38.45-.51.7-.29.51-.53,1.05-.78,1.59-.23.49-.42.99-.65,1.48-.19.4-.39.8-.62,1.19-.27.45-.42.96-.66,1.43-.17.32-.28.68-.47.99-.31.5-.67.98-1.01,1.46-.38.54-.68,1.12-.9,1.74-.31.9-.69,1.77-1.1,2.62-.19.39-.49.72-.51,1.19c0,.11-.09.32-.13.31-.21-.01-.21.14-.25.27-.08.26-.14.53-.34.74-.07.08-.07.23-.12.33-.22.42-.42.86-.69,1.25-.19.27-.44.49-.36.87.01.06-.06.15-.11.21-.07.1-.17.18-.23.29-.2.33-.28.71-.48,1.04-.11.19-.03.39-.17.59-.24.34-.37.76-.58,1.14-.23.42-.4.87-.76,1.21.3.02.67-.04,1.03-.11.28-.37.47-.74.73-1.07.37-.46.56-1.08.78-1.65.05-.12.09-.24.15-.36.29-.53.56-1.07.86-1.59.22-.38.47-.74.7-1.12.11-.18.21-.36.31-.55.22-.45.32-.95.61-1.37.24-.35.36-.79.6-1.14.2-.29.14-.7.47-.91.04-.29.06-.37.1-.45.18-.32.37-.63.55-.94.05-.09.1-.2.1-.29c0-.54.36-.93.58-1.37.2-.38.54-.68.76-1.05.34-.56.8-1.06.96-1.71.23-.38.43-.73.6-1.09.27-.57.52-1.14.79-1.71.25-.52.55-1.02.76-1.55.4-1,.92-1.92,1.51-2.81.07-.1.13-.22.22-.29.39-.3.57-.75.81-1.13.39-.6.65-1.3.95-1.96.12-.25.16-.54.3-.78.3-.54.52-1.1.68-1.69.13-.48.31-.95.46-1.42.18-.57.51-1.1.59-1.72.29-.7.52-1.26.71-1.83.15-.44.27-.9.4-1.35.11-.4.22-.8.33-1.21.04-.13.08-.25.13-.37.05.25.06.49,0,.71-.06.25.17.51-.02.75.03.51-.04,1.01-.2,1.5-.03.08,0,.17,0,.26-.04.52-.07,1.04-.11,1.57-.02.28.02.58-.05.85-.21.75-.08,1.53-.22,2.28-.04.22-.14.44-.11.65.07.51-.13.99-.18,1.48-.09.81-.33,1.59-.52,2.39-.07.32-.2.63-.24.96-.07.51-.22.98-.46,1.43-.07.12-.15.25-.16.39-.03.69-.46,1.25-.64,1.9-.14.5-.36.97-.54,1.47-.08.24-.08.53-.22.71-.12.14-.19.29-.23.45-.14.53-.27,1.07-.57,1.54-.26.4-.47.85-.74,1.24-.43.61-.84,1.23-1.22,1.88-.3.51-.62,1.01-.9,1.54-.27.51-.73.92-.83,1.53-.34.55-.69.94-.76,1.46-.05.39-.24.72-.46,1.05-.27.41-.51.83-.76,1.25-.04.07-.1.18-.07.24.09.17-.01.26-.11.36-.07.08-.17.15-.2.24-.25.67-.72,1.22-1.01,1.87-.05.12-.11.24-.18.36.6-.46,1.21-.91,1.81-1.37.09-.07.18-.14.27-.21.13-.22.24-.44.3-.7.57-.69.83-1.57,1.33-2.3.09-.13.13-.28.19-.43.08-.21.14-.43.25-.63.15-.29.32-.56.41-.89.07-.26.18-.57.37-.74.36-.32.55-.74.84-1.11.14-.18.17-.46.3-.65.3-.46.66-.88.97-1.34.66-.98,1.34-1.94,1.72-3.08.22-.66.46-1.31.7-1.97.17-.47.34-.94.51-1.41.14-.39.3-.77.44-1.16.12-.33.22-.66.34-.99.16-.48.32-.96.49-1.43-.13-.34.13-.58.21-.87.03-.1.08-.2.09-.3.09-.56.23-1.11.36-1.65.02-.08.07-.17.06-.25-.12-.63.31-1.22.16-1.86.25-.5.2-.96.23-1.38.06-.75.14-1.49.2-2.24.06-.78.13-1.56.18-2.34.03-.41.07-.82.05-1.24-.01-.36.05-.73.09-1.09.02-.24.06-.48.09-.72.03-.26.07-.51.1-.77.02-.2,0-.41.02-.61.06-.52.14-1.03.2-1.55.05-.47.07-.94.11-1.41c0-.1.06-.2.09-.3s.11-.2.1-.29c-.03-.49.13-.95.2-1.42.05-.33.09-.66.11-.99.01-.23.01-.45.13-.66s.11-.44.03-.66c-.06-.15-.02-.23.07-.37.17-.25.29-.53.31-.86.02-.42.02-.87.3-1.23.05-.07.09-.16.09-.24c0-.39-.02-.77.25-1.09-.02-.42.19-.68.24-.99.02-.13.08-.28.27-.27c0,.11-.01.22-.02.33c0,.77.03,1.38-.1,1.98-.03.13,0,.28.01.42.01.23.11.5.03.7-.22.61-.24,1.26-.34,1.89-.08.53.03,1.08-.04,1.61-.07.55,0,1.09-.05,1.63-.04.55-.09,1.1-.02,1.66.02.17-.04.34-.05.52c0,.21,0,.41,0,.62c0,.1.05.21.05.31c0,.65.04,1.31-.05,1.96-.04.32-.07.66-.02.97s.05.61.03.91c-.04,1.07-.06,2.15-.15,3.21-.08.85.04,1.7-.06,2.56-.1.79,0,1.61-.11,2.41-.07.51-.06,1.04-.14,1.56-.07.46-.19.92-.18,1.4c0,.15-.06.31-.08.46-.04.2-.08.41-.12.61-.03.23.02.51-.1.68-.17.24.02.48-.1.7-.05.09-.06.2-.11.29-.11.23-.18.46-.15.74.02.16-.03.34-.09.52-.16.47-.39.93-.39,1.45c0,.13-.07.27-.11.4-.09.3-.2.59-.26.9-.04.16.06.38-.01.5-.24.37-.22.81-.33,1.2-.28.98-.51,1.98-.9,2.94-.13.33-.19.69-.31,1.03-.23.65-.58,1.25-.89,1.86-.09.18-.15.4-.29.55-.2.21-.23.54-.4.7-.24.23-.26.53-.42.77-.1.14-.17.3-.27.44.4-.08.81-.17,1.21-.26.06-.08.12-.16.17-.24.28-.42.51-.87.78-1.29.28-.44.54-.9.81-1.36.13-.22.27-.47.3-.71.04-.29.16-.53.29-.78.09-.52.31-.8.38-1.13.11-.5.46-.9.49-1.45.03-.52.46-.97.38-1.54.25-.28.22-.65.31-.98.23-.84.44-1.68.66-2.53.07-.25.16-.5.22-.75.11-.53.2-1.06.31-1.58.14-.65.34-1.28.36-1.97.02-.65.17-1.3.25-1.95.05-.36.05-.73.11-1.09.15-.81.11-1.63.18-2.45.04-.48.13-.96,0-1.44-.02-.1,0-.21,0-.32.05-.5.13-1,.14-1.5.01-.42-.02-.84,0-1.27.03-.52-.02-1.03.02-1.56.06-.8.01-1.6-.02-2.41c0-.14-.01-.26,0-.4.02-.25.12-.52-.08-.75.19-.34.08-.72.09-1.07.03-1.12,0-2.24,0-3.36c0-.19-.09-.38-.07-.56.03-.34.12-.68.16-1.03.04-.36.06-.73.09-1.09-.26-.19-.02-.36.02-.54.03-.15.14-.28.03-.45-.06-.09-.03-.24-.02-.36.02-.26.1-.52.08-.78-.05-.48.16-.96.01-1.45.1-.6.19-.99.18-1.39-.02-.61.08-1.2.19-1.79.11-.61.29-1.22.44-1.82.07-.27.21-.55.17-.81-.05-.29.09-.45.22-.79.06.41.08.7.15.98.07.29.04.57.05.86.01.41.12.82.16,1.24.03.37.02.75.04,1.13.01.18.12.37.09.54-.09.61.01,1.22-.01,1.83-.01.29,0,.59.01.88.02.32.08.64.08.96c0,.57-.06,1.14-.07,1.72c0,.22.06.45.08.67.01.24,0,.49,0,.73.09.66.02,1.12-.03,1.58-.03.27.02.54.03.8c0,.28,0,.55,0,.83c0,.24-.07.46.02.71.11.3.16.66.12.98-.08.71.09,1.37.26,2.03.11.42.08.84.19,1.25.09.35.03.75.16,1.08.28.74.23,1.53.36,2.28.12.71.1,1.45.14,2.18.03.41,0,.83,0,1.25c0,1.03.01,2.06.01,3.1c0,.73.09,1.46-.08,2.18-.02.08.03.17.03.26.03.47.1.95-.05,1.41-.03.1-.07.2-.09.3-.11.88-.21,1.76-.3,2.64-.08.78-.14,1.56-.2,2.34-.01.18,0,.37,0,.55.42-1.27.79-2.56,1.21-3.84.15-.45.31-.9.49-1.34.04-.28.06-.56.09-.84.05-.53.1-1.06.09-1.59Z"
                fill="#ffece5"
              />
              <path
                d="M1018.25,89c-.13-.51-.21-1.03-.35-1.54-.16-.58-.25-1.16-.22-1.77.01-.23.02-.46-.03-.68-.12-.6-.19-1.21-.2-1.83c0-.27-.08-.55-.16-.82-.16-.59-.3-1.18-.23-1.83.24-.02.45-.02.65-.06.27-.05.49-.32.47-.56-.02-.25-.2-.43-.49-.46-.1-.01-.21,0-.32,0-.76,0-1.51,0-2.27.02-.53.02-1.05.07-1.57.13-.7.08-1.39.19-2.08.3-.88.13-1.77.26-2.65.41-.86.15-1.72.32-2.59.47-.78.13-1.56.23-2.34.36-1,.16-2.01.33-3.01.5-.95.17-1.91.28-2.84.53-2.14.57-4.28,1.11-6.35,1.91-1.05.4-2.15.65-3.21,1.04-1.63.59-3.26,1.22-4.87,1.88-.79.32-1.57.7-2.32,1.12-1.12.63-2.23,1.26-3.41,1.78-.42.18-.82.41-1.21.64-1.09.64-2.16,1.32-3.33,1.82-.58.25-1.15.55-1.68.89-1.08.7-2.11,1.47-3.29,1.99-.34.15-.67.32-.99.49-.42.22-.84.43-1.25.67-.87.5-1.73,1.01-2.58,1.54-.82.51-1.66,1-2.42,1.59-1.17.92-2.4,1.73-3.77,2.3-1.14.47-2.12,1.16-3.05,1.95-.99.85-1.99,1.67-3.07,2.4-.49.33-.95.73-1.37,1.15-.65.64-1.24,1.34-1.89,1.98-.87.87-1.77,1.71-2.66,2.57-.44.42-.74.94-.96,1.5-.79,1.97-1.07,4.03-1.13,6.13-.03.95.04,1.89.1,2.84.05.85.24,1.67.61,2.44.28.59.55,1.18.89,1.74.34.57.73,1.12,1.14,1.64.58.73,1.13,1.48,1.42,2.38.31.96.84,1.82,1.43,2.63.2.27.41.53.6.8.67,1.01,1.53,1.82,2.54,2.49.71.47,1.38,1.03,2.06,1.56.66.52,1.31,1.06,1.97,1.58.46.36.94.68,1.4,1.03.6.46,1.19.93,1.79,1.39.37.29.76.57,1.13.87.61.49,1.24.92,2.01,1.13c1.63.45,3.25.91,4.87,1.35.83.23,1.69.35,2.49.66c1.38.54,2.78.98,4.23,1.26.74.14,1.48.23,2.25.25c1.1.03,2.17-.21,3.25-.26.4-.02.8-.08,1.2-.14.87-.12,1.71-.39,2.54-.68c1.08-.37,2.18-.69,3.25-1.08.44-.16.84-.43,1.27-.64c1.01-.5,2.03-.97,3.03-1.49.9-.47,1.65-1.11,2.31-1.89.59-.7,1.26-1.32,1.93-1.94c1.19-1.1,2.37-2.2,3.1-3.69.5-1.01,1.17-1.92,1.9-2.78.64-.76,1.18-1.57,1.55-2.5.25-.62.51-1.24.79-1.84.57-1.21,1.09-2.44,1.53-3.7.23-.68.51-1.36.87-1.97.94-1.57,1.75-3.21,2.53-4.87.42-.89.78-1.81,1.12-2.73.45-1.22.9-2.44,1.5-3.6.79-1.54,1.66-3.02,2.6-4.46.31-.49.63-.98.86-1.51.87-1.96,1.7-3.93,2.57-5.89.97-2.18,1.97-4.35,2.94-6.53.12-.28.18-.61.2-.91.06-.75-.14-1.46-.36-2.17-.13-.42-.27-.84-.38-1.26Z"
                fill="#81c6b2"
              />
              <g>
                <path
                  d="M981.73,97.02c.2.37.37.77.64,1.09.78.92,1.33,1.98,1.85,3.06.44.93.92,1.85,1.39,2.78.08.16.18.31.29.44.38.47.84.6,1.4.39.16-.06.33-.13.48-.22.63-.38,1.23-.82,1.88-1.15.94-.48,1.85-1.01,2.76-1.54c1.6-.94,3.34-1.64,4.83-2.78.88-.45,1.6-.95,2.3-1.48c1.53-1.13,3.03-2.29,4.3-3.72.14-.16.31-.29.46-.43.48-.46.98-.91,1.44-1.39.46-.49.96-.92,1.55-1.25.46-.26.88-.57,1.32-.86.28-.18.55-.37.84-.55.58-.36,1.18-.68,1.67-1.18.43-.44.92-.81,1.38-1.21.37-.32.76-.63,1.09-.98.25-.26.5-.54.56-.91-.11-.35-.37-.36-.65-.37-1.37-.04-2.74-.04-4.09.25-1.81.4-3.63.78-5.43,1.24-1.32.34-2.61.81-3.93,1.19-1.84.52-3.69,1.01-5.53,1.5-1.54.42-3.08.83-4.62,1.24-2.18.57-4.34,1.18-6.29,2.34-.14.08-.28.15-.43.21-.9.33-1.68.86-2.5,1.34-.13.08-.24.19-.39.32.27.51.5.95.73,1.38s.46.86.7,1.29Z"
                  fill="#2b231d"
                />
                <path
                  d="M984.58,145.79c-.01-.15-.04-.32-.1-.46-.24-.56-.48-1.13-.75-1.68-.44-.86-.96-1.67-1.25-2.6-.19-.61-.57-1.11-.95-1.63-.64-.87-1.59-1.44-2.2-2.34-.2-.29-.42-.26-.66,0-.2.22-.39.45-.58.68-.45.54-.86,1.11-1.07,1.8-.3.95-.59,1.91-.89,2.86-.3.96-.33,1.93-.24,2.92.07.74.11,1.49.15,2.24.08,0,.16.01.24.02c1.1.03,2.17-.21,3.25-.26.4-.02.8-.08,1.2-.14.87-.12,1.71-.39,2.54-.68.43-.15.87-.29,1.31-.43.01-.09.01-.19,0-.3Z"
                  fill="#2b231d"
                />
                <path
                  d="M973.6,146.44c-.12-.65-.24-1.31-.39-1.95-.5-2.11-1.11-4.2-1.26-6.38-.03-.51-.26-1.01-.41-1.51-.03-.09-.15-.16-.26-.28-.23.2-.44.35-.62.54-.35.37-.66.78-1.03,1.13-.49.47-.88,1-1.22,1.58-1.05,1.72-1.94,3.52-2.66,5.43.52.14,1.04.29,1.56.43.83.23,1.69.35,2.49.66c1.18.46,2.37.84,3.6,1.12.17-.22.25-.48.2-.76Z"
                  fill="#2b231d"
                />
                <path
                  d="M990.56,105.32c-.41.26-.81.55-1.21.84-.3.21-.59.43-.89.65-.87.66-1.73,1.32-2.59,1.97-.12.09-.28.15-.41.23-.2.11-.41.21-.6.34-.98.65-1.92,1.35-2.93,1.95-1.06.62-1.91,1.49-2.85,2.25-.61.49-1.06,1.16-1.69,1.64-.28.22-.45.58-.28.95.17.36.54.33.88.31.22-.01.45-.03.67,0c1.22.14,2.43.38,3.67.3.86-.06,1.72-.06,2.58-.1.37-.02.73-.06,1.09-.12.95-.16,1.6-.66,1.84-1.64.03-.14.08-.27.13-.4.2-.47.37-.95.61-1.39.63-1.21,1.29-2.41,1.94-3.62.17-.32.32-.66.51-.98.6-1,.98-2.1,1.34-3.2.07-.21.1-.41-.15-.65-.18.02-.43.01-.64.1-.35.15-.68.35-1.01.56Z"
                  fill="#2b231d"
                />
                <path
                  d="M963.19,141.86c.17-.15.32-.33.47-.5.64-.77,1.28-1.54,1.91-2.32.24-.3.47-.62.62-.97.54-1.18,1.08-2.36,1.56-3.57.31-.76.54-1.55.78-2.34.39-1.27.75-2.55,1.14-3.82.14-.46.21-.93.16-1.4-.02-.14-.09-.32-.2-.39-.17-.11-.33.02-.46.15-.38.39-.82.73-1.15,1.16-.85,1.12-1.68,2.25-2.48,3.41-.64.94-1.21,1.93-1.83,2.89-.31.49-.71.93-1,1.42-.87,1.49-1.95,2.84-2.96,4.23-.4.56-.93,1.02-1.42,1.51.32.25.64.5.96.75.37.29.76.57,1.13.87.35.28.71.54,1.1.75.59-.78,1.09-1.34,1.67-1.84Z"
                  fill="#2b231d"
                />
                <path
                  d="M952.33,109.33c.09.17.31.26.47.38.68-.16,1.23-.37,1.71-.75c1.15-.92,2.32-1.82,3.45-2.77.57-.48,1.06-1.08,1.6-1.6.34-.32.53-.7.62-1.14.13-.62.14-1.25.02-1.87-.09-.45-.34-.76-.65-.78-.66.41-1.34.78-2.06,1.08-1.14.47-2.12,1.16-3.05,1.95-.99.85-1.99,1.67-3.07,2.4-.23.15-.44.32-.65.5.19.26.41.51.52.8.24.68.75,1.18,1.1,1.79Z"
                  fill="#2b231d"
                />
                <path
                  d="M961.72,101.85c.18.68.48.91,1.18.84.15-.02.31-.07.46-.11c1.07-.3,2.04-.85,3.01-1.38.38-.21.73-.49,1.06-.78.48-.41.94-.85,1.4-1.28c1.1-1.02,2.19-2.03,3.29-3.05.48-.45,1.03-.79,1.63-1.06.74-.33,1.48-.64,2.21-.97.13-.06.25-.13.37-.2.6-.3.64-.79.37-1.33-.24-.5-.62-.89-1.02-1.27-.72.42-1.45.83-2.22,1.15-.58.25-1.15.55-1.68.89-1.08.7-2.11,1.47-3.29,1.99-.34.15-.67.32-.99.49-.42.22-.84.43-1.25.67-.87.5-1.73,1.01-2.58,1.54-.71.44-1.43.87-2.09,1.36-.02.83-.07,1.67.14,2.49Z"
                  fill="#2b231d"
                />
                <path
                  d="M951.91,132.46c.28-.29.6-.54.9-.8.61-.55,1.25-1.08,1.83-1.66.83-.83,1.63-1.69,2.43-2.56.26-.28.5-.59.71-.91.45-.68.39-.96-.23-1.48-.08-.07-.18-.12-.26-.18-.25-.22-.51-.43-.73-.67-.38-.41-1.04-.51-1.47-.16-.29.24-.55.54-.8.83-.54.62-1.01,1.32-1.61,1.88-.8.74-1.53,1.54-2.28,2.33-.52.55-1.11,1.02-1.67,1.52-.33.3-.66.58-.87.89.3.62.66,1.19,1.07,1.75.19.26.39.5.57.76.19-.04.4-.13.66-.26.64-.33,1.23-.74,1.73-1.27Z"
                  fill="#2b231d"
                />
                <path
                  d="M960.14,110.51c.4-.82.87-1.6,1.3-2.41.25-.48.49-.97.72-1.46.14-.3.06-.51-.24-.64-.14-.06-.3-.09-.45-.14-.11.03-.22.04-.31.08-.42.22-.88.4-1.23.7-.59.52-1.26.88-1.94,1.25-.43.23-.85.49-1.24.79-.69.54-1.35,1.13-2.02,1.69-.61.51-1.11,1.12-1.47,1.84-.19.36-.22.69.06,1.02.1.12.2.26.24.41.17.64.57,1.16.87,1.73.31.59.72,1.07,1.22,1.5.36.3.61.34.97.02.24-.21.47-.43.63-.7.45-.73.89-1.48,1.27-2.24.56-1.13,1.06-2.3,1.61-3.43Z"
                  fill="#2b231d"
                />
                <path
                  d="M978.82,91.7c.33.53.71.73,1.29.53c1.47-.51,2.94-1.04,4.39-1.62.99-.4,1.93-.95,2.93-1.31c1.36-.48,2.61-1.22,3.96-1.7.45-.16.88-.35,1.34-.45c2.12-.47,4.24-.97,6.28-1.72.29-.11.61-.17.92-.22c1.24-.21,2.49-.42,3.73-.61.9-.14,1.8-.25,2.71-.36.85-.1,1.71-.18,2.56-.28.73-.09,1.46-.19,2.19-.28.57-.07,1.15-.15,1.72-.22.27-.03.45-.18.56-.42.07-.16.16-.32.21-.48.16-.66.47-1.24.82-1.82.09-.15.2-.29.27-.45.06-.17.08-.35.12-.56-.13-.05-.24-.1-.33-.14-.27.02-.54.05-.81.09-.7.08-1.39.19-2.08.3-.88.13-1.77.26-2.65.41-.86.15-1.72.32-2.59.47-.78.13-1.56.23-2.34.36-.38.06-.77.13-1.15.19-1.17.22-2.34.44-3.49.73-2.06.51-4.09,1.13-6.14,1.67-.47.12-.93.24-1.4.35-1.06.41-2.17.66-3.23,1.04-1.63.59-3.26,1.22-4.87,1.88-.79.32-1.57.7-2.32,1.12-.98.56-1.97,1.11-2.99,1.58-.16,1.03-.15,1.06.39,1.94Z"
                  fill="#2b231d"
                />
                <path
                  d="M947.57,128.75c.27-.28.57-.52.85-.78.6-.57,1.23-1.11,1.77-1.72.8-.91,1.55-1.86,2.29-2.82.63-.82,1.24-1.66,1.82-2.52.23-.34.35-.76.47-1.16.08-.27.04-.56-.12-.81-.14-.22-.29-.44-.43-.66-.17-.28-.36-.56-.49-.86-.28-.66-.53-1.33-.78-2-.12-.31-.32-.49-.68-.53-.37.29-.75.6-1.14.9-.66.51-1.24,1.1-1.69,1.8-1.08,1.66-2.13,3.35-3.17,5.04-.54.88-1.03,1.8-1.51,2.71-.08.16-.15.32-.22.5.13.26.26.52.41.76.34.57.73,1.12,1.14,1.64.23.29.45.58.65.88.28.06.55-.08.82-.35Z"
                  fill="#2b231d"
                />
                <path
                  d="M944.19,121.83c.89-1.42,1.88-2.76,2.93-4.05.7-.86,1.37-1.74,2.09-2.58.47-.55,1-1.04,1.48-1.57.35-.39.72-.82.68-1.38-.05-.7-.15-1.4-.64-1.96-.49-.57-.98-1.15-1.48-1.72-.06-.07-.14-.11-.23-.16-.3.33-.6.65-.92.97-.87.87-1.77,1.71-2.66,2.57-.44.42-.74.94-.96,1.5-.79,1.97-1.07,4.03-1.13,6.13-.03.93.04,1.87.1,2.81.18,0,.37-.08.55-.28.07-.08.13-.16.19-.25Z"
                  fill="#2b231d"
                />
                <path
                  d="M967.28,107.17c.37.58.78,1.12,1.35,1.54.24.17.4.44.6.66.26.29.48.62.78.84.76.56,1.41,1.22,1.97,1.97.4.54.91.97,1.5,1.31.49.28.96.31,1.44.02.2-.12.4-.21.61-.32.67-.33,1.23-.8,1.76-1.32.42-.41.89-.79,1.38-1.13.69-.48,1.42-.91,2.13-1.37.25-.16.5-.34.71-.55.53-.52,1.04-1.05,1.55-1.58.34-.36.46-.77.34-1.26-.19-.83-.57-1.59-.97-2.32-.61-1.09-1.3-2.13-1.94-3.2-.24-.4-.45-.84-.61-1.28-.39-1.09-.81-2.16-1.32-3.2-.23-.46-.53-.65-1.02-.55-.3.06-.59.21-.87.36-1.06.55-2.11,1.11-3.17,1.66-.48.25-1.01.44-1.44.76-.8.6-1.59,1.23-2.31,1.92-1.38,1.33-2.71,2.71-4.06,4.07.41,1.07,1.11,1.78,1.44,2.72.03.08.09.15.14.22Z"
                  fill="#2b231d"
                />
                <path
                  d="M970.22,120.19c-.23.05-.44.2-.63.33-.36.25-.68.55-1.04.8-.44.31-.91.59-1.36.89-.17.12-.33.26-.49.4-.34.31-2.69,1.77-3.13,1.93-.08.03-.16.06-.25.09-.31.11-.63.21-.94.35-.24.11-.49.23-.66.41-.72.75-1.47,1.46-2.28,2.1-.14.11-.25.24-.37.37-.54.56-1.07,1.12-1.61,1.67-.61.63-1.25,1.24-1.81,1.91-.57.68-1.2,1.29-1.9,1.82-.54.41-.69.99-.81,1.6-.03.26.06.45.26.6.23.16.45.33.69.49.61.39,1.22.76,1.83,1.15.28.18.56.22.85.08.4-.21.8-.44,1.18-.68.4-.25.79-.52,1.19-.77.76-.48,1.45-1.05,2.03-1.74.23-.27.46-.53.7-.79.98-1.02,1.79-2.17,2.56-3.34.83-1.26,1.65-2.53,2.51-3.77c1.21-1.75,2.46-3.47,3.69-5.2.05-.07.1-.15.13-.23.11-.29-.05-.53-.34-.47Z"
                  fill="#2b231d"
                />
                <path
                  d="M972.29,116.55c.24-.93-.1-1.81-.93-2.33-.53-.33-1.1-.62-1.67-.89-.54-.26-1.07-.52-1.5-.96-.8-.79-1.38-1.72-1.75-2.78-.06-.18-.18-.34-.27-.51-.1-.18-.22-.36-.31-.55-.35-.69-.69-1.37-1.35-1.82-.42-.11-.72.07-.96.39-.1.14-.21.28-.31.43-.4.58-.81,1.15-1.19,1.74-.45.69-.93,1.38-1.28,2.12-.68,1.44-1.29,2.92-1.91,4.39-.18.42-.31.86-.39,1.31-.22,1.12-.42,2.24-.59,3.37-.08.54-.1,1.08-.11,1.63c0,.38.13.58.51.62.52.05,1.07.11,1.56-.02.83-.23,1.64-.48,2.49-.64.85-.17,1.69-.47,2.51-.75.71-.24,1.42-.52,2.1-.83.4-.18.75-.45,1.11-.69.48-.32.93-.7,1.43-.98.9-.5,1.67-1.16,2.48-1.78.14-.11.28-.29.33-.46Z"
                  fill="#2b231d"
                />
                <path
                  d="M985.73,119.43c.21-.53,0-.88-.56-1-.81-.17-1.61-.33-2.45-.32-.54,0-1.09-.02-1.63-.03-.86,0-1.72-.03-2.58,0-.8.04-1.61.15-2.41.23-.39-.06-.78-.07-1.17-.05-.42.02-.87.05-1.17.38-.33.36-.67.74-.9,1.16-.66,1.27-.94,2.64-.91,4.07.02.86.1,1.72.33,2.56.02.08.04.17.05.26.08,1,.15,2,.25,2.99.05.5.14,1.01.25,1.5.22.99.52,1.97.69,2.97.15.86.52,1.59.96,2.31.23.37.52.4.82.08.88-.91,1.84-1.74,2.65-2.71.67-.8,1.36-1.57,1.81-2.52.14-.3.33-.58.5-.87.59-1.06,1.21-2.1,1.78-3.17.77-1.48,1.53-2.96,2.24-4.47.53-1.11.99-2.25,1.45-3.38Z"
                  fill="#2b231d"
                />
                <path
                  d="M988.52,127.72c.27-.63.59-1.23,1-1.79.43-.59.82-1.22,1.21-1.85.46-.73.89-1.47,1.35-2.2.8-1.26,1.73-2.43,2.36-3.8.12-.27.33-.49.5-.74.47-.68.97-1.34,1.41-2.03.76-1.18,1.5-2.38,2.45-3.42.43-.48.85-.99,1.2-1.53.42-.64.91-1.21,1.49-1.69.58-.47,1.04-1.04,1.47-1.64.28-.4.63-.75.97-1.1s.78-.63,1.07-1.01c.83-1.07,1.68-2.12,2.64-3.08.64-.84,1.18-1.63,1.79-2.35c1.12-1.31,2.22-2.63,3.28-3.99.79-1.01,1.46-2.06,1.78-3.31.21-.85.44-1.7.64-2.55.04-.18,0-.38,0-.62-.16-.01-.31-.07-.41-.02-.24.1-.47.22-.68.38-.43.33-.82.73-1.27,1.03-.69.45-1.36.94-2,1.46-1.54,1.26-3.11,2.47-4.64,3.74-.83.68-1.66,1.35-2.59,1.9-.27.16-.53.36-.75.58-.64.69-1.39,1.23-2.16,1.76-.48.33-.87.75-1.23,1.21-.4.51-.82,1.01-1.3,1.44-.67.61-1.25,1.27-1.66,2.09-.12.25-.3.47-.44.72-.7,1.18-1.39,2.36-2.08,3.54-.12.21-.22.44-.3.67-.24.67-.61,1.26-1,1.85-.89,1.31-1.69,2.67-2.19,4.19-.08.23-.17.46-.27.68-.57,1.26-1.15,2.52-1.72,3.78-.12.27-.28.54-.36.82-.33,1.17-.82,2.27-1.34,3.37-.56,1.19-1.24,2.32-1.7,3.56-.77,2.03-1.61,4.04-2.38,6.08-.46,1.23-.65,2.51-.57,3.83.01.19.06.34.35.42.28-.38.54-.78.85-1.13.78-.87,1.36-1.88,1.96-2.87.36-.6.58-1.29.97-1.87.94-1.41,1.61-2.95,2.28-4.5Z"
                  fill="#2b231d"
                />
                <path
                  d="M1015.85,96.51c-.25.15-.51.31-.74.49-.26.21-.5.44-.74.68-.7.72-1.43,1.41-2.07,2.18-.79.94-1.51,1.94-2.24,2.93-.25.34-.49.69-.68,1.07-.38.74-.81,1.43-1.29,2.11-.66.93-1.27,1.9-1.91,2.84-.49.73-.96,1.47-1.5,2.16-.5.64-.96,1.3-1.33,2.02-.18.36-.41.7-.67,1-.93,1.06-1.76,2.19-2.49,3.4-.54.89-1.15,1.72-1.85,2.5-.34.37-.57.84-.84,1.27-.26.42-.48.85-.75,1.27-.35.55-.77,1.05-1.09,1.62-.55.98-1.08,1.97-1.55,2.99-.61,1.35-1.51,2.53-2.24,3.81-.65,1.15-1.33,2.27-2.17,3.3-.4.48-.7,1.05-1.05,1.57-.23.35-.46.71-.73,1.03-.28.34-.61.63-.91.95-.65.69-.98,1.57-1.45,2.38-.08.14-.09.35-.05.51.15.63.33,1.25.52,1.87.2.62.46.73,1.02.38.46-.29.9-.62,1.29-1c.51-.5.93-1.1,1.45-1.61c1.13-1.11,2.02-2.39,2.88-3.7.35-.53.71-1.05,1.12-1.53.61-.71,1.12-1.48,1.51-2.34.19-.41.45-.79.7-1.17.82-1.23,1.56-2.5,2.13-3.87.25-.6.61-1.14.99-1.67.47-.65.94-1.32,1.33-2.02.63-1.14,1.3-2.25,2.07-3.3.52-.71.97-1.46,1.33-2.27.2-.45.46-.87.73-1.28.91-1.36,1.8-2.72,2.49-4.21.19-.41.45-.8.71-1.17.54-.76,1-1.57,1.39-2.41.62-1.34,1.24-2.68,2.11-3.88.31-.42.54-.9.78-1.37.67-1.33,1.34-2.67,2.25-3.86.27-.35.53-.7.76-1.08.37-.61.73-1.24,1.07-1.87.1-.18.15-.38.21-.54-.15-.26-.33-.29-.52-.18Z"
                  fill="#2b231d"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M1042.18,95.81c0,.99,0,1.88.01,2.78.01,2.52.02,5.03.04,7.55c0,.54.06,1.09.12,1.63.12,1.19.15,2.38.01,3.58-.03.3-.02.6-.02.9.02,2.22.03,4.43.05,6.65.04,3.06.1,6.12.12,9.18c0,.86-.1,1.72-.17,2.57-.06.77-.14,1.54-.22,2.3-.24,2.16-.68,4.29-1.36,6.36-.14.41-.35.8-.54,1.2-.81,1.79-1.79,3.49-2.54,5.32-.41.99-1.11,1.83-1.83,2.63-.3.32-.55.68-.85,1.01-.21.23-.44.45-.67.66-.21.19-.46.22-.73.23-1.39.08-2.38-.57-3.15-1.66-.36-.5-.75-.98-1.15-1.44-1.36-1.54-2.34-3.28-2.86-5.27-.6-2.25-1.23-4.5-1.82-6.75-.31-1.19-.58-2.38-.68-3.61-.07-.86-.16-1.71-.22-2.57-.09-1.38-.14-2.77-.24-4.15-.08-1.19-.21-2.38-.3-3.57-.04-.53-.03-1.05-.04-1.58c0-1.39-.02-2.78-.02-4.17c0-1.86-.1-3.72-.2-5.58-.1-1.89-.06-3.8-.08-5.69c0-.39-.01-.78.01-1.16.09-1.31.24-2.62.27-3.94.01-.68.28-1.05.82-1.38.5-.31.91-.77,1.52-.92.12-.03.24-.07.36-.08.44-.04.87-.09,1.31-.11c1.12-.05,2.25-.08,3.37-.12c2.18-.08,4.36-.15,6.53-.26.84-.04,1.67-.18,2.51-.29.69-.09,1.38-.21,2.08-.3.16-.02.33.04.55.07Z"
                  fill="#2b231d"
                />
                <path
                  d="M1027.06,64.03c1.04-.52,2.09-.86,3.18-1.06.41-.07.85-.11,1.26-.04c1.4.22,2.79.5,4.15,1.08.1-.15.2-.31.31-.46.43-.62.81-1.29,1.3-1.86.65-.76,1.38-1.45,2.08-2.16.16-.16.35-.3.49-.48c1.09-1.29,2.48-2.23,3.78-3.27.27-.22.59-.38.89-.57.57-.37,1.17-.72,1.71-1.14.65-.5,1.39-.82,2.12-1.17c1.42-.69,2.83-1.41,4.25-2.12.25-.13.5-.26.76-.36c1.16-.4,2.32-.81,3.5-1.18.76-.24,1.5-.49,2.18-.92.12-.08.24-.14.38-.19c1.24-.46,2.37-1.16,3.53-1.77.61-.32,1.17-.71,1.64-1.23.18-.2.29-.42.29-.71.02-.62.28-1.16.68-1.62.4-.48.91-.85,1.48-1.09c1.01-.42,1.72.19,1.68,1.1-.03.67-.27,1.24-.75,1.69-.65.61-1.39,1.08-2.33,1.16-.75.88-1.72,1.48-2.75,1.99-1.34.66-2.66,1.35-3.99,2.03-.19.09-.38.18-.58.25-1.33.45-2.67.89-4,1.35-.46.16-.91.37-1.35.57-.27.13-.52.3-.79.43-1.31.63-2.64,1.25-3.95,1.89-.47.23-.91.52-1.36.8-.44.28-.85.63-1.32.88-1.42.77-2.65,1.79-3.88,2.82-.84.71-1.55,1.59-2.37,2.33-1.09.98-1.87,2.18-2.61,3.44c1.99,1.55,3.3,3.49,3.56,6.08-.13.2-.32.29-.57.19-.66-.28-1.35-.14-2.03-.11-.63.03-1.26.11-1.88.19-.87.1-1.74.21-2.61.3-.52.05-1.05.11-1.58.11-1.41,0-2.81-.06-4.22-.05-1.25,0-2.49.08-3.74.11-.22,0-.45-.03-.75-.05-.11.05.02.44-.35.34-.18-.25-.12-.56-.07-.83.1-.61.29-1.19.6-1.73.25-.44.44-.91.67-1.37.58-1.15,1.22-2.26,2.38-3.01-.19-.14-.33-.28-.49-.36-1.27-.68-2.51-1.43-3.83-2-1.38-.6-2.79-1.15-4.27-1.52-1.04-.26-2.05-.65-3.1-.83-2.81-.5-5.51-1.45-8.26-2.15-.76-.19-1.48-.55-2.22-.84-1.37-.54-2.75-1.07-4.12-1.63-.58-.24-1.15-.52-1.72-.79-.55-.27-1.09-.58-1.65-.82-1.05-.46-2.05-1.01-2.91-1.79-.09-.08-.2-.14-.29-.2-.98.24-1.71-.06-2.3-.87-.54-.75-.63-1.55-.4-2.41.2-.73.75-1.02,1.41-.68.46.23.89.56,1.28.91.36.33.53.78.5,1.29-.01.21,0,.42,0,.68.63.62,1.34,1.22,2.18,1.66c1.09.57,2.18,1.14,3.29,1.68.41.2.85.34,1.27.52c1.34.54,2.68,1.06,4.01,1.63.96.41,1.92.77,2.93,1.03c1.19.31,2.36.69,3.55,1c1.16.3,2.33.53,3.49.83c2.16.57,4.32,1.11,6.41,1.92c1.78.69,3.44,1.6,5.12,2.49.38.2.74.46,1.1.68Z"
                  fill="#2b231d"
                />
              </g>
              <path
                d="M1047.73,79.38c0,.84,0,1.69.01,2.53-.13.64-.16,1.09-.21,1.54-.07.66-.11,1.33-.24,1.98-.28,1.43-.68,2.83-1.19,4.2-.24.62-.49,1.24-.73,1.86-.22.56-.44,1.11-.85,1.57-.75.83-1.5,1.67-2.26,2.49-.57.61-1.28,1.03-2.07,1.31-.4.14-.8.28-1.17.48-.78.42-1.58.74-2.43.99-1.54.46-3.09.79-4.7.77-.18,0-.37.07-.55.1-1.02,0-2.04,0-3.06.01-1.1-.19-2.08-.28-3.04-.41-.76-.1-1.52-.22-2.18-.68-.56-.39-1.14-.75-1.74-1.08-.79-.43-1.5-.97-2.11-1.63-.59-.63-1.18-1.24-1.77-1.87-.07-.08-.12-.17-.19-.25-.69-.94-1.09-2.04-1.64-3.05-.12-.23-.22-.48-.31-.72-.26-.73-.51-1.46-.74-2.19-.17-.53-.33-1.07-.48-1.61-.08-.26-.14-.53-.21-.8c0-1.2-.01-2.39-.02-3.59.07-.2.16-.39.19-.59.17-1.01.45-1.98.9-2.91.37-.78.7-1.57,1.07-2.35.52-1.13,1.16-2.17,2.32-2.77.76-.4,1.53-.8,2.29-1.2.69-.37,1.45-.55,2.21-.66.93-.14,1.88-.22,2.81-.33.33-.04.66-.09.99-.11.79-.04,1.57-.02,2.37-.1c1.13-.12,2.28-.11,3.42-.14c1-.02,2.01-.03,3.01-.01.65,0,1.3.04,1.94.11c1.06.11,2.12.31,3.18.38c1.09.07,2,.63,3.01.91.18.05.34.19.47.33.41.45.86.89,1.2,1.39.52.77.99,1.58,1.42,2.4.53,1,.64,2.15.98,3.22.05.16.08.33.11.5Z"
                fill="#ffece5"
              />
              <path
                d="M1031.45,96.27c-.48-.24-.72-.68-1-1.11-.93-1.41-1.65-2.94-2.47-4.41-.43-.77-.64-1.63-.78-2.5-.17-1.09-.3-2.18-.44-3.28-.04-1.03-.1-1.96-.12-2.89-.02-1.26.11-2.52.32-3.76.13-.78.31-1.54.43-2.32.1-.65.45-1.18.79-1.7.32-.48.7-.93,1.1-1.34.35-.36.77-.66,1.17-.97.2-.16.43-.13.65-.05c1.07.4,1.95,1.05,2.73,1.9.71.78.97,1.73,1.32,2.66.59,1.17.68,2.28.99,3.31.03.1.06.2.07.31.15,1.47.19,2.95.12,4.42-.1,2.07-.32,4.12-.91,6.12-.28.94-.54,1.89-.84,2.82-.17.54-.46,1.02-.88,1.42-.45.56-.78,1-1.21,1.37-.35,0-.7,0-1.06,0Z"
                fill="#2b231d"
              />
              <path
                d="M1016.61,82.82c.03-.1.1-.19.09-.29-.03-1.12.18-2.2.44-3.27.14-.59.39-1.17.62-1.73.29-.7.56-1.41.94-2.05.33-.55.8-1.02,1.25-1.48.47-.47,1.03-.68,1.73-.26.4.66.66,1.44.8,2.26.18,1.09.3,2.18.45,3.28.06.43.16.86.23,1.29.07.48.17.97.19,1.46.06,1.82.15,3.65.12,5.48-.02,1.35-.25,2.68-.52,4.01-.17.84-.33,1.68-.47,2.53-.12.66-.44.82-1.1.65-.52-.13-.83-.5-1.14-.89-.21-.26-.39-.55-.63-.77-.62-.57-1.09-1.24-1.37-2.03-.37-1.04-.88-2.03-1.11-3.12-.19-.87-.42-1.74-.42-2.64c0-.1-.06-.19-.1-.29c0-.7,0-1.41,0-2.11Z"
                fill="#2b231d"
              />
              <path
                d="M1034.71,65.1c.38.24.76.49,1.15.72.33.2.55.48.69.83.13.32.08.52-.19.75-.3.26-.67.28-1.03.27-.56-.02-1.04-.28-1.47-.63-.21-.17-.48-.34-.59-.57-.25-.53-.28-1.11.47-1.28.41-.09.69-.09.97-.1Z"
                fill="#ffece5"
              />
              <path
                d="M1040.79,93.66c-.31-.29-.37-.66-.46-1.02-.19-.82-.38-1.64-.55-2.46-.21-.99-.45-1.98-.46-3.01c0-.74-.02-1.48-.12-2.2-.16-1.16-.09-2.32-.09-3.47c0-.64.1-1.29.17-1.93.07-.73.15-1.46.23-2.19.03-.31.08-.62.11-.94.07-.59.1-1.19.2-1.77.11-.66.28-1.31.63-1.89.24-.4.96-.56,1.41-.32.8.43,1.42,1.06,1.86,1.82.63,1.08,1.2,2.2,1.56,3.4.36,1.17.7,2.35.7,3.6c0,.72.08,1.43.11,2.15.04,1.06-.15,2.09-.35,3.13-.26,1.33-.78,2.59-1.27,3.84-.11.27-.28.53-.45.77-.49.68-1.07,1.29-1.57,1.97-.37.51-1.03.63-1.66.52Z"
                fill="#2b231d"
              />
              <path
                d="M1026.61,68.09c-.59,0-1.03-.12-1.22-.62-.17-.46,0-.88.33-1.19.66-.63,1.42-1.09,2.38-1.04.15,0,.31.03.46.09.6.24.78.9.36,1.4-.45.55-.97,1.01-1.65,1.27-.21.08-.44.08-.66.12v-.03Z"
                fill="#ffece5"
              />
              <path
                d="M1033.42,144.41c-.09-.03-.18-.1-.28-.1-.56.02-1.11-.03-1.67-.12-.47-.08-.95-.12-1.42-.26-.33-.1-.69-.11-1.03-.13-.52-.03-1.01-.14-1.43-.47-.08-.06-.19-.1-.28-.15-.18-.4-.24-.7-.16-.95.09-.28.4-.25.64-.21.36.07.71.17,1.07.24.53.1,1.06.18,1.59.26.58.09,1.16.19,1.75.28.09.01.17.02.26.03.57.04,1.15-.04,1.73.07.39.07.82-.05,1.22-.09.39-.04.78-.09,1.17-.16.11-.02.21-.12.32-.14.56-.11,1.13-.19,1.66-.43.06-.02.4.25.46.35.1.15.09.26-.06.4-.49.45-1.02.8-1.71.87-.23.02-.44.2-.67.26-.4.1-.82.16-1.23.22-.43.06-.87.08-1.3.13-.4-.03-.47-.03-.54.1h-.11Z"
                fill="#81c6b2"
              />
              <path
                d="M1042.77,109.2c-.26.32-.52.66-1.01.58-.39.25-.85.26-1.27.4-.6.19-1.23.31-1.87.24-.1-.01-.2,0-.3.03-.41.08-.81.19-1.23.23-.28.03-.57-.04-.85-.05-.43.08-.75.07-1.07.09-.24.01-.48.06-.72.09-.14.01-.28.03-.42.02-.49-.04-.98,0-1.47,0-.71-.02-1.41-.12-2.11-.2-.15-.02-.28-.06-.45,0-.16.05-.36.05-.52,0-.58-.17-1.18-.15-1.76-.23-.3-.05-.63-.09-.93-.19-.53-.17-1.05-.37-1.57-.55-.12-.04-.59-.38-.64-.46-.18-.27.05-.68.42-.74.12-.02.25-.02.37,0c.17.03.34.03.51-.01.11-.02.24-.03.34.02.19.09.36.11.55.02.44.11.67.11.91,0c.39.24.72.04,1.04.05.63.02,1.25-.02,1.88,0c.65.03,1.31.1,1.96.15.72-.13,1.23-.09,1.75-.03.1.01.2-.02.3-.02.3,0,.6-.05.89,0c.2.04.36.1.53-.07.7-.04,1.21-.02,1.72-.16.36-.09.75-.04,1.13-.09.36-.05.71-.14,1.06-.21.54-.12,1.09-.24,1.63-.37.38-.09.67.11,1.01.29-.18.2-.23.39-.03.62.13.14.16.37.24.56v0Z"
                fill="#81c6b2"
              />
              <path
                d="M1024.06,102.98c0-.16-.01-.27,0-.37.04-.26.19-.34.47-.32.27.02.55-.02.83-.04.12,0,.25-.05.36-.03.69.09,1.39.05,2.08.17.9-.26,1.64-.06,2.38,0c.45.04.9.09,1.36.1.22,0,.47-.12.66-.06s.35.13.57.1c.26-.04.54-.03.8.01.29.05.55-.03.82-.04.44-.03.86-.12,1.29-.18.28-.04.58.11.86-.04.23.16.43-.02.65-.05.12-.02.23-.03.35-.04.09-.01.19-.02.28-.04s.19-.04.28-.05c.62-.24.97-.48,1.4-.57.21-.05.36-.23.62-.25.72-.06.88.06.99.76.03.2.14.39.26.56.1.15.1.25-.05.35-.9.59-1.89.96-2.93,1.21-1.05.25-2.12.3-3.18.45-.1.01-.2,0-.3-.02-.8.26-1.44.09-2.07.1-.62.01-1.23-.04-1.85-.08-.7-.05-1.39-.13-2.09-.18-.24-.02-.48,0-.72-.02-.26-.02-.52-.06-.77-.1-.6-.1-1.21-.18-1.79-.33-.49-.13-.95-.34-1.42-.54-.23-.1-.13-.34-.15-.46Z"
                fill="#81c6b2"
              />
              <path
                d="M1042.44,114.73c-.63.48-1.37.64-2.14.79-.74.15-1.5.1-2.23.27-.43.1-.86.05-1.29.09-.1,0-.2-.04-.3-.06-.36.19-.63.06-.89-.02-.52.13-.93-.04-1.34,0-.79.06-1.57-.08-2.36-.11-.74-.03-1.47-.17-2.2-.33-.41-.09-.84-.11-1.26-.17-.35-.05-.73-.07-1.05-.2-.54-.21-1.1-.16-1.65-.28-.22-.05-.44,0-.59-.23-.33-.11-.45-.18-.54-.28-.13-.13-.06-.25.05-.37.22-.63.22-.66.72-.63.5.02.99.05,1.49,0c.18-.02.37.07.56.09.63.07,1.26.14,1.88.2.24.02.48,0,.72,0c.16,0,.33-.01.47.04.38.16.79.02,1.17.11.08.02.17,0,.25,0c.54.06,1.08.16,1.63.05.21-.04.44.08.67.08.75,0,1.5,0,2.25,0c.09,0,.18,0,.26,0c.34-.05.67-.11,1.03-.06.29.04.61-.1.92-.15.15-.03.3-.07.45-.05.42.06.81-.11,1.21-.16.5-.06.99-.26,1.52-.12.18.05.27.12.31.3.08.41.19.81.28,1.21Z"
                fill="#81c6b2"
              />
              <path
                d="M1025.21,127.74c.25.06.51.11.75.2.42.16.83.36,1.24.54.67.41,1.27.37,1.78.62.71-.2,1.3.05,1.9.09.27.02.55-.07.83-.07.25,0,.51.09.76.06.4-.04.81,0,1.21-.02.4-.01.81.07,1.22.08.36,0,.73.04,1.09.06.67.04,1.32-.11,1.97-.25.1-.02.2-.06.3-.07.52-.06,1.03-.15,1.55-.17.75-.03,1.46-.3,2.22-.28.6.02.63.19.69.68.02.18-.1.32-.21.31-.46-.01-.77.34-1.2.41s-.83.27-1.25.37c-.69.18-1.4.27-2.07.5-.86.29-1.73.25-2.61.33-.35.03-.68-.06-1.02-.03-.71.08-1.42-.04-2.13.08-.44.07-.9-.03-1.35-.06-.49-.03-.98.09-1.46-.09-.74.12-1.43-.18-2.13-.32-.32-.06-.61-.24-.91-.37-.33-.14-.69-.22-.98-.46-.15-.12-.38-.15-.58-.22-.15-.05-.23-.15-.21-.31.04-.41.05-.82-.18-1.19.29-.25.53-.33.79-.42Z"
                fill="#81c6b2"
              />
              <path
                d="M1025.01,123.19c.22.03.37.02.49.08.52.27,1.1.32,1.66.46.55.14,1.11.26,1.67.38.78.17,1.56.35,2.37.35.56,0,1.13-.01,1.69,0c.21,0,.41.05.62.07.09,0,.17.03.26.02.37-.02.75-.12,1.12-.07.89.13,1.79,0,2.68.07.2.18.31-.16.47-.08.16.07.3.1.43-.04.71.06,1.27-.24,1.86-.31.33-.04.66-.03.99-.06.13-.01.27-.04.4-.08.41-.12.53.04.73.38.07.11-.02.15-.08.21-.33.33-.75.53-1.19.62-.45.09-.85.29-1.27.44-.14.05-.28.29-.45.04-.46.39-.99.31-1.45.44-.48.13-.98.19-1.47.2-.37,0-.73,0-1.11.03-.53.04-1.06.03-1.59.04-.94.02-1.89.05-2.83.05-.43,0-.86-.11-1.29-.12-.63-.02-1.21-.25-1.81-.37-.77-.16-1.56-.24-2.32-.49-.3-.1-.58-.23-.71-.55-.03-.07-.13-.11-.18-.19s-.07-.17-.09-.27c-.02-.09.03-.23-.02-.28-.25-.28-.07-.55.04-.78.06-.11.29-.14.38-.18Z"
                fill="#81c6b2"
              />
              <path
                d="M1038.76,133.51c.18-.23.47-.14.68-.16.57-.05,1.13-.25,1.71-.14.34-.13.4-.11.41.08c0,.2.25.3.24.54c0,.16,0,.28-.15.33-.47.16-.95.32-1.43.46-.38.12-.77.22-1.15.32-.37.1-.74.17-1.11.27-.2.05-.39.16-.6.19-.95.14-1.86.46-2.85.47-.67,0-1.34-.08-2.01-.02-.3.02-.6-.14-.9,0-.43-.26-.93-.04-1.39-.21-.24-.09-.57-.04-.85-.07-.4-.05-.79-.09-1.18-.17-.8-.17-1.6-.35-2.38-.57-.38-.11-.73-.33-1.08-.52-.08-.04-.16-.22-.13-.3.09-.31.01-.6-.1-.87-.08-.19-.03-.29.09-.41.38-.41.61-.49,1.09-.19.66.41,1.42.46,2.12.69.6.2,1.24.36,1.86.4.59.03,1.16.13,1.74.2.5.06,1,.12,1.5.2.45.07.92.12,1.39.06.31-.04.62-.02.93-.02.44.01.85-.15,1.3-.14.19,0,.4-.12.61-.18.54-.15,1.09-.24,1.65-.23.03.04.02.02,0,0Z"
                fill="#81c6b2"
              />
              <path
                d="M1021.06,75.92c.14.01.28.03.25.23-.04.39-.07.78-.1,1.17c0,.1.03.2.07.29.13.25.15.48-.03.74-.14.19-.23.43-.06.68.12.17-.04.29-.11.42.16.6.29.99.18,1.32-.08.23,0,.39.04.6.04.25.24.53-.01.78.29.31.03.65.2.88.04.05-.03.19-.06.29.21.45,0,.83.13,1.13-.05.35-.16.5.04.64-.23.29.07.75-.32.98-.05.27-.3.53-.03.82.05.05.06.21.03.23-.22.18-.1.43-.04.57.17.37.11.75.19,1.12.04.19.03.39.1.56.07.19-.12.36.03.55.14.18-.26.07-.19.26.05.13.32-.1.28.18-.01.12,0,.25,0,.37c0,.42-.02.84.17,1.24.03.07,0,.25-.04.27-.35.14-.07.43-.17.63.24.3.17.61.06.93.31.35.34.36.19.64-.08.15.11.16.07.26s-.09.19-.12.29c.33.15.25.38.23.51-.02.16-.13.32-.25.45-.08.09-.51-.1-.57-.26-.07-.18-.16-.37-.15-.55.03-.37-.08-.67-.25-.98-.06-.12-.12-.28-.08-.39.07-.26.21-.51-.1-.71.12-.7-.18-1.21-.17-1.75c0-.33-.17-.64-.02-.99.07-.15-.08-.39-.13-.59-.04-.18-.14-.33,0-.54.06-.08-.06-.3-.12-.45-.03-.09-.14-.18-.13-.26.02-.16.16-.34.13-.48-.04-.16-.18-.27-.02-.46.05-.06.02-.27-.05-.33-.26-.26-.2-.6-.24-.89-.05-.45,0-.91-.01-1.36c0-.17-.04-.34-.15-.5-.2-.29-.16-.63-.03-.95-.15-.7-.07-1.2-.09-1.68c0-.21,0-.42,0-.63c0-.13-.09-.26.07-.37-.27-.33-.09-.57-.08-.79c0-.12-.05-.24-.07-.35-.04-.22-.09-.45.09-.65-.03-.52.07-.83.16-1.14-.15-.53.07-.9.03-1.28-.01-.13.05-.27.09-.4-.26-.38.04-.72-.07-1.01-.09-.26-.03-.53.19-.77.25-.26.42-.6.5-.96.04-.19.11-.28.32-.19.08.03.17,0,.26.02.16.02.25.11.26.27.02.23.05.45.05.68c0,.07-.1.16-.18.21-.12.09-.22.18-.09.34.33.4.19.77-.08,1.13-.04.04-.02.02,0,0Z"
                fill="#ffece5"
              />
              <path
                d="M1031.69,80.2c.19,0,.37,0,.29.28-.03.09-.02.2.01.29.06.16.12.26-.07.39-.18.12-.16.33-.02.5.22.25.25.54.23.85-.03.51-.05,1.02-.08,1.53-.13.32-.15.43-.02.46.19.05.19.13.14.3-.04.13.02.3.01.45c0,.09-.03.19-.05.28.19.4.04.65.09.85.02.08-.01.22-.07.28-.23.25-.2.5-.04.77.08.29-.21.39.01.57.08.07,0,.31.04.46.04.17.15.32.18.49.04.2.03.41.04.61.02.31-.04.64.07.91.12.29.06.55.01.81-.02.14-.03.25,0,.39.04.27.09.57,0,.82-.14.39.03.72.08,1.07.03.26.07.52.05.79-.01.15.04.35.13.45.21.21.12.47.2.7.11.07.31.18.11.28-.22.11-.2.18-.11.34.22.41.09.85.05,1.27c0,.07-.09.15-.15.2-.14.13-.29.26-.49.43-.01-.51-.34-.94-.18-1.49.08-.28-.11-.62,0-.95-.2-.31-.28-.52-.17-.75.04-.08.06-.14-.03-.22-.09-.07-.14-.2-.18-.31-.11-.3-.12-.62-.26-.92-.11-.25-.11-.57.02-.85-.03-.23.14-.36-.01-.5-.07-.78.01-1.18.08-1.58.01-.07-.03-.19-.08-.24-.3-.27-.21-.6-.18-.92-.35-.34-.22-.65-.23-.85-.04-.74-.03-1.47-.02-2.21c0-.18.14-.36.12-.53s-.17-.33-.23-.51c-.07-.21-.08-.44-.16-.65s.15-.2.2-.32c-.08-.09-.16-.18-.23-.28.17-.57-.23-.94-.12-1.33.08-.29.06-.61.07-.91c0-.19.19-.4-.08-.56.1-.38.14-.58-.14-.72.08-.37-.07-.58-.13-.79-.04-.14-.03-.19.12-.2-.24-.24-.19-.39-.16-.58.04-.23.08-.46-.05-.71-.13-.22-.03-.45.18-.59.15-.1.14-.2.01-.28-.24-.15-.24-.31-.1-.52.04-.07.1-.18.07-.23-.14-.24-.02-.45.05-.66.05-.15.07-.26-.11-.34-.21-.09.05-.3-.09-.42.21-.15.03-.28-.01-.42s-.03-.3-.06-.45c-.02-.09-.07-.18-.09-.28.27-.7.23-1.26.23-1.81c0-.14-.01-.28.02-.42.43-.09.54-.24.68-.42.06-.08.17-.14.26-.16.26.15.31.26.3.36-.01.41-.05.82-.07,1.23-.01.28,0,.56-.02.84c0,.17.07.35-.12.48.36.61.37,1.13.33,1.65.2.4.1.65.1.88c0,.22,0,.43-.01.65c0,.27-.02.54-.02.81c0,.32.01.64.01.96-.08.5-.06.41-.06.3.06.24.23.6-.1.8-.04.09-.02.07,0,.05Z"
                fill="#ffece5"
              />
              <path
                d="M1034.31,140.77c-.65.18-1.18,0-1.71.03-.41-.11-.7-.08-.95-.14-.55-.15-1.11-.18-1.65-.17-.73,0-1.42-.26-2.14-.29-.22-.01-.43-.14-.64-.23-.32-.13-.63-.25-.94-.4-.09-.04-.15-.15-.22-.23-.07.12-.17.08-.27.04-.23-.33-.39-.38-.6-.38.03-.56-.03-.99.15-1.38.09-.21.2-.29.38-.24.34.09.67.2.99.35.63.3,1.27.56,1.99.59.12,0,.24.05.35.08.53.16,1.08.18,1.62.23.54.04,1.07.14,1.6.22.37.05.74.17,1.12.17.41,0,.83-.08,1.24-.13.31-.04.62-.08.92-.12.94-.12,1.89-.12,2.81-.38.72-.05,1.21-.14,1.69-.3.2-.06.3,0,.37.17.1.21.24.38.23.54-.01.2-.32.22-.41.35-.29.44-.76.48-1.18.61-.4.12-.82.2-1.22.34s-.84.24-1.26.26c-.68.03-1.29.33-1.96.38-.1,0-.2.02-.33.04Z"
                fill="#81c6b2"
              />
              <path
                d="M1041.47,91.67c-.24-.41-.14-.81.01-1.22.11-.3.18-.61.1-.96-.05-.2-.14-.43.04-.64-.06-.46-.3-.69-.08-.89.16-.14.18-.19,0-.31-.06-.03-.08-.15-.08-.24c0-.35-.01-.7,0-1.05c0-.2.01-.4.04-.6.02-.15-.15-.35.08-.47-.14-.23-.12-.34-.05-.46.04-.07.07-.19.03-.23-.14-.15-.24-.27-.16-.5.06-.16.02-.36.01-.55c0-.19-.02-.38-.04-.57.02-.5-.05-.91-.06-1.31c0-.23,0-.43.24-.59.2-.14.16-.4-.01-.66-.22-.34-.4-1.18-.38-1.59.02-.31-.02-.63-.04-.95-.02-.43-.04-.86-.06-1.3c0-.12-.03-.24-.03-.36c0-.11-.01-.25.04-.34.07-.11.09-.18-.01-.27-.18-.14-.14-.31-.15-.51-.01-.36-.09-.72-.09-1.08c0-.27-.03-.54-.07-.8-.02-.15-.14-.29-.15-.44c0-.11.2-.22.02-.36.35-.31.61-.47.87-.64.44.32.42.8.41,1.26c0,.13-.01.22.06.33.06.1.05.23.07.35.03.19.06.38.09.56.03.16-.11.35.08.48-.12.22-.01.43,0,.65.02.24.26.46.07.73-.02.02.1.13.14.21.09.15.14.29.06.49-.07.19-.03.42-.03.64.01.42-.09.63.13.78-.13.43.17.77.12,1.15-.02.14.03.31.09.44.07.13.12.2-.03.3.03.38.06.54-.14.69-.02.02.04.15.07.24-.25.21-.26.41-.15.46.24.1.18.24.2.43s.11.37-.04.54c.23.34,0,.68.08.96.05.15.04.32.03.47-.03.25-.22.5.08.71-.08.21-.18.26-.06.35.14.1.12.26.05.38-.13.24-.18.49-.16.76-.25.35-.11.52-.01.71.09.17.17.32.03.53-.08.11-.02.33,0,.49.02.22.06.44-.03.66-.03.07,0,.18.03.24.13.2.07.36-.08.52.37.38-.3.69-.07,1-.31.27-.06.55-.07.8-.31.44-.21.8-.3,1.11-.39.3-.4.41-.2.62-.04.39-.12.61-.23.82-.04.09-.12.17-.2.22-.2.13-.26.1-.36-.1s-.02-.44-.22-.62c-.08-.08.07-.3.28-.35.11-.02.26-.09.01-.21-.12-.06-.17-.27-.25-.42q.58-.15.43-.51v0Z"
                fill="#ffece5"
              />
              <path
                d="M1025.52,118.84c.58.02,1.15.04,1.72.04.26,0,.46.17.75.13.42-.05.86.04,1.3.09.45.05.89.13,1.34.15.23.01.46.07.68.06.23,0,.48.1.66.04.43-.13.85.14,1.28-.06.2-.09.47-.02.7-.02.2,0,.4.01.6-.02.2-.04.39-.07.61-.05.39.04.8-.02,1.19-.07.45-.05.89-.12,1.34-.21.86-.17,1.75-.21,2.59-.52.21-.08.43-.12.65-.18.27-.08.61.11.61.39c0,.19.06.31.15.45.1.15.06.26-.06.36-.46.42-1.03.64-1.63.76-.47.1-.95.21-1.42.28-.51.07-1.03.13-1.54.15-.69.03-1.37.09-2.06.18-.25.03-.51-.02-.77,0-.25.03-.5-.02-.76.03-.45.08-.92.02-1.39-.06-.43-.07-.87-.08-1.3-.12-.29-.02-.59.07-.86-.15-.08-.06-.26.01-.39,0-.98-.15-1.95-.31-2.92-.47-.15-.03-.33-.04-.45-.11-.18-.11-.33-.11-.53-.1-.17,0-.36-.11-.53-.2-.23-.12-.15-.32-.1-.51.06-.19.13-.37.39-.32.05.01.1.03.14.04Z"
                fill="#81c6b2"
              />
            </g>
          </g>
          <g
            transform="matrix(.987762-.155969 0.155969 0.987762 137.89642 20.90347)"
          >
            <g transform="translate(.000005 0.00002)">
              <g>
                <path
                  d="M1061.59,450.81c-.48-.14-.97-.27-1.45-.43-.59-.2-1.29-.28-1.72-.67-1.23-1.11-2.72-1.68-4.22-2.24-.38-.14-.78-.35-1.17-.36-1.08-.03-1.85-.59-2.54-1.33-1.23-1.33-2.02-2.91-2.43-4.64-.89-3.72-1.15-7.47-.64-11.29.6-4.55,2.79-8.2,6.07-11.28.34-.32.71-.6,1.06-.91-.26-1.33-1.06-2.07-1.89-2.78-2.34-2-4.46-4.19-6.42-6.57-.94-1.14-2.16-2.1-3.38-2.96-1.46-1.04-2.82-2.15-3.83-3.62-1.59-2.3-3.69-4.07-5.76-5.89-1.36-1.19-2.62-2.52-3.77-3.92-1.27-1.54-2.64-2.94-4.27-4.08-2.15-1.5-4.03-3.23-5.65-5.32-1.04-1.34-2.35-2.49-3.66-3.59-1.96-1.65-3.74-3.41-5.2-5.55-2.02-2.96-4.28-5.76-6.4-8.64-.65-.88-1.2-1.82-1.82-2.77-2.72-.28-4.53-1.83-6.21-3.94-2.55-3.23-1.95-6.49-.67-9.83.55-1.43,1.49-1.82,3.02-1.62c2.56.33,4.4,1.77,5.71,3.91c1.61,2.62,1.73,5.5,1.23,8.45-.04.26-.13.5-.23.9.24.46.46,1.05.81,1.55c1.76,2.51,3.54,5.01,5.33,7.5.73,1.01,1.56,1.96,2.23,3.01c1,1.56,2.22,2.88,3.68,4c2.11,1.63,3.89,3.57,5.59,5.63c1.11,1.35,2.51,2.48,3.9,3.55c1.98,1.54,3.88,3.14,5.33,5.21c1.43,2.04,3.56,3.33,5.29,5.05c1.21,1.2,2.42,2.44,3.47,3.78c1.17,1.49,2.44,2.83,4.04,3.86c1.68,1.07,3.05,2.47,4.31,4.02c1.21,1.49,2.55,2.88,3.95,4.19c1.64,1.52,3.4,2.89,4.56,4.85c2.49-.26,4.91-.51,7.15-.74c3.2-4.62,6.26-9.14,9.44-13.57c1.17-1.63,2.58-3.12,4.01-4.54c1.85-1.83,3.73-3.6,5.26-5.74.81-1.12,1.86-2.1,2.93-3c2.24-1.87,4.35-3.84,6.17-6.15c1.02-1.28,2.35-2.35,3.66-3.36c1.91-1.47,3.63-3.08,5.06-5.04.84-1.16,1.93-2.19,3.05-3.1c2.25-1.84,4.05-3.98,5.37-6.6.83-1.66,2.02-3.14,3.07-4.69.41-.6.87-1.17,1.31-1.75.57-.74.77-1.52.57-2.47-.78-3.66.71-6.6,3.1-9.19.91-.98,2.02-1.61,3.43-1.6c1.09,0,1.96.39,2.45,1.36c1.34,2.68,1.65,5.35-.22,7.96-.61.84-1.24,1.68-1.78,2.56-.89,1.47-2.01,2.53-3.94,2.38-1.73,2.54-3.94,4.71-5.26,7.53-1.24,2.64-3.05,4.83-5.33,6.62-1.57,1.23-2.83,2.72-4.08,4.27-1.19,1.48-2.66,2.77-4.15,3.96-1.75,1.41-3.34,2.93-4.79,4.65-1.43,1.7-3.12,3.19-4.81,4.65-1.38,1.2-2.62,2.49-3.78,3.91-1.51,1.84-3.19,3.56-4.91,5.21-1.55,1.49-2.93,3.07-4.13,4.85-1.94,2.89-4.01,5.7-6.01,8.56-.74,1.06-1.42,2.17-2.08,3.2c2.28,1.31,3.6,3.02,4.88,4.82c2.46,3.46,4.1,7.32,5.51,11.29.41,1.16.6,2.42.83,3.64.3,1.59-.02,3.12-.76,4.53-.79,1.52-1.63,3.02-2.54,4.47-1.55,2.48-3.89,3.83-6.67,4.47-1.16.27-2.34.45-3.51.69-.23.05-.43.22-.65.34-1.34.14-2.69.28-4.03.42Z"
                  fill="#2b231d"
                />
                <path
                  d="M1082.33,455.75c.19,1.86.38,3.73.57,5.59-.07.25-.18.49-.19.74-.08,2.49-.03,4.98-.25,7.45-.24,2.65-.18,5.28-.08,7.92.06,1.66.12,3.32.16,4.98.07,3.52.09,7.04.2,10.56.08,2.49.29,4.97.44,7.46s.31,4.97.42,7.46c.07,1.5.07,3.01.09,4.51.03,2.02-.03,4.04.1,6.06.14,2.23.48,4.45.65,6.68.12,1.6.14,3.22.09,4.82-.07,2.54-.23,5.07-.35,7.61-.16,3.31-.28,6.62-.49,9.92-.12,1.91-.36,3.82-.58,5.73-.24,2.16-.58,4.31-.78,6.48-.6,6.49-1.84,12.86-3.43,19.16-.77,3.07-1.66,6.12-2.67,9.12-.75,2.22-1.83,4.3-3.94,5.63-1.31.83-2.51.68-3.34-.59-.62-.96-1.13-1.98-1.73-2.96-3.07-5.03-4.79-10.59-6.34-16.2-1.2-4.34-2.37-8.7-3.38-13.1-.76-3.3-1.09-6.65-1.74-9.95-.7-3.56-.79-7.21-1.41-10.81-.71-4.09-.91-8.27-1.33-12.41-.02-.21,0-.42-.01-.62-.09-2.64-.12-5.29-.3-7.92-.09-1.34-.51-2.65-.66-3.99-.56-5.02-1.02-10.04-1.59-15.06-.54-4.75-1.14-9.49-1.78-14.23-.14-1-.58-1.96-.88-2.94-.55-5.39-1.11-10.77-1.66-16.16.09-1.12.2-2.25.25-3.37.23-4.56,1.32-8.93,3.01-13.15.73-1.81,1.9-3.44,3.63-4.35c2.8-1.47,5.72-2.68,8.91-3.08c3.25-.41,6.48-.61,9.75-.04c2.6.46,5,1.28,6.47,3.56c1.03,1.59,1.71,3.42,2.48,5.17.62,1.41,1.13,2.88,1.69,4.32Z"
                  fill="#f68a78"
                />
                <path
                  d="M1051.98,432.05c-.13-2.77.05-5.5,1.3-8.04.78-1.59,2.03-2.41,3.84-2.42c1.49,0,2.55.72,2.79,2.16.54,3.31.27,6.44-2.24,9-.69.7-1.28,1.53-2.07,2.08-1.69,1.19-3.18.49-3.49-1.53-.06-.41-.09-.83-.13-1.24Z"
                  fill="#ffc7b5"
                />
                <g>
                  <path
                    d="M1066.12,449.59c1.88.95,2.4,3.08,2.05,4.59-.26,1.1-1.32,2.16-2.42,2.37-1.31.25-2.27-.17-3.02-1.36-1.16-1.82-.82-3.73.91-5.05c1.04-.41,1.77-.48,2.49-.56Z"
                    fill="#2b231d"
                  />
                  <path
                    d="M1068.35,516.84c-.31.33-.68.67-1,1.06-1.09,1.32-2.17,2.65-3.24,3.99-.4.51-.84.88-1.54.92-.57.03-1.05-.11-1.36-.58-.33-.51-.36-1.07-.02-1.62c1.4-1.86,2.69-3.62,4.04-5.33.77-.98,1.82-1.47,3.09-1.57.94-.07,1.72.15,2.45.73s1.59,1,2.27,1.62c1.29,1.19,2.54,2.43,3.71,3.73.64.72.52,1.44-.06,1.93-.55.47-1.32.44-1.98-.1-.24-.19-.44-.44-.64-.67-1.37-1.52-3.76-3.26-5.71-4.12Z"
                    fill="#ffece5"
                  />
                  <path
                    d="M1073.21,465.71c-.37.37-.58.6-.81.8-.15.13-.33.23-.56.39-2.42-.98-3.56-3.61-5.98-4.68-1.26.82-1.72,2.28-2.61,3.39-.52.64-.92,1.38-1.44,2.02-.93,1.17-1.17,1.23-2.9.93-.55-1.02-.52-1.94.27-2.95c1.18-1.51,2.27-3.09,3.3-4.7c1.4-2.18,4.34-2.48,5.76-.93.87.95,1.84,1.82,2.75,2.74.51.51,1.04,1.02,1.47,1.6.32.42.51.94.75,1.39Z"
                    fill="#ffece5"
                  />
                  <path
                    d="M1077.64,548.59c-1.37.55-1.57.56-2.33-.42-1.33-1.71-3.09-2.89-4.73-4.2-1.03.3-1.77.82-2.37,1.57-.82,1.01-1.64,2.02-2.46,3.02-.23.28-.44.61-.73.8-.6.38-1.27.48-1.91.1-.57-.33-.81-1.02-.55-1.79.14-.43.39-.86.69-1.19c1.18-1.3,2.47-2.51,3.61-3.85c1.26-1.48,4.59-2.11,6.17-.48c1.36,1.41,2.96,2.58,4.11,4.2q.62.87.5,2.23Z"
                    fill="#ffece5"
                  />
                  <path
                    d="M1067.44,490.64c-1.69,1.49-3.15,3.09-4.25,5-.35.61-.86.86-1.54.87-1.21.02-1.9-1.07-1.3-2.14.38-.68.77-1.37,1.28-1.94c1.14-1.27,2.33-2.5,3.54-3.71c1.23-1.24,2.76-1.23,4.21-.64c2.29.94,3.83,2.8,5.15,4.83.32.49.14,1.02-.29,1.41-.47.43-1.07.55-1.58.23-.56-.35-1.07-.83-1.48-1.35-1.17-1.49-1.82-1.98-3.74-2.55Z"
                    fill="#ffece5"
                  />
                  <path
                    d="M1076.24,576.46c-1.51-1.46-2.97-2.88-4.61-4.47-.53.86-.95,1.49-1.32,2.15-.43.77-.8,1.57-1.23,2.34-.52.93-1.26,1.27-2.01.95-.74-.32-1.11-1.39-.67-2.29.59-1.21,1.29-2.36,1.97-3.53.31-.54.65-1.05,1-1.57c1.04-1.54,2.26-1.76,3.6-.52c1.44,1.34,2.9,2.65,3.98,4.33.7,1.1.65,1.55-.71,2.6Z"
                    fill="#ffece5"
                  />
                  <path
                    d="M1067.22,501.38c1.9.13,3.09.94,3.69,2.6.57,1.57.1,3.64-1.21,4.66-.75.59-1.59.9-2.6.5-1.42-.58-2.66-1.46-2.91-2.98-.27-1.63.59-3.01,1.86-4.05.36-.29.79-.49,1.17-.73Z"
                    fill="#2b231d"
                  />
                  <path
                    d="M1070.41,557.83c1.5-.1,3.48,1.37,3.85,3.1.36,1.68-.11,3.11-1.72,3.93-1.45.74-3.21.31-4.03-1.19-.44-.8-.75-1.73-.89-2.63-.22-1.44,1.31-3.11,2.79-3.21Z"
                    fill="#2b231d"
                  />
                  <path
                    d="M1069.36,529.34c2.27-.04,3.6,1.55,3.68,3.6.02.55-.18,1.13-.38,1.65-.38,1.01-1.24,1.66-2.21,1.74-1.07.09-2.2-.22-2.81-1.3-.41-.72-.84-1.46-1.02-2.25-.12-.54.07-1.23.33-1.75.49-.97,1.38-1.51,2.42-1.7Z"
                    fill="#2b231d"
                  />
                  <path
                    d="M1065.89,477.22c1.77-.17,3.22,1.1,3.34,2.92.12,1.76-1.36,3.84-2.87,3.89-1.6.05-3.09-1.12-3.29-3.26-.18-1.97.94-3.38,2.83-3.56Z"
                    fill="#2b231d"
                  />
                </g>
              </g>
              <path
                d="M1067.1,419.95c3.43,2.28,5.35,5.66,6.85,9.35.1.23.12.5.15.76.12.9.16,1.82-.7,2.39-.9.61-1.92.78-2.95.32-.51-.23-1.04-.51-1.44-.89-2.24-2.13-4.03-4.57-4.99-7.55-.55-1.71-.25-2.58,1.13-3.65.24-.19.47-.4.7-.6.41-.04.83-.09,1.24-.13Z"
                fill="#ffc7b5"
              />
            </g>
            <g id="e0gYpSRcAlv2383" transform="translate(2.000004 0.000007)">
              <path
                d="M1223,567.44c-.78-2.08-1.44-4.22-2.36-6.24-.6-1.31-1.54-2.46-2.4-3.63-1.56-2.14-2.97-4.42-4.79-6.32-2.33-2.42-4.95-4.58-7.55-6.72-1.19-.98-2.72-1.54-3.95-2.47-3.75-2.86-8.15-4.28-12.5-5.82-2.44-.87-4.88-1.76-7.3-2.69-2.52-.97-4.99-2.05-7.51-2.99-3.22-1.21-6.31-2.65-9.09-4.71-2.75-2.05-5.62-3.91-8.75-5.34-2.08-.95-4.17-1.86-6.22-2.88-3.49-1.74-7.04-3.29-10.81-4.36-2.49-.71-4.94-1.63-7.29-2.7-3.78-1.72-7.5-3.57-11.18-5.5-1.83-.96-3.52-2.18-5.23-3.36-.67-.46-1.18-1.16-1.82-1.69-2.1-1.74-4.49-2.99-6.98-4.05-2.44-1.04-4.96-1.89-7.37-2.98-3.54-1.61-7.25-2.48-11.08-2.94-1.28-.15-2.57-.37-3.81-.73-3.49-1-6.98-.79-10.49-.2-.14.02-.26.16-.47.28-.02.26-.16.59-.06.84.31.81.61,1.65,1.09,2.37.45.67,1.09,1.22,1.68,1.79.4.39.95.66,1.26,1.11.61.9,1.23,1.83,1.62,2.83.97,2.51,1.83,5.07,2.7,7.62c1.16,3.39,2.33,6.77,3.4,10.19.86,2.77,1.6,5.57,2.35,8.37.6,2.25,1.16,4.52,1.7,6.78.42,1.76.79,3.54,1.19,5.31.52,2.27,1.17,4.52,1.54,6.81.58,3.59,1.04,7.2,1.42,10.81.14,1.32.03,2.7-.2,4.01-.7,3.85-1.87,7.57-3.27,11.21-1.27,3.3-2.73,6.52-4.11,9.77-1.3,3.06-2.54,6.15-3.92,9.17-1.3,2.84-2.79,5.58-3.2,8.74-.11.87-.33,1.73-.46,2.61-.5,3.34-.89,6.68-.43,10.07.26,1.96.36,3.94.64,5.9.22,1.54.66,3.04.89,4.57.3,2,.76,4.02.69,6.02-.11,3.31-.67,6.6-.89,9.91-.15,2.32-.15,4.66-.05,6.99.09,2.13.49,4.24.6,6.37.17,3.13,1.17,6.02,2.57,8.76c1.59,3.12,4.12,5.02,7.73,5.26c2.22.15,4.44.33,6.65.49c1.13.08,2.07.54,2.97,1.22c1.59,1.2,2.92,2.64,4.07,4.26c1.42,1.99,2.92,3.93,4.94,5.36c2.4,1.7,4.92,3.19,7.95,3.22c1.96.02,3.93-.25,5.89-.32c1.61-.06,3.04-.6,4.42-1.36c1.54-.85,3.06-1.76,4.63-2.58c1.67-.86,3.42-1.09,5.27-.55c1.64.48,3.31.89,4.99,1.22c5.53,1.11,10.94.66,16.17-1.5c2.09-.86,3.94-2.07,5.29-3.96c1.71-2.38,2.92-5.02,4.17-7.65c3.05-6.37,2.26-5.35,7.21-9.52c1.8-1.49,3.42-2.22,5.31-2.35c1.61-.12,3.2-.41,4.81-.47c2.84-.11,5.15-1.43,7-3.35c2.09-2.15,4.04-4.49,5.4-7.22.73-1.47,1.12-3.01,1.11-4.65-.01-1.3-.06-2.59,0-3.88.27-4.79,2.9-8.33,6.2-11.48c1.57-1.5,3.22-2.92,4.86-4.36c2.08-1.82,3.15-4.16,3.8-6.82.81-3.33,1.07-6.66.5-10.04-.3-1.75.23-3.32,1.07-4.78c1.46-2.51,3.09-4.93,4.53-7.44c1.68-2.93,3.35-5.89,3.83-9.32.11-.76.23-1.51.35-2.27l-.54-5.28c-.13-.27-.28-.54-.38-.82Z"
                fill="#81c6b2"
              />
              <path
                d="M1125.79,623.24c.52-.02,1.04-.09,1.55-.12c1.19-.07,2-.7,2.65-1.68c1.28-1.94,1.47-4.04,1.16-6.28-.23-1.65-1.05-2.88-2.32-3.9-1.98-1.58-4.12-.84-6.16-.59-1.4,2.39-1.99,4.83-2.1,7.37-.1,2.46,2.01,5.34,5.21,5.19Z"
                fill="#2b231d"
              />
              <path
                d="M1133.98,645.24c.01-2.44.1-4.87-.17-7.3-.15-1.35-.6-2.53-1.55-3.47-.92-.91-1.87-1.78-2.88-2.59-.51-.41-1.12-.77-1.74-.95-1.88-.53-3.59.17-5.16,1.1-1.06.63-2,1.49-2.9,2.34-.99.93-1.68,2.08-2.16,3.38-.94,2.52-.92,5.08-.59,7.25.24,2.5.51,4.53,1.3,6.5c1.21,2.97,3.4,4.47,6.5,4.8.26.03.52,0,.78.03c3.8.55,6.24-1.53,7.3-4.42.79-2.16,1.26-4.32,1.27-6.67Z"
                fill="#2b231d"
              />
              <path
                d="M1195.87,548.37c.97-.25,1.5-.82,1.64-1.82.24-1.7-.69-3.2-2.35-3.71-1.7-.52-3.18.16-4.12,1.93.08.25.18.54.25.84.53,2.14,2.47,3.3,4.58,2.76Z"
                fill="#2b231d"
              />
              <path
                d="M1149.3,620.74c.61.8,1.52,1.01,2.49,1.04c2.29.08,5.11-1.9,5.11-4.82c0-.57-.03-1.14-.06-1.85-.28-2.07-1.21-4.06-2.3-5.91-.82-1.39-1.8-2.88-3.77-2.89-.67,0-1.34,0-2.01.06-1.56.16-1.99.55-2.25,2.06-.24,1.37-.45,2.76-.6,4.14-.15,1.4-.26,2.86.51,4.1.87,1.41,1.87,2.73,2.88,4.05Z"
                fill="#2b231d"
              />
              <path
                d="M1100.95,619.15c.46.03.93-.04,1.4-.06c1.96.13,2.88-1.08,3.6-2.66.71-1.56.63-3.13.34-4.73-.16-.9-.83-1.47-1.8-1.32-1.21.18-2.41.52-3.56.94-.49.18-.97.65-1.25,1.11-.81,1.36-1.18,2.83-1.08,4.46.08,1.36,1.25,2.18,2.35,2.26Z"
                fill="#2b231d"
              />
              <path
                d="M1100.84,641.25c1.51-1.41,2.88-3,4.1-4.66.84-1.14.93-2.58-.15-3.73-.65-.7-1.47-1.27-2.23-1.86-1.83-1.42-3.65-1.44-5.53-.11-.55.39-1.14.72-1.71,1.06-2.27,1.35-3.4,3.27-2.96,6.08.07,1.43.63,2.74,1.94,3.6c1.83,1.2,4.95,1.12,6.55-.37Z"
                fill="#2b231d"
              />
              <path
                d="M1203.55,558.71c.56.37,1.15.72,1.76,1c1.43.65,2.82.51,4.14-.35c1.75-1.13,2.92-2.56,2.89-4.82-.02-1.36-.35-2.46-1.51-3.2-.87-.56-1.8-1.03-2.67-1.59-1.01-.66-2.06-.84-3.26-.67-2.17.3-3.51,1.84-3.37,4.04.03.47.09.93.14,1.4.04.36.1.72.11,1.09.02,1.37.66,2.38,1.77,3.11Z"
                fill="#2b231d"
              />
              <path
                d="M1162.59,630.42c-.23-.48-.71-.92-1.18-1.19-2.47-1.41-4.98-1.61-7.49-.04-.35.22-.7.5-1.09.58-1.77.38-2.81,1.64-3.39,3.16-1.01,2.63-1.58,5.38-1.29,8.24.14.66.24,1.33.41,1.98.97,3.54,3.31,6.07,6.17,8.17c1.09.8,2.5,1.03,3.72.72c1.97-.51,3.69-1.6,4.94-3.32c2.53-3.49,2.85-7.37,2.07-11.44-.48-2.48-1.83-4.61-2.88-6.86Z"
                fill="#2b231d"
              />
              <path
                d="M1191.7,567.67c-.3-1.97-1.43-3.33-3.44-3.76-.69-.15-1.44-.05-2.16-.06-1.01.2-2.08.1-2.8,1.12-1.31,1.87-1.21,4.63-.29,6.23c1.3,2.26,4.94,2.87,7.02,1.23c1.54-1.22,1.94-2.93,1.67-4.76Z"
                fill="#2b231d"
              />
              <path
                d="M1201.5,574.34c-1.77-1.53-5.29-1.32-7.02.35-1.42,1.36-2.01,3.05-2.09,4.87-.1,2,.11,4.01.19,6.2.2.83.34,1.87.72,2.82.97,2.41,3.06,3.36,5.42,3.94c1.58.39,2.91,0,3.94-1.18c2.16-2.49,3.53-5.37,3.75-8.69.15-2.22-.5-4.21-2.14-5.79-.89-.87-1.82-1.7-2.77-2.51Z"
                fill="#2b231d"
              />
              <path
                d="M1208.06,604.1c-2.2-1.45-4.6-1.82-7.13-.92-.23.08-.5.03-.7.05-1.45-2.31-2.81-4.57-4.28-6.76-.75-1.12-1.71-2.09-2.55-3.14-.58-.73-1.24-1.43-1.65-2.26-1.18-2.41-2.83-4.47-4.59-6.46-.65-.74-1.31-1.49-1.83-2.32-1.04-1.64-2.22-3.14-3.63-4.46-.6-.57-1.22-1.14-1.74-1.78-2.36-2.91-4.87-5.64-7.63-8.2-3.5-3.25-6.73-6.77-10.26-10.01-5.17-4.74-10.34-9.48-15.93-13.73-1.7-1.29-3.45-2.5-5.53-3.14-.43-.13-.81-.41-1.23-.62.1-3.93-.3-7.73-1.01-11.66c1.28.54,2.54.98,3.72,1.58c2.59,1.33,5.22,2.53,7.99,3.45c1.22.41,2.37,1.05,3.52,1.64c4.02,2.06,8.05,4.1,12.36,5.49c1.08.35,2.2.69,3.18,1.24c3.67,2.09,7.59,3.62,11.43,5.31c2.59,1.14,5.01,2.5,7.12,4.41.92.83,1.91,1.62,2.98,2.25c1.87,1.1,3.34,2.6,4.81,4.16c1.46,1.54,3.09,2.92,4.65,4.36.65.6,1.43,1.07,1.98,1.75c2.06,2.54,4.06,5.13,6.08,7.71.44.56.86,1.15,1.21,1.61.01,1.46-.03,2.86.04,4.24.08,1.4.27,2.8.41,4.2.42,4.41,1.94,8.4,4.63,12c.19-.51.43-1.01.71-1.49c1.46-2.51,3.09-4.93,4.53-7.44c1.68-2.93,3.35-5.89,3.83-9.32.11-.76.23-1.51.35-2.27l-.32-3.13c-.3-.22-.63-.43-1.01-.62-3.28-1.61-6.35-1.55-9.57-.25-.47.19-.93.39-1.49.63-1.55-1.74-3.07-3.45-4.6-5.14-.66-.73-1.34-1.45-2.03-2.15-1.75-1.78-3.59-3.48-5.24-5.34-1.36-1.54-2.83-2.9-4.56-3.98-1.19-.74-2.39-1.47-3.61-2.16-3.9-2.2-7.68-4.56-11.2-7.34-1.25-.99-2.68-1.82-4.15-2.43-5.56-2.3-11.16-4.52-16.77-6.71-7.29-2.85-14.6-5.64-22.08-8.53-.58-1.75-1.65-3.45-3.05-4.94-2.52-3.87-4.96-7.43-7.15-11.14-.77-1.3-1.65-2.49-2.6-3.61-1.07-.55-2.15-1.08-3.22-1.64-.14,1.04.51,1.63.95,2.31c2.59,4.02,5.28,7.97,7.78,12.04c1.9,3.09,3.61,6.3,5.33,9.5.91,1.7,1.4,3.55,1.6,5.49.26,2.55-.03,5.08-.15,7.61-.06,1.36-.56,2.63-1.45,3.53-1.29,1.32-2.83,2.41-4.3,3.55-.35.27-.84.41-1.29.52-3.64.92-7.31,1.49-11.08.96-.72-.1-1.45-.08-2.17-.2-.96-.16-2-.21-2.84-.63-3.06-1.54-6.08-3.15-9.04-4.87-1.65-.96-3.24-2.09-4.69-3.34-1.89-1.63-3.58-3.47-5.4-5.18-.6-.56-1.29-1.06-2.02-1.44-.82-.42-1.67-.77-2.24-1.5.2.89.4,1.78.59,2.68c1.01.76,2.07,1.46,2.85,2.4c2.31,2.78,4.82,5.29,7.82,7.27-.09,3.97-.17,7.85-.28,11.74-.1,3.68-.36,7.36-.31,11.05.05,4.09-.55,8.07-1.51,12.01-1.21,4.94-2.61,9.83-3.76,14.79-.77,3.31-1.84,6.48-3.32,9.54-.79,1.63-1.28,3.4-1.89,5.11-.33.92-.63,1.85-.89,2.62-1.46.31-2.76.46-3.97.88-2.39.81-4.44,2.16-6.35,3.7.22,1.04.47,2.07.63,3.12.3,2,.76,4.02.69,6.02-.11,3.31-.67,6.6-.89,9.91-.05.76-.06,1.53-.08,2.3.71-.26,1.32-.56,1.89-.92c1.78-1.14,3.12-2.72,4.29-4.46.84-1.25,1.7-2.49,2.63-3.67c1.02-1.28,1.81-2.66,2.25-4.24.82-2.98,1.2-6.01.71-9.08-.15-.93.06-1.71.4-2.55c1.02-2.55,1.97-5.13,2.95-7.7.24-.63.43-1.29.71-1.89c1.84-3.97,2.71-8.27,4.18-12.37.36-1.02.68-2.06.99-3.1.28-.94.62-1.88.78-2.84.37-2.14.7-4.3.96-6.45.59-4.73,1.08-9.47,1.71-14.19.35-2.58.54-5.15.56-7.75.01-1.92-.01-3.84-.05-5.76-.03-1.28-.11-2.56-.17-3.92c1.1.82,2.17,1.82,3.42,2.49s2.69,1.01,3.99,1.48c.87,2.16,1.22,4.41,1.09,6.63-.15,2.52.02,4.98.28,7.47.2,1.92.42,3.83.52,5.75.11,2.23.12,4.46.14,6.69.02,1.56.1,3.12-.02,4.67-.17,2.28-.49,4.55-.12,6.84.05.3,0,.62-.02.93-.19,2.22-.42,4.44-.56,6.66-.07,1.08.14,2.19.07,3.27-.24,3.51-.52,7.03-.83,10.54-.28,3.14-1.09,6.26-.53,9.45-.32,3.67-.56,7.04-.92,10.39-.3,2.78-.7,5.56-1.11,8.33-.16,1.07-.43,2.12-.71,3.17-.27,1-.61,1.98-.91,2.98-.16.54-.3,1.08-.4,1.46-.87.44-1.59.74-2.25,1.14-1.9,1.17-3.78,2.37-5.64,3.6-.95.63-1.95,1.24-2.72,2.04-2.77,2.88-4.56,6.23-5.07,10.13c1.7.12,3.4.26,5.09.37c1.13.08,2.07.54,2.97,1.22c1.59,1.2,2.92,2.64,4.07,4.26c1.42,1.99,2.92,3.93,4.94,5.36.31.22.63.44.95.65.55.1.87.32,1.09.68.57.34,1.16.66,1.76.93.32-.3.5-.69.55-1.17.16-1.33.17-2.7.45-4c.66-3.05,1-6.13,1.24-9.23.25-3.21-.16-6.33-.96-9.41-.56-2.15-1.77-3.96-3.46-5.57.18-.75.29-1.53.55-2.24.71-1.91,1.08-3.89,1.29-5.91.19-1.75.42-3.5.6-5.25.34-3.3.7-6.59.97-9.9.36-4.44.66-8.88.98-13.32.19-2.69.4-5.37.57-8.06.27-4.23.54-8.47.79-12.71.13-2.27.34-4.55.33-6.83-.02-4.05-.14-8.1-.31-12.14-.2-4.99-.65-9.96-1.51-14.88-.05-.31-.16-.6-.24-.9-.28-1.09-.55-2.18-.79-3.13c1.53.24,2.99.53,4.46.67c1.13.11,2.27.05,3.41.04c1.44,0,2.89-.03,4.33-.04.18.32.37.57.47.86.69,1.9,1.42,3.78,2.02,5.71c1.31,4.26,2.43,8.58,3.08,13c.27,1.85.58,3.69.93,5.53.58,3.11,1.29,6.2,1.78,9.32.59,3.75,1.02,7.52,1.49,11.29.18,1.39.28,2.8.44,4.19.18,1.5.35,3,.58,4.49.37,2.41.82,4.81,1.18,7.22.32,2.16.46,4.35.9,6.48.46,2.22.42,4.44.42,6.67c0,2.33-.19,4.68-.04,7c.37,5.55.89,11.09,1.35,16.63.03.41.08.82.09.89-.7,1.4-1.37,2.47-1.79,3.62-1.21,3.31-2.32,6.66-3.49,9.99-.81,2.28-1.06,4.6-.82,6.97.82-.07,1.66,0,2.53.25c1.64.48,3.31.89,4.99,1.22c4.84.97,9.58.75,14.2-.77c1.16-.6,1.46-1.47,1.35-3.03-.37-5.11-2.43-9.49-5.63-13.4-1.28-1.56-2.8-2.73-4.79-3.3-1.23-.35-2.39-.96-3.51-1.43-.35-1.71-.71-3.33-1-4.96-.24-1.33-.55-2.67-.58-4.01-.04-2.17.13-4.35.19-6.52.02-.83.02-1.66-.04-2.49-.12-1.82-.28-3.63-.43-5.45-.22-2.64-.42-5.27-.68-7.91-.29-3-.66-5.98-.96-8.98-.23-2.22-.22-4.49-.67-6.67-.47-2.31-.65-4.62-.73-6.95-.08-2.28-.06-4.57-.59-6.82-.23-.96-.42-1.92-.57-2.9-.55-3.53-.41-7.14-1.69-10.58-.88-2.37-1.31-4.9-1.98-7.35-.65-2.34-1.43-4.65-2.03-7.01-.88-3.46-1.58-6.98-3.25-10.18-.13-.26-.2-.55-.32-.87c2.43-.37,4.36-1.65,6.36-3.03c1.42,1.84,2.98,3.43,4.01,5.32c1.07,1.97,2.27,3.81,3.52,5.66c1.77,2.61,3.47,5.28,5.15,7.95c1.98,3.16,3.59,6.55,5.38,9.83.55,1,1.09,2.01,1.7,2.97c1.97,3.14,3.37,6.54,4.38,10.09c1.13,3.99,2.16,8,3.2,12.01.88,3.41,1.7,6.84,2.57,10.25.61,2.41,1.08,4.87,1.9,7.21c1.81,5.18,3.8,10.29,5.78,15.61-.13.11-.34.27-.53.45-1.87,1.84-2.44,4.23-2.5,6.69-.09,3.74.99,7.15,2.82,10.29.68-.6,1.56-1.32,2.82-2.39c1.8-1.49,3.42-2.22,5.31-2.35c1.61-.12,3.2-.41,4.81-.47c1.5-.06,2.85-.46,4.07-1.11-.03-1.54-.12-3.09-1.03-4.47-1.02-1.56-1.93-3.2-3.02-4.71-2.34-3.24-5.42-4.74-9.46-3.76-.25.06-.5.09-.82.15-.41-.69-.9-1.31-1.2-2.01-1.11-2.69-2.1-5.45-2.44-8.34-.32-2.72-1.14-5.27-1.98-7.83-1.12-3.45-2.33-6.86-3.47-10.3-.2-.59-.3-1.21-.4-1.82-.11-.67-.09-1.37-.28-2.01-.87-2.93-1.8-5.84-2.71-8.76-.31-.99-.61-1.99-.93-2.97-.31-.93-.62-1.86-.98-2.78-.33-.87-.71-1.72-1.09-2.58-.54-1.23-1.06-2.47-1.66-3.67-1.74-3.47-3.51-6.93-5.29-10.38-.66-1.29-1.35-2.57-2.09-3.82-1.14-1.92-2.37-3.79-3.5-5.71-2.09-3.54-4.45-6.9-7.14-10.01-1.11-1.28-1.91-2.69-2.79-4.17c1.31-1.43,2.05-3.1,2.12-5.1c2.46.68,4.19,2.23,5.95,3.78c1.32,1.17,2.69,2.3,4.18,3.22c1.78,1.11,3.43,2.32,4.88,3.84c1.29,1.35,2.68,2.61,4.08,3.85c2.21,1.97,4.48,3.87,6.46,6.09c1.49,1.66,3.3,3.02,4.82,4.66c2.9,3.12,5.71,6.32,8.54,9.51c1.51,1.71,3.07,3.39,4.43,5.22c1.55,2.08,2.95,4.28,4.86,6.07.41.39.8.84,1.08,1.33c1.74,3.07,3.52,6.12,5.15,9.25.8,1.53,1.64,3,2.79,4.3.41.46.76.96,1.14,1.45-1.54,3.07-2.26,6.24-2.03,9.57.23,3.27.76,6.49,1.78,9.63.39,1.2.99,2.25,1.78,3.2.8-3.76,3.11-6.72,5.9-9.39c1.57-1.5,3.22-2.92,4.86-4.36c1.71-1.5,2.73-3.34,3.4-5.42-1.35-1.98-3.22-3.38-5.19-4.68Z"
                fill="#2b231d"
              />
              <path
                d="M1174.63,604.08c.46-.04.93-.08,1.39-.14c1.95-.27,2.89-1.07,3.2-3.02.16-1.01.02-2.06.04-3.09.04-1.94-.91-3.34-2.35-4.51-.52-.42-1.09-.83-1.49-1.35-1.06-1.38-2.48-1.45-3.94-1.09-1.3.32-2.15,1.31-2.38,2.62-.43,2.46-.68,4.94-.23,7.43.39,2.17,1.98,3.42,4.2,3.32.52-.02,1.03-.1,1.55-.15Z"
                fill="#2b231d"
              />
              <path
                d="M1183.08,608.54c-2.08.19-2.63.3-3.37,1.03-.69.69-1.34,1.46-1.87,2.28-1.43,2.23-2,4.77-2.4,7.34-.41,2.67.77,4.6,2.99,6.01c1.05.67,2.04,1.43,3.05,2.15c1.19.85,3.46.93,4.52-.03c2.11-1.89,3.92-4,4.3-7c.32-2.5.36-4.97-.51-7.37-.92-2.53-2.9-5.04-6.72-4.42Z"
                fill="#2b231d"
              />
              <path
                d="M1361.45,486.58c-.14-1.59-.71-3.02-1.49-4.39-.88-1.53-1.67-3.12-2.66-4.57-2.1-3.09-4.1-6.29-6.5-9.12-2.72-3.2-5.74-6.17-8.81-9.03-4.15-3.86-8.48-7.52-12.74-11.26-3.33-2.92-6.88-5.55-10.85-7.56-4.03-2.05-7.98-4.24-12.08-6.15-3.19-1.49-6.52-2.71-9.83-3.9-2.58-.93-5.24-1.66-7.86-2.47-.84-.26-1.68-.55-2.54-.73-5.74-1.18-11.48-2.33-17.23-3.47-.76-.15-1.54-.21-2.32-.24-2.49-.09-4.95-.39-7.39-.96-1.41-.33-2.86-.48-4.3-.62-1.8-.18-3.62-.23-5.42-.39-2.06-.18-4.12-.47-6.18-.63-1.39-.11-2.8.01-4.19-.13-3.66-.37-7.33-.54-11.02-.52-3.06,0-6.11-.04-9.17-.12-2.54-.07-5.07-.25-7.61-.35-2.22-.08-4.45-.15-6.68-.16-2.69,0-5.39.04-8.08.09-1.66.03-3.32.17-4.98.12-3.42-.1-6.84-.19-10.26.21-1.39.16-2.8.1-4.19.17-1.91.09-3.85.05-5.73.36-2.52.41-5.01.7-7.57.75-1.96.04-3.92.39-5.86.71-1.89.31-3.72.99-5.67.89-2.52-.12-4.95.48-7.39.99-3.81.79-7.61,1.61-11.44,2.26-1.7.29-3.38.59-4.96,1.27-3.63,1.57-7.49,2.43-11.24,3.62-2.12.68-4.31,1.25-6.27,2.25-3.53,1.78-7.23,3.13-10.91,4.53-2.47.94-5.03,1.66-7.44,2.73-4.08,1.8-8.08,3.79-12.1,5.73-1.03.49-2.02,1.06-3.01,1.63-.59.34-1.14.75-1.07,1.57.42.7.95.77,1.55.27.37-.31.62-.8,1.19-.76.4,2.18.1,4.28-.07,6.4-.13,1.64,0,3.31.11,4.96.16,2.33.55,4.65.58,6.97.03,2.34.06,4.67.37,7c.28,2.11.56,4.25.57,6.37c0,2.49-.2,4.98.49,7.43.11.39.08.83.09,1.24.03,1.14.06,2.28.08,3.43c0,.4,0,.8-.01,1.35-.89-.3-1.65-.55-2.38-.79-.76,1.04-.74,1.45.21,1.85c1.15.48,2.33.92,3.53,1.2c4.59,1.08,9.2,2.1,13.67,3.63.92.32,1.94.37,2.88.64c1.54.43,3.08.88,4.59,1.4c2.45.84,4.88,1.74,7.31,2.62c1.61.58,3.24,1.1,4.81,1.77c4.38,1.88,8.73,3.85,13.11,5.73c1.71.74,3.54,1.22,5.22,2.02c3.42,1.63,6.75,3.44,10.16,5.08c1.96.94,4.01,1.69,6.01,2.55c1.24.53,2.48,1.05,3.68,1.65c1.53.77,3.01,1.63,4.52,2.44c1.97,1.05,3.94,2.09,5.9,3.15c1.28.69,2.52,1.44,3.82,2.1c1.75.9,3.54,1.73,5.31,2.59c1.49.73,2.95,1.54,4.48,2.15c2.46.97,4.98,1.79,7.46,2.69c3.02,1.1,6.14,1.97,8.77,3.94.41.31.91.5,1.35.77c3.79,2.25,7.59,4.5,11.37,6.77c2.05,1.23,4.02,2.58,6.1,3.75c2.77,1.55,5.71,1.67,8.71.69.34-.11.69-.22,1.03-.31c1.89-.49,3.41-1.45,4.32-3.24.13-.26.33-.48.53-.76c2.2,1.75,4.64,2.74,7.26,3.29c1.32.28,2.66.44,3.96.75c1.34.32,2.67.33,4.01.13c1.92-.27,3.68-1.04,5.4-1.89c2.54-1.26,4.22-3.32,5.23-5.94.52-1.35.99-2.73,1.49-4.1.25-.67.52-1.33.78-1.97c1.85.59,3.54,1.24,5.29,1.65c4.08.96,8.21,1.46,12.43,1.61c3.56.13,6.43-1.13,9.22-3.06c2.17-1.5,3.93-3.36,5.56-5.4.94-1.18,1.59-2.44,1.67-3.94.07-1.34.06-2.68.08-4.06c1.14.26,2.29.61,3.46.77c3.99.55,7.98,1.21,12,1.49c3.34.23,6.57-.35,9.45-2.42c3.27-2.35,5.96-5.12,7.86-8.69.79-1.48,1.5-2.95,1.53-4.67c0-.53.12-1.07.2-1.67.41.21.74.35,1.05.54c2.35,1.38,4.81,2.1,7.58,1.71c1.21-.17,2.48-.04,3.71.1c3.29.37,6.34-.19,9.32-1.7c4.14-2.11,7.54-5.07,10.74-8.38c2.93-3.03,4.11-6.76,4.88-10.73.13-.7.18-1.41.27-2.12l-.35-3.42c-.16-.58-.4-1.15-.46-1.74Z"
                fill="#2b231d"
              />
              <path
                d="M1269.27,458.53c.09.01.5.05.9.15c3.69,1.01,7.45,1.77,10.9,3.6c2.55,1.36,5.25,2.45,7.86,3.71.79.38,1.51.91,2.22,1.42c2.19,1.57,4.32,3.22,6.56,4.72c1.33.89,2.8,1.57,4.21,2.33c2.27,1.23,4,3.11,5.81,4.88.26.25.5.53.77.76c3.53,2.98,7.13,5.89,10.58,8.96c1.46,1.3,2.64,2.91,3.89,4.43.53.64.65,1.4.08,2.15-.67.89-1.58,1.07-2.4.31-.6-.56-1.11-1.24-1.58-1.91-1.7-2.44-4.08-4.09-6.4-5.84-1.4-1.06-2.66-2.29-3.98-3.46-.46-.41-.89-.87-1.34-1.29-1.63-1.51-3.23-3.07-4.92-4.52-.86-.74-1.82-1.39-2.83-1.9-3.39-1.72-6.59-3.71-9.49-6.18-1.75-1.49-3.89-2.35-5.98-3.28-1.13-.51-2.27-1.01-3.36-1.6-3.14-1.69-6.48-2.76-9.94-3.54-.85-.19-1.69-.51-2.49-.88-.72-.33-1.03-1.24-.8-2c.21-.69.72-.98,1.74-1.02Z"
                fill="#ffece5"
              />
              <path
                d="M1288.81,515.09c.11,1.21-.35,2.11-1.04,2.36-.72.27-1.7-.19-2.16-1.1-1.04-2.02-2.62-3.59-4.26-5.1-2.32-2.14-4.64-4.28-6.93-6.46-2.59-2.46-5.07-5.04-7.72-7.43-2.63-2.37-5.77-4.03-8.73-5.93-1.04-.67-2.06-1.41-2.98-2.24-2.48-2.24-5.38-3.62-8.56-4.56-1.63-.48-3.21-1.2-4.76-1.91-1.11-.51-1.47-1.48-1.06-2.4.45-1,1.28-1.34,2.47-.91.88.32,1.7.77,2.58,1.1c2.08.8,4.2,1.51,6.26,2.36.94.39,1.91.86,2.68,1.51c2.94,2.49,6.17,4.54,9.41,6.6c3.42,2.16,6.56,4.71,9.27,7.78c1.5,1.7,3.24,3.2,4.88,4.78c1.82,1.76,3.65,3.52,5.49,5.27.94.89,1.94,1.72,2.82,2.67.7.75,1.3,1.62,1.87,2.48.28.42.4.94.48,1.14Z"
                fill="#ffece5"
              />
              <path
                d="M1295.97,444.47c1.8.32,3.87.49,5.78,1.38c1.83.85,3.64,1.75,5.49,2.57c1.18.52,2.42.93,3.64,1.37c2.61.93,4.93,2.4,7.3,3.79c1.16.68,2.28,1.45,3.47,2.07c3.23,1.68,6.3,3.61,9.19,5.8c1.56,1.18,2.89,2.67,4.34,4c1.07.98,2.17,1.93,3.24,2.91c1.91,1.75,3.85,3.47,5.71,5.27.55.53.94,1.25,1.3,1.93.41.78.11,1.68-.62,2.19-.76.54-1.36.52-2.08-.22-1.01-1.04-1.92-2.18-2.93-3.22-.83-.85-1.7-1.68-2.63-2.41-2.61-2.06-4.97-4.39-7.32-6.74-1.27-1.27-2.82-2.3-4.36-3.24-4.11-2.52-8.26-4.98-12.45-7.35-1.52-.86-3.23-1.4-4.85-2.09-2.15-.91-4.33-1.74-6.43-2.75-1.71-.82-3.43-1.43-5.33-1.56-.36-.02-.72-.09-1.07-.18-.99-.25-1.76-1.16-1.69-1.95.08-.83.95-1.5,2.28-1.57Z"
                fill="#ffece5"
              />
              <path
                d="M1213.14,496.3c1.79-.17,3.38.54,4.9,1.31c3.1,1.58,6.17,3.19,9.37,4.57c2.31,1,4.05,2.88,5.92,4.51.27.24.48.55.75.78c3.09,2.62,6.2,5.21,9.26,7.86c1.92,1.66,3.74,3.42,5.26,5.49c1.17,1.59,2.48,3.06,3.65,4.65.41.55.61,1.28.8,1.96.17.6-.06,1.24-.66,1.43-.55.17-1.24.19-1.77,0-.43-.15-.76-.67-1.08-1.07-2-2.52-3.98-5.05-5.97-7.57-.19-.24-.41-.47-.64-.67-2.56-2.19-5.15-4.35-7.69-6.58-1.87-1.64-3.69-3.33-5.5-5.03-1.66-1.56-3.61-2.58-5.66-3.5-1.94-.86-3.87-1.75-5.72-2.78-1.74-.97-3.52-1.74-5.5-2.04-.75-.11-1.42-.33-1.63-1.21-.31-1.3.27-1.95,1.92-2.1Z"
                fill="#ffece5"
              />
              <path
                d="M1193.21,513.79c.78-.83,1.64-1.04,2.6-.61c3.02,1.37,6.15,2.57,8.62,4.9c1.88,1.78,3.69,3.64,5.54,5.45c1.07,1.05,2.17,2.07,3.25,3.12c1.96,1.92,4.18,3.57,5.88,5.76.57.73,1.3,1.34,1.92,2.03.35.38.68.79.94,1.23.54.91.42,1.56-.36,2.19-.69.57-1.77.54-2.4-.13-.99-1.06-1.98-2.13-2.9-3.25-1.39-1.7-3.01-3.13-4.64-4.59-1.96-1.76-3.77-3.7-5.65-5.56-2.1-2.08-4.19-4.19-6.79-5.66-.99-.56-2.05-1-3.07-1.5-.56-.27-1.13-.52-1.69-.8-1.06-.52-1.58-1.31-1.26-2.61Z"
                fill="#ffece5"
              />
              <path
                d="M1162.86,525.45c.59-.91,1.08-1.89,1.6-2.85c1.21-2.24,1.83-4.61,1.68-7.18-.1-1.69.22-3.25,1.5-4.57c1.86-1.91,3.85-3.63,6.17-4.96.49-.28,1.01-.56,1.41-.95c2.69-2.68,4.44-5.85,4.86-9.68.22-2.01.29-4.09,1.64-5.75.95-1.16,1.94-2.31,3.03-3.33c2.36-2.21,5.04-4.01,7.83-5.61c1.24-.71,2.65-1.28,4.05-1.55c2.65-.52,5.26-1.13,7.83-1.93c2.67-.82,5.31-1.62,8.21-1.42c1.79.12,3.65-.19,5.41-.58c2.12-.47,4.16-1.26,6.24-1.89c2.06-.62,3.79-1.67,4.96-3.53.47-.75.93-1.5,1.34-2.28c1.42-2.72,3.6-4.75,6.2-6.18c2.82-1.54,5.64-3.05,8.26-4.95c2.84-2.05,5.5-4.26,7.63-7.05c1.32-1.73,2.48-3.58,3.82-5.3c1.38-1.75,2.89-3.4,4.35-5.09c2.74-3.19,6.13-5.4,10.11-6.74c1.38-.46,2.75-.93,4.1-1.46c3.04-1.21,6.1-2.36,9.43-2.45c1.27-.04,2.55-.03,3.82-.13-.75-.24-1.5-.49-2.26-.64-5.74-1.18-11.48-2.33-17.23-3.47-.76-.15-1.54-.21-2.32-.24-2.49-.09-4.95-.39-7.39-.96-.64-.15-1.3-.26-1.95-.35-.3.16-.59.34-.88.55-.63.45-1.25.93-1.85,1.42-.91.75-1.95,1.12-3.12,1.28-2.2.31-4.34-.15-6.51-.32-2.82-.21-5.63-.03-8.27.99-1.92.75-3.8,1.71-5.54,2.82-1.88,1.19-3.57,2.68-5.35,4.02-2.45,1.84-4.93,3.63-7.35,5.51-1.14.89-2.17,1.92-3.26,2.89-1.08.97-2.4,1.43-3.79,1.68-1.94.34-3.88.66-5.83.91-3.34.43-6.7.87-10.07.41-2.03-.28-3.92.16-5.79.81-4.25,1.5-7.82,4.1-10.78,7.44-3.76,4.24-7.08,8.82-9.7,13.89-.86,1.66-1.71,3.34-2.79,4.86-1.96,2.76-4.29,5.2-6.96,7.31-4.33,3.42-8.33,7.19-11.58,11.7-.4.55-.86,1.05-1.27,1.59-.31.41-.6.84-.87,1.29-1.18,1.96-2.37,3.9-3.5,5.89-1.32,2.31-2.6,4.71-2.49,7.45.1,2.48.51,4.95.88,7.41.21,1.41.76,2.76,1.9,3.67.79.63,1.6,1.23,2.41,1.84c1.85.86,3.76,1.58,5.63,2.39c1.24.53,2.48,1.05,3.68,1.65c1.53.77,3.01,1.63,4.52,2.44.77.41,1.54.82,2.31,1.23.89-.43,1.41-1.18,1.89-1.93Z"
                fill="#ffc7b5"
              />
              <path
                d="M1120.28,439.56c2.84-.03,5.69-.18,8.53-.04c2.99.15,5.97.55,8.95.91c3.49.42,6.53,1.93,9.37,3.93.85.59,1.78,1.05,2.67,1.59.57.35,1.16.69,1.68,1.11.8.65.94,1.24.54,2.21-1.36,3.27-3.41,5.91-6.73,7.4-1.28.57-2.53,1.22-3.79,1.81-3.53,1.66-7.12,1.5-10.78.43-2.58-.76-5.19-.81-7.82-.08-.99.27-2.05.26-3.09.35-1.44.13-2.88.23-4.32.33-1.81.12-3.61.27-5.42.33-1.75.06-3.51-.04-5.27.04-2.74.12-5.48.37-8.22.48-2.79.11-5.48-.28-7.86-1.93-.55-.38-1.22-.57-1.82-.88-.98-.51-1.25-1.2-.75-2.18.3-.59.69-1.18,1.19-1.6c2.29-1.89,4.74-3.52,7.41-4.84c1.9-.94,3.74-2.03,5.56-3.13c1.81-1.1,3.78-1.64,5.8-2.13c1.75-.42,3.48-1.01,5.16-1.68c2.91-1.14,5.79-2.33,8.99-2.43Z"
                fill="#81c6b2"
              />
              <path
                d="M1183.2,435.35c-1.21.26-2.42.58-3.64.74-1.07.14-2.17.19-3.24.11-2.53-.18-5.07-.33-7.57-.73-1.46-.23-2.89-.81-4.24-1.43-1.58-.72-1.8-1.96-.65-3.25c1.02-1.15,2.35-1.86,3.85-2.22c2.16-.52,4.3-1.17,6.49-1.5c2.03-.31,3.98-1.03,6.13-.85c1.33.11,2.72-.51,4.09-.79c1.62-.33,3.23-.78,4.87-.91c1.32-.11,2.68.18,4.02.29.41.03.83.09,1.24.05c4-.35,7.85.39,11.64,1.55.88.27,1.7.77,2.49,1.26.78.49,1.03,1.31.89,2.19-.47,2.85-2.07,4.29-5,4.67-2.41.31-4.81.77-7.23,1.02-1.43.15-2.89.09-4.33,0-3.25-.22-6.5-.48-9.79-.2Z"
                fill="#ff7159"
              />
              <path
                d="M1173.16,449.7c-4.31.57-8.05-.82-11.44-3.39-.99-.75-2.01-1.45-3.02-2.18-.25-.18-.49-.38-.72-.59-.69-.63-.91-1.3-.61-1.91.35-.72,1.01-.87,1.71-.81c1.7.14,3.4.34,5.1.48c3.91.31,7.4,1.89,10.81,3.66.63.33,1.19.84,1.68,1.37.79.86.74,1.67-.15,2.43-.41.35-.97.6-1.5.74-.59.16-1.23.15-1.85.21Z"
                fill="#ff7159"
              />
            </g>
            <g id="e0gYpSRcAlv2408" transform="translate(.000004 0)">
              <path
                d="M1053.26,487.99c-.67-.41-1.26-.12-1.91.17-.84.38-1.73.76-2.63.9-3.8.58-7.51,1.53-11.1,2.91-3.44,1.33-6.81,2.82-10.24,4.16-3.57,1.39-7.17,2.74-10.79,4.01-2.05.72-4.17,1.23-6.25,1.88-3.71,1.16-7.4,2.39-11.12,3.51-3.37,1.01-6.77,1.93-10.16,2.87-2.44.68-4.89,1.33-7.33,2.03-3.03.87-6.11,1.64-9.07,2.71-3.32,1.19-6.54,2.64-9.78,4.04-2.43,1.04-4.85,2.11-7.21,3.29-2.42,1.2-4.74,2.58-7.15,3.8-1.9.97-3.95,1.66-5.76,2.75-4.13,2.49-8.19,5.11-12.22,7.76-2.38,1.56-4.22,3.71-5.62,6.18-1.77,3.11-3.4,6.3-5.11,9.45-1.86,3.42-3.84,6.77-6.06,9.98-1.98,2.86-2.97,6.03-2.75,9.55.02.29-.12.59-.19.88l.83,8.08c.9,1.5,1.63,3.15,2.74,4.47c1.58,1.87,2.95,3.87,4.35,5.88c1.83,2.62,2.41,5.58,2.25,8.6-.14,2.62-.02,5.19.29,7.76.12.97.42,1.91.71,2.85.54,1.77,1.47,3.31,2.72,4.68.73.8,1.41,1.67,2,2.59c1.48,2.33,3.37,4.12,5.79,5.51c2.57,1.49,4.49,3.68,5.19,6.72.72,3.08,1.45,6.15,2.19,9.22.58,2.4,1.35,4.72,3.25,6.43c1.77,1.6,3.42,3.43,5.91,3.88c1.63.29,3.29.42,4.94.53c1.68.12,3.27.49,4.75,1.31c4.25,2.35,6.8,6.13,8.85,10.37c1.4,2.89,2.85,5.77,4.43,8.56.79,1.39,1.96,2.55,2.9,3.85c1.75,2.41,4.16,3.92,6.93,4.76c4.61,1.4,9.02.72,13.16-1.73c1.25-.74,2.43-1.64,3.75-2.23c1.76-.78,3.58-.92,5.34.24c2.06,1.36,4.37,2.24,6.8,2.55c1.93.24,3.92.13,5.88.05c1.29-.06,2.6-.22,3.84-.56c2.21-.62,3.83-2.23,5.54-3.65c3-2.48,5.93-5.04,9.43-6.86c1.25-.65,2.53-.89,3.89-.96c1.91-.09,3.82-.2,5.74-.27c1.18-.05,2.22-.48,3.2-1.1c1.94-1.24,3.7-2.69,5.1-4.52c2.14-2.81,4.28-5.62,6.3-8.51.67-.95,1.11-2.12,1.42-3.26.71-2.61,1.17-5.26,1.14-7.99-.03-3.13-.15-6.22-1.18-9.22-1.13-3.29-2.32-6.55-2.5-10.09-.07-1.32,0-2.58.31-3.85.86-3.48,1.71-6.95,2.54-10.44c1.08-4.51.51-8.86-1.23-13.11-.33-.81-.58-1.66-.88-2.49-.57-1.61-.99-3.3-1.75-4.81-1.45-2.87-3.09-5.65-4.66-8.46-1.72-3.06-3.02-6.23-3.22-9.82-.12-2.11-.61-4.21-.95-6.31-.04-.25-.17-.49-.23-.74-.52-2.22-1.17-4.4-.87-6.75.24-1.85.37-3.72.39-5.58.03-2.59-.19-5.18-.11-7.77.06-2.17.25-4.35.63-6.48.49-2.7,1.23-5.36,1.87-8.04.86-3.6,1.09-7.28,1.41-10.95.35-3.92.51-7.86.83-11.79.32-3.82.74-7.64,1.11-11.45.07-.74.09-1.48-.66-1.94Z"
                fill="#81c6b2"
              />
              <path
                d="M1020.01,612.55c1.56.91,3.25,1.34,5.05,1.14.65-.07,1.34-.28,1.88-.63c1.92-1.22,3.27-2.88,3.53-5.22.08-.75.2-1.61-.07-2.27-.39-.99-.93-2.09-1.73-2.71-1.41-1.07-2.29-2.47-3.21-3.89-.11-.17-.21-.39-.37-.49-.3-.17-.66-.39-.98-.37-1.06.05-2.1.35-2.74,1.23-1.54,2.09-2.98,4.25-3.66,6.81-.19.73-.21,1.51-.31,2.27.38,1.75,1.04,3.23,2.6,4.14Z"
                fill="#2b231d"
              />
              <path
                d="M953.12,585.31c.49.54.89,1.16,1.41,1.66.89.87,1.93,1.3,3.25,1.06c2.02-.37,3.57-1.38,4.54-3.18.63-1.18,1.1-2.46,1.65-3.69.69-1.55.63-3.13.21-4.73-.26-1-.6-1.97-.87-2.97-.71-2.63-1.8-3.43-4.46-3.27-.6.14-1.27.15-1.79.44-1.32.72-2.59,1.51-3.83,2.36-.45.31-.85.81-1.08,1.31-.6,1.37-1.2,2.77-1.59,4.21-.26.97-.19,2.04-.24,3.07-.03.73.35,1.25.89,1.73.68.62,1.29,1.31,1.91,2Z"
                fill="#2b231d"
              />
              <path
                d="M978.97,636.26c.76-1.85.69-4.05.99-6.07-.4-1.01-.72-1.93-1.13-2.81-.31-.65-.78-1.23-1.09-1.88-.54-1.14-1.4-1.94-2.5-2.46-1.12-.52-2.27-1.03-3.46-1.36-.87-.24-1.92-.49-2.72-.22-1.96.66-3.82,1.64-5.07,3.42-1.63,2.32-2.59,4.95-3.46,7.61-.31.93-.53,1.9-.66,2.87-.17,1.34.27,2.51,1.53,3.13.86.42,1.39,1.06,1.73,1.89c1.29,3.09,4.27,3.83,6.77,3.48c4.59-.65,7.42-3.59,9.07-7.61Z"
                fill="#2b231d"
              />
              <path
                d="M969.98,608.2c.48,1.76,1.2,3.4,3.09,4.01c1.16.38,2.41.48,3.62.71c2.03-.37,3.58-1.32,4.73-2.92c1.65-2.32,2.76-4.81,2.75-7.77c0-1.65-.23-3.23-.87-4.69-.86-1.95-2.13-3.5-4.57-3.69-2.06-.16-3.67.59-5.01,1.99-2.08,2.17-3.54,4.75-4.52,7.57-.2.58-.08,1.31.04,1.95.18.96.48,1.9.74,2.85Z"
                fill="#2b231d"
              />
              <path
                d="M937.54,613.39c1.03,2.53,2.36,3.53,5.07,3.5c1.08-.01,2.15-.32,3.24-.35c3.11-.09,5.26-2.81,5.49-5.24.15-1.53.64-2.94,1.28-4.3.57-1.21.89-2.44.51-3.82.19-1.39-.67-2.52-1.1-3.79-.28-.83-.79-1.48-1.54-1.89-1.62-.9-3.18-1.91-5.01-2.43-3.21-.9-6.65.39-8.32,3.26-.18.31-.37.66-.39,1-.06,1.56-.69,2.93-1.33,4.29-.67,1.44-.88,2.96-.95,4.53-.08,1.74.67,2.97,2,3.97.43.32.86.78,1.06,1.26Z"
                fill="#2b231d"
              />
              <path
                d="M928.14,577.09c1.34,1.02,2.83,1.72,4.74,1.57.3-.09.81-.12,1.18-.37c2.55-1.77,5.12-3.48,6.3-6.63.77-2.07.43-3.51-1.04-5.08-1.11-1.18-2.53-1.47-4.02-1.8-1.52-.34-2.84-.04-3.88.98-1.13,1.12-2.19,2.36-3.07,3.69-1.32,1.96-1.39,4.2-.87,6.45.1.43.33.93.66,1.19Z"
                fill="#2b231d"
              />
              <path
                d="M947.49,559.05c.87.59,1.83.77,2.93.26c2.29-1.05,3.4-2.92,3.05-5.47-.04-.26-.05-.52-.08-.77-.07-.57.01-1.16-.11-1.7-.13-.57-.29-1.35-.71-1.61-1.53-.97-3.2-1.57-4.97-.56-1.74.99-2.96,2.4-3.39,4.42-.27,1.24-.14,2.39.81,3.31.78.75,1.56,1.53,2.45,2.13Z"
                fill="#2b231d"
              />
              <path
                d="M1046.74,601.83c-1.69-1.14-3.5-.75-4.41,1.07-.6,1.2-.77,2.46-.7,3.89.07.3.17.7.27,1.1.45,1.89,2.85,2.31,4.19,1.62c2.99-1.56,3.51-5.75.66-7.68Z"
                fill="#2b231d"
              />
              <path
                d="M995.7,616.53c1.38.67,2.87,1.15,4.33,1.64c1.38.46,2.55-.06,3.52-1.04c2.29-2.28,3.44-5.01,3.16-8.27-.04-.5-.21-1.03-.47-1.45-.49-.79-1.04-1.55-1.64-2.25-.89-1.05-1.97-1.67-3.43-1.2-.38.12-.81.1-1.28.14-.67.65-1.49,1.24-2.04,2.02-.79,1.13-1.43,2.38-2.06,3.62-.49.97-.94,1.97-1.29,2.99-.55,1.65-.13,3.15,1.19,3.8Z"
                fill="#2b231d"
              />
              <path
                d="M1055.57,619.68c-.39-1.08-1.27-1.3-2.22-1.35-.56-.03-1.13.1-1.7.16-1.35,1.38-2.06,2.94-2.63,4.56-.66,1.86-.66,3.66.69,5.28.3.36.52.77.79,1.15c1.72,2.4,3.59,2.47,5.37.15.43-.56.74-1.25.95-1.93.25-.84.32-1.72.48-2.59.26-1.39.11-2.66-.82-3.81-.39-.47-.7-1.04-.91-1.62Z"
                fill="#2b231d"
              />
              <path
                d="M1054.58,641.87c-1.3-1.27-2.85-2.27-4.59-2.84-.9-.29-1.41-.85-1.65-1.7-.7-2.5-1.73-4.87-2.7-7.27-.83-2.06-1.39-4.23-2.12-6.33-.98-2.78-2.14-5.51-3-8.33-.89-2.9-2.01-5.64-3.62-8.21-.68-1.08-1.17-2.31-1.56-3.53-.59-1.87-1.03-3.8-1.51-5.7-.4-1.61-.99-3.21-1.09-4.83-.19-3.28-1.16-6.45-1.1-9.75c0-.2-.08-.41-.13-.61-.58-2.32-1.06-4.65-1.24-7.05-.08-1.03-.38-2.03-.53-3.06-.13-.87-.23-1.75-.28-2.64-.07-1.24-.07-2.49-.1-3.73-.02-.73-.05-1.45-.04-2.18.05-2.85.31-5.71.11-8.53-.2-2.92.07-5.8.16-8.7.05-1.49.42-2.93,2.05-3.72.81-.39,1.44-1.18,2.11-1.83c1.43-1.39,2.83-2.8,4.25-4.2.13,4.62.26,9.13.39,13.64.07,2.6.13,5.19.21,7.79.04,1.45-.02,2.92.18,4.36.34,2.47.71,4.95,1.33,7.35c1,3.86,2.22,7.67,3.34,11.5.73,2.53,2.23,4.68,3.43,6.96.42.81,1.05,1.49,1.32,2.41.74,2.47,2.18,4.45,4.36,5.88.51.34.96.77,1.43,1.16.22,2.99.67,5.86,1.13,8.72.32,2,1.24,3.7,2.48,5.29.49.63,1.11,1.03,1.78,1.27.74-2.99,1.47-5.98,2.19-8.97.46-1.92.61-3.82.5-5.68-.74-.53-1.49-1.06-2.24-1.57s-1.58-.83-2.49-.65c-.78.16-1.38-.14-2.04-.51-2.71-1.53-4.49-3.77-5.42-6.73-.73-2.34-1.8-4.52-3.08-6.6s-2.4-4.28-2.93-6.66c-.83-3.75-1.43-7.55-2.13-11.32-.15-.81-.33-1.62-.49-2.44-.3-1.58-.63-3.15-.86-4.74-.46-3.2-.61-6.41-.43-9.64.16-2.89.26-5.79.37-8.68.06-1.4.17-2.8.12-4.19-.03-.85.19-1.52.69-2.15.97-1.22,1.89-2.48,2.89-3.68c2.17-2.61,3.56-5.59,4.39-8.86.2-.8.42-1.62.79-2.35c1.1-2.14,2.03-4.34,2.87-6.58.15-2.05.3-4.1.44-6.14-.51,1.12-1,2.25-1.44,3.39-.44,1.16-.72,2.38-1.2,3.53-.83,2.01-1.68,4.03-2.66,5.98-1.9,3.8-3.02,7.99-5.73,11.37-.78.96-1.63,1.86-2.47,2.77-.6.64-1.36,1.16-1.84,1.88-1.68,2.53-4.12,4.26-6.46,6.03-2.42,1.83-5.08,3.37-7.73,4.87-2.64,1.49-5.12,3.29-8.23,3.85-2.82.5-5.63,1.04-8.46.51-2.05-.38-4.03-1.05-4.95-3.28-.19-.46-.65-.81-.94-1.23-.44-.64-.89-1.28-1.25-1.96-1.55-2.89-1.79-6.01-1.6-9.21.16-2.8.57-5.56,1.27-8.28.78-3.01.96-6.17,2.23-9.04.84-1.89,1.69-3.82,2.86-5.51c1.08-1.56,2.55-2.86,3.93-4.19c1.6-1.55,3.28-3.01,4.95-4.49.36-.32.56-.62.39-1.07-.95.27-1.9.53-2.83.83-.46.37-.7.66-.97.96-.28.3-.61.57-.97.76-2.52,1.4-4.48,3.34-5.81,5.91-.21.41-.48.81-.76,1.18-1.29,1.7-2.42,3.49-2.87,5.62-3.23.45-6.3,1.11-9.09,2.74-.22.13-.48.19-.73.26-2.52.77-5.04,1.56-7.58,2.3-2.91.84-5.72,1.85-8.17,3.71-.49.37-1.09.58-1.64.88-1.82.99-3.77,1.78-5.27,3.27-1.58,1.57-3.45,2.62-5.5,3.44-1.29.52-2.57,1.15-3.7,1.95-1.5,1.05-3.03,1.99-4.76,2.61-2.02.73-3.87,1.74-5.53,3.11-.64.52-1.35.99-2.11,1.32-3.54,1.52-6.74,3.65-10.1,5.5-1.31.72-2.56,1.56-3.81,2.38-.56.37-1.05.85-1.59,1.26-.6.46-1.22.63-2.03.46-2.34-.47-4.63-.05-6.92.49-.79.19-1.47.53-2.12.94-1.42,2.49-2.93,4.93-4.56,7.3-1.98,2.86-2.97,6.03-2.75,9.55.02.29-.12.59-.19.88l.2,1.91c.12.31.26.63.43.93.75,1.31,1.53,1.9,3,1.47c1.27-.38,2.67-.81,3.63-1.65c2.17-1.92,4.12-4.1,6.13-6.19.28-.29.44-.7.65-1.06.8-1.34,1.56-2.69,2.39-4.01c1.1-1.75,1.71-3.66,1.93-5.69.1-.87.11-1.75.16-2.58c1.2-.89,2.29-1.79,3.47-2.53c1.4-.87,2.91-1.58,4.35-2.4c1.62-.92,3.18-1.93,4.81-2.83c1.76-.98,3.58-1.86,5.35-2.81.55-.29,1.04-.68,1.57-1.01.74-.47,1.46-.98,2.24-1.38c2.11-1.1,4.34-2.01,6.34-3.27c4.56-2.86,8.99-5.95,13.54-8.83c2.39-1.51,4.75-3.15,7.5-4.01c1.72-.54,3.43-1.13,5.15-1.69c4.17-1.36,8.34-2.74,12.52-4.07.69-.22,1.47-.17,2.33-.26-1.03,4.98-2.01,9.75-2.95,14.33-1.92,1.18-3.63,2.25-5.37,3.28-1.2.71-2.39,1.48-3.68,1.99-3.72,1.48-7.21,3.41-10.75,5.26-.78.41-1.48.96-2.2,1.47-1.44,1.01-2.88,2.03-4.31,3.06-1.22.88-2.59,1.62-3.61,2.69-3.39,3.59-7.35,6.6-10.44,10.49-1.68,2.11-3.62,4.01-5.35,6.09-3.06,3.68-6.01,7.44-9.06,11.13-1.19,1.44-2.52,2.77-3.75,4.18-.93,1.05-1.86,2.1-2.71,3.21-2.09,2.72-4.14,5.47-6.11,8.08-.83.39-1.52.74-2.23,1.04-.62.26-1.25.55-1.9.65-1.45.22-2.44.97-3.12,2.12-.14,2.59-.01,5.13.3,7.68.12.97.42,1.91.71,2.85.54,1.77,1.47,3.31,2.72,4.68.73.8,1.41,1.67,2,2.59c1.23,1.94,2.77,3.49,4.65,4.76.69-.51,1.2-1.35,1.33-2.46.11-.92.1-1.87.02-2.8-.16-1.87-.35-3.73-.63-5.59-.31-2.05-.63-4.11-1.16-6.11-.58-2.19-1.42-4.31-2.14-6.43.61-.85,1.24-1.62,1.75-2.45.82-1.33,1.7-2.6,2.85-3.68.71-.66,1.2-1.56,1.79-2.34.63-.83,1.23-1.67,1.9-2.47.8-.95,1.65-1.86,2.49-2.79.55-.62,1.12-1.23,1.66-1.86.77-.91,1.53-1.83,2.29-2.75.53-.64,1.04-1.29,1.58-1.92c1.99-2.33,3.98-4.65,5.97-6.97c2.32-2.99,4.39-5.58,6.46-8.18c2.21-2.4,4.15-4.84,6.6-6.8c1.29-1.04,2.6-2.07,3.81-3.19c2.8-2.58,5.83-4.76,9.32-6.38c3.09-1.43,5.94-3.35,9.03-4.83c2.97-1.43,5.81-3.13,8.68-4.7.19,1.86.2,3.64.6,5.33s1.19,3.29,1.87,5.08c-.59.28-1.23.59-1.88.88-1.9.84-3.76,1.74-5.24,3.29-1.26,1.31-2.56,2.58-3.91,3.81-1.72,1.57-3.03,3.38-3.85,5.59-.43,1.16-1.12,2.22-1.7,3.32-1.69,3.21-3.44,6.4-5.08,9.64-1.68,3.34-3.19,6.77-5.41,9.82-.66.91-1.08,2-1.61,3.02-.89,1.7-1.66,3.48-2.67,5.1-1.72,2.74-3.21,5.56-4.37,8.6-1.23,3.21-2.78,6.26-4.79,9.08-.86,1.2-1.49,2.62-1.98,4.03-.74,2.13-1.7,4.12-2.91,6.02-.92,1.44-1.71,2.97-2.54,4.47-.45.81-.86,1.63-1.27,2.42-3.23-1.03-8.46.75-10.14,3.85.61,2.85,1.22,5.46,1.86,8.07.58,2.4,1.35,4.72,3.25,6.43c1.77,1.6,3.42,3.43,5.91,3.88c1.63.29,3.29.42,4.94.53.81.06,1.6.18,2.37.38-.27-2.15-.49-4.32-.77-6.47-.2-1.5-.64-2.92-1.36-4.27-.94-1.78-1.89-3.57-2.37-5.57-.36-1.53-1-2.94-1.98-4.19-.21-.27-.34-.62-.49-.9c1.1-2.1,2.14-4.13,3.21-6.15c1.5-2.84,3.04-5.67,4.52-8.52c1.29-2.49,2.52-5,3.79-7.5.35-.69.78-1.35,1.18-2.01.69-1.16,1.48-2.27,2.05-3.48c1.62-3.43,3.15-6.9,4.72-10.35.17-.38.4-.73.6-1.09.83-1.49,1.68-2.98,2.48-4.49.47-.87.84-1.79,1.31-2.65c1.75-3.24,3.61-6.43,5.26-9.72c1.21-2.41,2.49-4.79,3.7-7.19c1.25-2.48,2.56-4.81,4.48-6.85c1.14-1.21,2.16-2.52,3.46-3.56.4-.32.81-.67,1.12-1.08c1.94-2.54,4.87-3.37,7.54-4.54.82.67,1.53,1.26,2.33,1.92-.74,1.78-1.36,3.67-2.28,5.39-1.22,2.27-1.95,4.69-2.63,7.13-.6,2.14-1.06,4.32-1.58,6.49-.6,2.56-1.19,5.13-1.79,7.7-.24,1.43-.4,2.39-.58,3.35-.14.76-.36,1.51-.45,2.28-.25,2.16-.41,4.33-.69,6.48-.18,1.38-.57,2.73-.78,4.11-.33,2.25-.5,4.52-.91,6.75-.32,1.78-.62,3.56-.72,5.37-.07,1.39-.34,2.77-.46,4.17-.08.93,0,1.87-.12,2.79-.33,2.51-.06,5.09-.76,7.57.02,3.09-.91,5.87-1.37,8.72-.38,2.34-.93,4.66-1.4,6.98-.19,1.33-.36,2.35-.57,3.36-.13.61-.45,1.2-.46,1.81-.04,2.44-.85,4.78-.8,7.24.04,1.79-.36,3.59-.57,5.42-3.32.9-6.15,1.88-8.85,3.23-1.47.74-2.66,1.8-3.64,3.11-.61.82-.93,1.84-1.02,2.85c1.05,2.1,2.12,4.19,3.28,6.23.79,1.39,1.96,2.55,2.9,3.85.43.59.91,1.13,1.41,1.62.36.31.73.61,1.09.92c1.31,1,2.81,1.72,4.43,2.22c4.61,1.4,9.02.72,13.16-1.73.58-.34,1.15-.72,1.72-1.09.15-.96-.11-2.03-.85-3.08-.33-.47-.65-.94-.96-1.42-1.85-2.88-3.51-5.87-5.69-8.54-1.21-1.47-2.17-3.17-3.11-4.83-.79-1.39-1.42-2.88-1.3-4.56.18-2.38.34-4.75.47-7.13.12-2.23.26-4.48,1.03-6.59c1.42-3.89,1.85-7.97,2.37-12.03.72-5.6,1.33-11.22,2.06-16.82.4-3.03,1.04-6.03,1.41-9.06.31-2.46.31-4.97.6-7.43.48-4.12,1.05-8.23,1.65-12.33.52-3.54,1.11-7.05,2.36-10.45c1.55-4.24,2.94-8.53,3.99-12.94.51-2.16,1.29-4.26,1.94-6.35c1.25.21,2.37.39,3.48.58c1.17.2,2.34.4,3.5.6-.09,2.54-.15,4.97-.26,7.41-.09,2.02-.27,4.04-.35,6.06-.13,3.27-.22,6.53-.31,9.8-.08,3.11-.25,6.23-.16,9.34.15,4.68.44,9.35.78,14.01.24,3.37.61,6.74,1.02,10.1.55,4.54,1.23,9.07,1.78,13.61.25,2.11.4,4.25.47,6.38.09,2.8-.11,5.62.11,8.41.38,4.98.97,9.95,1.5,14.92.09.86.31,1.7.42,2.27-.92,1-1.67,1.79-2.39,2.59-.45.5-.83,1.07-1.29,1.56-1.35,1.45-2.51,3.04-3.39,4.84-.89,1.83-1.91,3.56-3.17,5.18-.56.72-1.08,1.62-1.21,2.49-.11.77-.13,1.45-.07,2.06.31.13.62.28.93.48c2.06,1.36,4.37,2.24,6.8,2.55c1.93.24,3.92.13,5.88.05c1.29-.06,2.6-.22,3.84-.56c2.21-.62,3.83-2.23,5.54-3.65.61-.51,1.23-1.02,1.84-1.53.03-.44.02-.91-.08-1.41-.22-1.17-.37-2.37-.72-3.5-1.52-4.92-4.2-8.89-9.32-10.95-.31-1.21-.64-2.51-.98-3.8-.14-.55-.46-1.11-.41-1.64.21-2.37-.26-4.63-.66-6.94-.41-2.39-.35-4.85-.77-7.26-.19-1.11,0-2.29-.14-3.41-.46-3.55-.28-7.16-1.04-10.68-.09-.4-.09-.83-.09-1.24-.02-4.17-.38-8.3-1.33-12.37-.29-1.26-.68-2.5-.46-3.83.06-.39-.09-.82-.16-1.23-.15-.87-.41-1.73-.45-2.6-.12-2.74-.32-5.5-.18-8.23.1-1.88.12-3.72-.05-5.58-.19-2.02-.25-4.04-.34-6.07-.1-2.33-.42-4.68-.21-6.98.3-3.24.73-6.47.82-9.73.02-.77.06-1.55.17-2.32.41-2.96.85-5.93,1.3-9.04.56-.06,1.12-.09,1.67-.18.77-.12,1.55-.2,2.29-.43c3.04-.93,5.9-2.24,8.62-3.89.59-.36,1.19-.69,1.96-1.13-.37,4.05-.68,7.8-.44,11.6.26,4.2.21,8.41.48,12.61.25,3.89.68,7.78,1.14,11.66.4,3.36.81,6.72,1.46,10.03.71,3.61,1.68,7.17,2.58,10.74.84,3.33,1.97,6.53,3.78,9.5c1.97,3.24,3.33,6.77,4.26,10.48.92,3.67,1.95,7.31,3.52,10.78.66,1.46,1.18,2.99,1.72,4.5.33.93.41,1.88.17,2.89-.84,3.56-2,6.98-3.77,10.19-.5.9-.97,1.86-1.22,2.85-.37,1.5-.72,3.06-.74,4.59-.03,1.99.04,3.97,1.05,5.63c1.25-.06,2.5-.13,3.76-.18c1.18-.05,2.22-.48,3.2-1.1c1.94-1.24,3.7-2.69,5.1-4.52c1.55-2.04,3.09-4.09,4.6-6.16-.18-1.57-.39-3.15-.81-4.66-.52-1.89-1.32-3.75-2.76-5.16Z"
                fill="#2b231d"
              />
              <path
                d="M1039.84,637.4c-.3-1.04-.65-2.08-1.1-3.07-.68-1.5-1.42-2.99-2.22-4.43-.6-1.08-1.71-1.68-2.83-1.68-1.65,0-3.33.2-4.93.6-.9.22-1.85.84-2.44,1.56-1.99,2.38-3.28,5.18-3.96,8.2-.57,2.53.26,4.95,1.11,7.3.43,1.18.89,2.32.93,3.59.04.99.56,1.65,1.44,2.05c1.28.57,2.53,1.23,3.85,1.67c2.03.68,4,.44,5.74-.91c3.88-3,5.8-6.84,5.1-11.85-.23-1.01-.41-2.03-.7-3.02Z"
                fill="#2b231d"
              />
              <path
                d="M1008.27,656.63c.83-1.51,1.48-3.09,1.73-4.81.13-.87.19-1.75.28-2.62-.34-1.39-.49-2.78-.76-4.16-.34-1.78-.67-3.57-1.22-5.29-.28-.9-.88-1.78-1.56-2.44-.56-.54-1.41-.97-2.18-1.05-1.04-.1-2.15.07-3.19.32-2.98.73-5.41,2.24-6.94,5.05-1.58,2.9-2.52,6.02-3.35,9.18-.69,2.64-.03,3.98,2.32,5.47.85.54,1.54,1.35,2.25,2.09.39.41.63.96.99,1.39c1.28,1.51,3,1.98,4.87,1.36.88-.29,1.75-.62,2.64-.9c1.91-.59,3.19-1.91,4.11-3.6Z"
                fill="#2b231d"
              />
              <path
                d="M1049.08,449.74c.06-.93-.25-1.77-1.01-2.33-1.18-.85-2.33-1.77-3.62-2.44-3.5-1.81-7.04-3.58-10.62-5.23-3.53-1.63-7.1-3.2-10.72-4.63-3.32-1.32-6.67-2.61-10.2-3.33-1.41-.29-2.79-.81-4.15-1.3-4.79-1.7-9.57-3.44-14.37-5.12-1.22-.43-2.49-.72-3.76-.99-4.56-.97-9.12-1.99-13.71-2.81-3.98-.71-8-1.15-12-1.74-2-.3-3.98-.75-5.98-.98-3.6-.42-7.22-.68-10.82-1.08-2.98-.33-5.92-.88-8.96-.87-3.15.02-6.3-.41-9.46-.62-2.07-.14-4.14-.28-6.21-.37-1.96-.1-3.93-.13-5.89-.21-.93-.04-1.86-.17-2.79-.15-4.25.09-8.5.2-12.75.33-3.06.09-6.11.22-9.17.34-.41.02-.83.02-1.24.03-2.02.03-4.04.04-6.06.1-1.76.05-3.52.16-5.28.26-1.91.11-3.82.2-5.73.35-1.64.13-3.28.34-4.92.51-1.6.17-3.24.16-4.79.54-2.02.5-4.03.98-6.11,1.14-1.88.14-3.68.62-5.42,1.34-1.64.67-3.33,1.12-5.1,1.36-1.95.27-3.84.83-5.69,1.54-1.78.68-3.64,1.18-5.47,1.75-2.23.69-4.48,1.3-6.68,2.07-3.03,1.07-6.02,2.24-9.02,3.39-.97.37-1.95.74-2.83,1.27-3.48,2.09-7.24,3.6-10.91,5.31-1.69.78-3.32,1.7-4.94,2.63-1.58.9-3.09,1.91-4.66,2.82-4.41,2.55-8.69,5.28-12.49,8.73-4,3.64-8.12,7.14-12.11,10.78-3.46,3.16-6.68,6.52-9.37,10.41-1.98,2.87-3.04,6.11-4.35,9.27-.19.47-.26,1.01-.27,1.53-.06,1.82-.09,3.63-.08,5.45c0,.67.05,1.38.28,2c.86,2.28,1.8,4.53,2.74,6.78.2.47.52.9.81,1.33c3.05,4.48,7.46,7.15,12.32,9.17c1.29.53,2.65.92,4.02,1.18c2.96.56,5.89.11,8.81-.42.69-.13,1.39-.15,2.12-.23.11.4.25.69.26.99.04,1.77.75,3.32,1.52,4.86.6,1.21,1.28,2.4,1.67,3.68.67,2.21,1.94,4,3.48,5.64c2.12,2.26,4.45,4.24,7.57,4.97c2.53.59,5.13.82,7.71.65c2.32-.15,4.62-.68,6.93-.94c2.2-.25,4.25-.89,6.21-1.9.35-.18.73-.31,1.04-.44.45,1.26.8,2.45,1.29,3.58.66,1.52,1.41,3,2.15,4.49.28.55.58,1.12.98,1.58c1.73,2,3.41,4.06,5.67,5.53c1.76,1.15,3.61,2.03,5.77,2.07c1.5.03,3,.07,4.5.1.93.02,1.87.1,2.79.03c1.91-.15,3.81-.4,5.71-.57c2.26-.2,4.37-.83,6.29-2.05.59.69.76,1.4,1.05,2.05c1.28,2.84,3.26,5.23,5.48,7.31c3.62,3.4,8.06,5.22,13.04,5.6.72.06,1.45-.04,2.18-.04c4.15,0,7.88-1.01,10.77-4.23.1-.11.24-.16.41-.27.34.47.6,1,1.02,1.35c1.92,1.59,3.88,3.14,6.43,3.63c3.01.57,5.88.4,8.46-1.49.63-.46,1.3-.84,1.96-1.26c1.27-.8,2.55-1.58,3.82-2.38c1.53-.97,3.04-1.98,4.58-2.93c1.09-.68,2.3-1.19,3.33-1.95c1.84-1.35,3.63-2.78,5.36-4.27c1.75-1.49,3.66-2.71,5.66-3.83c1.9-1.06,3.82-2.1,5.65-3.28c3.41-2.2,6.95-4.14,10.6-5.9c1.68-.81,3.24-1.85,4.89-2.72c1.32-.7,2.67-1.37,4.04-1.97c1.9-.82,3.87-1.48,5.75-2.36c2.63-1.23,5.2-2.59,7.98-3.47c2.96-.95,5.9-1.96,8.66-3.44.77-.41,1.63-.67,2.47-.91c2.9-.8,5.79-1.58,8.46-3.05.89-.49,1.95-.72,2.96-.9c2.37-.41,4.63-1.1,6.8-2.14.97-.47,2.01-.9,3.06-1.06c2.79-.42,5.45-1.23,8.05-2.31c1.28-.53,2.66-.82,4.01-1.17s2.74-.59,4.09-.96c1.85-.5,3.65-1.18,5.51-1.6c2.88-.66,5.77-1.2,8.51-2.39c1.31-.57,2.79-.77,4.19-1.11c1.71-.42,3.44-.79,5.14-1.23c1.65-.43,3.28-.94,4.93-1.38.51-.14.87-.33.85-.7-.5-.8-1.07-1.38-1.24-2.07-.24-.98-.2-2.03-.27-3.04-.18-2.27.14-4.55-.5-6.81-.36-1.27-.27-2.67-.29-4.02-.02-1.92.27-3.86.05-5.75-.48-4.1-.31-8.18-.05-12.28.1-1.65.08-3.34-.21-4.96-.32-1.8-.68-3.56-.57-5.4Z"
                fill="#2b231d"
              />
              <path
                d="M802.08,494.95c.07-.17.17-.75.48-1.17c1.98-2.62,4.26-4.92,6.96-6.85c2.18-1.56,4.17-3.41,6.19-5.19c1.71-1.51,3.25-3.22,5.03-4.62c1.66-1.3,3.47-2.5,5.37-3.41c2.61-1.25,4.86-2.99,7.1-4.75c1.82-1.43,3.84-2.44,5.92-3.38c2.69-1.22,5.33-2.58,8.07-3.69c1.86-.75,3.84-1.2,5.77-1.77.99-.29,1.99-.55,2.99-.83.9-.25,1.81.21,2.11,1.07.35.99.05,1.81-.94,2.13-1.67.54-3.35,1.07-5.07,1.43-2.99.63-5.62,2.1-8.37,3.32-1.47.65-2.88,1.46-4.37,2.04-2.22.87-3.93,2.5-5.87,3.79-1.77,1.18-3.5,2.46-5.4,3.39-3.08,1.51-5.62,3.67-8.09,5.98-2.31,2.16-4.7,4.23-7.1,6.29-1.14.97-2.49,1.71-3.58,2.74-1.27,1.21-2.35,2.62-3.53,3.93-.38.42-.75.89-1.22,1.18-1.22.77-2.26.21-2.46-1.63Z"
                fill="#ffece5"
              />
              <path
                d="M836.34,516.65c.13-1.99,1.37-3.43,2.72-4.71c3.49-3.32,7.1-6.52,10.61-9.81c1.43-1.34,2.77-2.8,4.11-4.24c1.92-2.07,4.17-3.73,6.51-5.28c2.25-1.49,4.57-2.87,6.81-4.37c1.24-.84,2.42-1.79,3.55-2.77c1.37-1.19,3.02-1.82,4.66-2.46c2.21-.88,4.48-1.61,6.72-2.44.87-.32,1.68-.56,2.47.15.72.65.86,1.46.22,2.19-.4.45-.92.87-1.47,1.09-2.21.88-4.44,1.74-6.7,2.49-1.86.62-3.5,1.56-4.97,2.83-1.94,1.67-4.12,2.95-6.29,4.29-3.87,2.41-7.66,4.95-10.68,8.48-1.27,1.49-2.81,2.76-4.25,4.09-2.81,2.61-5.67,5.17-8.44,7.81-.74.7-1.27,1.63-1.89,2.46-1.44,2.24-2.58,2.19-3.67.2Z"
                fill="#ffece5"
              />
              <path
                d="M828.1,445.41c.85-.09,1.47-.14,2.09-.22.75-.09,1.34.13,1.63.88.32.82.15,1.61-.59,2.07-.46.29-1.04.49-1.59.55-2.41.23-4.6,1.08-6.78,2.11-2.48,1.17-5.08,2.07-7.61,3.15-1.28.55-2.54,1.16-3.76,1.85-3.3,1.85-6.58,3.76-9.87,5.63-2.91,1.65-5.47,3.74-7.87,6.06-1.52,1.48-3.14,2.85-4.74,4.26-2.1,1.84-4.37,3.5-5.88,5.93-.42.67-1.45.95-2.08.7-.75-.3-.86-.96-.92-1.66-.07-.84.21-1.56.77-2.13c1.53-1.54,2.97-3.22,4.67-4.54c2.63-2.04,5.03-4.32,7.47-6.57c1.91-1.76,3.94-3.33,6.25-4.59c3.5-1.92,6.88-4.07,10.36-6.02c1.76-.98,3.63-1.78,5.48-2.59c2.42-1.07,4.89-2.01,7.28-3.13c1.9-.89,3.79-1.68,5.68-1.71Z"
                fill="#ffece5"
              />
              <path
                d="M911.6,497.43c.36-.04.72-.11,1.08-.1.87.02,1.64.69,1.73,1.49.1.8-.47,1.77-1.32,1.85-3.28.31-5.89,2.19-8.72,3.56-1.35.65-2.76,1.21-4.14,1.8-1.83.79-3.41,1.9-4.87,3.27-2.31,2.16-4.77,4.15-7.16,6.23-2.27,1.98-4.6,3.89-6.75,5.98-1.44,1.4-2.65,3.06-3.92,4.63-.88,1.09-1.66,2.26-2.54,3.35-.61.76-1.26.83-2.06.37-.7-.4-1.08-1.23-.83-1.99.14-.43.4-.84.67-1.22.94-1.3,1.86-2.62,2.87-3.87c1.96-2.42,4.06-4.7,6.55-6.62c1.6-1.23,3.06-2.64,4.58-3.97.62-.55,1.25-1.09,1.88-1.63c1.88-1.63,3.79-3.23,5.63-4.9c1.29-1.18,2.79-1.96,4.33-2.71c2.71-1.31,5.4-2.66,8.1-3.98c1.54-.75,3.12-1.4,4.86-1.55Z"
                fill="#ffece5"
              />
              <path
                d="M932.16,515.74c.17.85-.33,1.42-1.08,1.79-.88.44-1.77.87-2.69,1.23-3.01,1.17-5.44,3.19-7.75,5.37-3.16,3-6.32,5.99-9.42,9.04-1.51,1.49-2.86,3.14-4.33,4.67-.49.51-1.06,1-1.69,1.3-.62.29-1.34.23-1.84-.4-.39-.5-.42-1.46-.04-2.06.17-.26.37-.5.58-.74c2.26-2.65,4.7-5.1,7.29-7.43c2.08-1.87,4.07-3.84,6.03-5.83c3.16-3.2,6.58-6.01,10.86-7.62.82-.31,1.57-.78,2.49-.77.97,0,1.44.41,1.57,1.43Z"
                fill="#ffece5"
              />
              <path
                d="M970.79,512.63c.12-1.13.26-2.32,0-3.4-.38-1.66-.95-3.3-1.67-4.84-2.11-4.47-4.49-8.79-7.6-12.67-1.01-1.26-1.93-2.6-3.06-3.73-2.84-2.8-5.84-5.45-8.66-8.26-2.28-2.28-4.31-4.79-5.64-7.77-2.33-5.19-5.11-10.08-8.64-14.57-2.46-3.13-5.04-6.08-8.49-8.13-3.12-1.85-6.36-3.16-10.15-2.88-2.14.16-4.33.11-6.49-.37-2.53-.57-5.08-1.05-7.65-1.42-2.46-.36-4.33-1.6-5.98-3.36-.99-1.06-2.05-2.06-3.16-2.99-2.67-2.24-5.41-4.4-8.09-6.62-1.8-1.49-3.61-2.97-5.71-4.04-2.28-1.16-4.61-2.08-7.18-2.43-2.2-.3-4.35-.06-6.51.13-2.67.24-5.2,0-7.15-2.16-.17-.19-.39-.34-.6-.49-1.41-1-2.88-1.86-4.66-2.01-.19-.02-.39-.05-.58-.07-1.56.62-3.17,1.04-4.85,1.27-1.95.27-3.84.83-5.69,1.54-1.78.68-3.64,1.18-5.47,1.75-1.77.55-3.55,1.07-5.32,1.64c1.55.29,3.07.72,4.54,1.36c2.09.91,4.17,1.87,6.31,2.66c3.95,1.47,7.29,3.77,9.84,7.11c2.39,3.13,4.66,6.37,6.94,9.59c1.96,2.76,4.04,5.38,6.77,7.47c2.56,1.96,4.97,4.11,7.92,5.48c1.49.69,2.76,1.66,3.95,2.75c1.3,1.19,2.43,2.54,3.28,4.12.64,1.18,1.29,2.37,2,3.5.77,1.22,1.86,2.08,3.22,2.59.97.37,1.96.7,2.92,1.11c2.94,1.26,6,2.04,9.2,2.16c3.42.12,6.62,1.13,9.8,2.3c1.94.71,3.97,1.2,5.98,1.71c1.63.41,3.19.94,4.57,1.91c1.23.86,2.36,1.88,3.65,2.64c2.39,1.4,4.12,3.45,5.87,5.51c1.3,1.53,2.05,3.2,2.13,5.22.09,2.45.57,4.82,1.58,7.1c1.07,2.4,2.55,4.42,4.77,5.8c2.42,1.51,4.4,3.46,6.16,5.66.63.8.88,1.67.78,2.75-.21,2.22-.33,4.48.59,6.6.7,1.62,1.45,3.23,2.28,4.78.68,1.27,1.01,1.8,1.66,1.97c1.1-.58,2.2-1.14,3.33-1.68c1.68-.81,3.24-1.85,4.89-2.72c1.32-.7,2.67-1.37,4.04-1.97c1.9-.82,3.87-1.48,5.75-2.36.6-.28,1.2-.57,1.8-.86.96-1.23,1.61-2.69,1.85-4.41.19-1.34.52-2.66.66-4Z"
                fill="#ffc7b5"
              />
              <path
                d="M972.67,437.88c.72-.07,1.45-.12,2.17-.23c2.84-.43,5.68-.43,8.52-.05.61.08,1.24.04,1.86.04c2.64,0,5.11.74,7.52,1.76c2.49,1.05,5.06,1.89,7.73,2.35c1.82.32,3.42,1.21,5.01,2.09c2.09,1.15,4.2,2.27,6.24,3.5s4.04,2.53,5.98,3.9c.6.43,1.07,1.14,1.43,1.81.48.9.24,1.59-.69,2.07-1.83.96-3.58,2.12-5.61,2.65-.6.16-1.22.33-1.83.31-3.25-.12-6.51-.34-9.76-.44-2.27-.07-4.55.04-6.83-.03-1.96-.06-3.93-.22-5.88-.41-3.25-.31-6.48-.75-9.73-1.01-1.88-.15-3.72.31-5.51.87-2.78.88-5.54.89-8.22-.21-2.3-.95-4.58-1.97-6.75-3.18-2.66-1.5-4.07-4.09-5.13-6.85-.15-.38.17-.95.33-1.42.06-.18.25-.35.43-.44c3.32-1.8,6.25-4.28,9.83-5.65c2.28-.87,4.66-.97,7.02-1.24.62-.07,1.24-.13,1.86-.19v0Z"
                fill="#81c6b2"
              />
              <path
                d="M935.44,433.69c-2.53.22-5.06.49-7.59.64-.92.05-1.86-.15-2.77-.3-2.46-.41-4.9-.82-7.42-.56-2.37.25-4.76.35-7.14.44-.98.04-1.97-.03-2.94-.16-2.42-.31-4.83-.67-7.24-1.02-1.04-.15-2.01-.42-2.85-1.14-1.19-1.02-1.39-2.49-1.83-3.84-.23-.72.33-1.3.89-1.69.64-.44,1.32-.87,2.04-1.12c3.66-1.29,7.43-1.84,11.31-1.73.88.03,1.77-.04,2.64-.19c2.56-.44,5.07-.26,7.55.48c2.35.7,4.78.9,7.2,1.16c1.69.18,3.34.65,5.01,1c1.07.22,2.13.44,3.19.7c1.25.31,2.51.63,3.74,1.03c1.08.35,1.84,1.16,2.47,2.07.6.88.42,1.98-.53,2.4-1.84.81-3.74,1.47-5.62,2.2-.03-.12-.06-.24-.09-.36Z"
                fill="#ff7159"
              />
              <path
                d="M942.3,439.41c1.19-.12,2.37-.25,3.56-.36.36-.03.74-.1,1.08-.03.93.18,1.32,1.09.83,1.9-.13.22-.3.43-.5.59-2.83,2.27-5.6,4.7-9.17,5.71-2.6.74-5.29,1.02-7.98.39-2.05-.68-2.41-2.21-1.2-3.4c1.21-1.18,2.73-1.87,4.25-2.52c1.05-.45,2.09-.94,3.19-1.22c1.95-.49,3.93-.84,5.9-1.24.01.06.03.12.04.18Z"
                fill="#ff7159"
              />
            </g>
          </g>
          <g id="e0gYpSRcAlv2433" transform="translate(.000001-189.354623)">
            <g>
              <g>
                <g>
                  <path
                    d="M1310.2,641.91c2.28,1.48,4.47,2.44,6.81,4.06s4.94,3.87,6.93,6.07c3.98,4.4,8.46,9.19,11.33,14.22c2.55,4.46,1.33,9.56-3.47,11.12-5.56,1.8-9.66-1.41-12.96-5.62s-6.16-9-8.97-13.52c-1.37-2.21-2.54-4.47-3.23-6.93s-1.05-4.36-1.38-7.05s2.65-3.82,4.94-2.35Z"
                    fill="#ffead7"
                  />
                  <path
                    d="M1457.68,753.13c-.6.2-1.22.42-1.85.58-1.34.35-2.71.87-4.09,1.18-10.95,2.46-22.57,4.99-33.7,4.39-8.4-.46-18.09-9.32-11.05-16.79s15.83-6.66,26.02-7.09c8.49-.35,19.19.45,27.38,4.49.19.1.46.35.59.42s.18,0,.27-.02c4.62-1.04,8.76-2.29,13.42-.92c1.41.41,2.83,2.09,2.26,3.5-1.8,4.48-5.62,5.43-9.78,6.99-3.13,1.18-6.29,2.23-9.46,3.28Z"
                    fill="#ffead7"
                  />
                </g>
                <path
                  d="M1243.27,804.93c.18-3.55.3-7.13.28-10.81-.04-10.64-.86-21.42-2.13-32.1.83-5.81,1.08-11.81-.19-17.52-.51-2.31-1.35-4.47-2.28-6.6-.53-3.13-1.1-6.23-1.6-9.24-1.37-8.2-1.73-16.34-1.4-24.38.32-8.04.91-15.46.6-23.35-.15-3.85-.25-7.47.76-11.15.4-1.47,1.08-2.48,1.58-3.86.76,1.39,1.28,2.69,1.21,4.27-.45,9.51-.68,18.28,1.24,27.77c1.75,8.69,4.56,17.61,7.37,26.15c2.82,8.55,6.51,16.62,9.65,25.11c1.71,4.62,3.17,9.22,4.51,13.88c6.3,18.48,10.89,38.84,5.78,56.66h-26.41c.5-4.89,1.73-9.62,1.03-14.85Z"
                  fill="#727536"
                />
                <path
                  d="M1249.6,648.96c4.03,7.24,7.92,14.9,12.75,21.7s10.56,12.67,16.85,18.03c5.18,4.42,10.7,8.42,15.36,13.23c1.51,1.56,2.76,3.62,3.73,5.26c4.03,6.79,9.19,15.87,11.27,22.75c4.58,15.17,1.1,28.68-1,42.81-1.63,10.95-3.14,18.99-4.94,29.32-.12.67-.36,1.06-.61,1.66-.83,1.96-1.66,3.69-2.57,5.65s-2.32,3.86-3.5,5.72c-.51-.08-.98-.23-1.46-.43.26-1.59.34-3.16.27-4.77c1.24-9.53-.57-17.72-3.94-26.62-.06-2.02.09-3.88-.07-5.92-.1-1.24-.16-2.31-.42-3.64-1.2-6.14-1.66-10.98-3.93-17.28-4.62-12.85-11.49-25.96-17.91-38.37-.68-1.32-1.46-2.85-2.13-4.19-2.44-9.21-5.81-17.82-10.05-26.35-1.44-3.92-3.24-7.98-4.69-11.85s-3.09-7.6-4-11.5c-1.98-8.46-3-16.89-4.44-25.39-.08-.47-.03-.8-.04-1.27c1.58,4.03,3.33,7.62,5.47,11.45Z"
                />
                <path
                  d="M1389.23,735.9c-7.69,8.59-11.02,17.89-19.08,25.97-1.4,1.41-.03,4.5,1.23,5.79c3.26.56,6.18.86,9.54.84c3.35-.02,7,0,10.37.57c9.13-1.61,17.79-2.3,27.14-2.75c11.24-.54,23.6.99,34.72-1.11c20.15-3.8,35.29-14.34,51.99-25.42c2.9-1.74,5.77-3.29,8.21-5.7c1.26-1.24,1.13-2.82.36-4.33-5.58,2.06-13.19,3.41-18.74,3.14-8.95-.45-15.89-2.75-24.05-4.82-2.16-.55-4.48-.96-6.43-1.35-13.82-2.8-30.23-7.18-43.58-6.69-14.73.54-22.85,6-31.69,15.87Zm28.14,8.14c5.53-2.35,11.07-2.81,17.44-2.69c13.4.24,27.49,1.98,41.04,2.77-.94.43-1.62.98-2.62,1.36-10.72,4.05-20.58,5.85-32.25,6.37-10.91.48-22.84.02-33.99.35c3.59-2.92,5.85-6.24,10.38-8.16Z"
                  fill="#6d6d38"
                />
                <path
                  d="M1276.36,596.32c-.29.48-.75.56-.76,1.23-.32,18.24,4.76,31.97,15.12,47.13c7.23,10.59,15.83,20.05,23.59,30.9c7.76,10.86,15.63,23.4,22.92,34.94.2.32.68.51.73.96.2,1.68.05,3.44,0,5.14c2.25,7.16,4.4,14.34,6.36,21.58.31,1.15.75,2.24,1.32,3.28.06.1.22.2.26.05.87-2.97,1.64-5.24,2.39-8.42c1.81-7.74,3.3-16.11,3.41-24.16.11-8.06-1.03-15.63-1.83-23.64-.81-8.01-2.2-15.99-4.64-23.73-.31-.99-.64-2.05-1.33-2.89-5.48-6.69-11.76-12.3-18.34-17.94-7.42-6.35-14.99-12.04-22.99-17.86-10.35-7.53-19.71-15.24-26.21-26.57Zm28.18,42.82c6.62,6.52,13.59,13.07,18.91,20.62c4.13,5.88,6.54,11.94,9.27,18.44-7.3-11.55-15.5-22.4-23.73-33.27-1.49-1.97-2.96-3.86-4.45-5.8Z"
                  fill="#ba9e7e"
                />
                <g>
                  <path
                    d="M1342.21,689.57c-.68-.29-1.47.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1332.43,689.93c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.01,713.96c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1318.17,670.85c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1347.1,689.93c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1338.9,691.53c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1347.66,713.25c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1324.88,682.68c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.4,726.85c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1322.61,671.65c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1342.69,698.9c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.53,731.23c-.69-.29-1.48.03-1.77.72s.03,1.48.72,1.77s1.48-.03,1.77-.72-.03-1.48-.72-1.77Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1342.87,720.17c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1338.36,704.26c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.33,701.81c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.14,675.21c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.35,716.45c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1313.86,671.35c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1335.98,664.61c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1309.09,661.68c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.27,676.71c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1333.29,652.53c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1310.71,667.5c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1342.15,684.73c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1331.18,694.55c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1319.08,680.58c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1343.4,722.4c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.09,684.58c-.68-.29-1.47.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1342.4,705.54c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1328.26,683.85c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1336.57,696.53c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.27,718.35c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1334.71,669.33c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.22,699.6c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.99,680.13c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.74,713.18c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1350.53,710.46c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1347.29,728.73c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.04,692.94c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1334.69,698.69c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1341.43,710.74c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.15,675.59c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.21,696.38c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.14,685.19c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.62,715.57c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1305.51,654.99c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1332.71,671.39c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1336.76,660.02c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1339.53,685.18c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1349.22,705.75c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.89,698.48c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1336.09,693.57c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.34,699.92c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1350.65,715.45c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.62,661.78c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1332.46,683.46c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1343.19,666.38c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.19,704.72c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1327.28,687.9c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1329.3,691.63c-.68-.29-1.47.03-1.75.71s.03,1.47.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.24,679.13c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1337.49,671.03c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1336.71,686.71c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1329.62,680.65c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1326.23,665.54c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1341.24,708.25c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1349.06,717.95c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1328.87,659.42c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1315.02,666.76c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1350.22,702.95c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.31,656.07c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1338.45,681.68c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.25,733.84c-.69-.29-1.49.03-1.78.73-.29.69.03,1.49.73,1.78.69.29,1.49-.03,1.78-.73.29-.69-.03-1.49-.73-1.78Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1347.12,723.29c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1328.94,675.76c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.54,708.17c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1339.91,696.44c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1341.79,715.48c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.24,711.89c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1342.15,717.92c-.68-.29-1.47.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1324.4,686.3c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.44,670.13c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.58,694.71c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1321.95,675.57c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1322.83,679.9c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.15,724.83c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.05,709.86c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1335.96,675.59c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1340.78,669.63c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1335.1,691.4c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1345.21,722.24c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75s1.46-.03,1.75-.71-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1349.35,708.06c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1318.28,661.55c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1318.12,651.11c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1334.44,682.64c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1338.15,699.75c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1329.46,667.88c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1346.63,702.65c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1331.7,686.46c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.49,720.25c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1348.68,687.71c-.68-.29-1.46.03-1.75.71s.03,1.46.71,1.75s1.46-.03,1.75-.71-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1336.79,678.88c-.68-.29-1.46.03-1.75.71s.03,1.47.71,1.75c.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1344.55,724.62c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1332.62,676.84c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.46-.03,1.75-.71s-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1318.4,676.29c-.68-.29-1.47.03-1.75.71-.29.68.03,1.46.71,1.75s1.47-.03,1.75-.71c.29-.68-.03-1.46-.71-1.75Z"
                    fill="#4e531e"
                  />
                  <path
                    d="M1326.51,672.32c-.68-.29-1.47.03-1.75.71-.29.68.03,1.47.71,1.75.68.29,1.47-.03,1.75-.71.29-.68-.03-1.47-.71-1.75Z"
                    fill="#4e531e"
                  />
                </g>
                <path
                  d="M1392.42,697.35c4.51-5.33,9.61-10.29,14.75-15.07.26-.24.31-.6.63-.78c7.88-4.48,12.77-9.84,22.32-11.85c25.61-5.38,51.39-.94,77.23,3.03c6.06.93,11.95,1.31,17.93,2.52c2.24.46,3.66,1.97,4.83,3.84-5.8-.59-12.18-2.06-17.9-1.69-6.7.43-12.4,2.59-18.39,4.89-7.76,2.97-15.06,6.14-22.84,8.88-6.22,2.19-12.91,3.96-19.03,6.28-14.46,5.49-28.63,10.98-43.39,15.42-5.59,2.11-10.83,3.11-16.87,3.16-1.64.01-3.43.57-5.23.37-3.03-.32-4.85-2.32-5.43-5.31c4.19-4.31,7.5-9.09,11.4-13.69Z"
                  fill="#4e6528"
                />
                <path
                  d="M1332.72,570.94c6.61,8.36,13.68,16.99,19.84,25.84.12.17.32.36.39.57c2.54,7.84,4.91,16.73,6.62,24.57c2.24,10.25,4.05,20.92,5.02,30.78s1.3,17.72-.08,27.15c-.22,1.53-1.44,1.41-2.64,1.65-.31-2.71-1.46-5.02-2.25-7.58-1.25-4.05-3.1-7.94-5.28-11.47-.64-1.03-1.17-1.75-1.67-2.61-4.34-7.42-9-15.82-12.25-23.49-3.82-9.01-7.53-19.7-9.69-28.3-4.52-18.05-6.21-34.12-8.18-52.01-.11-1,.22-1.35.53-2.25c2.26,6.59,5.26,11.61,9.64,17.15Z"
                  fill="#707758"
                />
                <path
                  d="M1415.53,635.93c8.2-6.35,16.62-10.85,26.36-13.83c9.05-2.77,18.78-3.59,27.94-5.02c5.78.49,11.11.13,16.89-1.3c3.87-.95,7.83-2.24,11.45-4.1-.48,1.48-1.1,2.89-1.84,4.18-.77,2.05-1.85,3.86-3.06,5.51-1.21,1.64-2.56,3.1-3.72,4.51-7.22,6.48-13.81,12.48-21.8,18.12-8.59,6.06-18.4,10.6-28.35,14.26-3.63.11-7.01.64-10.66.26-2.62-.28-5.08-1.35-7.6-2.33-5.65-2.21-10.9-3.76-17.03-3.02c1.62-7.22,5.7-12.81,11.41-17.23Z"
                  fill="#8e934b"
                />
                <path
                  d="M1376.22,503.09c-1.08,6.83.26,12.5,3.39,18.53.75,1.44,1.62,2.48,2.41,3.71c1.57,2.45,3.19,4.64,4.5,7.18.54,1.04.86,1.99,1.18,3.1c1.3,4.45,2.39,8.19,3.65,12.87c1.77,6.57,1.96,13.57.82,20.48-.26,1.58-.69,3.1-1.1,4.76-1.22,4.97-2.6,9.91-3.78,14.99-.91,3.9-1.47,7.99-1.79,12.08-.11,1.36-.16,2.74-.26,4.22-.48,7.16-.48,14.09-3.44,20.81-3.11-6.65-8.24-11.67-11.34-18.4-2.79-6.06-5.14-12.59-7.23-19.04-.48-1.49-.88-3.03-1.14-4.71-1.59-10.08-1.77-20.63-1.13-30.72.35-5.49,1.4-10.15,2.32-15.38.31-1.75.72-3.4,1.14-5.06s.84-3.23,1.31-4.82c.75-2.54,1.59-4.99,2.5-7.45.24-.64.63-1.2.91-1.8c2.39-5.07,4.68-10.15,6.93-15.28.03-.06.12-.04.16-.07Z"
                  fill="#384512"
                />
                <path
                  d="M1406.19,593.75c5.97-6.06,12.03-9.22,19.55-13.59c8.54-4.97,18.88-5.09,28.76-4.39c4.11.29,8.01.97,12.01,1.69c4.43,2.16,8.72,4.42,13.27,6.33c5.57,2.33,10.61,4.51,16.47,6.58.65.24,1.3.44,1.96.62c5.03,2.03,8.73,3.59,14.18,4.43-10.12,10.25-25.04,11.23-38.11,12.61-2.27.14-4.53.22-6.79.28-6.76.18-13.4.11-19.52.34-3.97-.14-7.97-.4-12.04-.77-6.37-2.54-11.68-5.04-18.59-6.93-3.24-.89-8.34-1.3-11.99-.64-.33-2.09-.75-4.97.83-6.57Z"
                  fill="#7f8343"
                />
                <path
                  d="M1428.58,544.28c2.1-3.91,4.36-7.49,7.19-10.8.94-1.1,1.88-1.9,2.97-2.77s2.28-1.56,3.45-2.3c1.18-.73,2.32-1.46,3.57-2.08c7.36-3.6,14.91-6.47,22.74-8.87.6.11,1.09.15,1.72.18c6.26.31,12.41.94,18.64,1.93c1.55.25,3.13.55,4.76.8c14.69,2.25,28.46,3.11,43.12-.02-1.31,2.03-2.61,3.51-4.76,4.76-1.41.82-2.95,1.48-4.54,2.19-2.75,1.22-5.49,2.4-8.24,3.56-4.78.66-8.97,2.83-13.1,5.25-17.42,6.62-35.12,11.8-53.88,14.96-.42.07-.73.61-1.19.54-1.32-.23-2.45-.66-3.8-.89-6.49-1.09-12.99-1.92-19.6-1.94-.03-1.5.26-3.23.95-4.51Z"
                  fill="#6f7e43"
                />
                <path
                  d="M1394.32,468.52c4.59,5.33,10.08,10.44,15.45,15.14c2.95,4.11,5.67,8.16,7.86,12.74.55,1.14.96,2.07,1.34,3.42c4.82,16.99,2.55,29.88-10.45,42.3-1.33,1.28-3.14,1.76-4.51,2.98-.1.09-.29-.11-.28-.25.08-1.71.17-3.4.04-5.12-.54-6.68.39-13.08,1.25-19.71.24-1.86-.88-3.65-1.48-5.3s-1.38-3.2-1.96-4.76c-5.79-15.59-10.34-31.48-14.05-47.58-.49-2.14.04-3.1.86-4.94c1.34,4.36,2.88,7.51,5.94,11.07Z"
                  fill="#93a059"
                />
                <path
                  d="M1446.93,512.85c1.21-1.2,2.78-2.68,4.23-3.93c3.38-2.91,6.4-6.26,9-9.94.87-1.23,1.51-2.47,2.33-3.79.81-1.32,1.64-2.79,2.45-4.17c8.69-14.83,14.64-30.65,21.01-46.58.52-1.3,1.41-2.39,2.13-3.64c1.44-2.51,2.85-4.72,4.37-7.33c1.53-2.6,3.31-5.64,4.9-8.31-4.77,3.92-9.54,7.76-14.51,11.48-1.24.93-2.56,1.84-3.88,2.77-11.67,8.24-23.22,16.54-34.25,25.71-1.04.86-1.97,1.76-2.98,2.9s-2.13,2.45-3.03,3.91c-4.47,7.28-6.81,14.4-6.79,23.02c0,1.27-.17,2.46-.08,3.71.37,4.99-.79,10,.2,14.97c1.15,5.77,7.18,4.04,11.26,1.88c1.28-.68,2.44-1.46,3.65-2.65Z"
                  fill="#8b894e"
                />
                <path
                  d="M1450.73,483.57c.23-.82.44-1.64.65-2.46-.2.82-.42,1.64-.65,2.46Z"
                  fill="#3d470d"
                />
                <path
                  d="M1450.18,485.36c-.05.13-.11.26-.16.39.23-.73.48-1.45.71-2.19-.19.59-.34,1.21-.55,1.79Z"
                  fill="#3d470d"
                />
                <path
                  d="M1323.38,795.44c0,0,0-.05,0-.07s-.01.02,0,0c.19-1.59.79-2.71,1.54-4.16s1.18-3.53,1.63-5.05c.46-1.52,1.01-2.48,1.84-3.73.45-.68.93-1.4,1.41-2.03c3.16-11.02,7.58-20.47,11.81-31.32c3.35-8.59,6-17.16,6.21-27.05.18-8.66-2.81-18.58-4.69-27.27-.05-.21-.06-.31.13-.43c1.1,4.52,3.29,7.79,4.43,12.48c2.02,8.33,1.78,17.29,1.27,25.97-.91,4.12-1.71,8.79-3.11,12.64-2.92,8.02-6.53,15.24-9.52,23.13-1.53,4.04-2.77,8.25-4.23,12.34-.06,1.41-.76,2.72-1.32,3.92s-.86,2.24-1.37,3.41c-.01.03-.01.06,0,.07c8.15-11.01,16.35-22.54,22.01-34.85c2.4-5.23,3.9-10.43,5.63-15.29c1.49-4.18,2.4-6.92,3.76-10.82.37-1.05,1.37-1.83,1.53-2.92.21-1.52-.57-3.31-.45-4.85.11-1.54.7-2.71.93-4.2.49-3.19,1.2-6.21,1.25-9.51.12-7.36-.69-14.84-1.16-22.2.5-11.48-1.47-21.9-4.41-33.02-1.42-5.38-3.28-11.14-5.04-16.44c5,12.82,9.37,27.1,11.2,40.41c1.36,9.88.97,17.93,1.3,27.39.11,3.13-.01,5.82.04,8.88.02,1.21.05,2.27-.05,3.46.67-1.61,1.33-3.22,1.99-4.84.56-.31.98-.53,1.26-1.15c2.26-5.05,3.91-10.26,5.77-15.51c1.21-3.4,2.88-6.74,4.34-10.07-.09-.16-.19-.3-.22-.48-.32-2.06-.63-4.13-.93-6.19.62-4.23,1.22-8.47,1.8-12.7c1.04,4.81,1.42,9.58,1.41,14.5.79-2.14,1.49-4.31,2.16-6.49-.27-2.59.66-4.48,2.03-6.6.24-.38.27-.77.4-1.16.95-2.73,1.67-5.38,1.94-8.26.02-.22.05-.49-.01-.7-.06-.22-.2-.33-.22-.56-1.42-14.08-7.04-26.98-10.06-40.73-1.12-5.09-1.22-10.33-1.75-15.5.72-3.4,1.27-6.77,1.63-10.23.66,9.38.36,18.22,2.2,27.62c2.08,10.69,6.7,21.39,9.29,32.08c2.3-9.48,1.82-19.2,2.69-28.84.86-9.64,3.11-18.87,5.35-28.22.38-1.58,1.48-2.76,1.94-4.29-.31-1.61-.57-3.23-.7-4.87c0-.1.05-.19.06-.3.85-5.95.71-12.07,1.33-18.02.7-6.66,2.45-12.9,4.36-19.27c1.66-5.53,3.44-11.06,4.51-16.7.24-1.28.3-2.45.32-3.67.01-1.22-.11-2.28-.3-3.45s-.48-2.22-.83-3.36c-.34-1.14-.83-2.29-1.25-3.42-.07-.19-.11-.41-.16-.62-.04-.21.17-.39.3-.13.69,1.37,1.34,2.91,1.77,4.36s.72,2.93.88,4.36.24,2.95.13,4.3c-.58,6.78-3.04,13.35-4.83,19.7-2.19,7.76-3.73,14.8-4.48,22.78-.5,5.28.28,10.92-.17,16.28c2.43-5.27,4.76-10.61,7.45-15.75c1.49-2.84,3.16-5.6,4.45-8.52.69-1.57,1.03-3.02,2.32-4.26c2.67-5.37,5.17-10.79,7.46-16.34.46-1.11.8-2.26,1.3-3.36c6.67-14.46,14.44-28.1,23.16-41.42.9-1.38,1.58-2.87,2.3-4.36.66-1.36,1.18-2.78,1.69-4.2-.75,2.33-1.54,4.65-2.47,6.91-.61,1.48-1.21,3.01-1.94,4.42-6.83,13.2-14.03,26.16-20.26,39.65-.63,1.37-1.25,2.72-1.89,4.07-1.91,4.07-3.93,8.09-5.92,12.11c1.24-.8,3.11-1.25,4.32-1.93c3.14-1.76,6.24-4.02,9.19-5.68s5.45-2.54,8.52-3.58c.13-.04.23-.06.36-.11-3.36,1.85-6.69,3.72-9.89,5.85-2.57,1.71-5.15,3.42-7.83,4.93-1.24,1.66-2.7,2.6-4.34,3.9-1.65,1.3-3.08,3.19-4.62,4.68-7.65,15.36-14.42,30.59-18.52,47.3.3-.41.69-.99.95-1.39c2.16-3.36,4.2-6.66,7.49-8.94c3.29-2.27,6.54-3.49,10.18-5.28s7.55-4.14,11.32-5.91c.06-.03.14-.02.2,0-3.22,1.56-6.08,3.53-9.03,5.56-1.4.96-2.99,1.71-4.46,2.56-2.62,1.52-4.71,2.88-7.39,4.58-2.69,1.7-4.98,4.3-6.42,7.3-.27.56-.77,1.02-1.12,1.55-.79,1.18-1.58,2.38-2.22,3.66-1.37,16.49-1.46,32.81-5.42,48.96c3.1-2.88,6.5-5.29,10.15-7.36.7-.4,1.56-.9,2.16-1.11.59-.22.89-.03,1.33-.18c6.52-2.18,12.68-4.88,18.88-7.8-4.85,2.94-9.62,5.18-14.79,7.69-6.93,3.37-13.52,7.13-18.98,12.76-.6,1.78-1.19,3.71-1.78,5.46-5.96,17.61-12.56,34.87-19.32,52.17c1.49-1.11,2.85-1.99,4.43-2.98c5.75-3.62,9.8-7.74,14.93-12.47c9.55-8.82,21.31-13.6,33.61-17.85.18-.06.4.22.23.3-12,5.33-23.46,11.05-32.9,20.14-4.2,4.05-7.78,7.67-12.58,10.54-3.61,2.16-6.51,4.02-9.53,6.83-4.91,12.36-10.09,24.65-15.89,36.61c12.85,3,22.1-1.57,32.88-7.84s21.68-8.59,33.43-11.73c.17-.05.38.24.21.3-6.57,2.43-12.96,4.27-19.57,6.76s-11.85,5.8-18.2,9.63c-7.31,4.4-15.36,6.9-24.19,5.74-1.27.3-2.43.26-3.67.62s-2.39,1.21-3.64,1.61c-11.71,17.76-26.32,33.19-37.87,51h-2.89c5.91-8.2,11.78-16.44,18.13-24.33Z"
                  fill="#3d470d"
                />
                <path
                  d="M1239.35,775.56c.11-1.3.21-2.6.3-3.9.41-1.96.81-3.93,1.17-5.91c1.09-5.89,1.72-12.11.94-18.1.1-.04.25.08.27.24.92,8.99.72,17.85,1.23,26.94s.5,18.48.3,27.61c-.12,5.76-.28,11.57-.37,17.34h-4.5c-.24-6.43-.33-12.77-.3-19.19.03-8.42.24-16.7.96-25.02Z"
                  fill="#4e531e"
                />
                <path
                  d="M1257.37,687.51c-.99-2.07-1.66-4.4-2.62-6.5.09,0,.18.09.24.17c5.78,8.5,11.13,18.65,15.21,27.77c4.3,9.62,8.61,20.14,11.97,29.19c6.84,18.4,11.27,34.83,13.73,53.85.07.52-.64.55-.8.05-5.67-17.72-11.67-34.63-18.38-52.28-2.48-6.52-5.75-14.54-8.5-21.25-2.29-10.98-6.03-20.92-10.84-31Z"
                  fill="#4e531e"
                />
                <path
                  d="M1275.49,609.21c10.76,21.15,21.36,38.36,36.81,57.34c14.25,17.51,26.41,37.03,28.94,60.63.01.1.04.37.02.3-.84-2.55-1.65-5.2-2.48-7.77-.2-.63-.43-1.13-.83-1.7-8.31-20.51-21.93-37.69-35.47-54.62s-21.28-33.63-27.07-54.15c-.02-.06.06-.09.09-.04Z"
                  fill="#4e531e"
                />
                <path
                  d="M1509.34,731.54c-7.24,5.79-13.91,6.91-23.11,5.8-5.3-.64-10.58-2.8-15.91-4.17s-11.4-2.67-16.83-3.47c-23.51-3.47-42.95-5.67-62.96,8.91-.35.25-.95-.2-.71-.51c5.74-7.32,9.09-13.62,18.57-17.2c9.49-3.58,19.82-2.91,30.59-1.88s22.2,2.66,33.12,6.32c12.22,4.09,23.75,9.7,37.07,6.04.11-.03.24.1.17.16s-.01.02,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M1323.45,558.17c1.16,3.82,1.71,7.65,2.57,11.56s1.87,7.37,2.73,11.4c1.65,7.67,2.89,14.24,4.95,22.3c4.14,16.21,9.54,33.26,16.04,49.03.08.21-.19.24-.31.06-4.7-7.33-8.55-15.56-11.48-23.62-3.16-8.67-6.37-17.57-8.84-26.05-2.24-7.68-3.66-14.36-4.91-21.99-1.25-7.62-1.51-15.05-1.11-22.74.01-.21.31-.13.36.04s.01.02,0,0Z"
                  fill="#4e531e"
                />
                <path
                  d="M1409.7,593.25c15.23-12.33,28.02-22.28,48.63-21.86c10.27.21,19.31,6.74,28.46,11.45.11.06.23.13.34.19c1.88,1.5,3.77,2.98,5.68,4.37s3.85,2.7,5.81,3.85c3.38,1.27,8.31,3.34,12.01,4.9-7.2-.13-13.69,1.5-20.68-2.18-2.37-.85-4.74-1.8-7.1-2.73-4.72-1.86-9.41-3.66-13.95-4.44-10.76-2.93-19.7-1.49-29.98-1.24-10.89.26-19.42,3.52-28.99,8.14-.25.12-.44-.26-.22-.44Z"
                  fill="#4e531e"
                />
                <path
                  d="M1460.23,645.12c9.33-5.81,17.55-12.77,26.12-19.4c2.39-1.85,4.11-3.97,6.11-6.14s3.71-4.6,5.39-7.04c-1.7,4.61-3.85,8.85-6.57,12.97-.91,1.37-1.86,2.5-2.92,3.93s-2.39,3.23-3.67,4.6c-12.31,10.09-25.53,18.09-40.93,22.41c4.01-2.85,7.9-6.24,12.04-8.77c1.49-.92,3.14-1.74,4.44-2.55Z"
                  fill="#4e531e"
                />
                <path
                  d="M1390.08,471.3c5.57,14.95,13.18,28.6,17.92,44.02c2.75,8.93-.73,17.7-4.09,26.11-.16-2.3-.33-4.67-.44-7.02-.16-3.28-.5-6.66-.5-9.93c0-1.47.69-2.85.57-4.25-.26-3.08-1.73-5.92-2.72-8.7-4.72-13.22-7.9-26.57-10.89-40.21-.02-.09.13-.11.16-.02Z"
                  fill="#4e531e"
                />
                <path
                  d="M1473.76,543.77c10.99-2.61,21.74-5.14,32.62-7.8-1.32.77-2.63,1.56-3.96,2.34-14.34,5.6-28.75,10.63-43.89,13.93-.84.18-1.59.05-2.48.06-.89,0-1.88.32-2.81.1-2-.48-3.93-1.32-5.97-1.64-.07-.01-.14-.04-.19-.04c8.67-2.9,17.87-4.85,26.69-6.94Z"
                  fill="#4e531e"
                />
                <path
                  d="M1300.33,774.03c-2-5.08-3.57-9.97-5.92-14.99-2.35-5.01-5.04-9.66-7.22-14.99-4.68-11.47-9.03-23.55-13.85-35.09-.31-.74.78-.83,1.21-.18c8.07,11.96,18.2,23.28,24.46,36.3c4.85,10.09,5.02,18.61,1.81,29.03-.08.26-.43.11-.5-.07s-.02-.03,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1350.94,638.53c-10.21-15.16-15.23-31.51-20.09-48.96-.33-1.19,1.1-1.54,1.7-.61c9.83,15.12,12.57,32.58,18.96,49.22.16.43-.28.79-.57.35-.02-.02-.02.06,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1375.35,590.52c-1.2-.86-2.4-1.69-3.33-2.84s-1.8-2.12-2.42-3.54c-2.46-5.68-3-11.86-2.6-17.93.71-10.81,2.18-21.17,2.71-31.9.02-.42.82-.54.9-.18c2.06,8.98,4.09,17.68,5.78,26.8.75,4.06.84,8.73.69,12.92s-1.34,8.15-1.6,12.3c-.09,1.38-.01,2.78.1,4.16c0,.11-.15.28-.24.21s-.03,0,0,0Z"
                  fill="#746633"
                />
                <path
                  d="M1475.73,583.24c-11.53,1.18-22.93-1.07-34.43.43-.72.09-1.27-.94-.79-1.38c4.64-4.29,7.5-5.67,14.21-4.94s14.49,2.65,20.92,5.54c.14.06.25.34.1.35-.16.02-.03.03,0,0Z"
                  fill="#8e934b"
                />
                <path
                  d="M1449.22,501.78c2.74-2.55,4.7-5.81,6.26-9.09c1.84-3.85,4.03-7.71,5.79-11.35s2.71-6.9,4.15-10.51c1.43-3.6,3.36-6.88,4.81-10.49.14-.35-.44-.56-.78-.38-6.59,3.48-11.26,9.22-13.82,15.85-1.79,4.64-1.05,7.89-2.21,12.39s-3.38,8.88-4.61,13.43c-.06.23.26.29.42.15.16-.15.03,0,0,0Z"
                  fill="#bdbb7d"
                />
                <path
                  d="M1475.25,623.6c-17.65,9.34-32.31,22.9-50.81,30.67-.48.2-.81-.59-.43-.84c16.76-11.02,32.2-22.91,51.1-30.05.12-.05.25.16.14.22s-.02.01,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1399.57,479.86c10.91,9.88,14.72,20.73,15.18,35.25.04,1.11-1.16.6-1.52-.2-5.12-11.15-11.11-22.15-15.12-33.78-.38-1.09.53-2.11,1.46-1.27.08.07,0-.2,0,0Z"
                  fill="#ffead7"
                />
                <path
                  d="M1478.39,680.52c-7.09,1.48-14.63,2.84-21.27,5.45-6.11,2.4-11.58,5.21-17.53,7.55-11.91,4.68-23.43,9.79-35.66,13.45-.52.16-1.47-.41-.97-.93c21.33-22.28,45.72-24.83,75.34-25.7.12,0,.21.15.09.18-.11.02,0,.02,0,0Z"
                  fill="#ffead7"
                />
              </g>
              <path
                d="M1445.89,539.83c.64-.34,1.08-.93,1.7-1.3.6-.36,1.35-.6,2.04-.69c1.52-.22,3.2-.18,4.27,1.02.59.66.35,1.84-.33,2.33-1.12.81-2.44.53-3.74.47-.56-.03-1.13-.11-1.68-.25-.65-.17-1.31-.6-2-.6-.57,0-.78-.69-.26-.96v0Z"
                fill="#b9a672"
              />
              <path
                d="M1451.83,530.61c.16-.18.28-.44.4-.65.25-.41.52-.69.93-.95.72-.45,1.52-.85,2.39-.67.84.18,1.63,1.11,1.15,2.01-.45.85-1.13,1.29-2.03,1.58-.49.16-.89.21-1.39.15-.19-.02-.2,0-.35-.03-.07-.01-.52-.07-.33-.08-.67.02-1.31-.76-.77-1.36v0Z"
                fill="#b9a672"
              />
              <path
                d="M1468.25,531.47c.75-1.35,2.33-2.04,3.86-1.9c1.1.1,1.41,1.57.58,2.21-1.12.87-2.85,1.18-4.12.49-.26-.14-.5-.49-.33-.8v0Z"
                fill="#b9a672"
              />
              <path
                d="M1488.92,531.64c.41-.58,1.21-.84,1.87-.98.73-.16,1.44-.38,2.19-.34.41.02.81.36.95.73.04.09.06.2.08.3.08.4-.14.88-.47,1.11-.68.48-1.5.61-2.3.74-.7.11-1.66.06-2.2-.46-.32-.3-.39-.73-.13-1.1v0Z"
                fill="#b9a672"
              />
              <path
                d="M1479.59,525.88c.82-.79,1.8-1.35,2.96-1.29c1.35.07,1.45,2.01.32,2.49-.72.3-1.51.34-2.23.66-.49.22-1.09-.02-1.34-.47-.28-.51-.12-1.01.28-1.39v0Z"
                fill="#b9a672"
              />
              <path
                d="M1503.19,528.94c.45-1.03,2.11-1.57,3.08-1.92c1.09-.39,3.18-1.47,3.69.27.46,1.56-1.61,2.18-2.7,2.54-1.02.34-2.93.81-3.85,0-.25-.22-.37-.58-.23-.9v0Z"
                fill="#b9a672"
              />
              <path
                d="M1445.17,532.31c-.29.7-.82,1.4-1.26,2.02-.52.73-1.1,1.59-1.88,2.05-.58.34-1.27.42-1.83-.02-.5-.4-.74-1.17-.46-1.77.5-1.05,1.48-1.76,2.53-2.21.77-.33,1.85-.61,2.68-.47.18.03.3.21.22.39v0Z"
                fill="#b9a672"
              />
              <path
                d="M1444.69,547.65c-.86,0-1.73.09-2.59.08-.83-.02-1.66.02-2.35-.5-.39-.29-.35-.88.01-1.17c1.27-1,3.48-.35,4.92-.09.89.16,1.01,1.67,0,1.68v0Z"
                fill="#b9a672"
              />
              <path
                d="M1449.44,528.2c-.54.52-.67,1.14-.98,1.78-.4.84-1.08,1.29-1.86,1.74-.82.48-1.85.47-2.46-.35-.55-.73-.44-1.94.35-2.46.77-.51,1.53-1.03,2.48-1.06.77-.02,1.45.17,2.2-.11.3-.11.47.26.26.46v0Z"
                fill="#b9a672"
              />
              <path
                d="M1443.97,539.98c-1.28,1.36-2.68,2.11-4.35,2.93-1.58.78-3.06,1.91-4.87,1.09-.39-.18-.63-.58-.58-1c.23-2.05,2.14-2.76,3.82-3.45c1.83-.75,3.46-1.23,5.44-.88.56.1.99.83.54,1.31v0Z"
                fill="#b9a672"
              />
              <path
                d="M1435.38,539.12c-.17.37-.25.75-.44,1.11-.17.32-.41.62-.63.9-.49.63-.96,1.24-1.6,1.71-.85.64-2.25-.31-1.72-1.34.37-.72.87-1.28,1.41-1.88.24-.27.49-.54.77-.77.33-.28.69-.41,1.05-.65.6-.4,1.5.18,1.17.91v0Z"
                fill="#b9a672"
              />
              <path
                d="M1358.38,638.02c-1.67-.56-2.2-2.42-2.71-3.96-.41-1.25-1.25-3.81.66-4.32c1.82-.49,2.42,1.95,2.7,3.2.35,1.61.89,3.63-.31,4.99-.09.11-.22.13-.35.09v0Z"
                fill="#ffead7"
              />
              <path
                d="M1353.98,620.34c-.4.04-.63.17-.99-.11-.25-.19-.4-.46-.47-.76-.15-.65.13-1.39.86-1.46.38-.04.79.29.7.7-.03.15-.13.33-.12.48.01.18.17.39.23.56-.12-.09-.24-.18-.35-.27.05,0,.1.02.15.03.46.08.5.79,0,.84v0Z"
                fill="#ffead7"
              />
              <path
                d="M1348.89,611.16c-.42-.43-.64-.97-.79-1.55-.15-.56-.03-1.04.14-1.58.16-.51.77-.52,1.14-.29c1.03.62,1.48,1.72,1.43,2.91-.05,1.04-1.34,1.1-1.91.5v0Z"
                fill="#ffead7"
              />
            </g>
          </g>
          <g
            id="e0gYpSRcAlv2592"
            transform="matrix(.967284-.253696 0.253696 0.967284-168.750937 158.94265)"
          >
            <g>
              <path
                d="M1155.5,797.49c12.17,6.23,23.44,13.68,33.77,22.36h2.57c-.84-.11-1.59-.67-1.86-1.52-.17-.51-.14-1.03.04-1.49-1.15.32-2.38-.33-2.75-1.47-.39-1.19.27-2.45,1.44-2.84.63-.21,1.29-.11,1.82.19-.02-.54.15-1.07.48-1.48-.46.08-.91,0-1.3-.19-.2.69-.73,1.28-1.47,1.52-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84.58-.19,1.17-.13,1.67.11.19-.69.72-1.28,1.46-1.52.93-.3,1.91.03,2.49.77.26-.54.74-.97,1.35-1.17c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-.36.12-.74.13-1.09.07.37.27.66.65.81,1.12.09.29.13.57.1.86c1.1-.23,2.21.4,2.57,1.51.07.22.11.46.11.69.75.15,1.4.7,1.65,1.49.36,1.1-.17,2.27-1.19,2.73.19.15.36.33.48.54.27-.45.7-.83,1.25-1.01c1.06-.34,2.15.17,2.65,1.11h2.34c-.21-.65-.42-1.3-.63-1.95-15.77-48.08-33.3-95.52-60.69-138.4-19.83-31.02-42.3-62.55-45.15-100.45-.12-1.69,2.5-1.81,2.64-.11c2.83,35.88,23.7,66.11,42.6,95.5c18.67,29.02,33.51,59.41,45.51,91.75c5.07,13.65,9.86,27.42,14.52,41.23.02-1.62.1-3.19.2-4.74.79-12.02,3.27-24.12,1.37-36.02-2.35-14.75-11.29-28.01-12.44-42.89-1.24-15.82,6.21-33.14-1.81-46.83-1.55-2.65-3.63-5.01-4.61-7.91-1.16-3.41-.65-7.12-.41-10.69.11-1.8.16-3.61.12-5.42-1.34-1.67-2.69-3.33-4.03-4.95-6.07-7.32-81.64-77.92-82.7-75.53-28.36,64.1-38.82,142.63-1.2,201.77.37.58.75,1.17,1.12,1.74c19.29,5.76,38.32,12.38,56.22,21.54Zm-3.5-9.71c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84Zm-2.09-7.7c1.19-.39,2.45.27,2.84,1.44.38,1.18-.26,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.38-1.18.27-2.45,1.44-2.84Zm6.78-2.31c.34.26.61.63.75,1.08.38,1.18-.26,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84.74-.24,1.51-.08,2.08.36-.35-.27-.61-.64-.75-1.08-.14-.43-.14-.87-.04-1.28-.94-.01-1.8-.62-2.1-1.55-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.14.43.14.87.03,1.28.94.01,1.81.61,2.11,1.55.38,1.18-.27,2.45-1.44,2.84-.74.24-1.51.08-2.08-.36Zm14.17.17c-.24.56-.72,1.02-1.34,1.22-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84.93-.3,1.91.03,2.48.77.26-.55.74-1,1.36-1.2c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-.94.31-1.93-.05-2.49-.79Zm2.24,5.83c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84Zm-4.71-11.28c-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm.72,13.64c-1.18.38-2.45-.26-2.84-1.44-.14-.43-.14-.88-.03-1.29-.76-.15-1.43-.71-1.69-1.51-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.14.44.15.89.03,1.3.76.14,1.43.71,1.68,1.5.39,1.19-.26,2.45-1.44,2.84Zm-5.05-7.13c-1.18.38-2.45-.26-2.84-1.44-.33-1.03.12-2.13,1.03-2.65-.61-.24-1.12-.74-1.34-1.41-.29-.9.02-1.86.71-2.43-1.04.11-2.06-.5-2.39-1.54-.38-1.18.27-2.45,1.44-2.84.07-.02.14-.05.22-.06-.86-.07-1.66-.66-1.95-1.55-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84-.07.02-.15.05-.22.06.88.07,1.66.67,1.95,1.54.3.91-.01,1.86-.71,2.43c1.05-.12,2.06.51,2.39,1.54.34,1.04-.11,2.13-1.03,2.65.61.24,1.12.74,1.34,1.41.39,1.19-.26,2.45-1.44,2.84Zm-2.38-17.69c-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm-.54,23.99c-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84Zm-5.29-26.42c-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm-3.8,12.23c.05.99-.56,1.93-1.55,2.26-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84.36-.12.72-.14,1.08-.08-.05-.99.56-1.93,1.55-2.26c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84-.36.12-.72.14-1.08.08Zm-7.15,4.74c-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84-1.18.38-2.45-.26-2.84-1.44Zm1.45-7.35c.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44Zm-3.52-7.08c-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm.71,19.68c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm-3.16-2.82c-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84-1.19.39-2.45-.26-2.84-1.44Zm-2.52,3.1c1.18-.38,2.45.27,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.38-1.18.26-2.45,1.44-2.84Zm-4.19-7.91c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84Zm1.38-8.6c-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm-22.48,1.52c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84Zm-12.04-9.92c-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm5.27,16.51c-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84Zm7.06-16.36c.38,1.18-.26,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44Zm2.97-17.75c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm3.37,30.99c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm2.87-7.29c-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84-1.18.38-2.45-.26-2.84-1.44Zm-.64-14.75c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84Zm3.62-6.41c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm.56,32.67c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm5.88,7.05c.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44Zm-.37-14.47c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84Zm2.82-25.07c-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm.67,8.28c-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm1.62,9.15c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm4.09,9.18c.39,1.19-.27,2.45-1.44,2.84-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44Zm1.88-20.88c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm2.93,4.78c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm3.73-3.78c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm2.21,11.61c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm3.78-12.52c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm5.69,8.99c-1.19.39-2.45-.27-2.84-1.44-.21-.65-.11-1.34.21-1.89-.1.06-.2.1-.31.14-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.21.65.11,1.34-.21,1.89.1-.06.2-.1.31-.14c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84Zm5.05-1.25c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm1.87,7.34c-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84Zm1.7,5.39c-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84Zm3.54-.42c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm2.92-4.33c.31.26.55.6.68,1.01.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.37-1.13.21-2.35,1.31-2.78-.3-.26-.54-.61-.67-1.01-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.37,1.13-.22,2.35-1.32,2.78Zm4.46,5.18c-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm3.06,9.8c-.41.13-.82.15-1.2.05.19.21.33.47.43.76.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.09-.28-.12-.55-.11-.82-1.17.34-2.4-.31-2.77-1.47-.39-1.19.26-2.45,1.44-2.84c1.18-.38,2.45.26,2.84,1.44.09.27.12.55.1.82.39-.11.78-.12,1.15-.03-.19-.22-.33-.47-.42-.76-.31-.94.05-1.93.8-2.5-.93-.03-1.78-.63-2.08-1.56-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.31.95-.05,1.95-.8,2.51.94.01,1.79.61,2.09,1.55.39,1.19-.26,2.45-1.44,2.84Zm2.82,7.05c-1.18.38-2.45-.27-2.84-1.44-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Zm2.9,6.62c-.7.23-1.42.1-1.98-.29-.18.22-.4.41-.64.56.13.17.23.38.3.6.38,1.18-.26,2.45-1.44,2.84-1.18.38-2.45-.27-2.84-1.44-.05-.14-.08-.28-.09-.42-.24.22-.52.39-.84.5-1.18.38-2.45-.26-2.84-1.44-.25-.78-.05-1.62.46-2.19-.72-.18-1.34-.73-1.58-1.49-.38-1.18.27-2.45,1.44-2.84.04-.01.09-.03.13-.03-.14-.19-.26-.41-.34-.66-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84-.04.01-.09.03-.13.03.14.19.26.41.34.66.26.79.06,1.61-.45,2.18.71.19,1.33.74,1.57,1.49.05.14.08.28.09.43.13-.12.26-.23.41-.31-.13-.18-.23-.39-.31-.61-.38-1.18.26-2.45,1.44-2.84.7-.23,1.43-.09,1.98.3.27-.35.64-.62,1.08-.76c1.19-.39,2.45.27,2.84,1.44.39,1.19-.26,2.45-1.44,2.84Zm1.95,7.08c-1.19.39-2.45-.26-2.84-1.44-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.39,1.19-.27,2.45-1.44,2.84Zm-15.07-2.14c1.18-.38,2.45.27,2.84,1.44.2.61.12,1.25-.17,1.78.48.26.86.7,1.04,1.27.22.69.11,1.39-.26,1.94.47.26.85.71,1.03,1.26.03.11.06.21.08.31.15-.45.46-.85.88-1.13-.51-.27-.93-.73-1.13-1.31-.38-1.18.27-2.45,1.44-2.84.18-.06.37-.1.56-.1-.24-.24-.42-.54-.53-.88-.38-1.18.26-2.45,1.44-2.84c1.18-.38,2.45.27,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-.18.06-.36.09-.55.11.23.24.41.53.52.87.32.98-.07,2.03-.91,2.57.51.27.93.73,1.13,1.32.04.13.07.26.09.4.09-.86.67-1.63,1.54-1.91.16-.05.32-.08.48-.1-.51-.27-.92-.72-1.11-1.31-.38-1.18.27-2.45,1.44-2.84c1.19-.39,2.45.27,2.84,1.44.21.64.12,1.31-.2,1.84.16-.11.35-.2.54-.26c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84-.91.3-1.88-.03-2.45-.73-.07.86-.66,1.66-1.54,1.95-1.19.39-2.45-.27-2.84-1.44-.04-.13-.07-.26-.09-.4-.08.77-.56,1.48-1.31,1.82.5.26.92.71,1.11,1.31.38,1.18-.27,2.45-1.44,2.84s-2.45-.27-2.84-1.44c-.36-1.11.19-2.29,1.22-2.75-.51-.26-.93-.71-1.12-1.3-.03-.1-.05-.2-.07-.3-.23.63-.74,1.15-1.42,1.37-1.18.38-2.45-.27-2.84-1.44-.22-.68-.1-1.39.27-1.94-.49-.26-.86-.7-1.04-1.26-.2-.61-.12-1.25.17-1.77-.48-.26-.86-.7-1.04-1.28-.38-1.18.26-2.45,1.44-2.84Zm-14.13-4.83c1.18-.38,2.45.26,2.84,1.44.38,1.18-.27,2.45-1.44,2.84-1.19.39-2.45-.27-2.84-1.44-.39-1.19.26-2.45,1.44-2.84Zm-3.05-5.39c1.18-.38,2.45.26,2.84,1.44.02.05.03.11.04.15.28-.41.68-.73,1.19-.9.55-.18,1.1-.13,1.59.08.23-.63.74-1.15,1.43-1.38c1.18-.38,2.45.26,2.84,1.44.15.45.14.91.01,1.35.89.07,1.68.66,1.97,1.55.02.05.04.12.05.17.16-.77.71-1.43,1.51-1.69c1.18-.38,2.45.26,2.84,1.44.26.79.04,1.63-.48,2.2.62.23,1.12.72,1.34,1.4.39,1.19-.27,2.45-1.44,2.84-.61.2-1.25.12-1.78-.16.29,1.15-.35,2.31-1.48,2.68-1.18.38-2.45-.26-2.84-1.44-.38-1.18.27-2.45,1.44-2.84.61-.2,1.25-.12,1.78.17-.19-.74,0-1.51.51-2.05-.61-.24-1.12-.74-1.33-1.41-.02-.05-.03-.11-.04-.16-.17.76-.71,1.41-1.51,1.68-1.18.38-2.45-.26-2.84-1.44-.15-.45-.14-.91-.01-1.35-.26-.02-.5-.09-.74-.19-.22.63-.73,1.16-1.42,1.38-1.19.39-2.45-.27-2.84-1.44-.02-.05-.03-.11-.04-.16-.27.41-.68.74-1.18.91-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84Zm-2.76.97c-1.18.38-2.45-.27-2.84-1.44-.39-1.19.27-2.45,1.44-2.84c1.19-.39,2.45.26,2.84,1.44.38,1.18-.26,2.45-1.44,2.84Z"
                fill="#ffbe9f"
              />
              <path
                d="M1203.88,802.69c.79-12.02,3.27-24.12,1.37-36.02-2.35-14.75-11.29-28.01-12.44-42.89-1.24-15.82,6.21-33.14-1.81-46.83-1.55-2.65-3.63-5.01-4.61-7.91-1.16-3.41-.65-7.12-.41-10.69.11-1.8.16-3.61.12-5.42c5.89,7.35,11.72,15.18,17.4,23.43c14.6,21.1,28.36,44.89,40.28,70.26v0c1.72,17.02,2.91,34.09,3.56,51.18.29,7.33.44,14.73.02,22.05h-39.55c-1.37-4.14-2.73-8.29-4.13-12.42.02-1.62.1-3.19.2-4.74Z"
                fill="#f8c6b4"
              />
              <path
                d="M1161.96,753.55c-.39-1.19-1.66-1.83-2.84-1.44-.11.03-.21.08-.31.14.33-.56.43-1.24.21-1.89-.38-1.18-1.65-1.83-2.84-1.44-1.18.38-1.83,1.66-1.44,2.84.39,1.19,1.66,1.83,2.84,1.44.11-.03.21-.08.31-.14-.33.56-.43,1.24-.21,1.89.38,1.18,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1156.27,744.56c-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1150.28,745.47c-.39-1.19-1.66-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.66,1.83,2.84,1.44c1.18-.38,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1097.46,579.38c.19-1.29.6-2.84,1.85-3.19c1.73-.49,2.91,1.68,3.43,3.4c7.94,26.59,24.51,49.57,39.12,73.16s27.83,49.56,27.74,77.31c-15.13-30.68-34.41-59.31-57.15-84.86-5.36-6.02-10.97-11.96-14.75-19.08-3.77-7.11-5.53-15.25-5.11-23.28.21-3.95,1.73-5.97,2.79-9.38c1.35-4.33,1.42-9.57,2.08-14.07Z"
                fill="#f8c6b4"
              />
              <path
                d="M1143.62,744.47c-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1135.37,738.74c-.39-1.19-1.66-1.83-2.84-1.44-1.19.39-1.83,1.65-1.44,2.84.38,1.18,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1133.2,745.57c-1.19.39-1.83,1.66-1.44,2.84.39,1.19,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.65,1.44-2.84-.38-1.18-1.66-1.83-2.84-1.44Z"
                fill="#f8c6b4"
              />
              <path
                d="M1126.48,738.56c-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1124.26,749.25c-.38-1.18-1.65-1.83-2.84-1.44-1.18.38-1.83,1.66-1.44,2.84.39,1.19,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.65,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1117.27,736.02c-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84Z"
                fill="#f8c6b4"
              />
              <path
                d="M1109.29,614.74c1.4,4.6,3.08,9.11,4.9,13.49c2.53,6.09,5.15,12.42,8.96,17.83c2.32,3.29,5.04,6.24,7.75,9.19c1.33,2,2.7,3.97,4.18,5.9c1.43,2.23,2.86,4.45,4.29,6.67s2.86,4.42,4.28,6.63c18.67,29.02,33.51,59.41,45.51,91.75c5.07,13.65,9.86,27.42,14.52,41.23-.06,3.44.07,6.99.57,10.48-15.77-48.08-33.3-95.52-60.69-138.4-2.97-4.65-6.01-9.32-9.03-14.01-1.51-2.35-3.01-4.7-4.5-7.05-9.77-13.03-16.56-27.83-20.74-43.7Z"
                fill="#371c0e"
              />
              <path
                d="M1247.34,797.8c-.66-17.09-1.84-34.16-3.56-51.17c3.97,8.41,7.72,17,11.23,25.72c2,15.79,3.83,31.63,4.32,47.5h-11.97c.42-7.32.27-14.72-.02-22.05Z"
                fill="#ffe2d5"
              />
              <g>
                <path
                  d="M1235.77,748.81c-1.18.38-1.83,1.65-1.44,2.84s1.65,1.83,2.84,1.44c1.18-.38,1.83-1.65,1.44-2.84-.38-1.18-1.65-1.83-2.84-1.44Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1221.28,742.75c-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.65,1.44-2.84-.38-1.18-1.65-1.83-2.84-1.44Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1223.2,728.77c-1.18.38-1.83,1.65-1.44,2.84.38,1.18,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.65,1.44-2.84-.38-1.18-1.65-1.83-2.84-1.44Z"
                  fill="#ffe2d5"
                />
              </g>
              <g>
                <path
                  d="M1139.34,745.86c.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1112.99,737.41c.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1154.75,751.74c.39,1.19,1.66,1.83,2.84,1.44.11-.03.21-.08.31-.14.39-.19.7-.48.92-.81.33-.56.43-1.24.21-1.89-.38-1.18-1.65-1.83-2.84-1.44-1.18.38-1.83,1.66-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1131.76,748.41c.39,1.19,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.65,1.44-2.84-.38-1.18-1.66-1.83-2.84-1.44-1.19.39-1.83,1.66-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1122.2,739.96c.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1151.99,745.95c.38,1.18,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.66,1.44-2.84-.39-1.19-1.65-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1131.09,740.13c.38,1.18,1.65,1.83,2.84,1.44c1.18-.38,1.83-1.66,1.44-2.84-.39-1.19-1.66-1.83-2.84-1.44-1.19.39-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1146,746.86c.38,1.18,1.66,1.83,2.84,1.44c1.18-.38,1.83-1.66,1.44-2.84-.39-1.19-1.66-1.83-2.84-1.44-1.18.38-1.83,1.65-1.44,2.84Z"
                  fill="#ffe2d5"
                />
                <path
                  d="M1119.98,750.64c.39,1.19,1.66,1.83,2.84,1.44c1.19-.39,1.83-1.65,1.44-2.84-.38-1.18-1.65-1.83-2.84-1.44-1.18.38-1.83,1.66-1.44,2.84Z"
                  fill="#ffe2d5"
                />
              </g>
              <path
                d="M1203.88,802.69c.79-12.02,3.27-24.12,1.37-36.02-2.35-14.75-11.29-28.01-12.44-42.89-1.24-15.82,6.21-33.14-1.81-46.83-1.55-2.65-3.63-5.01-4.61-7.91-1.16-3.41-.65-7.12-.41-10.69.11-1.8.16-3.61.12-5.42c5.89,7.35,11.72,15.18,17.4,23.43-.61,25.48-5.37,52.6,6.37,75.21c3.08,5.93,7.29,11.52,8.31,18.13.7,4.46-.13,8.99-.95,13.42-2.41,12.97-4.42,24.58-5.09,36.73h-4.33c-1.37-4.14-2.73-8.29-4.13-12.42.02-1.62.1-3.19.2-4.74Z"
                fill="#fffcf4"
              />
              <path
                d="M1082.3,631.12c.7,28.6,22.62,48.69,46.23,61.65c3.34,1.87,6.69,3.69,9.99,5.48s6.54,3.57,9.64,5.37c3.18,2.52,5.92,5.47,7.72,8.73s2.66,6.83,2.1,10.56c-1.44,2.84-4.31,4.95-7.87,4.92-17.77-3.1-37.51-7.2-50.94-18.42-2.69-2.24-5.12-4.77-7.23-7.64-1.76-2.98-3.19-6.06-4.4-9.26-7.13-18.94-9.46-40.66-5.24-61.4v0Z"
                fill="#9c6f65"
              />
              <path
                d="M1182.74,671.85c17.42,26.11,4.37,27.82,5.49,52.72-3.3-11.35-4.9-39.62-5.49-52.72v0Z"
                fill="#9c6f65"
              />
              <path
                d="M1171.23,726.47c0,0-.07-.06-.02-.08s.07.06.02.08v0Z"
                fill="#371c0e"
              />
              <path
                d="M1170.54,725.67c-8.01-11.65-16.67-22.94-28.02-31.54-5.3-4.01-11.02-7.39-16.18-11.59-5.32-4.33-10.06-9.2-14.75-14.19-.1-.11.04-.28.16-.18c5.26,4.81,10.46,9.77,16.04,14.2c5.46,4.35,11.54,7.82,17.01,12.16c10.65,8.44,19.15,19.3,26.03,30.94.11.19-.16.37-.29.19v0Z"
                fill="#371c0e"
              />
              <path
                d="M1191.27,777.97c-1.5-15.38-4.25-30.02-8.54-44.87-.06-.2.22-.29.3-.1c5.77,13.98,8.8,29.83,8.48,44.96c0,.15-.22.16-.24.01v0Z"
                fill="#371c0e"
              />
            </g>
          </g>
        </g>
        <mask
          id="e0gYpSRcAlv2628"
          mask-type="luminance"
          x="-150%"
          y="-150%"
          height="400%"
          width="400%"
        >
          <rect
            width="1920"
            height="1080"
            rx="0"
            ry="0"
            transform="matrix(1.128935 0 0 1-122.864659 0)"
            fill="#fff"
            stroke-width="0"
          />
        </mask>
      </g>
      <g transform="translate(322.763528 220.583869)">
        <g>
          <path
            d="M22.56,64.49h.38c3.57-7.52,12.6-14.85,26.51-14.85c24.25,0,32.9,17.11,32.9,35.54v56.97h-22.56v-45.69c0-9.96-.75-26.51-16.55-26.51-14.85,0-20.68,10.91-20.68,22.94v49.26h-22.56L0,0h22.56v64.49Z"
            fill="#231003"
          />
          <path
            d="M125.97,104.91c1.5,13.35,11.66,21.43,24.25,21.43c11.28,0,18.61-5.26,24.25-12.22l16.17,12.22c-10.53,12.97-23.88,18.05-38.17,18.05-27.26,0-49.07-18.99-49.07-47.38s21.81-47.38,49.07-47.38c25.19,0,42.3,17.67,42.3,49.07v6.2h-68.8Zm46.25-16.92c-.19-13.16-8.84-21.43-22.94-21.43-13.35,0-21.62,8.46-23.31,21.43h46.25Z"
            fill="#231003"
          />
          <path d="M216.22,0h22.56v142.14h-22.56v-142.14Z" fill="#231003" />
          <path d="M265.11,0h22.56v142.14h-22.56v-142.14Z" fill="#231003" />
          <path
            d="M358.18,49.64c27.26,0,49.07,18.99,49.07,47.38s-21.81,47.38-49.07,47.38-49.07-18.99-49.07-47.38s21.81-47.38,49.07-47.38Zm0,74.46c16.55,0,26.51-12.97,26.51-27.07s-9.96-27.07-26.51-27.07-26.51,12.97-26.51,27.07s9.97,27.07,26.51,27.07Z"
            fill="#231003"
          />
          <path
            d="M443.35,114.32c8.08,0,15.04,6.2,15.04,14.29s-6.77,14.67-15.04,14.67-15.04-6.2-15.04-14.29s6.77-14.67,15.04-14.67Z"
            fill="#231003"
          />
        </g>
        <g>
          <path d="M0.38,170.35h22.56v142.14h-22.56v-142.14Z" fill="#231003" />
          <path
            d="M66.93,275.26c1.5,13.35,11.66,21.43,24.25,21.43c11.28,0,18.61-5.26,24.25-12.22l16.17,12.22c-10.53,12.97-23.88,18.05-38.17,18.05-27.26,0-49.07-18.99-49.07-47.38s21.81-47.38,49.07-47.38c25.19,0,42.3,17.67,42.3,49.07v6.21h-68.8Zm46.25-16.92c-.19-13.16-8.84-21.43-22.94-21.43-13.35,0-21.62,8.46-23.31,21.43h46.25Z"
            fill="#231003"
          />
          <path
            d="M146.28,241.42v-19.18h18.61v-26.13h22.56v26.13h24.82v19.18h-24.82v39.48c0,9.02,2.63,14.67,12.6,14.67c3.95,0,9.4-.75,12.22-2.82v18.99c-4.7,2.26-12.6,3.01-17.86,3.01-23.88,0-29.52-10.72-29.52-31.96v-41.36h-18.61Z"
            fill="#231003"
          />
          <path
            d="M240.1,179.37h22.94l-15.98,49.64h-20.12l13.16-49.64Z"
            fill="#231003"
          />
          <path
            d="M333.73,247.25c-4.32-6.02-9.96-9.21-17.67-9.21-6.02,0-13.16,2.82-13.16,9.59c0,16.17,48.7,3.01,48.7,38.17c0,21.43-20.49,28.95-38.92,28.95-13.91,0-25.95-3.57-35.16-13.91l15.04-14.1c5.83,6.39,11.84,11.09,21.43,11.09c6.58,0,15.04-3.2,15.04-10.34c0-18.61-48.7-3.95-48.7-38.36c0-20.12,18.05-29.14,36.29-29.14c12.03,0,24.82,3.76,32.15,13.72l-15.04,13.54Z"
            fill="#231003"
          />
          <path
            d="M423.79,222.24h21.43v14.1h.38c3.95-8.46,12.6-16.36,27.64-16.36c13.91,0,23.5,5.45,28.2,16.73c6.58-11.47,16.17-16.73,29.71-16.73c24.07,0,32.53,17.11,32.53,38.73v53.77h-22.56v-51.14c0-11.28-3.38-21.06-16.73-21.06-14.1,0-19.37,11.66-19.37,23.31v48.88h-22.56v-53.77c0-11.09-4.51-18.43-15.42-18.43-14.85,0-20.68,10.91-20.68,22.94v49.26h-22.56v-90.25Z"
            fill="#231003"
          />
          <path
            d="M632.87,219.98c27.26,0,49.07,18.99,49.07,47.38s-21.81,47.38-49.07,47.38-49.07-18.99-49.07-47.38s21.81-47.38,49.07-47.38Zm0,74.46c16.55,0,26.51-12.97,26.51-27.07s-9.96-27.08-26.51-27.08-26.51,12.97-26.51,27.08s9.96,27.07,26.51,27.07Z"
            fill="#231003"
          />
          <path
            d="M690.78,222.24h24.63l24.07,63.17h.38l24.25-63.17h23.13L751.7,312.49h-24.07l-36.85-90.25Z"
            fill="#231003"
          />
          <path
            d="M818.63,275.26c1.5,13.35,11.66,21.43,24.25,21.43c11.28,0,18.61-5.26,24.25-12.22l16.17,12.22c-10.53,12.97-23.88,18.05-38.17,18.05-27.26,0-49.07-18.99-49.07-47.38s21.81-47.38,49.07-47.38c25.19,0,42.3,17.67,42.3,49.07v6.21h-68.82Zm46.25-16.92c-.19-13.16-8.84-21.43-22.94-21.43-13.35,0-21.62,8.46-23.31,21.43h46.25Z"
            fill="#231003"
          />
          <path
            d="M923.55,284.66c8.08,0,15.04,6.21,15.04,14.29s-6.77,14.67-15.04,14.67-15.04-6.2-15.04-14.29s6.77-14.67,15.04-14.67Z"
            fill="#231003"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  setup() {},
  mounted() {
    !(function (t, e) {
      "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof __SVGATOR_DEFINE__ && __SVGATOR_DEFINE__.amd
        ? __SVGATOR_DEFINE__(e)
        : (((t =
            "undefined" != typeof globalThis
              ? globalThis
              : t || self).__SVGATOR_PLAYER__ = t.__SVGATOR_PLAYER__ || {}),
          (t.__SVGATOR_PLAYER__["91c80d77"] = e()));
    })(this, function () {
      "use strict";
      function t(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function e(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2
            ? t(Object(r), !0).forEach(function (t) {
                u(e, t, r[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
            : t(Object(r)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(r, t)
                );
              });
        }
        return e;
      }
      function n(t) {
        return (n =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function r(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r);
        }
      }
      function o(t, e, n) {
        return e && i(t.prototype, e), n && i(t, n), t;
      }
      function u(t, e, n) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = n),
          t
        );
      }
      function a(t) {
        return (a = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function s(t, e) {
        return (s =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          })(t, e);
      }
      function l() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      }
      function f(t, e, n) {
        return (f = l()
          ? Reflect.construct
          : function (t, e, n) {
              var r = [null];
              r.push.apply(r, e);
              var i = new (Function.bind.apply(t, r))();
              return n && s(i, n.prototype), i;
            }).apply(null, arguments);
      }
      function c(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return (function (t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        })(t);
      }
      function h(t, e, n) {
        return (h =
          "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (t, e, n) {
                var r = (function (t, e) {
                  for (
                    ;
                    !Object.prototype.hasOwnProperty.call(t, e) &&
                    null !== (t = a(t));

                  );
                  return t;
                })(t, e);
                if (r) {
                  var i = Object.getOwnPropertyDescriptor(r, e);
                  return i.get ? i.get.call(n) : i.value;
                }
              })(t, e, n || t);
      }
      function v(t) {
        return (
          (function (t) {
            if (Array.isArray(t)) return y(t);
          })(t) ||
          (function (t) {
            if (
              ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
              null != t["@@iterator"]
            )
              return Array.from(t);
          })(t) ||
          (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return y(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if (
              "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return y(t, e);
          })(t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function y(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      Number.isInteger ||
        (Number.isInteger = function (t) {
          return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
        }),
        Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
      var d = g(Math.pow(10, -6));
      function g(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        if (Number.isInteger(t)) return t;
        var n = Math.pow(10, e);
        return Math.round((+t + Number.EPSILON) * n) / n;
      }
      function p(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : d;
        return Math.abs(t - e) < n;
      }
      var m = Math.PI / 180;
      function b(t) {
        return t;
      }
      function w(t, e, n) {
        var r = 1 - n;
        return 3 * n * r * (t * r + e * n) + n * n * n;
      }
      function k() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          r =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        return t < 0 || t > 1 || n < 0 || n > 1
          ? null
          : p(t, e) && p(n, r)
          ? b
          : function (i) {
              if (i <= 0)
                return t > 0 ? (i * e) / t : 0 === e && n > 0 ? (i * r) / n : 0;
              if (i >= 1)
                return n < 1
                  ? 1 + ((i - 1) * (r - 1)) / (n - 1)
                  : 1 === n && t < 1
                  ? 1 + ((i - 1) * (e - 1)) / (t - 1)
                  : 1;
              for (var o, u = 0, a = 1; u < a; ) {
                var s = w(t, n, (o = (u + a) / 2));
                if (p(i, s)) break;
                s < i ? (u = o) : (a = o);
              }
              return w(e, r, o);
            };
      }
      function _() {
        return 1;
      }
      function A(t) {
        return 1 === t ? 1 : 0;
      }
      function x() {
        var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
          e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (1 === t) {
          if (0 === e) return A;
          if (1 === e) return _;
        }
        var n = 1 / t;
        return function (t) {
          return t >= 1 ? 1 : (t += e * n) - (t % n);
        };
      }
      var O = Math.sin,
        S = Math.cos,
        E = Math.acos,
        P = Math.asin,
        j = Math.tan,
        M = Math.atan2,
        B = Math.PI / 180,
        T = 180 / Math.PI,
        I = Math.sqrt,
        R = (function () {
          function t() {
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 1,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0,
              i =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : 0,
              o =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : 1,
              u =
                arguments.length > 4 && void 0 !== arguments[4]
                  ? arguments[4]
                  : 0,
              a =
                arguments.length > 5 && void 0 !== arguments[5]
                  ? arguments[5]
                  : 0;
            r(this, t),
              (this.m = [e, n, i, o, u, a]),
              (this.i = null),
              (this.w = null),
              (this.s = null);
          }
          return (
            o(
              t,
              [
                {
                  key: "determinant",
                  get: function () {
                    var t = this.m;
                    return t[0] * t[3] - t[1] * t[2];
                  },
                },
                {
                  key: "isIdentity",
                  get: function () {
                    if (null === this.i) {
                      var t = this.m;
                      this.i =
                        1 === t[0] &&
                        0 === t[1] &&
                        0 === t[2] &&
                        1 === t[3] &&
                        0 === t[4] &&
                        0 === t[5];
                    }
                    return this.i;
                  },
                },
                {
                  key: "point",
                  value: function (t, e) {
                    var n = this.m;
                    return {
                      x: n[0] * t + n[2] * e + n[4],
                      y: n[1] * t + n[3] * e + n[5],
                    };
                  },
                },
                {
                  key: "translateSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0;
                    if (!t && !e) return this;
                    var n = this.m;
                    return (
                      (n[4] += n[0] * t + n[2] * e),
                      (n[5] += n[1] * t + n[3] * e),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "rotateSelf",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 0;
                    if ((t %= 360)) {
                      var e = O((t *= B)),
                        n = S(t),
                        r = this.m,
                        i = r[0],
                        o = r[1];
                      (r[0] = i * n + r[2] * e),
                        (r[1] = o * n + r[3] * e),
                        (r[2] = r[2] * n - i * e),
                        (r[3] = r[3] * n - o * e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "scaleSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 1;
                    if (1 !== t || 1 !== e) {
                      var n = this.m;
                      (n[0] *= t),
                        (n[1] *= t),
                        (n[2] *= e),
                        (n[3] *= e),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "skewSelf",
                  value: function (t, e) {
                    if (((e %= 360), (t %= 360) || e)) {
                      var n = this.m,
                        r = n[0],
                        i = n[1],
                        o = n[2],
                        u = n[3];
                      t && ((t = j(t * B)), (n[2] += r * t), (n[3] += i * t)),
                        e && ((e = j(e * B)), (n[0] += o * e), (n[1] += u * e)),
                        (this.w = this.s = this.i = null);
                    }
                    return this;
                  },
                },
                {
                  key: "resetSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : 0,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : 1,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : 0,
                      o =
                        arguments.length > 5 && void 0 !== arguments[5]
                          ? arguments[5]
                          : 0,
                      u = this.m;
                    return (
                      (u[0] = t),
                      (u[1] = e),
                      (u[2] = n),
                      (u[3] = r),
                      (u[4] = i),
                      (u[5] = o),
                      (this.w = this.s = this.i = null),
                      this
                    );
                  },
                },
                {
                  key: "recomposeSelf",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : null,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : null,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : null,
                      r =
                        arguments.length > 3 && void 0 !== arguments[3]
                          ? arguments[3]
                          : null,
                      i =
                        arguments.length > 4 && void 0 !== arguments[4]
                          ? arguments[4]
                          : null;
                    return (
                      this.isIdentity || this.resetSelf(),
                      t && (t.x || t.y) && this.translateSelf(t.x, t.y),
                      e && this.rotateSelf(e),
                      n &&
                        (n.x && this.skewSelf(n.x, 0),
                        n.y && this.skewSelf(0, n.y)),
                      !r ||
                        (1 === r.x && 1 === r.y) ||
                        this.scaleSelf(r.x, r.y),
                      i && (i.x || i.y) && this.translateSelf(i.x, i.y),
                      this
                    );
                  },
                },
                {
                  key: "decompose",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 0,
                      n = this.m,
                      r = n[0] * n[0] + n[1] * n[1],
                      i = [
                        [n[0], n[1]],
                        [n[2], n[3]],
                      ],
                      o = I(r);
                    if (0 === o)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: 0, y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[0][0] /= o), (i[0][1] /= o);
                    var u = n[0] * n[3] - n[1] * n[2] < 0;
                    u && (o = -o);
                    var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                    (i[1][0] -= i[0][0] * a), (i[1][1] -= i[0][1] * a);
                    var s = I(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                    if (0 === s)
                      return {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: 0 },
                        skew: { x: 0, y: 0 },
                        rotate: 0,
                      };
                    (i[1][0] /= s), (i[1][1] /= s), (a /= s);
                    var l = 0;
                    return (
                      i[1][1] < 0
                        ? ((l = E(i[1][1]) * T), i[0][1] < 0 && (l = 360 - l))
                        : (l = P(i[0][1]) * T),
                      u && (l = -l),
                      (a = M(a, I(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * T),
                      u && (a = -a),
                      {
                        origin: { x: g(n[4]), y: g(n[5]) },
                        translate: { x: g(t), y: g(e) },
                        scale: { x: g(o), y: g(s) },
                        skew: { x: g(a), y: 0 },
                        rotate: g(l),
                      }
                    );
                  },
                },
                {
                  key: "clone",
                  value: function () {
                    var t = this.m;
                    return new this.constructor(
                      t[0],
                      t[1],
                      t[2],
                      t[3],
                      t[4],
                      t[5]
                    );
                  },
                },
                {
                  key: "toString",
                  value: function () {
                    var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : " ";
                    if (null === this.s) {
                      var e = this.m.map(function (t) {
                        return g(t);
                      });
                      1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]
                        ? (this.s = "translate(" + e[4] + t + e[5] + ")")
                        : (this.s = "matrix(" + e.join(t) + ")");
                    }
                    return this.s;
                  },
                },
              ],
              [
                {
                  key: "create",
                  value: function (t) {
                    return t
                      ? Array.isArray(t)
                        ? f(this, v(t))
                        : t instanceof this
                        ? t.clone()
                        : new this().recomposeSelf(
                            t.origin,
                            t.rotate,
                            t.skew,
                            t.scale,
                            t.translate
                          )
                      : new this();
                  },
                },
              ]
            ),
            t
          );
        })();
      function N(t, e, n) {
        return t >= 0.5 ? n : e;
      }
      function F(t, e, n) {
        return 0 === t || e === n ? e : t * (n - e) + e;
      }
      function C(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r;
      }
      function D(t, e, n) {
        var r = F(t, e, n);
        return r <= 0 ? 0 : r >= 1 ? 1 : r;
      }
      function L(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: F(t, e.x, n.x), y: F(t, e.y, n.y) };
      }
      function V(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : { x: C(t, e.x, n.x), y: C(t, e.y, n.y) };
      }
      function q(t, e, n) {
        var r = (function (t, e, n) {
          return Math.round(F(t, e, n));
        })(t, e, n);
        return r <= 0 ? 0 : r >= 255 ? 255 : r;
      }
      function G(t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : {
              r: q(t, e.r, n.r),
              g: q(t, e.g, n.g),
              b: q(t, e.b, n.b),
              a: F(t, null == e.a ? 1 : e.a, null == n.a ? 1 : n.a),
            };
      }
      function z(t, e, n) {
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i = new Array(r), o = 0; o < r; o++) i[o] = F(t, e[o], n[o]);
        return i;
      }
      function Y(t, e) {
        for (var n = [], r = 0; r < t; r++) n.push(e);
        return n;
      }
      function U(t, e) {
        if (--e <= 0) return t;
        var n = (t = Object.assign([], t)).length;
        do {
          for (var r = 0; r < n; r++) t.push(t[r]);
        } while (--e > 0);
        return t;
      }
      var W,
        $ = (function () {
          function t(e) {
            r(this, t), (this.list = e), (this.length = e.length);
          }
          return (
            o(t, [
              {
                key: "setAttribute",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].setAttribute(t, e);
                },
              },
              {
                key: "removeAttribute",
                value: function (t) {
                  for (var e = this.list, n = 0; n < this.length; n++)
                    e[n].removeAttribute(t);
                },
              },
              {
                key: "style",
                value: function (t, e) {
                  for (var n = this.list, r = 0; r < this.length; r++)
                    n[r].style[t] = e;
                },
              },
            ]),
            t
          );
        })(),
        H = /-./g,
        Q = function (t, e) {
          return e.toUpperCase();
        };
      function X(t) {
        return "function" == typeof t ? t : N;
      }
      function J(t) {
        return t
          ? "function" == typeof t
            ? t
            : Array.isArray(t)
            ? (function (t) {
                var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : b;
                if (!Array.isArray(t)) return e;
                switch (t.length) {
                  case 1:
                    return x(t[0]) || e;
                  case 2:
                    return x(t[0], t[1]) || e;
                  case 4:
                    return k(t[0], t[1], t[2], t[3]) || e;
                }
                return e;
              })(t, null)
            : (function (t, e) {
                var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : b;
                switch (t) {
                  case "linear":
                    return b;
                  case "steps":
                    return x(e.steps || 1, e.jump || 0) || n;
                  case "bezier":
                  case "cubic-bezier":
                    return k(e.x1 || 0, e.y1 || 0, e.x2 || 0, e.y2 || 0) || n;
                }
                return n;
              })(t.type, t.value, null)
          : null;
      }
      function K(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = e.length - 1;
        if (t <= e[0].t) return r ? [0, 0, e[0].v] : e[0].v;
        if (t >= e[i].t) return r ? [i, 1, e[i].v] : e[i].v;
        var o,
          u = e[0],
          a = null;
        for (o = 1; o <= i; o++) {
          if (!(t > e[o].t)) {
            a = e[o];
            break;
          }
          u = e[o];
        }
        return null == a
          ? r
            ? [i, 1, e[i].v]
            : e[i].v
          : u.t === a.t
          ? r
            ? [o, 1, a.v]
            : a.v
          : ((t = (t - u.t) / (a.t - u.t)),
            u.e && (t = u.e(t)),
            r ? [o, t, n(t, u.v, a.v)] : n(t, u.v, a.v));
      }
      function Z(t, e) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return t && t.length
          ? "function" != typeof e
            ? null
            : ("function" != typeof n && (n = null),
              function (r) {
                var i = K(r, t, e);
                return null != i && n && (i = n(i)), i;
              })
          : null;
      }
      function tt(t, e) {
        return t.t - e.t;
      }
      function et(t, e, r, i, o) {
        var u,
          a = "@" === r[0],
          s = "#" === r[0],
          l = W[r],
          f = N;
        switch (
          (a
            ? ((u = r.substr(1)), (r = u.replace(H, Q)))
            : s && (r = r.substr(1)),
          n(l))
        ) {
          case "function":
            if (((f = l(i, o, K, J, r, a, e, t)), s)) return f;
            break;
          case "string":
            f = Z(i, X(l));
            break;
          case "object":
            if ((f = Z(i, X(l.i), l.f)) && "function" == typeof l.u)
              return l.u(e, f, r, a, t);
        }
        return f
          ? (function (t, e, n) {
              if (
                arguments.length > 3 &&
                void 0 !== arguments[3] &&
                arguments[3]
              )
                return t instanceof $
                  ? function (r) {
                      return t.style(e, n(r));
                    }
                  : function (r) {
                      return (t.style[e] = n(r));
                    };
              if (Array.isArray(e)) {
                var r = e.length;
                return function (i) {
                  var o = n(i);
                  if (null == o)
                    for (var u = 0; u < r; u++) t[u].removeAttribute(e);
                  else for (var a = 0; a < r; a++) t[a].setAttribute(e, o);
                };
              }
              return function (r) {
                var i = n(r);
                null == i ? t.removeAttribute(e) : t.setAttribute(e, i);
              };
            })(e, r, f, a)
          : null;
      }
      function nt(t, e, r, i) {
        if (!i || "object" !== n(i)) return null;
        var o = null,
          u = null;
        return (
          Array.isArray(i)
            ? (u = (function (t) {
                if (!t || !t.length) return null;
                for (var e = 0; e < t.length; e++)
                  t[e].e && (t[e].e = J(t[e].e));
                return t.sort(tt);
              })(i))
            : ((u = i.keys), (o = i.data || null)),
          u ? et(t, e, r, u, o) : null
        );
      }
      function rt(t, e, n) {
        if (!n) return null;
        var r = [];
        for (var i in n)
          if (n.hasOwnProperty(i)) {
            var o = nt(t, e, i, n[i]);
            o && r.push(o);
          }
        return r.length ? r : null;
      }
      function it(t, e) {
        if (!e.settings.duration || e.settings.duration < 0) return null;
        var n,
          r,
          i,
          o,
          u,
          a = (function (t, e) {
            if (!e) return null;
            var n = [];
            if (Array.isArray(e))
              for (var r = e.length, i = 0; i < r; i++) {
                var o = e[i];
                if (2 === o.length) {
                  var u = null;
                  if ("string" == typeof o[0]) u = t.getElementById(o[0]);
                  else if (Array.isArray(o[0])) {
                    u = [];
                    for (var a = 0; a < o[0].length; a++)
                      if ("string" == typeof o[0][a]) {
                        var s = t.getElementById(o[0][a]);
                        s && u.push(s);
                      }
                    u = u.length ? (1 === u.length ? u[0] : new $(u)) : null;
                  }
                  if (u) {
                    var l = rt(t, u, o[1]);
                    l && (n = n.concat(l));
                  }
                }
              }
            else
              for (var f in e)
                if (e.hasOwnProperty(f)) {
                  var c = t.getElementById(f);
                  if (c) {
                    var h = rt(t, c, e[f]);
                    h && (n = n.concat(h));
                  }
                }
            return n.length ? n : null;
          })(t, e.elements);
        return a
          ? ((n = a),
            (r = e.settings),
            (i = r.duration),
            (o = n.length),
            (u = null),
            function (t, e) {
              var a = r.iterations || 1 / 0,
                s = (r.alternate && a % 2 == 0) ^ (r.direction > 0) ? i : 0,
                l = t % i,
                f = 1 + (t - l) / i;
              (e *= r.direction), r.alternate && f % 2 == 0 && (e = -e);
              var c = !1;
              if (f > a)
                (l = s),
                  (c = !0),
                  -1 === r.fill && (l = r.direction > 0 ? 0 : i);
              else if ((e < 0 && (l = i - l), l === u)) return !1;
              u = l;
              for (var h = 0; h < o; h++) n[h](l);
              return c;
            })
          : null;
      }
      function ot(t, e) {
        if (((W = e), !t || !t.root || !Array.isArray(t.animations)))
          return null;
        var n = (function (t) {
          for (
            var e = document.getElementsByTagName("svg"), n = 0;
            n < e.length;
            n++
          )
            if (e[n].id === t.root && !e[n].svgatorAnimation)
              return (e[n].svgatorAnimation = !0), e[n];
          return null;
        })(t);
        if (!n) return null;
        var r = t.animations
          .map(function (t) {
            return it(n, t);
          })
          .filter(function (t) {
            return !!t;
          });
        return r.length
          ? {
              svg: n,
              animations: r,
              animationSettings: t.animationSettings,
              options: t.options || void 0,
            }
          : null;
      }
      function ut(t) {
        return +("0x" + (t.replace(/[^0-9a-fA-F]+/g, "") || 27));
      }
      function at(t, e, n) {
        return !t || !n || e > t.length
          ? t
          : t.substring(0, e) + at(t.substring(e + 1), n, n);
      }
      function st(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
        return !t || t % e ? t % e : st(t / e, e);
      }
      function lt(t, e, n) {
        if (t && t.length) {
          var r = ut(n),
            i = ut(e),
            o = st(r) + 5,
            u = at(t, st(r, 5), o);
          return (
            (u = u.replace(/\x7c$/g, "==").replace(/\x2f$/g, "=")),
            (u = (function (t, e, n) {
              var r = +("0x" + t.substring(0, 4));
              t = t.substring(4);
              for (
                var i = (e % r) + (n % 27), o = [], u = 0;
                u < t.length;
                u += 2
              )
                if ("|" !== t[u]) {
                  var a = +("0x" + t[u] + t[u + 1]) - i;
                  o.push(a);
                } else {
                  var s = +("0x" + t.substring(u + 1, u + 1 + 4)) - i;
                  (u += 3), o.push(s);
                }
              return String.fromCharCode.apply(String, o);
            })((u = (u = atob(u)).replace(/[\x41-\x5A]/g, "")), i, r)),
            (u = JSON.parse(u))
          );
        }
      }
      var ft = [
          { key: "alternate", def: !1 },
          { key: "fill", def: 1 },
          { key: "iterations", def: 0 },
          { key: "direction", def: 1 },
          { key: "speed", def: 1 },
          { key: "fps", def: 100 },
        ],
        ct = (function () {
          function t(e, n) {
            var i = this,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            r(this, t),
              (this._id = 0),
              (this._running = !1),
              (this._rollingBack = !1),
              (this._animations = e),
              (this._settings = n),
              (!o || o < "2022-05-02") && delete this._settings.speed,
              ft.forEach(function (t) {
                i._settings[t.key] = i._settings[t.key] || t.def;
              }),
              (this.duration = n.duration),
              (this.offset = n.offset || 0),
              (this.rollbackStartOffset = 0);
          }
          return (
            o(
              t,
              [
                {
                  key: "alternate",
                  get: function () {
                    return this._settings.alternate;
                  },
                },
                {
                  key: "fill",
                  get: function () {
                    return this._settings.fill;
                  },
                },
                {
                  key: "iterations",
                  get: function () {
                    return this._settings.iterations;
                  },
                },
                {
                  key: "direction",
                  get: function () {
                    return this._settings.direction;
                  },
                },
                {
                  key: "speed",
                  get: function () {
                    return this._settings.speed;
                  },
                },
                {
                  key: "fps",
                  get: function () {
                    return this._settings.fps;
                  },
                },
                {
                  key: "maxFiniteDuration",
                  get: function () {
                    return this.iterations > 0
                      ? this.iterations * this.duration
                      : this.duration;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    for (
                      var e =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : {},
                        n = this._animations,
                        r = n.length,
                        i = 0,
                        o = 0;
                      o < r;
                      o++
                    )
                      e[o] ? i++ : ((e[o] = n[o](t, 1)), e[o] && i++);
                    return i;
                  },
                },
                {
                  key: "_rollback",
                  value: function (t) {
                    var e = this,
                      n = 1 / 0,
                      r = null;
                    (this.rollbackStartOffset = t),
                      (this._rollingBack = !0),
                      (this._running = !0);
                    this._id = window.requestAnimationFrame(function i(o) {
                      if (e._rollingBack) {
                        null == r && (r = o);
                        var u = Math.round(t - (o - r) * e.speed);
                        if (u > e.duration && n !== 1 / 0) {
                          var a = !!e.alternate && (u / e.duration) % 2 > 1,
                            s = u % e.duration;
                          u = (s += a ? e.duration : 0) || e.duration;
                        }
                        var l = (e.fps ? 1e3 / e.fps : 0) * e.speed,
                          f = Math.max(0, u);
                        f <= n - l && ((e.offset = f), (n = f), e._apply(f));
                        var c =
                          e.iterations > 0 &&
                          -1 === e.fill &&
                          u >= e.maxFiniteDuration;
                        (u <= 0 || e.offset < u || c) && e.stop(),
                          (e._id = window.requestAnimationFrame(i));
                      }
                    });
                  },
                },
                {
                  key: "_start",
                  value: function () {
                    var t = this,
                      e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 0,
                      n = -1 / 0,
                      r = null,
                      i = {};
                    this._running = !0;
                    var o = function o(u) {
                      null == r && (r = u);
                      var a = Math.round((u - r) * t.speed + e),
                        s = (t.fps ? 1e3 / t.fps : 0) * t.speed;
                      if (
                        a >= n + s &&
                        !t._rollingBack &&
                        ((t.offset = a),
                        (n = a),
                        t._apply(a, i) === t._animations.length)
                      )
                        return void t.pause(!0);
                      t._id = window.requestAnimationFrame(o);
                    };
                    this._id = window.requestAnimationFrame(o);
                  },
                },
                {
                  key: "_pause",
                  value: function () {
                    this._id && window.cancelAnimationFrame(this._id),
                      (this._running = !1);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    if (!this._running)
                      return this._rollingBack
                        ? this._rollback(this.offset)
                        : this._start(this.offset);
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    this._pause(),
                      (this.offset = 0),
                      (this.rollbackStartOffset = 0),
                      (this._rollingBack = !1),
                      this._apply(0);
                  },
                },
                {
                  key: "reachedToEnd",
                  value: function () {
                    return (
                      this.iterations > 0 &&
                      this.offset >= this.iterations * this.duration
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    this.stop(t), this.play(t);
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    this._pause();
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    this.direction = -this.direction;
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t, e) {
                    delete t.animationSettings,
                      (t.options = lt(t.options, t.root, "91c80d77")),
                      t.animations.map(function (e) {
                        (e.settings = lt(e.s, t.root, "91c80d77")),
                          delete e.s,
                          t.animationSettings ||
                            (t.animationSettings = e.settings);
                      });
                    var n = t.version;
                    if (!(t = ot(t, e))) return null;
                    var r = t.options || {},
                      i = new this(t.animations, t.animationSettings, n);
                    return { el: t.svg, options: r, player: i };
                  },
                },
                {
                  key: "push",
                  value: function (t) {
                    return this.build(t);
                  },
                },
                {
                  key: "init",
                  value: function () {
                    var t = this,
                      e =
                        window.__SVGATOR_PLAYER__ &&
                        window.__SVGATOR_PLAYER__["91c80d77"];
                    Array.isArray(e) &&
                      e.splice(0).forEach(function (e) {
                        return t.build(e);
                      });
                  },
                },
              ]
            ),
            t
          );
        })();
      !(function () {
        for (
          var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0;
          n < e.length && !window.requestAnimationFrame;
          ++n
        )
          (window.requestAnimationFrame =
            window[e[n] + "RequestAnimationFrame"]),
            (window.cancelAnimationFrame =
              window[e[n] + "CancelAnimationFrame"] ||
              window[e[n] + "CancelRequestAnimationFrame"]);
        window.requestAnimationFrame ||
          ((window.requestAnimationFrame = function (e) {
            var n = Date.now(),
              r = Math.max(0, 16 - (n - t)),
              i = window.setTimeout(function () {
                e(n + r);
              }, r);
            return (t = n + r), i;
          }),
          (window.cancelAnimationFrame = window.clearTimeout));
      })();
      var ht = (function () {
        function t(e, n, i) {
          r(this, t);
          var o = (function (t) {
            var e,
              n,
              r,
              i =
                t &&
                1 ===
                  (null === (e = t.ownerDocument) ||
                  void 0 === e ||
                  null === (n = e.childNodes) ||
                  void 0 === n
                    ? void 0
                    : n.length) &&
                window.parent !== window,
              o = { el: t, window: window };
            if (!i) return o;
            try {
              r = window.parent.document;
            } catch (t) {
              return o;
            }
            return (
              (o.window = window.parent),
              (o.el =
                Array.from(r.querySelectorAll("iframe,object")).filter(
                  function (t) {
                    return t.contentWindow === window;
                  }
                )[0] || o.el),
              o
            );
          })(e);
          (n = Math.max(1, n || 1)),
            (n = Math.min(n, 100)),
            (this.el = o.el),
            (this._handlers = []),
            (this.onThresholdChange = i && i.call ? i : function () {}),
            (this.thresholdPercent = n || 1),
            (this.currentVisibility = null),
            (this.visibilityCalculator = (function (t, e) {
              var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : n,
                r = !1,
                i = null,
                o = function () {
                  for (
                    var o = 0,
                      u = n.innerHeight,
                      a = 0,
                      s = n.innerWidth,
                      l = t.parentNode;
                    l instanceof Element;

                  ) {
                    var f = n.getComputedStyle(l);
                    if (
                      "visible" !== f.overflowY ||
                      "visible" !== f.overflowX
                    ) {
                      var c = l.getBoundingClientRect();
                      "visible" !== f.overflowY &&
                        ((o = Math.max(o, c.top)), (u = Math.min(u, c.bottom))),
                        "visible" !== f.overflowX &&
                          ((a = Math.max(a, c.left)),
                          (s = Math.min(s, c.right)));
                    }
                    if (l === l.parentNode) break;
                    l = l.parentNode;
                  }
                  r = !1;
                  var h = t.getBoundingClientRect(),
                    v = Math.min(h.height, Math.max(0, o - h.top)),
                    y = Math.min(h.height, Math.max(0, h.bottom - u)),
                    d = Math.min(h.width, Math.max(0, a - h.left)),
                    g = Math.min(h.width, Math.max(0, h.right - s)),
                    p = (h.height - v - y) / h.height,
                    m = (h.width - d - g) / h.width,
                    b = Math.round(p * m * 100);
                  (null !== i && i === b) || ((i = b), e(b));
                };
              return function (t) {
                r && clearTimeout(r),
                  (r = setTimeout(function () {
                    return o();
                  }, 100));
              };
            })(this.el, this.onVisibilityUpdate.bind(this), o.window)),
            this.bindScrollWatchers(),
            this.visibilityCalculator();
        }
        return (
          o(t, [
            {
              key: "bindScrollWatchers",
              value: function () {
                for (
                  var t = this.el.parentNode;
                  t &&
                  (this._handlers.push({
                    element: t,
                    event: "scroll",
                    handler: this.visibilityCalculator,
                  }),
                  t.addEventListener("scroll", this.visibilityCalculator),
                  t !== t.parentNode && t !== document);

                )
                  t = t.parentNode;
              },
            },
            {
              key: "onVisibilityUpdate",
              value: function (t) {
                var e = this.currentVisibility >= this.thresholdPercent,
                  n = t >= this.thresholdPercent;
                if (null === this.currentVisibility || e !== n)
                  return (
                    (this.currentVisibility = t), void this.onThresholdChange(n)
                  );
                this.currentVisibility = t;
              },
            },
            {
              key: "destruct",
              value: function () {
                this._handlers.forEach(function (t) {
                  t.element.removeEventListener(t.event, t.handler);
                });
              },
            },
          ]),
          t
        );
      })();
      function vt(t) {
        return g(t) + "";
      }
      function yt(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
        return t && t.length ? t.map(vt).join(e) : "";
      }
      function dt(t) {
        return vt(t.x) + "," + vt(t.y);
      }
      function gt(t) {
        if (!t) return "transparent";
        if (null == t.a || t.a >= 1) {
          var e = function (t) {
              return 1 === (t = parseInt(t).toString(16)).length ? "0" + t : t;
            },
            n = function (t) {
              return t.charAt(0) === t.charAt(1);
            },
            r = e(t.r),
            i = e(t.g),
            o = e(t.b);
          return (
            n(r) &&
              n(i) &&
              n(o) &&
              ((r = r.charAt(0)), (i = i.charAt(0)), (o = o.charAt(0))),
            "#" + r + i + o
          );
        }
        return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
      }
      function pt(t) {
        return t ? "url(#" + t + ")" : "none";
      }
      var mt = {
          f: null,
          i: V,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("rx", vt(r.x)), t.setAttribute("ry", vt(r.y));
            };
          },
        },
        bt = {
          f: null,
          i: function (t, e, n) {
            return 0 === t
              ? e
              : 1 === t
              ? n
              : {
                  width: C(t, e.width, n.width),
                  height: C(t, e.height, n.height),
                };
          },
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("width", vt(r.width)),
                t.setAttribute("height", vt(r.height));
            };
          },
        };
      Object.freeze({
        M: 2,
        L: 2,
        Z: 0,
        H: 1,
        V: 1,
        C: 6,
        Q: 4,
        T: 2,
        S: 4,
        A: 7,
      });
      var wt = {},
        kt = null;
      function _t(t) {
        var e = (function () {
          if (kt) return kt;
          if (
            "object" !==
              ("undefined" == typeof document ? "undefined" : n(document)) ||
            !document.createElementNS
          )
            return {};
          var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          return t && t.style
            ? ((t.style.position = "absolute"),
              (t.style.opacity = "0.01"),
              (t.style.zIndex = "-9999"),
              (t.style.left = "-9999px"),
              (t.style.width = "1px"),
              (t.style.height = "1px"),
              (kt = { svg: t }))
            : {};
        })().svg;
        if (!e)
          return function (t) {
            return null;
          };
        var r = document.createElementNS(e.namespaceURI, "path");
        r.setAttributeNS(null, "d", t),
          r.setAttributeNS(null, "fill", "none"),
          r.setAttributeNS(null, "stroke", "none"),
          e.appendChild(r);
        var i = r.getTotalLength();
        return function (t) {
          var e = r.getPointAtLength(i * t);
          return { x: e.x, y: e.y };
        };
      }
      function At(t) {
        return wt[t] ? wt[t] : (wt[t] = _t(t));
      }
      function xt(t, e, n, r) {
        if (!t || !r) return !1;
        var i = ["M", t.x, t.y];
        if (
          (e &&
            n &&
            (i.push("C"), i.push(e.x), i.push(e.y), i.push(n.x), i.push(n.y)),
          e ? !n : n)
        ) {
          var o = e || n;
          i.push("Q"), i.push(o.x), i.push(o.y);
        }
        return e || n || i.push("L"), i.push(r.x), i.push(r.y), i.join(" ");
      }
      function Ot(t, e, n, r) {
        var i =
            arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
          o = xt(t, e, n, r),
          u = At(o);
        try {
          return u(i);
        } catch (t) {
          return null;
        }
      }
      function St(t, e, n) {
        return t + (e - t) * n;
      }
      function Et(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          i = { x: St(t.x, e.x, n), y: St(t.y, e.y, n) };
        return r && (i.a = Pt(t, e)), i;
      }
      function Pt(t, e) {
        return Math.atan2(e.y - t.y, e.x - t.x);
      }
      function jt(t, e, n, r) {
        var i = 1 - r;
        return i * i * t + 2 * i * r * e + r * r * n;
      }
      function Mt(t, e, n, r) {
        return 2 * (1 - r) * (e - t) + 2 * r * (n - e);
      }
      function Bt(t, e, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          o = Ot(t, e, null, n, r);
        return (
          o || (o = { x: jt(t.x, e.x, n.x, r), y: jt(t.y, e.y, n.y, r) }),
          i && (o.a = Tt(t, e, n, r)),
          o
        );
      }
      function Tt(t, e, n, r) {
        return Math.atan2(Mt(t.y, e.y, n.y, r), Mt(t.x, e.x, n.x, r));
      }
      function It(t, e, n, r, i) {
        var o = i * i;
        return (
          i * o * (r - t + 3 * (e - n)) +
          3 * o * (t + n - 2 * e) +
          3 * i * (e - t) +
          t
        );
      }
      function Rt(t, e, n, r, i) {
        var o = 1 - i;
        return 3 * (o * o * (e - t) + 2 * o * i * (n - e) + i * i * (r - n));
      }
      function Nt(t, e, n, r, i) {
        var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
          u = Ot(t, e, n, r, i);
        return (
          u ||
            (u = {
              x: It(t.x, e.x, n.x, r.x, i),
              y: It(t.y, e.y, n.y, r.y, i),
            }),
          o && (u.a = Ft(t, e, n, r, i)),
          u
        );
      }
      function Ft(t, e, n, r, i) {
        return Math.atan2(Rt(t.y, e.y, n.y, r.y, i), Rt(t.x, e.x, n.x, r.x, i));
      }
      function Ct(t, e, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (Lt(e)) {
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        } else if (Lt(n)) {
          if (qt(e)) return Bt(e, e.end, n, t, r);
        } else {
          if (qt(e))
            return Vt(n)
              ? Nt(e, e.end, n.start, n, t, r)
              : Bt(e, e.end, n, t, r);
          if (Vt(n)) return Bt(e, n.start, n, t, r);
        }
        return Et(e, n, t, r);
      }
      function Dt(t, e, n) {
        var r = Ct(t, e, n, !0);
        return (
          (r.a =
            (function (t) {
              return arguments.length > 1 &&
                void 0 !== arguments[1] &&
                arguments[1]
                ? t + Math.PI
                : t;
            })(r.a) / m),
          r
        );
      }
      function Lt(t) {
        return !t.type || "corner" === t.type;
      }
      function Vt(t) {
        return null != t.start && !Lt(t);
      }
      function qt(t) {
        return null != t.end && !Lt(t);
      }
      var Gt = new R();
      var zt = {
          f: function (t) {
            return t ? t.join(" ") : "";
          },
          i: function (t, e, r) {
            if (0 === t) return e;
            if (1 === t) return r;
            var i = e.length;
            if (i !== r.length) return N(t, e, r);
            for (var o, u = new Array(i), a = 0; a < i; a++) {
              if ((o = n(e[a])) !== n(r[a])) return N(t, e, r);
              if ("number" === o) u[a] = F(t, e[a], r[a]);
              else {
                if (e[a] !== r[a]) return N(t, e, r);
                u[a] = e[a];
              }
            }
            return u;
          },
        },
        Yt = {
          f: null,
          i: z,
          u: function (t, e) {
            return function (n) {
              var r = e(n);
              t.setAttribute("x1", vt(r[0])),
                t.setAttribute("y1", vt(r[1])),
                t.setAttribute("x2", vt(r[2])),
                t.setAttribute("y2", vt(r[3]));
            };
          },
        },
        Ut = { f: vt, i: F },
        Wt = { f: vt, i: D },
        $t = {
          f: function (t) {
            var e =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : " ";
            return (
              t &&
                t.length > 0 &&
                (t = t.map(function (t) {
                  return g(t, 4);
                })),
              yt(t, e)
            );
          },
          i: function (t, e, n) {
            var r,
              i,
              o,
              u = e.length,
              a = n.length;
            if (u !== a)
              if (0 === u) e = Y((u = a), 0);
              else if (0 === a) (a = u), (n = Y(u, 0));
              else {
                var s =
                  (o =
                    ((r = u) * (i = a)) /
                    (function (t, e) {
                      for (var n; e; ) (n = e), (e = t % e), (t = n);
                      return t || 1;
                    })(r, i)) < 0
                    ? -o
                    : o;
                (e = U(e, Math.floor(s / u))),
                  (n = U(n, Math.floor(s / a))),
                  (u = a = s);
              }
            for (var l = [], f = 0; f < u; f++) l.push(g(C(t, e[f], n[f])));
            return l;
          },
        };
      function Ht(t, e, n) {
        return t.map(function (t) {
          return (function (t, e, n) {
            var r = t.v;
            if (!r || "g" !== r.t || r.s || !r.v || !r.r) return t;
            var i = n.getElementById(r.r),
              o = (i && i.querySelectorAll("stop")) || [];
            return (
              (r.s = r.v.map(function (t, e) {
                var n = o[e] && o[e].getAttribute("offset");
                return { c: t, o: (n = g(parseInt(n) / 100)) };
              })),
              delete r.v,
              t
            );
          })(t, 0, n);
        });
      }
      var Qt = {
        gt: "gradientTransform",
        c: { x: "cx", y: "cy" },
        rd: "r",
        f: { x: "x1", y: "y1" },
        to: { x: "x2", y: "y2" },
      };
      function Xt(t, e, r, i, o, u, a, s) {
        return (
          Ht(t, 0, s),
          (e = (function (t, e, n) {
            for (var r, i, o, u = t.length - 1, a = {}, s = 0; s <= u; s++)
              (r = t[s]).e && (r.e = e(r.e)),
                r.v &&
                  "g" === (i = r.v).t &&
                  i.r &&
                  (o = n.getElementById(i.r)) &&
                  (a[i.r] = { e: o, s: o.querySelectorAll("stop") });
            return a;
          })(t, i, s)),
          function (i) {
            var o = r(i, t, Jt);
            if (!o) return "none";
            if ("c" === o.t) return gt(o.v);
            if ("g" === o.t) {
              if (!e[o.r]) return pt(o.r);
              var u = e[o.r];
              return (
                (function (t, e) {
                  for (var n = t.s, r = n.length; r < e.length; r++) {
                    var i = n[n.length - 1].cloneNode();
                    (i.id = te(i.id)),
                      t.e.appendChild(i),
                      (n = t.s = t.e.querySelectorAll("stop"));
                  }
                  for (var o = 0, u = n.length, a = e.length - 1; o < u; o++)
                    n[o].setAttribute("stop-color", gt(e[Math.min(o, a)].c)),
                      n[o].setAttribute("offset", e[Math.min(o, a)].o);
                })(u, o.s),
                Object.keys(Qt).forEach(function (t) {
                  if (void 0 !== o[t])
                    if ("object" !== n(Qt[t])) {
                      var e,
                        r =
                          "gt" === t
                            ? ((e = o[t]),
                              Array.isArray(e)
                                ? "matrix(" + e.join(" ") + ")"
                                : "")
                            : o[t],
                        i = Qt[t];
                      u.e.setAttribute(i, r);
                    } else
                      Object.keys(Qt[t]).forEach(function (e) {
                        if (void 0 !== o[t][e]) {
                          var n = o[t][e],
                            r = Qt[t][e];
                          u.e.setAttribute(r, n);
                        }
                      });
                }),
                pt(o.r)
              );
            }
            return "none";
          }
        );
      }
      function Jt(t, n, r) {
        if (0 === t) return n;
        if (1 === t) return r;
        if (n && r) {
          var i = n.t;
          if (i === r.t)
            switch (n.t) {
              case "c":
                return { t: i, v: G(t, n.v, r.v) };
              case "g":
                if (n.r === r.r) {
                  var o = { t: i, s: Kt(t, n.s, r.s), r: n.r };
                  return (
                    n.gt && r.gt && (o.gt = z(t, n.gt, r.gt)),
                    n.c
                      ? ((o.c = L(t, n.c, r.c)), (o.rd = C(t, n.rd, r.rd)))
                      : n.f &&
                        ((o.f = L(t, n.f, r.f)), (o.to = L(t, n.to, r.to))),
                    o
                  );
                }
            }
          if (("c" === n.t && "g" === r.t) || ("c" === r.t && "g" === n.t)) {
            var u = "c" === n.t ? n : r,
              a = "g" === n.t ? e({}, n) : e({}, r),
              s = a.s.map(function (t) {
                return { c: u.v, o: t.o };
              });
            return (a.s = "c" === n.t ? Kt(t, s, a.s) : Kt(t, a.s, s)), a;
          }
        }
        return N(t, n, r);
      }
      function Kt(t, e, n) {
        if (e.length === n.length)
          return e.map(function (e, r) {
            return Zt(t, e, n[r]);
          });
        for (var r = Math.max(e.length, n.length), i = [], o = 0; o < r; o++) {
          var u = Zt(
            t,
            e[Math.min(o, e.length - 1)],
            n[Math.min(o, n.length - 1)]
          );
          i.push(u);
        }
        return i;
      }
      function Zt(t, e, n) {
        return { o: D(t, e.o, n.o || 0), c: G(t, e.c, n.c || {}) };
      }
      function te(t) {
        return t.replace(/-fill-([0-9]+)$/, function (t, e) {
          return "-fill-" + (+e + 1);
        });
      }
      var ee = {
        blur: V,
        brightness: C,
        contrast: C,
        "drop-shadow": function (t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : {
                blur: V(t, e.blur, n.blur),
                offset: L(t, e.offset, n.offset),
                color: G(t, e.color, n.color),
              };
        },
        grayscale: C,
        "hue-rotate": F,
        invert: C,
        opacity: C,
        saturate: C,
        sepia: C,
      };
      function ne(t, e, n) {
        if (0 === t) return e;
        if (1 === t) return n;
        var r = e.length;
        if (r !== n.length) return N(t, e, n);
        for (var i, o = [], u = 0; u < r; u++) {
          if (e[u].type !== n[u].type) return e;
          if (!(i = ee[e[u].type])) return N(t, e, n);
          o.push({ type: e.type, value: i(t, e[u].value, n[u].value) });
        }
        return o;
      }
      var re = {
        blur: function (t) {
          return t
            ? function (e) {
                t.setAttribute("stdDeviation", dt(e));
              }
            : null;
        },
        brightness: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e)),
                  t.map(function (t) {
                    return t.setAttribute("slope", e);
                  });
              }
            : null;
        },
        contrast: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                var n = vt((1 - e) / 2);
                (e = vt(e)),
                  t.map(function (t) {
                    t.setAttribute("slope", e), t.setAttribute("intercept", n);
                  });
              }
            : null;
        },
        "drop-shadow": function (t, e, n) {
          var r = n.getElementById(e + "-blur");
          if (!r) return null;
          var i = n.getElementById(e + "-offset");
          if (!i) return null;
          var o = n.getElementById(e + "-flood");
          return o
            ? function (t) {
                r.setAttribute("stdDeviation", dt(t.blur)),
                  i.setAttribute("dx", vt(t.offset.x)),
                  i.setAttribute("dy", vt(t.offset.y)),
                  o.setAttribute("flood-color", gt(t.color));
              }
            : null;
        },
        grayscale: function (t) {
          return t
            ? function (e) {
                t.setAttribute(
                  "values",
                  yt(
                    (function (t) {
                      return [
                        0.2126 + 0.7874 * (t = 1 - t),
                        0.7152 - 0.7152 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 + 0.2848 * t,
                        0.0722 - 0.0722 * t,
                        0,
                        0,
                        0.2126 - 0.2126 * t,
                        0.7152 - 0.7152 * t,
                        0.0722 + 0.9278 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
        "hue-rotate": function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        invert: function (t, e, n) {
          return (t = oe(n, e))
            ? function (e) {
                (e = vt(e) + " " + vt(1 - e)),
                  t.map(function (t) {
                    return t.setAttribute("tableValues", e);
                  });
              }
            : null;
        },
        opacity: function (t, e, n) {
          return (t = n.getElementById(e + "-A"))
            ? function (e) {
                return t.setAttribute("tableValues", "0 " + vt(e));
              }
            : null;
        },
        saturate: function (t) {
          return t
            ? function (e) {
                return t.setAttribute("values", vt(e));
              }
            : null;
        },
        sepia: function (t) {
          return t
            ? function (e) {
                return t.setAttribute(
                  "values",
                  yt(
                    (function (t) {
                      return [
                        0.393 + 0.607 * (t = 1 - t),
                        0.769 - 0.769 * t,
                        0.189 - 0.189 * t,
                        0,
                        0,
                        0.349 - 0.349 * t,
                        0.686 + 0.314 * t,
                        0.168 - 0.168 * t,
                        0,
                        0,
                        0.272 - 0.272 * t,
                        0.534 - 0.534 * t,
                        0.131 + 0.869 * t,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                      ];
                    })(e)
                  )
                );
              }
            : null;
        },
      };
      var ie = ["R", "G", "B"];
      function oe(t, e) {
        var n = ie.map(function (n) {
          return t.getElementById(e + "-" + n) || null;
        });
        return -1 !== n.indexOf(null) ? null : n;
      }
      var ue = {
          fill: Xt,
          "fill-opacity": Wt,
          stroke: Xt,
          "stroke-opacity": Wt,
          "stroke-width": Ut,
          "stroke-dashoffset": { f: vt, i: F },
          "stroke-dasharray": $t,
          opacity: Wt,
          transform: function (t, e, r, i) {
            if (
              !(t = (function (t, e) {
                if (!t || "object" !== n(t)) return null;
                var r = !1;
                for (var i in t)
                  t.hasOwnProperty(i) &&
                    (t[i] && t[i].length
                      ? (t[i].forEach(function (t) {
                          t.e && (t.e = e(t.e));
                        }),
                        (r = !0))
                      : delete t[i]);
                return r ? t : null;
              })(t, i))
            )
              return null;
            var o = function (n, i, o) {
              var u =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return t[n] ? r(i, t[n], o) : e && e[n] ? e[n] : u;
            };
            return e && e.a && t.o
              ? function (e) {
                  var n = r(e, t.o, Dt);
                  return Gt.recomposeSelf(
                    n,
                    o("r", e, F, 0) + n.a,
                    o("k", e, L),
                    o("s", e, L),
                    o("t", e, L)
                  ).toString();
                }
              : function (t) {
                  return Gt.recomposeSelf(
                    o("o", t, Ct, null),
                    o("r", t, F, 0),
                    o("k", t, L),
                    o("s", t, L),
                    o("t", t, L)
                  ).toString();
                };
          },
          "#filter": function (t, e, n, r, i, o, u, a) {
            if (!e.items || !t || !t.length) return null;
            var s = (function (t, e) {
              var n = (t = t.map(function (t) {
                return t && re[t[0]]
                  ? (e.getElementById(t[1]),
                    re[t[0]](e.getElementById(t[1]), t[1], e))
                  : null;
              })).length;
              return function (e) {
                for (var r = 0; r < n; r++) t[r] && t[r](e[r].value);
              };
            })(e.items, a);
            return s
              ? ((t = (function (t, e) {
                  return t.map(function (t) {
                    return (t.e = e(t.e)), t;
                  });
                })(t, r)),
                function (e) {
                  s(n(e, t, ne));
                })
              : null;
          },
          "#line": Yt,
          points: { f: yt, i: z },
          d: zt,
          r: Ut,
          "#size": bt,
          "#radius": mt,
          _: function (t, e) {
            if (Array.isArray(t))
              for (var n = 0; n < t.length; n++) this[t[n]] = e;
            else this[t] = e;
          },
        },
        ae = {
          currentTime: "offset",
          duration: "duration",
          hasEnded: function () {
            return this.reachedToEnd();
          },
          isAlternate: "alternate",
          isPlaying: "_running",
          isRollingBack: "_rollingBack",
          state: function (t, e) {
            return e.isPlaying
              ? e.isRollingBack
                ? "rollback"
                : "playing"
              : e.hasEnded
              ? "ended"
              : "paused";
          },
          totalTime: "maxFiniteDuration",
          iterations: "iterations",
          direction: "direction",
          fill: "fill",
          isReversed: function (t, e) {
            return -1 === e.direction;
          },
          isBackwards: function (t, e) {
            return -1 === e.fill;
          },
          isInfinite: function (t, e) {
            return 0 === e.iterations;
          },
          speed: "speed",
          fps: "fps",
        },
        se = {
          destruct: "destruct",
          pause: "pause",
          play: function (t, e) {
            return le(t, e.hasEnded ? "restart" : "play", e);
          },
          restart: "restart",
          reverse: function (t, e) {
            return le(t, "reverse", e, [!0]);
          },
          seek: "seek",
          seekBy: "seekBy",
          seekTo: "seekTo",
          stop: "stop",
          toggle: "toggle",
          togglePlay: "toggle",
          set: "set",
        };
      function le(t, e, n) {
        var r =
          arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
        return function () {
          var i,
            o = Array.prototype.slice.call(arguments);
          return (
            o.unshift.apply(o, v(r)),
            (i = t[e]).call.apply(i, [t].concat(v(o))),
            n
          );
        };
      }
      var fe = function t(e) {
        r(this, t);
        var n = {},
          i = ["on", "off"],
          o = {
            get: function (t, e, r) {
              return ae[e]
                ? "function" == typeof ae[e]
                  ? ae[e].call(t, t, r)
                  : t[ae[e]]
                : se[e]
                ? "function" == typeof se[e]
                  ? se[e].call(t, t, r)
                  : le(t, se[e], r)
                : -1 !== i.indexOf(e)
                ? n[e]
                : "ready" === e
                ? function (t) {
                    return t && t.call(r, r), r;
                  }
                : void 0;
            },
            set: function (t, e, r) {
              return -1 !== i.indexOf(e) && (n[e] = r);
            },
            ownKeys: function (t) {
              return Object.keys(ae);
            },
            has: function (t, e) {
              return void 0 !== ae[e];
            },
          };
        if ("function" == typeof Proxy) return new Proxy(e, o);
        var u = Object.keys(ae).concat(Object.keys(se)).concat(i),
          a = {};
        return (
          u.forEach(function (t) {
            var n = {
              enumerable: !1,
              configurable: !1,
              get: function () {
                return o.get(e, t, a);
              },
            };
            -1 !== i.indexOf(t) &&
              (n.set = function (n) {
                return o.set(e, t, n);
              }),
              Object.defineProperty(a, t, n);
          }),
          a
        );
      };
      function ce(t) {
        t || (t = this);
        var e = {};
        (this.on = function (t, n) {
          var r =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return (
            "function" == typeof n &&
            (t.split(/[, ]+/g).forEach(function (t) {
              return (e[t] = e[t] || []), r ? e[t].unshift(n) : e[t].push(n);
            }),
            !0)
          );
        }),
          (this.off = function (t, n) {
            for (var r in e)
              if (e.hasOwnProperty(r) && r.substr(0, t.length) === t)
                if (n)
                  for (var i = 0; i < e[r].length; i++)
                    e[r][i] === n && (e[r][i] = null);
                else e[r] = null;
          }),
          (this.trigger = function () {
            var n,
              r = Array.prototype.slice.call(arguments),
              i = r[0],
              o = r.slice(1);
            t: for (var u in e)
              if (
                e.hasOwnProperty(u) &&
                e[u] &&
                (u === i || u.substr(0, i.length + 1) === i + ".")
              )
                for (var a = 0; a < (e[u] || []).length; a++)
                  if (e[u][a] && !1 === (n = e[u][a].apply(t, o))) break t;
            return n;
          });
      }
      var he = !0,
        ve = ["iterations", "speed", "fps", "direction", "fill", "alternate"],
        ye = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (t.prototype = Object.create(e && e.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              e && s(t, e);
          })(u, t);
          var e,
            n,
            i =
              ((e = u),
              (n = l()),
              function () {
                var t,
                  r = a(e);
                if (n) {
                  var i = a(this).constructor;
                  t = Reflect.construct(r, arguments, i);
                } else t = r.apply(this, arguments);
                return c(this, t);
              });
          function u(t, e) {
            var n,
              o =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            return r(this, u), ((n = i.call(this, t, e, o))._handlers = []), n;
          }
          return (
            o(
              u,
              [
                {
                  key: "_adjustOffset",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e = this.alternate ? 2 * this.duration : this.duration;
                    if (t) {
                      if (!this._rollingBack && 0 === this.offset)
                        return void (this.offset = e);
                      this._rollingBack &&
                        (this.offset, this.maxFiniteDuration);
                    }
                    !this._rollingBack ||
                    this.rollbackStartOffset <= this.duration
                      ? 0 !== this.iterations &&
                        (this.offset = Math.min(
                          this.offset,
                          this.maxFiniteDuration
                        ))
                      : ((this.offset =
                          this.rollbackStartOffset -
                          ((this.rollbackStartOffset - this.offset) % e)),
                        (this.rollbackStartOffset = 0));
                  },
                },
                {
                  key: "reverse",
                  value: function () {
                    var t =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                    if (!this._running)
                      return (
                        this._adjustOffset(t),
                        (this._rollingBack = !this._rollingBack),
                        t && this.play(!1),
                        void this.trigger("reverse", this.offset)
                      );
                    this.pause(!1, !1),
                      this._adjustOffset(),
                      (this._rollingBack = !this._rollingBack),
                      this.play(!1),
                      this.trigger("reverse", this.offset);
                  },
                },
                {
                  key: "play",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "play", this).call(this);
                    return t === he && this.trigger("play", this.offset), e;
                  },
                },
                {
                  key: "pause",
                  value: function () {
                    var t =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : he,
                      n = h(a(u.prototype), "pause", this).call(this);
                    return (
                      e === he &&
                        this.trigger(t ? "end" : "pause", this.offset),
                      n
                    );
                  },
                },
                {
                  key: "restart",
                  value: function () {
                    var t = h(a(u.prototype), "restart", this).call(this, !1);
                    return this.trigger("restart", this.offset), t;
                  },
                },
                {
                  key: "stop",
                  value: function () {
                    var t =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : he,
                      e = h(a(u.prototype), "stop", this).call(this);
                    return t === he && this.trigger("stop", this.offset), e;
                  },
                },
                {
                  key: "_apply",
                  value: function (t) {
                    var e = this,
                      n =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : he,
                      r = h(a(u.prototype), "_apply", this).call(this, t);
                    if (n === he) {
                      var i = function () {
                        return e.trigger("keyframe", t);
                      };
                      window.requestAnimationFrame(i);
                    }
                    return r;
                  },
                },
                {
                  key: "seekTo",
                  value: function (t) {
                    var e,
                      n,
                      r,
                      i = this._running;
                    i && this.pause(!1, !1),
                      (this.offset =
                        this.iterations > 0
                          ? ((e = t),
                            (n = 0),
                            (r = this.maxFiniteDuration),
                            e < n ? n : e > r ? r : e)
                          : Math.max(t, 0)),
                      this._apply(this.offset),
                      i && this.play(!1);
                  },
                },
                {
                  key: "seek",
                  value: function (t) {
                    return this.seekTo(
                      Math.round((t / 100) * this.maxFiniteDuration)
                    );
                  },
                },
                {
                  key: "seekBy",
                  value: function (t) {
                    return this.seekTo(this.offset + t);
                  },
                },
                {
                  key: "toggle",
                  value: function () {
                    return this._running
                      ? this.pause()
                      : this.reachedToEnd()
                      ? this.restart()
                      : this.play();
                  },
                },
                {
                  key: "set",
                  value: function (t, e) {
                    if (ve.includes(t)) {
                      var n = this._running;
                      n && this.pause(!1, !1),
                        (this._settings[t] = e),
                        n ? this.play(!1) : this._apply(this.offset, {}, !1);
                    }
                  },
                },
                {
                  key: "destruct",
                  value: function () {
                    var t = this;
                    this.stop(),
                      this._handlers.forEach(function (t) {
                        t.element
                          ? t.element.removeEventListener(t.event, t.handler)
                          : t.callback && t.callback.call && t.callback.call();
                      });
                    var e = function () {},
                      n = Object.getOwnPropertyNames(
                        Object.getPrototypeOf(this)
                      );
                    n.push.apply(n, v(Object.getOwnPropertyNames(this))),
                      n.forEach(function (n) {
                        "function" == typeof t[n] ? (t[n] = e) : delete t[n];
                      });
                  },
                },
              ],
              [
                {
                  key: "build",
                  value: function (t) {
                    var e = h(a(u), "build", this).call(this, t, ue);
                    if (!e) return null;
                    var n = e.el,
                      r = e.options,
                      i = e.player,
                      o = new fe(i),
                      s = new ce(o);
                    (o.on = s.on), (o.off = s.off), (i.trigger = s.trigger);
                    var l =
                      n.svgatorPlayer &&
                      n.svgatorPlayer.ready &&
                      n.svgatorPlayer.ready.call &&
                      n.svgatorPlayer.ready.call();
                    (n.svgatorPlayer = o),
                      (function (t, e, n) {
                        if ("click" === n.start) {
                          var r = function () {
                            switch (n.click) {
                              case "freeze":
                                return !t._running && t.reachedToEnd()
                                  ? t.restart()
                                  : t.toggle();
                              case "restart":
                                return t.offset > 0 ? t.restart() : t.play();
                              case "reverse":
                                return t._running
                                  ? t.reverse()
                                  : t.reachedToEnd()
                                  ? 1 === t.fill
                                    ? t.reverse(!0)
                                    : t.restart()
                                  : t.play();
                              case "none":
                              default:
                                if (t._running) return;
                                return t.reachedToEnd()
                                  ? t.restart()
                                  : t.play();
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "click",
                              handler: r,
                            }),
                            void e.addEventListener("click", r)
                          );
                        }
                        if ("hover" === n.start) {
                          var i = function () {
                            return t.reachedToEnd()
                              ? t.restart()
                              : t._rollingBack
                              ? t.reverse()
                              : t.play();
                          };
                          t._handlers.push({
                            element: e,
                            event: "mouseenter",
                            handler: i,
                          }),
                            e.addEventListener("mouseenter", i);
                          var o = function () {
                            switch (n.hover) {
                              case "freeze":
                                return t.pause();
                              case "reset":
                                return t.stop();
                              case "reverse":
                                if ((t.reverse(), t._running)) return;
                                return t.play();
                              case "none":
                              default:
                                return;
                            }
                          };
                          return (
                            t._handlers.push({
                              element: e,
                              event: "mouseleave",
                              handler: o,
                            }),
                            void e.addEventListener("mouseleave", o)
                          );
                        }
                        if ("scroll" === n.start) {
                          var u = new ht(e, n.scroll || 25, function (e) {
                            e
                              ? t.reachedToEnd()
                                ? t.restart()
                                : t.play()
                              : t.pause();
                          });
                          return void t._handlers.push({
                            callback: function () {
                              return u.destruct();
                            },
                          });
                        }
                        if ("programmatic" === n.start) return;
                        t.play();
                      })(i, n, r),
                      (function (t, e, n) {
                        var r;
                        "function" == typeof Event
                          ? (r = new Event("ready"))
                          : (r = document.createEvent("Event")).initEvent(
                              "ready",
                              !0,
                              !0
                            );
                        if ((t.dispatchEvent(r), !n || !n.length)) return;
                        n.forEach(function (t) {
                          return e.ready(t);
                        });
                      })(n, n.svgatorPlayer, l);
                  },
                },
              ]
            ),
            u
          );
        })(ct);
      return ye.init(), ye;
    });
    (function (s, i, o, w, d, a, b) {
      (a =
        Array.from(d.querySelectorAll("svg#" + i.root)).filter(
          (n) => !n.svgatorPlayer
        )[0] || {}).svgatorPlayer = {
        ready: (function (a) {
          b = [];
          return function (c) {
            return c ? (b.push(c), a.svgatorPlayer) : b;
          };
        })(a),
      };
      w[o] = w[o] || {};
      w[o][s] = w[o][s] || [];
      w[o][s].push(i);
    })(
      "91c80d77",
      {
        root: "e0gYpSRcAlv1",
        version: "2022-05-04",
        animations: [
          {
            elements: {
              e0gYpSRcAlv5: {
                transform: {
                  data: {
                    o: { x: 1629.853516, y: 727.803641, type: "corner" },
                    t: { x: -1629.853507, y: -917.158271 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 1800, v: 1.848011, e: [0.42, 0, 0.22, 1.005] },
                      { t: 4500, v: -0.194372, e: [0.42, 0, 0.22, 1.005] },
                      { t: 7500, v: 2.151963, e: [0.42, 0, 0.22, 1.005] },
                      { t: 9600, v: 0.666482, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv327: {
                transform: {
                  data: {
                    o: { x: 1429.304069, y: 718, type: "corner" },
                    t: { x: -1379.191646, y: -887.416036 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: -2.639315, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2000, v: -0.725257, e: [0.42, 0, 0.22, 1.005] },
                      { t: 5200, v: -2.545107, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8000, v: 1.48846, e: [0.42, 0, 0.22, 1.005] },
                      { t: 10000, v: -0.7332, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: -2.639315, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv844: {
                transform: {
                  data: {
                    o: { x: 1452.649671, y: 733.815092, type: "corner" },
                    t: { x: -1452.649671, y: -916.081567 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2500, v: 4.642991, e: [0.42, 0, 0.22, 1.005] },
                      { t: 5800, v: -4.369014, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8400, v: 5.090348, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv863: {
                transform: {
                  data: {
                    o: { x: 816.206087, y: 698.646741, type: "corner" },
                    t: { x: -816.206039, y: -876.862845 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 3400, v: 2.481852, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6300, v: 0.854624, e: [0.42, 0, 0.22, 1.005] },
                      { t: 9400, v: 3.80371, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv934: {
                transform: {
                  data: {
                    o: { x: 598.607544, y: 635.726413, type: "corner" },
                    t: { x: -607.576325, y: -858.415973 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 1800, v: 8.426362, e: [0.42, 0, 0.22, 1.005] },
                      { t: 4000, v: 0.875417, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6500, v: 1.13274, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8000, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 10100, v: 1.13274, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1251: {
                transform: {
                  data: {
                    o: { x: 401.567841, y: 532.045105, type: "corner" },
                    t: { x: -401.567834, y: -532.045105 },
                  },
                  keys: {
                    s: [
                      { t: 0, v: { x: 1, y: 1 } },
                      { t: 1600, v: { x: 0.5, y: 1 } },
                      { t: 3200, v: { x: 1, y: 1 } },
                      { t: 5400, v: { x: 0.5, y: 1 } },
                      { t: 6900, v: { x: 1, y: 1 } },
                      { t: 9800, v: { x: 0.5, y: 1 } },
                      { t: 11400, v: { x: 1, y: 1 } },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1349: {
                transform: {
                  data: {
                    o: { x: 362.194519, y: 504.443512, type: "corner" },
                    t: { x: -364.194501, y: -518.443512 },
                  },
                  keys: {
                    s: [
                      { t: 0, v: { x: 1, y: 1 } },
                      { t: 1600, v: { x: 0.5, y: 1 } },
                      { t: 3200, v: { x: 1, y: 1 } },
                      { t: 5400, v: { x: 0.5, y: 1 } },
                      { t: 6900, v: { x: 1, y: 1 } },
                      { t: 9800, v: { x: 0.5, y: 1 } },
                      { t: 11400, v: { x: 1, y: 1 } },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1401: {
                transform: {
                  data: {
                    o: { x: 506.81, y: 681.30184, type: "corner" },
                    t: { x: -506.809995, y: -875.719419 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2200, v: -1.658004, e: [0.42, 0, 0.22, 1.005] },
                      { t: 4800, v: 0.316447, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8800, v: -1.315162, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1630: {
                transform: {
                  data: {
                    o: { x: 669.869568, y: 634.56643, type: "corner" },
                    t: { x: -669.869556, y: -815.820302 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2000, v: 4.860247, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6100, v: 1.957424, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8400, v: 4.587812, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1665: {
                transform: {
                  data: {
                    o: { x: 150.981959, y: 711.060505, type: "corner" },
                    t: { x: -273.959552, y: -887.247066 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 1700, v: 2.552838, e: [0.42, 0, 0.22, 1.005] },
                      { t: 3900, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6300, v: 2.552838, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8800, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv1853: {
                transform: {
                  data: {
                    o: { x: 142.008909, y: 702.064439, type: "corner" },
                    t: { x: -160.008898, y: -888.381287 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2700, v: 1.278749, e: [0.42, 0, 0.22, 1.005] },
                      { t: 5600, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8300, v: 1.278749, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2186: {
                transform: {
                  data: { t: { x: -1459.328054, y: -161.735215 } },
                  keys: {
                    o: [
                      {
                        t: 3700,
                        v: {
                          x: 853.978988,
                          y: 724.606185,
                          type: "cusp",
                          end: { x: 899.862783, y: 492.649818 },
                        },
                      },
                      {
                        t: 11400,
                        v: {
                          x: 1995.357903,
                          y: -328.30773,
                          type: "cusp",
                          start: { x: 1060.344975, y: -71.787779 },
                        },
                      },
                    ],
                    r: [
                      { t: 3700, v: 9.599076 },
                      { t: 11400, v: 64 },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2221: {
                transform: {
                  data: {
                    o: { x: 1456.260019, y: 177.163025, type: "corner" },
                    t: { x: -1456.259997, y: -177.163025 },
                  },
                  keys: {
                    s: [
                      {
                        t: 0,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 1000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 1500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 2000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 2500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 3000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 3500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 4000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 4500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 5000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 5500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 6000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 6500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 7000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 7500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 8000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 8500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 9000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 9500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 10000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 10500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 11000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 11400,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2254: {
                transform: {
                  data: {
                    o: { x: 1445.07365, y: 176.945682, type: "corner" },
                    t: { x: -1445.073642, y: -176.945682 },
                  },
                  keys: {
                    s: [
                      {
                        t: 0,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 1000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 1500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 2000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 2500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 3000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 3500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 4000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 4500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 5000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 5500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 6000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 6500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 7000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 7500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 8000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 8500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 9000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 9500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 10000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 10500,
                        v: { x: 0.5, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 11000,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                      {
                        t: 11400,
                        v: { x: 1, y: 1 },
                        e: [0.57, 0.005, 0.06, 1.005],
                      },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2296: {
                transform: {
                  data: { t: { x: -1032.261871, y: -96.712299 } },
                  keys: {
                    o: [
                      {
                        t: 0,
                        v: {
                          x: 2073.438987,
                          y: 345.857911,
                          type: "cusp",
                          end: { x: 1671.142609, y: 337.693952 },
                        },
                      },
                      {
                        t: 6800,
                        v: {
                          x: 914.953621,
                          y: -545.185576,
                          type: "cusp",
                          start: { x: 1027.489995, y: -200.493432 },
                        },
                      },
                    ],
                    r: [
                      { t: 0, v: -68.238589 },
                      { t: 6800, v: -1.074994 },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2297: {
                transform: {
                  data: {
                    o: { x: 1038.358398, y: 114.890014, type: "corner" },
                    t: { x: -1038.358395, y: -114.89 },
                  },
                  keys: {
                    s: [
                      { t: 0, v: { x: 1, y: 1 } },
                      { t: 500, v: { x: 0.5, y: 1 } },
                      { t: 1000, v: { x: 1, y: 1 } },
                      { t: 1500, v: { x: 0.5, y: 1 } },
                      { t: 2000, v: { x: 1, y: 1 } },
                      { t: 2500, v: { x: 0.5, y: 1 } },
                      { t: 3000, v: { x: 1, y: 1 } },
                      { t: 3500, v: { x: 0.5, y: 1 } },
                      { t: 4000, v: { x: 1, y: 1 } },
                      { t: 4500, v: { x: 0.5, y: 1 } },
                      { t: 5000, v: { x: 1, y: 1 } },
                      { t: 5500, v: { x: 0.5, y: 1 } },
                      { t: 6000, v: { x: 1, y: 1 } },
                      { t: 6500, v: { x: 0.5, y: 1 } },
                      { t: 7000, v: { x: 1, y: 1 } },
                      { t: 7500, v: { x: 0.5, y: 1 } },
                      { t: 8000, v: { x: 1, y: 1 } },
                      { t: 8500, v: { x: 0.5, y: 1 } },
                      { t: 9000, v: { x: 1, y: 1 } },
                      { t: 9500, v: { x: 0.5, y: 1 } },
                      { t: 10000, v: { x: 1, y: 1 } },
                      { t: 10500, v: { x: 0.5, y: 1 } },
                      { t: 11000, v: { x: 1, y: 1 } },
                      { t: 11400, v: { x: 1, y: 1 } },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2320: {
                transform: {
                  data: {
                    o: { x: 1025.323242, y: 113.499077, type: "corner" },
                    t: { x: -1025.323241, y: -113.499063 },
                  },
                  keys: {
                    s: [
                      { t: 0, v: { x: 1, y: 1 } },
                      { t: 500, v: { x: 0.5, y: 1 } },
                      { t: 1000, v: { x: 1, y: 1 } },
                      { t: 1500, v: { x: 0.5, y: 1 } },
                      { t: 2000, v: { x: 1, y: 1 } },
                      { t: 2500, v: { x: 0.5, y: 1 } },
                      { t: 3000, v: { x: 1, y: 1 } },
                      { t: 3500, v: { x: 0.5, y: 1 } },
                      { t: 4000, v: { x: 1, y: 1 } },
                      { t: 4500, v: { x: 0.5, y: 1 } },
                      { t: 5000, v: { x: 1, y: 1 } },
                      { t: 5500, v: { x: 0.5, y: 1 } },
                      { t: 6000, v: { x: 1, y: 1 } },
                      { t: 6500, v: { x: 0.5, y: 1 } },
                      { t: 7000, v: { x: 1, y: 1 } },
                      { t: 7500, v: { x: 0.5, y: 1 } },
                      { t: 8000, v: { x: 1, y: 1 } },
                      { t: 8500, v: { x: 0.5, y: 1 } },
                      { t: 9000, v: { x: 1, y: 1 } },
                      { t: 9500, v: { x: 0.5, y: 1 } },
                      { t: 10000, v: { x: 1, y: 1 } },
                      { t: 10500, v: { x: 0.5, y: 1 } },
                      { t: 11000, v: { x: 1, y: 1 } },
                      { t: 11400, v: { x: 1, y: 1 } },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2383: {
                transform: {
                  data: {
                    o: { x: 1075.21, y: 549.699768, type: "corner" },
                    t: { x: -1073.209996, y: -549.699761 },
                  },
                  keys: {
                    s: [
                      {
                        t: 0,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 500,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 1800,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 2600,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 3400,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 4900,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 5900,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 7900,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 9600,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 10300,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 11400,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2408: {
                transform: {
                  data: {
                    o: { x: 1062.051147, y: 549.699768, type: "corner" },
                    t: { x: -1062.051143, y: -549.699768 },
                  },
                  keys: {
                    s: [
                      {
                        t: 0,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 500,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 1800,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 2600,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 3400,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 4900,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 5900,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 7900,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 9600,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 10300,
                        v: { x: 0.5, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                      {
                        t: 11400,
                        v: { x: 1, y: 1 },
                        e: [0.83, 0.005, 0.16, 0.995],
                      },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2433: {
                transform: {
                  data: {
                    o: { x: 1309.906982, y: 629.724201, type: "corner" },
                    t: { x: -1309.906981, y: -819.078824 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 1800, v: 3.32487, e: [0.42, 0, 0.22, 1.005] },
                      { t: 4000, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6200, v: 3.32487, e: [0.42, 0, 0.22, 1.005] },
                      { t: 9000, v: 0, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: 0, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
              e0gYpSRcAlv2592: {
                transform: {
                  data: {
                    o: { x: 1203.906883, y: 647.099342, type: "corner" },
                    t: { x: -1203.906875, y: -820.423478 },
                  },
                  keys: {
                    r: [
                      { t: 0, v: -14.696308, e: [0.42, 0, 0.22, 1.005] },
                      { t: 2300, v: -10, e: [0.42, 0, 0.22, 1.005] },
                      { t: 4600, v: -14.696308, e: [0.42, 0, 0.22, 1.005] },
                      { t: 6800, v: -10, e: [0.42, 0, 0.22, 1.005] },
                      { t: 8800, v: -14.696308, e: [0.42, 0, 0.22, 1.005] },
                      { t: 11400, v: -14.696308, e: [0.42, 0, 0.22, 1.005] },
                    ],
                  },
                },
              },
            },
            s: "MDNA2MjljNDM4NJTk2OTNWODI5YNThhOTA4ZjQWzRDViNTI1MjHU1NTE1MTRkNQDM4NThhOTM4ONjg0OTU4YTkOwOGY0MzViNTSI0ZDQzOGE5NKTg2OTM4Mjk1HOGE5MDhmOTQV0MzViNTE0ZDSQzODc4YThkOLGQ0MzViNGU1IMjRkNDM4MjhGkOTU4NjkzOGEY4Mjk1ODY0MAzViODc4MjhkYUzk0ODZQNGQF0M0o5NDkxODVY4Njg1NDM1YAjUxNGY1OUs1VNjRkVjQzODcD5MTk0NDM1YjOUyNTE1MTll",
          },
        ],
        options: "MDMAxMDgyMjlXNN2E3YjY4Nzk3XYjI5RzQxMjkD3Mzc2Njg2YlVkyOTg0",
      },
      "__SVGATOR_PLAYER__",
      window,
      document
    );
  },
};
</script>